
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire925f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire925f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.8";

});

parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});


parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.8" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.8"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.8"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});


parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});

parcelRegister("feCqm", function(module, exports) {
module.exports = import.meta.resolve("lj5bU");

});

parcelRegister("kDwNf", function(module, exports) {
module.exports = import.meta.resolve("6HNUL");

});

parcelRegister("dV726", function(module, exports) {
module.exports = import.meta.resolve("bEZXE");

});

parcelRegister("1NmxF", function(module, exports) {
module.exports = import.meta.resolve("zjFeg");

});

parcelRegister("j4J5v", function(module, exports) {
module.exports = import.meta.resolve("6bQv7");

});

parcelRegister("GUGyC", function(module, exports) {
module.exports = import.meta.resolve("kdLSm");

});

parcelRegister("kQV5E", function(module, exports) {
module.exports = import.meta.resolve("2OqwC");

});

parcelRegister("aG36s", function(module, exports) {
module.exports = import.meta.resolve("76ac2");

});

parcelRegister("lsCqq", function(module, exports) {
module.exports = import.meta.resolve("1NcfW");

});

parcelRegister("q2WpK", function(module, exports) {
module.exports = import.meta.resolve("fW2wI");

});

parcelRegister("gBRIp", function(module, exports) {
module.exports = import.meta.resolve("85KgL");

});

parcelRegister("eoS7H", function(module, exports) {
module.exports = import.meta.resolve("8gAu7");

});

parcelRegister("luWKO", function(module, exports) {
module.exports = import.meta.resolve("cBYYD");

});

parcelRegister("7IhZQ", function(module, exports) {
module.exports = import.meta.resolve("eQqWS");

});

parcelRegister("2w2QI", function(module, exports) {
module.exports = import.meta.resolve("hlR6q");

});

parcelRegister("5nmUL", function(module, exports) {
module.exports = import.meta.resolve("97SaF");

});

parcelRegister("3f17H", function(module, exports) {
module.exports = import.meta.resolve("jo3l8");

});

parcelRegister("ch0Bi", function(module, exports) {
module.exports = import.meta.resolve("9EhZi");

});

parcelRegister("1S1Lm", function(module, exports) {
module.exports = import.meta.resolve("ggClv");

});

parcelRegister("cuaoc", function(module, exports) {
module.exports = import.meta.resolve("fD9ej");

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));





"use client";
//#region packages/@mantine/core/src/core/MantineProvider/color-scheme-managers/is-mantine-color-scheme.ts
function $0819c57096921b23$export$65daf38465c08e79(value) {
    return value === "auto" || value === "dark" || value === "light";
}


"use client";
//#region packages/@mantine/core/src/core/MantineProvider/color-scheme-managers/local-storage-manager.ts
function $3bad1881056c620a$export$3114d9bddade735e({ key: key = "mantine-color-scheme-value" } = {}) {
    let handleStorageEvent;
    return {
        get: (defaultValue)=>{
            if (typeof window === "undefined") return defaultValue;
            try {
                const storedColorScheme = window.localStorage.getItem(key);
                return (0, $0819c57096921b23$export$65daf38465c08e79)(storedColorScheme) ? storedColorScheme : defaultValue;
            } catch  {
                return defaultValue;
            }
        },
        set: (value)=>{
            try {
                window.localStorage.setItem(key, value);
            } catch (error) {
                console.warn("[@mantine/core] Local storage color scheme manager was unable to save color scheme.", error);
            }
        },
        subscribe: (onUpdate)=>{
            handleStorageEvent = (event)=>{
                if (event.storageArea === window.localStorage && event.key === key) (0, $0819c57096921b23$export$65daf38465c08e79)(event.newValue) && onUpdate(event.newValue);
            };
            window.addEventListener("storage", handleStorageEvent);
        },
        unsubscribe: ()=>{
            window.removeEventListener("storage", handleStorageEvent);
        },
        clear: ()=>{
            window.localStorage.removeItem(key);
        }
    };
}



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/core/MantineProvider/Mantine.context.ts
const $bbb97275c373484a$export$4ba45a360873bd20 = (0, $acw62.createContext)(null);
function $bbb97275c373484a$export$2f9729a1501fd576() {
    const ctx = (0, $acw62.use)($bbb97275c373484a$export$4ba45a360873bd20);
    if (!ctx) throw new Error("[@mantine/core] MantineProvider was not found in tree");
    return ctx;
}
function $bbb97275c373484a$export$875b251c245b8c99() {
    return $bbb97275c373484a$export$2f9729a1501fd576().cssVariablesResolver;
}
function $bbb97275c373484a$export$635322ad820b722f() {
    return $bbb97275c373484a$export$2f9729a1501fd576().classNamesPrefix;
}
function $bbb97275c373484a$export$ca3d89ae7d92a638() {
    return $bbb97275c373484a$export$2f9729a1501fd576().getStyleNonce;
}
function $bbb97275c373484a$export$9f9af79c864a043d() {
    return $bbb97275c373484a$export$2f9729a1501fd576().withStaticClasses;
}
function $bbb97275c373484a$export$dd8473d25cec2fe9() {
    return $bbb97275c373484a$export$2f9729a1501fd576().headless;
}
function $bbb97275c373484a$export$90b3f271845c7f71() {
    return $bbb97275c373484a$export$2f9729a1501fd576().stylesTransform?.sx;
}
function $bbb97275c373484a$export$a6d64564e25afc49() {
    return $bbb97275c373484a$export$2f9729a1501fd576().stylesTransform?.styles;
}
function $bbb97275c373484a$export$2a0cf0a5fd0c6e81() {
    return $bbb97275c373484a$export$2f9729a1501fd576().env || "default";
}
function $bbb97275c373484a$export$1c2d544eb56b2eae() {
    return $bbb97275c373484a$export$2f9729a1501fd576().deduplicateInlineStyles;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-isomorphic-effect/use-isomorphic-effect.ts
const $562774022e0ac3ca$export$363c9f3eb56bbdbe = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


"use client";
//#region packages/@mantine/core/src/core/MantineProvider/use-mantine-color-scheme/use-provider-color-scheme.ts
function $e58862222fe72cb1$var$setColorSchemeAttribute(colorScheme, getRootElement) {
    const hasDarkColorScheme = typeof window !== "undefined" && "matchMedia" in window && window.matchMedia("(prefers-color-scheme: dark)")?.matches;
    const computedColorScheme = colorScheme !== "auto" ? colorScheme : hasDarkColorScheme ? "dark" : "light";
    getRootElement()?.setAttribute("data-mantine-color-scheme", computedColorScheme);
}
function $e58862222fe72cb1$export$390785fb3763d6cf({ manager: manager, defaultColorScheme: defaultColorScheme, getRootElement: getRootElement, forceColorScheme: forceColorScheme }) {
    const media = (0, $acw62.useRef)(null);
    const [value, setValue] = (0, $acw62.useState)(()=>manager.get(defaultColorScheme));
    const colorSchemeValue = forceColorScheme || value;
    const setColorScheme = (0, $acw62.useCallback)((colorScheme)=>{
        if (!forceColorScheme) {
            $e58862222fe72cb1$var$setColorSchemeAttribute(colorScheme, getRootElement);
            setValue(colorScheme);
            manager.set(colorScheme);
        }
    }, [
        manager.set,
        colorSchemeValue,
        forceColorScheme
    ]);
    const clearColorScheme = (0, $acw62.useCallback)(()=>{
        setValue(defaultColorScheme);
        $e58862222fe72cb1$var$setColorSchemeAttribute(defaultColorScheme, getRootElement);
        manager.clear();
    }, [
        manager.clear,
        defaultColorScheme
    ]);
    (0, $acw62.useEffect)(()=>{
        manager.subscribe(setColorScheme);
        return manager.unsubscribe;
    }, [
        manager.subscribe,
        manager.unsubscribe
    ]);
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        $e58862222fe72cb1$var$setColorSchemeAttribute(manager.get(defaultColorScheme), getRootElement);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (forceColorScheme) {
            $e58862222fe72cb1$var$setColorSchemeAttribute(forceColorScheme, getRootElement);
            return ()=>{};
        }
        if (forceColorScheme === void 0) $e58862222fe72cb1$var$setColorSchemeAttribute(value, getRootElement);
        if (typeof window !== "undefined" && "matchMedia" in window) media.current = window.matchMedia("(prefers-color-scheme: dark)");
        const listener = (event)=>{
            if (value === "auto") $e58862222fe72cb1$var$setColorSchemeAttribute(event.matches ? "dark" : "light", getRootElement);
        };
        media.current?.addEventListener("change", listener);
        return ()=>media.current?.removeEventListener("change", listener);
    }, [
        value,
        forceColorScheme
    ]);
    return {
        colorScheme: colorSchemeValue,
        setColorScheme: setColorScheme,
        clearColorScheme: clearColorScheme
    };
}





//#region packages/@mantine/core/src/core/utils/units-converters/rem.ts
function $7a68b0670ce0ab52$var$scaleRem(remValue) {
    if (remValue === "0rem") return "0rem";
    return `calc(${remValue} * var(--mantine-scale))`;
}
function $7a68b0670ce0ab52$var$createConverter(units, { shouldScale: shouldScale = false } = {}) {
    function converter(value) {
        if (value === 0 || value === "0") return `0${units}`;
        if (typeof value === "number") {
            const val = `${value / 16}${units}`;
            return shouldScale ? $7a68b0670ce0ab52$var$scaleRem(val) : val;
        }
        if (typeof value === "string") {
            if (value === "") return value;
            if (value.startsWith("calc(") || value.startsWith("clamp(") || value.includes("rgba(")) return value;
            if (value.includes(",")) return value.split(",").map((val)=>converter(val)).join(",");
            if (value.includes(" ")) return value.split(" ").map((val)=>converter(val)).join(" ");
            const replaced = value.replace("px", "");
            if (!Number.isNaN(Number(replaced))) {
                const val = `${Number(replaced) / 16}${units}`;
                return shouldScale ? $7a68b0670ce0ab52$var$scaleRem(val) : val;
            }
        }
        return value;
    }
    return converter;
}
const $7a68b0670ce0ab52$export$fb1897a40d146f7f = $7a68b0670ce0ab52$var$createConverter("rem", {
    shouldScale: true
});
const $7a68b0670ce0ab52$export$c63c6f932822f543 = $7a68b0670ce0ab52$var$createConverter("em");



"use client";
//#region packages/@mantine/core/src/core/MantineProvider/color-functions/get-primary-shade/get-primary-shade.ts
function $8c0a85c8b0a1cf67$export$577a930223dcda99(theme, colorScheme) {
    if (typeof theme.primaryShade === "number") return theme.primaryShade;
    if (colorScheme === "dark") return theme.primaryShade.dark;
    return theme.primaryShade.light;
}


//#region packages/@mantine/core/src/core/MantineProvider/color-functions/to-rgba/to-rgba.ts
function $eedf50c1f1ee6321$var$isHexColor(hex) {
    return /^#?([0-9A-F]{3}){1,2}([0-9A-F]{2})?$/i.test(hex);
}
function $eedf50c1f1ee6321$var$hexToRgba(color) {
    let hexString = color.replace("#", "");
    if (hexString.length === 3) {
        const shorthandHex = hexString.split("");
        hexString = [
            shorthandHex[0],
            shorthandHex[0],
            shorthandHex[1],
            shorthandHex[1],
            shorthandHex[2],
            shorthandHex[2]
        ].join("");
    }
    if (hexString.length === 8) {
        const alpha = parseInt(hexString.slice(6, 8), 16) / 255;
        return {
            r: parseInt(hexString.slice(0, 2), 16),
            g: parseInt(hexString.slice(2, 4), 16),
            b: parseInt(hexString.slice(4, 6), 16),
            a: alpha
        };
    }
    const parsed = parseInt(hexString, 16);
    return {
        r: parsed >> 16 & 255,
        g: parsed >> 8 & 255,
        b: parsed & 255,
        a: 1
    };
}
function $eedf50c1f1ee6321$var$rgbStringToRgba(color) {
    const [r, g, b, a] = color.replace(/[^0-9,./]/g, "").split(/[/,]/).map(Number);
    return {
        r: r,
        g: g,
        b: b,
        a: a === void 0 ? 1 : a
    };
}
function $eedf50c1f1ee6321$var$hslStringToRgba(hslaString) {
    const matches = hslaString.match(/^hsla?\(\s*(\d+)\s*,\s*(\d+%)\s*,\s*(\d+%)\s*(,\s*(0?\.\d+|\d+(\.\d+)?))?\s*\)$/i);
    if (!matches) return {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    };
    const h = parseInt(matches[1], 10);
    const s = parseInt(matches[2], 10) / 100;
    const l = parseInt(matches[3], 10) / 100;
    const a = matches[5] ? parseFloat(matches[5]) : void 0;
    const chroma = (1 - Math.abs(2 * l - 1)) * s;
    const huePrime = h / 60;
    const x = chroma * (1 - Math.abs(huePrime % 2 - 1));
    const m = l - chroma / 2;
    let r;
    let g;
    let b;
    if (huePrime >= 0 && huePrime < 1) {
        r = chroma;
        g = x;
        b = 0;
    } else if (huePrime >= 1 && huePrime < 2) {
        r = x;
        g = chroma;
        b = 0;
    } else if (huePrime >= 2 && huePrime < 3) {
        r = 0;
        g = chroma;
        b = x;
    } else if (huePrime >= 3 && huePrime < 4) {
        r = 0;
        g = x;
        b = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        r = x;
        g = 0;
        b = chroma;
    } else {
        r = chroma;
        g = 0;
        b = x;
    }
    return {
        r: Math.round((r + m) * 255),
        g: Math.round((g + m) * 255),
        b: Math.round((b + m) * 255),
        a: a || 1
    };
}
function $eedf50c1f1ee6321$export$5db297beaffffbfc(color) {
    if ($eedf50c1f1ee6321$var$isHexColor(color)) return $eedf50c1f1ee6321$var$hexToRgba(color);
    if (color.startsWith("rgb")) return $eedf50c1f1ee6321$var$rgbStringToRgba(color);
    if (color.startsWith("hsl")) return $eedf50c1f1ee6321$var$hslStringToRgba(color);
    return {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    };
}


//#region packages/@mantine/core/src/core/MantineProvider/color-functions/luminance/luminance.ts
function $ff16d6dd659ff4be$var$gammaCorrect(c) {
    return c <= .03928 ? c / 12.92 : ((c + .055) / 1.055) ** 2.4;
}
function $ff16d6dd659ff4be$var$getLightnessFromOklch(oklchColor) {
    const match = oklchColor.match(/oklch\((.*?)%\s/);
    return match ? parseFloat(match[1]) : null;
}
function $ff16d6dd659ff4be$export$5c6e3c2b59b7fbbe(color) {
    if (color.startsWith("oklch(")) return ($ff16d6dd659ff4be$var$getLightnessFromOklch(color) || 0) / 100;
    const { r: r, g: g, b: b } = (0, $eedf50c1f1ee6321$export$5db297beaffffbfc)(color);
    const sR = r / 255;
    const sG = g / 255;
    const sB = b / 255;
    const rLinear = $ff16d6dd659ff4be$var$gammaCorrect(sR);
    const gLinear = $ff16d6dd659ff4be$var$gammaCorrect(sG);
    const bLinear = $ff16d6dd659ff4be$var$gammaCorrect(sB);
    return .2126 * rLinear + .7152 * gLinear + .0722 * bLinear;
}
function $ff16d6dd659ff4be$export$94fcbb60fb75553c(color, luminanceThreshold = .179) {
    if (color.startsWith("var(")) return false;
    return $ff16d6dd659ff4be$export$5c6e3c2b59b7fbbe(color) > luminanceThreshold;
}


"use client";
//#region packages/@mantine/core/src/core/MantineProvider/color-functions/parse-theme-color/parse-theme-color.ts
function $33a822173b5f4b0f$export$83e0a426d2da8ac1({ color: color, theme: theme, colorScheme: colorScheme }) {
    if (typeof color !== "string") throw new Error(`[@mantine/core] Failed to parse color. Expected color to be a string, instead got ${typeof color}`);
    if (color === "bright") return {
        color: color,
        value: colorScheme === "dark" ? theme.white : theme.black,
        shade: void 0,
        isThemeColor: false,
        isLight: (0, $ff16d6dd659ff4be$export$94fcbb60fb75553c)(colorScheme === "dark" ? theme.white : theme.black, theme.luminanceThreshold),
        variable: "--mantine-color-bright"
    };
    if (color === "dimmed") return {
        color: color,
        value: colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
        shade: void 0,
        isThemeColor: false,
        isLight: (0, $ff16d6dd659ff4be$export$94fcbb60fb75553c)(colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6], theme.luminanceThreshold),
        variable: "--mantine-color-dimmed"
    };
    if (color === "white" || color === "black") return {
        color: color,
        value: color === "white" ? theme.white : theme.black,
        shade: void 0,
        isThemeColor: false,
        isLight: (0, $ff16d6dd659ff4be$export$94fcbb60fb75553c)(color === "white" ? theme.white : theme.black, theme.luminanceThreshold),
        variable: `--mantine-color-${color}`
    };
    const [_color, shade] = color.split(".");
    const colorShade = shade ? Number(shade) : void 0;
    const isThemeColor = _color in theme.colors;
    if (isThemeColor) {
        const colorValue = colorShade !== void 0 ? theme.colors[_color][colorShade] : theme.colors[_color][(0, $8c0a85c8b0a1cf67$export$577a930223dcda99)(theme, colorScheme || "light")];
        return {
            color: _color,
            value: colorValue,
            shade: colorShade,
            isThemeColor: isThemeColor,
            isLight: (0, $ff16d6dd659ff4be$export$94fcbb60fb75553c)(colorValue, theme.luminanceThreshold),
            variable: shade ? `--mantine-color-${_color}-${colorShade}` : `--mantine-color-${_color}-filled`
        };
    }
    return {
        color: color,
        value: color,
        isThemeColor: isThemeColor,
        isLight: (0, $ff16d6dd659ff4be$export$94fcbb60fb75553c)(color, theme.luminanceThreshold),
        shade: colorShade,
        variable: void 0
    };
}


//#region packages/@mantine/core/src/core/MantineProvider/color-functions/colors-tuple/colors-tuple.ts
function $fb307e4fc1fb40ac$export$451ef11199896fbe(input) {
    if (Array.isArray(input)) return input;
    return Array(10).fill(input);
}


//#region packages/@mantine/core/src/core/MantineProvider/MantineCssVariables/virtual-color/virtual-color.ts
function $c1081712acbf6d97$export$960187165b40296f(input) {
    const result = (0, $fb307e4fc1fb40ac$export$451ef11199896fbe)(Array.from({
        length: 10
    }).map((_, i)=>`var(--mantine-color-${input.name}-${i})`));
    Object.defineProperty(result, "mantine-virtual-color", {
        enumerable: false,
        writable: false,
        configurable: false,
        value: true
    });
    Object.defineProperty(result, "dark", {
        enumerable: false,
        writable: false,
        configurable: false,
        value: input.dark
    });
    Object.defineProperty(result, "light", {
        enumerable: false,
        writable: false,
        configurable: false,
        value: input.light
    });
    Object.defineProperty(result, "name", {
        enumerable: false,
        writable: false,
        configurable: false,
        value: input.name
    });
    return result;
}
function $c1081712acbf6d97$export$887531f01b0b01c7(value) {
    return !!value && typeof value === "object" && "mantine-virtual-color" in value;
}



//#region packages/@mantine/core/src/core/MantineProvider/color-functions/darken/darken.ts
function $658d03b0d202e9a7$export$4b073707ff63303(color, alpha) {
    if (color.startsWith("var(")) return `color-mix(in srgb, ${color}, black ${alpha * 100}%)`;
    const { r: r, g: g, b: b, a: a } = (0, $eedf50c1f1ee6321$export$5db297beaffffbfc)(color);
    const f = 1 - alpha;
    const dark = (input)=>Math.round(input * f);
    return `rgba(${dark(r)}, ${dark(g)}, ${dark(b)}, ${a})`;
}



"use client";
//#region packages/@mantine/core/src/core/MantineProvider/color-functions/get-theme-color/get-theme-color.ts
function $0a9c57cec2a3e373$export$e22c5d06d177c3fa(color, theme) {
    const parsed = (0, $33a822173b5f4b0f$export$83e0a426d2da8ac1)({
        color: color || theme.primaryColor,
        theme: theme
    });
    return parsed.variable ? `var(${parsed.variable})` : color;
}


"use client";
//#region packages/@mantine/core/src/core/MantineProvider/color-functions/get-gradient/get-gradient.ts
function $bdea122fb92e1007$export$e14995d3ec1747ee(gradient, theme) {
    const merged = {
        from: gradient?.from || theme.defaultGradient.from,
        to: gradient?.to || theme.defaultGradient.to,
        deg: gradient?.deg ?? theme.defaultGradient.deg ?? 0
    };
    const fromColor = (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(merged.from, theme);
    const toColor = (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(merged.to, theme);
    return `linear-gradient(${merged.deg}deg, ${fromColor} 0%, ${toColor} 100%)`;
}



//#region packages/@mantine/core/src/core/MantineProvider/color-functions/rgba/rgba.ts
function $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b(color, alpha) {
    if (typeof color !== "string" || alpha > 1 || alpha < 0) return "rgba(0, 0, 0, 1)";
    if (color.startsWith("var(")) return `color-mix(in srgb, ${color}, transparent ${(1 - alpha) * 100}%)`;
    if (color.startsWith("oklch")) {
        if (color.includes("/")) return color.replace(/\/\s*[\d.]+\s*\)/, `/ ${alpha})`);
        return color.replace(")", ` / ${alpha})`);
    }
    const { r: r, g: g, b: b } = (0, $eedf50c1f1ee6321$export$5db297beaffffbfc)(color);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
const $a29d51c1f7df5c7c$export$58f0f39f63f3cf42 = $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b;


"use client";
//#region packages/@mantine/core/src/core/MantineProvider/color-functions/default-variant-colors-resolver/default-variant-colors-resolver.ts
const $1f26a13d318caa8d$export$a75cb1ab905fa258 = ({ color: color, theme: theme, variant: variant, gradient: gradient, autoContrast: autoContrast })=>{
    const parsed = (0, $33a822173b5f4b0f$export$83e0a426d2da8ac1)({
        color: color,
        theme: theme
    });
    const _autoContrast = typeof autoContrast === "boolean" ? autoContrast : theme.autoContrast;
    if (variant === "none") return {
        background: "transparent",
        hover: "transparent",
        color: "inherit",
        border: "none"
    };
    if (variant === "filled") {
        const isVirtual = parsed.isThemeColor && parsed.shade === void 0 && (0, $c1081712acbf6d97$export$887531f01b0b01c7)(theme.colors[parsed.color]);
        const textColor = _autoContrast ? isVirtual ? `var(--mantine-color-${parsed.color}-contrast)` : parsed.isLight ? "var(--mantine-color-black)" : "var(--mantine-color-white)" : "var(--mantine-color-white)";
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: `var(--mantine-color-${color}-filled)`,
                hover: `var(--mantine-color-${color}-filled-hover)`,
                color: textColor,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
            return {
                background: `var(--mantine-color-${parsed.color}-${parsed.shade})`,
                hover: `var(--mantine-color-${parsed.color}-${parsed.shade === 9 ? 8 : parsed.shade + 1})`,
                color: textColor,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
        }
        return {
            background: color,
            hover: (0, $658d03b0d202e9a7$export$4b073707ff63303)(color, .1),
            color: textColor,
            border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
        };
    }
    if (variant === "light") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: `var(--mantine-color-${color}-light)`,
                hover: `var(--mantine-color-${color}-light-hover)`,
                color: `var(--mantine-color-${color}-light-color)`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
            const parsedColor = theme.colors[parsed.color][parsed.shade];
            return {
                background: parsedColor,
                hover: (0, $658d03b0d202e9a7$export$4b073707ff63303)(parsedColor, .1),
                color: `var(--mantine-color-${parsed.color}-light-color)`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
        }
        return {
            background: (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(color, .1),
            hover: (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(color, .12),
            color: color,
            border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
        };
    }
    if (variant === "outline") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "transparent",
                hover: `var(--mantine-color-${color}-outline-hover)`,
                color: `var(--mantine-color-${color}-outline)`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid var(--mantine-color-${color}-outline)`
            };
            return {
                background: "transparent",
                hover: (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(theme.colors[parsed.color][parsed.shade], .05),
                color: `var(--mantine-color-${parsed.color}-${parsed.shade})`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid var(--mantine-color-${parsed.color}-${parsed.shade})`
            };
        }
        return {
            background: "transparent",
            hover: (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(color, .05),
            color: color,
            border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid ${color}`
        };
    }
    if (variant === "subtle") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "transparent",
                hover: `var(--mantine-color-${color}-light-hover)`,
                color: `var(--mantine-color-${color}-light-color)`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
            const parsedColor = theme.colors[parsed.color][parsed.shade];
            return {
                background: "transparent",
                hover: (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(parsedColor, .12),
                color: `var(--mantine-color-${parsed.color}-${Math.min(parsed.shade, 6)})`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
        }
        return {
            background: "transparent",
            hover: (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(color, .12),
            color: color,
            border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
        };
    }
    if (variant === "transparent") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "transparent",
                hover: "transparent",
                color: `var(--mantine-color-${color}-light-color)`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
            return {
                background: "transparent",
                hover: "transparent",
                color: `var(--mantine-color-${parsed.color}-${Math.min(parsed.shade, 6)})`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
        }
        return {
            background: "transparent",
            hover: "transparent",
            color: color,
            border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
        };
    }
    if (variant === "white") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "var(--mantine-color-white)",
                hover: (0, $658d03b0d202e9a7$export$4b073707ff63303)(theme.white, .01),
                color: `var(--mantine-color-${color}-filled)`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
            return {
                background: "var(--mantine-color-white)",
                hover: (0, $658d03b0d202e9a7$export$4b073707ff63303)(theme.white, .01),
                color: `var(--mantine-color-${parsed.color}-${parsed.shade})`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
        }
        return {
            background: "var(--mantine-color-white)",
            hover: (0, $658d03b0d202e9a7$export$4b073707ff63303)(theme.white, .01),
            color: color,
            border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
        };
    }
    if (variant === "gradient") return {
        background: (0, $bdea122fb92e1007$export$e14995d3ec1747ee)(gradient, theme),
        hover: (0, $bdea122fb92e1007$export$e14995d3ec1747ee)(gradient, theme),
        color: "var(--mantine-color-white)",
        border: "none"
    };
    if (variant === "default") return {
        background: "var(--mantine-color-default)",
        hover: "var(--mantine-color-default-hover)",
        color: "var(--mantine-color-default-color)",
        border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid var(--mantine-color-default-border)`
    };
    return {};
};


//#region packages/@mantine/core/src/core/MantineProvider/default-colors.ts
const $b5aa84565affcc12$export$e60cfe038231c681 = {
    dark: [
        "#C9C9C9",
        "#b8b8b8",
        "#828282",
        "#696969",
        "#424242",
        "#3b3b3b",
        "#2e2e2e",
        "#242424",
        "#1f1f1f",
        "#141414"
    ],
    gray: [
        "#f8f9fa",
        "#f1f3f5",
        "#e9ecef",
        "#dee2e6",
        "#ced4da",
        "#adb5bd",
        "#868e96",
        "#495057",
        "#343a40",
        "#212529"
    ],
    red: [
        "#fff5f5",
        "#ffe3e3",
        "#ffc9c9",
        "#ffa8a8",
        "#ff8787",
        "#ff6b6b",
        "#fa5252",
        "#f03e3e",
        "#e03131",
        "#c92a2a"
    ],
    pink: [
        "#fff0f6",
        "#ffdeeb",
        "#fcc2d7",
        "#faa2c1",
        "#f783ac",
        "#f06595",
        "#e64980",
        "#d6336c",
        "#c2255c",
        "#a61e4d"
    ],
    grape: [
        "#f8f0fc",
        "#f3d9fa",
        "#eebefa",
        "#e599f7",
        "#da77f2",
        "#cc5de8",
        "#be4bdb",
        "#ae3ec9",
        "#9c36b5",
        "#862e9c"
    ],
    violet: [
        "#f3f0ff",
        "#e5dbff",
        "#d0bfff",
        "#b197fc",
        "#9775fa",
        "#845ef7",
        "#7950f2",
        "#7048e8",
        "#6741d9",
        "#5f3dc4"
    ],
    indigo: [
        "#edf2ff",
        "#dbe4ff",
        "#bac8ff",
        "#91a7ff",
        "#748ffc",
        "#5c7cfa",
        "#4c6ef5",
        "#4263eb",
        "#3b5bdb",
        "#364fc7"
    ],
    blue: [
        "#e7f5ff",
        "#d0ebff",
        "#a5d8ff",
        "#74c0fc",
        "#4dabf7",
        "#339af0",
        "#228be6",
        "#1c7ed6",
        "#1971c2",
        "#1864ab"
    ],
    cyan: [
        "#e3fafc",
        "#c5f6fa",
        "#99e9f2",
        "#66d9e8",
        "#3bc9db",
        "#22b8cf",
        "#15aabf",
        "#1098ad",
        "#0c8599",
        "#0b7285"
    ],
    teal: [
        "#e6fcf5",
        "#c3fae8",
        "#96f2d7",
        "#63e6be",
        "#38d9a9",
        "#20c997",
        "#12b886",
        "#0ca678",
        "#099268",
        "#087f5b"
    ],
    green: [
        "#ebfbee",
        "#d3f9d8",
        "#b2f2bb",
        "#8ce99a",
        "#69db7c",
        "#51cf66",
        "#40c057",
        "#37b24d",
        "#2f9e44",
        "#2b8a3e"
    ],
    lime: [
        "#f4fce3",
        "#e9fac8",
        "#d8f5a2",
        "#c0eb75",
        "#a9e34b",
        "#94d82d",
        "#82c91e",
        "#74b816",
        "#66a80f",
        "#5c940d"
    ],
    yellow: [
        "#fff9db",
        "#fff3bf",
        "#ffec99",
        "#ffe066",
        "#ffd43b",
        "#fcc419",
        "#fab005",
        "#f59f00",
        "#f08c00",
        "#e67700"
    ],
    orange: [
        "#fff4e6",
        "#ffe8cc",
        "#ffd8a8",
        "#ffc078",
        "#ffa94d",
        "#ff922b",
        "#fd7e14",
        "#f76707",
        "#e8590c",
        "#d9480f"
    ]
};


//#region packages/@mantine/core/src/core/MantineProvider/default-theme.ts
const $5b6cd714d8388858$var$DEFAULT_FONT_FAMILY = "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji";
const $5b6cd714d8388858$export$2faeed762aac6741 = {
    scale: 1,
    fontSmoothing: true,
    focusRing: "auto",
    white: "#fff",
    black: "#000",
    colors: (0, $b5aa84565affcc12$export$e60cfe038231c681),
    primaryShade: {
        light: 6,
        dark: 8
    },
    primaryColor: "blue",
    variantColorResolver: (0, $1f26a13d318caa8d$export$a75cb1ab905fa258),
    autoContrast: false,
    luminanceThreshold: .3,
    fontFamily: $5b6cd714d8388858$var$DEFAULT_FONT_FAMILY,
    fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
    respectReducedMotion: false,
    cursorType: "default",
    defaultGradient: {
        from: "blue",
        to: "cyan",
        deg: 45
    },
    defaultRadius: "md",
    activeClassName: "mantine-active",
    focusClassName: "",
    headings: {
        fontFamily: $5b6cd714d8388858$var$DEFAULT_FONT_FAMILY,
        fontWeight: "700",
        textWrap: "wrap",
        sizes: {
            h1: {
                fontSize: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(34),
                lineHeight: "1.3"
            },
            h2: {
                fontSize: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(26),
                lineHeight: "1.35"
            },
            h3: {
                fontSize: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(22),
                lineHeight: "1.4"
            },
            h4: {
                fontSize: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(18),
                lineHeight: "1.45"
            },
            h5: {
                fontSize: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(16),
                lineHeight: "1.5"
            },
            h6: {
                fontSize: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(14),
                lineHeight: "1.5"
            }
        }
    },
    fontSizes: {
        xs: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(12),
        sm: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(14),
        md: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(16),
        lg: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(18),
        xl: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(20)
    },
    lineHeights: {
        xs: "1.4",
        sm: "1.45",
        md: "1.55",
        lg: "1.6",
        xl: "1.65"
    },
    fontWeights: {
        regular: "400",
        medium: "600",
        bold: "700"
    },
    radius: {
        xs: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(2),
        sm: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(4),
        md: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(8),
        lg: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(16),
        xl: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(32)
    },
    spacing: {
        xs: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(10),
        sm: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(12),
        md: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(16),
        lg: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(20),
        xl: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(32)
    },
    breakpoints: {
        xs: "36em",
        sm: "48em",
        md: "62em",
        lg: "75em",
        xl: "88em"
    },
    shadows: {
        xs: `0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(3)} rgba(0, 0, 0, 0.05), 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(2)} rgba(0, 0, 0, 0.1)`,
        sm: `0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(10)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(15)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-5)}, rgba(0, 0, 0, 0.04) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(7)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(7)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-5)}`,
        md: `0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(20)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(25)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-5)}, rgba(0, 0, 0, 0.04) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(10)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(10)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-5)}`,
        lg: `0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(28)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(23)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-7)}, rgba(0, 0, 0, 0.04) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(12)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(12)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-7)}`,
        xl: `0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(36)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(28)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-7)}, rgba(0, 0, 0, 0.04) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(17)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(17)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-7)}`
    },
    other: {},
    components: {}
};


//#region packages/@mantine/core/src/core/utils/deep-merge/deep-merge.ts
function $8ff81336d9cb648b$var$isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
}
function $8ff81336d9cb648b$export$6969335ea1e4e77c(target, source) {
    const result = {
        ...target
    };
    const _source = source;
    if ($8ff81336d9cb648b$var$isObject(target) && $8ff81336d9cb648b$var$isObject(source)) Object.keys(source).forEach((key)=>{
        if ($8ff81336d9cb648b$var$isObject(_source[key])) {
            if (!(key in target)) result[key] = _source[key];
            else result[key] = $8ff81336d9cb648b$export$6969335ea1e4e77c(result[key], _source[key]);
        } else result[key] = _source[key];
    });
    return result;
}


//#region packages/@mantine/core/src/core/MantineProvider/merge-mantine-theme/merge-mantine-theme.ts
const $b1497e5035b07e57$var$INVALID_PRIMARY_COLOR_ERROR = "[@mantine/core] MantineProvider: Invalid theme.primaryColor, it accepts only key of theme.colors, learn more \u2013 https://mantine.dev/theming/colors/#primary-color";
const $b1497e5035b07e57$var$INVALID_PRIMARY_SHADE_ERROR = "[@mantine/core] MantineProvider: Invalid theme.primaryShade, it accepts only 0-9 integers or an object { light: 0-9, dark: 0-9 }";
function $b1497e5035b07e57$var$isValidPrimaryShade(shade) {
    if (shade < 0 || shade > 9) return false;
    return parseInt(shade.toString(), 10) === shade;
}
function $b1497e5035b07e57$export$2368dd16b50ed520(theme) {
    if (!(theme.primaryColor in theme.colors)) throw new Error($b1497e5035b07e57$var$INVALID_PRIMARY_COLOR_ERROR);
    if (typeof theme.primaryShade === "object") {
        if (!$b1497e5035b07e57$var$isValidPrimaryShade(theme.primaryShade.dark) || !$b1497e5035b07e57$var$isValidPrimaryShade(theme.primaryShade.light)) throw new Error($b1497e5035b07e57$var$INVALID_PRIMARY_SHADE_ERROR);
    }
    if (typeof theme.primaryShade === "number" && !$b1497e5035b07e57$var$isValidPrimaryShade(theme.primaryShade)) throw new Error($b1497e5035b07e57$var$INVALID_PRIMARY_SHADE_ERROR);
}
function $b1497e5035b07e57$export$c3dbee3ac229ebad(currentTheme, themeOverride) {
    if (!themeOverride) {
        $b1497e5035b07e57$export$2368dd16b50ed520(currentTheme);
        return currentTheme;
    }
    const result = (0, $8ff81336d9cb648b$export$6969335ea1e4e77c)(currentTheme, themeOverride);
    if (themeOverride.fontFamily && !themeOverride.headings?.fontFamily) result.headings = {
        ...result.headings,
        fontFamily: themeOverride.fontFamily
    };
    $b1497e5035b07e57$export$2368dd16b50ed520(result);
    return result;
}



var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/core/MantineProvider/MantineThemeProvider/MantineThemeProvider.tsx
const $692af3391f7b0a55$export$7fd5915d8252bddf = (0, $acw62.createContext)(null);
const $692af3391f7b0a55$export$374685f039976992 = ()=>(0, $acw62.use)($692af3391f7b0a55$export$7fd5915d8252bddf) || (0, $5b6cd714d8388858$export$2faeed762aac6741);
function $692af3391f7b0a55$export$5eb0e84f6418b457() {
    const ctx = (0, $acw62.use)($692af3391f7b0a55$export$7fd5915d8252bddf);
    if (!ctx) throw new Error("@mantine/core: MantineProvider was not found in component tree, make sure you have it in your app");
    return ctx;
}
function $692af3391f7b0a55$export$58281642be5f461a({ theme: theme, children: children, inherit: inherit = true }) {
    const parentTheme = $692af3391f7b0a55$export$374685f039976992();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($692af3391f7b0a55$export$7fd5915d8252bddf, {
        value: (0, $acw62.useMemo)(()=>(0, $b1497e5035b07e57$export$c3dbee3ac229ebad)(inherit ? parentTheme : (0, $5b6cd714d8388858$export$2faeed762aac6741), theme), [
            theme,
            parentTheme,
            inherit
        ]),
        children: children
    });
}
$692af3391f7b0a55$export$58281642be5f461a.displayName = "@mantine/core/MantineThemeProvider";


"use client";
//#region packages/@mantine/core/src/core/utils/keys/keys.ts
function $76cd5f02de8ee394$export$ed97f33186d4b816(object) {
    return Object.keys(object);
}


//#region packages/@mantine/core/src/core/utils/units-converters/px.ts
function $36050ce217b59930$var$getTransformedScaledValue(value) {
    if (typeof value !== "string" || !value.includes("var(--mantine-scale)")) return value;
    return value.match(/^calc\((.*?)\)$/)?.[1].split("*")[0].trim();
}
function $36050ce217b59930$export$91c0eda1d06bf008(value) {
    const transformedValue = $36050ce217b59930$var$getTransformedScaledValue(value);
    if (typeof transformedValue === "number") return transformedValue;
    if (typeof transformedValue === "string") {
        if (transformedValue.includes("calc") || transformedValue.includes("var")) return transformedValue;
        if (transformedValue.includes("px")) return Number(transformedValue.replace("px", ""));
        if (transformedValue.includes("rem")) return Number(transformedValue.replace("rem", "")) * 16;
        if (transformedValue.includes("em")) return Number(transformedValue.replace("em", "")) * 16;
        return Number(transformedValue);
    }
    return NaN;
}






"use client";
//#region packages/@mantine/core/src/core/MantineProvider/MantineClasses/MantineClasses.tsx
function $cea444195a17e4a3$export$a9121e68af319ab5() {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const nonce = (0, $bbb97275c373484a$export$ca3d89ae7d92a638)();
    const classes = (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(theme.breakpoints).reduce((acc, breakpoint)=>{
        const isPxBreakpoint = theme.breakpoints[breakpoint].includes("px");
        const pxValue = (0, $36050ce217b59930$export$91c0eda1d06bf008)(theme.breakpoints[breakpoint]);
        return `${acc}@media (max-width: ${isPxBreakpoint ? `${pxValue - .1}px` : (0, $7a68b0670ce0ab52$export$c63c6f932822f543)(pxValue - .1)}) {.mantine-visible-from-${breakpoint} {display: none !important;}}@media (min-width: ${isPxBreakpoint ? `${pxValue}px` : (0, $7a68b0670ce0ab52$export$c63c6f932822f543)(pxValue)}) {.mantine-hidden-from-${breakpoint} {display: none !important;}}`;
    }, "");
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("style", {
        "data-mantine-styles": "classes",
        nonce: nonce?.(),
        dangerouslySetInnerHTML: {
            __html: classes
        }
    });
}




"use client";
//#region packages/@mantine/core/src/core/MantineProvider/convert-css-variables/css-variables-object-to-string.ts
function $fb4c966bff9e1163$export$75fae6257d54d243(variables) {
    return Object.entries(variables).map(([name, value])=>`${name}: ${value};`).join("");
}


"use client";
//#region packages/@mantine/core/src/core/MantineProvider/convert-css-variables/convert-css-variables.ts
function $6754ab582a2c604a$export$6147dbdcc6854746(input, selectorOverride) {
    const selectors = selectorOverride ? [
        selectorOverride
    ] : [
        ":root",
        ":host"
    ];
    const sharedVariables = (0, $fb4c966bff9e1163$export$75fae6257d54d243)(input.variables);
    const shared = sharedVariables ? `${selectors.join(", ")}{${sharedVariables}}` : "";
    const dark = (0, $fb4c966bff9e1163$export$75fae6257d54d243)(input.dark);
    const light = (0, $fb4c966bff9e1163$export$75fae6257d54d243)(input.light);
    const selectorsWithScheme = (scheme)=>selectors.map((selector)=>selector === ":host" ? `${selector}([data-mantine-color-scheme="${scheme}"])` : `${selector}[data-mantine-color-scheme="${scheme}"]`).join(", ");
    return `${shared}\n\n${dark ? `${selectorsWithScheme("dark")}{${dark}}` : ""}\n\n${light ? `${selectorsWithScheme("light")}{${light}}` : ""}`;
}










"use client";
//#region packages/@mantine/core/src/core/MantineProvider/color-functions/get-contrast-color/get-contrast-color.ts
function $9082801c02aa279b$export$77a1051494882576({ color: color, theme: theme, autoContrast: autoContrast, colorScheme: colorScheme }) {
    if (!(typeof autoContrast === "boolean" ? autoContrast : theme.autoContrast)) return "var(--mantine-color-white)";
    return (0, $33a822173b5f4b0f$export$83e0a426d2da8ac1)({
        color: color || theme.primaryColor,
        theme: theme,
        colorScheme: colorScheme
    }).isLight ? "var(--mantine-color-black)" : "var(--mantine-color-white)";
}
function $9082801c02aa279b$export$a0a810beccb6dc65(value, theme, colorScheme) {
    return $9082801c02aa279b$export$77a1051494882576({
        color: colorScheme === "dark" ? value.dark : value.light,
        theme: theme,
        colorScheme: colorScheme,
        autoContrast: true
    });
}
function $9082801c02aa279b$export$8cd4b29a63693641(theme, colorScheme) {
    const primaryColor = theme.colors[theme.primaryColor];
    if ((0, $c1081712acbf6d97$export$887531f01b0b01c7)(primaryColor)) {
        if (!theme.autoContrast) return "var(--mantine-color-white)";
        return $9082801c02aa279b$export$a0a810beccb6dc65(primaryColor, theme, colorScheme);
    }
    return $9082801c02aa279b$export$77a1051494882576({
        color: primaryColor[(0, $8c0a85c8b0a1cf67$export$577a930223dcda99)(theme, colorScheme)],
        theme: theme,
        autoContrast: null
    });
}





"use client";
//#region packages/@mantine/core/src/core/MantineProvider/MantineCssVariables/get-css-color-variables.ts
function $5d748f21677e891a$export$299a2817bd07a327({ theme: theme, color: color, colorScheme: colorScheme, name: name = color, withColorValues: withColorValues = true }) {
    if (!theme.colors[color]) return {};
    if (colorScheme === "light") {
        const primaryShade = (0, $8c0a85c8b0a1cf67$export$577a930223dcda99)(theme, "light");
        const dynamicVariables = {
            [`--mantine-color-${name}-text`]: `var(--mantine-color-${name}-filled)`,
            [`--mantine-color-${name}-filled`]: `var(--mantine-color-${name}-${primaryShade})`,
            [`--mantine-color-${name}-filled-hover`]: `var(--mantine-color-${name}-${primaryShade === 9 ? 8 : primaryShade + 1})`,
            [`--mantine-color-${name}-light`]: `var(--mantine-color-${name}-1)`,
            [`--mantine-color-${name}-light-hover`]: `var(--mantine-color-${name}-2)`,
            [`--mantine-color-${name}-light-color`]: `var(--mantine-color-${name}-9)`,
            [`--mantine-color-${name}-outline`]: `var(--mantine-color-${name}-${primaryShade})`,
            [`--mantine-color-${name}-outline-hover`]: (0, $a29d51c1f7df5c7c$export$58f0f39f63f3cf42)(theme.colors[color][primaryShade], .05)
        };
        if (!withColorValues) return dynamicVariables;
        return {
            [`--mantine-color-${name}-0`]: theme.colors[color][0],
            [`--mantine-color-${name}-1`]: theme.colors[color][1],
            [`--mantine-color-${name}-2`]: theme.colors[color][2],
            [`--mantine-color-${name}-3`]: theme.colors[color][3],
            [`--mantine-color-${name}-4`]: theme.colors[color][4],
            [`--mantine-color-${name}-5`]: theme.colors[color][5],
            [`--mantine-color-${name}-6`]: theme.colors[color][6],
            [`--mantine-color-${name}-7`]: theme.colors[color][7],
            [`--mantine-color-${name}-8`]: theme.colors[color][8],
            [`--mantine-color-${name}-9`]: theme.colors[color][9],
            ...dynamicVariables
        };
    }
    const primaryShade = (0, $8c0a85c8b0a1cf67$export$577a930223dcda99)(theme, "dark");
    const dynamicVariables = {
        [`--mantine-color-${name}-text`]: `var(--mantine-color-${name}-4)`,
        [`--mantine-color-${name}-filled`]: `var(--mantine-color-${name}-${primaryShade})`,
        [`--mantine-color-${name}-filled-hover`]: `var(--mantine-color-${name}-${primaryShade === 9 ? 8 : primaryShade + 1})`,
        [`--mantine-color-${name}-light`]: (0, $658d03b0d202e9a7$export$4b073707ff63303)(theme.colors[color][9], .5),
        [`--mantine-color-${name}-light-hover`]: (0, $658d03b0d202e9a7$export$4b073707ff63303)(theme.colors[color][9], .3),
        [`--mantine-color-${name}-light-color`]: `var(--mantine-color-${name}-0)`,
        [`--mantine-color-${name}-outline`]: `var(--mantine-color-${name}-${Math.max(primaryShade - 4, 0)})`,
        [`--mantine-color-${name}-outline-hover`]: (0, $a29d51c1f7df5c7c$export$58f0f39f63f3cf42)(theme.colors[color][Math.max(primaryShade - 4, 0)], .05)
    };
    if (!withColorValues) return dynamicVariables;
    return {
        [`--mantine-color-${name}-0`]: theme.colors[color][0],
        [`--mantine-color-${name}-1`]: theme.colors[color][1],
        [`--mantine-color-${name}-2`]: theme.colors[color][2],
        [`--mantine-color-${name}-3`]: theme.colors[color][3],
        [`--mantine-color-${name}-4`]: theme.colors[color][4],
        [`--mantine-color-${name}-5`]: theme.colors[color][5],
        [`--mantine-color-${name}-6`]: theme.colors[color][6],
        [`--mantine-color-${name}-7`]: theme.colors[color][7],
        [`--mantine-color-${name}-8`]: theme.colors[color][8],
        [`--mantine-color-${name}-9`]: theme.colors[color][9],
        ...dynamicVariables
    };
}


"use client";
//#region packages/@mantine/core/src/core/MantineProvider/MantineCssVariables/default-css-variables-resolver.ts
function $7c7ebb59e6d0d04d$var$assignSizeVariables(variables, sizes, name) {
    (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(sizes).forEach((size)=>Object.assign(variables, {
            [`--mantine-${name}-${size}`]: sizes[size]
        }));
}
const $7c7ebb59e6d0d04d$export$f1525197a070c054 = (theme)=>{
    const lightPrimaryShade = (0, $8c0a85c8b0a1cf67$export$577a930223dcda99)(theme, "light");
    const defaultRadius = theme.defaultRadius in theme.radius ? theme.radius[theme.defaultRadius] : (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(theme.defaultRadius);
    const result = {
        variables: {
            "--mantine-z-index-app": "100",
            "--mantine-z-index-modal": "200",
            "--mantine-z-index-popover": "300",
            "--mantine-z-index-overlay": "400",
            "--mantine-z-index-max": "9999",
            "--mantine-scale": theme.scale.toString(),
            "--mantine-cursor-type": theme.cursorType,
            "--mantine-webkit-font-smoothing": theme.fontSmoothing ? "antialiased" : "unset",
            "--mantine-moz-font-smoothing": theme.fontSmoothing ? "grayscale" : "unset",
            "--mantine-color-white": theme.white,
            "--mantine-color-black": theme.black,
            "--mantine-line-height": theme.lineHeights.md,
            "--mantine-font-family": theme.fontFamily,
            "--mantine-font-family-monospace": theme.fontFamilyMonospace,
            "--mantine-font-family-headings": theme.headings.fontFamily,
            "--mantine-heading-font-weight": theme.headings.fontWeight,
            "--mantine-heading-text-wrap": theme.headings.textWrap,
            "--mantine-radius-default": defaultRadius,
            "--mantine-primary-color-filled": `var(--mantine-color-${theme.primaryColor}-filled)`,
            "--mantine-primary-color-filled-hover": `var(--mantine-color-${theme.primaryColor}-filled-hover)`,
            "--mantine-primary-color-light": `var(--mantine-color-${theme.primaryColor}-light)`,
            "--mantine-primary-color-light-hover": `var(--mantine-color-${theme.primaryColor}-light-hover)`,
            "--mantine-primary-color-light-color": `var(--mantine-color-${theme.primaryColor}-light-color)`
        },
        light: {
            "--mantine-color-scheme": "light",
            "--mantine-primary-color-contrast": (0, $9082801c02aa279b$export$8cd4b29a63693641)(theme, "light"),
            "--mantine-color-bright": "var(--mantine-color-black)",
            "--mantine-color-text": theme.black,
            "--mantine-color-body": theme.white,
            "--mantine-color-error": "var(--mantine-color-red-6)",
            "--mantine-color-success": "var(--mantine-color-teal-8)",
            "--mantine-color-placeholder": "var(--mantine-color-gray-5)",
            "--mantine-color-anchor": `var(--mantine-color-${theme.primaryColor}-${lightPrimaryShade})`,
            "--mantine-color-default": "var(--mantine-color-white)",
            "--mantine-color-default-hover": "var(--mantine-color-gray-0)",
            "--mantine-color-default-color": "var(--mantine-color-black)",
            "--mantine-color-default-border": "var(--mantine-color-gray-4)",
            "--mantine-color-dimmed": "var(--mantine-color-gray-6)",
            "--mantine-color-disabled": "var(--mantine-color-gray-2)",
            "--mantine-color-disabled-color": "var(--mantine-color-gray-5)",
            "--mantine-color-disabled-border": "var(--mantine-color-gray-3)"
        },
        dark: {
            "--mantine-color-scheme": "dark",
            "--mantine-primary-color-contrast": (0, $9082801c02aa279b$export$8cd4b29a63693641)(theme, "dark"),
            "--mantine-color-bright": "var(--mantine-color-white)",
            "--mantine-color-text": "var(--mantine-color-dark-0)",
            "--mantine-color-body": "var(--mantine-color-dark-7)",
            "--mantine-color-error": "var(--mantine-color-red-8)",
            "--mantine-color-success": "var(--mantine-color-teal-8)",
            "--mantine-color-placeholder": "var(--mantine-color-dark-3)",
            "--mantine-color-anchor": `var(--mantine-color-${theme.primaryColor}-4)`,
            "--mantine-color-default": "var(--mantine-color-dark-6)",
            "--mantine-color-default-hover": "var(--mantine-color-dark-5)",
            "--mantine-color-default-color": "var(--mantine-color-white)",
            "--mantine-color-default-border": "var(--mantine-color-dark-4)",
            "--mantine-color-dimmed": "var(--mantine-color-dark-2)",
            "--mantine-color-disabled": "var(--mantine-color-dark-6)",
            "--mantine-color-disabled-color": "var(--mantine-color-dark-3)",
            "--mantine-color-disabled-border": "var(--mantine-color-dark-4)"
        }
    };
    $7c7ebb59e6d0d04d$var$assignSizeVariables(result.variables, theme.breakpoints, "breakpoint");
    $7c7ebb59e6d0d04d$var$assignSizeVariables(result.variables, theme.spacing, "spacing");
    $7c7ebb59e6d0d04d$var$assignSizeVariables(result.variables, theme.fontSizes, "font-size");
    $7c7ebb59e6d0d04d$var$assignSizeVariables(result.variables, theme.lineHeights, "line-height");
    $7c7ebb59e6d0d04d$var$assignSizeVariables(result.variables, theme.shadows, "shadow");
    $7c7ebb59e6d0d04d$var$assignSizeVariables(result.variables, theme.radius, "radius");
    $7c7ebb59e6d0d04d$var$assignSizeVariables(result.variables, theme.fontWeights, "font-weight");
    theme.colors[theme.primaryColor].forEach((_, index)=>{
        result.variables[`--mantine-primary-color-${index}`] = `var(--mantine-color-${theme.primaryColor}-${index})`;
    });
    (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(theme.colors).forEach((color)=>{
        const value = theme.colors[color];
        if ((0, $c1081712acbf6d97$export$887531f01b0b01c7)(value)) {
            Object.assign(result.light, (0, $5d748f21677e891a$export$299a2817bd07a327)({
                theme: theme,
                name: value.name,
                color: value.light,
                colorScheme: "light",
                withColorValues: true
            }));
            Object.assign(result.dark, (0, $5d748f21677e891a$export$299a2817bd07a327)({
                theme: theme,
                name: value.name,
                color: value.dark,
                colorScheme: "dark",
                withColorValues: true
            }));
            result.light[`--mantine-color-${value.name}-contrast`] = (0, $9082801c02aa279b$export$a0a810beccb6dc65)(value, theme, "light");
            result.dark[`--mantine-color-${value.name}-contrast`] = (0, $9082801c02aa279b$export$a0a810beccb6dc65)(value, theme, "dark");
            return;
        }
        value.forEach((shade, index)=>{
            result.variables[`--mantine-color-${color}-${index}`] = shade;
        });
        Object.assign(result.light, (0, $5d748f21677e891a$export$299a2817bd07a327)({
            theme: theme,
            color: color,
            colorScheme: "light",
            withColorValues: false
        }));
        Object.assign(result.dark, (0, $5d748f21677e891a$export$299a2817bd07a327)({
            theme: theme,
            color: color,
            colorScheme: "dark",
            withColorValues: false
        }));
    });
    const headings = theme.headings.sizes;
    (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(headings).forEach((heading)=>{
        result.variables[`--mantine-${heading}-font-size`] = headings[heading].fontSize;
        result.variables[`--mantine-${heading}-line-height`] = headings[heading].lineHeight;
        result.variables[`--mantine-${heading}-font-weight`] = headings[heading].fontWeight || theme.headings.fontWeight;
    });
    return result;
};


"use client";
//#region packages/@mantine/core/src/core/MantineProvider/MantineCssVariables/get-merged-variables.ts
function $8c6d0c59070748ce$export$6e7ec19697e023e9({ theme: theme, generator: generator }) {
    const defaultResolver = (0, $7c7ebb59e6d0d04d$export$f1525197a070c054)(theme);
    const providerGenerator = generator?.(theme);
    return providerGenerator ? (0, $8ff81336d9cb648b$export$6969335ea1e4e77c)(defaultResolver, providerGenerator) : defaultResolver;
}





"use client";
//#region packages/@mantine/core/src/core/MantineProvider/MantineCssVariables/remove-default-variables.ts
const $aa1cfada76150c50$var$defaultCssVariables = (0, $7c7ebb59e6d0d04d$export$f1525197a070c054)((0, $5b6cd714d8388858$export$2faeed762aac6741));
function $aa1cfada76150c50$export$cfc05db1e6c5ab80(input) {
    const cleaned = {
        variables: {},
        light: {},
        dark: {}
    };
    (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(input.variables).forEach((key)=>{
        if ($aa1cfada76150c50$var$defaultCssVariables.variables[key] !== input.variables[key]) cleaned.variables[key] = input.variables[key];
    });
    (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(input.light).forEach((key)=>{
        if ($aa1cfada76150c50$var$defaultCssVariables.light[key] !== input.light[key]) cleaned.light[key] = input.light[key];
    });
    (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(input.dark).forEach((key)=>{
        if ($aa1cfada76150c50$var$defaultCssVariables.dark[key] !== input.dark[key]) cleaned.dark[key] = input.dark[key];
    });
    return cleaned;
}



"use client";
//#region packages/@mantine/core/src/core/MantineProvider/MantineCssVariables/MantineCssVariables.tsx
function $d31deba178d0679f$var$getColorSchemeCssVariables(selectorOverride) {
    return (0, $6754ab582a2c604a$export$6147dbdcc6854746)({
        variables: {},
        dark: {
            "--mantine-color-scheme": "dark"
        },
        light: {
            "--mantine-color-scheme": "light"
        }
    }, selectorOverride);
}
function $d31deba178d0679f$export$bfc71f5317840eaf({ cssVariablesSelector: cssVariablesSelector, deduplicateCssVariables: deduplicateCssVariables }) {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const nonce = (0, $bbb97275c373484a$export$ca3d89ae7d92a638)();
    const mergedVariables = (0, $8c6d0c59070748ce$export$6e7ec19697e023e9)({
        theme: theme,
        generator: (0, $bbb97275c373484a$export$875b251c245b8c99)()
    });
    const shouldCleanVariables = (cssVariablesSelector === void 0 || cssVariablesSelector === ":root" || cssVariablesSelector === ":host") && deduplicateCssVariables;
    const css = (0, $6754ab582a2c604a$export$6147dbdcc6854746)(shouldCleanVariables ? (0, $aa1cfada76150c50$export$cfc05db1e6c5ab80)(mergedVariables) : mergedVariables, cssVariablesSelector);
    if (css) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("style", {
        "data-mantine-styles": true,
        nonce: nonce?.(),
        dangerouslySetInnerHTML: {
            __html: `${css}${shouldCleanVariables ? "" : $d31deba178d0679f$var$getColorSchemeCssVariables(cssVariablesSelector)}`
        }
    });
    return null;
}
$d31deba178d0679f$export$bfc71f5317840eaf.displayName = "@mantine/CssVariables";



"use client";
//#region packages/@mantine/core/src/core/MantineProvider/use-respect-reduce-motion/use-respect-reduce-motion.ts
function $d45a0048df23fa10$export$aca9c65a2d2518b2({ respectReducedMotion: respectReducedMotion, getRootElement: getRootElement }) {
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        if (respectReducedMotion) getRootElement()?.setAttribute("data-respect-reduced-motion", "true");
    }, [
        respectReducedMotion
    ]);
}



"use client";
//#region packages/@mantine/core/src/core/MantineProvider/MantineProvider.tsx
function $5f8e78febad0631e$export$2ec8a50af9fc9ed7({ theme: theme, children: children, getStyleNonce: getStyleNonce, withStaticClasses: withStaticClasses = true, withGlobalClasses: withGlobalClasses = true, deduplicateCssVariables: deduplicateCssVariables = true, withCssVariables: withCssVariables = true, cssVariablesSelector: cssVariablesSelector, classNamesPrefix: classNamesPrefix = "mantine", colorSchemeManager: colorSchemeManager = (0, $3bad1881056c620a$export$3114d9bddade735e)(), defaultColorScheme: defaultColorScheme = "light", getRootElement: getRootElement = ()=>document.documentElement, cssVariablesResolver: cssVariablesResolver, forceColorScheme: forceColorScheme, stylesTransform: stylesTransform, env: env, deduplicateInlineStyles: deduplicateInlineStyles = false }) {
    const { colorScheme: colorScheme, setColorScheme: setColorScheme, clearColorScheme: clearColorScheme } = (0, $e58862222fe72cb1$export$390785fb3763d6cf)({
        defaultColorScheme: defaultColorScheme,
        forceColorScheme: forceColorScheme,
        manager: colorSchemeManager,
        getRootElement: getRootElement
    });
    (0, $d45a0048df23fa10$export$aca9c65a2d2518b2)({
        respectReducedMotion: theme?.respectReducedMotion || false,
        getRootElement: getRootElement
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $bbb97275c373484a$export$4ba45a360873bd20), {
        value: {
            colorScheme: colorScheme,
            setColorScheme: setColorScheme,
            clearColorScheme: clearColorScheme,
            getRootElement: getRootElement,
            classNamesPrefix: classNamesPrefix,
            getStyleNonce: getStyleNonce,
            cssVariablesResolver: cssVariablesResolver,
            cssVariablesSelector: cssVariablesSelector ?? ":root",
            withStaticClasses: withStaticClasses,
            stylesTransform: stylesTransform,
            env: env,
            deduplicateInlineStyles: deduplicateInlineStyles
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $692af3391f7b0a55$export$58281642be5f461a), {
            theme: theme,
            children: [
                withCssVariables && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $d31deba178d0679f$export$bfc71f5317840eaf), {
                    cssVariablesSelector: cssVariablesSelector,
                    deduplicateCssVariables: deduplicateCssVariables
                }),
                withGlobalClasses && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cea444195a17e4a3$export$a9121e68af319ab5), {}),
                children
            ]
        })
    });
}
$5f8e78febad0631e$export$2ec8a50af9fc9ed7.displayName = "@mantine/core/MantineProvider";
function $5f8e78febad0631e$export$a70725a4d7989cfd({ children: children, theme: theme, env: env }) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $bbb97275c373484a$export$4ba45a360873bd20), {
        value: {
            colorScheme: "auto",
            setColorScheme: ()=>{},
            clearColorScheme: ()=>{},
            getRootElement: ()=>document.documentElement,
            classNamesPrefix: "mantine",
            cssVariablesSelector: ":root",
            withStaticClasses: false,
            headless: true,
            env: env
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $692af3391f7b0a55$export$58281642be5f461a), {
            theme: theme,
            children: children
        })
    });
}
$5f8e78febad0631e$export$a70725a4d7989cfd.displayName = "@mantine/core/HeadlessMantineProvider";



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/modals/src/context.ts
const $263b364e1d2529cf$export$e5a070ff20f0f776 = (0, $acw62.createContext)(null);
$263b364e1d2529cf$export$e5a070ff20f0f776.displayName = "@mantine/modals/ModalsContext";




var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/modals/src/use-modals/use-modals.ts
function $b6724fb04d5a1332$export$2ee174121202e4c7() {
    const ctx = (0, $acw62.use)((0, $263b364e1d2529cf$export$e5a070ff20f0f776));
    if (!ctx) throw new Error("[@mantine/modals] useModals hook was called outside of context, wrap your app with ModalsProvider component");
    return ctx;
}


"use client";
//#region packages/@mantine/core/src/core/utils/is-number-like/is-number-like.ts
function $e5afc710a090ec45$export$bbf2f88383591790(value) {
    if (typeof value === "number") return true;
    if (typeof value === "string") {
        if (value.startsWith("calc(") || value.startsWith("var(") || value.includes(" ") && value.trim() !== "") return true;
        const cssUnitsRegex = /^[+-]?[0-9]+(\.[0-9]+)?(px|em|rem|ex|ch|lh|rlh|vw|vh|vmin|vmax|vb|vi|svw|svh|lvw|lvh|dvw|dvh|cm|mm|in|pt|pc|q|cqw|cqh|cqi|cqb|cqmin|cqmax|%)?$/;
        return value.trim().split(/\s+/).every((val)=>cssUnitsRegex.test(val));
    }
    return false;
}






"use client";
//#region packages/@mantine/core/src/core/utils/camel-to-kebab-case/camel-to-kebab-case.ts
function $8251449e4ce423eb$export$12e614f5e6e4ebe4(value) {
    return value.replace(/[A-Z]/g, (letter)=>`-${letter.toLowerCase()}`);
}


"use client";
//#region packages/@mantine/core/src/core/InlineStyles/css-object-to-string/css-object-to-string.ts
function $2a0efa82827a21b7$export$aa9768612bfaff7b(css) {
    return (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(css).reduce((acc, rule)=>css[rule] !== void 0 ? `${acc}${(0, $8251449e4ce423eb$export$12e614f5e6e4ebe4)(rule)}:${css[rule]};` : acc, "").trim();
}


"use client";
//#region packages/@mantine/core/src/core/InlineStyles/styles-to-string/styles-to-string.ts
function $eda5bb01d7647257$export$7790f45375f1d41({ selector: selector, styles: styles, media: media, container: container }) {
    const baseStyles = styles ? (0, $2a0efa82827a21b7$export$aa9768612bfaff7b)(styles) : "";
    const mediaQueryStyles = !Array.isArray(media) ? [] : media.map((item)=>`@media${item.query}{${selector}{${(0, $2a0efa82827a21b7$export$aa9768612bfaff7b)(item.styles)}}}`);
    const containerStyles = !Array.isArray(container) ? [] : container.map((item)=>`@container ${item.query}{${selector}{${(0, $2a0efa82827a21b7$export$aa9768612bfaff7b)(item.styles)}}}`);
    return `${baseStyles ? `${selector}{${baseStyles}}` : ""}${mediaQueryStyles.join("")}${containerStyles.join("")}`.trim();
}



"use client";
//#region packages/@mantine/core/src/core/InlineStyles/InlineStyles.tsx
function $e221d2b030e78e40$var$simpleHash(str) {
    let hash = 5381;
    for(let i = 0; i < str.length; i++)hash = (hash << 5) + hash + str.charCodeAt(i) & 4294967295;
    return (hash >>> 0).toString(36);
}
function $e221d2b030e78e40$export$6b8bda124c097cf0({ deduplicate: deduplicate, ...props }) {
    const nonce = (0, $bbb97275c373484a$export$ca3d89ae7d92a638)();
    const css = (0, $eda5bb01d7647257$export$7790f45375f1d41)(props);
    if (deduplicate) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("style", {
        href: `mantine-${$e221d2b030e78e40$var$simpleHash(css)}`,
        precedence: "mantine",
        nonce: nonce?.(),
        children: css
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("style", {
        "data-mantine-styles": "inline",
        nonce: nonce?.(),
        dangerouslySetInnerHTML: {
            __html: css
        }
    });
}



"use client";
//#region packages/@mantine/core/src/core/InlineStyles/hash-styles.ts
function $d0a84b59951c8281$var$djb2Hash(str) {
    let hash = 5381;
    for(let i = 0; i < str.length; i++)hash = (hash << 5) + hash + str.charCodeAt(i) & 4294967295;
    return (hash >>> 0).toString(36);
}
function $d0a84b59951c8281$export$76582071530e725d(styles, media) {
    return `__mdi__-${$d0a84b59951c8281$var$djb2Hash(`${styles ? (0, $2a0efa82827a21b7$export$aa9768612bfaff7b)(styles) : ""}|${Array.isArray(media) ? media.map((m)=>`${m.query}:${(0, $2a0efa82827a21b7$export$aa9768612bfaff7b)(m.styles)}`).join("|") : ""}`)}`;
}


"use client";
//#region packages/@mantine/core/src/core/utils/filter-props/filter-props.ts
function $3fdf1c4abf64babc$export$d697c39a2985a4c(props) {
    return Object.keys(props).reduce((acc, key)=>{
        if (props[key] !== void 0) acc[key] = props[key];
        return acc;
    }, {});
}


"use client";
//#region packages/@mantine/core/src/core/Box/style-props/extract-style-props/extract-style-props.ts
function $2e4262c949ef0e61$export$fbc67becbdd26fbf(others) {
    const { m: m, mx: mx, my: my, mt: mt, mb: mb, ml: ml, mr: mr, me: me, ms: ms, mis: mis, mie: mie, p: p, px: px, py: py, pt: pt, pb: pb, pl: pl, pr: pr, pe: pe, ps: ps, pis: pis, pie: pie, bd: bd, bdrs: bdrs, bg: bg, c: c, opacity: opacity, ff: ff, fz: fz, fw: fw, lts: lts, ta: ta, lh: lh, fs: fs, tt: tt, td: td, w: w, miw: miw, maw: maw, h: h, mih: mih, mah: mah, bgsz: bgsz, bgp: bgp, bgr: bgr, bga: bga, pos: pos, top: top, left: left, bottom: bottom, right: right, inset: inset, display: display, flex: flex, hiddenFrom: hiddenFrom, visibleFrom: visibleFrom, lightHidden: lightHidden, darkHidden: darkHidden, sx: sx, ...rest } = others;
    return {
        styleProps: (0, $3fdf1c4abf64babc$export$d697c39a2985a4c)({
            m: m,
            mx: mx,
            my: my,
            mt: mt,
            mb: mb,
            ml: ml,
            mr: mr,
            me: me,
            ms: ms,
            mis: mis,
            mie: mie,
            p: p,
            px: px,
            py: py,
            pt: pt,
            pb: pb,
            pl: pl,
            pr: pr,
            pis: pis,
            pie: pie,
            pe: pe,
            ps: ps,
            bd: bd,
            bg: bg,
            c: c,
            opacity: opacity,
            ff: ff,
            fz: fz,
            fw: fw,
            lts: lts,
            ta: ta,
            lh: lh,
            fs: fs,
            tt: tt,
            td: td,
            w: w,
            miw: miw,
            maw: maw,
            h: h,
            mih: mih,
            mah: mah,
            bgsz: bgsz,
            bgp: bgp,
            bgr: bgr,
            bga: bga,
            pos: pos,
            top: top,
            left: left,
            bottom: bottom,
            right: right,
            inset: inset,
            display: display,
            flex: flex,
            bdrs: bdrs,
            hiddenFrom: hiddenFrom,
            visibleFrom: visibleFrom,
            lightHidden: lightHidden,
            darkHidden: darkHidden,
            sx: sx
        }),
        rest: rest
    };
}


"use client";
//#region packages/@mantine/core/src/core/Box/style-props/style-props-data.ts
const $b59b7faf20a9d5d4$export$2716120594d536e8 = {
    m: {
        type: "spacing",
        property: "margin"
    },
    mt: {
        type: "spacing",
        property: "marginTop"
    },
    mb: {
        type: "spacing",
        property: "marginBottom"
    },
    ml: {
        type: "spacing",
        property: "marginLeft"
    },
    mr: {
        type: "spacing",
        property: "marginRight"
    },
    ms: {
        type: "spacing",
        property: "marginInlineStart"
    },
    me: {
        type: "spacing",
        property: "marginInlineEnd"
    },
    mis: {
        type: "spacing",
        property: "marginInlineStart"
    },
    mie: {
        type: "spacing",
        property: "marginInlineEnd"
    },
    mx: {
        type: "spacing",
        property: "marginInline"
    },
    my: {
        type: "spacing",
        property: "marginBlock"
    },
    p: {
        type: "spacing",
        property: "padding"
    },
    pt: {
        type: "spacing",
        property: "paddingTop"
    },
    pb: {
        type: "spacing",
        property: "paddingBottom"
    },
    pl: {
        type: "spacing",
        property: "paddingLeft"
    },
    pr: {
        type: "spacing",
        property: "paddingRight"
    },
    ps: {
        type: "spacing",
        property: "paddingInlineStart"
    },
    pe: {
        type: "spacing",
        property: "paddingInlineEnd"
    },
    pis: {
        type: "spacing",
        property: "paddingInlineStart"
    },
    pie: {
        type: "spacing",
        property: "paddingInlineEnd"
    },
    px: {
        type: "spacing",
        property: "paddingInline"
    },
    py: {
        type: "spacing",
        property: "paddingBlock"
    },
    bd: {
        type: "border",
        property: "border"
    },
    bdrs: {
        type: "radius",
        property: "borderRadius"
    },
    bg: {
        type: "color",
        property: "background"
    },
    c: {
        type: "textColor",
        property: "color"
    },
    opacity: {
        type: "identity",
        property: "opacity"
    },
    ff: {
        type: "fontFamily",
        property: "fontFamily"
    },
    fz: {
        type: "fontSize",
        property: "fontSize"
    },
    fw: {
        type: "identity",
        property: "fontWeight"
    },
    lts: {
        type: "size",
        property: "letterSpacing"
    },
    ta: {
        type: "identity",
        property: "textAlign"
    },
    lh: {
        type: "lineHeight",
        property: "lineHeight"
    },
    fs: {
        type: "identity",
        property: "fontStyle"
    },
    tt: {
        type: "identity",
        property: "textTransform"
    },
    td: {
        type: "identity",
        property: "textDecoration"
    },
    w: {
        type: "spacing",
        property: "width"
    },
    miw: {
        type: "spacing",
        property: "minWidth"
    },
    maw: {
        type: "spacing",
        property: "maxWidth"
    },
    h: {
        type: "spacing",
        property: "height"
    },
    mih: {
        type: "spacing",
        property: "minHeight"
    },
    mah: {
        type: "spacing",
        property: "maxHeight"
    },
    bgsz: {
        type: "size",
        property: "backgroundSize"
    },
    bgp: {
        type: "identity",
        property: "backgroundPosition"
    },
    bgr: {
        type: "identity",
        property: "backgroundRepeat"
    },
    bga: {
        type: "identity",
        property: "backgroundAttachment"
    },
    pos: {
        type: "identity",
        property: "position"
    },
    top: {
        type: "size",
        property: "top"
    },
    left: {
        type: "size",
        property: "left"
    },
    bottom: {
        type: "size",
        property: "bottom"
    },
    right: {
        type: "size",
        property: "right"
    },
    inset: {
        type: "size",
        property: "inset"
    },
    display: {
        type: "identity",
        property: "display"
    },
    flex: {
        type: "identity",
        property: "flex"
    }
};




"use client";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/color-resolver/color-resolver.ts
function $35bccfb500178ec5$export$4eae9cf015af18e5(color, theme) {
    const parsedColor = (0, $33a822173b5f4b0f$export$83e0a426d2da8ac1)({
        color: color,
        theme: theme
    });
    if (parsedColor.color === "dimmed") return "var(--mantine-color-dimmed)";
    if (parsedColor.color === "bright") return "var(--mantine-color-bright)";
    return parsedColor.variable ? `var(${parsedColor.variable})` : parsedColor.color;
}
function $35bccfb500178ec5$export$604e6d568fe1fa3e(color, theme) {
    const parsedColor = (0, $33a822173b5f4b0f$export$83e0a426d2da8ac1)({
        color: color,
        theme: theme
    });
    if (parsedColor.isThemeColor && parsedColor.shade === void 0) return `var(--mantine-color-${parsedColor.color}-text)`;
    return $35bccfb500178ec5$export$4eae9cf015af18e5(color, theme);
}




"use client";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/border-resolver/border-resolver.ts
function $cadb53a967bb95fe$export$b5e3bc515e648632(value, theme) {
    if (typeof value === "number") return (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(value);
    if (typeof value === "string") {
        const [size, style, ...colorTuple] = value.split(" ").filter((val)=>val.trim() !== "");
        let result = `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(size)}`;
        style && (result += ` ${style}`);
        colorTuple.length > 0 && (result += ` ${(0, $35bccfb500178ec5$export$4eae9cf015af18e5)(colorTuple.join(" "), theme)}`);
        return result.trim();
    }
    return value;
}


"use client";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/font-family-resolver/font-family-resolver.ts
const $5cb52101d888a8b3$var$values = {
    text: "var(--mantine-font-family)",
    mono: "var(--mantine-font-family-monospace)",
    monospace: "var(--mantine-font-family-monospace)",
    heading: "var(--mantine-font-family-headings)",
    headings: "var(--mantine-font-family-headings)"
};
function $5cb52101d888a8b3$export$a98e7ca632e77aba(fontFamily) {
    if (typeof fontFamily === "string" && fontFamily in $5cb52101d888a8b3$var$values) return $5cb52101d888a8b3$var$values[fontFamily];
    return fontFamily;
}



"use client";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/font-size-resolver/font-size-resolver.ts
const $be02c3e429f44fcc$var$headings = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
];
function $be02c3e429f44fcc$export$878e905dd08d927c(value, theme) {
    if (typeof value === "string" && value in theme.fontSizes) return `var(--mantine-font-size-${value})`;
    if (typeof value === "string" && $be02c3e429f44fcc$var$headings.includes(value)) return `var(--mantine-${value}-font-size)`;
    if (typeof value === "number") return (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(value);
    if (typeof value === "string") return (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(value);
    return value;
}


"use client";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/identity-resolver/identity-resolver.ts
function $c8c0c63f11a096c2$export$b5037849b1d1bf66(value) {
    return value;
}


"use client";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/line-height-resolver/line-height-resolver.ts
const $05bb07fad2d65ceb$var$headings = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
];
function $05bb07fad2d65ceb$export$850e3162a100106c(value, theme) {
    if (typeof value === "string" && value in theme.lineHeights) return `var(--mantine-line-height-${value})`;
    if (typeof value === "string" && $05bb07fad2d65ceb$var$headings.includes(value)) return `var(--mantine-${value}-line-height)`;
    return value;
}



"use client";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/radius-resolver/radius-resolver.ts
function $a0761d3b6cd828df$export$3f59bd94d99231df(value, theme) {
    if (typeof value === "string" && value in theme.radius) return `var(--mantine-radius-${value})`;
    if (typeof value === "number") return (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(value);
    if (typeof value === "string") return (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(value);
    return value;
}



"use client";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/size-resolver/size-resolver.ts
function $49a8ebb02bf8e3c8$export$523b15dd291e73b8(value) {
    if (typeof value === "number") return (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(value);
    return value;
}



"use client";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/spacing-resolver/spacing-resolver.ts
function $e65e36a42f72f660$export$923b9614c33e29ca(value, theme) {
    if (typeof value === "number") return (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(value);
    if (typeof value === "string") {
        const mod = value.replace("-", "");
        if (!(mod in theme.spacing)) return (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(value);
        const variable = `--mantine-spacing-${mod}`;
        return value.startsWith("-") ? `calc(var(${variable}) * -1)` : `var(${variable})`;
    }
    return value;
}


"use client";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/index.ts
const $9ba7ded20a33cd51$export$f62412552be5daf2 = {
    color: (0, $35bccfb500178ec5$export$4eae9cf015af18e5),
    textColor: (0, $35bccfb500178ec5$export$604e6d568fe1fa3e),
    fontSize: (0, $be02c3e429f44fcc$export$878e905dd08d927c),
    spacing: (0, $e65e36a42f72f660$export$923b9614c33e29ca),
    radius: (0, $a0761d3b6cd828df$export$3f59bd94d99231df),
    identity: (0, $c8c0c63f11a096c2$export$b5037849b1d1bf66),
    size: (0, $49a8ebb02bf8e3c8$export$523b15dd291e73b8),
    lineHeight: (0, $05bb07fad2d65ceb$export$850e3162a100106c),
    fontFamily: (0, $5cb52101d888a8b3$export$a98e7ca632e77aba),
    border: (0, $cadb53a967bb95fe$export$b5e3bc515e648632)
};


"use client";
//#region packages/@mantine/core/src/core/Box/style-props/parse-style-props/sort-media-queries.ts
function $c7cc304b6badeae9$var$replaceMediaQuery(query) {
    return query.replace("(min-width: ", "").replace("em)", "");
}
function $c7cc304b6badeae9$export$7b166a3227e41284({ media: media, ...props }) {
    const sortedMedia = Object.keys(media).sort((a, b)=>Number($c7cc304b6badeae9$var$replaceMediaQuery(a)) - Number($c7cc304b6badeae9$var$replaceMediaQuery(b))).map((query)=>({
            query: query,
            styles: media[query]
        }));
    return {
        ...props,
        media: sortedMedia
    };
}


"use client";
//#region packages/@mantine/core/src/core/Box/style-props/parse-style-props/parse-style-props.ts
function $06c0be1ba7c6b78f$var$hasResponsiveStyles(styleProp) {
    if (typeof styleProp !== "object" || styleProp === null) return false;
    const breakpoints = Object.keys(styleProp);
    if (breakpoints.length === 1 && breakpoints[0] === "base") return false;
    return true;
}
function $06c0be1ba7c6b78f$var$getBaseValue(value) {
    if (typeof value === "object" && value !== null) {
        if ("base" in value) return value.base;
        return;
    }
    return value;
}
function $06c0be1ba7c6b78f$var$getBreakpointKeys(value) {
    if (typeof value === "object" && value !== null) return (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(value).filter((key)=>key !== "base");
    return [];
}
function $06c0be1ba7c6b78f$var$getBreakpointValue(value, breakpoint) {
    if (typeof value === "object" && value !== null && breakpoint in value) return value[breakpoint];
    return value;
}
function $06c0be1ba7c6b78f$export$369a566827bae64e({ styleProps: styleProps, data: data, theme: theme }) {
    return (0, $c7cc304b6badeae9$export$7b166a3227e41284)((0, $76cd5f02de8ee394$export$ed97f33186d4b816)(styleProps).reduce((acc, styleProp)=>{
        if (styleProp === "hiddenFrom" || styleProp === "visibleFrom" || styleProp === "sx") return acc;
        const propertyData = data[styleProp];
        const properties = Array.isArray(propertyData.property) ? propertyData.property : [
            propertyData.property
        ];
        const baseValue = $06c0be1ba7c6b78f$var$getBaseValue(styleProps[styleProp]);
        if (!$06c0be1ba7c6b78f$var$hasResponsiveStyles(styleProps[styleProp])) {
            properties.forEach((property)=>{
                acc.inlineStyles[property] = (0, $9ba7ded20a33cd51$export$f62412552be5daf2)[propertyData.type](baseValue, theme);
            });
            return acc;
        }
        acc.hasResponsiveStyles = true;
        const breakpoints = $06c0be1ba7c6b78f$var$getBreakpointKeys(styleProps[styleProp]);
        properties.forEach((property)=>{
            if (baseValue != null) acc.styles[property] = (0, $9ba7ded20a33cd51$export$f62412552be5daf2)[propertyData.type](baseValue, theme);
            breakpoints.forEach((breakpoint)=>{
                const bp = `(min-width: ${theme.breakpoints[breakpoint]})`;
                acc.media[bp] = {
                    ...acc.media[bp],
                    [property]: (0, $9ba7ded20a33cd51$export$f62412552be5daf2)[propertyData.type]($06c0be1ba7c6b78f$var$getBreakpointValue(styleProps[styleProp], breakpoint), theme)
                };
            });
        });
        return acc;
    }, {
        hasResponsiveStyles: false,
        styles: {},
        inlineStyles: {},
        media: {}
    }));
}



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/core/Box/use-random-classname/use-random-classname.ts
function $6f7b5997f3c2d4f0$export$27120f2982e012b1() {
    return `__m__-${(0, $acw62.useId)().replace(/[:«»]/g, "")}`;
}


//#region packages/@mantine/core/src/core/factory/create-polymorphic-component.ts
function $1a5a3b9a879562b6$export$639b89ea563ec697(component) {
    return component;
}
const $1a5a3b9a879562b6$export$4d31b44c6b905728 = $1a5a3b9a879562b6$export$639b89ea563ec697;


"use client";
//#region packages/@mantine/core/src/core/Box/get-box-mod/get-box-mod.ts
function $723471e9004c98dc$var$transformModKey(key) {
    return `data-${(key.startsWith("data-") ? key.slice(5) : key).replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
}
function $723471e9004c98dc$var$getMod(props) {
    return Object.keys(props).reduce((acc, key)=>{
        const value = props[key];
        if (value === void 0 || value === "" || value === false || value === null) return acc;
        acc[$723471e9004c98dc$var$transformModKey(key)] = props[key];
        return acc;
    }, {});
}
function $723471e9004c98dc$export$3ac4144d30a9eee0(mod) {
    if (!mod) return null;
    if (typeof mod === "string") return {
        [$723471e9004c98dc$var$transformModKey(mod)]: true
    };
    if (Array.isArray(mod)) return [
        ...mod
    ].reduce((acc, value)=>({
            ...acc,
            ...$723471e9004c98dc$export$3ac4144d30a9eee0(value)
        }), {});
    return $723471e9004c98dc$var$getMod(mod);
}


"use client";
//#region packages/@mantine/core/src/core/Box/get-box-style/get-box-style.ts
function $7b2d4b12475827bc$var$mergeStyles(styles, theme) {
    if (Array.isArray(styles)) return [
        ...styles
    ].reduce((acc, item)=>({
            ...acc,
            ...$7b2d4b12475827bc$var$mergeStyles(item, theme)
        }), {});
    if (typeof styles === "function") return styles(theme);
    if (styles == null) return {};
    return styles;
}
function $7b2d4b12475827bc$export$19e246842511d5b({ theme: theme, style: style, vars: vars, styleProps: styleProps }) {
    const _style = $7b2d4b12475827bc$var$mergeStyles(style, theme);
    const _vars = $7b2d4b12475827bc$var$mergeStyles(vars, theme);
    return {
        ..._style,
        ..._vars,
        ...styleProps
    };
}


function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;



"use client";
//#region packages/@mantine/core/src/core/Box/Box.tsx
function $8978bf78d2f2c844$var$_Box({ component: component, style: style, __vars: __vars, className: className, variant: variant, mod: mod, size: size, hiddenFrom: hiddenFrom, visibleFrom: visibleFrom, lightHidden: lightHidden, darkHidden: darkHidden, renderRoot: renderRoot, __size: __size, ref: ref, ...others }) {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const Element = component || "div";
    const { styleProps: styleProps, rest: rest } = (0, $2e4262c949ef0e61$export$fbc67becbdd26fbf)(others);
    const transformedSx = (0, $bbb97275c373484a$export$90b3f271845c7f71)()?.()?.(styleProps.sx);
    const randomClassName = (0, $6f7b5997f3c2d4f0$export$27120f2982e012b1)();
    const parsedStyleProps = (0, $06c0be1ba7c6b78f$export$369a566827bae64e)({
        styleProps: styleProps,
        theme: theme,
        data: (0, $b59b7faf20a9d5d4$export$2716120594d536e8)
    });
    const deduplicateInlineStyles = (0, $bbb97275c373484a$export$1c2d544eb56b2eae)();
    const responsiveClassName = deduplicateInlineStyles && parsedStyleProps.hasResponsiveStyles ? (0, $d0a84b59951c8281$export$76582071530e725d)(parsedStyleProps.styles, parsedStyleProps.media) : randomClassName;
    const props = {
        ref: ref,
        style: (0, $7b2d4b12475827bc$export$19e246842511d5b)({
            theme: theme,
            style: style,
            vars: __vars,
            styleProps: parsedStyleProps.inlineStyles
        }),
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(className, transformedSx, {
            [responsiveClassName]: parsedStyleProps.hasResponsiveStyles,
            "mantine-light-hidden": lightHidden,
            "mantine-dark-hidden": darkHidden,
            [`mantine-hidden-from-${hiddenFrom}`]: hiddenFrom,
            [`mantine-visible-from-${visibleFrom}`]: visibleFrom
        }),
        "data-variant": variant,
        "data-size": (0, $e5afc710a090ec45$export$bbf2f88383591790)(size) ? void 0 : size || void 0,
        size: __size,
        ...(0, $723471e9004c98dc$export$3ac4144d30a9eee0)(mod),
        ...rest
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e221d2b030e78e40$export$6b8bda124c097cf0), {
                selector: `.${responsiveClassName}`,
                styles: parsedStyleProps.styles,
                media: parsedStyleProps.media,
                deduplicate: deduplicateInlineStyles
            }),
            typeof renderRoot === "function" ? renderRoot(props) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Element, {
                ...props
            })
        ]
    });
}
$8978bf78d2f2c844$var$_Box.displayName = "@mantine/core/Box";
const $8978bf78d2f2c844$export$e71c4d32a2263218 = (0, $1a5a3b9a879562b6$export$4d31b44c6b905728)($8978bf78d2f2c844$var$_Box);




"use client";
//#region packages/@mantine/core/src/core/utils/get-size/get-size.ts
function $fcab4af601ce7e99$export$31b21d0167753bb4(size, prefix = "size", convertToRem = true) {
    if (size === void 0) return;
    return (0, $e5afc710a090ec45$export$bbf2f88383591790)(size) ? convertToRem ? (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(size) : size : `var(--${prefix}-${size})`;
}
function $fcab4af601ce7e99$export$f63796f8a9382bfb(size) {
    return $fcab4af601ce7e99$export$31b21d0167753bb4(size, "mantine-spacing");
}
function $fcab4af601ce7e99$export$35724d9c2979edc5(size) {
    if (size === void 0) return "var(--mantine-radius-default)";
    return $fcab4af601ce7e99$export$31b21d0167753bb4(size, "mantine-radius");
}
function $fcab4af601ce7e99$export$7d055c252aebca58(size) {
    return $fcab4af601ce7e99$export$31b21d0167753bb4(size, "mantine-font-size");
}
function $fcab4af601ce7e99$export$56204a27a2958a55(size) {
    return $fcab4af601ce7e99$export$31b21d0167753bb4(size, "mantine-line-height", false);
}
function $fcab4af601ce7e99$export$db93b77dbb14f011(size) {
    if (!size) return;
    return $fcab4af601ce7e99$export$31b21d0167753bb4(size, "mantine-shadow", false);
}


"use client";
//#region packages/@mantine/core/src/core/styles-api/create-vars-resolver/create-vars-resolver.ts
function $aa82169640332897$export$b64e283f076215ce(resolver) {
    return resolver;
}




"use client";
//#region packages/@mantine/core/src/core/MantineProvider/use-props/use-props.ts
function $4fa4869d2d954dac$export$1f264be2c424fccf(component, defaultProps, props) {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const names = (Array.isArray(component) ? component : [
        component
    ]).filter(Boolean);
    let contextProps = {};
    for (const name of names){
        const payload = theme.components[name]?.defaultProps;
        const resolved = typeof payload === "function" ? payload(theme) : payload;
        if (resolved) contextProps = {
            ...contextProps,
            ...resolved
        };
    }
    return {
        ...defaultProps,
        ...contextProps,
        ...(0, $3fdf1c4abf64babc$export$d697c39a2985a4c)(props)
    };
}



"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/resolve-class-names/resolve-class-names.ts
const $ba12a721d32e28d3$var$EMPTY_CLASS_NAMES = {};
function $ba12a721d32e28d3$var$mergeClassNames(objects) {
    const merged = {};
    objects.forEach((obj)=>{
        Object.entries(obj).forEach(([key, value])=>{
            if (merged[key]) merged[key] = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(merged[key], value);
            else merged[key] = value;
        });
    });
    return merged;
}
function $ba12a721d32e28d3$export$7df0003ea9a4d3a4({ theme: theme, classNames: classNames, props: props, stylesCtx: stylesCtx }) {
    return $ba12a721d32e28d3$var$mergeClassNames((Array.isArray(classNames) ? classNames : [
        classNames
    ]).map((item)=>typeof item === "function" ? item(theme, props, stylesCtx) : item || $ba12a721d32e28d3$var$EMPTY_CLASS_NAMES));
}


"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-style/resolve-styles/resolve-styles.ts
function $d9501d38e7649221$export$5376e124e9154c53({ theme: theme, styles: styles, props: props, stylesCtx: stylesCtx }) {
    const arrayStyles = Array.isArray(styles) ? styles : [
        styles
    ];
    const result = {};
    for (const style of arrayStyles)if (typeof style === "function") Object.assign(result, style(theme, props, stylesCtx));
    else if (style) Object.assign(result, style);
    return result;
}





"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-global-class-names/get-global-class-names.ts
const $3ca60559339b6e87$export$a04011e0788b5983 = {
    always: "mantine-focus-always",
    auto: "mantine-focus-auto",
    never: "mantine-focus-never"
};
/** Returns classes that are defined globally (focus and active styles) based on options */ function $3ca60559339b6e87$export$e14385d8f1853921({ theme: theme, options: options, unstyled: unstyled }) {
    return (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(options?.focusable && !unstyled && (theme.focusClassName || $3ca60559339b6e87$export$a04011e0788b5983[theme.focusRing]), options?.active && !unstyled && theme.activeClassName);
}



"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-options-class-names/get-options-class-names.ts
function $bc1fc9c10c57d64d$export$7a7a11f4686fc73({ selector: selector, stylesCtx: stylesCtx, options: options, props: props, theme: theme }) {
    return (0, $ba12a721d32e28d3$export$7df0003ea9a4d3a4)({
        theme: theme,
        classNames: options?.classNames,
        props: options?.props || props,
        stylesCtx: stylesCtx
    })[selector];
}



"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-resolved-class-names/get-resolved-class-names.ts
function $c68d38cde857116f$export$c8ee29f5e6126f29({ selector: selector, stylesCtx: stylesCtx, theme: theme, classNames: classNames, props: props }) {
    return (0, $ba12a721d32e28d3$export$7df0003ea9a4d3a4)({
        theme: theme,
        classNames: classNames,
        props: props,
        stylesCtx: stylesCtx
    })[selector];
}


"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-root-class-name/get-root-class-name.ts
/** Adds `className` to the list if given selector is root */ function $d45d65829f01fd32$export$ed68779644c0480d({ rootSelector: rootSelector, selector: selector, className: className }) {
    return rootSelector === selector ? className : void 0;
}


"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-selector-class-name/get-selector-class-name.ts
/** Returns class for given selector from library styles (`*.module.css`) */ function $d883915b9d10d1e9$export$b7a73d31db4300dd({ selector: selector, classes: classes, unstyled: unstyled }) {
    return unstyled ? void 0 : classes[selector];
}


"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-static-class-names/get-static-class-names.ts
/** Returns static component classes, for example, `.mantine-Input-wrapper` */ function $3e4744740ea17450$export$8e7d06930ec89569({ themeName: themeName, classNamesPrefix: classNamesPrefix, selector: selector, withStaticClass: withStaticClass }) {
    if (withStaticClass === false) return [];
    return themeName.map((n)=>`${classNamesPrefix}-${n}-${selector}`);
}


"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-variant-class-name/get-variant-class-name.ts
/** Returns variant className, variant is always separated from selector with `--`, for example, `tab--default` */ function $c045c3b67c26f6b9$export$298d4a593fcafeff({ options: options, classes: classes, selector: selector, unstyled: unstyled }) {
    return options?.variant && !unstyled ? classes[`${selector}--${options.variant}`] : void 0;
}



"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-class-name.ts
function $8adf988400b74449$export$307b18b61172f7ed({ theme: theme, options: options, themeName: themeName, selector: selector, classNamesPrefix: classNamesPrefix, resolvedClassNames: resolvedClassNames, resolvedThemeClassNames: resolvedThemeClassNames, classes: classes, unstyled: unstyled, className: className, rootSelector: rootSelector, props: props, stylesCtx: stylesCtx, withStaticClasses: withStaticClasses, headless: headless, transformedStyles: transformedStyles }) {
    return (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $3ca60559339b6e87$export$e14385d8f1853921)({
        theme: theme,
        options: options,
        unstyled: unstyled || headless
    }), resolvedThemeClassNames.map((m)=>m[selector]), (0, $c045c3b67c26f6b9$export$298d4a593fcafeff)({
        options: options,
        classes: classes,
        selector: selector,
        unstyled: unstyled || headless
    }), resolvedClassNames[selector], (0, $c68d38cde857116f$export$c8ee29f5e6126f29)({
        selector: selector,
        stylesCtx: stylesCtx,
        theme: theme,
        classNames: transformedStyles,
        props: props
    }), (0, $bc1fc9c10c57d64d$export$7a7a11f4686fc73)({
        selector: selector,
        stylesCtx: stylesCtx,
        options: options,
        props: props,
        theme: theme
    }), (0, $d45d65829f01fd32$export$ed68779644c0480d)({
        rootSelector: rootSelector,
        selector: selector,
        className: className
    }), (0, $d883915b9d10d1e9$export$b7a73d31db4300dd)({
        selector: selector,
        classes: classes,
        unstyled: unstyled || headless
    }), withStaticClasses && !headless && (0, $3e4744740ea17450$export$8e7d06930ec89569)({
        themeName: themeName,
        classNamesPrefix: classNamesPrefix,
        selector: selector,
        withStaticClass: options?.withStaticClass
    }), options?.className);
}


"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-style/resolve-style/resolve-style.ts
function $6a3ebd58250268aa$export$d2850a44b8d56931({ style: style, theme: theme }) {
    if (Array.isArray(style)) return style.reduce((acc, item)=>({
            ...acc,
            ...$6a3ebd58250268aa$export$d2850a44b8d56931({
                style: item,
                theme: theme
            })
        }), {});
    if (typeof style === "function") return style(theme);
    if (style == null) return {};
    return style;
}




"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-style/get-style.ts
function $b81ffff4e2011c98$export$3d2f074408bd1b82({ theme: theme, selector: selector, options: options, props: props, stylesCtx: stylesCtx, rootSelector: rootSelector, withStylesTransform: withStylesTransform, resolvedStyles: resolvedStyles, resolvedThemeStyles: resolvedThemeStyles, resolvedVars: resolvedVars, resolvedRootStyle: resolvedRootStyle }) {
    return {
        ...resolvedThemeStyles[selector],
        ...resolvedStyles[selector],
        ...!withStylesTransform && (0, $d9501d38e7649221$export$5376e124e9154c53)({
            theme: theme,
            styles: options?.styles,
            props: options?.props || props,
            stylesCtx: stylesCtx
        })[selector],
        ...resolvedVars[selector],
        ...rootSelector === selector ? resolvedRootStyle : null,
        ...(0, $6a3ebd58250268aa$export$d2850a44b8d56931)({
            style: options?.style,
            theme: theme
        })
    };
}



"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-style/resolve-vars/merge-vars.ts
function $1e6d95f5c77cc341$export$55b7902d9d3bf524(vars) {
    return vars.reduce((acc, current)=>{
        if (current) Object.keys(current).forEach((key)=>{
            acc[key] = {
                ...acc[key],
                ...(0, $3fdf1c4abf64babc$export$d697c39a2985a4c)(current[key])
            };
        });
        return acc;
    }, {});
}



"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/use-transformed-styles.ts
function $4fe849970912f76d$export$29ea41dbfb82adb7({ props: props, stylesCtx: stylesCtx, themeName: themeName, theme: theme }) {
    const stylesTransform = (0, $bbb97275c373484a$export$a6d64564e25afc49)()?.();
    const getTransformedStyles = (styles)=>{
        if (!stylesTransform) return [];
        return [
            ...styles.map((style)=>stylesTransform(style, {
                    props: props,
                    theme: theme,
                    ctx: stylesCtx
                })),
            ...themeName.map((n)=>stylesTransform(theme.components[n]?.styles, {
                    props: props,
                    theme: theme,
                    ctx: stylesCtx
                }))
        ].filter(Boolean);
    };
    return {
        getTransformedStyles: getTransformedStyles,
        withStylesTransform: !!stylesTransform
    };
}


"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/use-styles.ts
function $4689b421f37b1ee0$export$28e6b9b82ee883c({ name: name, classes: classes, props: props, stylesCtx: stylesCtx, className: className, style: style, rootSelector: rootSelector = "root", unstyled: unstyled, classNames: classNames, styles: styles, vars: vars, varsResolver: varsResolver, attributes: attributes }) {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const classNamesPrefix = (0, $bbb97275c373484a$export$635322ad820b722f)();
    const withStaticClasses = (0, $bbb97275c373484a$export$9f9af79c864a043d)();
    const headless = (0, $bbb97275c373484a$export$dd8473d25cec2fe9)();
    const themeName = (Array.isArray(name) ? name : [
        name
    ]).filter((n)=>n);
    const { withStylesTransform: withStylesTransform, getTransformedStyles: getTransformedStyles } = (0, $4fe849970912f76d$export$29ea41dbfb82adb7)({
        props: props,
        stylesCtx: stylesCtx,
        themeName: themeName,
        theme: theme
    });
    const resolvedClassNames = (0, $ba12a721d32e28d3$export$7df0003ea9a4d3a4)({
        theme: theme,
        classNames: classNames,
        props: props,
        stylesCtx: stylesCtx
    });
    const resolvedThemeClassNames = themeName.map((n)=>(0, $ba12a721d32e28d3$export$7df0003ea9a4d3a4)({
            theme: theme,
            classNames: theme.components[n]?.classNames,
            props: props,
            stylesCtx: stylesCtx
        }));
    const resolvedComponentStyles = withStylesTransform ? {} : (0, $d9501d38e7649221$export$5376e124e9154c53)({
        theme: theme,
        styles: styles,
        props: props,
        stylesCtx: stylesCtx
    });
    const resolvedThemeStyles = {};
    if (!withStylesTransform) for (const n of themeName){
        const resolved = (0, $d9501d38e7649221$export$5376e124e9154c53)({
            theme: theme,
            styles: theme.components[n]?.styles,
            props: props,
            stylesCtx: stylesCtx
        });
        for (const key of Object.keys(resolved))resolvedThemeStyles[key] = {
            ...resolvedThemeStyles[key],
            ...resolved[key]
        };
    }
    const resolvedVars = (0, $1e6d95f5c77cc341$export$55b7902d9d3bf524)([
        headless ? {} : varsResolver?.(theme, props, stylesCtx),
        ...themeName.map((n)=>theme.components?.[n]?.vars?.(theme, props, stylesCtx)),
        vars?.(theme, props, stylesCtx)
    ]);
    const resolvedRootStyle = (0, $6a3ebd58250268aa$export$d2850a44b8d56931)({
        style: style,
        theme: theme
    });
    return (selector, options)=>({
            ...attributes?.[selector],
            className: (0, $8adf988400b74449$export$307b18b61172f7ed)({
                theme: theme,
                options: options,
                themeName: themeName,
                selector: selector,
                classNamesPrefix: classNamesPrefix,
                resolvedClassNames: resolvedClassNames,
                resolvedThemeClassNames: resolvedThemeClassNames,
                classes: classes,
                unstyled: unstyled,
                className: className,
                rootSelector: rootSelector,
                props: props,
                stylesCtx: stylesCtx,
                withStaticClasses: withStaticClasses,
                headless: headless,
                transformedStyles: getTransformedStyles([
                    options?.styles,
                    styles
                ])
            }),
            style: (0, $b81ffff4e2011c98$export$3d2f074408bd1b82)({
                theme: theme,
                selector: selector,
                options: options,
                props: props,
                stylesCtx: stylesCtx,
                rootSelector: rootSelector,
                withStylesTransform: withStylesTransform,
                resolvedStyles: resolvedComponentStyles,
                resolvedThemeStyles: resolvedThemeStyles,
                resolvedVars: resolvedVars,
                resolvedRootStyle: resolvedRootStyle
            })
        });
}



"use client";
//#region packages/@mantine/core/src/core/factory/factory.tsx
function $f1a4862560c68aef$export$f0954fd7d5368655(value) {
    return value;
}
function $f1a4862560c68aef$export$e9008f2713103c6c(ui) {
    const Component = ui;
    Component.extend = $f1a4862560c68aef$export$f0954fd7d5368655;
    Component.withProps = (fixedProps)=>{
        const Extended = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...fixedProps,
                ...props
            });
        Extended.extend = Component.extend;
        Extended.displayName = `WithProps(${Component.displayName})`;
        return Extended;
    };
    return Component;
}
function $f1a4862560c68aef$export$3f239de2ecfaebe3(ui) {
    return $f1a4862560c68aef$export$e9008f2713103c6c(ui);
}



"use client";
//#region packages/@mantine/core/src/core/factory/polymorphic-factory.tsx
function $dfead8eb7283bc39$export$197bdd704df40a29(ui) {
    const Component = ui;
    Component.withProps = (fixedProps)=>{
        const Extended = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...fixedProps,
                ...props
            });
        Extended.extend = Component.extend;
        Extended.displayName = `WithProps(${Component.displayName})`;
        return Extended;
    };
    Component.extend = (0, $f1a4862560c68aef$export$f0954fd7d5368655);
    return Component;
}







"use client";
//#region packages/@mantine/core/src/components/UnstyledButton/UnstyledButton.module.css
var $7e97a5f4ed4ff539$export$2e2bcd8739ae039 = {
    "root": "m_87cf2631"
};



"use client";
//#region packages/@mantine/core/src/components/UnstyledButton/UnstyledButton.tsx
const $b9babe59f8fa61e8$var$defaultProps = {
    __staticSelector: "UnstyledButton"
};
const $b9babe59f8fa61e8$export$3167f6ecaaaa3457 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("UnstyledButton", $b9babe59f8fa61e8$var$defaultProps, _props);
    const { className: className, component: component = "button", __staticSelector: __staticSelector, unstyled: unstyled, classNames: classNames, styles: styles, style: style, attributes: attributes, ...others } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...(0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
            name: __staticSelector,
            props: props,
            classes: (0, $7e97a5f4ed4ff539$export$2e2bcd8739ae039),
            className: className,
            style: style,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            attributes: attributes
        })("root", {
            focusable: true
        }),
        component: component,
        type: component === "button" ? "button" : void 0,
        ...others
    });
});
$b9babe59f8fa61e8$export$3167f6ecaaaa3457.classes = (0, $7e97a5f4ed4ff539$export$2e2bcd8739ae039);
$b9babe59f8fa61e8$export$3167f6ecaaaa3457.displayName = "@mantine/core/UnstyledButton";



"use client";
//#region packages/@mantine/core/src/components/Transition/transitions.ts
const $ff2b36baf316e392$var$popIn = (from)=>({
        in: {
            opacity: 1,
            transform: "scale(1)"
        },
        out: {
            opacity: 0,
            transform: `scale(.9) translateY(${from === "bottom" ? 10 : -10}px)`
        },
        transitionProperty: "transform, opacity"
    });
const $ff2b36baf316e392$export$622eca585e740ed5 = {
    fade: {
        in: {
            opacity: 1
        },
        out: {
            opacity: 0
        },
        transitionProperty: "opacity"
    },
    "fade-up": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(30px)"
        },
        transitionProperty: "opacity, transform"
    },
    "fade-down": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(-30px)"
        },
        transitionProperty: "opacity, transform"
    },
    "fade-left": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(30px)"
        },
        transitionProperty: "opacity, transform"
    },
    "fade-right": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(-30px)"
        },
        transitionProperty: "opacity, transform"
    },
    scale: {
        in: {
            opacity: 1,
            transform: "scale(1)"
        },
        out: {
            opacity: 0,
            transform: "scale(0)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "scale-y": {
        in: {
            opacity: 1,
            transform: "scaleY(1)"
        },
        out: {
            opacity: 0,
            transform: "scaleY(0)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "scale-x": {
        in: {
            opacity: 1,
            transform: "scaleX(1)"
        },
        out: {
            opacity: 0,
            transform: "scaleX(0)"
        },
        common: {
            transformOrigin: "left"
        },
        transitionProperty: "transform, opacity"
    },
    "skew-up": {
        in: {
            opacity: 1,
            transform: "translateY(0) skew(0deg, 0deg)"
        },
        out: {
            opacity: 0,
            transform: "translateY(-20px) skew(-10deg, -5deg)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "skew-down": {
        in: {
            opacity: 1,
            transform: "translateY(0) skew(0deg, 0deg)"
        },
        out: {
            opacity: 0,
            transform: "translateY(20px) skew(-10deg, -5deg)"
        },
        common: {
            transformOrigin: "bottom"
        },
        transitionProperty: "transform, opacity"
    },
    "rotate-left": {
        in: {
            opacity: 1,
            transform: "translateY(0) rotate(0deg)"
        },
        out: {
            opacity: 0,
            transform: "translateY(20px) rotate(-5deg)"
        },
        common: {
            transformOrigin: "bottom"
        },
        transitionProperty: "transform, opacity"
    },
    "rotate-right": {
        in: {
            opacity: 1,
            transform: "translateY(0) rotate(0deg)"
        },
        out: {
            opacity: 0,
            transform: "translateY(20px) rotate(5deg)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-down": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(-100%)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-up": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(100%)"
        },
        common: {
            transformOrigin: "bottom"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-left": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(100%)"
        },
        common: {
            transformOrigin: "left"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-right": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(-100%)"
        },
        common: {
            transformOrigin: "right"
        },
        transitionProperty: "transform, opacity"
    },
    pop: {
        ...$ff2b36baf316e392$var$popIn("bottom"),
        common: {
            transformOrigin: "center center"
        }
    },
    "pop-bottom-left": {
        ...$ff2b36baf316e392$var$popIn("bottom"),
        common: {
            transformOrigin: "bottom left"
        }
    },
    "pop-bottom-right": {
        ...$ff2b36baf316e392$var$popIn("bottom"),
        common: {
            transformOrigin: "bottom right"
        }
    },
    "pop-top-left": {
        ...$ff2b36baf316e392$var$popIn("top"),
        common: {
            transformOrigin: "top left"
        }
    },
    "pop-top-right": {
        ...$ff2b36baf316e392$var$popIn("top"),
        common: {
            transformOrigin: "top right"
        }
    }
};


"use client";
//#region packages/@mantine/core/src/components/Transition/get-transition-styles/get-transition-styles.ts
const $ca5c1f0106cf02fa$var$transitionStatuses = {
    entering: "in",
    entered: "in",
    exiting: "out",
    exited: "out",
    "pre-exiting": "out",
    "pre-entering": "out"
};
function $ca5c1f0106cf02fa$export$cfbcd9a4c0ed32ac({ transition: transition, state: state, duration: duration, timingFunction: timingFunction }) {
    const shared = {
        WebkitBackfaceVisibility: "hidden",
        transitionDuration: `${duration}ms`,
        transitionTimingFunction: timingFunction
    };
    if (typeof transition === "string") {
        if (!(transition in (0, $ff2b36baf316e392$export$622eca585e740ed5))) return {};
        return {
            transitionProperty: (0, $ff2b36baf316e392$export$622eca585e740ed5)[transition].transitionProperty,
            ...shared,
            ...(0, $ff2b36baf316e392$export$622eca585e740ed5)[transition].common,
            ...(0, $ff2b36baf316e392$export$622eca585e740ed5)[transition][$ca5c1f0106cf02fa$var$transitionStatuses[state]]
        };
    }
    return {
        transitionProperty: transition.transitionProperty,
        ...shared,
        ...transition.common,
        ...transition[$ca5c1f0106cf02fa$var$transitionStatuses[state]]
    };
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-did-update/use-did-update.ts
function $d9273517323905a9$export$e34ed88fef4dc107(fn, dependencies) {
    const mounted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>()=>{
            mounted.current = false;
        }, []);
    (0, $acw62.useEffect)(()=>{
        if (mounted.current) return fn();
        mounted.current = true;
    }, dependencies);
}


var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-media-query/use-media-query.ts
function $3e336cc32962af14$var$getInitialValue(query, initialValue) {
    if (typeof initialValue === "boolean") return initialValue;
    if (typeof window !== "undefined" && "matchMedia" in window) return window.matchMedia(query).matches;
    return false;
}
function $3e336cc32962af14$export$32d5543ab307c01(query, initialValue, { getInitialValueInEffect: getInitialValueInEffect } = {
    getInitialValueInEffect: true
}) {
    const [matches, setMatches] = (0, $acw62.useState)(getInitialValueInEffect ? initialValue : $3e336cc32962af14$var$getInitialValue(query));
    (0, $acw62.useEffect)(()=>{
        try {
            if ("matchMedia" in window) {
                const mediaQuery = window.matchMedia(query);
                setMatches(mediaQuery.matches);
                const callback = (event)=>setMatches(event.matches);
                mediaQuery.addEventListener("change", callback);
                return ()=>{
                    mediaQuery.removeEventListener("change", callback);
                };
            }
        } catch (e) {
            return;
        }
    }, [
        query
    ]);
    return matches || false;
}


"use client";
//#region packages/@mantine/hooks/src/use-reduced-motion/use-reduced-motion.ts
function $91a4302ee7795ed2$export$6a42007cf1e7b6f8(initialValue, options) {
    return (0, $3e336cc32962af14$export$32d5543ab307c01)("(prefers-reduced-motion: reduce)", initialValue, options);
}



var $1u0KT = parcelRequire("1u0KT");
"use client";
//#region packages/@mantine/core/src/components/Transition/use-transition.ts
function $c142579a0c1a5140$export$7b286972b8d8ccbf({ duration: duration, exitDuration: exitDuration, timingFunction: timingFunction, mounted: mounted, onEnter: onEnter, onExit: onExit, onEntered: onEntered, onExited: onExited, enterDelay: enterDelay, exitDelay: exitDelay }) {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const shouldReduceMotion = (0, $91a4302ee7795ed2$export$6a42007cf1e7b6f8)();
    const reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
    const [transitionDuration, setTransitionDuration] = (0, $acw62.useState)(reduceMotion ? 0 : duration);
    const [transitionStatus, setStatus] = (0, $acw62.useState)(mounted ? "entered" : "exited");
    const transitionTimeoutRef = (0, $acw62.useRef)(-1);
    const delayTimeoutRef = (0, $acw62.useRef)(-1);
    const rafRef = (0, $acw62.useRef)(-1);
    function clearAllTimeouts() {
        window.clearTimeout(transitionTimeoutRef.current);
        window.clearTimeout(delayTimeoutRef.current);
        cancelAnimationFrame(rafRef.current);
    }
    const handleStateChange = (shouldMount)=>{
        clearAllTimeouts();
        const preHandler = shouldMount ? onEnter : onExit;
        const handler = shouldMount ? onEntered : onExited;
        const newTransitionDuration = reduceMotion ? 0 : shouldMount ? duration : exitDuration;
        setTransitionDuration(newTransitionDuration);
        if (newTransitionDuration === 0) {
            typeof preHandler === "function" && preHandler();
            typeof handler === "function" && handler();
            setStatus(shouldMount ? "entered" : "exited");
        } else rafRef.current = requestAnimationFrame(()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).flushSync(()=>{
                setStatus(shouldMount ? "pre-entering" : "pre-exiting");
            });
            rafRef.current = requestAnimationFrame(()=>{
                typeof preHandler === "function" && preHandler();
                setStatus(shouldMount ? "entering" : "exiting");
                transitionTimeoutRef.current = window.setTimeout(()=>{
                    typeof handler === "function" && handler();
                    setStatus(shouldMount ? "entered" : "exited");
                }, newTransitionDuration);
            });
        });
    };
    const handleTransitionWithDelay = (shouldMount)=>{
        clearAllTimeouts();
        if (typeof (shouldMount ? enterDelay : exitDelay) !== "number") {
            handleStateChange(shouldMount);
            return;
        }
        delayTimeoutRef.current = window.setTimeout(()=>{
            handleStateChange(shouldMount);
        }, shouldMount ? enterDelay : exitDelay);
    };
    (0, $d9273517323905a9$export$e34ed88fef4dc107)(()=>{
        handleTransitionWithDelay(mounted);
    }, [
        mounted
    ]);
    (0, $acw62.useEffect)(()=>()=>{
            clearAllTimeouts();
        }, []);
    return {
        transitionDuration: transitionDuration,
        transitionStatus: transitionStatus,
        transitionTimingFunction: timingFunction || "ease"
    };
}



var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/Transition/Transition.tsx
function $4e0d3c4af0891b98$export$be58926105124dd4({ keepMounted: keepMounted, keepMountedMode: keepMountedMode = "activity", transition: transition = "fade", duration: duration = 250, exitDuration: exitDuration = duration, mounted: mounted, children: children, timingFunction: timingFunction = "ease", onExit: onExit, onEntered: onEntered, onEnter: onEnter, onExited: onExited, enterDelay: enterDelay, exitDelay: exitDelay }) {
    const env = (0, $bbb97275c373484a$export$2a0cf0a5fd0c6e81)();
    const { transitionDuration: transitionDuration, transitionStatus: transitionStatus, transitionTimingFunction: transitionTimingFunction } = (0, $c142579a0c1a5140$export$7b286972b8d8ccbf)({
        mounted: mounted,
        exitDuration: exitDuration,
        duration: duration,
        timingFunction: timingFunction,
        onExit: onExit,
        onEntered: onEntered,
        onEnter: onEnter,
        onExited: onExited,
        enterDelay: enterDelay,
        exitDelay: exitDelay
    });
    if (env === "test") return mounted ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children({})
    }) : keepMounted ? children({
        display: "none"
    }) : null;
    if (transitionDuration === 0) {
        if (keepMounted) {
            if (keepMountedMode === "display-none") return mounted ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: children({})
            }) : children({
                display: "none"
            });
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Activity), {
                mode: mounted ? "visible" : "hidden",
                children: children({})
            });
        }
        return mounted ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: children({})
        }) : null;
    }
    const isExited = transitionStatus === "exited";
    if (keepMounted) {
        const keepMountedChildren = children(isExited ? keepMountedMode === "display-none" ? {
            display: "none"
        } : {} : (0, $ca5c1f0106cf02fa$export$cfbcd9a4c0ed32ac)({
            transition: transition,
            duration: transitionDuration,
            state: transitionStatus,
            timingFunction: transitionTimingFunction
        }));
        if (keepMountedMode === "display-none") return keepMountedChildren;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Activity), {
            mode: isExited ? "hidden" : "visible",
            children: keepMountedChildren
        });
    }
    return isExited ? null : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children((0, $ca5c1f0106cf02fa$export$cfbcd9a4c0ed32ac)({
            transition: transition,
            duration: transitionDuration,
            state: transitionStatus,
            timingFunction: transitionTimingFunction
        }))
    });
}
$4e0d3c4af0891b98$export$be58926105124dd4.displayName = "@mantine/core/Transition";









"use client";
//#region packages/@mantine/core/src/components/Loader/Loader.module.css
var $b90e9c0269727d12$export$2e2bcd8739ae039 = {
    "root": "m_5ae2e3c",
    "barsLoader": "m_7a2bd4cd",
    "bar": "m_870bb79",
    "bars-loader-animation": "m_5d2b3b9d",
    "dotsLoader": "m_4e3f22d7",
    "dot": "m_870c4af",
    "loader-dots-animation": "m_aac34a1",
    "ovalLoader": "m_b34414df",
    "oval-loader-animation": "m_f8e89c4b"
};






"use client";
//#region packages/@mantine/core/src/components/Loader/loaders/Bars.tsx
const $d3bea8b47e5cc43d$export$fbc7d6f7dd821b47 = ({ className: className, ...others })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "span",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $b90e9c0269727d12$export$2e2bcd8739ae039).barsLoader, className),
        ...others,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: (0, $b90e9c0269727d12$export$2e2bcd8739ae039).bar
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: (0, $b90e9c0269727d12$export$2e2bcd8739ae039).bar
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: (0, $b90e9c0269727d12$export$2e2bcd8739ae039).bar
            })
        ]
    });
$d3bea8b47e5cc43d$export$fbc7d6f7dd821b47.displayName = "@mantine/core/Bars";






"use client";
//#region packages/@mantine/core/src/components/Loader/loaders/Dots.tsx
const $22d94f1a07eb5634$export$8da50d3722682be0 = ({ className: className, ...others })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "span",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $b90e9c0269727d12$export$2e2bcd8739ae039).dotsLoader, className),
        ...others,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: (0, $b90e9c0269727d12$export$2e2bcd8739ae039).dot
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: (0, $b90e9c0269727d12$export$2e2bcd8739ae039).dot
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: (0, $b90e9c0269727d12$export$2e2bcd8739ae039).dot
            })
        ]
    });
$22d94f1a07eb5634$export$8da50d3722682be0.displayName = "@mantine/core/Dots";






"use client";
//#region packages/@mantine/core/src/components/Loader/loaders/Oval.tsx
const $48b6c6c3667834c0$export$67ad50c48ca3ede4 = ({ className: className, ...others })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "span",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $b90e9c0269727d12$export$2e2bcd8739ae039).ovalLoader, className),
        ...others
    });
$48b6c6c3667834c0$export$67ad50c48ca3ede4.displayName = "@mantine/core/Oval";



"use client";
//#region packages/@mantine/core/src/components/Loader/Loader.tsx
const $f943dfe4129424c6$export$67c811dd955240bb = {
    bars: (0, $d3bea8b47e5cc43d$export$fbc7d6f7dd821b47),
    oval: (0, $48b6c6c3667834c0$export$67ad50c48ca3ede4),
    dots: (0, $22d94f1a07eb5634$export$8da50d3722682be0)
};
const $f943dfe4129424c6$var$defaultProps = {
    loaders: $f943dfe4129424c6$export$67c811dd955240bb,
    type: "oval"
};
const $f943dfe4129424c6$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { size: size, color: color })=>({
        root: {
            "--loader-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "loader-size"),
            "--loader-color": color ? (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(color, theme) : void 0
        }
    }));
const $f943dfe4129424c6$export$3b0d6d7590275603 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Loader", $f943dfe4129424c6$var$defaultProps, _props);
    const { size: size, color: color, type: type, vars: vars, className: className, style: style, classNames: classNames, styles: styles, unstyled: unstyled, loaders: loaders, variant: variant, children: children, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Loader",
        props: props,
        classes: (0, $b90e9c0269727d12$export$2e2bcd8739ae039),
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $f943dfe4129424c6$var$varsResolver
    });
    if (children) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...getStyles("root"),
        ...others,
        children: children
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...getStyles("root"),
        component: loaders[type],
        variant: variant,
        size: size,
        ...others
    });
});
$f943dfe4129424c6$export$3b0d6d7590275603.defaultLoaders = $f943dfe4129424c6$export$67c811dd955240bb;
$f943dfe4129424c6$export$3b0d6d7590275603.classes = (0, $b90e9c0269727d12$export$2e2bcd8739ae039);
$f943dfe4129424c6$export$3b0d6d7590275603.varsResolver = $f943dfe4129424c6$var$varsResolver;
$f943dfe4129424c6$export$3b0d6d7590275603.displayName = "@mantine/core/Loader";


"use client";
//#region packages/@mantine/core/src/components/Button/Button.module.css
var $2d6b6e5f45e37227$export$2e2bcd8739ae039 = {
    "root": "m_77c9d27d",
    "inner": "m_80f1301b",
    "label": "m_811560b9",
    "section": "m_a74036a",
    "loader": "m_a25b86ee",
    "group": "m_80d6d844",
    "groupSection": "m_70be2a01"
};










"use client";
//#region packages/@mantine/core/src/components/Button/ButtonGroup/ButtonGroup.tsx
const $6ec1bea904b3b08b$var$defaultProps = {
    orientation: "horizontal"
};
const $6ec1bea904b3b08b$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { borderWidth: borderWidth })=>({
        group: {
            "--button-border-width": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(borderWidth)
        }
    }));
const $6ec1bea904b3b08b$export$69b1032f2ecdf404 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ButtonGroup", $6ec1bea904b3b08b$var$defaultProps, _props);
    const { className: className, style: style, classNames: classNames, styles: styles, unstyled: unstyled, orientation: orientation, vars: vars, borderWidth: borderWidth, mod: mod, attributes: attributes, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ButtonGroup", $6ec1bea904b3b08b$var$defaultProps, _props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...(0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
            name: "ButtonGroup",
            props: props,
            classes: (0, $2d6b6e5f45e37227$export$2e2bcd8739ae039),
            className: className,
            style: style,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            attributes: attributes,
            vars: vars,
            varsResolver: $6ec1bea904b3b08b$var$varsResolver,
            rootSelector: "group"
        })("group"),
        mod: [
            {
                "data-orientation": orientation
            },
            mod
        ],
        role: "group",
        ...others
    });
});
$6ec1bea904b3b08b$export$69b1032f2ecdf404.classes = (0, $2d6b6e5f45e37227$export$2e2bcd8739ae039);
$6ec1bea904b3b08b$export$69b1032f2ecdf404.varsResolver = $6ec1bea904b3b08b$var$varsResolver;
$6ec1bea904b3b08b$export$69b1032f2ecdf404.displayName = "@mantine/core/ButtonGroup";










"use client";
//#region packages/@mantine/core/src/components/Button/ButtonGroupSection/ButtonGroupSection.tsx
const $2a321fd8fdb927c0$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { radius: radius, color: color, gradient: gradient, variant: variant, autoContrast: autoContrast, size: size })=>{
    const colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme: theme,
        gradient: gradient,
        variant: variant || "filled",
        autoContrast: autoContrast
    });
    return {
        groupSection: {
            "--section-height": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "section-height"),
            "--section-padding-x": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "section-padding-x"),
            "--section-fz": size?.includes("compact") ? (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size.replace("compact-", "")) : (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--section-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--section-bg": color || variant ? colors.background : void 0,
            "--section-color": colors.color,
            "--section-bd": color || variant ? colors.border : void 0
        }
    };
});
const $2a321fd8fdb927c0$export$fd69fe432ef7f12d = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ButtonGroupSection", null, _props);
    const { className: className, style: style, classNames: classNames, styles: styles, unstyled: unstyled, vars: vars, gradient: gradient, radius: radius, autoContrast: autoContrast, attributes: attributes, ...others } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...(0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
            name: "ButtonGroupSection",
            props: props,
            classes: (0, $2d6b6e5f45e37227$export$2e2bcd8739ae039),
            className: className,
            style: style,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            attributes: attributes,
            vars: vars,
            varsResolver: $2a321fd8fdb927c0$var$varsResolver,
            rootSelector: "groupSection"
        })("groupSection"),
        ...others
    });
});
$2a321fd8fdb927c0$export$fd69fe432ef7f12d.classes = (0, $2d6b6e5f45e37227$export$2e2bcd8739ae039);
$2a321fd8fdb927c0$export$fd69fe432ef7f12d.varsResolver = $2a321fd8fdb927c0$var$varsResolver;
$2a321fd8fdb927c0$export$fd69fe432ef7f12d.displayName = "@mantine/core/ButtonGroupSection";



"use client";
//#region packages/@mantine/core/src/components/Button/Button.tsx
const $4416f4ee338d8f77$var$loaderTransition = {
    in: {
        opacity: 1,
        transform: `translate(-50%, calc(-50% + ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)}))`
    },
    out: {
        opacity: 0,
        transform: "translate(-50%, -200%)"
    },
    common: {
        transformOrigin: "center"
    },
    transitionProperty: "transform, opacity"
};
const $4416f4ee338d8f77$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { radius: radius, color: color, gradient: gradient, variant: variant, size: size, justify: justify, autoContrast: autoContrast })=>{
    const colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme: theme,
        gradient: gradient,
        variant: variant || "filled",
        autoContrast: autoContrast
    });
    return {
        root: {
            "--button-justify": justify,
            "--button-height": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "button-height"),
            "--button-padding-x": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "button-padding-x"),
            "--button-fz": size?.includes("compact") ? (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size.replace("compact-", "")) : (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--button-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--button-bg": color || variant ? colors.background : void 0,
            "--button-hover": color || variant ? colors.hover : void 0,
            "--button-color": colors.color,
            "--button-bd": color || variant ? colors.border : void 0,
            "--button-hover-color": color || variant ? colors.hoverColor : void 0
        }
    };
});
const $4416f4ee338d8f77$export$353f5b6fc5456de1 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Button", null, _props);
    const { style: style, vars: vars, className: className, color: color, disabled: disabled, children: children, leftSection: leftSection, rightSection: rightSection, fullWidth: fullWidth, variant: variant, radius: radius, loading: loading, loaderProps: loaderProps, gradient: gradient, classNames: classNames, styles: styles, unstyled: unstyled, "data-disabled": dataDisabled, autoContrast: autoContrast, mod: mod, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Button",
        props: props,
        classes: (0, $2d6b6e5f45e37227$export$2e2bcd8739ae039),
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $4416f4ee338d8f77$var$varsResolver
    });
    const hasLeftSection = !!leftSection;
    const hasRightSection = !!rightSection;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), {
        ...getStyles("root", {
            active: !disabled && !loading && !dataDisabled
        }),
        unstyled: unstyled,
        variant: variant,
        disabled: disabled || loading,
        mod: [
            {
                disabled: disabled || dataDisabled,
                loading: loading,
                block: fullWidth,
                "with-left-section": hasLeftSection,
                "with-right-section": hasRightSection
            },
            mod
        ],
        ...others,
        children: [
            typeof loading === "boolean" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4e0d3c4af0891b98$export$be58926105124dd4), {
                mounted: loading,
                transition: $4416f4ee338d8f77$var$loaderTransition,
                duration: 150,
                children: (transitionStyles)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                        component: "span",
                        ...getStyles("loader", {
                            style: transitionStyles
                        }),
                        "aria-hidden": true,
                        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f943dfe4129424c6$export$3b0d6d7590275603), {
                            color: "var(--button-color)",
                            size: "calc(var(--button-height) / 1.8)",
                            ...loaderProps
                        })
                    })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("span", {
                ...getStyles("inner"),
                children: [
                    leftSection && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                        component: "span",
                        ...getStyles("section"),
                        mod: {
                            position: "left"
                        },
                        children: leftSection
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                        component: "span",
                        mod: {
                            loading: loading
                        },
                        ...getStyles("label"),
                        children: children
                    }),
                    rightSection && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                        component: "span",
                        ...getStyles("section"),
                        mod: {
                            position: "right"
                        },
                        children: rightSection
                    })
                ]
            })
        ]
    });
});
$4416f4ee338d8f77$export$353f5b6fc5456de1.classes = (0, $2d6b6e5f45e37227$export$2e2bcd8739ae039);
$4416f4ee338d8f77$export$353f5b6fc5456de1.varsResolver = $4416f4ee338d8f77$var$varsResolver;
$4416f4ee338d8f77$export$353f5b6fc5456de1.displayName = "@mantine/core/Button";
$4416f4ee338d8f77$export$353f5b6fc5456de1.Group = (0, $6ec1bea904b3b08b$export$69b1032f2ecdf404);
$4416f4ee338d8f77$export$353f5b6fc5456de1.GroupSection = (0, $2a321fd8fdb927c0$export$fd69fe432ef7f12d);








var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/components/Group/filter-falsy-children/filter-falsy-children.ts
function $765d0434bc8e1ded$export$21ff29ccd4c87981(children) {
    return (0, $acw62.Children).toArray(children).filter(Boolean);
}


"use client";
//#region packages/@mantine/core/src/components/Group/Group.module.css
var $e7b26f515173d491$export$2e2bcd8739ae039 = {
    "root": "m_4081bf90"
};



"use client";
//#region packages/@mantine/core/src/components/Group/Group.tsx
const $da41c60fbf9c6a46$var$defaultProps = {
    preventGrowOverflow: true,
    gap: "md",
    align: "center",
    justify: "flex-start",
    wrap: "wrap"
};
const $da41c60fbf9c6a46$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { grow: grow, preventGrowOverflow: preventGrowOverflow, gap: gap, align: align, justify: justify, wrap: wrap }, { childWidth: childWidth })=>({
        root: {
            "--group-child-width": grow && preventGrowOverflow ? childWidth : void 0,
            "--group-gap": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(gap),
            "--group-align": align,
            "--group-justify": justify,
            "--group-wrap": wrap
        }
    }));
const $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Group", $da41c60fbf9c6a46$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, children: children, gap: gap, align: align, justify: justify, wrap: wrap, grow: grow, preventGrowOverflow: preventGrowOverflow, vars: vars, variant: variant, __size: __size, mod: mod, attributes: attributes, ...others } = props;
    const filteredChildren = (0, $765d0434bc8e1ded$export$21ff29ccd4c87981)(children);
    const childrenCount = filteredChildren.length;
    const resolvedGap = (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(gap ?? "md");
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...(0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
            name: "Group",
            props: props,
            stylesCtx: {
                childWidth: `calc(${100 / childrenCount}% - (${resolvedGap} - ${resolvedGap} / ${childrenCount}))`
            },
            className: className,
            style: style,
            classes: (0, $e7b26f515173d491$export$2e2bcd8739ae039),
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            attributes: attributes,
            vars: vars,
            varsResolver: $da41c60fbf9c6a46$var$varsResolver
        })("root"),
        variant: variant,
        mod: [
            {
                grow: grow
            },
            mod
        ],
        size: __size,
        ...others,
        children: filteredChildren
    });
});
$da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4.classes = (0, $e7b26f515173d491$export$2e2bcd8739ae039);
$da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4.varsResolver = $da41c60fbf9c6a46$var$varsResolver;
$da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4.displayName = "@mantine/core/Group";



"use client";
//#region packages/@mantine/modals/src/ConfirmModal.tsx
function $4d2824ce73eaaf80$export$8eec1a3a911975a4({ id: id, cancelProps: cancelProps, confirmProps: confirmProps, labels: labels = {
    cancel: "",
    confirm: ""
}, closeOnConfirm: closeOnConfirm = true, closeOnCancel: closeOnCancel = true, groupProps: groupProps, onCancel: onCancel, onConfirm: onConfirm, children: children }) {
    const { cancel: cancelLabel, confirm: confirmLabel } = labels;
    const ctx = (0, $b6724fb04d5a1332$export$2ee174121202e4c7)();
    const handleCancel = (event)=>{
        typeof cancelProps?.onClick === "function" && cancelProps?.onClick(event);
        typeof onCancel === "function" && onCancel();
        closeOnCancel && ctx.closeModal(id);
    };
    const handleConfirm = (event)=>{
        typeof confirmProps?.onClick === "function" && confirmProps?.onClick(event);
        typeof onConfirm === "function" && onConfirm();
        closeOnConfirm && ctx.closeModal(id);
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            children && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                mb: "md",
                children: children
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                mt: children ? 0 : "md",
                justify: "flex-end",
                ...groupProps,
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                        variant: "default",
                        ...cancelProps,
                        onClick: handleCancel,
                        children: cancelProps?.children || cancelLabel
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                        ...confirmProps,
                        onClick: handleConfirm,
                        children: confirmProps?.children || confirmLabel
                    })
                ]
            })
        ]
    });
}



"use client";
//#region packages/@mantine/core/src/core/utils/create-use-external-events/create-use-external-events.ts
function $9d1dca29aabb1156$var$dispatchEvent(type, detail) {
    window.dispatchEvent(new CustomEvent(type, {
        detail: detail
    }));
}
function $9d1dca29aabb1156$export$1e78633c070e02d6(prefix) {
    function _useExternalEvents(events) {
        const handlers = Object.keys(events).reduce((acc, eventKey)=>{
            acc[`${prefix}:${eventKey}`] = (event)=>events[eventKey](event.detail);
            return acc;
        }, {});
        (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
            Object.keys(handlers).forEach((eventKey)=>{
                window.removeEventListener(eventKey, handlers[eventKey]);
                window.addEventListener(eventKey, handlers[eventKey]);
            });
            return ()=>Object.keys(handlers).forEach((eventKey)=>{
                    window.removeEventListener(eventKey, handlers[eventKey]);
                });
        }, [
            handlers
        ]);
    }
    function createEvent(event) {
        return (...payload)=>$9d1dca29aabb1156$var$dispatchEvent(`${prefix}:${String(event)}`, payload[0]);
    }
    return [
        _useExternalEvents,
        createEvent
    ];
}


"use client";
//#region packages/@mantine/hooks/src/utils/random-id/random-id.ts
function $9e1d22b9666695e5$export$5e699d18035b41af(prefix = "mantine-") {
    return `${prefix}${Math.random().toString(36).slice(2, 11)}`;
}


"use client";
//#region packages/@mantine/modals/src/events.ts
const [$6de41693d1c89b64$export$f52b16a0182e6eb, $6de41693d1c89b64$var$createEvent] = (0, $9d1dca29aabb1156$export$1e78633c070e02d6)("mantine-modals");
const $6de41693d1c89b64$export$a7f6cffb6b8ba11c = (payload)=>{
    const id = payload.modalId || (0, $9e1d22b9666695e5$export$5e699d18035b41af)();
    $6de41693d1c89b64$var$createEvent("openModal")({
        ...payload,
        modalId: id
    });
    return id;
};
const $6de41693d1c89b64$export$f184eb19c298e819 = (payload)=>{
    const id = payload.modalId || (0, $9e1d22b9666695e5$export$5e699d18035b41af)();
    $6de41693d1c89b64$var$createEvent("openConfirmModal")({
        ...payload,
        modalId: id
    });
    return id;
};
const $6de41693d1c89b64$export$2ae7845a2724dbcd = (payload)=>{
    const id = payload.modalId || (0, $9e1d22b9666695e5$export$5e699d18035b41af)();
    $6de41693d1c89b64$var$createEvent("openContextModal")({
        ...payload,
        modalId: id
    });
    return id;
};
const $6de41693d1c89b64$export$3f6fecd573f3fa48 = $6de41693d1c89b64$var$createEvent("closeModal");
const $6de41693d1c89b64$export$8d2660641b6fb76a = $6de41693d1c89b64$var$createEvent("closeAllModals");
const $6de41693d1c89b64$export$564ba700ce02cb93 = (payload)=>$6de41693d1c89b64$var$createEvent("updateModal")(payload);
const $6de41693d1c89b64$export$b15ad5c5f8d4ba2e = (payload)=>$6de41693d1c89b64$var$createEvent("updateContextModal")(payload);
const $6de41693d1c89b64$export$3d96f1ad58688d8 = {
    open: $6de41693d1c89b64$export$a7f6cffb6b8ba11c,
    close: $6de41693d1c89b64$export$3f6fecd573f3fa48,
    closeAll: $6de41693d1c89b64$export$8d2660641b6fb76a,
    openConfirmModal: $6de41693d1c89b64$export$f184eb19c298e819,
    openContextModal: $6de41693d1c89b64$export$2ae7845a2724dbcd,
    updateModal: $6de41693d1c89b64$export$564ba700ce02cb93,
    updateContextModal: $6de41693d1c89b64$export$b15ad5c5f8d4ba2e
};


"use client";
//#region packages/@mantine/modals/src/reducer.ts
function $9bae518c51f5a3e4$export$5c038338ec3229b7(modal, canceled) {
    if (canceled && modal.type === "confirm") modal.props.onCancel?.();
    modal.props.onClose?.();
}
function $9bae518c51f5a3e4$export$c732e1f962e199dd(state, action) {
    switch(action.type){
        case "OPEN":
            if (state.modals.some((modal)=>modal.id === action.modal.id)) return state;
            return {
                current: action.modal,
                modals: [
                    ...state.modals,
                    action.modal
                ]
            };
        case "CLOSE":
            {
                if (!state.modals.find((m)=>m.id === action.modalId)) return state;
                const remainingModals = state.modals.filter((m)=>m.id !== action.modalId);
                return {
                    current: remainingModals[remainingModals.length - 1] || state.current,
                    modals: remainingModals
                };
            }
        case "CLOSE_ALL":
            if (!state.modals.length) return state;
            return {
                current: state.current,
                modals: []
            };
        case "UPDATE":
            {
                const { modalId: modalId, newProps: newProps } = action;
                const updatedModals = state.modals.map((modal)=>{
                    if (modal.id !== modalId) return modal;
                    if (modal.type === "content" || modal.type === "confirm") return {
                        ...modal,
                        props: {
                            ...modal.props,
                            ...newProps
                        }
                    };
                    if (modal.type === "context") return {
                        ...modal,
                        props: {
                            ...modal.props,
                            ...newProps,
                            innerProps: {
                                ...modal.props.innerProps,
                                ...newProps.innerProps
                            }
                        }
                    };
                    return modal;
                });
                const currentModal = state.current?.id === modalId ? updatedModals.find((modal)=>modal.id === modalId) || state.current : state.current;
                return {
                    ...state,
                    modals: updatedModals,
                    current: currentModal
                };
            }
        default:
            return state;
    }
}



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/core/utils/get-default-z-index/get-default-z-index.ts
const $f4b868e08831abbf$var$elevations = {
    app: 100,
    modal: 200,
    popover: 300,
    overlay: 400,
    max: 9999
};
function $f4b868e08831abbf$export$65573e7d509c92dc(level) {
    return $f4b868e08831abbf$var$elevations[level];
}




"use client";
//#region packages/@mantine/core/src/components/Modal/Modal.module.css
var $94b0e478eaf03e0e$export$2e2bcd8739ae039 = {
    "root": "m_9df02822",
    "content": "m_54c44539",
    "inner": "m_1f958f16",
    "header": "m_d0e2b9cd"
};






var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/core/utils/create-safe-context/create-safe-context.tsx
function $0bf9cc213b4abd2e$export$97d0e477aacf9b7d(errorMessage) {
    const Context = (0, $acw62.createContext)(null);
    const useSafeContext = ()=>{
        const ctx = (0, $acw62.use)(Context);
        if (ctx === null) throw new Error(errorMessage);
        return ctx;
    };
    return [
        Context,
        useSafeContext
    ];
}


"use client";
//#region packages/@mantine/core/src/components/ModalBase/ModalBase.context.ts
const [$fe9617635751bdba$export$695854637ffea3cb, $fe9617635751bdba$export$48c4ab01c2900d2] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("ModalBase component was not found in tree");




var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/components/ModalBase/use-modal-body-id.ts
function $e67eed789ceb9808$export$5e6569270cd12e2c() {
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    (0, $acw62.useEffect)(()=>{
        ctx.setBodyMounted(true);
        return ()=>ctx.setBodyMounted(false);
    }, []);
    return ctx.getBodyId();
}


"use client";
//#region packages/@mantine/core/src/components/ModalBase/ModalBase.module.css
var $ed1030d453965fd5$export$2e2bcd8739ae039 = {
    "title": "m_615af6c9",
    "header": "m_b5489c3c",
    "inner": "m_60c222c7",
    "content": "m_fd1ab0aa",
    "close": "m_606cb269",
    "body": "m_5df29311"
};




"use client";
//#region packages/@mantine/core/src/components/ModalBase/ModalBaseBody.tsx
function $d5fd70f91a4bdfcc$export$d7aef95ad3794d3a({ className: className, ...others }) {
    const bodyId = (0, $e67eed789ceb9808$export$5e6569270cd12e2c)();
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        id: bodyId,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
            [(0, $ed1030d453965fd5$export$2e2bcd8739ae039).body]: !ctx.unstyled
        }, className),
        ...others
    });
}
$d5fd70f91a4bdfcc$export$d7aef95ad3794d3a.displayName = "@mantine/core/ModalBaseBody";



"use client";
//#region packages/@mantine/core/src/components/Modal/Modal.context.ts
const [$1874173f3d3e2272$export$178405afcd8c5eb, $1874173f3d3e2272$export$4cc1699d46f42cae] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("Modal component was not found in tree");




"use client";
//#region packages/@mantine/core/src/components/Modal/ModalBody.tsx
const $5d2fa167359bcff9$export$cb540d8b0ef7906c = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ModalBody", null, _props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $d5fd70f91a4bdfcc$export$d7aef95ad3794d3a), {
        ...(0, $1874173f3d3e2272$export$4cc1699d46f42cae)().getStyles("body", {
            classNames: classNames,
            style: style,
            styles: styles,
            className: className
        }),
        ...others
    });
});
$5d2fa167359bcff9$export$cb540d8b0ef7906c.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$5d2fa167359bcff9$export$cb540d8b0ef7906c.displayName = "@mantine/core/ModalBody";











parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/CloseButton/CloseIcon.tsx
function $85c9758eca14ab21$export$cae179f078f4b4a4({ size: size = "var(--cb-icon-size, 70%)", style: style, ...others }) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            ...style,
            width: size,
            height: size
        },
        ...others,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    });
}
$85c9758eca14ab21$export$cae179f078f4b4a4.displayName = "@mantine/core/CloseIcon";


"use client";
//#region packages/@mantine/core/src/components/CloseButton/CloseButton.module.css
var $53031e2e92844b02$export$2e2bcd8739ae039 = {
    "root": "m_86a44da5",
    "root--subtle": "m_220c80f2"
};



"use client";
//#region packages/@mantine/core/src/components/CloseButton/CloseButton.tsx
const $30da360a5c87638a$var$defaultProps = {
    variant: "subtle"
};
const $30da360a5c87638a$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size, radius: radius, iconSize: iconSize })=>({
        root: {
            "--cb-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "cb-size"),
            "--cb-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--cb-icon-size": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(iconSize)
        }
    }));
const $30da360a5c87638a$export$de65de8213222d10 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("CloseButton", $30da360a5c87638a$var$defaultProps, _props);
    const { iconSize: iconSize, children: children, vars: vars, radius: radius, className: className, classNames: classNames, style: style, styles: styles, unstyled: unstyled, "data-disabled": dataDisabled, disabled: disabled, variant: variant, icon: icon, mod: mod, attributes: attributes, __staticSelector: __staticSelector, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: __staticSelector || "CloseButton",
        props: props,
        className: className,
        style: style,
        classes: (0, $53031e2e92844b02$export$2e2bcd8739ae039),
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $30da360a5c87638a$var$varsResolver
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), {
        ...others,
        unstyled: unstyled,
        variant: variant,
        disabled: disabled,
        mod: [
            {
                disabled: disabled || dataDisabled
            },
            mod
        ],
        ...getStyles("root", {
            variant: variant,
            active: !disabled && !dataDisabled
        }),
        children: [
            icon || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $85c9758eca14ab21$export$cae179f078f4b4a4), {}),
            children
        ]
    });
});
$30da360a5c87638a$export$de65de8213222d10.classes = (0, $53031e2e92844b02$export$2e2bcd8739ae039);
$30da360a5c87638a$export$de65de8213222d10.varsResolver = $30da360a5c87638a$var$varsResolver;
$30da360a5c87638a$export$de65de8213222d10.displayName = "@mantine/core/CloseButton";






"use client";
//#region packages/@mantine/core/src/components/ModalBase/ModalBaseCloseButton.tsx
function $4a8838dd16520833$export$cb6429a0eac3477a({ className: className, onClick: onClick, ...others }) {
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $30da360a5c87638a$export$de65de8213222d10), {
        ...others,
        onClick: (event)=>{
            ctx.onClose();
            onClick?.(event);
        },
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
            [(0, $ed1030d453965fd5$export$2e2bcd8739ae039).close]: !ctx.unstyled
        }, className),
        unstyled: ctx.unstyled
    });
}
$4a8838dd16520833$export$cb6429a0eac3477a.displayName = "@mantine/core/ModalBaseCloseButton";





"use client";
//#region packages/@mantine/core/src/components/Modal/ModalCloseButton.tsx
const $35769c8ec5687fff$export$edf9108895ba774f = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ModalCloseButton", null, _props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4a8838dd16520833$export$cb6429a0eac3477a), {
        ...(0, $1874173f3d3e2272$export$4cc1699d46f42cae)().getStyles("close", {
            classNames: classNames,
            style: style,
            styles: styles,
            className: className
        }),
        ...others
    });
});
$35769c8ec5687fff$export$edf9108895ba774f.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$35769c8ec5687fff$export$edf9108895ba774f.displayName = "@mantine/core/ModalCloseButton";











"use client";
//#region packages/@mantine/core/src/components/Paper/Paper.module.css
var $227c9ef646c028c4$export$2e2bcd8739ae039 = {
    "root": "m_1b7284a3"
};



"use client";
//#region packages/@mantine/core/src/components/Paper/Paper.tsx
const $f9eedd3a1a3486ca$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { radius: radius, shadow: shadow })=>({
        root: {
            "--paper-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--paper-shadow": (0, $fcab4af601ce7e99$export$db93b77dbb14f011)(shadow)
        }
    }));
const $f9eedd3a1a3486ca$export$e01703dff029898a = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Paper", null, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, withBorder: withBorder, vars: vars, radius: radius, shadow: shadow, variant: variant, mod: mod, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Paper",
        props: props,
        classes: (0, $227c9ef646c028c4$export$2e2bcd8739ae039),
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $f9eedd3a1a3486ca$var$varsResolver
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        mod: [
            {
                "data-with-border": withBorder
            },
            mod
        ],
        ...getStyles("root"),
        variant: variant,
        ...others
    });
});
$f9eedd3a1a3486ca$export$e01703dff029898a.classes = (0, $227c9ef646c028c4$export$2e2bcd8739ae039);
$f9eedd3a1a3486ca$export$e01703dff029898a.varsResolver = $f9eedd3a1a3486ca$var$varsResolver;
$f9eedd3a1a3486ca$export$e01703dff029898a.displayName = "@mantine/core/Paper";




var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/core/utils/is-element/is-element.ts
function $65b68cae0fe4eb32$export$45a5e7f76e0caa8d(value) {
    if (Array.isArray(value) || value === null) return false;
    if (typeof value === "object") {
        if (value.type === (0, $acw62.Fragment)) return false;
        return true;
    }
    return false;
}



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/core/utils/get-single-element-child/get-single-element-child.ts
function $fc5f5fc6d9909a8d$export$1fd9bef6809ad57c(children) {
    const _children = (0, $acw62.Children).toArray(children);
    if (_children.length !== 1 || !(0, $65b68cae0fe4eb32$export$45a5e7f76e0caa8d)(_children[0])) return null;
    return _children[0];
}






"use client";
//#region packages/@mantine/core/src/components/VisuallyHidden/VisuallyHidden.module.css
var $5fd8acbe9ca07e39$export$2e2bcd8739ae039 = {
    "root": "m_515a97f8"
};



"use client";
//#region packages/@mantine/core/src/components/VisuallyHidden/VisuallyHidden.tsx
const $185486110a4f3e54$export$439d29a4e110a164 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("VisuallyHidden", null, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, attributes: attributes, ...others } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "span",
        ...(0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
            name: "VisuallyHidden",
            classes: (0, $5fd8acbe9ca07e39$export$2e2bcd8739ae039),
            props: props,
            className: className,
            style: style,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            attributes: attributes
        })("root"),
        ...others
    });
});
$185486110a4f3e54$export$439d29a4e110a164.classes = (0, $5fd8acbe9ca07e39$export$2e2bcd8739ae039);
$185486110a4f3e54$export$439d29a4e110a164.displayName = "@mantine/core/VisuallyHidden";



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-focus-trap/tabbable.ts
const $f455481bb19aecdd$var$TABBABLE_NODES = /input|select|textarea|button|object/;
const $f455481bb19aecdd$export$1402e37c3ad71960 = "a, input, select, textarea, button, object, [tabindex]";
function $f455481bb19aecdd$var$hidden(element) {
    return element.style.display === "none";
}
function $f455481bb19aecdd$var$visible(element) {
    if (element.getAttribute("aria-hidden") || element.getAttribute("hidden") || element.getAttribute("type") === "hidden") return false;
    let parentElement = element;
    while(parentElement){
        if (parentElement === document.body || parentElement.nodeType === 11) break;
        if ($f455481bb19aecdd$var$hidden(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $f455481bb19aecdd$var$getElementTabIndex(element) {
    let tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = void 0;
    return parseInt(tabIndex, 10);
}
function $f455481bb19aecdd$export$ecc6d1fcdff4f700(element) {
    const nodeName = element.nodeName.toLowerCase();
    const isTabIndexNotNaN = !Number.isNaN($f455481bb19aecdd$var$getElementTabIndex(element));
    return ($f455481bb19aecdd$var$TABBABLE_NODES.test(nodeName) && !element.disabled || (element instanceof HTMLAnchorElement ? element.href || isTabIndexNotNaN : isTabIndexNotNaN)) && $f455481bb19aecdd$var$visible(element);
}
function $f455481bb19aecdd$export$17100aea90429aa7(element) {
    const tabIndex = $f455481bb19aecdd$var$getElementTabIndex(element);
    return (Number.isNaN(tabIndex) || tabIndex >= 0) && $f455481bb19aecdd$export$ecc6d1fcdff4f700(element);
}
function $f455481bb19aecdd$export$9add2e4db58062c(element) {
    return Array.from(element.querySelectorAll($f455481bb19aecdd$export$1402e37c3ad71960)).filter($f455481bb19aecdd$export$17100aea90429aa7);
}



"use client";
//#region packages/@mantine/hooks/src/use-focus-trap/scope-tab.ts
function $e497d06b12418905$export$a4ab3f53d4a6be9b(node, event) {
    const tabbable = (0, $f455481bb19aecdd$export$9add2e4db58062c)(node);
    if (!tabbable.length) {
        event.preventDefault();
        return;
    }
    const finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
    const root = node.getRootNode();
    let leavingFinalTabbable = finalTabbable === root.activeElement || node === root.activeElement;
    const activeElement = root.activeElement;
    if (activeElement.tagName === "INPUT" && activeElement.getAttribute("type") === "radio") leavingFinalTabbable = tabbable.filter((element)=>element.getAttribute("type") === "radio" && element.getAttribute("name") === activeElement.getAttribute("name")).includes(finalTabbable);
    if (!leavingFinalTabbable) return;
    event.preventDefault();
    const target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
    if (target) target.focus();
}



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-focus-trap/use-focus-trap.ts
function $f0e5ce899b20f8cd$export$5562a1f223a0d314(active = true) {
    const ref = (0, $acw62.useRef)(null);
    const focusNode = (node)=>{
        let focusElement = node.querySelector("[data-autofocus]");
        if (!focusElement) {
            const children = Array.from(node.querySelectorAll((0, $f455481bb19aecdd$export$1402e37c3ad71960)));
            focusElement = children.find((0, $f455481bb19aecdd$export$17100aea90429aa7)) || children.find((0, $f455481bb19aecdd$export$ecc6d1fcdff4f700)) || null;
            if (!focusElement && (0, $f455481bb19aecdd$export$ecc6d1fcdff4f700)(node)) focusElement = node;
        }
        if (focusElement) focusElement.focus({
            preventScroll: true
        });
        else console.warn("[@mantine/hooks/use-focus-trap] Failed to find focusable element within provided node", node);
    };
    const setRef = (0, $acw62.useCallback)((node)=>{
        if (!active) return;
        if (node === null) {
            ref.current = null;
            return;
        }
        if (ref.current === node) return;
        setTimeout(()=>{
            if (node.getRootNode()) focusNode(node);
            else console.warn("[@mantine/hooks/use-focus-trap] Ref node is not part of the dom", node);
        });
        ref.current = node;
    }, [
        active
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!active) return;
        if (ref.current) setTimeout(()=>{
            if (ref.current) focusNode(ref.current);
        });
        const handleKeyDown = (event)=>{
            if (event.key === "Tab" && ref.current) (0, $e497d06b12418905$export$a4ab3f53d4a6be9b)(ref.current, event);
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        active
    ]);
    return setRef;
}


var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-merged-ref/use-merged-ref.ts
function $7034a45159125c0b$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (typeof ref === "object" && ref !== null && "current" in ref) ref.current = value;
}
function $7034a45159125c0b$export$c9058316764c140e(...refs) {
    const cleanupMap = /* @__PURE__ */ new Map();
    return (node)=>{
        refs.forEach((ref)=>{
            const cleanup = $7034a45159125c0b$export$d734136a7b018efe(ref, node);
            if (cleanup) cleanupMap.set(ref, cleanup);
        });
        if (cleanupMap.size > 0) return ()=>{
            refs.forEach((ref)=>{
                const cleanup = cleanupMap.get(ref);
                if (cleanup && typeof cleanup === "function") cleanup();
                else $7034a45159125c0b$export$d734136a7b018efe(ref, null);
            });
            cleanupMap.clear();
        };
    };
}
function $7034a45159125c0b$export$36a55fa7500f01f(...refs) {
    return (0, $acw62.useCallback)($7034a45159125c0b$export$c9058316764c140e(...refs), refs);
}



"use client";
//#region packages/@mantine/core/src/components/FocusTrap/FocusTrap.tsx
function $78545dc889974525$export$34eba2437817a67b({ children: children, active: active = true, refProp: refProp = "ref", innerRef: innerRef }) {
    const ref = (0, $7034a45159125c0b$export$36a55fa7500f01f)((0, $f0e5ce899b20f8cd$export$5562a1f223a0d314)(active), innerRef);
    const child = (0, $fc5f5fc6d9909a8d$export$1fd9bef6809ad57c)(children);
    if (!child) return children;
    return (0, $acw62.cloneElement)(child, {
        [refProp]: ref
    });
}
function $78545dc889974525$export$14260a9cdb2a0ed6(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $185486110a4f3e54$export$439d29a4e110a164), {
        tabIndex: -1,
        "data-autofocus": true,
        ...props
    });
}
$78545dc889974525$export$34eba2437817a67b.displayName = "@mantine/core/FocusTrap";
$78545dc889974525$export$14260a9cdb2a0ed6.displayName = "@mantine/core/FocusTrapInitialFocus";
$78545dc889974525$export$34eba2437817a67b.InitialFocus = $78545dc889974525$export$14260a9cdb2a0ed6;






"use client";
//#region packages/@mantine/core/src/components/ModalBase/ModalBaseContent.tsx
function $de3968c572b3eca5$export$a0b222e605967853({ transitionProps: transitionProps, className: className, innerProps: innerProps, onKeyDown: onKeyDown, style: style, ref: ref, ...others }) {
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4e0d3c4af0891b98$export$be58926105124dd4), {
        mounted: ctx.opened,
        transition: "pop",
        ...ctx.transitionProps,
        onExited: ()=>{
            ctx.onExitTransitionEnd?.();
            ctx.transitionProps?.onExited?.();
        },
        onEntered: ()=>{
            ctx.onEnterTransitionEnd?.();
            ctx.transitionProps?.onEntered?.();
        },
        ...transitionProps,
        children: (transitionStyles)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...innerProps,
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                    [(0, $ed1030d453965fd5$export$2e2bcd8739ae039).inner]: !ctx.unstyled
                }, innerProps.className),
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $78545dc889974525$export$34eba2437817a67b), {
                    active: ctx.opened && ctx.trapFocus,
                    innerRef: ref,
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f9eedd3a1a3486ca$export$e01703dff029898a), {
                        ...others,
                        component: "section",
                        role: "dialog",
                        tabIndex: -1,
                        "aria-modal": true,
                        "aria-describedby": ctx.bodyMounted ? ctx.getBodyId() : void 0,
                        "aria-labelledby": ctx.titleMounted ? ctx.getTitleId() : void 0,
                        style: [
                            style,
                            transitionStyles
                        ],
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                            [(0, $ed1030d453965fd5$export$2e2bcd8739ae039).content]: !ctx.unstyled
                        }, className),
                        unstyled: ctx.unstyled,
                        children: others.children
                    })
                })
            })
    });
}
$de3968c572b3eca5$export$a0b222e605967853.displayName = "@mantine/core/ModalBaseContent";



"use client";
//#region packages/@mantine/core/src/components/ModalBase/NativeScrollArea.tsx
function $382093e308c1e7d9$export$db1aa91c77c94e4c({ children: children }) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
}





"use client";
//#region packages/@mantine/core/src/components/Modal/ModalContent.tsx
const $5a867aa53d8adb6b$export$6da19a24bf249f17 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, children: children, __hidden: __hidden, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ModalContent", null, _props);
    const ctx = (0, $1874173f3d3e2272$export$4cc1699d46f42cae)();
    const Scroll = ctx.scrollAreaComponent || (0, $382093e308c1e7d9$export$db1aa91c77c94e4c);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $de3968c572b3eca5$export$a0b222e605967853), {
        ...ctx.getStyles("content", {
            className: className,
            style: style,
            styles: styles,
            classNames: classNames
        }),
        innerProps: ctx.getStyles("inner", {
            className: className,
            style: style,
            styles: styles,
            classNames: classNames
        }),
        "data-full-screen": ctx.fullScreen || void 0,
        "data-modal-content": true,
        "data-hidden": __hidden || void 0,
        ...others,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Scroll, {
            style: {
                maxHeight: ctx.fullScreen ? "100dvh" : `calc(100dvh - (${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(ctx.yOffset)} * 2))`
            },
            children: children
        })
    });
});
$5a867aa53d8adb6b$export$6da19a24bf249f17.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$5a867aa53d8adb6b$export$6da19a24bf249f17.displayName = "@mantine/core/ModalContent";









"use client";
//#region packages/@mantine/core/src/components/ModalBase/ModalBaseHeader.tsx
function $36f14f6b2ad38d8c$export$6cdb8b1b385d5e98({ className: className, ...others }) {
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "header",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
            [(0, $ed1030d453965fd5$export$2e2bcd8739ae039).header]: !ctx.unstyled
        }, className),
        ...others
    });
}
$36f14f6b2ad38d8c$export$6cdb8b1b385d5e98.displayName = "@mantine/core/ModalBaseHeader";





"use client";
//#region packages/@mantine/core/src/components/Modal/ModalHeader.tsx
const $33aea0631d2029a1$export$f50a68e3694789ee = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ModalHeader", null, _props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $36f14f6b2ad38d8c$export$6cdb8b1b385d5e98), {
        ...(0, $1874173f3d3e2272$export$4cc1699d46f42cae)().getStyles("header", {
            classNames: classNames,
            style: style,
            styles: styles,
            className: className
        }),
        ...others
    });
});
$33aea0631d2029a1$export$f50a68e3694789ee.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$33aea0631d2029a1$export$f50a68e3694789ee.displayName = "@mantine/core/ModalHeader";













"use client";
//#region packages/@mantine/core/src/components/Overlay/Overlay.module.css
var $a59458134950664f$export$2e2bcd8739ae039 = {
    "root": "m_9814e45f"
};



"use client";
//#region packages/@mantine/core/src/components/Overlay/Overlay.tsx
const $8816b2889866f4a7$var$defaultProps = {
    zIndex: (0, $f4b868e08831abbf$export$65573e7d509c92dc)("modal")
};
const $8816b2889866f4a7$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { gradient: gradient, color: color, backgroundOpacity: backgroundOpacity, blur: blur, radius: radius, zIndex: zIndex })=>({
        root: {
            "--overlay-bg": gradient || (color !== void 0 || backgroundOpacity !== void 0) && (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(color || "#000", backgroundOpacity ?? .6) || void 0,
            "--overlay-filter": blur ? `blur(${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(blur)})` : void 0,
            "--overlay-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--overlay-z-index": zIndex?.toString()
        }
    }));
const $8816b2889866f4a7$export$c6fdb837b070b4ff = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Overlay", $8816b2889866f4a7$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, fixed: fixed, center: center, children: children, radius: radius, zIndex: zIndex, gradient: gradient, blur: blur, color: color, backgroundOpacity: backgroundOpacity, mod: mod, attributes: attributes, ...others } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...(0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
            name: "Overlay",
            props: props,
            classes: (0, $a59458134950664f$export$2e2bcd8739ae039),
            className: className,
            style: style,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            attributes: attributes,
            vars: vars,
            varsResolver: $8816b2889866f4a7$var$varsResolver
        })("root"),
        mod: [
            {
                center: center,
                fixed: fixed
            },
            mod
        ],
        ...others,
        children: children
    });
});
$8816b2889866f4a7$export$c6fdb837b070b4ff.classes = (0, $a59458134950664f$export$2e2bcd8739ae039);
$8816b2889866f4a7$export$c6fdb837b070b4ff.varsResolver = $8816b2889866f4a7$var$varsResolver;
$8816b2889866f4a7$export$c6fdb837b070b4ff.displayName = "@mantine/core/Overlay";





"use client";
//#region packages/@mantine/core/src/components/ModalBase/use-modal-transition.ts
const $9c8a16c6280d87ab$var$DEFAULT_TRANSITION = {
    duration: 200,
    timingFunction: "ease",
    transition: "fade"
};
function $9c8a16c6280d87ab$export$5df0a1c6e658f755(transitionOverride) {
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    return {
        ...$9c8a16c6280d87ab$var$DEFAULT_TRANSITION,
        ...ctx.transitionProps,
        ...transitionOverride
    };
}



"use client";
//#region packages/@mantine/core/src/components/ModalBase/ModalBaseOverlay.tsx
function $06d7d3a0bbd37bf0$export$dfc81a5f853cf392({ onClick: onClick, transitionProps: transitionProps, style: style, visible: visible, ...others }) {
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    const transition = (0, $9c8a16c6280d87ab$export$5df0a1c6e658f755)(transitionProps);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4e0d3c4af0891b98$export$be58926105124dd4), {
        mounted: visible !== void 0 ? visible : ctx.opened,
        ...transition,
        transition: "fade",
        children: (transitionStyles)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8816b2889866f4a7$export$c6fdb837b070b4ff), {
                fixed: true,
                style: [
                    style,
                    transitionStyles
                ],
                zIndex: ctx.zIndex,
                unstyled: ctx.unstyled,
                onClick: (event)=>{
                    onClick?.(event);
                    ctx.closeOnClickOutside && ctx.onClose();
                },
                ...others
            })
    });
}
$06d7d3a0bbd37bf0$export$dfc81a5f853cf392.displayName = "@mantine/core/ModalBaseOverlay";





"use client";
//#region packages/@mantine/core/src/components/Modal/ModalOverlay.tsx
const $913f345f895164ed$export$8948f78d83984c69 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ModalOverlay", null, _props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06d7d3a0bbd37bf0$export$dfc81a5f853cf392), {
        ...(0, $1874173f3d3e2272$export$4cc1699d46f42cae)().getStyles("overlay", {
            classNames: classNames,
            style: style,
            styles: styles,
            className: className
        }),
        ...others
    });
});
$913f345f895164ed$export$8948f78d83984c69.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$913f345f895164ed$export$8948f78d83984c69.displayName = "@mantine/core/ModalOverlay";
















var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/ScrollArea/use-resize-observer.ts
function $132fa50acb2babc6$export$683480f191c0e3ea(element, onResize) {
    const handleResize = (0, $acw62.useEffectEvent)(onResize);
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        let rAF = 0;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                cancelAnimationFrame(rAF);
                rAF = window.requestAnimationFrame(handleResize);
            });
            resizeObserver.observe(element);
            return ()=>{
                window.cancelAnimationFrame(rAF);
                resizeObserver.unobserve(element);
            };
        }
    }, [
        element
    ]);
}



"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollArea.context.ts
const [$79f911f27c208c7e$export$ea262e38353a259a, $79f911f27c208c7e$export$6f5f1e779aff6cfb] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("ScrollArea.Root component was not found in tree");




var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollAreaCorner/ScrollAreaCorner.tsx
function $f537e37f6c0b850a$var$Corner(props) {
    const { style: style, ...others } = props;
    const ctx = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const [width, setWidth] = (0, $acw62.useState)(0);
    const [height, setHeight] = (0, $acw62.useState)(0);
    const hasSize = Boolean(width && height);
    (0, $132fa50acb2babc6$export$683480f191c0e3ea)(ctx.scrollbarX, ()=>{
        const h = ctx.scrollbarX?.offsetHeight || 0;
        ctx.onCornerHeightChange(h);
        setHeight(h);
    });
    (0, $132fa50acb2babc6$export$683480f191c0e3ea)(ctx.scrollbarY, ()=>{
        const w = ctx.scrollbarY?.offsetWidth || 0;
        ctx.onCornerWidthChange(w);
        setWidth(w);
    });
    return hasSize ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        ...others,
        style: {
            ...style,
            width: width,
            height: height
        }
    }) : null;
}
function $f537e37f6c0b850a$export$56969d565df7cc4b(props) {
    const ctx = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const hasBothScrollbarsVisible = Boolean(ctx.scrollbarX && ctx.scrollbarY);
    return ctx.type !== "scroll" && hasBothScrollbarsVisible ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($f537e37f6c0b850a$var$Corner, {
        ...props
    }) : null;
}






var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollAreaRoot/ScrollAreaRoot.tsx
const $e2df1435548fd2cc$var$defaultProps = {
    scrollHideDelay: 1e3,
    type: "hover"
};
function $e2df1435548fd2cc$export$f2a893fcd08ef34d(_props) {
    const { type: type, scrollHideDelay: scrollHideDelay, scrollbars: scrollbars, getStyles: getStyles, ref: ref, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ScrollAreaRoot", $e2df1435548fd2cc$var$defaultProps, _props);
    const [scrollArea, setScrollArea] = (0, $acw62.useState)(null);
    const [viewport, setViewport] = (0, $acw62.useState)(null);
    const [content, setContent] = (0, $acw62.useState)(null);
    const [scrollbarX, setScrollbarX] = (0, $acw62.useState)(null);
    const [scrollbarY, setScrollbarY] = (0, $acw62.useState)(null);
    const [cornerWidth, setCornerWidth] = (0, $acw62.useState)(0);
    const [cornerHeight, setCornerHeight] = (0, $acw62.useState)(0);
    const [scrollbarXEnabled, setScrollbarXEnabled] = (0, $acw62.useState)(false);
    const [scrollbarYEnabled, setScrollbarYEnabled] = (0, $acw62.useState)(false);
    const rootRef = (0, $7034a45159125c0b$export$36a55fa7500f01f)(ref, setScrollArea);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $79f911f27c208c7e$export$ea262e38353a259a), {
        value: {
            type: type,
            scrollHideDelay: scrollHideDelay,
            scrollArea: scrollArea,
            viewport: viewport,
            onViewportChange: setViewport,
            content: content,
            onContentChange: setContent,
            scrollbarX: scrollbarX,
            onScrollbarXChange: setScrollbarX,
            scrollbarXEnabled: scrollbarXEnabled,
            onScrollbarXEnabledChange: setScrollbarXEnabled,
            scrollbarY: scrollbarY,
            onScrollbarYChange: setScrollbarY,
            scrollbarYEnabled: scrollbarYEnabled,
            onScrollbarYEnabledChange: setScrollbarYEnabled,
            onCornerWidthChange: setCornerWidth,
            onCornerHeightChange: setCornerHeight,
            getStyles: getStyles
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
            ...others,
            ref: rootRef,
            __vars: {
                "--sa-corner-width": scrollbars !== "xy" ? "0px" : `${cornerWidth}px`,
                "--sa-corner-height": scrollbars !== "xy" ? "0px" : `${cornerHeight}px`
            }
        })
    });
}
$e2df1435548fd2cc$export$f2a893fcd08ef34d.displayName = "@mantine/core/ScrollAreaRoot";




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-mutation-observer/use-mutation-observer.ts
function $07f5bc051447d2a4$export$8ecdcf3bb089e9cd(callback, options) {
    const observer = (0, $acw62.useRef)(null);
    return (0, $acw62.useCallback)((node)=>{
        if (observer.current) {
            observer.current.disconnect();
            observer.current = null;
        }
        if (node) {
            observer.current = new MutationObserver(callback);
            observer.current.observe(node, options);
        }
        return ()=>{
            if (observer.current) {
                observer.current.disconnect();
                observer.current = null;
            }
        };
    }, [
        callback,
        options
    ]);
}
function $07f5bc051447d2a4$export$8f8c694c79ca66b(callback, options, target) {
    const observer = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (observer.current) {
            observer.current.disconnect();
            observer.current = null;
        }
        const targetElement = typeof target === "function" ? target() : target;
        if (targetElement) {
            observer.current = new MutationObserver(callback);
            observer.current.observe(targetElement, options);
        }
        return ()=>{
            if (observer.current) {
                observer.current.disconnect();
                observer.current = null;
            }
        };
    }, [
        callback,
        options,
        target
    ]);
}



"use client";
//#region packages/@mantine/core/src/core/DirectionProvider/DirectionProvider.tsx
const $35c57ac18e24a61d$export$46f936cc30cb9075 = (0, $acw62.createContext)({
    dir: "ltr",
    toggleDirection: ()=>{},
    setDirection: ()=>{}
});
function $35c57ac18e24a61d$export$b39126d51d94e6f3() {
    return (0, $acw62.use)($35c57ac18e24a61d$export$46f936cc30cb9075);
}
function $35c57ac18e24a61d$export$c760c09fdd558351({ children: children, initialDirection: initialDirection = "ltr", detectDirection: detectDirection = true }) {
    const [dir, setDir] = (0, $acw62.useState)(initialDirection);
    const setDirection = (0, $acw62.useCallback)((direction)=>{
        setDir(direction);
        if (document.documentElement.getAttribute("dir") !== direction) document.documentElement.setAttribute("dir", direction);
    }, []);
    const toggleDirection = ()=>setDirection(dir === "ltr" ? "rtl" : "ltr");
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        if (detectDirection) {
            const direction = document.documentElement.getAttribute("dir");
            if (direction === "rtl" || direction === "ltr") setDir(direction);
        }
    }, []);
    (0, $07f5bc051447d2a4$export$8f8c694c79ca66b)((0, $acw62.useCallback)(()=>{
        if (typeof document === "undefined") return;
        const direction = document.documentElement.getAttribute("dir");
        if (direction === "rtl" || direction === "ltr") setDir((prev)=>prev !== direction ? direction : prev);
    }, []), detectDirection ? {
        attributes: true,
        attributeFilter: [
            "dir"
        ]
    } : {}, typeof document !== "undefined" && detectDirection ? document.documentElement : null);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($35c57ac18e24a61d$export$46f936cc30cb9075, {
        value: {
            dir: dir,
            toggleDirection: toggleDirection,
            setDirection: setDirection
        },
        children: children
    });
}



"use client";
//#region packages/@mantine/core/src/components/ScrollArea/utils/get-thumb-ratio.tsx
function $e40829f322f41fa9$export$cf7769cb1c49cedf(viewportSize, contentSize) {
    const ratio = viewportSize / contentSize;
    return Number.isNaN(ratio) ? 0 : ratio;
}



"use client";
//#region packages/@mantine/core/src/components/ScrollArea/utils/get-thumb-size.tsx
function $ad769dbbdef0d7a6$export$7b14c3f3cc4d1eca(sizes) {
    const ratio = (0, $e40829f322f41fa9$export$cf7769cb1c49cedf)(sizes.viewport, sizes.content);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const thumbSize = (sizes.scrollbar.size - scrollbarPadding) * ratio;
    return Math.max(thumbSize, 18);
}


"use client";
//#region packages/@mantine/core/src/components/ScrollArea/utils/linear-scale.ts
function $3d9580bad10edfae$export$fefe9507ec0904ed(input, output) {
    return (value)=>{
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        const ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}


"use client";
//#region packages/@mantine/core/src/components/ScrollArea/utils/get-thumb-offset-from-scroll.ts
function $48a05505b367dbd3$var$clamp(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}
function $48a05505b367dbd3$export$ed4bbb745ec92b4f(scrollPos, sizes, dir = "ltr") {
    const thumbSizePx = (0, $ad769dbbdef0d7a6$export$7b14c3f3cc4d1eca)(sizes);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const scrollbar = sizes.scrollbar.size - scrollbarPadding;
    const maxScrollPos = sizes.content - sizes.viewport;
    const maxThumbPos = scrollbar - thumbSizePx;
    const scrollWithoutMomentum = $48a05505b367dbd3$var$clamp(scrollPos, dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ]);
    return (0, $3d9580bad10edfae$export$fefe9507ec0904ed)([
        0,
        maxScrollPos
    ], [
        0,
        maxThumbPos
    ])(scrollWithoutMomentum);
}




"use client";
//#region packages/@mantine/core/src/components/ScrollArea/utils/get-scroll-position-from-pointer.ts
function $33809556927fa4c1$export$8bf262e596ba0cb9(pointerPos, pointerOffset, sizes, dir = "ltr") {
    const thumbSizePx = (0, $ad769dbbdef0d7a6$export$7b14c3f3cc4d1eca)(sizes);
    const thumbCenter = thumbSizePx / 2;
    const offset = pointerOffset || thumbCenter;
    const thumbOffsetFromEnd = thumbSizePx - offset;
    const minPointerPos = sizes.scrollbar.paddingStart + offset;
    const maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd;
    const maxScrollPos = sizes.content - sizes.viewport;
    const scrollRange = dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    return (0, $3d9580bad10edfae$export$fefe9507ec0904ed)([
        minPointerPos,
        maxPointerPos
    ], scrollRange)(pointerPos);
}



"use client";
//#region packages/@mantine/core/src/components/ScrollArea/utils/is-scrolling-within-scrollbar-bounds.ts
function $3bc502b82e5dc37a$export$3dd2cb87ed130ea5(scrollPos, maxScrollPos) {
    return scrollPos > 0 && scrollPos < maxScrollPos;
}



"use client";
//#region packages/@mantine/core/src/components/ScrollArea/utils/to-int.ts
function $d6ccc87a85e73501$export$e7a1baa2fae31f0f(value) {
    return value ? parseInt(value, 10) : 0;
}




"use client";
//#region packages/@mantine/core/src/components/ScrollArea/utils/compose-event-handlers.ts
function $1c9ccee2f3ecd168$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return (event)=>{
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) ourEventHandler?.(event);
    };
}



"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollAreaScrollbar/Scrollbar.context.ts
const [$e66ab2864f33f4cb$export$9ab4af0f5675598e, $e66ab2864f33f4cb$export$9eae1e0809562d06] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("ScrollAreaScrollbar was not found in tree");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/utils/use-callback-ref/use-callback-ref.ts
function $9b08cecfd84e8161$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $acw62.useRef)(callback);
    (0, $acw62.useEffect)(()=>{
        callbackRef.current = callback;
    });
    return (0, $acw62.useMemo)(()=>(...args)=>callbackRef.current?.(...args), []);
}



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-debounced-callback/use-debounced-callback.ts
function $4919278891a7db8a$export$e70e6da722faba05(callback, options) {
    const { delay: delay, flushOnUnmount: flushOnUnmount, leading: leading, maxWait: maxWait } = typeof options === "number" ? {
        delay: options,
        flushOnUnmount: false,
        leading: false,
        maxWait: void 0
    } : options;
    const handleCallback = (0, $9b08cecfd84e8161$export$25bec8c6f54ee79a)(callback);
    const debounceTimerRef = (0, $acw62.useRef)(0);
    const maxWaitTimerRef = (0, $acw62.useRef)(0);
    const latestArgsRef = (0, $acw62.useRef)(null);
    const lastCallback = (0, $acw62.useMemo)(()=>{
        const currentCallback = Object.assign((...args)=>{
            window.clearTimeout(debounceTimerRef.current);
            latestArgsRef.current = args;
            const isFirstCall = currentCallback._isFirstCall;
            currentCallback._isFirstCall = false;
            function clearTimeoutAndLeadingRef() {
                window.clearTimeout(debounceTimerRef.current);
                window.clearTimeout(maxWaitTimerRef.current);
                debounceTimerRef.current = 0;
                maxWaitTimerRef.current = 0;
                currentCallback._isFirstCall = true;
                currentCallback._hasPendingCallback = false;
            }
            function startMaxWaitTimer() {
                if (maxWait !== void 0 && maxWaitTimerRef.current === 0) maxWaitTimerRef.current = window.setTimeout(()=>{
                    if (debounceTimerRef.current !== 0) {
                        const latestArgs = latestArgsRef.current;
                        clearTimeoutAndLeadingRef();
                        handleCallback(...latestArgs);
                    }
                }, maxWait);
            }
            if (leading && isFirstCall) {
                handleCallback(...args);
                const resetLeadingState = ()=>{
                    clearTimeoutAndLeadingRef();
                };
                const flush = ()=>{
                    if (debounceTimerRef.current !== 0) {
                        clearTimeoutAndLeadingRef();
                        handleCallback(...args);
                    }
                };
                const cancel = ()=>{
                    clearTimeoutAndLeadingRef();
                };
                currentCallback.flush = flush;
                currentCallback.cancel = cancel;
                debounceTimerRef.current = window.setTimeout(resetLeadingState, delay);
                startMaxWaitTimer();
                return;
            }
            if (leading && !isFirstCall) {
                currentCallback._hasPendingCallback = true;
                const flush = ()=>{
                    if (debounceTimerRef.current !== 0) {
                        clearTimeoutAndLeadingRef();
                        handleCallback(...args);
                    }
                };
                const cancel = ()=>{
                    clearTimeoutAndLeadingRef();
                };
                currentCallback.flush = flush;
                currentCallback.cancel = cancel;
                const resetLeadingState = ()=>{
                    clearTimeoutAndLeadingRef();
                };
                debounceTimerRef.current = window.setTimeout(resetLeadingState, delay);
                startMaxWaitTimer();
                return;
            }
            currentCallback._hasPendingCallback = true;
            const flush = ()=>{
                if (debounceTimerRef.current !== 0) {
                    clearTimeoutAndLeadingRef();
                    handleCallback(...args);
                }
            };
            const cancel = ()=>{
                clearTimeoutAndLeadingRef();
            };
            currentCallback.flush = flush;
            currentCallback.cancel = cancel;
            debounceTimerRef.current = window.setTimeout(flush, delay);
            startMaxWaitTimer();
        }, {
            flush: ()=>{},
            cancel: ()=>{},
            isPending: ()=>currentCallback._hasPendingCallback,
            _isFirstCall: true,
            _hasPendingCallback: false
        });
        return currentCallback;
    }, [
        handleCallback,
        delay,
        leading,
        maxWait
    ]);
    (0, $acw62.useEffect)(()=>()=>{
            if (flushOnUnmount) lastCallback.flush();
            else lastCallback.cancel();
        }, [
        lastCallback,
        flushOnUnmount
    ]);
    return lastCallback;
}



"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollAreaScrollbar/Scrollbar.tsx
function $3a6eef7319454adf$export$9a4e88b92edfce6b(props) {
    const { sizes: sizes, hasThumb: hasThumb, onThumbChange: onThumbChange, onThumbPointerUp: onThumbPointerUp, onThumbPointerDown: onThumbPointerDown, onThumbPositionChange: onThumbPositionChange, onDragScroll: onDragScroll, onWheelScroll: onWheelScroll, onResize: onResize, ref: ref, ...scrollbarProps } = props;
    const context = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const [scrollbar, setScrollbar] = (0, $acw62.useState)(null);
    const composeRefs = (0, $7034a45159125c0b$export$36a55fa7500f01f)(ref, setScrollbar);
    const rectRef = (0, $acw62.useRef)(null);
    const prevWebkitUserSelectRef = (0, $acw62.useRef)("");
    const { viewport: viewport } = context;
    const maxScrollPos = sizes.content - sizes.viewport;
    const handleWheelScroll = (0, $acw62.useEffectEvent)(onWheelScroll);
    const handleThumbPositionChange = (0, $9b08cecfd84e8161$export$25bec8c6f54ee79a)(onThumbPositionChange);
    const handleResize = (0, $4919278891a7db8a$export$e70e6da722faba05)(onResize, 10);
    const handleDragScroll = (event)=>{
        if (rectRef.current) onDragScroll({
            x: event.clientX - rectRef.current.left,
            y: event.clientY - rectRef.current.top
        });
    };
    (0, $acw62.useEffect)(()=>{
        const handleWheel = (event)=>{
            const element = event.target;
            if (scrollbar?.contains(element)) handleWheelScroll(event, maxScrollPos);
        };
        document.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return ()=>document.removeEventListener("wheel", handleWheel, {
                passive: false
            });
    }, [
        viewport,
        scrollbar,
        maxScrollPos
    ]);
    (0, $acw62.useEffect)(handleThumbPositionChange, [
        sizes,
        handleThumbPositionChange
    ]);
    (0, $132fa50acb2babc6$export$683480f191c0e3ea)(scrollbar, handleResize);
    (0, $132fa50acb2babc6$export$683480f191c0e3ea)(context.content, handleResize);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e66ab2864f33f4cb$export$9ab4af0f5675598e), {
        value: {
            scrollbar: scrollbar,
            hasThumb: hasThumb,
            onThumbChange: (0, $9b08cecfd84e8161$export$25bec8c6f54ee79a)(onThumbChange),
            onThumbPointerUp: (0, $9b08cecfd84e8161$export$25bec8c6f54ee79a)(onThumbPointerUp),
            onThumbPositionChange: handleThumbPositionChange,
            onThumbPointerDown: (0, $9b08cecfd84e8161$export$25bec8c6f54ee79a)(onThumbPointerDown)
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...scrollbarProps,
            ref: composeRefs,
            "data-mantine-scrollbar": true,
            style: {
                position: "absolute",
                ...scrollbarProps.style
            },
            onPointerDown: (0, $1c9ccee2f3ecd168$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
                event.preventDefault();
                if (event.button === 0) {
                    event.target.setPointerCapture(event.pointerId);
                    rectRef.current = scrollbar.getBoundingClientRect();
                    prevWebkitUserSelectRef.current = document.body.style.webkitUserSelect;
                    document.body.style.webkitUserSelect = "none";
                    handleDragScroll(event);
                }
            }),
            onPointerMove: (0, $1c9ccee2f3ecd168$export$b9ecd428b558ff10)(props.onPointerMove, handleDragScroll),
            onPointerUp: (0, $1c9ccee2f3ecd168$export$b9ecd428b558ff10)(props.onPointerUp, (event)=>{
                const element = event.target;
                if (element.hasPointerCapture(event.pointerId)) {
                    event.preventDefault();
                    element.releasePointerCapture(event.pointerId);
                }
            }),
            onLostPointerCapture: ()=>{
                document.body.style.webkitUserSelect = prevWebkitUserSelectRef.current;
                rectRef.current = null;
            }
        })
    });
}



var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollAreaScrollbar/ScrollbarX.tsx
const $a93a46694e11b218$export$5e2b1ec78aa559bf = (props)=>{
    const { sizes: sizes, onSizesChange: onSizesChange, style: style, ref: forwardedRef, ...others } = props;
    const ctx = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const [computedStyle, setComputedStyle] = (0, $acw62.useState)();
    const ref = (0, $acw62.useRef)(null);
    const composeRefs = (0, $7034a45159125c0b$export$36a55fa7500f01f)(forwardedRef, ref, ctx.onScrollbarXChange);
    (0, $acw62.useEffect)(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a6eef7319454adf$export$9a4e88b92edfce6b), {
        "data-orientation": "horizontal",
        ...others,
        ref: composeRefs,
        sizes: sizes,
        style: {
            ...style,
            ["--sa-thumb-width"]: `${(0, $ad769dbbdef0d7a6$export$7b14c3f3cc4d1eca)(sizes)}px`
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.x),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.x),
        onWheelScroll: (event, maxScrollPos)=>{
            if (ctx.viewport) {
                const scrollPos = ctx.viewport.scrollLeft + event.deltaX;
                props.onWheelScroll(scrollPos);
                if ((0, $3bc502b82e5dc37a$export$3dd2cb87ed130ea5)(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && ctx.viewport && computedStyle) onSizesChange({
                content: ctx.viewport.scrollWidth,
                viewport: ctx.viewport.offsetWidth,
                scrollbar: {
                    size: ref.current.clientWidth,
                    paddingStart: (0, $d6ccc87a85e73501$export$e7a1baa2fae31f0f)(computedStyle.paddingLeft),
                    paddingEnd: (0, $d6ccc87a85e73501$export$e7a1baa2fae31f0f)(computedStyle.paddingRight)
                }
            });
        }
    });
};
$a93a46694e11b218$export$5e2b1ec78aa559bf.displayName = "@mantine/core/ScrollAreaScrollbarX";








var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollAreaScrollbar/ScrollbarY.tsx
function $9a5b2de3367badec$export$e7c703d55d1ec9c0(props) {
    const { sizes: sizes, onSizesChange: onSizesChange, style: style, ref: forwardedRef, ...others } = props;
    const context = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const [computedStyle, setComputedStyle] = (0, $acw62.useState)();
    const ref = (0, $acw62.useRef)(null);
    const composeRefs = (0, $7034a45159125c0b$export$36a55fa7500f01f)(forwardedRef, ref, context.onScrollbarYChange);
    (0, $acw62.useEffect)(()=>{
        if (ref.current) setComputedStyle(window.getComputedStyle(ref.current));
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a6eef7319454adf$export$9a4e88b92edfce6b), {
        ...others,
        "data-orientation": "vertical",
        ref: composeRefs,
        sizes: sizes,
        style: {
            ["--sa-thumb-height"]: `${(0, $ad769dbbdef0d7a6$export$7b14c3f3cc4d1eca)(sizes)}px`,
            ...style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.y),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.y),
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollTop + event.deltaY;
                props.onWheelScroll(scrollPos);
                if ((0, $3bc502b82e5dc37a$export$3dd2cb87ed130ea5)(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollHeight,
                viewport: context.viewport.offsetHeight,
                scrollbar: {
                    size: ref.current.clientHeight,
                    paddingStart: (0, $d6ccc87a85e73501$export$e7a1baa2fae31f0f)(computedStyle.paddingTop),
                    paddingEnd: (0, $d6ccc87a85e73501$export$e7a1baa2fae31f0f)(computedStyle.paddingBottom)
                }
            });
        }
    });
}
$9a5b2de3367badec$export$e7c703d55d1ec9c0.displayName = "@mantine/core/ScrollAreaScrollbarY";



var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollAreaScrollbar/ScrollAreaScrollbarVisible.tsx
function $710585c028a94153$export$8be42cbd47985943(props) {
    const { orientation: orientation = "vertical", ...scrollbarProps } = props;
    const { dir: dir } = (0, $35c57ac18e24a61d$export$b39126d51d94e6f3)();
    const context = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const thumbRef = (0, $acw62.useRef)(null);
    const pointerOffsetRef = (0, $acw62.useRef)(0);
    const [sizes, setSizes] = (0, $acw62.useState)({
        content: 0,
        viewport: 0,
        scrollbar: {
            size: 0,
            paddingStart: 0,
            paddingEnd: 0
        }
    });
    const thumbRatio = (0, $e40829f322f41fa9$export$cf7769cb1c49cedf)(sizes.viewport, sizes.content);
    const commonProps = {
        ...scrollbarProps,
        sizes: sizes,
        onSizesChange: setSizes,
        hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
        onThumbChange: (thumb)=>{
            thumbRef.current = thumb;
        },
        onThumbPointerUp: ()=>{
            pointerOffsetRef.current = 0;
        },
        onThumbPointerDown: (pointerPos)=>{
            pointerOffsetRef.current = pointerPos;
        }
    };
    const getScrollPosition = (pointerPos, direction)=>(0, $33809556927fa4c1$export$8bf262e596ba0cb9)(pointerPos, pointerOffsetRef.current, sizes, direction);
    if (orientation === "horizontal") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93a46694e11b218$export$5e2b1ec78aa559bf), {
        ...commonProps,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollLeft;
                const offset = (0, $48a05505b367dbd3$export$ed4bbb745ec92b4f)(scrollPos, sizes, dir);
                thumbRef.current.style.transform = `translate3d(${offset}px, 0, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollLeft = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollLeft = getScrollPosition(pointerPos, dir);
        }
    });
    if (orientation === "vertical") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9a5b2de3367badec$export$e7c703d55d1ec9c0), {
        ...commonProps,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollTop;
                const offset = (0, $48a05505b367dbd3$export$ed4bbb745ec92b4f)(scrollPos, sizes);
                if (sizes.scrollbar.size === 0) thumbRef.current.style.setProperty("--thumb-opacity", "0");
                else thumbRef.current.style.setProperty("--thumb-opacity", "1");
                thumbRef.current.style.transform = `translate3d(0, ${offset}px, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollTop = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollTop = getScrollPosition(pointerPos);
        }
    });
    return null;
}
$710585c028a94153$export$8be42cbd47985943.displayName = "@mantine/core/ScrollAreaScrollbarVisible";






var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollAreaScrollbar/ScrollAreaScrollbarAuto.tsx
function $2cce3ee594976e59$export$122d1fc0e42a83be(props) {
    const context = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const [visible, setVisible] = (0, $acw62.useState)(false);
    const isHorizontal = props.orientation === "horizontal";
    const handleResize = (0, $4919278891a7db8a$export$e70e6da722faba05)(()=>{
        if (context.viewport) {
            const isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth;
            const isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
            setVisible(isHorizontal ? isOverflowX : isOverflowY);
        }
    }, 10);
    (0, $132fa50acb2babc6$export$683480f191c0e3ea)(context.viewport, handleResize);
    (0, $132fa50acb2babc6$export$683480f191c0e3ea)(context.content, handleResize);
    if (forceMount || visible) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $710585c028a94153$export$8be42cbd47985943), {
        "data-state": visible ? "visible" : "hidden",
        ...scrollbarProps
    });
    return null;
}
$2cce3ee594976e59$export$122d1fc0e42a83be.displayName = "@mantine/core/ScrollAreaScrollbarAuto";





var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollAreaScrollbar/ScrollAreaScrollbarHover.tsx
function $5500c318d003fdf6$export$76ee0a6492d8f1d0(props) {
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const context = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const [visible, setVisible] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const { scrollArea: scrollArea } = context;
        let hideTimer = 0;
        if (scrollArea) {
            const handlePointerEnter = ()=>{
                window.clearTimeout(hideTimer);
                setVisible(true);
            };
            const handlePointerLeave = ()=>{
                hideTimer = window.setTimeout(()=>setVisible(false), context.scrollHideDelay);
            };
            scrollArea.addEventListener("pointerenter", handlePointerEnter);
            scrollArea.addEventListener("pointerleave", handlePointerLeave);
            return ()=>{
                window.clearTimeout(hideTimer);
                scrollArea.removeEventListener("pointerenter", handlePointerEnter);
                scrollArea.removeEventListener("pointerleave", handlePointerLeave);
            };
        }
    }, [
        context.scrollArea,
        context.scrollHideDelay
    ]);
    if (forceMount || visible) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2cce3ee594976e59$export$122d1fc0e42a83be), {
        "data-state": visible ? "visible" : "hidden",
        ...scrollbarProps
    });
    return null;
}
$5500c318d003fdf6$export$76ee0a6492d8f1d0.displayName = "@mantine/core/ScrollAreaScrollbarHover";






var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollAreaScrollbar/ScrollAreaScrollbarScroll.tsx
function $203200efe7525cee$export$c35aa02e701a23ad(props) {
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const context = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const isHorizontal = props.orientation === "horizontal";
    const [state, setState] = (0, $acw62.useState)("hidden");
    const debounceScrollEnd = (0, $4919278891a7db8a$export$e70e6da722faba05)(()=>setState("idle"), 100);
    (0, $acw62.useEffect)(()=>{
        if (state === "idle") {
            const hideTimer = window.setTimeout(()=>setState("hidden"), context.scrollHideDelay);
            return ()=>window.clearTimeout(hideTimer);
        }
    }, [
        state,
        context.scrollHideDelay
    ]);
    (0, $acw62.useEffect)(()=>{
        const { viewport: viewport } = context;
        const scrollDirection = isHorizontal ? "scrollLeft" : "scrollTop";
        if (viewport) {
            let prevScrollPos = viewport[scrollDirection];
            const handleScroll = ()=>{
                const scrollPos = viewport[scrollDirection];
                if (prevScrollPos !== scrollPos) {
                    setState("scrolling");
                    debounceScrollEnd();
                }
                prevScrollPos = scrollPos;
            };
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        context.viewport,
        isHorizontal,
        debounceScrollEnd
    ]);
    if (forceMount || state !== "hidden") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $710585c028a94153$export$8be42cbd47985943), {
        "data-state": state === "hidden" ? "hidden" : "visible",
        ...scrollbarProps,
        onPointerEnter: (0, $1c9ccee2f3ecd168$export$b9ecd428b558ff10)(props.onPointerEnter, ()=>setState("interacting")),
        onPointerLeave: (0, $1c9ccee2f3ecd168$export$b9ecd428b558ff10)(props.onPointerLeave, ()=>setState("idle"))
    });
    return null;
}



var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollAreaScrollbar/ScrollAreaScrollbar.tsx
function $11b5067cafb406ae$export$2fabd85d0eba3c57(props) {
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const context = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const { onScrollbarXEnabledChange: onScrollbarXEnabledChange, onScrollbarYEnabledChange: onScrollbarYEnabledChange } = context;
    const isHorizontal = props.orientation === "horizontal";
    (0, $acw62.useEffect)(()=>{
        isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
        return ()=>{
            isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
        };
    }, [
        isHorizontal,
        onScrollbarXEnabledChange,
        onScrollbarYEnabledChange
    ]);
    return context.type === "hover" ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $5500c318d003fdf6$export$76ee0a6492d8f1d0), {
        ...scrollbarProps,
        forceMount: forceMount
    }) : context.type === "scroll" ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $203200efe7525cee$export$c35aa02e701a23ad), {
        ...scrollbarProps,
        forceMount: forceMount
    }) : context.type === "auto" ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2cce3ee594976e59$export$122d1fc0e42a83be), {
        ...scrollbarProps,
        forceMount: forceMount
    }) : context.type === "always" ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $710585c028a94153$export$8be42cbd47985943), {
        ...scrollbarProps
    }) : null;
}
$11b5067cafb406ae$export$2fabd85d0eba3c57.displayName = "@mantine/core/ScrollAreaScrollbar";




"use client";
//#region packages/@mantine/core/src/components/ScrollArea/utils/add-unlinked-scroll-listener.tsx
function $0be43da0068dce4d$export$7a2fcd0d3a006438(node, handler = ()=>{}) {
    let prevPosition = {
        left: node.scrollLeft,
        top: node.scrollTop
    };
    let rAF = 0;
    (function loop() {
        const position = {
            left: node.scrollLeft,
            top: node.scrollTop
        };
        const isHorizontalScroll = prevPosition.left !== position.left;
        const isVerticalScroll = prevPosition.top !== position.top;
        if (isHorizontalScroll || isVerticalScroll) handler();
        prevPosition = position;
        rAF = window.requestAnimationFrame(loop);
    })();
    return ()=>window.cancelAnimationFrame(rAF);
}




var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollAreaThumb/ScrollAreaThumb.tsx
function $81f0525478ce18ce$var$Thumb(props) {
    const { style: style, ref: forwardedRef, ...others } = props;
    const scrollAreaContext = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const scrollbarContext = (0, $e66ab2864f33f4cb$export$9eae1e0809562d06)();
    const { onThumbPositionChange: onThumbPositionChange } = scrollbarContext;
    const composedRef = (0, $7034a45159125c0b$export$36a55fa7500f01f)(forwardedRef, scrollbarContext.onThumbChange);
    const removeUnlinkedScrollListenerRef = (0, $acw62.useRef)(void 0);
    const debounceScrollEnd = (0, $4919278891a7db8a$export$e70e6da722faba05)(()=>{
        if (removeUnlinkedScrollListenerRef.current) {
            removeUnlinkedScrollListenerRef.current();
            removeUnlinkedScrollListenerRef.current = void 0;
        }
    }, 100);
    (0, $acw62.useEffect)(()=>{
        const { viewport: viewport } = scrollAreaContext;
        if (viewport) {
            const handleScroll = ()=>{
                debounceScrollEnd();
                if (!removeUnlinkedScrollListenerRef.current) {
                    removeUnlinkedScrollListenerRef.current = (0, $0be43da0068dce4d$export$7a2fcd0d3a006438)(viewport, onThumbPositionChange);
                    onThumbPositionChange();
                }
            };
            onThumbPositionChange();
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        scrollAreaContext.viewport,
        debounceScrollEnd,
        onThumbPositionChange
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-state": scrollbarContext.hasThumb ? "visible" : "hidden",
        ...others,
        ref: composedRef,
        style: {
            width: "var(--sa-thumb-width)",
            height: "var(--sa-thumb-height)",
            ...style
        },
        onPointerDownCapture: (0, $1c9ccee2f3ecd168$export$b9ecd428b558ff10)(props.onPointerDownCapture, (event)=>{
            const thumbRect = event.target.getBoundingClientRect();
            const x = event.clientX - thumbRect.left;
            const y = event.clientY - thumbRect.top;
            scrollbarContext.onThumbPointerDown({
                x: x,
                y: y
            });
        }),
        onPointerUp: (0, $1c9ccee2f3ecd168$export$b9ecd428b558ff10)(props.onPointerUp, scrollbarContext.onThumbPointerUp)
    });
}
$81f0525478ce18ce$var$Thumb.displayName = "@mantine/core/ScrollAreaThumb";
function $81f0525478ce18ce$export$9fba1154677d7cd2(props) {
    const { forceMount: forceMount, ...thumbProps } = props;
    const scrollbarContext = (0, $e66ab2864f33f4cb$export$9eae1e0809562d06)();
    if (forceMount || scrollbarContext.hasThumb) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($81f0525478ce18ce$var$Thumb, {
        ...thumbProps
    });
    return null;
}
$81f0525478ce18ce$export$9fba1154677d7cd2.displayName = "@mantine/core/ScrollAreaThumb";






"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollAreaViewport/ScrollAreaViewport.tsx
function $6cec10d0bcac6dc0$export$a21cbf9f11fca853({ children: children, style: style, ref: ref, onWheel: onWheel, ...others }) {
    const ctx = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const rootRef = (0, $7034a45159125c0b$export$36a55fa7500f01f)(ref, ctx.onViewportChange);
    const handleWheel = (event)=>{
        onWheel?.(event);
        if (ctx.scrollbarXEnabled && ctx.viewport && event.shiftKey) {
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight, scrollWidth: scrollWidth, clientWidth: clientWidth } = ctx.viewport;
            const isAtTop = scrollTop < 1;
            const isAtBottom = scrollTop >= scrollHeight - clientHeight - 1;
            if (scrollWidth > clientWidth && (isAtTop || isAtBottom)) event.stopPropagation();
        }
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...others,
        ref: rootRef,
        onWheel: handleWheel,
        "data-scrollarea-viewport": true,
        style: {
            overflowX: ctx.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: ctx.scrollbarYEnabled ? "scroll" : "hidden",
            ...style
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...ctx.getStyles("content"),
            ref: ctx.onContentChange,
            children: children
        })
    });
}
$6cec10d0bcac6dc0$export$a21cbf9f11fca853.displayName = "@mantine/core/ScrollAreaViewport";


"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollArea.module.css
var $580479a53fd6266c$export$2e2bcd8739ae039 = {
    "root": "m_d57069b5",
    "content": "m_b1336c6",
    "viewport": "m_c0783ff9",
    "viewportInner": "m_f8f631dd",
    "scrollbar": "m_c44ba933",
    "thumb": "m_d8b5e363",
    "corner": "m_21657268"
};



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $c51400d9a81fca36$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $c51400d9a81fca36$export$651544f548703224(node) {
    if ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $c51400d9a81fca36$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $c51400d9a81fca36$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $c51400d9a81fca36$export$8ee0fc9ee280b4ee(value) {
    if (!$c51400d9a81fca36$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Node;
}
function $c51400d9a81fca36$export$45a5e7f76e0caa8d(value) {
    if (!$c51400d9a81fca36$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Element;
}
function $c51400d9a81fca36$export$1b3bfaa9684536aa(value) {
    if (!$c51400d9a81fca36$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).HTMLElement;
}
function $c51400d9a81fca36$export$af51f0f06c0f328a(value) {
    if (!$c51400d9a81fca36$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $c51400d9a81fca36$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $c51400d9a81fca36$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $c51400d9a81fca36$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($c51400d9a81fca36$export$651544f548703224(element));
}
function $c51400d9a81fca36$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $c51400d9a81fca36$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $c51400d9a81fca36$var$containRe = /paint|layout|strict|content/;
const $c51400d9a81fca36$var$isNotNone = (value)=>!!value && value !== 'none';
let $c51400d9a81fca36$var$isWebKitValue;
function $c51400d9a81fca36$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $c51400d9a81fca36$export$45a5e7f76e0caa8d(elementOrCss) ? $c51400d9a81fca36$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $c51400d9a81fca36$var$isNotNone(css.transform) || $c51400d9a81fca36$var$isNotNone(css.translate) || $c51400d9a81fca36$var$isNotNone(css.scale) || $c51400d9a81fca36$var$isNotNone(css.rotate) || $c51400d9a81fca36$var$isNotNone(css.perspective) || !$c51400d9a81fca36$export$78551043582a6a98() && ($c51400d9a81fca36$var$isNotNone(css.backdropFilter) || $c51400d9a81fca36$var$isNotNone(css.filter)) || $c51400d9a81fca36$var$willChangeRe.test(css.willChange || '') || $c51400d9a81fca36$var$containRe.test(css.contain || '');
}
function $c51400d9a81fca36$export$940d8225183e1404(element) {
    let currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(element);
    while($c51400d9a81fca36$export$1b3bfaa9684536aa(currentNode) && !$c51400d9a81fca36$export$d1162fb0b6d4cd51(currentNode)){
        if ($c51400d9a81fca36$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($c51400d9a81fca36$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $c51400d9a81fca36$export$78551043582a6a98() {
    if ($c51400d9a81fca36$var$isWebKitValue == null) $c51400d9a81fca36$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $c51400d9a81fca36$var$isWebKitValue;
}
function $c51400d9a81fca36$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($c51400d9a81fca36$export$651544f548703224(node));
}
function $c51400d9a81fca36$export$3735103072e4a80(element) {
    return $c51400d9a81fca36$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $c51400d9a81fca36$export$dc8fc79fa2800137(element) {
    if ($c51400d9a81fca36$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $c51400d9a81fca36$export$4e12058fc4d51d56(node) {
    if ($c51400d9a81fca36$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $c51400d9a81fca36$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $c51400d9a81fca36$export$e495491855dc5418(node);
    return $c51400d9a81fca36$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $c51400d9a81fca36$export$7cd01a57c8ca906c(node) {
    const parentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(node);
    if ($c51400d9a81fca36$export$d1162fb0b6d4cd51(parentNode)) return (node.ownerDocument || node).body;
    if ($c51400d9a81fca36$export$1b3bfaa9684536aa(parentNode) && $c51400d9a81fca36$export$989e911fa9af580a(parentNode)) return parentNode;
    return $c51400d9a81fca36$export$7cd01a57c8ca906c(parentNode);
}
function $c51400d9a81fca36$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $c51400d9a81fca36$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $c51400d9a81fca36$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $c51400d9a81fca36$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $c51400d9a81fca36$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $c51400d9a81fca36$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $c51400d9a81fca36$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $c51400d9a81fca36$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}



var $acw62 = parcelRequire("acw62");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $204931a4986f463b$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $204931a4986f463b$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $204931a4986f463b$export$803cd8101b6c182b = /*#__PURE__*/ $204931a4986f463b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[0], side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[1]), []);
const $204931a4986f463b$export$96ec731ed4dcb222 = Math.min;
const $204931a4986f463b$export$8960430cfd85939f = Math.max;
const $204931a4986f463b$export$2077e0241d6afd3c = Math.round;
const $204931a4986f463b$export$a3fe094919f356fd = Math.floor;
const $204931a4986f463b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $204931a4986f463b$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $204931a4986f463b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $204931a4986f463b$export$8960430cfd85939f(start, $204931a4986f463b$export$96ec731ed4dcb222(value, end));
}
function $204931a4986f463b$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $204931a4986f463b$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $204931a4986f463b$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $204931a4986f463b$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $204931a4986f463b$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $204931a4986f463b$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $204931a4986f463b$export$2b57e0052a6d6d4c(placement) {
    return $204931a4986f463b$export$8a000a963141ac32($204931a4986f463b$export$f28e8f882010718a(placement));
}
function $204931a4986f463b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $204931a4986f463b$export$2b57e0052a6d6d4c(placement);
    const length = $204931a4986f463b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $204931a4986f463b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $204931a4986f463b$export$9c5e28bad23365fa(placement);
    return [
        $204931a4986f463b$export$2b182c584985588b(placement),
        oppositePlacement,
        $204931a4986f463b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $204931a4986f463b$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $204931a4986f463b$var$lrPlacement = [
    'left',
    'right'
];
const $204931a4986f463b$var$rlPlacement = [
    'right',
    'left'
];
const $204931a4986f463b$var$tbPlacement = [
    'top',
    'bottom'
];
const $204931a4986f463b$var$btPlacement = [
    'bottom',
    'top'
];
function $204931a4986f463b$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $204931a4986f463b$var$rlPlacement : $204931a4986f463b$var$lrPlacement;
            return isStart ? $204931a4986f463b$var$lrPlacement : $204931a4986f463b$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $204931a4986f463b$var$tbPlacement : $204931a4986f463b$var$btPlacement;
        default:
            return [];
    }
}
function $204931a4986f463b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    let list = $204931a4986f463b$var$getSideList($204931a4986f463b$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($204931a4986f463b$export$2b182c584985588b));
    }
    return list;
}
function $204931a4986f463b$export$9c5e28bad23365fa(placement) {
    const side = $204931a4986f463b$export$3c915306cb7fc97a(placement);
    return $204931a4986f463b$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $204931a4986f463b$export$1c66dbf1a9e34223(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function $204931a4986f463b$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $204931a4986f463b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $204931a4986f463b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


/*!
* tabbable 6.5.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
var $a4b3b7902c9a987d$var$candidateSelectors = [
    'input:not([inert]):not([inert] *)',
    'select:not([inert]):not([inert] *)',
    'textarea:not([inert]):not([inert] *)',
    'a[href]:not([inert]):not([inert] *)',
    'area[href]:not([inert]):not([inert] *)',
    'button:not([inert]):not([inert] *)',
    '[tabindex]:not(slot):not([inert]):not([inert] *)',
    'audio[controls]:not([inert]):not([inert] *)',
    'video[controls]:not([inert]):not([inert] *)',
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    'details>summary:first-of-type:not([inert]):not([inert] *)',
    'details:not([inert]):not([inert] *)'
];
var $a4b3b7902c9a987d$var$candidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.join(',');
var $a4b3b7902c9a987d$var$NoElement = typeof Element === 'undefined';
var $a4b3b7902c9a987d$var$matches = $a4b3b7902c9a987d$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $a4b3b7902c9a987d$var$getRootNode = !$a4b3b7902c9a987d$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Node} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $a4b3b7902c9a987d$var$_isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === 'function' ? node.closest('[inert]') : $a4b3b7902c9a987d$var$_isInert(node.parentNode));
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $a4b3b7902c9a987d$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert (either by itself or via its parent), then all its children are inert
    if ($a4b3b7902c9a987d$var$_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($a4b3b7902c9a987d$var$candidateSelector));
    if (includeContainer && $a4b3b7902c9a987d$var$matches.call(el, $a4b3b7902c9a987d$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $a4b3b7902c9a987d$var$_getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($a4b3b7902c9a987d$var$_isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = $a4b3b7902c9a987d$var$_getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $a4b3b7902c9a987d$var$matches.call(element, $a4b3b7902c9a987d$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$a4b3b7902c9a987d$var$_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = $a4b3b7902c9a987d$var$_getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $a4b3b7902c9a987d$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $a4b3b7902c9a987d$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $a4b3b7902c9a987d$var$isContentEditable(node)) && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $a4b3b7902c9a987d$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $a4b3b7902c9a987d$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $a4b3b7902c9a987d$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $a4b3b7902c9a987d$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $a4b3b7902c9a987d$var$isHiddenInput = function isHiddenInput(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === 'hidden';
};
var $a4b3b7902c9a987d$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $a4b3b7902c9a987d$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $a4b3b7902c9a987d$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $a4b3b7902c9a987d$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $a4b3b7902c9a987d$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $a4b3b7902c9a987d$var$isRadio = function isRadio(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === 'radio';
};
var $a4b3b7902c9a987d$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $a4b3b7902c9a987d$var$isRadio(node) && !$a4b3b7902c9a987d$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $a4b3b7902c9a987d$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $a4b3b7902c9a987d$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $a4b3b7902c9a987d$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $a4b3b7902c9a987d$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $a4b3b7902c9a987d$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === 'full-native') {
        if ('checkVisibility' in node) {
            // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    var _getComputedStyle = getComputedStyle(node), visibility = _getComputedStyle.visibility;
    if (visibility === 'hidden' || visibility === 'collapse') return true;
    var isDirectSummary = $a4b3b7902c9a987d$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($a4b3b7902c9a987d$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === 'full-native' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $a4b3b7902c9a987d$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $a4b3b7902c9a987d$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($a4b3b7902c9a987d$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $a4b3b7902c9a987d$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $a4b3b7902c9a987d$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $a4b3b7902c9a987d$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || $a4b3b7902c9a987d$var$isHiddenInput(node) || $a4b3b7902c9a987d$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $a4b3b7902c9a987d$var$isDetailsWithSummary(node) || $a4b3b7902c9a987d$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($a4b3b7902c9a987d$var$isNonTabbableRadio(node) || $a4b3b7902c9a987d$export$a4672efddb4181b8(node) < 0 || !$a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $a4b3b7902c9a987d$var$_sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $a4b3b7902c9a987d$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? $a4b3b7902c9a987d$var$_sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($a4b3b7902c9a987d$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $a4b3b7902c9a987d$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $a4b3b7902c9a987d$var$isShadowRootTabbable
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $a4b3b7902c9a987d$var$_sortByOrder(candidates);
};
var $a4b3b7902c9a987d$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $a4b3b7902c9a987d$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$candidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable(options, node);
};
var $a4b3b7902c9a987d$var$focusableCandidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.concat('iframe:not([inert]):not([inert] *)').join(',');
var $a4b3b7902c9a987d$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$focusableCandidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node);
};


// Avoid Chrome DevTools blue warning.
function $85ea27aada64f9e6$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $85ea27aada64f9e6$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
function $85ea27aada64f9e6$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $85ea27aada64f9e6$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($85ea27aada64f9e6$export$867a782338812cb4()) || re.test($85ea27aada64f9e6$export$7935961ef7719cb0());
}
function $85ea27aada64f9e6$export$9ac100e40613ea10() {
    return $85ea27aada64f9e6$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $85ea27aada64f9e6$export$c8f880a2d81914c4() {
    return $85ea27aada64f9e6$export$7935961ef7719cb0().includes('jsdom/');
}
const $85ea27aada64f9e6$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const $85ea27aada64f9e6$var$TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
const $85ea27aada64f9e6$var$ARROW_LEFT = 'ArrowLeft';
const $85ea27aada64f9e6$var$ARROW_RIGHT = 'ArrowRight';
const $85ea27aada64f9e6$var$ARROW_UP = 'ArrowUp';
const $85ea27aada64f9e6$var$ARROW_DOWN = 'ArrowDown';
function $85ea27aada64f9e6$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $85ea27aada64f9e6$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $c51400d9a81fca36$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $85ea27aada64f9e6$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $85ea27aada64f9e6$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $85ea27aada64f9e6$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $85ea27aada64f9e6$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $85ea27aada64f9e6$export$42ad131c32f0fb8d(element) {
    return (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) && element.matches($85ea27aada64f9e6$var$TYPEABLE_SELECTOR);
}
function $85ea27aada64f9e6$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $85ea27aada64f9e6$export$42ad131c32f0fb8d(element);
}
function $85ea27aada64f9e6$export$65750043c2fb2f40(element) {
    // We don't want to block focus from working with `visibleOnly`
    // (JSDOM doesn't match `:focus-visible` when the element has `:focus`)
    if (!element || $85ea27aada64f9e6$export$c8f880a2d81914c4()) return true;
    try {
        return element.matches(':focus-visible');
    } catch (_e) {
        return true;
    }
}
function $85ea27aada64f9e6$export$9b0901b5e9b45fc7(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($85ea27aada64f9e6$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $85ea27aada64f9e6$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
function $85ea27aada64f9e6$export$1f1998cc3c6b56fb(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...$85ea27aada64f9e6$export$1f1998cc3c6b56fb(nodes, child.id, onlyOpenChildren)
        ]);
}
function $85ea27aada64f9e6$export$e7e88d43cb97db79(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $85ea27aada64f9e6$export$1f1998cc3c6b56fb(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
function $85ea27aada64f9e6$export$5d8eb345316b65c0(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $85ea27aada64f9e6$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $85ea27aada64f9e6$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $85ea27aada64f9e6$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($85ea27aada64f9e6$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $85ea27aada64f9e6$export$29bf1b5f2c56cf63(event) {
    if ($85ea27aada64f9e6$export$c8f880a2d81914c4()) return false;
    return !$85ea27aada64f9e6$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $85ea27aada64f9e6$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $85ea27aada64f9e6$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
var $85ea27aada64f9e6$var$isClient = typeof document !== 'undefined';
var $85ea27aada64f9e6$var$noop = function noop() {};
var $85ea27aada64f9e6$export$bb3b3b3acfd7447f = $85ea27aada64f9e6$var$isClient ? (0, $acw62.useLayoutEffect) : $85ea27aada64f9e6$var$noop;
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $85ea27aada64f9e6$var$SafeReact = {
    ...$acw62
};
function $85ea27aada64f9e6$export$bcd07ba85a740103(value) {
    const ref = $acw62.useRef(value);
    $85ea27aada64f9e6$export$bb3b3b3acfd7447f(()=>{
        ref.current = value;
    });
    return ref;
}
const $85ea27aada64f9e6$var$useInsertionEffect = $85ea27aada64f9e6$var$SafeReact.useInsertionEffect;
const $85ea27aada64f9e6$var$useSafeInsertionEffect = $85ea27aada64f9e6$var$useInsertionEffect || ((fn)=>fn());
function $85ea27aada64f9e6$export$7f54fc3180508a52(callback) {
    const ref = $acw62.useRef(()=>{});
    $85ea27aada64f9e6$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $acw62.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
function $85ea27aada64f9e6$export$709046525cac3019(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $85ea27aada64f9e6$export$75effb89758ec596(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $85ea27aada64f9e6$export$53f691ee0acc6058(listRef, disabledIndices) {
    return $85ea27aada64f9e6$export$3fc3ea4a67cf714(listRef, {
        disabledIndices: disabledIndices
    });
}
function $85ea27aada64f9e6$export$b585558af466e926(listRef, disabledIndices) {
    return $85ea27aada64f9e6$export$3fc3ea4a67cf714(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $85ea27aada64f9e6$export$3fc3ea4a67cf714(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= listRef.current.length - 1 && $85ea27aada64f9e6$export$446656ed0410fd9(listRef, index, disabledIndices));
    return index;
}
function $85ea27aada64f9e6$export$342fcce33a2688bc(listRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $85ea27aada64f9e6$var$ARROW_UP) {
        stop && $85ea27aada64f9e6$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $85ea27aada64f9e6$export$3fc3ea4a67cf714(listRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($85ea27aada64f9e6$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $85ea27aada64f9e6$var$ARROW_DOWN) {
        stop && $85ea27aada64f9e6$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $85ea27aada64f9e6$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $85ea27aada64f9e6$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($85ea27aada64f9e6$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $204931a4986f463b$export$a3fe094919f356fd)(prevIndex / cols);
        if (event.key === (rtl ? $85ea27aada64f9e6$var$ARROW_LEFT : $85ea27aada64f9e6$var$ARROW_RIGHT)) {
            stop && $85ea27aada64f9e6$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $85ea27aada64f9e6$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $85ea27aada64f9e6$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $85ea27aada64f9e6$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $85ea27aada64f9e6$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($85ea27aada64f9e6$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $85ea27aada64f9e6$var$ARROW_RIGHT : $85ea27aada64f9e6$var$ARROW_LEFT)) {
            stop && $85ea27aada64f9e6$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $85ea27aada64f9e6$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $85ea27aada64f9e6$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $85ea27aada64f9e6$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $85ea27aada64f9e6$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($85ea27aada64f9e6$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $204931a4986f463b$export$a3fe094919f356fd)(maxIndex / cols) === prevRow;
        if ($85ea27aada64f9e6$export$75effb89758ec596(listRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $85ea27aada64f9e6$var$ARROW_RIGHT : $85ea27aada64f9e6$var$ARROW_LEFT) ? maxIndex : $85ea27aada64f9e6$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $85ea27aada64f9e6$export$5334c96856356f08(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $85ea27aada64f9e6$export$dab2b2ce7761f8e4(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $85ea27aada64f9e6$export$50d8709b2ccc23f9(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $85ea27aada64f9e6$export$446656ed0410fd9(listRef, index, disabledIndices) {
    if (typeof disabledIndices === 'function') return disabledIndices(index);
    else if (disabledIndices) return disabledIndices.includes(index);
    const element = listRef.current[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
const $85ea27aada64f9e6$export$6324a2bbae6a332f = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $85ea27aada64f9e6$var$getTabbableIn(container, dir) {
    const list = (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(container, $85ea27aada64f9e6$export$6324a2bbae6a332f());
    const len = list.length;
    if (len === 0) return;
    const active = $85ea27aada64f9e6$export$da980962bd2147a4($85ea27aada64f9e6$export$f65ca476c09acec0(container));
    const index = list.indexOf(active);
    const nextIndex = index === -1 ? dir === 1 ? 0 : len - 1 : index + dir;
    return list[nextIndex];
}
function $85ea27aada64f9e6$export$28f33206776129a7(referenceElement) {
    return $85ea27aada64f9e6$var$getTabbableIn($85ea27aada64f9e6$export$f65ca476c09acec0(referenceElement).body, 1) || referenceElement;
}
function $85ea27aada64f9e6$export$2e5518c3303f364a(referenceElement) {
    return $85ea27aada64f9e6$var$getTabbableIn($85ea27aada64f9e6$export$f65ca476c09acec0(referenceElement).body, -1) || referenceElement;
}
function $85ea27aada64f9e6$export$6e0c4e272f3faa2(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !$85ea27aada64f9e6$export$2344b14b097df817(containerElement, relatedTarget);
}
function $85ea27aada64f9e6$export$3995dd353b80da11(container) {
    const tabbableElements = (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(container, $85ea27aada64f9e6$export$6324a2bbae6a332f());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $85ea27aada64f9e6$export$a65f4028abb17f36(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}






var $1u0KT = parcelRequire("1u0KT");

function $9dccb9a8753b0e86$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $204931a4986f463b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) && await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $9dccb9a8753b0e86$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9dccb9a8753b0e86$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $9dccb9a8753b0e86$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $9dccb9a8753b0e86$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9dccb9a8753b0e86$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $204931a4986f463b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(minPadding, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $9dccb9a8753b0e86$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $204931a4986f463b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9dccb9a8753b0e86$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $204931a4986f463b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $204931a4986f463b$export$803cd8101b6c182b) ? $9dccb9a8753b0e86$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const alignmentSides = (0, $204931a4986f463b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            const currentOverflows = [
                overflow[(0, $204931a4986f463b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $204931a4986f463b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9dccb9a8753b0e86$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $204931a4986f463b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $204931a4986f463b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $204931a4986f463b$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $204931a4986f463b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $204931a4986f463b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $204931a4986f463b$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $204931a4986f463b$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9dccb9a8753b0e86$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9dccb9a8753b0e86$var$isAnySideFullyClipped(overflow) {
    return (0, $204931a4986f463b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9dccb9a8753b0e86$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9dccb9a8753b0e86$var$getBoundingRect(rects) {
    const minX = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9dccb9a8753b0e86$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9dccb9a8753b0e86$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
            // keep the existing reference rect rather than resetting to an invalid
            // one with non-finite values.
            if (!nativeClientRects.length) return {};
            const clientRects = $9dccb9a8753b0e86$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $204931a4986f463b$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        return (0, $204931a4986f463b$export$ee05aea0aeecbad4)({
                            x: left,
                            y: top,
                            width: right - left,
                            height: bottom - top
                        });
                    }
                    const isLeftSide = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $204931a4986f463b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)({
                        x: minLeft,
                        y: top,
                        width: maxRight - minLeft,
                        height: bottom - top
                    });
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $9dccb9a8753b0e86$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9dccb9a8753b0e86$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $9dccb9a8753b0e86$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9dccb9a8753b0e86$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $9dccb9a8753b0e86$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9dccb9a8753b0e86$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const clampCoord = (axis, coord)=>(0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9dccb9a8753b0e86$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $204931a4986f463b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $9dccb9a8753b0e86$var$originSides.has((0, $204931a4986f463b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9dccb9a8753b0e86$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $204931a4986f463b$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $204931a4986f463b$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const shiftData = state.middlewareData.shift;
            const noShift = !shiftData;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                if (isYAxis) availableWidth = width - 2 * (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.left, overflow.right);
                else availableHeight = height - 2 * (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.top, overflow.bottom);
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};




function $bede215d88ec3aee$var$getCssDimensions(element) {
    const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $204931a4986f463b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $204931a4986f463b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bede215d88ec3aee$var$unwrapElement(element) {
    return !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $bede215d88ec3aee$var$getScale(element) {
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(domElement)) return (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bede215d88ec3aee$var$getCssDimensions(domElement);
    let x = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bede215d88ec3aee$var$noOffsets = /*#__PURE__*/ (0, $204931a4986f463b$export$a397704b5e280835)(0);
function $bede215d88ec3aee$var$getVisualOffsets(element) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if (!(0, $c51400d9a81fca36$export$78551043582a6a98)() || !win.visualViewport) return $bede215d88ec3aee$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bede215d88ec3aee$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
}
function $bede215d88ec3aee$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent)) scale = $bede215d88ec3aee$var$getScale(offsetParent);
        } else scale = $bede215d88ec3aee$var$getScale(element);
    }
    const visualOffsets = $bede215d88ec3aee$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bede215d88ec3aee$var$getVisualOffsets(domElement) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement && offsetParent) {
        const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(domElement);
        const offsetWin = (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $c51400d9a81fca36$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetWin !== currentWin){
            const iframeScale = $bede215d88ec3aee$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $c51400d9a81fca36$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $bede215d88ec3aee$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $bede215d88ec3aee$var$getBoundingClientRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $bede215d88ec3aee$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $bede215d88ec3aee$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $c51400d9a81fca36$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== 'body' || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent);
            scale = $bede215d88ec3aee$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bede215d88ec3aee$var$getHTMLOffset(documentElement, scroll) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $bede215d88ec3aee$var$getClientRects(element) {
    return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bede215d88ec3aee$var$getDocumentRect(html) {
    const scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(html);
    const body = html.ownerDocument.body;
    const width = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bede215d88ec3aee$var$getWindowScrollBarX(html);
    const y = -scroll.scrollTop;
    if ((0, $c51400d9a81fca36$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $204931a4986f463b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $bede215d88ec3aee$var$SCROLLBAR_MAX = 25;
function $bede215d88ec3aee$var$getViewportRect(element, strategy, rootBoundary) {
    if (rootBoundary === void 0) rootBoundary = 'viewport';
    const isLayoutViewport = rootBoundary === 'layoutViewport';
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    const html = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        // Client coordinates are relative to the layout viewport, except in
        // WebKit with an `absolute` strategy, where they are relative to the
        // visual viewport.
        const layoutRelativeClientCoords = !(0, $c51400d9a81fca36$export$78551043582a6a98)() || strategy === 'fixed';
        if (isLayoutViewport) {
            if (!layoutRelativeClientCoords) {
                x = -visualViewport.offsetLeft;
                y = -visualViewport.offsetTop;
            }
        } else {
            width = visualViewport.width;
            height = visualViewport.height;
            if (layoutRelativeClientCoords) {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
    }
    const windowScrollbarX = $bede215d88ec3aee$var$getWindowScrollBarX(html);
    // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
    // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
    // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
    // reserves an empty inline-start gutter that clips nothing, so exclude just
    // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
    // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
    // `getHTMLOffset`/`visualViewport.width`; skip it here.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        const gutter = getComputedStyle(html).scrollbarGutter === 'stable both-edges' ? reservedWidth / 2 : reservedWidth;
        if (gutter <= $bede215d88ec3aee$var$SCROLLBAR_MAX) width -= gutter;
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $bede215d88ec3aee$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $bede215d88ec3aee$var$getScale(element);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport' || clippingAncestor === 'layoutViewport') rect = $bede215d88ec3aee$var$getViewportRect(element, strategy, clippingAncestor);
    else if (clippingAncestor === 'document') rect = $bede215d88ec3aee$var$getDocumentRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element));
    else if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $bede215d88ec3aee$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bede215d88ec3aee$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)(rect);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bede215d88ec3aee$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $c51400d9a81fca36$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(el) && (0, $c51400d9a81fca36$export$651544f548703224)(el) !== 'body');
    let lastKeptComputedStyle = null;
    const elementIsFixed = (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(currentNode) && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(currentNode);
        // Position of the containing block chain below the current node. A fixed
        // element whose containing block hasn't been found yet is a fixed chain.
        const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? 'fixed' : '';
        // A non-containing ancestor does not clip the element when the chain
        // below it escapes it: a fixed chain escapes all ancestors up to the
        // next containing block, an absolute chain escapes static ancestors.
        const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === 'fixed' || lastPosition === 'absolute' && computedStyle.position === 'static');
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // The kept node carries the chain position for the next iteration.
        lastKeptComputedStyle = computedStyle;
        currentNode = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bede215d88ec3aee$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $c51400d9a81fca36$export$89e651af02346cd4)(element) ? [] : $bede215d88ec3aee$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.top, top);
        right = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $bede215d88ec3aee$var$getDimensions(element) {
    const { width: width, height: height } = $bede215d88ec3aee$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bede215d88ec3aee$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== 'body' || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    if (!isOffsetParentAnElement && documentElement) offsets.x = $bede215d88ec3aee$var$getWindowScrollBarX(documentElement);
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bede215d88ec3aee$var$getHTMLOffset(documentElement, scroll) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bede215d88ec3aee$var$isStaticPositioned(element) {
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === 'static';
}
function $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) || (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $c51400d9a81fca36$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bede215d88ec3aee$var$getOffsetParent(element, polyfill) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if ((0, $c51400d9a81fca36$export$89e651af02346cd4)(element)) return win;
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$bede215d88ec3aee$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $c51400d9a81fca36$export$71535ffaa902797f)(offsetParent) && $bede215d88ec3aee$var$isStaticPositioned(offsetParent))offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(offsetParent) && $bede215d88ec3aee$var$isStaticPositioned(offsetParent) && !(0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $c51400d9a81fca36$export$940d8225183e1404)(element) || win;
}
const $bede215d88ec3aee$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bede215d88ec3aee$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $bede215d88ec3aee$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $bede215d88ec3aee$var$isRTL(element) {
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(element).direction === 'rtl';
}
const $bede215d88ec3aee$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $c51400d9a81fca36$export$e495491855dc5418,
    getClippingRect: $bede215d88ec3aee$var$getClippingRect,
    getOffsetParent: $bede215d88ec3aee$var$getOffsetParent,
    getElementRects: $bede215d88ec3aee$var$getElementRects,
    getClientRects: $bede215d88ec3aee$var$getClientRects,
    getDimensions: $bede215d88ec3aee$var$getDimensions,
    getScale: $bede215d88ec3aee$var$getScale,
    isElement: $c51400d9a81fca36$export$45a5e7f76e0caa8d,
    isRTL: $bede215d88ec3aee$var$isRTL
};
function $bede215d88ec3aee$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $bede215d88ec3aee$var$observeMove(element, onMove, ancestorResize) {
    let io = null;
    let timeoutId;
    const root = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $204931a4986f463b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $204931a4986f463b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $204931a4986f463b$export$8960430cfd85939f)(0, (0, $204931a4986f463b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            // The entry is a snapshot, so the reference may have moved since the
            // intersection was computed (under performance constraints, or between
            // consecutive frames of a multi-frame layout shift). The reported ratio
            // and the observed area are stale in that case and cannot be trusted to
            // detect subsequent movement, so refresh regardless of the ratio.
            if (!$bede215d88ec3aee$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) return refresh();
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped in place, the ratio is 0. Throttle
                // the refresh to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    // The window is a resize ancestor, so when `ancestorResize` is enabled its
    // listener already runs the update on resize. Here we only need to rebuild
    // the `IntersectionObserver` for the new root size, skipping a redundant
    // update. When `ancestorResize` is disabled, this becomes the sole update.
    const handleResize = ()=>refresh(ancestorResize);
    win.addEventListener('resize', handleResize);
    refresh(true);
    return ()=>{
        win.removeEventListener('resize', handleResize);
        cleanup();
    };
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bede215d88ec3aee$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $bede215d88ec3aee$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $c51400d9a81fca36$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $c51400d9a81fca36$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update);
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bede215d88ec3aee$var$observeMove(referenceEl, update, ancestorResize) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bede215d88ec3aee$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bede215d88ec3aee$var$getBoundingClientRect(reference);
        if (prevRefRect && !$bede215d88ec3aee$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $bede215d88ec3aee$export$37b6bde19b108ecc = (0, $9dccb9a8753b0e86$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bede215d88ec3aee$export$cc800923e997bb8 = (0, $9dccb9a8753b0e86$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bede215d88ec3aee$export$91fb6ecbd551914 = (0, $9dccb9a8753b0e86$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bede215d88ec3aee$export$fba63a578e423eb = (0, $9dccb9a8753b0e86$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bede215d88ec3aee$export$8a83211c878a3f1f = (0, $9dccb9a8753b0e86$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bede215d88ec3aee$export$346677f925de839c = (0, $9dccb9a8753b0e86$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bede215d88ec3aee$export$fe8985bb6374093c = (0, $9dccb9a8753b0e86$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bede215d88ec3aee$export$f2120bbfa5450bd2 = (0, $9dccb9a8753b0e86$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bede215d88ec3aee$export$18c8ad048e32c7d5 = (0, $9dccb9a8753b0e86$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bede215d88ec3aee$export$7bf07e38f3dc4b69 = (0, $9dccb9a8753b0e86$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bede215d88ec3aee$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = options != null ? options : {};
    const platformWithCache = {
        ...$bede215d88ec3aee$export$722a64dea1b767dc,
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $9dccb9a8753b0e86$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $4cdaae7c2a5f3f0d$var$isClient = typeof document !== 'undefined';
var $4cdaae7c2a5f3f0d$var$noop = function noop() {};
var $4cdaae7c2a5f3f0d$var$index = $4cdaae7c2a5f3f0d$var$isClient ? (0, $acw62.useLayoutEffect) : $4cdaae7c2a5f3f0d$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $4cdaae7c2a5f3f0d$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$4cdaae7c2a5f3f0d$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$4cdaae7c2a5f3f0d$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $4cdaae7c2a5f3f0d$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $4cdaae7c2a5f3f0d$var$roundByDPR(element, value) {
    const dpr = $4cdaae7c2a5f3f0d$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $4cdaae7c2a5f3f0d$var$useLatestRef(value) {
    const ref = $acw62.useRef(value);
    $4cdaae7c2a5f3f0d$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $4cdaae7c2a5f3f0d$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $acw62.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!$4cdaae7c2a5f3f0d$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $acw62.useState(null);
    const [_floating, _setFloating] = $acw62.useState(null);
    const setReference = $acw62.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $acw62.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $acw62.useRef(null);
    const floatingRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $4cdaae7c2a5f3f0d$var$useLatestRef(whileElementsMounted);
    const platformRef = $4cdaae7c2a5f3f0d$var$useLatestRef(platform);
    const openRef = $4cdaae7c2a5f3f0d$var$useLatestRef(open);
    const update = $acw62.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $bede215d88ec3aee$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$4cdaae7c2a5f3f0d$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $1u0KT.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $4cdaae7c2a5f3f0d$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $acw62.useRef(false);
    $4cdaae7c2a5f3f0d$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $4cdaae7c2a5f3f0d$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $acw62.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $acw62.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $4cdaae7c2a5f3f0d$var$roundByDPR(elements.floating, data.x);
        const y = $4cdaae7c2a5f3f0d$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$4cdaae7c2a5f3f0d$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $acw62.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $4cdaae7c2a5f3f0d$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $bede215d88ec3aee$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $bede215d88ec3aee$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $4cdaae7c2a5f3f0d$export$cc800923e997bb8 = (options, deps)=>{
    const result = (0, $bede215d88ec3aee$export$cc800923e997bb8)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $4cdaae7c2a5f3f0d$export$fba63a578e423eb = (options, deps)=>{
    const result = (0, $bede215d88ec3aee$export$fba63a578e423eb)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $4cdaae7c2a5f3f0d$export$7bf07e38f3dc4b69 = (options, deps)=>{
    const result = (0, $bede215d88ec3aee$export$7bf07e38f3dc4b69)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $4cdaae7c2a5f3f0d$export$8a83211c878a3f1f = (options, deps)=>{
    const result = (0, $bede215d88ec3aee$export$8a83211c878a3f1f)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $4cdaae7c2a5f3f0d$export$346677f925de839c = (options, deps)=>{
    const result = (0, $bede215d88ec3aee$export$346677f925de839c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $4cdaae7c2a5f3f0d$export$91fb6ecbd551914 = (options, deps)=>{
    const result = (0, $bede215d88ec3aee$export$91fb6ecbd551914)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $4cdaae7c2a5f3f0d$export$fe8985bb6374093c = (options, deps)=>{
    const result = (0, $bede215d88ec3aee$export$fe8985bb6374093c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $4cdaae7c2a5f3f0d$export$18c8ad048e32c7d5 = (options, deps)=>{
    const result = (0, $bede215d88ec3aee$export$18c8ad048e32c7d5)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $4cdaae7c2a5f3f0d$export$f2120bbfa5450bd2 = (options, deps)=>{
    const result = $4cdaae7c2a5f3f0d$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};



/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $1923ad12705fb717$export$74665b213cb5c4cf(refs) {
    const cleanupRef = $acw62.useRef(undefined);
    const refEffect = $acw62.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup == null ? void 0 : refCleanup());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
function $1923ad12705fb717$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
const $1923ad12705fb717$var$FloatingListContext = /*#__PURE__*/ $acw62.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $1923ad12705fb717$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [nodes, setNodes] = $acw62.useState(()=>new Set());
    const register = $acw62.useCallback((node)=>{
        setNodes((prevSet)=>new Set(prevSet).add(node));
    }, []);
    const unregister = $acw62.useCallback((node)=>{
        setNodes((prevSet)=>{
            const set = new Set(prevSet);
            set.delete(node);
            return set;
        });
    }, []);
    const map = $acw62.useMemo(()=>{
        const newMap = new Map();
        const sortedNodes = Array.from(nodes.keys()).sort($1923ad12705fb717$var$sortByDocumentPosition);
        sortedNodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        return newMap;
    }, [
        nodes
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1923ad12705fb717$var$FloatingListContext.Provider, {
        value: $acw62.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ]),
        children: children
    });
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $1923ad12705fb717$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $acw62.useContext($1923ad12705fb717$var$FloatingListContext);
    const [index, setIndex] = $acw62.useState(null);
    const componentRef = $acw62.useRef(null);
    const ref = $acw62.useCallback((node)=>{
        componentRef.current = node;
        if (index !== null) {
            elementsRef.current[index] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index,
        elementsRef,
        labelsRef,
        label
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $acw62.useMemo(()=>({
            ref: ref,
            index: index == null ? -1 : index
        }), [
        index,
        ref
    ]);
}
const $1923ad12705fb717$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const $1923ad12705fb717$var$ACTIVE_KEY = 'active';
const $1923ad12705fb717$var$SELECTED_KEY = 'selected';
const $1923ad12705fb717$var$ARROW_LEFT = 'ArrowLeft';
const $1923ad12705fb717$var$ARROW_RIGHT = 'ArrowRight';
const $1923ad12705fb717$var$ARROW_UP = 'ArrowUp';
const $1923ad12705fb717$var$ARROW_DOWN = 'ArrowDown';
function $1923ad12705fb717$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $acw62.cloneElement(render, computedProps);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ...computedProps
    });
}
const $1923ad12705fb717$var$CompositeContext = /*#__PURE__*/ $acw62.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $1923ad12705fb717$var$horizontalKeys = [
    $1923ad12705fb717$var$ARROW_LEFT,
    $1923ad12705fb717$var$ARROW_RIGHT
];
const $1923ad12705fb717$var$verticalKeys = [
    $1923ad12705fb717$var$ARROW_UP,
    $1923ad12705fb717$var$ARROW_DOWN
];
const $1923ad12705fb717$var$allKeys = [
    ...$1923ad12705fb717$var$horizontalKeys,
    ...$1923ad12705fb717$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $1923ad12705fb717$export$43586241d9db0c6d = /*#__PURE__*/ $acw62.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, rtl: rtl = false, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $acw62.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $acw62.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $acw62.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$1923ad12705fb717$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = (0, $85ea27aada64f9e6$export$53f691ee0acc6058)(elementsRef, disabledIndices);
        const maxIndex = (0, $85ea27aada64f9e6$export$b585558af466e926)(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? $1923ad12705fb717$var$ARROW_LEFT : $1923ad12705fb717$var$ARROW_RIGHT;
        const horizontalStartKey = rtl ? $1923ad12705fb717$var$ARROW_RIGHT : $1923ad12705fb717$var$ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $85ea27aada64f9e6$export$5334c96856356f08)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $85ea27aada64f9e6$export$446656ed0410fd9)(elementsRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $85ea27aada64f9e6$export$446656ed0410fd9)(elementsRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[(0, $85ea27aada64f9e6$export$342fcce33a2688bc)({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $85ea27aada64f9e6$export$50d8709b2ccc23f9)([
                    ...(typeof disabledIndices !== 'function' ? disabledIndices : null) || elementsRef.current.map((_, index)=>(0, $85ea27aada64f9e6$export$446656ed0410fd9)(elementsRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $85ea27aada64f9e6$export$dab2b2ce7761f8e4)(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $1923ad12705fb717$var$ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $1923ad12705fb717$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $1923ad12705fb717$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $1923ad12705fb717$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $1923ad12705fb717$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $1923ad12705fb717$var$allKeys : ({
            horizontal: $1923ad12705fb717$var$horizontalKeys,
            vertical: $1923ad12705fb717$var$verticalKeys,
            both: $1923ad12705fb717$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = (0, $85ea27aada64f9e6$export$3fc3ea4a67cf714)(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !(0, $85ea27aada64f9e6$export$75effb89758ec596)(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1923ad12705fb717$var$CompositeContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1923ad12705fb717$export$ffe15b0e64951704, {
            elementsRef: elementsRef,
            children: $1923ad12705fb717$var$renderJsx(render, computedProps)
        })
    });
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $1923ad12705fb717$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $acw62.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $acw62.useContext($1923ad12705fb717$var$CompositeContext);
    const { ref: ref, index: index } = $1923ad12705fb717$export$dcdc7ff5149f7d1a();
    const mergedRef = $1923ad12705fb717$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $1923ad12705fb717$var$renderJsx(render, computedProps);
});
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $1923ad12705fb717$var$SafeReact = {
    ...$acw62
};
let $1923ad12705fb717$var$serverHandoffComplete = false;
let $1923ad12705fb717$var$count = 0;
const $1923ad12705fb717$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $1923ad12705fb717$var$count++;
function $1923ad12705fb717$var$useFloatingId() {
    const [id, setId] = $acw62.useState(()=>$1923ad12705fb717$var$serverHandoffComplete ? $1923ad12705fb717$var$genId() : undefined);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (id == null) setId($1923ad12705fb717$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $acw62.useEffect(()=>{
        $1923ad12705fb717$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $1923ad12705fb717$var$useReactId = $1923ad12705fb717$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $1923ad12705fb717$export$f680877a34711e37 = $1923ad12705fb717$var$useReactId || $1923ad12705fb717$var$useFloatingId;
let $1923ad12705fb717$var$devMessageSet;
function $1923ad12705fb717$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $1923ad12705fb717$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $1923ad12705fb717$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $1923ad12705fb717$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $1923ad12705fb717$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $1923ad12705fb717$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $1923ad12705fb717$export$33511391554732bc = /*#__PURE__*/ $acw62.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $1923ad12705fb717$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $acw62.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (!floating) return;
        const isRTL = (0, $c51400d9a81fca36$export$3735103072e4a80)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        ...rest,
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' '),
            ...restStyle
        },
        children: [
            computedStrokeWidth > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                clipPath: "url(#" + clipPathId + ")",
                fill: "none",
                stroke: stroke,
                strokeWidth: computedStrokeWidth + (d ? 0 : 1),
                d: dValue
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: computedStrokeWidth && !d ? rest.fill : 'none',
                d: dValue
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                id: clipPathId,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: -halfStrokeWidth,
                    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
                    width: width + computedStrokeWidth,
                    height: width
                })
            })
        ]
    });
});
function $1923ad12705fb717$var$createEventEmitter() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((listener)=>listener(data));
        },
        on (event, listener) {
            if (!map.has(event)) map.set(event, new Set());
            map.get(event).add(listener);
        },
        off (event, listener) {
            var _map$get2;
            (_map$get2 = map.get(event)) == null || _map$get2.delete(listener);
        }
    };
}
const $1923ad12705fb717$var$FloatingNodeContext = /*#__PURE__*/ $acw62.createContext(null);
const $1923ad12705fb717$var$FloatingTreeContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $1923ad12705fb717$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $acw62.useContext($1923ad12705fb717$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $1923ad12705fb717$export$db0c2a7c7a2a4f69 = ()=>$acw62.useContext($1923ad12705fb717$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $1923ad12705fb717$export$9b136e0e758a42f4(customParentId) {
    const id = $1923ad12705fb717$export$f680877a34711e37();
    const tree = $1923ad12705fb717$export$db0c2a7c7a2a4f69();
    const reactParentId = $1923ad12705fb717$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (!id) return;
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $1923ad12705fb717$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $1923ad12705fb717$export$165209eae06d3488();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1923ad12705fb717$var$FloatingNodeContext.Provider, {
        value: $acw62.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ]),
        children: children
    });
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $1923ad12705fb717$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $acw62.useRef([]);
    const addNode = $acw62.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $acw62.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const [events] = $acw62.useState(()=>$1923ad12705fb717$var$createEventEmitter());
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1923ad12705fb717$var$FloatingTreeContext.Provider, {
        value: $acw62.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ]),
        children: children
    });
}
function $1923ad12705fb717$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $1923ad12705fb717$var$clearTimeoutIfSet(timeoutRef) {
    if (timeoutRef.current !== -1) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = -1;
    }
}
const $1923ad12705fb717$var$safePolygonIdentifier = /*#__PURE__*/ $1923ad12705fb717$var$createAttribute('safe-polygon');
function $1923ad12705fb717$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $85ea27aada64f9e6$export$81cf264172d31e51)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    if (typeof value === 'function') {
        const result = value();
        if (typeof result === 'number') return result;
        return result == null ? void 0 : result[prop];
    }
    return value == null ? void 0 : value[prop];
}
function $1923ad12705fb717$var$getRestMs(value) {
    if (typeof value === 'function') return value();
    return value;
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $1923ad12705fb717$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $1923ad12705fb717$export$db0c2a7c7a2a4f69();
    const parentId = $1923ad12705fb717$export$165209eae06d3488();
    const handleCloseRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(handleClose);
    const delayRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(delay);
    const openRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(open);
    const restMsRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(restMs);
    const pointerTypeRef = $acw62.useRef();
    const timeoutRef = $acw62.useRef(-1);
    const handlerRef = $acw62.useRef();
    const restTimeoutRef = $acw62.useRef(-1);
    const blockMouseMoveRef = $acw62.useRef(true);
    const performedPointerEventsMutationRef = $acw62.useRef(false);
    const unbindMouseMoveRef = $acw62.useRef(()=>{});
    const restTimeoutPendingRef = $acw62.useRef(false);
    const isHoverOpen = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    });
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                $1923ad12705fb717$var$clearTimeoutIfSet(timeoutRef);
                $1923ad12705fb717$var$clearTimeoutIfSet(restTimeoutRef);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $acw62.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $1923ad12705fb717$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            $1923ad12705fb717$var$clearTimeoutIfSet(timeoutRef);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            $1923ad12705fb717$var$clearTimeoutIfSet(timeoutRef);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($1923ad12705fb717$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)(()=>{
        return dataRef.current.openEvent ? [
            'click',
            'mousedown'
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onReferenceMouseEnter(event) {
            $1923ad12705fb717$var$clearTimeoutIfSet(timeoutRef);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $85ea27aada64f9e6$export$81cf264172d31e51)(pointerTypeRef.current) || $1923ad12705fb717$var$getRestMs(restMsRef.current) > 0 && !$1923ad12705fb717$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $1923ad12705fb717$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else if (!open) onOpenChange(true, event, 'hover');
        }
        function onReferenceMouseLeave(event) {
            if (isClickLikeOpenEvent()) {
                clearPointerEvents();
                return;
            }
            unbindMouseMoveRef.current();
            const doc = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(elements.floating);
            $1923ad12705fb717$var$clearTimeoutIfSet(restTimeoutRef);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) $1923ad12705fb717$var$clearTimeoutIfSet(timeoutRef);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $85ea27aada64f9e6$export$2344b14b097df817)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            })(event);
        }
        function onFloatingMouseEnter() {
            $1923ad12705fb717$var$clearTimeoutIfSet(timeoutRef);
        }
        function onFloatingMouseLeave(event) {
            if (!isClickLikeOpenEvent()) closeWithDelay(event, false);
        }
        if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(elements.domReference)) {
            const reference = elements.domReference;
            const floating = elements.floating;
            if (open) reference.addEventListener('mouseleave', onScrollMouseLeave);
            if (move) reference.addEventListener('mousemove', onReferenceMouseEnter, {
                once: true
            });
            reference.addEventListener('mouseenter', onReferenceMouseEnter);
            reference.addEventListener('mouseleave', onReferenceMouseLeave);
            if (floating) {
                floating.addEventListener('mouseleave', onScrollMouseLeave);
                floating.addEventListener('mouseenter', onFloatingMouseEnter);
                floating.addEventListener('mouseleave', onFloatingMouseLeave);
            }
            return ()=>{
                if (open) reference.removeEventListener('mouseleave', onScrollMouseLeave);
                if (move) reference.removeEventListener('mousemove', onReferenceMouseEnter);
                reference.removeEventListener('mouseenter', onReferenceMouseEnter);
                reference.removeEventListener('mouseleave', onReferenceMouseLeave);
                if (floating) {
                    floating.removeEventListener('mouseleave', onScrollMouseLeave);
                    floating.removeEventListener('mouseenter', onFloatingMouseEnter);
                    floating.removeEventListener('mouseleave', onFloatingMouseLeave);
                }
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent,
        restMsRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && (_handleCloseRef$curre = _handleCloseRef$curre.__options) != null && _handleCloseRef$curre.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(elements.floating).body;
                body.setAttribute($1923ad12705fb717$var$safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            $1923ad12705fb717$var$clearTimeoutIfSet(timeoutRef);
            $1923ad12705fb717$var$clearTimeoutIfSet(restTimeoutRef);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $acw62.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $85ea27aada64f9e6$export$81cf264172d31e51)(pointerTypeRef.current)) return;
                if (open || $1923ad12705fb717$var$getRestMs(restMsRef.current) === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                $1923ad12705fb717$var$clearTimeoutIfSet(restTimeoutRef);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, $1923ad12705fb717$var$getRestMs(restMsRef.current));
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMsRef
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $1923ad12705fb717$var$NOOP = ()=>{};
const $1923ad12705fb717$var$FloatingDelayGroupContext = /*#__PURE__*/ $acw62.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $1923ad12705fb717$var$NOOP,
    setState: $1923ad12705fb717$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $1923ad12705fb717$export$e2411914b150383d = ()=>$acw62.useContext($1923ad12705fb717$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $1923ad12705fb717$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $acw62.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $acw62.useRef(null);
    const setCurrentId = $acw62.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1923ad12705fb717$var$FloatingDelayGroupContext.Provider, {
        value: $acw62.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $1923ad12705fb717$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $1923ad12705fb717$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $1923ad12705fb717$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (setCurrentId === $1923ad12705fb717$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
const $1923ad12705fb717$var$NextFloatingDelayGroupContext = /*#__PURE__*/ $acw62.createContext({
    hasProvider: false,
    timeoutMs: 0,
    delayRef: {
        current: 0
    },
    initialDelayRef: {
        current: 0
    },
    timeoutIdRef: {
        current: -1
    },
    currentIdRef: {
        current: null
    },
    currentContextRef: {
        current: null
    }
});
/**
 * Experimental next version of `FloatingDelayGroup` to become the default
 * in the future. This component is not yet stable.
 * Provides context for a group of floating elements that should share a
 * `delay`. Unlike `FloatingDelayGroup`, `useNextDelayGroup` with this
 * component does not cause a re-render of unrelated consumers of the
 * context when the delay changes.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $1923ad12705fb717$export$e766ee16075bdf6b(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const delayRef = $acw62.useRef(delay);
    const initialDelayRef = $acw62.useRef(delay);
    const currentIdRef = $acw62.useRef(null);
    const currentContextRef = $acw62.useRef(null);
    const timeoutIdRef = $acw62.useRef(-1);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1923ad12705fb717$var$NextFloatingDelayGroupContext.Provider, {
        value: $acw62.useMemo(()=>({
                hasProvider: true,
                delayRef: delayRef,
                initialDelayRef: initialDelayRef,
                currentIdRef: currentIdRef,
                timeoutMs: timeoutMs,
                currentContextRef: currentContextRef,
                timeoutIdRef: timeoutIdRef
            }), [
            timeoutMs
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `NextFloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $1923ad12705fb717$export$f86f270cee1e809c(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { enabled: enabled = true } = options;
    const groupContext = $acw62.useContext($1923ad12705fb717$var$NextFloatingDelayGroupContext);
    const { currentIdRef: currentIdRef, delayRef: delayRef, timeoutMs: timeoutMs, initialDelayRef: initialDelayRef, currentContextRef: currentContextRef, hasProvider: hasProvider, timeoutIdRef: timeoutIdRef } = groupContext;
    const [isInstantPhase, setIsInstantPhase] = $acw62.useState(false);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        function unset() {
            var _currentContextRef$cu;
            setIsInstantPhase(false);
            (_currentContextRef$cu = currentContextRef.current) == null || _currentContextRef$cu.setIsInstantPhase(false);
            currentIdRef.current = null;
            currentContextRef.current = null;
            delayRef.current = initialDelayRef.current;
        }
        if (!enabled) return;
        if (!currentIdRef.current) return;
        if (!open && currentIdRef.current === floatingId) {
            setIsInstantPhase(false);
            if (timeoutMs) {
                timeoutIdRef.current = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeoutIdRef.current);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        floatingId,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!open) return;
        const prevContext = currentContextRef.current;
        const prevId = currentIdRef.current;
        currentContextRef.current = {
            onOpenChange: onOpenChange,
            setIsInstantPhase: setIsInstantPhase
        };
        currentIdRef.current = floatingId;
        delayRef.current = {
            open: 0,
            close: $1923ad12705fb717$var$getDelay(initialDelayRef.current, 'close')
        };
        if (prevId !== null && prevId !== floatingId) {
            $1923ad12705fb717$var$clearTimeoutIfSet(timeoutIdRef);
            setIsInstantPhase(true);
            prevContext == null || prevContext.setIsInstantPhase(true);
            prevContext == null || prevContext.onOpenChange(false);
        } else {
            setIsInstantPhase(false);
            prevContext == null || prevContext.setIsInstantPhase(false);
        }
    }, [
        enabled,
        open,
        floatingId,
        onOpenChange,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        return ()=>{
            currentContextRef.current = null;
        };
    }, [
        currentContextRef
    ]);
    return $acw62.useMemo(()=>({
            hasProvider: hasProvider,
            delayRef: delayRef,
            isInstantPhase: isInstantPhase
        }), [
        hasProvider,
        delayRef,
        isInstantPhase
    ]);
}
let $1923ad12705fb717$var$rafId = 0;
function $1923ad12705fb717$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($1923ad12705fb717$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $1923ad12705fb717$var$rafId = requestAnimationFrame(exec);
}
function $1923ad12705fb717$var$contains(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $c51400d9a81fca36$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $1923ad12705fb717$var$getTarget(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $1923ad12705fb717$var$getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
const $1923ad12705fb717$var$counters = {
    inert: /*#__PURE__*/ new WeakMap(),
    'aria-hidden': /*#__PURE__*/ new WeakMap(),
    none: /*#__PURE__*/ new WeakMap()
};
function $1923ad12705fb717$var$getCounterMap(control) {
    if (control === 'inert') return $1923ad12705fb717$var$counters.inert;
    if (control === 'aria-hidden') return $1923ad12705fb717$var$counters['aria-hidden'];
    return $1923ad12705fb717$var$counters.none;
}
let $1923ad12705fb717$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $1923ad12705fb717$var$markerMap = {};
let $1923ad12705fb717$var$lockCount$1 = 0;
const $1923ad12705fb717$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
function $1923ad12705fb717$var$unwrapHost(node) {
    if (!node) return null;
    return (0, $c51400d9a81fca36$export$af51f0f06c0f328a)(node) ? node.host : $1923ad12705fb717$var$unwrapHost(node.parentNode);
}
const $1923ad12705fb717$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $1923ad12705fb717$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $1923ad12705fb717$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $1923ad12705fb717$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$1923ad12705fb717$var$markerMap[markerName]) $1923ad12705fb717$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $1923ad12705fb717$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $c51400d9a81fca36$export$651544f548703224)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterMap = $1923ad12705fb717$var$getCounterMap(controlAttribute);
                const counterValue = (counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $1923ad12705fb717$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, controlAttribute === 'inert' ? '' : 'true');
            }
        });
    }
    $1923ad12705fb717$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterMap = $1923ad12705fb717$var$getCounterMap(controlAttribute);
            const currentCounterValue = counterMap.get(element) || 0;
            const counterValue = currentCounterValue - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$1923ad12705fb717$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $1923ad12705fb717$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $1923ad12705fb717$var$lockCount$1--;
        if (!$1923ad12705fb717$var$lockCount$1) {
            $1923ad12705fb717$var$counters.inert = new WeakMap();
            $1923ad12705fb717$var$counters['aria-hidden'] = new WeakMap();
            $1923ad12705fb717$var$counters.none = new WeakMap();
            $1923ad12705fb717$var$uncontrolledElementsSet = new WeakSet();
            $1923ad12705fb717$var$markerMap = {};
        }
    };
}
function $1923ad12705fb717$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = $1923ad12705fb717$var$getDocument(avoidElements[0]).body;
    return $1923ad12705fb717$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live],[role="status"],output'))), body, ariaHidden, inert);
}
const $1923ad12705fb717$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
const $1923ad12705fb717$var$FocusGuard = /*#__PURE__*/ $acw62.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $acw62.useState();
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if ((0, $85ea27aada64f9e6$export$95df08bae54cb4df)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$1923ad12705fb717$var$createAttribute('focus-guard')]: '',
        style: $1923ad12705fb717$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        ...props,
        ...restProps
    });
});
const $1923ad12705fb717$var$HIDDEN_OWNER_STYLES = {
    clipPath: 'inset(50%)',
    position: 'fixed',
    top: 0,
    left: 0
};
const $1923ad12705fb717$var$PortalContext = /*#__PURE__*/ $acw62.createContext(null);
const $1923ad12705fb717$var$attr = /*#__PURE__*/ $1923ad12705fb717$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $1923ad12705fb717$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $1923ad12705fb717$export$f680877a34711e37();
    const portalContext = $1923ad12705fb717$var$usePortalContext();
    const [portalNode, setPortalNode] = $acw62.useState(null);
    const portalNodeRef = $acw62.useRef(null);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($1923ad12705fb717$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $c51400d9a81fca36$export$8ee0fc9ee280b4ee)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($1923ad12705fb717$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $1923ad12705fb717$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $1923ad12705fb717$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $acw62.useState(null);
    const beforeOutsideRef = $acw62.useRef(null);
    const afterOutsideRef = $acw62.useRef(null);
    const beforeInsideRef = $acw62.useRef(null);
    const afterInsideRef = $acw62.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $acw62.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && (0, $85ea27aada64f9e6$export$6e0c4e272f3faa2)(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? (0, $85ea27aada64f9e6$export$a65f4028abb17f36) : (0, $85ea27aada64f9e6$export$3995dd353b80da11);
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $acw62.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        (0, $85ea27aada64f9e6$export$a65f4028abb17f36)(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($1923ad12705fb717$var$PortalContext.Provider, {
        value: $acw62.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ]),
        children: [
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1923ad12705fb717$var$FocusGuard, {
                "data-type": "outside",
                ref: beforeOutsideRef,
                onFocus: (event)=>{
                    if ((0, $85ea27aada64f9e6$export$6e0c4e272f3faa2)(event, portalNode)) {
                        var _beforeInsideRef$curr;
                        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const prevTabbable = (0, $85ea27aada64f9e6$export$2e5518c3303f364a)(domReference);
                        prevTabbable == null || prevTabbable.focus();
                    }
                }
            }),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                "aria-owns": portalNode.id,
                style: $1923ad12705fb717$var$HIDDEN_OWNER_STYLES
            }),
            portalNode && /*#__PURE__*/ $1u0KT.createPortal(children, portalNode),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1923ad12705fb717$var$FocusGuard, {
                "data-type": "outside",
                ref: afterOutsideRef,
                onFocus: (event)=>{
                    if ((0, $85ea27aada64f9e6$export$6e0c4e272f3faa2)(event, portalNode)) {
                        var _afterInsideRef$curre;
                        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const nextTabbable = (0, $85ea27aada64f9e6$export$28f33206776129a7)(domReference);
                        nextTabbable == null || nextTabbable.focus();
                        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
                    }
                }
            })
        ]
    });
}
const $1923ad12705fb717$var$usePortalContext = ()=>$acw62.useContext($1923ad12705fb717$var$PortalContext);
function $1923ad12705fb717$var$useLiteMergeRefs(refs) {
    return $acw62.useMemo(()=>{
        return (value)=>{
            refs.forEach((ref)=>{
                if (ref) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
const $1923ad12705fb717$var$LIST_LIMIT = 20;
let $1923ad12705fb717$var$previouslyFocusedElements = [];
function $1923ad12705fb717$var$clearDisconnectedPreviouslyFocusedElements() {
    $1923ad12705fb717$var$previouslyFocusedElements = $1923ad12705fb717$var$previouslyFocusedElements.filter((elementRef)=>{
        var _elementRef$deref;
        return (_elementRef$deref = elementRef.deref()) == null ? void 0 : _elementRef$deref.isConnected;
    });
}
function $1923ad12705fb717$var$addPreviouslyFocusedElement(element) {
    $1923ad12705fb717$var$clearDisconnectedPreviouslyFocusedElements();
    if (element && (0, $c51400d9a81fca36$export$651544f548703224)(element) !== 'body') {
        $1923ad12705fb717$var$previouslyFocusedElements.push(new WeakRef(element));
        if ($1923ad12705fb717$var$previouslyFocusedElements.length > $1923ad12705fb717$var$LIST_LIMIT) $1923ad12705fb717$var$previouslyFocusedElements = $1923ad12705fb717$var$previouslyFocusedElements.slice(-$1923ad12705fb717$var$LIST_LIMIT);
    }
}
function $1923ad12705fb717$var$getPreviouslyFocusedElement() {
    $1923ad12705fb717$var$clearDisconnectedPreviouslyFocusedElements();
    const elementRef = $1923ad12705fb717$var$previouslyFocusedElements[$1923ad12705fb717$var$previouslyFocusedElements.length - 1];
    return elementRef == null ? void 0 : elementRef.deref();
}
function $1923ad12705fb717$var$getFirstTabbableElement(container) {
    const tabbableOptions = (0, $85ea27aada64f9e6$export$6324a2bbae6a332f)();
    if ((0, $a4b3b7902c9a987d$export$bebd5a1431fec25d)(container, tabbableOptions)) return container;
    return (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(container, tabbableOptions)[0] || container;
}
function $1923ad12705fb717$var$handleTabIndex(floatingFocusElement, orderRef) {
    var _floatingFocusElement;
    if (!orderRef.current.includes('floating') && !((_floatingFocusElement = floatingFocusElement.getAttribute('role')) != null && _floatingFocusElement.includes('dialog'))) return;
    const options = (0, $85ea27aada64f9e6$export$6324a2bbae6a332f)();
    const focusableElements = (0, $a4b3b7902c9a987d$export$ecc6d1fcdff4f700)(floatingFocusElement, options);
    const tabbableContent = focusableElements.filter((element)=>{
        const dataTabIndex = element.getAttribute('data-tabindex') || '';
        return (0, $a4b3b7902c9a987d$export$bebd5a1431fec25d)(element, options) || element.hasAttribute('data-tabindex') && !dataTabIndex.startsWith('-');
    });
    const tabIndex = floatingFocusElement.getAttribute('tabindex');
    if (orderRef.current.includes('floating') || tabbableContent.length === 0) {
        if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
    } else if (tabIndex !== '-1' || floatingFocusElement.hasAttribute('data-tabindex') && floatingFocusElement.getAttribute('data-tabindex') !== '-1') {
        floatingFocusElement.setAttribute('tabindex', '-1');
        floatingFocusElement.setAttribute('data-tabindex', '-1');
    }
}
const $1923ad12705fb717$var$VisuallyHiddenDismiss = /*#__PURE__*/ $acw62.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        ...props,
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $1923ad12705fb717$var$HIDDEN_STYLES
    });
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $1923ad12705fb717$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true, outsideElementsInert: outsideElementsInert = false, getInsideElements: _getInsideElements = ()=>[] } = props;
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: { domReference: domReference, floating: floating } } = context;
    const getNodeId = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)(()=>{
        var _dataRef$current$floa;
        return (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    });
    const getInsideElements = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)(_getInsideElements);
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $85ea27aada64f9e6$export$259ba5ae38188551)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const inertSupported = $1923ad12705fb717$var$supportsInert();
    const guards = inertSupported ? _guards : true;
    const useInert = !guards || inertSupported && outsideElementsInert;
    const orderRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(order);
    const initialFocusRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(initialFocus);
    const returnFocusRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(returnFocus);
    const tree = $1923ad12705fb717$export$db0c2a7c7a2a4f69();
    const portalContext = $1923ad12705fb717$var$usePortalContext();
    const startDismissButtonRef = $acw62.useRef(null);
    const endDismissButtonRef = $acw62.useRef(null);
    const preventReturnFocusRef = $acw62.useRef(false);
    const isPointerDownRef = $acw62.useRef(false);
    const tabbableIndexRef = $acw62.useRef(-1);
    const blurTimeoutRef = $acw62.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = (0, $85ea27aada64f9e6$export$9b0901b5e9b45fc7)(floating);
    const getTabbableContent = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(container, (0, $85ea27aada64f9e6$export$6324a2bbae6a332f)()) : [];
    });
    const getTabbableElements = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $acw62.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $85ea27aada64f9e6$export$2344b14b097df817)(floatingFocusElement, (0, $85ea27aada64f9e6$export$da980962bd2147a4)((0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                const els = getTabbableElements();
                const target = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                    if (event.shiftKey) $1923ad12705fb717$var$enqueueFocus(els[els.length - 1]);
                    else $1923ad12705fb717$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                    $1923ad12705fb717$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $acw62.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $acw62.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            const currentTarget = event.currentTarget;
            const target = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event);
            queueMicrotask(()=>{
                const nodeId = getNodeId();
                const movedToUnrelatedNode = !((0, $85ea27aada64f9e6$export$2344b14b097df817)(domReference, relatedTarget) || (0, $85ea27aada64f9e6$export$2344b14b097df817)(floating, relatedTarget) || (0, $85ea27aada64f9e6$export$2344b14b097df817)(relatedTarget, floating) || (0, $85ea27aada64f9e6$export$2344b14b097df817)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($1923ad12705fb717$var$createAttribute('focus-guard')) || tree && ((0, $85ea27aada64f9e6$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $85ea27aada64f9e6$export$2344b14b097df817)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $85ea27aada64f9e6$export$2344b14b097df817)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || (0, $85ea27aada64f9e6$export$5d8eb345316b65c0)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4, _node$context5;
                    return [
                        (_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating,
                        (0, $85ea27aada64f9e6$export$9b0901b5e9b45fc7)((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.floating)
                    ].includes(relatedTarget) || ((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.domReference) === relatedTarget;
                })));
                if (currentTarget === domReference && floatingFocusElement) $1923ad12705fb717$var$handleTabIndex(floatingFocusElement, orderRef);
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && currentTarget !== domReference && !(target != null && target.isConnected) && (0, $85ea27aada64f9e6$export$da980962bd2147a4)((0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floatingFocusElement)) === (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(nodeToFocus)) nodeToFocus.focus();
                }
                // https://github.com/floating-ui/floating-ui/issues/3060
                if (dataRef.current.insideReactTree) {
                    dataRef.current.insideReactTree = false;
                    return;
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $1923ad12705fb717$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        const shouldHandleBlurCapture = Boolean(!tree && portalContext);
        function markInsideReactTree() {
            $1923ad12705fb717$var$clearTimeoutIfSet(blurTimeoutRef);
            dataRef.current.insideReactTree = true;
            blurTimeoutRef.current = window.setTimeout(()=>{
                dataRef.current.insideReactTree = false;
            });
        }
        if (floating && (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            if (shouldHandleBlurCapture) floating.addEventListener('focusout', markInsideReactTree, true);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
                if (shouldHandleBlurCapture) floating.removeEventListener('focusout', markInsideReactTree, true);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox,
        getNodeId,
        orderRef,
        dataRef
    ]);
    const beforeGuardRef = $acw62.useRef(null);
    const afterGuardRef = $acw62.useRef(null);
    const mergedBeforeGuardRef = $1923ad12705fb717$var$useLiteMergeRefs([
        beforeGuardRef,
        portalContext == null ? void 0 : portalContext.beforeInsideRef
    ]);
    const mergedAfterGuardRef = $1923ad12705fb717$var$useLiteMergeRefs([
        afterGuardRef,
        portalContext == null ? void 0 : portalContext.afterInsideRef
    ]);
    $acw62.useEffect(()=>{
        var _portalContext$portal, _ancestors$find;
        if (disabled) return;
        if (!floating) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $1923ad12705fb717$var$createAttribute('portal') + "]")) || []);
        const ancestors = tree ? (0, $85ea27aada64f9e6$export$5d8eb345316b65c0)(tree.nodesRef.current, getNodeId()) : [];
        const rootAncestorComboboxDomReference = (_ancestors$find = ancestors.find((node)=>{
            var _node$context6;
            return (0, $85ea27aada64f9e6$export$259ba5ae38188551)(((_node$context6 = node.context) == null ? void 0 : _node$context6.elements.domReference) || null);
        })) == null || (_ancestors$find = _ancestors$find.context) == null ? void 0 : _ancestors$find.elements.domReference;
        const insideElements = [
            floating,
            rootAncestorComboboxDomReference,
            ...portalNodes,
            ...getInsideElements(),
            startDismissButtonRef.current,
            endDismissButtonRef.current,
            beforeGuardRef.current,
            afterGuardRef.current,
            portalContext == null ? void 0 : portalContext.beforeOutsideRef.current,
            portalContext == null ? void 0 : portalContext.afterOutsideRef.current,
            orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
        ].filter((x)=>x != null);
        const cleanup = modal || isUntrappedTypeableCombobox ? $1923ad12705fb717$var$markOthers(insideElements, !useInert, useInert) : $1923ad12705fb717$var$markOthers(insideElements);
        return ()=>{
            cleanup();
        };
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards,
        useInert,
        tree,
        getNodeId,
        getInsideElements
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (disabled || !(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(floatingFocusElement)) return;
        const doc = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $85ea27aada64f9e6$export$da980962bd2147a4)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $85ea27aada64f9e6$export$2344b14b097df817)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $1923ad12705fb717$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (disabled || !floatingFocusElement) return;
        const doc = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $85ea27aada64f9e6$export$da980962bd2147a4)(doc);
        $1923ad12705fb717$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { reason: reason, event: event, nested: nested } = _ref;
            if ([
                'hover',
                'safe-polygon'
            ].includes(reason) && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) preventReturnFocusRef.current = false;
            else if ((0, $85ea27aada64f9e6$export$60278871457622de)(event) || (0, $85ea27aada64f9e6$export$29bf1b5f2c56cf63)(event)) preventReturnFocusRef.current = false;
            else {
                let isPreventScrollSupported = false;
                document.createElement('div').focus({
                    get preventScroll () {
                        isPreventScrollSupported = true;
                        return false;
                    }
                });
                if (isPreventScrollSupported) preventReturnFocusRef.current = false;
                else preventReturnFocusRef.current = true;
            }
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $1923ad12705fb717$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') {
                const el = domReference || $1923ad12705fb717$var$getPreviouslyFocusedElement();
                return el && el.isConnected ? el : fallbackEl;
            }
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $85ea27aada64f9e6$export$da980962bd2147a4)(doc);
            const isFocusInsideFloatingTree = (0, $85ea27aada64f9e6$export$2344b14b097df817)(floating, activeEl) || tree && (0, $85ea27aada64f9e6$export$1f1998cc3c6b56fb)(tree.nodesRef.current, getNodeId(), false).some((node)=>{
                var _node$context7;
                return (0, $85ea27aada64f9e6$export$2344b14b097df817)((_node$context7 = node.context) == null ? void 0 : _node$context7.elements.floating, activeEl);
            });
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                // This is `returnElement`, if it's tabbable, or its first tabbable child.
                const tabbableReturnElement = $1923ad12705fb717$var$getFirstTabbableElement(returnElement);
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(tabbableReturnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) tabbableReturnElement.focus({
                    preventScroll: true
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        events,
        tree,
        isInsidePortal,
        domReference,
        getNodeId
    ]);
    $acw62.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
        return ()=>{
            queueMicrotask($1923ad12705fb717$var$clearDisconnectedPreviouslyFocusedElements);
        };
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            domReference: domReference
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        closeOnFocusOut,
        domReference
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        $1923ad12705fb717$var$handleTabIndex(floatingFocusElement, orderRef);
    }, [
        disabled,
        floatingFocusElement,
        orderRef
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1923ad12705fb717$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent),
            children: typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss'
        });
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            shouldRenderGuards && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1923ad12705fb717$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedBeforeGuardRef,
                onFocus: (event)=>{
                    if (modal) {
                        const els = getTabbableElements();
                        $1923ad12705fb717$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
                    } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        preventReturnFocusRef.current = false;
                        if ((0, $85ea27aada64f9e6$export$6e0c4e272f3faa2)(event, portalContext.portalNode)) {
                            const nextTabbable = (0, $85ea27aada64f9e6$export$28f33206776129a7)(domReference);
                            nextTabbable == null || nextTabbable.focus();
                        } else {
                            var _portalContext$before;
                            (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                        }
                    }
                }
            }),
            !isUntrappedTypeableCombobox && renderDismissButton('start'),
            children,
            renderDismissButton('end'),
            shouldRenderGuards && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1923ad12705fb717$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedAfterGuardRef,
                onFocus: (event)=>{
                    if (modal) $1923ad12705fb717$var$enqueueFocus(getTabbableElements()[0]);
                    else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        if (closeOnFocusOut) preventReturnFocusRef.current = true;
                        if ((0, $85ea27aada64f9e6$export$6e0c4e272f3faa2)(event, portalContext.portalNode)) {
                            const prevTabbable = (0, $85ea27aada64f9e6$export$2e5518c3303f364a)(domReference);
                            prevTabbable == null || prevTabbable.focus();
                        } else {
                            var _portalContext$afterO;
                            (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                        }
                    }
                }
            })
        ]
    });
}
let $1923ad12705fb717$var$lockCount = 0;
const $1923ad12705fb717$var$scrollbarProperty = '--floating-ui-scrollbar-width';
function $1923ad12705fb717$var$enableScrollLock() {
    const platform = (0, $85ea27aada64f9e6$export$867a782338812cb4)();
    const isIOS = /iP(hone|ad|od)|iOS/.test(platform) || // iPads can claim to be MacIntel
    platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    bodyStyle.setProperty($1923ad12705fb717$var$scrollbarProperty, scrollbarWidth + "px");
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        bodyStyle.removeProperty($1923ad12705fb717$var$scrollbarProperty);
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $1923ad12705fb717$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $1923ad12705fb717$export$a35954495955337b = /*#__PURE__*/ $acw62.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (!lockScroll) return;
        $1923ad12705fb717$var$lockCount++;
        if ($1923ad12705fb717$var$lockCount === 1) $1923ad12705fb717$var$cleanup = $1923ad12705fb717$var$enableScrollLock();
        return ()=>{
            $1923ad12705fb717$var$lockCount--;
            if ($1923ad12705fb717$var$lockCount === 0) $1923ad12705fb717$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        ...rest,
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    });
});
function $1923ad12705fb717$var$isButtonTarget(event) {
    return (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === 'BUTTON';
}
function $1923ad12705fb717$var$isAnchorTarget(event) {
    return (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === 'A';
}
function $1923ad12705fb717$var$isSpaceIgnored(element) {
    return (0, $85ea27aada64f9e6$export$42ad131c32f0fb8d)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $1923ad12705fb717$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true, stickIfOpen: stickIfOpen = true } = props;
    const pointerTypeRef = $acw62.useRef();
    const didKeyDownRef = $acw62.useRef(false);
    const reference = $acw62.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $85ea27aada64f9e6$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $85ea27aada64f9e6$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $1923ad12705fb717$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$1923ad12705fb717$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if ($1923ad12705fb717$var$isAnchorTarget(event)) return;
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $1923ad12705fb717$var$isButtonTarget(event) || $1923ad12705fb717$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $1923ad12705fb717$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $1923ad12705fb717$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $1923ad12705fb717$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $acw62.useRef(false);
    const cleanupListenerRef = $acw62.useRef(null);
    const [pointerType, setPointerType] = $acw62.useState();
    const [reactive, setReactive] = $acw62.useState([]);
    const setReference = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$1923ad12705fb717$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($1923ad12705fb717$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $85ea27aada64f9e6$export$81cf264172d31e51)(pointerType) ? floating : open;
    const addListener = $acw62.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(floating);
        function handleMouseMove(event) {
            const target = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event);
            if (!(0, $85ea27aada64f9e6$export$2344b14b097df817)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $1923ad12705fb717$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $acw62.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $acw62.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $acw62.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $acw62.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $1923ad12705fb717$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $1923ad12705fb717$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $1923ad12705fb717$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $1923ad12705fb717$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $1923ad12705fb717$export$db0c2a7c7a2a4f69();
    const outsidePressFn = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const endedOrStartedInsideRef = $acw62.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $1923ad12705fb717$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $1923ad12705fb717$var$normalizeProp(capture);
    const isComposingRef = $acw62.useRef(false);
    const closeOnEscapeKeyDown = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? (0, $85ea27aada64f9e6$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $85ea27aada64f9e6$export$94781ce41a161222)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = dataRef.current.insideReactTree;
        dataRef.current.insideReactTree = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event);
        const inertSelector = "[" + $1923ad12705fb717$var$createAttribute('inert') + "]";
        const markers = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(target) ? target : null;
        while(targetRootAncestor && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(targetRootAncestor)){
            const nextParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(targetRootAncestor);
            if ((0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(nextParent) || !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(target) && !(0, $85ea27aada64f9e6$export$7b296c28e0fa3aed)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $85ea27aada64f9e6$export$2344b14b097df817)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $85ea27aada64f9e6$export$2344b14b097df817)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(target) && floating) {
            const lastTraversableNode = (0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(target);
            const style = (0, $c51400d9a81fca36$export$3735103072e4a80)(target);
            const scrollRe = /auto|scroll/;
            const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
            const isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
            const canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            const isRTL = style.direction === 'rtl';
            // Check click position relative to scrollbar.
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            const pressedVerticalScrollbar = canScrollY && (isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
            const pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
            if (pressedVerticalScrollbar || pressedHorizontalScrollbar) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && (0, $85ea27aada64f9e6$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $85ea27aada64f9e6$export$43c3154d5bf2c6c2)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $85ea27aada64f9e6$export$43c3154d5bf2c6c2)(event, elements.floating) || (0, $85ea27aada64f9e6$export$43c3154d5bf2c6c2)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? (0, $85ea27aada64f9e6$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $acw62.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $c51400d9a81fca36$export$78551043582a6a98)() ? 5 : 0);
        }
        const doc = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(elements.domReference)) ancestors = (0, $c51400d9a81fca36$export$3b57c1601291186b)(elements.domReference);
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(elements.floating)) ancestors = ancestors.concat((0, $c51400d9a81fca36$export$3b57c1601291186b)(elements.floating));
            if (!(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $c51400d9a81fca36$export$3b57c1601291186b)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll);
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $acw62.useEffect(()=>{
        dataRef.current.insideReactTree = false;
    }, [
        dataRef,
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $acw62.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            ...referencePress && {
                [$1923ad12705fb717$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                    onOpenChange(false, event.nativeEvent, 'reference-press');
                },
                ...referencePressEvent !== 'click' && {
                    onClick (event) {
                        onOpenChange(false, event.nativeEvent, 'reference-press');
                    }
                }
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $acw62.useMemo(()=>{
        function setMouseDownOrUpInside(event) {
            if (event.button !== 0) return;
            endedOrStartedInsideRef.current = true;
        }
        return {
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown: setMouseDownOrUpInside,
            onMouseUp: setMouseDownOrUpInside,
            [$1923ad12705fb717$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                dataRef.current.insideReactTree = true;
            }
        };
    }, [
        closeOnEscapeKeyDown,
        outsidePressEvent,
        dataRef
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $1923ad12705fb717$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $1923ad12705fb717$export$f680877a34711e37();
    const dataRef = $acw62.useRef({});
    const [events] = $acw62.useState(()=>$1923ad12705fb717$var$createEventEmitter());
    const nested = $1923ad12705fb717$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $acw62.useState(elementsProp.reference);
    const onOpenChange = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $acw62.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $acw62.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $acw62.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $1923ad12705fb717$export$4e02a5c1d08bac65(_temp) {
    var _elementsOption$refer, _elementsOption$float;
    let { elements: elementsOption, ...options } = _temp === void 0 ? {} : _temp;
    const { nodeId: nodeId } = options;
    const internalRootContext = $1923ad12705fb717$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: (_elementsOption$refer = elementsOption == null ? void 0 : elementsOption.reference) != null ? _elementsOption$refer : null,
            floating: (_elementsOption$float = elementsOption == null ? void 0 : elementsOption.floating) != null ? _elementsOption$float : null
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $acw62.useState(null);
    const [positionReference, _setPositionReference] = $acw62.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $acw62.useRef(null);
    const tree = $1923ad12705fb717$export$db0c2a7c7a2a4f69();
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $4cdaae7c2a5f3f0d$export$4e02a5c1d08bac65)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $acw62.useCallback((node)=>{
        const computedPositionReference = (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            getClientRects: ()=>node.getClientRects(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $acw62.useCallback((node)=>{
        if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $acw62.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $acw62.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $acw62.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $acw62.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
function $1923ad12705fb717$var$isMacSafari() {
    return (0, $85ea27aada64f9e6$export$9ac100e40613ea10)() && (0, $85ea27aada64f9e6$export$95df08bae54cb4df)();
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $1923ad12705fb717$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $acw62.useRef(false);
    const timeoutRef = $acw62.useRef(-1);
    const keyboardModalityRef = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(elements.domReference) && elements.domReference === (0, $85ea27aada64f9e6$export$da980962bd2147a4)((0, $85ea27aada64f9e6$export$f65ca476c09acec0)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        function onPointerDown() {
            keyboardModalityRef.current = false;
        }
        win.addEventListener('blur', onBlur);
        if ($1923ad12705fb717$var$isMacSafari()) {
            win.addEventListener('keydown', onKeyDown, true);
            win.addEventListener('pointerdown', onPointerDown, true);
        }
        return ()=>{
            win.removeEventListener('blur', onBlur);
            if ($1923ad12705fb717$var$isMacSafari()) {
                win.removeEventListener('keydown', onKeyDown, true);
                win.removeEventListener('pointerdown', onPointerDown, true);
            }
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            $1923ad12705fb717$var$clearTimeoutIfSet(timeoutRef);
        };
    }, []);
    const reference = $acw62.useMemo(()=>({
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event.nativeEvent);
                if (visibleOnly && (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(target)) {
                    // Safari fails to match `:focus-visible` if focus was initially
                    // outside the document.
                    if ($1923ad12705fb717$var$isMacSafari() && !event.relatedTarget) {
                        if (!keyboardModalityRef.current && !(0, $85ea27aada64f9e6$export$42ad131c32f0fb8d)(target)) return;
                    } else if (!(0, $85ea27aada64f9e6$export$65750043c2fb2f40)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(relatedTarget) && relatedTarget.hasAttribute($1923ad12705fb717$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $85ea27aada64f9e6$export$da980962bd2147a4)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $85ea27aada64f9e6$export$2344b14b097df817)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $85ea27aada64f9e6$export$2344b14b097df817)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $1923ad12705fb717$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$1923ad12705fb717$var$ACTIVE_KEY]: _, [$1923ad12705fb717$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1,
            [$1923ad12705fb717$var$FOCUSABLE_ATTRIBUTE]: ''
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $1923ad12705fb717$var$ACTIVE_KEY,
                    $1923ad12705fb717$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $1923ad12705fb717$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $acw62.useCallback((userProps)=>$1923ad12705fb717$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $acw62.useCallback((userProps)=>$1923ad12705fb717$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $acw62.useCallback((userProps)=>$1923ad12705fb717$var$mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $acw62.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
const $1923ad12705fb717$var$ESCAPE = 'Escape';
function $1923ad12705fb717$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $1923ad12705fb717$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $1923ad12705fb717$var$ARROW_UP || key === $1923ad12705fb717$var$ARROW_DOWN;
    const horizontal = key === $1923ad12705fb717$var$ARROW_LEFT || key === $1923ad12705fb717$var$ARROW_RIGHT;
    return $1923ad12705fb717$var$doSwitch(orientation, vertical, horizontal);
}
function $1923ad12705fb717$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $1923ad12705fb717$var$ARROW_DOWN;
    const horizontal = rtl ? key === $1923ad12705fb717$var$ARROW_LEFT : key === $1923ad12705fb717$var$ARROW_RIGHT;
    return $1923ad12705fb717$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $1923ad12705fb717$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $1923ad12705fb717$var$ARROW_LEFT : key === $1923ad12705fb717$var$ARROW_RIGHT;
    const horizontal = key === $1923ad12705fb717$var$ARROW_DOWN;
    return $1923ad12705fb717$var$doSwitch(orientation, vertical, horizontal);
}
function $1923ad12705fb717$var$isCrossOrientationCloseKey(key, orientation, rtl, cols) {
    const vertical = rtl ? key === $1923ad12705fb717$var$ARROW_RIGHT : key === $1923ad12705fb717$var$ARROW_LEFT;
    const horizontal = key === $1923ad12705fb717$var$ARROW_UP;
    if (orientation === 'both' || orientation === 'horizontal' && cols && cols > 1) return key === $1923ad12705fb717$var$ESCAPE;
    return $1923ad12705fb717$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $1923ad12705fb717$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements, floatingId: floatingId } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', parentOrientation: parentOrientation, cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = (0, $85ea27aada64f9e6$export$9b0901b5e9b45fc7)(elements.floating);
    const floatingFocusElementRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(floatingFocusElement);
    const parentId = $1923ad12705fb717$export$165209eae06d3488();
    const tree = $1923ad12705fb717$export$db0c2a7c7a2a4f69();
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        context.dataRef.current.orientation = orientation;
    }, [
        context,
        orientation
    ]);
    const onNavigate = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)(()=>{
        unstable_onNavigate(indexRef.current === -1 ? null : indexRef.current);
    });
    const typeableComboboxReference = (0, $85ea27aada64f9e6$export$259ba5ae38188551)(elements.domReference);
    const focusItemOnOpenRef = $acw62.useRef(focusItemOnOpen);
    const indexRef = $acw62.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $acw62.useRef(null);
    const isPointerModalityRef = $acw62.useRef(true);
    const previousOnNavigateRef = $acw62.useRef(onNavigate);
    const previousMountedRef = $acw62.useRef(!!elements.floating);
    const previousOpenRef = $acw62.useRef(open);
    const forceSyncFocusRef = $acw62.useRef(false);
    const forceScrollIntoViewRef = $acw62.useRef(false);
    const disabledIndicesRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(disabledIndices);
    const latestOpenRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(open);
    const scrollItemIntoViewRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(scrollItemIntoView);
    const selectedIndexRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(selectedIndex);
    const [activeId, setActiveId] = $acw62.useState();
    const [virtualId, setVirtualId] = $acw62.useState();
    const focusItem = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)(()=>{
        function runFocus(item) {
            if (virtual) {
                var _item$id;
                if ((_item$id = item.id) != null && _item$id.endsWith('-fui-option')) item.id = floatingId + "-" + Math.random().toString(16).slice(2, 10);
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $1923ad12705fb717$var$enqueueFocus(item, {
                sync: forceSyncFocusRef.current,
                preventScroll: true
            });
        }
        const initialItem = listRef.current[indexRef.current];
        const forceScrollIntoView = forceScrollIntoViewRef.current;
        if (initialItem) runFocus(initialItem);
        const scheduler = forceSyncFocusRef.current ? (v)=>v() : requestAnimationFrame;
        scheduler(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate();
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current();
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!open) return;
        if (!elements.floating) return;
        if (activeIndex == null) {
            forceSyncFocusRef.current = false;
            if (selectedIndexRef.current != null) return;
            // Reset while the floating element was open (e.g. the list changed).
            if (previousMountedRef.current) {
                indexRef.current = -1;
                focusItem();
            }
            // Initial sync.
            if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                let runs = 0;
                const waitForListPopulated = ()=>{
                    if (listRef.current[0] == null) {
                        // Avoid letting the browser paint if possible on the first try,
                        // otherwise use rAF. Don't try more than twice, since something
                        // is wrong otherwise.
                        if (runs < 2) {
                            const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                            scheduler(waitForListPopulated);
                        }
                        runs++;
                    } else {
                        indexRef.current = keyRef.current == null || $1923ad12705fb717$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? (0, $85ea27aada64f9e6$export$53f691ee0acc6058)(listRef, disabledIndicesRef.current) : (0, $85ea27aada64f9e6$export$b585558af466e926)(listRef, disabledIndicesRef.current);
                        keyRef.current = null;
                        onNavigate();
                    }
                };
                waitForListPopulated();
            }
        } else if (!(0, $85ea27aada64f9e6$export$75effb89758ec596)(listRef, activeIndex)) {
            indexRef.current = activeIndex;
            focusItem();
            forceScrollIntoViewRef.current = false;
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $85ea27aada64f9e6$export$da980962bd2147a4)((0, $85ea27aada64f9e6$export$f65ca476c09acec0)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $85ea27aada64f9e6$export$2344b14b097df817)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousOpenRef.current = open;
        previousMountedRef.current = !!elements.floating;
    });
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (!open) {
            keyRef.current = null;
            focusItemOnOpenRef.current = focusItemOnOpen;
        }
    }, [
        open,
        focusItemOnOpen
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $acw62.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!latestOpenRef.current) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1 && indexRef.current !== index) {
                indexRef.current = index;
                onNavigate();
            }
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                forceSyncFocusRef.current = true;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            onMouseMove (_ref3) {
                let { currentTarget: currentTarget } = _ref3;
                forceSyncFocusRef.current = true;
                forceScrollIntoViewRef.current = false;
                if (focusItemOnHover) syncCurrentTarget(currentTarget);
            },
            onPointerLeave (_ref4) {
                let { pointerType: pointerType } = _ref4;
                if (!isPointerModalityRef.current || pointerType === 'touch') return;
                forceSyncFocusRef.current = true;
                if (!focusItemOnHover) return;
                indexRef.current = -1;
                onNavigate();
                if (!virtual) {
                    var _floatingFocusElement;
                    (_floatingFocusElement = floatingFocusElementRef.current) == null || _floatingFocusElement.focus({
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        latestOpenRef,
        floatingFocusElementRef,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const getParentOrientation = $acw62.useCallback(()=>{
        var _tree$nodesRef$curren;
        return parentOrientation != null ? parentOrientation : tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.dataRef) == null ? void 0 : _tree$nodesRef$curren.current.orientation;
    }, [
        parentId,
        tree,
        parentOrientation
    ]);
    const commonOnKeyDown = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocusRef.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $1923ad12705fb717$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols)) {
            // If the nested list's close key is also the parent navigation key,
            // let the parent navigate. Otherwise, stop propagating the event.
            if (!$1923ad12705fb717$var$isMainOrientationKey(event.key, getParentOrientation())) (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = (0, $85ea27aada64f9e6$export$53f691ee0acc6058)(listRef, disabledIndices);
        const maxIndex = (0, $85ea27aada64f9e6$export$b585558af466e926)(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                indexRef.current = minIndex;
                onNavigate();
            }
            if (event.key === 'End') {
                (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                indexRef.current = maxIndex;
                onNavigate();
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $85ea27aada64f9e6$export$5334c96856356f08)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $85ea27aada64f9e6$export$446656ed0410fd9)(listRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $85ea27aada64f9e6$export$446656ed0410fd9)(listRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[(0, $85ea27aada64f9e6$export$342fcce33a2688bc)({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $85ea27aada64f9e6$export$50d8709b2ccc23f9)([
                    ...(typeof disabledIndices !== 'function' ? disabledIndices : null) || listRef.current.map((_, index)=>(0, $85ea27aada64f9e6$export$446656ed0410fd9)(listRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $85ea27aada64f9e6$export$dab2b2ce7761f8e4)(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $1923ad12705fb717$var$ARROW_DOWN ? 'bl' : event.key === (rtl ? $1923ad12705fb717$var$ARROW_LEFT : $1923ad12705fb717$var$ARROW_RIGHT) ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate();
            }
            if (orientation === 'both') return;
        }
        if ($1923ad12705fb717$var$isMainOrientationKey(event.key, orientation)) {
            (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $85ea27aada64f9e6$export$da980962bd2147a4)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $1923ad12705fb717$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate();
                return;
            }
            if ($1923ad12705fb717$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : (0, $85ea27aada64f9e6$export$3fc3ea4a67cf714)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, (0, $85ea27aada64f9e6$export$3fc3ea4a67cf714)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : (0, $85ea27aada64f9e6$export$3fc3ea4a67cf714)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, (0, $85ea27aada64f9e6$export$3fc3ea4a67cf714)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ((0, $85ea27aada64f9e6$export$75effb89758ec596)(listRef, indexRef.current)) indexRef.current = -1;
            onNavigate();
        }
    });
    const ariaActiveDescendantProp = $acw62.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $acw62.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!typeableComboboxReference ? ariaActiveDescendantProp : {},
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        orientation,
        typeableComboboxReference
    ]);
    const reference = $acw62.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $85ea27aada64f9e6$export$60278871457622de)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $85ea27aada64f9e6$export$29bf1b5f2c56cf63)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $1923ad12705fb717$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $1923ad12705fb717$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols);
                const isParentCrossOpenKey = $1923ad12705fb717$var$isCrossOrientationOpenKey(event.key, getParentOrientation(), rtl);
                const isMainKey = $1923ad12705fb717$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isParentCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? (0, $85ea27aada64f9e6$export$e7e88d43cb97db79)(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) {
                    const isParentMainKey = $1923ad12705fb717$var$isMainOrientationKey(event.key, getParentOrientation());
                    keyRef.current = nested && isParentMainKey ? null : event.key;
                }
                if (nested) {
                    if (isParentCrossOpenKey) {
                        (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                        if (open) {
                            indexRef.current = (0, $85ea27aada64f9e6$export$53f691ee0acc6058)(listRef, disabledIndicesRef.current);
                            onNavigate();
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate();
                }
            },
            onFocus () {
                if (open && !virtual) {
                    indexRef.current = -1;
                    onNavigate();
                }
            },
            onPointerDown: checkVirtualPointer,
            onPointerEnter: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        cols,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        getParentOrientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $1923ad12705fb717$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $1923ad12705fb717$export$f66572793fa256a1(context, props) {
    var _elements$domReferenc, _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, elements: elements, floatingId: defaultFloatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const defaultReferenceId = $1923ad12705fb717$export$f680877a34711e37();
    const referenceId = ((_elements$domReferenc = elements.domReference) == null ? void 0 : _elements$domReferenc.id) || defaultReferenceId;
    const floatingId = $acw62.useMemo(()=>{
        var _getFloatingFocusElem;
        return ((_getFloatingFocusElem = (0, $85ea27aada64f9e6$export$9b0901b5e9b45fc7)(elements.floating)) == null ? void 0 : _getFloatingFocusElem.id) || defaultFloatingId;
    }, [
        elements.floating,
        defaultFloatingId
    ]);
    const ariaRole = (_componentRoleToAriaR = $1923ad12705fb717$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const parentId = $1923ad12705fb717$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $acw62.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return {
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined,
            ...ariaRole === 'listbox' && {
                role: 'combobox'
            },
            ...ariaRole === 'menu' && {
                id: referenceId
            },
            ...ariaRole === 'menu' && isNested && {
                role: 'menuitem'
            },
            ...role === 'select' && {
                'aria-autocomplete': 'none'
            },
            ...role === 'combobox' && {
                'aria-autocomplete': 'list'
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $acw62.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === 'menu' && {
                'aria-labelledby': referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $acw62.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: 'option',
            ...active && {
                id: floatingId + "-fui-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
            case 'combobox':
                return {
                    ...commonProps,
                    'aria-selected': selected
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $1923ad12705fb717$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $1923ad12705fb717$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $1923ad12705fb717$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $acw62.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $acw62.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $1923ad12705fb717$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $acw62.useState('unmounted');
    const isMounted = $1923ad12705fb717$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                // Ensure it opens before paint. With `FloatingDelayGroup`,
                // this avoids a flicker when moving between floating elements
                // to ensure one is always open with no missing frames.
                $1u0KT.flushSync(()=>{
                    setStatus('open');
                });
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $1923ad12705fb717$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $acw62.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $acw62.useState(()=>({
            ...$1923ad12705fb717$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$1923ad12705fb717$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $1923ad12705fb717$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(unstable_initial);
    const openRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(unstable_open);
    const closeRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(unstable_close);
    const commonRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(unstable_common);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        const initialStyles = $1923ad12705fb717$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $1923ad12705fb717$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $1923ad12705fb717$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $1923ad12705fb717$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($1923ad12705fb717$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($1923ad12705fb717$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $1923ad12705fb717$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $acw62.useRef(-1);
    const stringRef = $acw62.useRef('');
    const prevIndexRef = $acw62.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $acw62.useRef(null);
    const onMatch = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)(unstable_onMatch);
    const onTypingChange = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)(unstable_onTypingChange);
    const findMatchRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(findMatch);
    const ignoreKeysRef = (0, $85ea27aada64f9e6$export$bcd07ba85a740103)(ignoreKeys);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        if (open) {
            $1923ad12705fb717$var$clearTimeoutIfSet(timeoutIdRef);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    (0, $85ea27aada64f9e6$export$bb3b3b3acfd7447f)(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        $1923ad12705fb717$var$clearTimeoutIfSet(timeoutIdRef);
        timeoutIdRef.current = window.setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = $acw62.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $acw62.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $1923ad12705fb717$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ const $1923ad12705fb717$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(props, state);
            const { rects: rects, platform: platform, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $4cdaae7c2a5f3f0d$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await platform.detectOverflow($1923ad12705fb717$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await platform.detectOverflow(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = (0, $204931a4986f463b$export$8960430cfd85939f)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $204931a4986f463b$export$2077e0241d6afd3c);
            const maxHeight = rounder((0, $204931a4986f463b$export$8960430cfd85939f)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $204931a4986f463b$export$8960430cfd85939f)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $204931a4986f463b$export$96ec731ed4dcb222)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $1u0KT.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await platform.detectOverflow($1923ad12705fb717$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ function $1923ad12705fb717$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = (0, $85ea27aada64f9e6$export$7f54fc3180508a52)(unstable_onChange);
    const controlledScrollingRef = $acw62.useRef(false);
    const prevScrollTopRef = $acw62.useRef(null);
    const initialOverflowRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $1u0KT.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $85ea27aada64f9e6$export$7935961ef7719cb0)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $acw62.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $1u0KT.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $acw62.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $1923ad12705fb717$var$getNodeChildren(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...$1923ad12705fb717$var$getNodeChildren(nodes, child.id, onlyOpenChildren)
        ]);
}
function $1923ad12705fb717$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $1923ad12705fb717$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $1923ad12705fb717$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    const timeoutRef = {
        current: -1
    };
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = typeof performance !== 'undefined' ? performance.now() : 0;
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                $1923ad12705fb717$var$clearTimeoutIfSet(timeoutRef);
                onClose();
            }
            $1923ad12705fb717$var$clearTimeoutIfSet(timeoutRef);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = $1923ad12705fb717$var$getTarget(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = $1923ad12705fb717$var$contains(elements.floating, target);
            const isOverReferenceEl = $1923ad12705fb717$var$contains(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $1923ad12705fb717$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(event.relatedTarget) && $1923ad12705fb717$var$contains(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $1923ad12705fb717$var$getNodeChildren(tree.nodesRef.current, nodeId).length) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref2) {
                let [x, y] = _ref2;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($1923ad12705fb717$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$1923ad12705fb717$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutRef.current = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}


"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollArea.tsx
const $dffe8bd53d7188f1$var$defaultProps = {
    scrollHideDelay: 1e3,
    type: "hover",
    scrollbars: "xy"
};
const $dffe8bd53d7188f1$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { scrollbarSize: scrollbarSize, overscrollBehavior: overscrollBehavior, scrollbars: scrollbars })=>{
    let overrideOverscrollBehavior = overscrollBehavior;
    if (overscrollBehavior && scrollbars) {
        if (scrollbars === "x") overrideOverscrollBehavior = `${overscrollBehavior} auto`;
        else if (scrollbars === "y") overrideOverscrollBehavior = `auto ${overscrollBehavior}`;
    }
    return {
        root: {
            "--scrollarea-scrollbar-size": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(scrollbarSize),
            "--scrollarea-over-scroll-behavior": overrideOverscrollBehavior
        }
    };
});
const $dffe8bd53d7188f1$export$ccf8d8d7bbf3c2cc = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ScrollArea", $dffe8bd53d7188f1$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, scrollbarSize: scrollbarSize, vars: vars, type: type, scrollHideDelay: scrollHideDelay, viewportProps: viewportProps, viewportRef: viewportRef, onScrollPositionChange: onScrollPositionChange, children: children, offsetScrollbars: offsetScrollbars, scrollbars: scrollbars, onBottomReached: onBottomReached, onTopReached: onTopReached, onLeftReached: onLeftReached, onRightReached: onRightReached, overscrollBehavior: overscrollBehavior, startScrollPosition: startScrollPosition, attributes: attributes, ...others } = props;
    const [scrollbarHovered, setScrollbarHovered] = (0, $acw62.useState)(false);
    const [verticalThumbVisible, setVerticalThumbVisible] = (0, $acw62.useState)(false);
    const [horizontalThumbVisible, setHorizontalThumbVisible] = (0, $acw62.useState)(false);
    const prevAtTopRef = (0, $acw62.useRef)(true);
    const prevAtBottomRef = (0, $acw62.useRef)(false);
    const prevAtLeftRef = (0, $acw62.useRef)(true);
    const prevAtRightRef = (0, $acw62.useRef)(false);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "ScrollArea",
        props: props,
        classes: (0, $580479a53fd6266c$export$2e2bcd8739ae039),
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $dffe8bd53d7188f1$var$varsResolver
    });
    const localViewportRef = (0, $acw62.useRef)(null);
    const [viewportElement, setViewportElement] = (0, $acw62.useState)(null);
    const combinedViewportRef = (0, $1923ad12705fb717$export$74665b213cb5c4cf)([
        viewportRef,
        localViewportRef,
        (0, $acw62.useCallback)((node)=>{
            setViewportElement((current)=>current === node ? current : node);
        }, [])
    ]);
    (0, $132fa50acb2babc6$export$683480f191c0e3ea)(offsetScrollbars === "present" ? viewportElement : null, ()=>{
        const element = localViewportRef.current;
        if (element) {
            setVerticalThumbVisible(element.scrollHeight > element.clientHeight);
            setHorizontalThumbVisible(element.scrollWidth > element.clientWidth);
        }
    });
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        if (startScrollPosition && localViewportRef.current) localViewportRef.current.scrollTo({
            left: startScrollPosition.x ?? 0,
            top: startScrollPosition.y ?? 0
        });
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $e2df1435548fd2cc$export$f2a893fcd08ef34d), {
        getStyles: getStyles,
        type: type === "never" ? "always" : type,
        scrollHideDelay: scrollHideDelay,
        scrollbars: scrollbars,
        ...getStyles("root"),
        ...others,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6cec10d0bcac6dc0$export$a21cbf9f11fca853), {
                ...viewportProps,
                ...getStyles("viewport", {
                    style: viewportProps?.style
                }),
                ref: combinedViewportRef,
                "data-offset-scrollbars": offsetScrollbars === true ? "xy" : offsetScrollbars || void 0,
                "data-scrollbars": scrollbars || void 0,
                "data-horizontal-hidden": offsetScrollbars === "present" && !horizontalThumbVisible ? "true" : void 0,
                "data-vertical-hidden": offsetScrollbars === "present" && !verticalThumbVisible ? "true" : void 0,
                onScroll: (e)=>{
                    viewportProps?.onScroll?.(e);
                    onScrollPositionChange?.({
                        x: e.currentTarget.scrollLeft,
                        y: e.currentTarget.scrollTop
                    });
                    const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight, scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = e.currentTarget;
                    const isAtBottom = scrollTop - (scrollHeight - clientHeight) >= -0.8;
                    const isAtTop = scrollTop === 0;
                    if (isAtBottom && !prevAtBottomRef.current) onBottomReached?.();
                    if (isAtTop && !prevAtTopRef.current) onTopReached?.();
                    prevAtBottomRef.current = isAtBottom;
                    prevAtTopRef.current = isAtTop;
                    const isAtRight = scrollLeft - (scrollWidth - clientWidth) >= -0.8;
                    const isAtLeft = scrollLeft === 0;
                    if (isAtRight && !prevAtRightRef.current) onRightReached?.();
                    if (isAtLeft && !prevAtLeftRef.current) onLeftReached?.();
                    prevAtRightRef.current = isAtRight;
                    prevAtLeftRef.current = isAtLeft;
                },
                children: children
            }),
            (scrollbars === "xy" || scrollbars === "x") && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $11b5067cafb406ae$export$2fabd85d0eba3c57), {
                ...getStyles("scrollbar"),
                orientation: "horizontal",
                "data-hidden": type === "never" || offsetScrollbars === "present" && !horizontalThumbVisible ? true : void 0,
                forceMount: true,
                onMouseEnter: ()=>setScrollbarHovered(true),
                onMouseLeave: ()=>setScrollbarHovered(false),
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $81f0525478ce18ce$export$9fba1154677d7cd2), {
                    ...getStyles("thumb")
                })
            }),
            (scrollbars === "xy" || scrollbars === "y") && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $11b5067cafb406ae$export$2fabd85d0eba3c57), {
                ...getStyles("scrollbar"),
                orientation: "vertical",
                "data-hidden": type === "never" || offsetScrollbars === "present" && !verticalThumbVisible ? true : void 0,
                forceMount: true,
                onMouseEnter: ()=>setScrollbarHovered(true),
                onMouseLeave: ()=>setScrollbarHovered(false),
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $81f0525478ce18ce$export$9fba1154677d7cd2), {
                    ...getStyles("thumb")
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f537e37f6c0b850a$export$56969d565df7cc4b), {
                ...getStyles("corner"),
                "data-hovered": scrollbarHovered || void 0,
                "data-hidden": type === "never" || void 0
            })
        ]
    });
});
$dffe8bd53d7188f1$export$ccf8d8d7bbf3c2cc.displayName = "@mantine/core/ScrollArea";
const $dffe8bd53d7188f1$export$a7a962e3bd12ae1d = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props)=>{
    const { children: children, classNames: classNames, styles: styles, scrollbarSize: scrollbarSize, scrollHideDelay: scrollHideDelay, type: type, dir: dir, offsetScrollbars: offsetScrollbars, overscrollBehavior: overscrollBehavior, viewportRef: viewportRef, onScrollPositionChange: onScrollPositionChange, unstyled: unstyled, variant: variant, viewportProps: viewportProps, scrollbars: scrollbars, style: style, vars: vars, onBottomReached: onBottomReached, onTopReached: onTopReached, startScrollPosition: startScrollPosition, onOverflowChange: onOverflowChange, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ScrollAreaAutosize", $dffe8bd53d7188f1$var$defaultProps, props);
    const viewportObserverRef = (0, $acw62.useRef)(null);
    const [viewportObserverElement, setViewportObserverElement] = (0, $acw62.useState)(null);
    const combinedViewportRef = (0, $1923ad12705fb717$export$74665b213cb5c4cf)([
        viewportRef,
        viewportObserverRef,
        (0, $acw62.useCallback)((node)=>{
            setViewportObserverElement((current)=>current === node ? current : node);
        }, [])
    ]);
    const overflowingRef = (0, $acw62.useRef)(false);
    const didMountRef = (0, $acw62.useRef)(false);
    const handleOverflowCheck = (0, $acw62.useEffectEvent)(()=>{
        const el = viewportObserverRef.current;
        if (!el || !onOverflowChange) return;
        const isOverflowing = el.scrollHeight > el.clientHeight;
        if (isOverflowing !== overflowingRef.current) {
            if (didMountRef.current) onOverflowChange(isOverflowing);
            else {
                didMountRef.current = true;
                if (isOverflowing) onOverflowChange(true);
            }
            overflowingRef.current = isOverflowing;
        }
    });
    (0, $132fa50acb2babc6$export$683480f191c0e3ea)(onOverflowChange ? viewportObserverElement : null, handleOverflowCheck);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...others,
        variant: variant,
        style: [
            {
                display: "flex",
                overflow: "hidden"
            },
            style
        ],
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
            style: {
                display: "flex",
                flexDirection: "column",
                flex: 1,
                overflow: "hidden",
                ...scrollbars === "y" && {
                    minWidth: 0
                },
                ...scrollbars === "x" && {
                    minHeight: 0
                },
                ...scrollbars === "xy" && {
                    minWidth: 0,
                    minHeight: 0
                },
                ...scrollbars === false && {
                    minWidth: 0,
                    minHeight: 0
                }
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($dffe8bd53d7188f1$export$ccf8d8d7bbf3c2cc, {
                classNames: classNames,
                styles: styles,
                scrollHideDelay: scrollHideDelay,
                scrollbarSize: scrollbarSize,
                type: type,
                dir: dir,
                offsetScrollbars: offsetScrollbars,
                overscrollBehavior: overscrollBehavior,
                viewportRef: combinedViewportRef,
                onScrollPositionChange: onScrollPositionChange,
                unstyled: unstyled,
                variant: variant,
                viewportProps: viewportProps,
                vars: vars,
                scrollbars: scrollbars,
                onBottomReached: onBottomReached,
                onTopReached: onTopReached,
                startScrollPosition: startScrollPosition,
                "data-autosize": "true",
                children: children
            })
        })
    });
});
$dffe8bd53d7188f1$export$ccf8d8d7bbf3c2cc.classes = (0, $580479a53fd6266c$export$2e2bcd8739ae039);
$dffe8bd53d7188f1$export$ccf8d8d7bbf3c2cc.varsResolver = $dffe8bd53d7188f1$var$varsResolver;
$dffe8bd53d7188f1$export$a7a962e3bd12ae1d.displayName = "@mantine/core/ScrollAreaAutosize";
$dffe8bd53d7188f1$export$a7a962e3bd12ae1d.classes = (0, $580479a53fd6266c$export$2e2bcd8739ae039);
$dffe8bd53d7188f1$export$ccf8d8d7bbf3c2cc.Autosize = $dffe8bd53d7188f1$export$a7a962e3bd12ae1d;










var $acw62 = parcelRequire("acw62");



var $1u0KT = parcelRequire("1u0KT");
"use client";
//#region packages/@mantine/core/src/components/Portal/Portal.tsx
function $8764181c19a03e13$var$createPortalNode(props) {
    const node = document.createElement("div");
    node.setAttribute("data-portal", "true");
    typeof props.className === "string" && node.classList.add(...props.className.split(" ").filter(Boolean));
    typeof props.style === "object" && Object.assign(node.style, props.style);
    typeof props.id === "string" && node.setAttribute("id", props.id);
    return node;
}
function $8764181c19a03e13$var$getTargetNode({ target: target, reuseTargetNode: reuseTargetNode, ...others }) {
    if (target) {
        if (typeof target === "string") return document.querySelector(target) || $8764181c19a03e13$var$createPortalNode(others);
        return target;
    }
    if (reuseTargetNode) {
        const existingNode = document.querySelector("[data-mantine-shared-portal-node]");
        if (existingNode) return existingNode;
        const node = $8764181c19a03e13$var$createPortalNode(others);
        node.setAttribute("data-mantine-shared-portal-node", "true");
        document.body.appendChild(node);
        return node;
    }
    return $8764181c19a03e13$var$createPortalNode(others);
}
const $8764181c19a03e13$var$defaultProps = {
    reuseTargetNode: true
};
const $8764181c19a03e13$export$602eac185826482c = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props)=>{
    const { children: children, target: target, reuseTargetNode: reuseTargetNode, ref: ref, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Portal", $8764181c19a03e13$var$defaultProps, props);
    const [mounted, setMounted] = (0, $acw62.useState)(false);
    const nodeRef = (0, $acw62.useRef)(null);
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        setMounted(true);
        nodeRef.current = $8764181c19a03e13$var$getTargetNode({
            target: target,
            reuseTargetNode: reuseTargetNode,
            ...others
        });
        (0, $7034a45159125c0b$export$d734136a7b018efe)(ref, nodeRef.current);
        if (!target && !reuseTargetNode && nodeRef.current) document.body.appendChild(nodeRef.current);
        return ()=>{
            if (!target && !reuseTargetNode && nodeRef.current) document.body.removeChild(nodeRef.current);
        };
    }, [
        target
    ]);
    if (!mounted || !nodeRef.current) return null;
    return (0, $1u0KT.createPortal)(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    }), nodeRef.current);
});
$8764181c19a03e13$export$602eac185826482c.displayName = "@mantine/core/Portal";



"use client";
//#region packages/@mantine/core/src/components/Portal/OptionalPortal.tsx
const $c40c05f34c6cea16$export$425106c5d6e6dc37 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)(({ withinPortal: withinPortal = true, children: children, ...others })=>{
    if ((0, $bbb97275c373484a$export$2a0cf0a5fd0c6e81)() === "test" || !withinPortal) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8764181c19a03e13$export$602eac185826482c), {
        ...others,
        children: children
    });
});
$c40c05f34c6cea16$export$425106c5d6e6dc37.displayName = "@mantine/core/OptionalPortal";




var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/ModalBase/use-lock-scroll.ts
function $4d41452b7a78dc51$export$6be872921498f185({ opened: opened, transitionDuration: transitionDuration }) {
    const [shouldLockScroll, setShouldLockScroll] = (0, $acw62.useState)(opened);
    const timeout = (0, $acw62.useRef)(-1);
    const _transitionDuration = (0, $91a4302ee7795ed2$export$6a42007cf1e7b6f8)() ? 0 : transitionDuration;
    (0, $acw62.useEffect)(()=>{
        if (opened) {
            setShouldLockScroll(true);
            window.clearTimeout(timeout.current);
        } else if (_transitionDuration === 0) setShouldLockScroll(false);
        else timeout.current = window.setTimeout(()=>setShouldLockScroll(false), _transitionDuration);
        return ()=>window.clearTimeout(timeout.current);
    }, [
        opened,
        _transitionDuration
    ]);
    return shouldLockScroll;
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-focus-return/use-focus-return.ts
function $f4823e3369c057aa$export$275f09232623ff6f({ opened: opened, shouldReturnFocus: shouldReturnFocus = true }) {
    const lastActiveElement = (0, $acw62.useRef)(null);
    const returnFocus = ()=>{
        if (lastActiveElement.current && "focus" in lastActiveElement.current && typeof lastActiveElement.current.focus === "function") lastActiveElement.current?.focus({
            preventScroll: true
        });
    };
    (0, $d9273517323905a9$export$e34ed88fef4dc107)(()=>{
        let timeout = -1;
        const clearFocusTimeout = (event)=>{
            if (event.key === "Tab") window.clearTimeout(timeout);
        };
        document.addEventListener("keydown", clearFocusTimeout);
        if (opened) lastActiveElement.current = document.activeElement;
        else if (shouldReturnFocus) {
            const activeElementAtClose = document.activeElement;
            timeout = window.setTimeout(()=>{
                const currentActiveElement = document.activeElement;
                if (currentActiveElement === null || currentActiveElement === document.body || currentActiveElement === activeElementAtClose) returnFocus();
            }, 10);
        }
        return ()=>{
            window.clearTimeout(timeout);
            document.removeEventListener("keydown", clearFocusTimeout);
        };
    }, [
        opened,
        shouldReturnFocus
    ]);
    return returnFocus;
}




var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-id/use-id.ts
function $cee42e5537afff93$export$f680877a34711e37(staticId) {
    const [uuid, setUuid] = (0, $acw62.useState)(`mantine-${(0, $acw62.useId)().replace(/:/g, "")}`);
    const hasInitializedRef = (0, $acw62.useRef)(false);
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        if (hasInitializedRef.current) return;
        hasInitializedRef.current = true;
        setUuid((0, $9e1d22b9666695e5$export$5e699d18035b41af)());
    }, []);
    if (typeof staticId === "string") return staticId;
    return uuid;
}


var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-window-event/use-window-event.ts
function $f73e1d55da1ebeeb$export$ee579bb285b8d4aa(type, listener, options) {
    const stableListener = (0, $acw62.useEffectEvent)(listener);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener(type, stableListener, options);
        return ()=>window.removeEventListener(type, stableListener, options);
    }, [
        type
    ]);
}


"use client";
//#region packages/@mantine/core/src/components/ModalBase/use-modal.ts
function $077126358bce20dd$export$33ffd74ebf07f060({ id: id, transitionProps: transitionProps, opened: opened, trapFocus: trapFocus, closeOnEscape: closeOnEscape, onClose: onClose, returnFocus: returnFocus }) {
    const _id = (0, $cee42e5537afff93$export$f680877a34711e37)(id);
    const [titleMounted, setTitleMounted] = (0, $acw62.useState)(false);
    const [bodyMounted, setBodyMounted] = (0, $acw62.useState)(false);
    const shouldLockScroll = (0, $4d41452b7a78dc51$export$6be872921498f185)({
        opened: opened,
        transitionDuration: typeof transitionProps?.duration === "number" ? transitionProps?.duration : 200
    });
    (0, $f73e1d55da1ebeeb$export$ee579bb285b8d4aa)("keydown", (event)=>{
        if (event.key === "Escape" && closeOnEscape && !event.isComposing && opened) event.target?.getAttribute("data-mantine-stop-propagation") !== "true" && onClose();
    }, {
        capture: true
    });
    (0, $f4823e3369c057aa$export$275f09232623ff6f)({
        opened: opened,
        shouldReturnFocus: trapFocus && returnFocus
    });
    return {
        _id: _id,
        titleMounted: titleMounted,
        bodyMounted: bodyMounted,
        shouldLockScroll: shouldLockScroll,
        setTitleMounted: setTitleMounted,
        setBodyMounted: setBodyMounted
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $a0acfd416da73b8a$var$extendStatics = function(d, b) {
    $a0acfd416da73b8a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a0acfd416da73b8a$var$extendStatics(d, b);
};
function $a0acfd416da73b8a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a0acfd416da73b8a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a0acfd416da73b8a$export$18ce0697a983be9b = function() {
    $a0acfd416da73b8a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a0acfd416da73b8a$export$18ce0697a983be9b.apply(this, arguments);
};
function $a0acfd416da73b8a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a0acfd416da73b8a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a0acfd416da73b8a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a0acfd416da73b8a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a0acfd416da73b8a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a0acfd416da73b8a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a0acfd416da73b8a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a0acfd416da73b8a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a0acfd416da73b8a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a0acfd416da73b8a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a0acfd416da73b8a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a0acfd416da73b8a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a0acfd416da73b8a$export$45d3717a4c69092e(o, m, p);
}
function $a0acfd416da73b8a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a0acfd416da73b8a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a0acfd416da73b8a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a0acfd416da73b8a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a0acfd416da73b8a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a0acfd416da73b8a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a0acfd416da73b8a$export$10c90e4f7922046c(v) {
    return this instanceof $a0acfd416da73b8a$export$10c90e4f7922046c ? (this.v = v, this) : new $a0acfd416da73b8a$export$10c90e4f7922046c(v);
}
function $a0acfd416da73b8a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a0acfd416da73b8a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a0acfd416da73b8a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a0acfd416da73b8a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a0acfd416da73b8a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a0acfd416da73b8a$export$19a8beecd37a4c45 === "function" ? $a0acfd416da73b8a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a0acfd416da73b8a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a0acfd416da73b8a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $a0acfd416da73b8a$var$ownKeys = function(o) {
    $a0acfd416da73b8a$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $a0acfd416da73b8a$var$ownKeys(o);
};
function $a0acfd416da73b8a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $a0acfd416da73b8a$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $a0acfd416da73b8a$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $a0acfd416da73b8a$var$__setModuleDefault(result, mod);
    return result;
}
function $a0acfd416da73b8a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a0acfd416da73b8a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a0acfd416da73b8a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a0acfd416da73b8a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a0acfd416da73b8a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a0acfd416da73b8a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a0acfd416da73b8a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a0acfd416da73b8a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $a0acfd416da73b8a$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $a0acfd416da73b8a$export$2e2bcd8739ae039 = {
    __extends: $a0acfd416da73b8a$export$a8ba968b8961cb8a,
    __assign: $a0acfd416da73b8a$export$18ce0697a983be9b,
    __rest: $a0acfd416da73b8a$export$3c9a16f847548506,
    __decorate: $a0acfd416da73b8a$export$29e00dfd3077644b,
    __param: $a0acfd416da73b8a$export$d5ad3fd78186038f,
    __esDecorate: $a0acfd416da73b8a$export$3a84e1ae4e97e9b0,
    __runInitializers: $a0acfd416da73b8a$export$d831c04e792af3d,
    __propKey: $a0acfd416da73b8a$export$6a2a36740a146cb8,
    __setFunctionName: $a0acfd416da73b8a$export$d1a06452d3489bc7,
    __metadata: $a0acfd416da73b8a$export$f1db080c865becb9,
    __awaiter: $a0acfd416da73b8a$export$1050f835b63b671e,
    __generator: $a0acfd416da73b8a$export$67ebef60e6f28a6,
    __createBinding: $a0acfd416da73b8a$export$45d3717a4c69092e,
    __exportStar: $a0acfd416da73b8a$export$f33643c0debef087,
    __values: $a0acfd416da73b8a$export$19a8beecd37a4c45,
    __read: $a0acfd416da73b8a$export$8d051b38c9118094,
    __spread: $a0acfd416da73b8a$export$afc72e2116322959,
    __spreadArrays: $a0acfd416da73b8a$export$6388937ca91ccae8,
    __spreadArray: $a0acfd416da73b8a$export$1216008129fb82ed,
    __await: $a0acfd416da73b8a$export$10c90e4f7922046c,
    __asyncGenerator: $a0acfd416da73b8a$export$e427f37a30a4de9b,
    __asyncDelegator: $a0acfd416da73b8a$export$bbd80228419bb833,
    __asyncValues: $a0acfd416da73b8a$export$e3b29a3d6162315f,
    __makeTemplateObject: $a0acfd416da73b8a$export$4fb47efe1390b86f,
    __importStar: $a0acfd416da73b8a$export$c21735bcef00d192,
    __importDefault: $a0acfd416da73b8a$export$da59b14a69baef04,
    __classPrivateFieldGet: $a0acfd416da73b8a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a0acfd416da73b8a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a0acfd416da73b8a$export$81fdc39f203e4e04,
    __addDisposableResource: $a0acfd416da73b8a$export$88ac25d8e944e405,
    __disposeResources: $a0acfd416da73b8a$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $a0acfd416da73b8a$export$889dfb5d17574b0b
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';



var $acw62 = parcelRequire("acw62");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $f6d5b57f3512e73c$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};




var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $acw62.createElement(Target, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};


function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $1334c25f36aeceaf$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $be1d9ed5bb532264$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $b5f767dd03f483e5$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9f2b7a700f678519$var$Style = (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $3f8d56f1a38c65c8$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $3f8d56f1a38c65c8$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9f2b7a700f678519$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $9f2b7a700f678519$export$a1939b1f9f9b02dc = function() {
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, ($9f2b7a700f678519$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9f2b7a700f678519$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
            else document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $9f2b7a700f678519$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $19c77eb414ad2a19$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};







var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;


var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowY');
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowX');
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState((0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
        var selection = window.getSelection();
        var anchorNode = selection && selection.anchorNode;
        var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
        if (isTouchingSelection) return false;
        var canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $a7f277057d6643d0$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $f5f147098910888d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener('touchmove', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener('touchstart', scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener('touchmove', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $f5f147098910888d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $f6d5b57f3512e73c$export$e27363444bedfeac), (0, $f5f147098910888d$export$a09dbff87b5da2d));


var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $cac2578984d345ac$export$22940b497e769dee), (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $0e88b28988758ab2$export$2e2bcd8739ae039)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $cac2578984d345ac$export$22940b497e769dee).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;



"use client";
//#region packages/@mantine/core/src/components/ModalBase/ModalBase.tsx
function $cf609d56b9141a65$export$acabb5bd2b72d092({ keepMounted: keepMounted, keepMountedMode: keepMountedMode = "activity", opened: opened, onClose: onClose, id: id, transitionProps: transitionProps, onExitTransitionEnd: onExitTransitionEnd, onEnterTransitionEnd: onEnterTransitionEnd, trapFocus: trapFocus, closeOnEscape: closeOnEscape, returnFocus: returnFocus, closeOnClickOutside: closeOnClickOutside, withinPortal: withinPortal, portalProps: portalProps, lockScroll: lockScroll, children: children, zIndex: zIndex, shadow: shadow, padding: padding, __vars: __vars, unstyled: unstyled, removeScrollProps: removeScrollProps, ...others }) {
    const { _id: _id, titleMounted: titleMounted, bodyMounted: bodyMounted, shouldLockScroll: shouldLockScroll, setTitleMounted: setTitleMounted, setBodyMounted: setBodyMounted } = (0, $077126358bce20dd$export$33ffd74ebf07f060)({
        id: id,
        transitionProps: transitionProps,
        opened: opened,
        trapFocus: trapFocus,
        closeOnEscape: closeOnEscape,
        onClose: onClose,
        returnFocus: returnFocus
    });
    const { key: removeScrollKey, ...otherRemoveScrollProps } = removeScrollProps || {};
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c40c05f34c6cea16$export$425106c5d6e6dc37), {
        ...portalProps,
        withinPortal: withinPortal,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $fe9617635751bdba$export$695854637ffea3cb), {
            value: {
                opened: opened,
                onClose: onClose,
                closeOnClickOutside: closeOnClickOutside,
                onExitTransitionEnd: onExitTransitionEnd,
                onEnterTransitionEnd: onEnterTransitionEnd,
                transitionProps: {
                    ...transitionProps,
                    keepMounted: keepMounted,
                    keepMountedMode: keepMountedMode
                },
                getTitleId: ()=>`${_id}-title`,
                getBodyId: ()=>`${_id}-body`,
                titleMounted: titleMounted,
                bodyMounted: bodyMounted,
                setTitleMounted: setTitleMounted,
                setBodyMounted: setBodyMounted,
                trapFocus: trapFocus,
                closeOnEscape: closeOnEscape,
                zIndex: zIndex,
                unstyled: unstyled
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
                enabled: shouldLockScroll && lockScroll,
                ...otherRemoveScrollProps,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                    ...others,
                    id: _id,
                    __vars: {
                        ...__vars,
                        "--mb-z-index": (zIndex || (0, $f4b868e08831abbf$export$65573e7d509c92dc)("modal")).toString(),
                        "--mb-shadow": (0, $fcab4af601ce7e99$export$db93b77dbb14f011)(shadow),
                        "--mb-padding": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(padding)
                    },
                    children: children
                })
            }, removeScrollKey)
        })
    });
}
$cf609d56b9141a65$export$acabb5bd2b72d092.displayName = "@mantine/core/ModalBase";





"use client";
//#region packages/@mantine/core/src/components/Modal/ModalRoot.tsx
const $5c4afba21fad19e5$var$defaultProps = {
    __staticSelector: "Modal",
    closeOnClickOutside: true,
    withinPortal: true,
    lockScroll: true,
    trapFocus: true,
    returnFocus: true,
    closeOnEscape: true,
    keepMounted: false,
    zIndex: (0, $f4b868e08831abbf$export$65573e7d509c92dc)("modal"),
    transitionProps: {
        duration: 200,
        transition: "fade-down"
    },
    yOffset: "5dvh"
};
const $5c4afba21fad19e5$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { radius: radius, size: size, yOffset: yOffset, xOffset: xOffset })=>({
        root: {
            "--modal-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--modal-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "modal-size"),
            "--modal-y-offset": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(yOffset),
            "--modal-x-offset": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(xOffset)
        }
    }));
const $5c4afba21fad19e5$export$76630a3be18d4dc4 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ModalRoot", $5c4afba21fad19e5$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, yOffset: yOffset, scrollAreaComponent: scrollAreaComponent, radius: radius, fullScreen: fullScreen, centered: centered, xOffset: xOffset, __staticSelector: __staticSelector, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: __staticSelector,
        classes: (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039),
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $5c4afba21fad19e5$var$varsResolver
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $1874173f3d3e2272$export$178405afcd8c5eb), {
        value: {
            yOffset: yOffset,
            scrollAreaComponent: scrollAreaComponent,
            getStyles: getStyles,
            fullScreen: fullScreen
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cf609d56b9141a65$export$acabb5bd2b72d092), {
            ...getStyles("root"),
            "data-full-screen": fullScreen || void 0,
            "data-centered": centered || void 0,
            "data-offset-scrollbars": scrollAreaComponent === (0, $dffe8bd53d7188f1$export$ccf8d8d7bbf3c2cc).Autosize || void 0,
            unstyled: unstyled,
            ...others
        })
    });
});
$5c4afba21fad19e5$export$76630a3be18d4dc4.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$5c4afba21fad19e5$export$76630a3be18d4dc4.varsResolver = $5c4afba21fad19e5$var$varsResolver;
$5c4afba21fad19e5$export$76630a3be18d4dc4.displayName = "@mantine/core/ModalRoot";




var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/Modal/ModalStack.tsx
const $16a15d13af72c85c$export$4f2bcc810fdb9bbb = (0, $acw62.createContext)(null);
function $16a15d13af72c85c$export$34a5ac21fcda39c3({ children: children }) {
    const [stack, setStack] = (0, $acw62.useState)([]);
    const [maxZIndex, setMaxZIndex] = (0, $acw62.useState)((0, $f4b868e08831abbf$export$65573e7d509c92dc)("modal"));
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($16a15d13af72c85c$export$4f2bcc810fdb9bbb, {
        value: {
            stack: stack,
            addModal: (id, zIndex)=>{
                setStack((current)=>[
                        ...new Set([
                            ...current,
                            id
                        ])
                    ]);
                setMaxZIndex((current)=>typeof zIndex === "number" && typeof current === "number" ? Math.max(current, zIndex) : current);
            },
            removeModal: (id)=>setStack((current)=>current.filter((currentId)=>currentId !== id)),
            getZIndex: (id)=>`calc(${maxZIndex} + ${stack.indexOf(id)} + 1)`,
            currentId: stack[stack.length - 1],
            maxZIndex: maxZIndex
        },
        children: children
    });
}
$16a15d13af72c85c$export$34a5ac21fcda39c3.displayName = "@mantine/core/ModalStack";









var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/components/ModalBase/use-modal-title-id.ts
function $224fbbd1388458db$export$40f4ca977bb60074() {
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    (0, $acw62.useEffect)(()=>{
        ctx.setTitleMounted(true);
        return ()=>ctx.setTitleMounted(false);
    }, []);
    return ctx.getTitleId();
}




"use client";
//#region packages/@mantine/core/src/components/ModalBase/ModalBaseTitle.tsx
function $07ac7932ab612e37$export$a1d3732afcf18148({ className: className, ...others }) {
    const id = (0, $224fbbd1388458db$export$40f4ca977bb60074)();
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "h2",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
            [(0, $ed1030d453965fd5$export$2e2bcd8739ae039).title]: !ctx.unstyled
        }, className),
        id: id,
        ...others
    });
}
$07ac7932ab612e37$export$a1d3732afcf18148.displayName = "@mantine/core/ModalBaseTitle";





"use client";
//#region packages/@mantine/core/src/components/Modal/ModalTitle.tsx
const $5e540156043d8c03$export$b26fae16ba5468aa = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ModalTitle", null, _props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $07ac7932ab612e37$export$a1d3732afcf18148), {
        ...(0, $1874173f3d3e2272$export$4cc1699d46f42cae)().getStyles("title", {
            classNames: classNames,
            style: style,
            styles: styles,
            className: className
        }),
        ...others
    });
});
$5e540156043d8c03$export$b26fae16ba5468aa.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$5e540156043d8c03$export$b26fae16ba5468aa.displayName = "@mantine/core/ModalTitle";



var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/Modal/Modal.tsx
const $b1b81586258b47fb$var$defaultProps = {
    closeOnClickOutside: true,
    withinPortal: true,
    lockScroll: true,
    trapFocus: true,
    returnFocus: true,
    closeOnEscape: true,
    keepMounted: false,
    zIndex: (0, $f4b868e08831abbf$export$65573e7d509c92dc)("modal"),
    transitionProps: {
        duration: 200,
        transition: "fade-down"
    },
    withOverlay: true,
    withCloseButton: true
};
const $b1b81586258b47fb$export$2b77a92f1a5ad772 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { title: title, withOverlay: withOverlay, overlayProps: overlayProps, withCloseButton: withCloseButton, closeButtonProps: closeButtonProps, children: children, radius: radius, opened: opened, stackId: stackId, zIndex: zIndex, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Modal", $b1b81586258b47fb$var$defaultProps, _props);
    const ctx = (0, $acw62.use)((0, $16a15d13af72c85c$export$4f2bcc810fdb9bbb));
    const hasHeader = !!title || withCloseButton;
    const stackProps = ctx && stackId ? {
        closeOnEscape: ctx.currentId === stackId,
        trapFocus: ctx.currentId === stackId,
        zIndex: ctx.getZIndex(stackId)
    } : {};
    const overlayVisible = withOverlay === false ? false : stackId && ctx ? ctx.currentId === stackId : opened;
    (0, $acw62.useEffect)(()=>{
        if (ctx && stackId) opened ? ctx.addModal(stackId, zIndex || (0, $f4b868e08831abbf$export$65573e7d509c92dc)("modal")) : ctx.removeModal(stackId);
    }, [
        opened,
        stackId,
        zIndex
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $5c4afba21fad19e5$export$76630a3be18d4dc4), {
        radius: radius,
        opened: opened,
        zIndex: ctx && stackId ? ctx.getZIndex(stackId) : zIndex,
        ...others,
        ...stackProps,
        children: [
            withOverlay && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $913f345f895164ed$export$8948f78d83984c69), {
                visible: overlayVisible,
                transitionProps: ctx && stackId ? {
                    duration: 0
                } : void 0,
                ...overlayProps
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $5a867aa53d8adb6b$export$6da19a24bf249f17), {
                radius: radius,
                __hidden: ctx && stackId && opened ? stackId !== ctx.currentId : false,
                children: [
                    hasHeader && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $33aea0631d2029a1$export$f50a68e3694789ee), {
                        children: [
                            title && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $5e540156043d8c03$export$b26fae16ba5468aa), {
                                children: title
                            }),
                            withCloseButton && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $35769c8ec5687fff$export$edf9108895ba774f), {
                                ...closeButtonProps
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $5d2fa167359bcff9$export$cb540d8b0ef7906c), {
                        children: children
                    })
                ]
            })
        ]
    });
});
$b1b81586258b47fb$export$2b77a92f1a5ad772.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$b1b81586258b47fb$export$2b77a92f1a5ad772.displayName = "@mantine/core/Modal";
$b1b81586258b47fb$export$2b77a92f1a5ad772.Root = (0, $5c4afba21fad19e5$export$76630a3be18d4dc4);
$b1b81586258b47fb$export$2b77a92f1a5ad772.Overlay = (0, $913f345f895164ed$export$8948f78d83984c69);
$b1b81586258b47fb$export$2b77a92f1a5ad772.Content = (0, $5a867aa53d8adb6b$export$6da19a24bf249f17);
$b1b81586258b47fb$export$2b77a92f1a5ad772.Body = (0, $5d2fa167359bcff9$export$cb540d8b0ef7906c);
$b1b81586258b47fb$export$2b77a92f1a5ad772.Header = (0, $33aea0631d2029a1$export$f50a68e3694789ee);
$b1b81586258b47fb$export$2b77a92f1a5ad772.Title = (0, $5e540156043d8c03$export$b26fae16ba5468aa);
$b1b81586258b47fb$export$2b77a92f1a5ad772.CloseButton = (0, $35769c8ec5687fff$export$edf9108895ba774f);
$b1b81586258b47fb$export$2b77a92f1a5ad772.Stack = (0, $16a15d13af72c85c$export$34a5ac21fcda39c3);




"use client";
//#region packages/@mantine/modals/src/ModalsProvider.tsx
function $a1d8e70ac2325fe5$var$separateConfirmModalProps(props) {
    if (!props) return {
        confirmProps: {},
        modalProps: {}
    };
    const { id: id, children: children, onCancel: onCancel, onConfirm: onConfirm, closeOnConfirm: closeOnConfirm, closeOnCancel: closeOnCancel, cancelProps: cancelProps, confirmProps: confirmProps, groupProps: groupProps, labels: labels, ...others } = props;
    return {
        confirmProps: {
            id: id,
            children: children,
            onCancel: onCancel,
            onConfirm: onConfirm,
            closeOnConfirm: closeOnConfirm,
            closeOnCancel: closeOnCancel,
            cancelProps: cancelProps,
            confirmProps: confirmProps,
            groupProps: groupProps,
            labels: labels
        },
        modalProps: {
            id: id,
            ...others
        }
    };
}
function $a1d8e70ac2325fe5$export$d130e6a5a0bde89c({ children: children, modalProps: modalProps, labels: labels, modals: modals }) {
    const [state, dispatch] = (0, $acw62.useReducer)((0, $9bae518c51f5a3e4$export$c732e1f962e199dd), {
        modals: [],
        current: null
    });
    const stateRef = (0, $acw62.useRef)(state);
    stateRef.current = state;
    const closingRef = (0, $acw62.useRef)(false);
    const closeAll = (0, $acw62.useCallback)((canceled)=>{
        if (!closingRef.current) {
            closingRef.current = true;
            stateRef.current.modals.concat().reverse().forEach((modal)=>{
                (0, $9bae518c51f5a3e4$export$5c038338ec3229b7)(modal, canceled);
            });
            closingRef.current = false;
        }
        dispatch({
            type: "CLOSE_ALL",
            canceled: canceled
        });
    }, [
        stateRef,
        dispatch
    ]);
    const openModal = (0, $acw62.useCallback)(({ modalId: modalId, ...props })=>{
        const id = modalId || (0, $9e1d22b9666695e5$export$5e699d18035b41af)();
        dispatch({
            type: "OPEN",
            modal: {
                id: id,
                type: "content",
                props: props
            }
        });
        return id;
    }, [
        dispatch
    ]);
    const openConfirmModal = (0, $acw62.useCallback)(({ modalId: modalId, ...props })=>{
        const id = modalId || (0, $9e1d22b9666695e5$export$5e699d18035b41af)();
        dispatch({
            type: "OPEN",
            modal: {
                id: id,
                type: "confirm",
                props: props
            }
        });
        return id;
    }, [
        dispatch
    ]);
    const openContextModal = (0, $acw62.useCallback)((modal, { modalId: modalId, ...props })=>{
        const id = modalId || (0, $9e1d22b9666695e5$export$5e699d18035b41af)();
        dispatch({
            type: "OPEN",
            modal: {
                id: id,
                type: "context",
                props: props,
                ctx: modal
            }
        });
        return id;
    }, [
        dispatch
    ]);
    const closeModal = (0, $acw62.useCallback)((id, canceled)=>{
        if (!closingRef.current) {
            const modal = stateRef.current.modals.find((m)=>m.id === id);
            if (modal) {
                closingRef.current = true;
                (0, $9bae518c51f5a3e4$export$5c038338ec3229b7)(modal, canceled);
                closingRef.current = false;
            }
        }
        dispatch({
            type: "CLOSE",
            modalId: id,
            canceled: canceled
        });
    }, [
        stateRef,
        dispatch
    ]);
    const updateModal = (0, $acw62.useCallback)(({ modalId: modalId, ...newProps })=>{
        dispatch({
            type: "UPDATE",
            modalId: modalId,
            newProps: newProps
        });
    }, [
        dispatch
    ]);
    const updateContextModal = (0, $acw62.useCallback)(({ modalId: modalId, ...newProps })=>{
        dispatch({
            type: "UPDATE",
            modalId: modalId,
            newProps: newProps
        });
    }, [
        dispatch
    ]);
    (0, $6de41693d1c89b64$export$f52b16a0182e6eb)({
        openModal: openModal,
        openConfirmModal: openConfirmModal,
        openContextModal: ({ modal: modal, ...payload })=>openContextModal(modal, payload),
        closeModal: closeModal,
        closeContextModal: closeModal,
        closeAllModals: closeAll,
        updateModal: updateModal,
        updateContextModal: updateContextModal
    });
    const ctx = {
        modalProps: modalProps || {},
        modals: state.modals,
        openModal: openModal,
        openConfirmModal: openConfirmModal,
        openContextModal: openContextModal,
        closeModal: closeModal,
        closeContextModal: closeModal,
        closeAll: closeAll,
        updateModal: updateModal,
        updateContextModal: updateContextModal
    };
    const getCurrentModal = ()=>{
        const currentModal = stateRef.current.current;
        switch(currentModal?.type){
            case "context":
                {
                    const { innerProps: innerProps, ...rest } = currentModal.props;
                    const ContextModal = modals[currentModal.ctx];
                    return {
                        modalProps: rest,
                        content: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ContextModal, {
                            innerProps: innerProps,
                            context: ctx,
                            id: currentModal.id
                        })
                    };
                }
            case "confirm":
                {
                    const { modalProps: separatedModalProps, confirmProps: separatedConfirmProps } = $a1d8e70ac2325fe5$var$separateConfirmModalProps(currentModal.props);
                    return {
                        modalProps: separatedModalProps,
                        content: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4d2824ce73eaaf80$export$8eec1a3a911975a4), {
                            ...separatedConfirmProps,
                            id: currentModal.id,
                            labels: currentModal.props.labels || labels
                        })
                    };
                }
            case "content":
                {
                    const { children: currentModalChildren, ...rest } = currentModal.props;
                    return {
                        modalProps: rest,
                        content: currentModalChildren
                    };
                }
            default:
                return {
                    modalProps: {},
                    content: null
                };
        }
    };
    const { modalProps: currentModalProps, content: content } = getCurrentModal();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $263b364e1d2529cf$export$e5a070ff20f0f776), {
        value: ctx,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b1b81586258b47fb$export$2b77a92f1a5ad772), {
                zIndex: (0, $f4b868e08831abbf$export$65573e7d509c92dc)("modal") + 1,
                ...modalProps,
                ...currentModalProps,
                opened: state.modals.length > 0,
                onClose: ()=>closeModal(state.current?.id),
                children: content
            }),
            children
        ]
    });
}




var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/store/src/store.ts
function $3367205d37370099$export$f51a9068ac82ea43(initialState) {
    let state = initialState;
    let initialized = false;
    const listeners = /* @__PURE__ */ new Set();
    return {
        getState () {
            return state;
        },
        updateState (value) {
            state = typeof value === "function" ? value(state) : value;
        },
        setState (value) {
            this.updateState(value);
            listeners.forEach((listener)=>listener(state));
        },
        initialize (value) {
            if (!initialized) {
                state = value;
                initialized = true;
            }
        },
        subscribe (callback) {
            listeners.add(callback);
            return ()=>listeners.delete(callback);
        }
    };
}
function $3367205d37370099$export$6ccbb43953eebf8(store) {
    return (0, $acw62.useSyncExternalStore)(store.subscribe, ()=>store.getState(), ()=>store.getState());
}


"use client";
//#region packages/@mantine/notifications/src/notifications.store.ts
let $92225eae00b0597b$var$notificationSequence = 0;
function $92225eae00b0597b$var$getDistributedNotifications(data, defaultPosition, limit) {
    const queue = [];
    const notifications = [];
    const groups = /* @__PURE__ */ new Map();
    for (const item of data){
        const position = item.position || defaultPosition;
        const group = groups.get(position);
        if (group) group.push(item);
        else groups.set(position, [
            item
        ]);
    }
    for (const group of groups.values()){
        group.sort((a, b)=>(b.priority ?? 0) - (a.priority ?? 0) || (a.__sequence ?? 0) - (b.__sequence ?? 0));
        group.forEach((item, index)=>{
            if (index < limit) notifications.push(item);
            else queue.push(item);
        });
    }
    return {
        notifications: notifications,
        queue: queue
    };
}
const $92225eae00b0597b$export$db12807f427ec6f3 = ()=>(0, $3367205d37370099$export$f51a9068ac82ea43)({
        notifications: [],
        queue: [],
        defaultPosition: "bottom-right",
        limit: 5
    });
const $92225eae00b0597b$export$21b66e234e71aa95 = $92225eae00b0597b$export$db12807f427ec6f3();
const $92225eae00b0597b$export$53d5ca6c3f53e109 = (store = $92225eae00b0597b$export$21b66e234e71aa95)=>(0, $3367205d37370099$export$6ccbb43953eebf8)(store);
function $92225eae00b0597b$export$9bb80b35752a5f05(store, update) {
    const state = store.getState();
    const notifications = update([
        ...state.notifications,
        ...state.queue
    ]);
    for (const item of notifications)if (item.__sequence === void 0) {
        item.__sequence = $92225eae00b0597b$var$notificationSequence;
        $92225eae00b0597b$var$notificationSequence += 1;
    }
    const updated = $92225eae00b0597b$var$getDistributedNotifications(notifications, state.defaultPosition, state.limit);
    store.setState({
        notifications: updated.notifications,
        queue: updated.queue,
        limit: state.limit,
        defaultPosition: state.defaultPosition
    });
}
function $92225eae00b0597b$export$f7dc72e91f29c7d7(notification, store = $92225eae00b0597b$export$21b66e234e71aa95) {
    const id = notification.id || (0, $9e1d22b9666695e5$export$5e699d18035b41af)();
    $92225eae00b0597b$export$9bb80b35752a5f05(store, (notifications)=>{
        if (notification.id && notifications.some((n)=>n.id === notification.id)) return notifications;
        return [
            ...notifications,
            {
                ...notification,
                id: id
            }
        ];
    });
    return id;
}
function $92225eae00b0597b$export$87f1090575f0067e(id, store = $92225eae00b0597b$export$21b66e234e71aa95) {
    $92225eae00b0597b$export$9bb80b35752a5f05(store, (notifications)=>notifications.filter((notification)=>{
            if (notification.id === id) {
                notification.onClose?.(notification);
                return false;
            }
            return true;
        }));
    return id;
}
function $92225eae00b0597b$export$31ce28e5754d2c6a(notification, store = $92225eae00b0597b$export$21b66e234e71aa95) {
    $92225eae00b0597b$export$9bb80b35752a5f05(store, (notifications)=>notifications.map((item)=>{
            if (item.id === notification.id) return {
                ...item,
                ...notification
            };
            return item;
        }));
    return notification.id;
}
function $92225eae00b0597b$export$3087239f422bfe3f(store = $92225eae00b0597b$export$21b66e234e71aa95) {
    $92225eae00b0597b$export$9bb80b35752a5f05(store, ()=>[]);
}
function $92225eae00b0597b$export$c6f8234126274c80(store = $92225eae00b0597b$export$21b66e234e71aa95) {
    const { defaultPosition: defaultPosition, limit: limit } = store.getState();
    $92225eae00b0597b$export$9bb80b35752a5f05(store, (notifications)=>$92225eae00b0597b$var$getDistributedNotifications(notifications, defaultPosition, limit).notifications);
}
const $92225eae00b0597b$export$6008d97729a90c74 = {
    show: $92225eae00b0597b$export$f7dc72e91f29c7d7,
    hide: $92225eae00b0597b$export$87f1090575f0067e,
    update: $92225eae00b0597b$export$31ce28e5754d2c6a,
    clean: $92225eae00b0597b$export$3087239f422bfe3f,
    cleanQueue: $92225eae00b0597b$export$c6f8234126274c80,
    updateState: $92225eae00b0597b$export$9bb80b35752a5f05
};


"use client";
//#region packages/@mantine/notifications/src/get-grouped-notifications/get-grouped-notifications.ts
const $30df0d36aa9f19ca$export$878041e1e4cd4218 = [
    "bottom-center",
    "bottom-left",
    "bottom-right",
    "top-center",
    "top-left",
    "top-right"
];
function $30df0d36aa9f19ca$export$d5321ec32efed55a(notifications, defaultPosition) {
    return notifications.reduce((acc, notification)=>{
        acc[notification.position || defaultPosition].push(notification);
        return acc;
    }, $30df0d36aa9f19ca$export$878041e1e4cd4218.reduce((acc, item)=>{
        acc[item] = [];
        return acc;
    }, {}));
}


"use client";
//#region packages/@mantine/notifications/src/get-notification-state-styles.ts
const $5fd0cf466c982a50$var$transforms = {
    left: "translateX(-100%)",
    right: "translateX(100%)",
    "top-center": "translateY(-100%)",
    "bottom-center": "translateY(100%)"
};
const $5fd0cf466c982a50$var$noTransform = {
    left: "translateX(0)",
    right: "translateX(0)",
    "top-center": "translateY(0)",
    "bottom-center": "translateY(0)"
};
function $5fd0cf466c982a50$export$2139e2d0d570f849({ state: state, maxHeight: maxHeight, position: position, transitionDuration: transitionDuration }) {
    const [vertical, horizontal] = position.split("-");
    const property = horizontal === "center" ? `${vertical}-center` : horizontal;
    const commonStyles = {
        opacity: 0,
        maxHeight: maxHeight,
        transform: $5fd0cf466c982a50$var$transforms[property],
        transitionDuration: `${transitionDuration}ms, ${transitionDuration}ms, ${transitionDuration}ms`,
        transitionTimingFunction: "cubic-bezier(.51,.3,0,1.21), cubic-bezier(.51,.3,0,1.21), linear",
        transitionProperty: "opacity, transform, max-height"
    };
    const inState = {
        opacity: 1,
        transform: $5fd0cf466c982a50$var$noTransform[property]
    };
    const outState = {
        opacity: 0,
        maxHeight: 0,
        transform: $5fd0cf466c982a50$var$transforms[property]
    };
    const transitionStyles = {
        entering: inState,
        entered: inState,
        exiting: outState,
        exited: outState
    };
    return {
        ...commonStyles,
        ...transitionStyles[state]
    };
}


"use client";
//#region packages/@mantine/notifications/src/get-auto-close/get-auto-close.ts
function $952c15f5334196e8$export$41f752814752ebd1(autoClose, notificationAutoClose) {
    if (typeof notificationAutoClose === "number") return notificationAutoClose;
    if (notificationAutoClose === false || autoClose === false) return false;
    return autoClose;
}



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-drag/use-drag.ts
const $0bbd225a490c498b$var$VELOCITY_DECAY_MS = 100;
function $0bbd225a490c498b$var$sign(n) {
    if (n > 0) return 1;
    if (n < 0) return -1;
    return 0;
}
function $0bbd225a490c498b$var$getThresholdVector(threshold) {
    const t = threshold ?? 0;
    if (typeof t === "number") return [
        t,
        t
    ];
    return t;
}
function $0bbd225a490c498b$var$createInitialState() {
    return {
        isActive: false,
        pointerId: -1,
        startXY: [
            0,
            0
        ],
        prevXY: [
            0,
            0
        ],
        startTimestamp: 0,
        prevTimestamp: 0,
        thresholdMet: false,
        firstFired: false,
        lockedAxis: null,
        canceled: false,
        lastVelocity: [
            0,
            0
        ]
    };
}
function $0bbd225a490c498b$export$7941f8aafa4b6021(handler, options = {}) {
    const [active, setActive] = (0, $acw62.useState)(false);
    const handlerRef = (0, $acw62.useRef)(handler);
    handlerRef.current = handler;
    const optionsRef = (0, $acw62.useRef)(options);
    optionsRef.current = options;
    const stateRef = (0, $acw62.useRef)($0bbd225a490c498b$var$createInitialState());
    const documentControllerRef = (0, $acw62.useRef)(null);
    return {
        ref: (0, $acw62.useCallback)((node)=>{
            if (!node) return;
            const elementController = new AbortController();
            const applyAxisConstraint = (v)=>{
                const opts = optionsRef.current;
                const s = stateRef.current;
                if (opts.axis === "x") return [
                    v[0],
                    0
                ];
                if (opts.axis === "y") return [
                    0,
                    v[1]
                ];
                if (opts.axis === "lock") {
                    if (s.lockedAxis === null) {
                        const t = opts.axisThreshold ?? 1;
                        if (Math.abs(v[0]) > t || Math.abs(v[1]) > t) s.lockedAxis = Math.abs(v[0]) >= Math.abs(v[1]) ? "x" : "y";
                    }
                    if (s.lockedAxis === "x") return [
                        v[0],
                        0
                    ];
                    if (s.lockedAxis === "y") return [
                        0,
                        v[1]
                    ];
                }
                return v;
            };
            const resetDrag = ()=>{
                const s = stateRef.current;
                s.isActive = false;
                s.pointerId = -1;
                s.thresholdMet = false;
                s.firstFired = false;
                s.lockedAxis = null;
                s.canceled = false;
                setActive(false);
                document.body.style.userSelect = "";
                document.body.style.webkitUserSelect = "";
                documentControllerRef.current?.abort();
                documentControllerRef.current = null;
            };
            const cancel = ()=>{
                if (stateRef.current.isActive) {
                    stateRef.current.canceled = true;
                    resetDrag();
                }
            };
            const activateDrag = ()=>{
                setActive(true);
                document.body.style.userSelect = "none";
                document.body.style.webkitUserSelect = "none";
            };
            const onPointerDown = (event)=>{
                if (optionsRef.current.enabled === false) return;
                if (event.button !== 0) return;
                if (stateRef.current.isActive) return;
                const s = stateRef.current;
                s.isActive = true;
                s.pointerId = event.pointerId;
                s.startXY = [
                    event.clientX,
                    event.clientY
                ];
                s.prevXY = [
                    event.clientX,
                    event.clientY
                ];
                s.startTimestamp = event.timeStamp;
                s.prevTimestamp = event.timeStamp;
                s.thresholdMet = false;
                s.firstFired = false;
                s.lockedAxis = null;
                s.canceled = false;
                s.lastVelocity = [
                    0,
                    0
                ];
                const [tx, ty] = $0bbd225a490c498b$var$getThresholdVector(optionsRef.current.threshold);
                if (tx === 0 && ty === 0) {
                    s.thresholdMet = true;
                    s.firstFired = true;
                    activateDrag();
                    handlerRef.current({
                        xy: [
                            event.clientX,
                            event.clientY
                        ],
                        initial: [
                            event.clientX,
                            event.clientY
                        ],
                        movement: [
                            0,
                            0
                        ],
                        delta: [
                            0,
                            0
                        ],
                        distance: [
                            0,
                            0
                        ],
                        direction: [
                            0,
                            0
                        ],
                        velocity: [
                            0,
                            0
                        ],
                        elapsedTime: 0,
                        first: true,
                        last: false,
                        active: true,
                        tap: false,
                        canceled: false,
                        cancel: cancel,
                        event: event
                    });
                }
                documentControllerRef.current?.abort();
                documentControllerRef.current = new AbortController();
                const sig = documentControllerRef.current.signal;
                document.addEventListener("pointermove", onPointerMove, {
                    signal: sig
                });
                document.addEventListener("pointerup", onPointerUp, {
                    signal: sig
                });
                document.addEventListener("pointercancel", onPointerCancel, {
                    signal: sig
                });
            };
            const onPointerMove = (event)=>{
                const s = stateRef.current;
                if (!s.isActive || event.pointerId !== s.pointerId) return;
                const rawMovement = [
                    event.clientX - s.startXY[0],
                    event.clientY - s.startXY[1]
                ];
                if (!s.thresholdMet) {
                    const [tx, ty] = $0bbd225a490c498b$var$getThresholdVector(optionsRef.current.threshold);
                    if (Math.abs(rawMovement[0]) < tx && Math.abs(rawMovement[1]) < ty) {
                        s.prevXY = [
                            event.clientX,
                            event.clientY
                        ];
                        s.prevTimestamp = event.timeStamp;
                        return;
                    }
                    s.thresholdMet = true;
                    activateDrag();
                }
                const movement = applyAxisConstraint(rawMovement);
                const delta = applyAxisConstraint([
                    event.clientX - s.prevXY[0],
                    event.clientY - s.prevXY[1]
                ]);
                const timeDelta = event.timeStamp - s.prevTimestamp;
                const velocity = timeDelta > 0 ? [
                    Math.abs(delta[0]) / timeDelta,
                    Math.abs(delta[1]) / timeDelta
                ] : s.lastVelocity;
                s.lastVelocity = velocity;
                const isFirst = !s.firstFired;
                s.firstFired = true;
                s.prevXY = [
                    event.clientX,
                    event.clientY
                ];
                s.prevTimestamp = event.timeStamp;
                handlerRef.current({
                    xy: [
                        event.clientX,
                        event.clientY
                    ],
                    initial: [
                        ...s.startXY
                    ],
                    movement: movement,
                    delta: delta,
                    distance: [
                        Math.abs(movement[0]),
                        Math.abs(movement[1])
                    ],
                    direction: [
                        $0bbd225a490c498b$var$sign(delta[0]),
                        $0bbd225a490c498b$var$sign(delta[1])
                    ],
                    velocity: velocity,
                    elapsedTime: event.timeStamp - s.startTimestamp,
                    first: isFirst,
                    last: false,
                    active: true,
                    tap: false,
                    canceled: false,
                    cancel: cancel,
                    event: event
                });
            };
            const onPointerUp = (event)=>{
                const s = stateRef.current;
                if (!s.isActive || event.pointerId !== s.pointerId) return;
                const opts = optionsRef.current;
                if (!s.thresholdMet) {
                    if (opts.filterTaps) {
                        const mov = applyAxisConstraint([
                            event.clientX - s.startXY[0],
                            event.clientY - s.startXY[1]
                        ]);
                        const dist = [
                            Math.abs(mov[0]),
                            Math.abs(mov[1])
                        ];
                        const isTap = Math.max(dist[0], dist[1]) < (opts.tapThreshold ?? 3);
                        handlerRef.current({
                            xy: [
                                event.clientX,
                                event.clientY
                            ],
                            initial: [
                                ...s.startXY
                            ],
                            movement: mov,
                            delta: mov,
                            distance: dist,
                            direction: [
                                $0bbd225a490c498b$var$sign(mov[0]),
                                $0bbd225a490c498b$var$sign(mov[1])
                            ],
                            velocity: [
                                0,
                                0
                            ],
                            elapsedTime: event.timeStamp - s.startTimestamp,
                            first: true,
                            last: true,
                            active: false,
                            tap: isTap,
                            canceled: false,
                            cancel: cancel,
                            event: event
                        });
                    }
                    resetDrag();
                    return;
                }
                const movement = applyAxisConstraint([
                    event.clientX - s.startXY[0],
                    event.clientY - s.startXY[1]
                ]);
                const distance = [
                    Math.abs(movement[0]),
                    Math.abs(movement[1])
                ];
                const delta = applyAxisConstraint([
                    event.clientX - s.prevXY[0],
                    event.clientY - s.prevXY[1]
                ]);
                const velocity = event.timeStamp - s.prevTimestamp > $0bbd225a490c498b$var$VELOCITY_DECAY_MS ? [
                    0,
                    0
                ] : s.lastVelocity;
                const maxDistance = Math.max(distance[0], distance[1]);
                const tap = opts.filterTaps === true && maxDistance < (opts.tapThreshold ?? 3);
                handlerRef.current({
                    xy: [
                        event.clientX,
                        event.clientY
                    ],
                    initial: [
                        ...s.startXY
                    ],
                    movement: movement,
                    delta: delta,
                    distance: distance,
                    direction: [
                        $0bbd225a490c498b$var$sign(delta[0]),
                        $0bbd225a490c498b$var$sign(delta[1])
                    ],
                    velocity: velocity,
                    elapsedTime: event.timeStamp - s.startTimestamp,
                    first: !s.firstFired,
                    last: true,
                    active: false,
                    tap: tap,
                    canceled: false,
                    cancel: cancel,
                    event: event
                });
                resetDrag();
            };
            const onPointerCancel = (event)=>{
                const s = stateRef.current;
                if (!s.isActive || event.pointerId !== s.pointerId) return;
                const movement = applyAxisConstraint([
                    event.clientX - s.startXY[0],
                    event.clientY - s.startXY[1]
                ]);
                handlerRef.current({
                    xy: [
                        event.clientX,
                        event.clientY
                    ],
                    initial: [
                        ...s.startXY
                    ],
                    movement: movement,
                    delta: [
                        0,
                        0
                    ],
                    distance: [
                        Math.abs(movement[0]),
                        Math.abs(movement[1])
                    ],
                    direction: [
                        0,
                        0
                    ],
                    velocity: [
                        0,
                        0
                    ],
                    elapsedTime: event.timeStamp - s.startTimestamp,
                    first: !s.firstFired,
                    last: true,
                    active: false,
                    tap: false,
                    canceled: true,
                    cancel: cancel,
                    event: event
                });
                resetDrag();
            };
            node.addEventListener("pointerdown", onPointerDown, {
                signal: elementController.signal
            });
            return ()=>{
                elementController.abort();
                documentControllerRef.current?.abort();
                documentControllerRef.current = null;
                if (stateRef.current.isActive) {
                    stateRef.current.isActive = false;
                    setActive(false);
                    document.body.style.userSelect = "";
                    document.body.style.webkitUserSelect = "";
                }
            };
        }, []),
        active: active
    };
}



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/core/Box/get-style-object/get-style-object.ts
function $9f77ba4d5177d71b$export$6dbbdf4a0acaecb4(style, theme) {
    if (Array.isArray(style)) return [
        ...style
    ].reduce((acc, item)=>({
            ...acc,
            ...$9f77ba4d5177d71b$export$6dbbdf4a0acaecb4(item, theme)
        }), {});
    if (typeof style === "function") return style(theme);
    if (style == null) return {};
    return style;
}










"use client";
//#region packages/@mantine/core/src/components/Notification/Notification.module.css
var $172c445fc605a0d2$export$2e2bcd8739ae039 = {
    "root": "m_a513464",
    "icon": "m_a4ceffb",
    "loader": "m_b0920b15",
    "body": "m_a49ed24",
    "title": "m_3feedf16",
    "description": "m_3d733a3a",
    "closeButton": "m_919a4d88"
};



"use client";
//#region packages/@mantine/core/src/components/Notification/Notification.tsx
const $324be376d87a9898$var$defaultProps = {
    withCloseButton: true
};
const $324be376d87a9898$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { radius: radius, color: color })=>({
        root: {
            "--notification-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--notification-color": color ? (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(color, theme) : void 0
        }
    }));
const $324be376d87a9898$export$14834abbfce3b8cd = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Notification", $324be376d87a9898$var$defaultProps, _props);
    const { className: className, color: color, radius: radius, loading: loading, withCloseButton: withCloseButton, withBorder: withBorder, title: title, icon: icon, children: children, onClose: onClose, closeButtonProps: closeButtonProps, classNames: classNames, style: style, styles: styles, unstyled: unstyled, vars: vars, mod: mod, loaderProps: loaderProps, role: role, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Notification",
        classes: (0, $172c445fc605a0d2$export$2e2bcd8739ae039),
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $324be376d87a9898$var$varsResolver
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...getStyles("root"),
        mod: [
            {
                "data-with-icon": !!icon || loading,
                "data-with-border": withBorder
            },
            mod
        ],
        role: role || "alert",
        ...others,
        children: [
            icon && !loading && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...getStyles("icon"),
                children: icon
            }),
            loading && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f943dfe4129424c6$export$3b0d6d7590275603), {
                size: 28,
                color: color,
                ...getStyles("loader"),
                ...loaderProps
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ...getStyles("body"),
                children: [
                    title && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                        ...getStyles("title"),
                        children: title
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                        ...getStyles("description"),
                        mod: {
                            "data-with-title": !!title
                        },
                        children: children
                    })
                ]
            }),
            withCloseButton && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $30da360a5c87638a$export$de65de8213222d10), {
                iconSize: 16,
                color: "gray",
                ...closeButtonProps,
                unstyled: unstyled,
                onClick: (event)=>{
                    closeButtonProps?.onClick?.(event);
                    onClose?.();
                },
                ...getStyles("closeButton")
            })
        ]
    });
});
$324be376d87a9898$export$14834abbfce3b8cd.classes = (0, $172c445fc605a0d2$export$2e2bcd8739ae039);
$324be376d87a9898$export$14834abbfce3b8cd.varsResolver = $324be376d87a9898$var$varsResolver;
$324be376d87a9898$export$14834abbfce3b8cd.displayName = "@mantine/core/Notification";



"use client";
//#region packages/@mantine/notifications/src/NotificationContainer.tsx
const $2cc5a47b53d862ca$var$SCROLL_DISMISS_RESET_TIMEOUT = 120;
function $2cc5a47b53d862ca$export$aef1c47d6b127917({ data: data, onHide: onHide, autoClose: autoClose, transitionDuration: transitionDuration, allowDragDismiss: allowDragDismiss, allowScrollDismiss: allowScrollDismiss, paused: paused, onHoverStart: onHoverStart, onHoverEnd: onHoverEnd, ref: ref, style: style, ...others }) {
    const [offset, setOffset] = (0, $acw62.useState)(0);
    const [dismissed, setDismissed] = (0, $acw62.useState)(false);
    const [dismissDirection, setDismissDirection] = (0, $acw62.useState)(1);
    const [scrollDismissActive, setScrollDismissActive] = (0, $acw62.useState)(false);
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const { autoClose: _autoClose, message: message, allowClose: allowClose, position: _position, style: dataStyle, withCloseButton: withCloseButton, onOpen: _onOpen, priority: _priority, __sequence: _sequence, ...notificationProps } = data;
    const autoCloseDuration = (0, $952c15f5334196e8$export$41f752814752ebd1)(autoClose, data.autoClose);
    const autoCloseTimeout = (0, $acw62.useRef)(-1);
    const hideTimeout = (0, $acw62.useRef)(-1);
    const scrollDismissTimeout = (0, $acw62.useRef)(-1);
    const notificationRef = (0, $acw62.useRef)(null);
    const hoveredRef = (0, $acw62.useRef)(false);
    const offsetRef = (0, $acw62.useRef)(0);
    const isCloseDisabled = allowClose === false;
    const cancelAutoClose = ()=>window.clearTimeout(autoCloseTimeout.current);
    const cancelHide = ()=>window.clearTimeout(hideTimeout.current);
    const cancelScrollDismissReset = ()=>window.clearTimeout(scrollDismissTimeout.current);
    const setSwipeOffset = (value)=>{
        offsetRef.current = value;
        setOffset(value);
    };
    const handleHide = ()=>{
        onHide(data.id);
        cancelAutoClose();
        cancelHide();
        cancelScrollDismissReset();
    };
    const handleAutoClose = ()=>{
        if (dismissed || active || paused || hoveredRef.current || typeof autoCloseDuration !== "number") return;
        cancelAutoClose();
        autoCloseTimeout.current = window.setTimeout(handleHide, autoCloseDuration);
    };
    const getExitOffset = (direction)=>{
        return direction * ((notificationRef.current?.offsetWidth ?? 440) + 40);
    };
    const shouldDismiss = (movement, velocity)=>{
        const width = notificationRef.current?.offsetWidth ?? 440;
        return Math.abs(movement) > width * .35 || velocity > .5;
    };
    const resetSwipe = ()=>{
        cancelScrollDismissReset();
        setScrollDismissActive(false);
        setSwipeOffset(0);
    };
    const dismissNotification = (direction)=>{
        setDismissDirection(direction);
        setDismissed(true);
        setScrollDismissActive(false);
        setSwipeOffset(getExitOffset(direction));
        cancelAutoClose();
        cancelHide();
        cancelScrollDismissReset();
        hideTimeout.current = window.setTimeout(handleHide, transitionDuration);
    };
    const scheduleScrollDismissReset = ()=>{
        cancelScrollDismissReset();
        scrollDismissTimeout.current = window.setTimeout(()=>{
            setScrollDismissActive(false);
            setSwipeOffset(0);
            handleAutoClose();
        }, $2cc5a47b53d862ca$var$SCROLL_DISMISS_RESET_TIMEOUT);
    };
    const { ref: dragRef, active: active } = (0, $0bbd225a490c498b$export$7941f8aafa4b6021)((state)=>{
        if (dismissed) return;
        if (state.first) cancelAutoClose();
        if (state.last) {
            if (state.tap || state.canceled) {
                setSwipeOffset(0);
                handleAutoClose();
                return;
            }
            const movement = state.movement[0];
            const direction = movement === 0 ? state.direction[0] === -1 ? -1 : 1 : movement > 0 ? 1 : -1;
            if (shouldDismiss(movement, state.velocity[0])) dismissNotification(direction);
            else {
                setSwipeOffset(0);
                handleAutoClose();
            }
        } else setSwipeOffset(state.movement[0]);
    }, {
        axis: "x",
        threshold: 5,
        filterTaps: true,
        enabled: allowDragDismiss && !isCloseDisabled && !dismissed
    });
    const mergedRef = (0, $7034a45159125c0b$export$36a55fa7500f01f)(ref, notificationRef, dragRef);
    const resolvedStyle = (0, $9f77ba4d5177d71b$export$6dbbdf4a0acaecb4)(style, theme);
    const resolvedDataStyle = (0, $9f77ba4d5177d71b$export$6dbbdf4a0acaecb4)(dataStyle, theme);
    const baseStyle = {
        ...resolvedStyle,
        ...resolvedDataStyle
    };
    const baseOpacity = typeof baseStyle.opacity === "number" ? baseStyle.opacity : 1;
    const swipeOpacity = dismissed ? 0 : 1 - Math.min(Math.abs(offset) / 200, 1) * .6;
    const resolvedTransitionDuration = baseStyle.transitionDuration ?? `${transitionDuration}ms, ${transitionDuration}ms, ${transitionDuration}ms`;
    const notificationStyle = {
        ...baseStyle,
        ["--notifications-state-transform"]: typeof baseStyle.transform === "string" ? baseStyle.transform : "translateX(0)",
        ["--notifications-state-opacity"]: String(baseOpacity),
        ["--notifications-swipe-offset"]: `${offset}px`,
        ["--notifications-swipe-opacity"]: String(swipeOpacity),
        transform: "var(--notifications-state-transform) translate3d(var(--notifications-swipe-offset), 0, 0)",
        opacity: "calc(var(--notifications-state-opacity) * var(--notifications-swipe-opacity))",
        transitionDuration: active || scrollDismissActive ? "0ms, 0ms, 0ms" : resolvedTransitionDuration,
        cursor: "default",
        touchAction: "pan-y"
    };
    const handleMouseEnter = ()=>{
        hoveredRef.current = true;
        cancelAutoClose();
        onHoverStart?.();
    };
    const handleMouseLeave = ()=>{
        hoveredRef.current = false;
        if (!scrollDismissActive) {
            resetSwipe();
            handleAutoClose();
        }
        onHoverEnd?.();
    };
    const handleWheel = (0, $acw62.useEffectEvent)((event)=>{
        if (dismissed || active) return;
        const isDocumentEvent = event.currentTarget === document;
        if (!isDocumentEvent && !hoveredRef.current) return;
        const { deltaX: deltaX, deltaY: deltaY } = event;
        if (Math.abs(deltaX) <= Math.abs(deltaY) || deltaX === 0) return;
        if (!allowScrollDismiss || isCloseDisabled) return;
        if (!isDocumentEvent) {
            event.preventDefault();
            event.stopPropagation();
        }
        cancelAutoClose();
        setScrollDismissActive(true);
        const nextOffset = offsetRef.current - deltaX;
        const direction = nextOffset > 0 ? 1 : -1;
        if (shouldDismiss(nextOffset, 0)) {
            dismissNotification(direction);
            return;
        }
        setSwipeOffset(nextOffset);
        scheduleScrollDismissReset();
    });
    (0, $acw62.useEffect)(()=>{
        if (!scrollDismissActive) return;
        document.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return ()=>document.removeEventListener("wheel", handleWheel, {
                passive: false
            });
    }, [
        scrollDismissActive
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleResize = ()=>{
            if (dismissed) setSwipeOffset(getExitOffset(dismissDirection));
        };
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        dismissDirection,
        dismissed
    ]);
    (0, $acw62.useEffect)(()=>{
        const node = notificationRef.current;
        if (!node) return;
        node.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return ()=>node.removeEventListener("wheel", handleWheel, {
                passive: false
            });
    }, []);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            cancelHide();
            cancelScrollDismissReset();
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        data.onOpen?.(data);
    }, []);
    (0, $acw62.useEffect)(()=>{
        handleAutoClose();
        return cancelAutoClose;
    }, [
        autoCloseDuration,
        active,
        dismissed
    ]);
    (0, $acw62.useEffect)(()=>{
        if (paused) cancelAutoClose();
        else handleAutoClose();
        return cancelAutoClose;
    }, [
        paused
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $324be376d87a9898$export$14834abbfce3b8cd), {
        ref: mergedRef,
        ...others,
        style: notificationStyle,
        ...notificationProps,
        withCloseButton: isCloseDisabled ? false : withCloseButton,
        onClose: handleHide,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: message
    });
}
$2cc5a47b53d862ca$export$aef1c47d6b127917.displayName = "@mantine/notifications/NotificationContainer";


"use client";
//#region packages/@mantine/notifications/src/Notifications.module.css
var $a78bfbe7bf01f519$export$2e2bcd8739ae039 = {
    "root": "m_b37d9ac7",
    "notification": "m_5ed0edd0"
};



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-force-update/use-force-update.ts
const $aaffb9e6ba2a5054$var$reducer = (value)=>(value + 1) % 1e6;
function $aaffb9e6ba2a5054$export$91db9bc4f8ac944a() {
    const [, update] = (0, $acw62.useReducer)($aaffb9e6ba2a5054$var$reducer, 0);
    return update;
}



var $acw62 = parcelRequire("acw62");
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}


function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, 'appear', props),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', props),
            exit: $04540450bf60efa1$var$getProp(child, 'exit', props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $04540450bf60efa1$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $04540450bf60efa1$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $04540450bf60efa1$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;




"use client";
//#region packages/@mantine/notifications/src/Notifications.tsx
const $adfe52a85354f23c$var$Transition$1 = (0, $0fef977f04119bf5$export$2e2bcd8739ae039);
const $adfe52a85354f23c$var$defaultProps = {
    position: "bottom-right",
    autoClose: 4e3,
    transitionDuration: 250,
    allowDragDismiss: true,
    allowScrollDismiss: true,
    containerWidth: 440,
    notificationMaxHeight: 200,
    limit: 5,
    zIndex: (0, $f4b868e08831abbf$export$65573e7d509c92dc)("overlay"),
    store: (0, $92225eae00b0597b$export$21b66e234e71aa95),
    withinPortal: true,
    pauseResetOnHover: "all"
};
const $adfe52a85354f23c$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { zIndex: zIndex, containerWidth: containerWidth })=>({
        root: {
            "--notifications-z-index": zIndex?.toString(),
            "--notifications-container-width": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(containerWidth)
        }
    }));
const $adfe52a85354f23c$export$36ba2f559d49a8f6 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Notifications", $adfe52a85354f23c$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, attributes: attributes, position: position, autoClose: autoClose, transitionDuration: transitionDuration, allowDragDismiss: allowDragDismiss, allowScrollDismiss: allowScrollDismiss, containerWidth: containerWidth, notificationMaxHeight: notificationMaxHeight, limit: limit, zIndex: zIndex, store: store, portalProps: portalProps, withinPortal: withinPortal, pauseResetOnHover: pauseResetOnHover, ...others } = props;
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const data = (0, $92225eae00b0597b$export$53d5ca6c3f53e109)(store);
    const forceUpdate = (0, $aaffb9e6ba2a5054$export$91db9bc4f8ac944a)();
    const shouldReduceMotion = (0, $91a4302ee7795ed2$export$6a42007cf1e7b6f8)();
    const refs = (0, $acw62.useRef)({});
    const previousLength = (0, $acw62.useRef)(0);
    const [hoveredCount, setHoveredCount] = (0, $acw62.useState)(0);
    const handleHoverStart = (0, $acw62.useCallback)(()=>setHoveredCount((c)=>c + 1), []);
    const handleHoverEnd = (0, $acw62.useCallback)(()=>setHoveredCount((c)=>Math.max(0, c - 1)), []);
    const duration = (theme.respectReducedMotion ? shouldReduceMotion : false) ? 1 : transitionDuration;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Notifications",
        classes: (0, $a78bfbe7bf01f519$export$2e2bcd8739ae039),
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $adfe52a85354f23c$var$varsResolver
    });
    (0, $acw62.useEffect)(()=>{
        store?.updateState((current)=>({
                ...current,
                limit: limit || 5,
                defaultPosition: position
            }));
    }, [
        limit,
        position
    ]);
    (0, $d9273517323905a9$export$e34ed88fef4dc107)(()=>{
        if (data.notifications.length > previousLength.current) setTimeout(()=>forceUpdate(), 0);
        previousLength.current = data.notifications.length;
    }, [
        data.notifications
    ]);
    const grouped = (0, $30df0d36aa9f19ca$export$d5321ec32efed55a)(data.notifications, position);
    const groupedComponents = (0, $30df0d36aa9f19ca$export$878041e1e4cd4218).reduce((acc, pos)=>{
        acc[pos] = grouped[pos].map(({ style: notificationStyle, ...notification })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($adfe52a85354f23c$var$Transition$1, {
                timeout: duration,
                onEnter: ()=>refs.current[notification.id].offsetHeight,
                nodeRef: {
                    current: refs.current[notification.id]
                },
                children: (state)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2cc5a47b53d862ca$export$aef1c47d6b127917), {
                        ref: (node)=>{
                            if (node) refs.current[notification.id] = node;
                            else delete refs.current[notification.id];
                        },
                        data: notification,
                        onHide: (id)=>(0, $92225eae00b0597b$export$87f1090575f0067e)(id, store),
                        autoClose: autoClose,
                        transitionDuration: duration,
                        allowDragDismiss: allowDragDismiss,
                        allowScrollDismiss: allowScrollDismiss,
                        paused: pauseResetOnHover === "all" ? hoveredCount > 0 : false,
                        onHoverStart: handleHoverStart,
                        onHoverEnd: handleHoverEnd,
                        ...getStyles("notification", {
                            style: {
                                ...(0, $5fd0cf466c982a50$export$2139e2d0d570f849)({
                                    state: state,
                                    position: pos,
                                    transitionDuration: duration,
                                    maxHeight: notificationMaxHeight
                                }),
                                ...notificationStyle
                            }
                        })
                    })
            }, notification.id));
        return acc;
    }, {});
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $c40c05f34c6cea16$export$425106c5d6e6dc37), {
        withinPortal: withinPortal,
        ...portalProps,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                ...getStyles("root"),
                "data-position": "top-center",
                ...others,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
                    children: groupedComponents["top-center"]
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                ...getStyles("root"),
                "data-position": "top-left",
                ...others,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
                    children: groupedComponents["top-left"]
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                ...getStyles("root", {
                    className: (0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039).classNames.fullWidth
                }),
                "data-position": "top-right",
                ...others,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
                    children: groupedComponents["top-right"]
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                ...getStyles("root", {
                    className: (0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039).classNames.fullWidth
                }),
                "data-position": "bottom-right",
                ...others,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
                    children: groupedComponents["bottom-right"]
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                ...getStyles("root"),
                "data-position": "bottom-left",
                ...others,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
                    children: groupedComponents["bottom-left"]
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                ...getStyles("root"),
                "data-position": "bottom-center",
                ...others,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
                    children: groupedComponents["bottom-center"]
                })
            })
        ]
    });
});
$adfe52a85354f23c$export$36ba2f559d49a8f6.classes = (0, $a78bfbe7bf01f519$export$2e2bcd8739ae039);
$adfe52a85354f23c$export$36ba2f559d49a8f6.varsResolver = $adfe52a85354f23c$var$varsResolver;
$adfe52a85354f23c$export$36ba2f559d49a8f6.displayName = "@mantine/notifications/Notifications";
$adfe52a85354f23c$export$36ba2f559d49a8f6.show = (0, $92225eae00b0597b$export$6008d97729a90c74).show;
$adfe52a85354f23c$export$36ba2f559d49a8f6.hide = (0, $92225eae00b0597b$export$6008d97729a90c74).hide;
$adfe52a85354f23c$export$36ba2f559d49a8f6.update = (0, $92225eae00b0597b$export$6008d97729a90c74).update;
$adfe52a85354f23c$export$36ba2f559d49a8f6.clean = (0, $92225eae00b0597b$export$6008d97729a90c74).clean;
$adfe52a85354f23c$export$36ba2f559d49a8f6.cleanQueue = (0, $92225eae00b0597b$export$6008d97729a90c74).cleanQueue;
$adfe52a85354f23c$export$36ba2f559d49a8f6.updateState = (0, $92225eae00b0597b$export$6008d97729a90c74).updateState;


// src/queryClient.ts
// src/utils.ts
// src/timeoutManager.ts
var $b7f1384d98eac5cd$export$d235812f9125bf47 = {
    // We need the wrapper function syntax below instead of direct references to
    // global setTimeout etc.
    //
    // BAD: `setTimeout: setTimeout`
    // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
    //
    // If we use direct references here, then anything that wants to spy on or
    // replace the global setTimeout (like tests) won't work since we'll already
    // have a hard reference to the original implementation at the time when this
    // file was imported.
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var $b7f1384d98eac5cd$export$6336d90323f0ab52 = class {
    // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
    // type at app boot; and if we leave that type, then any new timer provider
    // would need to support the default provider's concrete timer ID, which is
    // infeasible across environments.
    //
    // We settle for type safety for the TimeoutProvider type, and accept that
    // this class is unsafe internally to allow for extension.
    #provider = $b7f1384d98eac5cd$export$d235812f9125bf47;
    #providerCalled = false;
    setTimeoutProvider(provider) {
        this.#provider = provider;
    }
    setTimeout(callback, delay) {
        return this.#provider.setTimeout(callback, delay);
    }
    clearTimeout(timeoutId) {
        this.#provider.clearTimeout(timeoutId);
    }
    setInterval(callback, delay) {
        return this.#provider.setInterval(callback, delay);
    }
    clearInterval(intervalId) {
        this.#provider.clearInterval(intervalId);
    }
};
var $b7f1384d98eac5cd$export$94a2700736e69372 = new $b7f1384d98eac5cd$export$6336d90323f0ab52();
function $b7f1384d98eac5cd$export$5086591e51e32a18(callback) {
    setTimeout(callback, 0);
}


var $938ae10f13d49bdc$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $938ae10f13d49bdc$export$8793edee2d425525() {}
function $938ae10f13d49bdc$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $938ae10f13d49bdc$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $938ae10f13d49bdc$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $938ae10f13d49bdc$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $938ae10f13d49bdc$export$d7ee3961208f79c1(option, query) {
    return typeof option === "function" ? option(query) : option;
}
function $938ae10f13d49bdc$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $938ae10f13d49bdc$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$938ae10f13d49bdc$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $938ae10f13d49bdc$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($938ae10f13d49bdc$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $938ae10f13d49bdc$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$938ae10f13d49bdc$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $938ae10f13d49bdc$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = options?.queryKeyHashFn || $938ae10f13d49bdc$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $938ae10f13d49bdc$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$938ae10f13d49bdc$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $938ae10f13d49bdc$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (Array.isArray(a) && Array.isArray(b)) {
            for(let i = 0; i < b.length; i++){
                if (!$938ae10f13d49bdc$export$2f07189bb9fa26a7(a[i], b[i])) return false;
            }
            return true;
        }
        const bKeys = Object.keys(b);
        for (const key of bKeys){
            if (!$938ae10f13d49bdc$export$2f07189bb9fa26a7(a[key], b[key])) return false;
        }
        return true;
    }
    return false;
}
var $938ae10f13d49bdc$var$hasOwn = Object.prototype.hasOwnProperty;
function $938ae10f13d49bdc$export$77a71fc411098696(a, b, depth = 0) {
    if (a === b) return a;
    if (depth > 500) return b;
    const array = $938ae10f13d49bdc$export$7a8558113332b71e(a) && $938ae10f13d49bdc$export$7a8558113332b71e(b);
    if (!array && !($938ae10f13d49bdc$export$53b83ca8eaab0383(a) && $938ae10f13d49bdc$export$53b83ca8eaab0383(b))) return b;
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $938ae10f13d49bdc$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $938ae10f13d49bdc$export$77a71fc411098696(aItem, bItem, depth + 1);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
function $938ae10f13d49bdc$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $938ae10f13d49bdc$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $938ae10f13d49bdc$export$53b83ca8eaab0383(o) {
    if (!$938ae10f13d49bdc$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$938ae10f13d49bdc$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $938ae10f13d49bdc$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $938ae10f13d49bdc$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        (0, $b7f1384d98eac5cd$export$94a2700736e69372).setTimeout(resolve, timeout);
    });
}
function $938ae10f13d49bdc$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $938ae10f13d49bdc$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $938ae10f13d49bdc$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $938ae10f13d49bdc$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $938ae10f13d49bdc$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $938ae10f13d49bdc$export$1aa5a89531b7670d = /* @__PURE__ */ Symbol();
function $938ae10f13d49bdc$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && fetchOptions?.initialPromise) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $938ae10f13d49bdc$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function $938ae10f13d49bdc$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}
function $938ae10f13d49bdc$export$83f813cd1f8a4973(object, getSignal, onCancelled) {
    let consumed = false;
    let signal;
    Object.defineProperty(object, "signal", {
        enumerable: true,
        get: ()=>{
            signal ??= getSignal();
            if (consumed) return signal;
            consumed = true;
            if (signal.aborted) onCancelled();
            else signal.addEventListener("abort", onCancelled, {
                once: true
            });
            return signal;
        }
    });
    return object;
}


// src/queryCache.ts

// src/query.ts

// src/notifyManager.ts

var $e2307e33fb454067$export$7c76da44185e6090 = (0, $b7f1384d98eac5cd$export$5086591e51e32a18);
function $e2307e33fb454067$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $e2307e33fb454067$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $e2307e33fb454067$export$520687f44db6e1ab = $e2307e33fb454067$export$316a8efd03cd1458();


// src/retryer.ts
// src/focusManager.ts
// src/subscribable.ts
var $f28bf069faa02086$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};


var $3f1a0485b2ecb725$export$86f1af424b2ca4de = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    #focused;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onFocus)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.#focused !== focused;
        if (changed) {
            this.#focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        if (typeof this.#focused === "boolean") return this.#focused;
        return globalThis.document?.visibilityState !== "hidden";
    }
};
var $3f1a0485b2ecb725$export$6bf54661be5b02cf = new $3f1a0485b2ecb725$export$86f1af424b2ca4de();


// src/onlineManager.ts

var $0d08006668a80e57$export$58774fb55d5ff7fc = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    #online = true;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onOnline)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup(this.setOnline.bind(this));
    }
    setOnline(online) {
        const changed = this.#online !== online;
        if (changed) {
            this.#online = online;
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return this.#online;
    }
};
var $0d08006668a80e57$export$b113e788b2dd3fdc = new $0d08006668a80e57$export$58774fb55d5ff7fc();


// src/thenable.ts

function $f6114de20f9a4572$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}
function $f6114de20f9a4572$export$216296c47a9d1275(promise) {
    let data;
    promise.then((result)=>{
        data = result;
        return result;
    }, (0, $938ae10f13d49bdc$export$8793edee2d425525))?.catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    if (data !== void 0) return {
        data: data
    };
    return void 0;
}


// src/environmentManager.ts

var $bba8658037432dc5$export$2d935f1a9c9d3f3e = /* @__PURE__ */ (()=>{
    let isServerFn = ()=>(0, $938ae10f13d49bdc$export$6acf61af03e62db);
    return {
        /**
     * Returns whether the current runtime should be treated as a server environment.
     */ isServer () {
            return isServerFn();
        },
        /**
     * Overrides the server check globally.
     */ setIsServer (isServerValue) {
            isServerFn = isServerValue;
        }
    };
})();



function $af92dbbbb3fbc9c5$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $af92dbbbb3fbc9c5$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $0d08006668a80e57$export$b113e788b2dd3fdc).isOnline() : true;
}
var $af92dbbbb3fbc9c5$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options?.revert;
        this.silent = options?.silent;
    }
};
function $af92dbbbb3fbc9c5$export$986cc6445c1d323(value) {
    return value instanceof $af92dbbbb3fbc9c5$export$a8430ed4188f35a9;
}
function $af92dbbbb3fbc9c5$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    const thenable = (0, $f6114de20f9a4572$export$d54630db02a12b72)();
    const isResolved = ()=>thenable.status !== "pending";
    const cancel = (cancelOptions)=>{
        if (!isResolved()) {
            const error = new $af92dbbbb3fbc9c5$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            config.onCancel?.(error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $3f1a0485b2ecb725$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $0d08006668a80e57$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$af92dbbbb3fbc9c5$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn?.();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn?.();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            config.onPause?.();
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved()) config.onContinue?.();
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $bba8658037432dc5$export$2d935f1a9c9d3f3e).isServer() ? 0 : 3);
            const retryDelay = config.retryDelay ?? $af92dbbbb3fbc9c5$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            config.onFail?.(failureCount, error);
            (0, $938ae10f13d49bdc$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        status: ()=>thenable.status,
        cancel: cancel,
        continue: ()=>{
            continueFn?.();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}


// src/removable.ts



var $e24fc843f912068a$export$e09608847fcc8c59 = class {
    #gcTimeout;
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $938ae10f13d49bdc$export$e539f754e934e270)(this.gcTime)) this.#gcTimeout = (0, $b7f1384d98eac5cd$export$94a2700736e69372).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime);
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $bba8658037432dc5$export$2d935f1a9c9d3f3e).isServer() ? Infinity : 300000));
    }
    clearGcTimeout() {
        if (this.#gcTimeout !== void 0) {
            (0, $b7f1384d98eac5cd$export$94a2700736e69372).clearTimeout(this.#gcTimeout);
            this.#gcTimeout = void 0;
        }
    }
};


// src/infiniteQueryBehavior.ts

function $5e3ed657d3a894dc$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const options = context.options;
            const direction = context.fetchOptions?.meta?.fetchMore?.direction;
            const oldPages = context.state.data?.pages || [];
            const oldPageParams = context.state.data?.pageParams || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    (0, $938ae10f13d49bdc$export$83f813cd1f8a4973)(object, ()=>context.signal, ()=>cancelled = true);
                };
                const queryFn = (0, $938ae10f13d49bdc$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject(context.signal.reason);
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $938ae10f13d49bdc$export$8c6246b73dd61f4a) : (0, $938ae10f13d49bdc$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $5e3ed657d3a894dc$var$getPreviousPageParam : $5e3ed657d3a894dc$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $5e3ed657d3a894dc$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                return context.options.persister?.(fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $5e3ed657d3a894dc$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $5e3ed657d3a894dc$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    return pages.length > 0 ? options.getPreviousPageParam?.(pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $5e3ed657d3a894dc$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $5e3ed657d3a894dc$var$getNextPageParam(options, data) != null;
}
function $5e3ed657d3a894dc$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $5e3ed657d3a894dc$var$getPreviousPageParam(options, data) != null;
}


var $bbb5e4108fb61687$export$62297b13309008b2 = class extends (0, $e24fc843f912068a$export$e09608847fcc8c59) {
    #queryType;
    #initialState;
    #revertState;
    #cache;
    #client;
    #retryer;
    #defaultOptions;
    #abortSignalConsumed;
    constructor(config){
        super();
        this.#abortSignalConsumed = false;
        this.#defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.#client = config.client;
        this.#cache = this.#client.getQueryCache();
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.#initialState = $bbb5e4108fb61687$var$getDefaultState(this.options);
        this.state = config.state ?? this.#initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get queryType() {
        return this.#queryType;
    }
    get promise() {
        return this.#retryer?.promise;
    }
    setOptions(options) {
        this.options = {
            ...this.#defaultOptions,
            ...options
        };
        if (options?._type) this.#queryType = options._type;
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = $bbb5e4108fb61687$var$getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState($bbb5e4108fb61687$var$successState(defaultState.data, defaultState.dataUpdatedAt));
                this.#initialState = defaultState;
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.#cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $938ae10f13d49bdc$export$17619bac5b909b23)(this.state.data, newData, this.options);
        this.#dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options?.updatedAt,
            manual: options?.manual
        });
        return data;
    }
    setState(state) {
        this.#dispatch({
            type: "setState",
            state: state
        });
    }
    cancel(options) {
        const promise = this.#retryer?.promise;
        this.#retryer?.cancel(options);
        return promise ? promise.then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    get resetState() {
        return this.#initialState;
    }
    reset() {
        this.destroy();
        this.setState(this.resetState);
    }
    isActive() {
        return this.observers.some((observer)=>(0, $938ae10f13d49bdc$export$d7ee3961208f79c1)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $938ae10f13d49bdc$export$1aa5a89531b7670d) || !this.isFetched();
    }
    isFetched() {
        return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $938ae10f13d49bdc$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    onOnline() {
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            this.#cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if (this.#retryer) {
                    if (this.#abortSignalConsumed || this.#isInitialPausedFetch()) this.#retryer.cancel({
                        revert: true
                    });
                    else this.#retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.#cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    #isInitialPausedFetch() {
        return this.state.fetchStatus === "paused" && this.state.status === "pending";
    }
    invalidate() {
        if (!this.state.isInvalidated) this.#dispatch({
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        if (this.state.fetchStatus !== "idle" && // If the promise in the retryer is already rejected, we have to definitely
        // re-start the fetch; there is a chance that the query is still in a
        // pending state when that happens
        this.#retryer?.status() !== "rejected") {
            if (this.state.data !== void 0 && fetchOptions?.cancelRefetch) this.cancel({
                silent: true
            });
            else if (this.#retryer) {
                this.#retryer.continueRetry();
                return this.#retryer.promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    this.#abortSignalConsumed = true;
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $938ae10f13d49bdc$export$c71c44209368a3bc)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: this.#client,
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            this.#abortSignalConsumed = false;
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: this.#client,
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        const behavior = this.#queryType === "infinite" ? (0, $5e3ed657d3a894dc$export$84470d1367601e8d)(this.options.pages) : this.options.behavior;
        behavior?.onFetch(context, this);
        this.#revertState = this.state;
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== context.fetchOptions?.meta) this.#dispatch({
            type: "fetch",
            meta: context.fetchOptions?.meta
        });
        this.#retryer = (0, $af92dbbbb3fbc9c5$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions?.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $af92dbbbb3fbc9c5$export$a8430ed4188f35a9) && error.revert) this.setState({
                    ...this.#revertState,
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        });
        try {
            const data = await this.#retryer.start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            this.#cache.config.onSuccess?.(data, this);
            this.#cache.config.onSettled?.(data, this.state.error, this);
            return data;
        } catch (error) {
            if (error instanceof (0, $af92dbbbb3fbc9c5$export$a8430ed4188f35a9)) {
                if (error.silent) return this.#retryer.promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            this.#dispatch({
                type: "error",
                error: error
            });
            this.#cache.config.onError?.(error, this);
            this.#cache.config.onSettled?.(this.state.data, error, this);
            throw error;
        } finally{
            this.scheduleGc();
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        ...$bbb5e4108fb61687$export$f3df9013f2b58bce(state.data, this.options),
                        fetchMeta: action.meta ?? null
                    };
                case "success":
                    const newState = {
                        ...state,
                        ...$bbb5e4108fb61687$var$successState(action.data, action.dataUpdatedAt),
                        dataUpdateCount: state.dataUpdateCount + 1,
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                    this.#revertState = action.manual ? newState : void 0;
                    return newState;
                case "error":
                    const error = action.error;
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error",
                        // flag existing data as invalidated if we get a background error
                        // note that "no data" always means stale so we can set unconditionally here
                        isInvalidated: true
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate();
            });
            this.#cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $bbb5e4108fb61687$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $af92dbbbb3fbc9c5$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $bbb5e4108fb61687$var$successState(data, dataUpdatedAt) {
    return {
        data: data,
        dataUpdatedAt: dataUpdatedAt ?? Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
function $bbb5e4108fb61687$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $74dfca891c706a66$export$5dde0cd941da8468 = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#queries = /* @__PURE__ */ new Map();
    }
    #queries;
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $938ae10f13d49bdc$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $bbb5e4108fb61687$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.#queries.has(query.queryHash)) {
            this.#queries.set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.#queries.get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) this.#queries.delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.#queries.get(queryHash);
    }
    getAll() {
        return [
            ...this.#queries.values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $938ae10f13d49bdc$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $938ae10f13d49bdc$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};


// src/mutationCache.ts

// src/mutation.ts



var $524c502dbe70a85f$export$17b8b19c814bcf56 = class extends (0, $e24fc843f912068a$export$e09608847fcc8c59) {
    #client;
    #observers;
    #mutationCache;
    #retryer;
    constructor(config){
        super();
        this.#client = config.client;
        this.mutationId = config.mutationId;
        this.#mutationCache = config.mutationCache;
        this.#observers = [];
        this.state = config.state || $524c502dbe70a85f$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!this.#observers.includes(observer)) {
            this.#observers.push(observer);
            this.clearGcTimeout();
            this.#mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.#observers = this.#observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.#mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.#observers.length) {
            if (this.state.status === "pending") this.scheduleGc();
            else this.#mutationCache.remove(this);
        }
    }
    continue() {
        return this.#retryer?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        const onContinue = ()=>{
            this.#dispatch({
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: this.#client,
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        this.#retryer = (0, $af92dbbbb3fbc9c5$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>this.#mutationCache.canRun(this)
        });
        const restored = this.state.status === "pending";
        const isPaused = !this.#retryer.canStart();
        try {
            if (restored) onContinue();
            else {
                this.#dispatch({
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                if (this.#mutationCache.config.onMutate) await this.#mutationCache.config.onMutate(variables, this, mutationFnContext);
                const context = await this.options.onMutate?.(variables, mutationFnContext);
                if (context !== this.state.context) this.#dispatch({
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await this.#retryer.start();
            await this.#mutationCache.config.onSuccess?.(data, variables, this.state.context, this, mutationFnContext);
            await this.options.onSuccess?.(data, variables, this.state.context, mutationFnContext);
            await this.#mutationCache.config.onSettled?.(data, null, this.state.variables, this.state.context, this, mutationFnContext);
            await this.options.onSettled?.(data, null, variables, this.state.context, mutationFnContext);
            this.#dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await this.#mutationCache.config.onError?.(error, variables, this.state.context, this, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.options.onError?.(error, variables, this.state.context, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.#mutationCache.config.onSettled?.(void 0, error, this.state.variables, this.state.context, this, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.options.onSettled?.(void 0, error, variables, this.state.context, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            this.#dispatch({
                type: "error",
                error: error
            });
            throw error;
        } finally{
            this.#mutationCache.runNext(this);
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "pending":
                    return {
                        ...state,
                        context: action.context,
                        data: void 0,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: action.isPaused,
                        status: "pending",
                        variables: action.variables,
                        submittedAt: Date.now()
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: void 0,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.#observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.#mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $524c502dbe70a85f$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $217efee59d834f2b$export$1fcfd9a244434844 = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#mutations = /* @__PURE__ */ new Set();
        this.#scopes = /* @__PURE__ */ new Map();
        this.#mutationId = 0;
    }
    #mutations;
    #scopes;
    #mutationId;
    build(client, options, state) {
        const mutation = new (0, $524c502dbe70a85f$export$17b8b19c814bcf56)({
            client: client,
            mutationCache: this,
            mutationId: ++this.#mutationId,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.#mutations.add(mutation);
        const scope = $217efee59d834f2b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = this.#scopes.get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else this.#scopes.set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if (this.#mutations.delete(mutation)) {
            const scope = $217efee59d834f2b$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = this.#scopes.get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) this.#scopes.delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $217efee59d834f2b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = this.#scopes.get(scope);
            const firstPendingMutation = mutationsWithSameScope?.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        const scope = $217efee59d834f2b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = this.#scopes.get(scope)?.find((m)=>m !== mutation && m.state.isPaused);
            return foundMutation?.continue() ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.#mutations.forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            this.#mutations.clear();
            this.#scopes.clear();
        });
    }
    getAll() {
        return Array.from(this.#mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $938ae10f13d49bdc$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $938ae10f13d49bdc$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $938ae10f13d49bdc$export$8793edee2d425525)))));
    }
};
function $217efee59d834f2b$var$scopeFor(mutation) {
    return mutation.options.scope?.id;
}





var $83ccb5f70678ce73$export$405d0624ed55a03f = class {
    #queryCache;
    #mutationCache;
    #defaultOptions;
    #queryDefaults;
    #mutationDefaults;
    #mountCount;
    #unsubscribeFocus;
    #unsubscribeOnline;
    constructor(config = {}){
        this.#queryCache = config.queryCache || new (0, $74dfca891c706a66$export$5dde0cd941da8468)();
        this.#mutationCache = config.mutationCache || new (0, $217efee59d834f2b$export$1fcfd9a244434844)();
        this.#defaultOptions = config.defaultOptions || {};
        this.#queryDefaults = /* @__PURE__ */ new Map();
        this.#mutationDefaults = /* @__PURE__ */ new Map();
        this.#mountCount = 0;
    }
    mount() {
        this.#mountCount++;
        if (this.#mountCount !== 1) return;
        this.#unsubscribeFocus = (0, $3f1a0485b2ecb725$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                this.#queryCache.onFocus();
            }
        });
        this.#unsubscribeOnline = (0, $0d08006668a80e57$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                this.#queryCache.onOnline();
            }
        });
    }
    unmount() {
        this.#mountCount--;
        if (this.#mountCount !== 0) return;
        this.#unsubscribeFocus?.();
        this.#unsubscribeFocus = void 0;
        this.#unsubscribeOnline?.();
        this.#unsubscribeOnline = void 0;
    }
    isFetching(filters) {
        return this.#queryCache.findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return this.#mutationCache.findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = this.#queryCache.build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return this.#queryCache.findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = this.#queryCache.get(defaultedOptions.queryHash);
        const prevData = query?.state.data;
        const data = (0, $938ae10f13d49bdc$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return this.#queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state;
    }
    removeQueries(filters) {
        const queryCache = this.#queryCache;
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = this.#queryCache;
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.#queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters?.refetchType === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: filters?.refetchType ?? filters?.type ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = this.#queryCache.build(this, defaultedOptions);
        return query.isStaleByTime((0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options._type = "infinite";
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options._type = "infinite";
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $0d08006668a80e57$export$b113e788b2dd3fdc).isOnline()) return this.#mutationCache.resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return this.#queryCache;
    }
    getMutationCache() {
        return this.#mutationCache;
    }
    getDefaultOptions() {
        return this.#defaultOptions;
    }
    setDefaultOptions(options) {
        this.#defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        this.#queryDefaults.set((0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...this.#queryDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $938ae10f13d49bdc$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        this.#mutationDefaults.set((0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...this.#mutationDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $938ae10f13d49bdc$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...this.#defaultOptions.queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $938ae10f13d49bdc$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $938ae10f13d49bdc$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options?._defaulted) return options;
        return {
            ...this.#defaultOptions.mutations,
            ...options?.mutationKey && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.#queryCache.clear();
        this.#mutationCache.clear();
    }
};


var $acw62 = parcelRequire("acw62");

"use client";
var $c780594f51309d36$export$da112d31b0149f31 = $acw62.createContext(void 0);
var $c780594f51309d36$export$22e77b9572c4fded = (queryClient)=>{
    const client = $acw62.useContext($c780594f51309d36$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $c780594f51309d36$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $acw62.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($c780594f51309d36$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};


parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $673ff3dfc4a496de$var$isString = (obj)=>typeof obj === 'string';
const $673ff3dfc4a496de$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $673ff3dfc4a496de$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $673ff3dfc4a496de$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $673ff3dfc4a496de$var$lastOfPathSeparatorRegExp = /###/g;
const $673ff3dfc4a496de$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($673ff3dfc4a496de$var$lastOfPathSeparatorRegExp, '.') : key;
const $673ff3dfc4a496de$var$canNotTraverseDeeper = (object)=>!object || $673ff3dfc4a496de$var$isString(object);
const $673ff3dfc4a496de$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$673ff3dfc4a496de$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
        const key = $673ff3dfc4a496de$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $673ff3dfc4a496de$var$cleanKey(stack[stackIndex])
    };
};
const $673ff3dfc4a496de$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $673ff3dfc4a496de$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $673ff3dfc4a496de$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $673ff3dfc4a496de$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
};
const $673ff3dfc4a496de$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($673ff3dfc4a496de$var$isString(target[prop]) || target[prop] instanceof String || $673ff3dfc4a496de$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $673ff3dfc4a496de$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $673ff3dfc4a496de$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $673ff3dfc4a496de$var$escape = (data)=>{
    if ($673ff3dfc4a496de$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$673ff3dfc4a496de$var$_entityMap[s]);
    return data;
};
class $673ff3dfc4a496de$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $673ff3dfc4a496de$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache = new $673ff3dfc4a496de$var$RegExpCache(20);
const $673ff3dfc4a496de$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $673ff3dfc4a496de$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $673ff3dfc4a496de$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $673ff3dfc4a496de$var$getCleanedCode = (code)=>code?.replace(/_/g, '-');
const $673ff3dfc4a496de$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $673ff3dfc4a496de$var$Logger {
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($673ff3dfc4a496de$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $673ff3dfc4a496de$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $673ff3dfc4a496de$var$Logger(this.logger, options);
    }
}
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
class $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $673ff3dfc4a496de$var$ResourceStore extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($673ff3dfc4a496de$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $673ff3dfc4a496de$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$673ff3dfc4a496de$var$isString(key)) return result;
        return $673ff3dfc4a496de$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $673ff3dfc4a496de$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($673ff3dfc4a496de$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $673ff3dfc4a496de$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $673ff3dfc4a496de$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $673ff3dfc4a496de$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        proxy?.revoke?.();
        if (key === $673ff3dfc4a496de$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$673ff3dfc4a496de$var$PATH_KEY]: path } = selector($673ff3dfc4a496de$var$createProxy());
    const keySeparator = opts?.keySeparator ?? '.';
    const nsSeparator = opts?.nsSeparator ?? ':';
    if (path.length > 1 && nsSeparator) {
        const ns = opts?.ns;
        const nsArray = Array.isArray(ns) ? ns : null;
        if (nsArray && nsArray.length > 1 && nsArray.slice(1).includes(path[0])) return `${path[0]}${nsSeparator}${path.slice(1).join(keySeparator)}`;
    }
    return path.join(keySeparator);
}
const $673ff3dfc4a496de$var$checkedLoadedFor = {};
const $673ff3dfc4a496de$var$shouldHandleAsObject = (res)=>!$673ff3dfc4a496de$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $673ff3dfc4a496de$var$Translator extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(services, options = {}){
        super();
        $673ff3dfc4a496de$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if (resolved?.res === undefined) return false;
        const isObject = $673ff3dfc4a496de$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        keys = keys.map((k)=>typeof k === 'function' ? $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : String(k));
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$673ff3dfc4a496de$var$isString(opt.count);
        const hasDefaultValue = $673ff3dfc4a496de$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $673ff3dfc4a496de$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $673ff3dfc4a496de$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $673ff3dfc4a496de$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$673ff3dfc4a496de$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $673ff3dfc4a496de$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($673ff3dfc4a496de$var$isString(keys)) keys = [
            keys
        ];
        if (Array.isArray(keys)) keys = keys.map((k)=>typeof k === 'function' ? $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : k);
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$673ff3dfc4a496de$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($673ff3dfc4a496de$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$673ff3dfc4a496de$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $673ff3dfc4a496de$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($673ff3dfc4a496de$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($673ff3dfc4a496de$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($673ff3dfc4a496de$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($673ff3dfc4a496de$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $673ff3dfc4a496de$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $673ff3dfc4a496de$var$PluralResolver {
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $673ff3dfc4a496de$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (typeof Intl === 'undefined') {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $673ff3dfc4a496de$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $673ff3dfc4a496de$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $673ff3dfc4a496de$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $673ff3dfc4a496de$var$isString(key)) {
        path = $673ff3dfc4a496de$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $673ff3dfc4a496de$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $673ff3dfc4a496de$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $673ff3dfc4a496de$var$Interpolator {
    constructor(options = {}){
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $673ff3dfc4a496de$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $673ff3dfc4a496de$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $673ff3dfc4a496de$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$673ff3dfc4a496de$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $673ff3dfc4a496de$var$regexSafe(this.escape(val)) : $673ff3dfc4a496de$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $673ff3dfc4a496de$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$673ff3dfc4a496de$var$isString(value) && !this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${$673ff3dfc4a496de$var$regexEscape(sep)}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || (matchedDoubleQuotes?.length ?? 0) % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$673ff3dfc4a496de$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$673ff3dfc4a496de$var$isString(value)) return value;
            if (!$673ff3dfc4a496de$var$isString(value)) value = $673ff3dfc4a496de$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $673ff3dfc4a496de$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $673ff3dfc4a496de$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($673ff3dfc4a496de$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $673ff3dfc4a496de$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($673ff3dfc4a496de$var$getCleanedCode(l), o)(v);
class $673ff3dfc4a496de$var$Formatter {
    constructor(options = {}){
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $673ff3dfc4a496de$var$createCachedFormatter : $673ff3dfc4a496de$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $673ff3dfc4a496de$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $673ff3dfc4a496de$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $673ff3dfc4a496de$var$Connector extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(backend, store, services, options = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $673ff3dfc4a496de$var$pushPath(q.loaded, [
                lng
            ], ns);
            $673ff3dfc4a496de$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($673ff3dfc4a496de$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($673ff3dfc4a496de$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $673ff3dfc4a496de$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($673ff3dfc4a496de$var$isString(args[1])) ret.defaultValue = args[1];
            if ($673ff3dfc4a496de$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $673ff3dfc4a496de$var$transformOptions = (options)=>{
    if ($673ff3dfc4a496de$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($673ff3dfc4a496de$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($673ff3dfc4a496de$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs?.indexOf?.('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
    return options;
};
const $673ff3dfc4a496de$var$noop = ()=>{};
const $673ff3dfc4a496de$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
const $673ff3dfc4a496de$var$SUPPORT_NOTICE_KEY = '__i18next_supportNoticeShown';
const $673ff3dfc4a496de$var$getSupportNoticeShown = ()=>{
    if (typeof globalThis !== 'undefined' && !!globalThis[$673ff3dfc4a496de$var$SUPPORT_NOTICE_KEY]) return true;
    return false;
};
const $673ff3dfc4a496de$var$setSupportNoticeShown = ()=>{
    if (typeof globalThis !== 'undefined') globalThis[$673ff3dfc4a496de$var$SUPPORT_NOTICE_KEY] = true;
};
const $673ff3dfc4a496de$var$usesLocize = (inst)=>{
    if (inst?.modules?.backend?.name?.indexOf('Locize') > 0) return true;
    if (inst?.modules?.backend?.constructor?.name?.indexOf('Locize') > 0) return true;
    if (inst?.options?.backend?.backends) {
        if (inst.options.backend.backends.some((b)=>b?.name?.indexOf('Locize') > 0 || b?.constructor?.name?.indexOf('Locize') > 0)) return true;
    }
    if (inst?.options?.backend?.projectId) return true;
    if (inst?.options?.backend?.backendOptions) {
        if (inst.options.backend.backendOptions.some((b)=>b?.projectId)) return true;
    }
    return false;
};
class $673ff3dfc4a496de$var$I18n extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(options = {}, callback){
        super();
        this.options = $673ff3dfc4a496de$var$transformOptions(options);
        this.services = {};
        this.logger = $673ff3dfc4a496de$var$baseLogger;
        this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($673ff3dfc4a496de$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $673ff3dfc4a496de$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$673ff3dfc4a496de$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
        if (this.options.showSupportNotice !== false && !$673ff3dfc4a496de$var$usesLocize(this) && !$673ff3dfc4a496de$var$getSupportNoticeShown()) {
            if (typeof console !== 'undefined' && typeof console.info !== 'undefined') console.info("\uD83C\uDF10 i18next is made possible by our own product, Locize \u2014 consider powering your project with managed localization (AI, CDN, integrations): https://locize.com \uD83D\uDC99");
            $673ff3dfc4a496de$var$setSupportNoticeShown();
        }
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $673ff3dfc4a496de$var$Formatter;
            const lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
            this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $673ff3dfc4a496de$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            const usingLegacyFormatFunction = this.options.interpolation.format && this.options.interpolation.format !== defOpts.interpolation.format;
            if (usingLegacyFormatFunction) this.logger.deprecate(`init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting`);
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $673ff3dfc4a496de$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $673ff3dfc4a496de$var$noop) {
        let usedCallback = callback;
        const usedLng = $673ff3dfc4a496de$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $673ff3dfc4a496de$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $673ff3dfc4a496de$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($673ff3dfc4a496de$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const selectorOpts = {
                ...this.options,
                ...o
            };
            if (typeof o.keyPrefix === 'function') o.keyPrefix = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(o.keyPrefix, selectorOpts);
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(k, selectorOpts);
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(key, selectorOpts);
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($673ff3dfc4a496de$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($673ff3dfc4a496de$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if ($673ff3dfc4a496de$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $673ff3dfc4a496de$var$LanguageUtil($673ff3dfc4a496de$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $673ff3dfc4a496de$var$I18n(options, callback);
        instance.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $673ff3dfc4a496de$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $673ff3dfc4a496de$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $673ff3dfc4a496de$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        if (options.interpolation) {
            const defOpts = $673ff3dfc4a496de$var$get();
            const mergedInterpolation = {
                ...defOpts.interpolation,
                ...this.options.interpolation,
                ...options.interpolation
            };
            const mergedForInterpolator = {
                ...mergedOptions,
                interpolation: mergedInterpolation
            };
            clone.services.interpolator = new $673ff3dfc4a496de$var$Interpolator(mergedForInterpolator);
        }
        clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$I18n.createInstance();
const $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance;
const $673ff3dfc4a496de$export$147ec2801e896265 = $673ff3dfc4a496de$export$2e2bcd8739ae039.dir;
const $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$export$2e2bcd8739ae039.init;
const $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadResources;
const $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$export$2e2bcd8739ae039.reloadResources;
const $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$export$2e2bcd8739ae039.use;
const $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$export$2e2bcd8739ae039.changeLanguage;
const $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$export$2e2bcd8739ae039.getFixedT;
const $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$export$2e2bcd8739ae039.t;
const $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$export$2e2bcd8739ae039.exists;
const $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$export$2e2bcd8739ae039.setDefaultNamespace;
const $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$export$2e2bcd8739ae039.hasLoadedNamespace;
const $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadNamespaces;
const $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadLanguages;


var $dca61ba26e2661d8$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $dca61ba26e2661d8$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $69084eaa2e6a0d50$var$e = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?("[^"]*"|'[^']*')/g;
function $69084eaa2e6a0d50$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($dca61ba26e2661d8$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($69084eaa2e6a0d50$var$e), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var l = c[1].trim(), o = [
                l,
                ""
            ];
            l.indexOf("=") > -1 && (o = l.split("=")), r.attrs[o[0]] = o[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $69084eaa2e6a0d50$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $69084eaa2e6a0d50$var$i = /^\s*$/, $69084eaa2e6a0d50$var$s = Object.create(null);
function $69084eaa2e6a0d50$var$a(t, e) {
    switch(e.type){
        case "text":
            return t + e.content;
        case "tag":
            return t += "<" + e.name + (e.attrs ? function(t) {
                var e = [];
                for(var n in t)e.push(n + '="' + t[n] + '"');
                return e.length ? " " + e.join(" ") : "";
            }(e.attrs) : "") + (e.voidElement ? "/>" : ">"), e.voidElement ? t : t + e.children.reduce($69084eaa2e6a0d50$var$a, "") + "</" + e.name + ">";
        case "comment":
            return t + "\x3c!--" + e.comment + "--\x3e";
    }
}
var $69084eaa2e6a0d50$var$c = {
    parse: function(t, e) {
        e || (e = {}), e.components || (e.components = $69084eaa2e6a0d50$var$s);
        var a, c = [], l = [], o = -1, u = !1;
        if (0 !== t.indexOf("<")) {
            var h = t.indexOf("<");
            c.push({
                type: "text",
                content: -1 === h ? t : t.substring(0, h)
            });
        }
        for(var v, f = []; v = $69084eaa2e6a0d50$var$r.exec(t);)f.push(v);
        return f.forEach(function(t, e) {
            var n = t[0];
            if (n && !n.startsWith("\x3c!--")) {
                for(var r = 0, i = 0, s = -1, a = null, c = 0; c < n.length; c++){
                    var l = n.charAt(c);
                    a ? l === a && (a = null) : '"' === l || "'" === l ? a = l : "<" === l ? 2 == ++r && (s = c) : ">" === l && i++;
                }
                var o = s > -1 && /[a-zA-Z0-9\-!/]/.test(n.charAt(s + 1));
                if (r > i && o) {
                    var u = n.substring(0, s), h = n.substring(u.length);
                    f[e][0] = h, f[e].index += u.length;
                }
            }
        }), f.forEach(function(r, s) {
            var h = r[0];
            if (h) {
                var v = r.index;
                if (u) {
                    if (h !== "</" + a.name + ">") return;
                    u = !1;
                }
                var m, d, p = "/" !== h.charAt(1), x = h.startsWith("\x3c!--"), g = v + h.length, y = t.charAt(g), E = f[s + 1];
                if ("<" === y && E) {
                    var A = t.substring(g, E.index);
                    m = A.split("<").length > A.split(">").length;
                }
                if (x) {
                    var b = $69084eaa2e6a0d50$var$n(h);
                    if (o < 0) return c.push(b), c;
                    (d = l[o]).children.push(b);
                    var O = t.slice(g, E ? E.index : void 0);
                    return O.length > 0 && d.children.push({
                        type: "text",
                        content: O
                    }), c;
                }
                if (p && (o++, "tag" === (a = $69084eaa2e6a0d50$var$n(h)).type && e.components[a.name] && (a.type = "component", u = !0), a.voidElement || u || !y || "<" === y || a.children.push({
                    type: "text",
                    content: t.slice(g, E ? E.index : void 0)
                }), 0 === o && c.push(a), (d = l[o - 1]) && d.children.push(a), l[o] = a), (!p || a.voidElement) && (o > -1 && (a.voidElement || a.name === h.slice(2, -1)) && (o--, a = -1 === o ? c : l[o]), !u && ("<" !== y || m) && y)) {
                    d = -1 === o ? c : l[o].children;
                    var W = E ? E.index : -1, j = t.slice(g, -1 === W ? void 0 : W);
                    $69084eaa2e6a0d50$var$i.test(j) && (j = " "), (W > -1 && o + d.length >= 0 || " " !== j) && d.push({
                        type: "text",
                        content: j
                    });
                }
            }
        }), c;
    },
    stringify: function(t) {
        return t.reduce(function(t, e) {
            return t + $69084eaa2e6a0d50$var$a("", e);
        }, "");
    }
};
var $69084eaa2e6a0d50$export$2e2bcd8739ae039 = $69084eaa2e6a0d50$var$c;


const $cfb6e0167e0b350d$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $cfb6e0167e0b350d$var$alreadyWarned = {};
const $cfb6e0167e0b350d$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(msg) && $cfb6e0167e0b350d$var$alreadyWarned[msg]) return;
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(msg)) $cfb6e0167e0b350d$var$alreadyWarned[msg] = new Date();
    $cfb6e0167e0b350d$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $cfb6e0167e0b350d$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $cfb6e0167e0b350d$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
};
const $cfb6e0167e0b350d$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $cfb6e0167e0b350d$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
};
const $cfb6e0167e0b350d$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $cfb6e0167e0b350d$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $cfb6e0167e0b350d$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($cfb6e0167e0b350d$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $cfb6e0167e0b350d$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $cfb6e0167e0b350d$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $d7f2d92b0368699f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $d7f2d92b0368699f$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $d7f2d92b0368699f$var$unescapeHtmlEntity = (m)=>$d7f2d92b0368699f$var$htmlEntities[m];
const $d7f2d92b0368699f$export$e8bacd2802a88316 = (text)=>text.replace($d7f2d92b0368699f$var$matchHtmlEntity, $d7f2d92b0368699f$var$unescapeHtmlEntity);


let $4f75eea5b29ffc65$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $d7f2d92b0368699f$export$e8bacd2802a88316,
    transDefaultProps: undefined
};
const $4f75eea5b29ffc65$export$2e2366488d12e20d = (options = {})=>{
    $4f75eea5b29ffc65$var$defaultOptions = {
        ...$4f75eea5b29ffc65$var$defaultOptions,
        ...options
    };
};
const $4f75eea5b29ffc65$export$212bb2fc580a90a8 = ()=>$4f75eea5b29ffc65$var$defaultOptions;


let $1d04edb3ddd0d89e$var$i18nInstance;
const $1d04edb3ddd0d89e$export$a039134f2fc7e0 = (instance)=>{
    $1d04edb3ddd0d89e$var$i18nInstance = instance;
};
const $1d04edb3ddd0d89e$export$64af334f494c2f47 = ()=>$1d04edb3ddd0d89e$var$i18nInstance;



const $acffcb171536f8e9$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $acffcb171536f8e9$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $acffcb171536f8e9$var$getAsArray(children) : children;
};
const $acffcb171536f8e9$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $acw62.isValidElement));
const $acffcb171536f8e9$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $acffcb171536f8e9$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = {
        ...target.props,
        ...source.props
    };
    return newTarget;
};
const $acffcb171536f8e9$var$getValuesFromChildren = (children)=>{
    const values = {};
    if (!children) return values;
    const getData = (childs)=>{
        const childrenArray = $acffcb171536f8e9$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) return;
            if ($acffcb171536f8e9$var$hasChildren(child)) getData($acffcb171536f8e9$var$getChildren(child));
            else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !(0, $acw62.isValidElement)(child)) Object.assign(values, child);
        });
    };
    getData(children);
    return values;
};
const $acffcb171536f8e9$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $acffcb171536f8e9$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $acw62.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount === 1 && (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(childChildren)) {
                stringNode += `<${type}>${childChildren}</${type}>`;
                return;
            }
            const content = $acffcb171536f8e9$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $acffcb171536f8e9$var$escapeLiteralLessThan = (str, keepArray = [], knownComponentsMap = {})=>{
    if (!str) return str;
    const knownNames = Object.keys(knownComponentsMap);
    const allValidNames = [
        ...keepArray,
        ...knownNames
    ];
    let result = '';
    let i = 0;
    while(i < str.length)if (str[i] === '<') {
        let isValidTag = false;
        const closingMatch = str.slice(i).match(/^<\/(\d+|[a-zA-Z][a-zA-Z0-9_-]*)>/);
        if (closingMatch) {
            const tagName = closingMatch[1];
            if (/^\d+$/.test(tagName) || allValidNames.includes(tagName)) {
                isValidTag = true;
                result += closingMatch[0];
                i += closingMatch[0].length;
            }
        }
        if (!isValidTag) {
            const openingMatch = str.slice(i).match(/^<(\d+|[a-zA-Z][a-zA-Z0-9_-]*)(\s+[\w-]+(?:=(?:"[^"]*"|'[^']*'|[^\s>]+))?)*\s*(\/)?>/);
            if (openingMatch) {
                const tagName = openingMatch[1];
                if (/^\d+$/.test(tagName) || allValidNames.includes(tagName)) {
                    isValidTag = true;
                    result += openingMatch[0];
                    i += openingMatch[0].length;
                }
            }
        }
        if (!isValidTag) {
            result += '&lt;';
            i += 1;
        }
    } else {
        result += str[i];
        i += 1;
    }
    return result;
};
const $acffcb171536f8e9$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap ?? {};
    const getData = (childs)=>{
        const childrenArray = $acffcb171536f8e9$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) return;
            if ($acffcb171536f8e9$var$hasChildren(child)) getData($acffcb171536f8e9$var$getChildren(child));
            else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !(0, $acw62.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const escapedString = $acffcb171536f8e9$var$escapeLiteralLessThan(targetString, keepArray, data);
    const ast = (0, $69084eaa2e6a0d50$export$2e2bcd8739ae039).parse(`<0>${escapedString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $acffcb171536f8e9$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $acffcb171536f8e9$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $acw62.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $acw62.Children).map([
            child
        ], (c)=>{
            const INTERNAL_DYNAMIC_MARKER = 'data-i18n-is-dynamic-list';
            const override = {
                key: i,
                [INTERNAL_DYNAMIC_MARKER]: undefined
            };
            if (c && c.props) Object.keys(c.props).forEach((k)=>{
                if (k === 'ref' || k === 'children' || k === 'i18nIsDynamicList' || k === INTERNAL_DYNAMIC_MARKER) return;
                override[k] = c.props[k];
            });
            return (0, $acw62.cloneElement)(c, override, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $acffcb171536f8e9$var$getAsArray(reactNode);
        const astNodes = $acffcb171536f8e9$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const props = {
                    ...node.attrs
                };
                if (shouldUnescape) Object.keys(props).forEach((p)=>{
                    const val = props[p];
                    if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(val)) props[p] = (0, $d7f2d92b0368699f$export$e8bacd2802a88316)(val);
                });
                const child = Object.keys(props).length !== 0 ? $acffcb171536f8e9$var$mergeProps({
                    props: props
                }, tmp) : tmp;
                const isElement = (0, $acw62.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $acffcb171536f8e9$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($acffcb171536f8e9$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $acw62.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $acw62.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const unescapeFn = typeof i18nOptions.unescape === 'function' ? i18nOptions.unescape : (0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)().unescape;
                const content = shouldUnescape ? unescapeFn(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $acw62.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $acffcb171536f8e9$var$getAsArray(children || []));
    return $acffcb171536f8e9$var$getChildren(result[0]);
};
const $acffcb171536f8e9$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $acw62.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $acw62.createElement)((0, $acw62.Fragment), null, comp);
    }
    return (0, $acw62.createElement)(Componentized, {
        key: componentKey
    });
};
const $acffcb171536f8e9$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$acffcb171536f8e9$var$fixComponentProps(c, index, translation));
const $acffcb171536f8e9$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $acffcb171536f8e9$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $acffcb171536f8e9$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $acffcb171536f8e9$var$generateArrayComponents(components, translation);
    if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(components)) return $acffcb171536f8e9$var$generateObjectComponents(components, translation);
    (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $acffcb171536f8e9$var$isComponentsMap = (object)=>{
    if (!(0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $acffcb171536f8e9$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const { transDefaultProps: transDefaultProps } = reactI18nextOptions;
    const mergedTOptions = transDefaultProps?.tOptions ? {
        ...transDefaultProps.tOptions,
        ...tOptions
    } : tOptions;
    const mergedShouldUnescape = shouldUnescape ?? transDefaultProps?.shouldUnescape;
    const mergedValues = transDefaultProps?.values ? {
        ...transDefaultProps.values,
        ...values
    } : values;
    const mergedComponents = transDefaultProps?.components ? {
        ...transDefaultProps.components,
        ...components
    } : components;
    const nodeAsString = $acffcb171536f8e9$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || mergedTOptions?.defaultValue || nodeAsString || reactI18nextOptions.transEmptyNodeValue || (typeof i18nKey === 'function' ? (0, $673ff3dfc4a496de$export$ec2cccc18ab4c2ae)(i18nKey) : i18nKey);
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = mergedValues && Object.keys(mergedValues).length > 0 ? {
        ...mergedValues,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    else values = mergedValues;
    const valuesFromChildren = $acffcb171536f8e9$var$getValuesFromChildren(children);
    if (valuesFromChildren && typeof valuesFromChildren.count === 'number' && count === undefined) count = valuesFromChildren.count;
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? mergedTOptions.interpolation : {
        interpolation: {
            ...mergedTOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...mergedTOptions,
        context: context || mergedTOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    let translation = key ? t(key, combinedTOpts) : defaultValue;
    if (translation === key && defaultValue) translation = defaultValue;
    const generatedComponents = $acffcb171536f8e9$var$generateComponents(mergedComponents, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($acffcb171536f8e9$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $acffcb171536f8e9$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, mergedShouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $acw62.createElement)(useAsParent, additionalProps, content) : content;
}



var $acw62 = parcelRequire("acw62");




const $26bfda595e5aa141$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $4f75eea5b29ffc65$export$2e2366488d12e20d)(instance.options.react);
        (0, $1d04edb3ddd0d89e$export$a039134f2fc7e0)(instance);
    }
};


const $0636c84fe4549f1f$export$5603ab5ced17ce64 = (0, $acw62.createContext)();
class $0636c84fe4549f1f$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $0636c84fe4549f1f$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $0636c84fe4549f1f$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $0636c84fe4549f1f$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        console.warn('react-i18next:: getInitialProps: You will need to pass in an i18next instance by using initReactI18next');
        return {};
    }
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $e04d9533328ca578$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $acffcb171536f8e9$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


class $e0c19337b294ccec$export$aa9e222d9ffc5d1b extends Error {
    constructor(message, position, translationString){
        super(message);
        this.name = 'TranslationParserError';
        this.position = position;
        this.translationString = translationString;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $e0c19337b294ccec$export$aa9e222d9ffc5d1b);
    }
}


const $1ddf6027fecc0115$var$commonEntities = {
    '&nbsp;': '\u00A0',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': "'",
    '&copy;': "\xa9",
    '&reg;': "\xae",
    '&trade;': "\u2122",
    '&hellip;': "\u2026",
    '&ndash;': "\u2013",
    '&mdash;': "\u2014",
    '&lsquo;': '\u2018',
    '&rsquo;': '\u2019',
    '&sbquo;': '\u201A',
    '&ldquo;': '\u201C',
    '&rdquo;': '\u201D',
    '&bdquo;': '\u201E',
    '&dagger;': "\u2020",
    '&Dagger;': "\u2021",
    '&bull;': "\u2022",
    '&prime;': "\u2032",
    '&Prime;': "\u2033",
    '&lsaquo;': "\u2039",
    '&rsaquo;': "\u203A",
    '&sect;': "\xa7",
    '&para;': "\xb6",
    '&middot;': "\xb7",
    '&ensp;': '\u2002',
    '&emsp;': '\u2003',
    '&thinsp;': '\u2009',
    '&euro;': "\u20AC",
    '&pound;': "\xa3",
    '&yen;': "\xa5",
    '&cent;': "\xa2",
    '&curren;': "\xa4",
    '&times;': "\xd7",
    '&divide;': "\xf7",
    '&minus;': "\u2212",
    '&plusmn;': "\xb1",
    '&ne;': "\u2260",
    '&le;': "\u2264",
    '&ge;': "\u2265",
    '&asymp;': "\u2248",
    '&equiv;': "\u2261",
    '&infin;': "\u221E",
    '&int;': "\u222B",
    '&sum;': "\u2211",
    '&prod;': "\u220F",
    '&radic;': "\u221A",
    '&part;': "\u2202",
    '&permil;': "\u2030",
    '&deg;': "\xb0",
    '&micro;': "\xb5",
    '&larr;': "\u2190",
    '&uarr;': "\u2191",
    '&rarr;': "\u2192",
    '&darr;': "\u2193",
    '&harr;': "\u2194",
    '&crarr;': "\u21B5",
    '&lArr;': "\u21D0",
    '&uArr;': "\u21D1",
    '&rArr;': "\u21D2",
    '&dArr;': "\u21D3",
    '&hArr;': "\u21D4",
    '&alpha;': "\u03B1",
    '&beta;': "\u03B2",
    '&gamma;': "\u03B3",
    '&delta;': "\u03B4",
    '&epsilon;': "\u03B5",
    '&zeta;': "\u03B6",
    '&eta;': "\u03B7",
    '&theta;': "\u03B8",
    '&iota;': "\u03B9",
    '&kappa;': "\u03BA",
    '&lambda;': "\u03BB",
    '&mu;': "\u03BC",
    '&nu;': "\u03BD",
    '&xi;': "\u03BE",
    '&omicron;': "\u03BF",
    '&pi;': "\u03C0",
    '&rho;': "\u03C1",
    '&sigma;': "\u03C3",
    '&tau;': "\u03C4",
    '&upsilon;': "\u03C5",
    '&phi;': "\u03C6",
    '&chi;': "\u03C7",
    '&psi;': "\u03C8",
    '&omega;': "\u03C9",
    '&Alpha;': "\u0391",
    '&Beta;': "\u0392",
    '&Gamma;': "\u0393",
    '&Delta;': "\u0394",
    '&Epsilon;': "\u0395",
    '&Zeta;': "\u0396",
    '&Eta;': "\u0397",
    '&Theta;': "\u0398",
    '&Iota;': "\u0399",
    '&Kappa;': "\u039A",
    '&Lambda;': "\u039B",
    '&Mu;': "\u039C",
    '&Nu;': "\u039D",
    '&Xi;': "\u039E",
    '&Omicron;': "\u039F",
    '&Pi;': "\u03A0",
    '&Rho;': "\u03A1",
    '&Sigma;': "\u03A3",
    '&Tau;': "\u03A4",
    '&Upsilon;': "\u03A5",
    '&Phi;': "\u03A6",
    '&Chi;': "\u03A7",
    '&Psi;': "\u03A8",
    '&Omega;': "\u03A9",
    '&Agrave;': "\xc0",
    '&Aacute;': "\xc1",
    '&Acirc;': "\xc2",
    '&Atilde;': "\xc3",
    '&Auml;': "\xc4",
    '&Aring;': "\xc5",
    '&AElig;': "\xc6",
    '&Ccedil;': "\xc7",
    '&Egrave;': "\xc8",
    '&Eacute;': "\xc9",
    '&Ecirc;': "\xca",
    '&Euml;': "\xcb",
    '&Igrave;': "\xcc",
    '&Iacute;': "\xcd",
    '&Icirc;': "\xce",
    '&Iuml;': "\xcf",
    '&ETH;': "\xd0",
    '&Ntilde;': "\xd1",
    '&Ograve;': "\xd2",
    '&Oacute;': "\xd3",
    '&Ocirc;': "\xd4",
    '&Otilde;': "\xd5",
    '&Ouml;': "\xd6",
    '&Oslash;': "\xd8",
    '&Ugrave;': "\xd9",
    '&Uacute;': "\xda",
    '&Ucirc;': "\xdb",
    '&Uuml;': "\xdc",
    '&Yacute;': "\xdd",
    '&THORN;': "\xde",
    '&szlig;': "\xdf",
    '&agrave;': "\xe0",
    '&aacute;': "\xe1",
    '&acirc;': "\xe2",
    '&atilde;': "\xe3",
    '&auml;': "\xe4",
    '&aring;': "\xe5",
    '&aelig;': "\xe6",
    '&ccedil;': "\xe7",
    '&egrave;': "\xe8",
    '&eacute;': "\xe9",
    '&ecirc;': "\xea",
    '&euml;': "\xeb",
    '&igrave;': "\xec",
    '&iacute;': "\xed",
    '&icirc;': "\xee",
    '&iuml;': "\xef",
    '&eth;': "\xf0",
    '&ntilde;': "\xf1",
    '&ograve;': "\xf2",
    '&oacute;': "\xf3",
    '&ocirc;': "\xf4",
    '&otilde;': "\xf5",
    '&ouml;': "\xf6",
    '&oslash;': "\xf8",
    '&ugrave;': "\xf9",
    '&uacute;': "\xfa",
    '&ucirc;': "\xfb",
    '&uuml;': "\xfc",
    '&yacute;': "\xfd",
    '&thorn;': "\xfe",
    '&yuml;': "\xff",
    '&iexcl;': "\xa1",
    '&iquest;': "\xbf",
    '&fnof;': "\u0192",
    '&circ;': "\u02C6",
    '&tilde;': "\u02DC",
    '&OElig;': "\u0152",
    '&oelig;': "\u0153",
    '&Scaron;': "\u0160",
    '&scaron;': "\u0161",
    '&Yuml;': "\u0178",
    '&ordf;': "\xaa",
    '&ordm;': "\xba",
    '&macr;': "\xaf",
    '&acute;': "\xb4",
    '&cedil;': "\xb8",
    '&sup1;': "\xb9",
    '&sup2;': "\xb2",
    '&sup3;': "\xb3",
    '&frac14;': "\xbc",
    '&frac12;': "\xbd",
    '&frac34;': "\xbe",
    '&spades;': "\u2660",
    '&clubs;': "\u2663",
    '&hearts;': "\u2665",
    '&diams;': "\u2666",
    '&loz;': "\u25CA",
    '&oline;': "\u203E",
    '&frasl;': "\u2044",
    '&weierp;': "\u2118",
    '&image;': "\u2111",
    '&real;': "\u211C",
    '&alefsym;': "\u2135"
};
const $1ddf6027fecc0115$var$entityPattern = new RegExp(Object.keys($1ddf6027fecc0115$var$commonEntities).map((entity)=>entity.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'g');
const $1ddf6027fecc0115$export$5cfeaa4af6841c8f = (text)=>text.replace($1ddf6027fecc0115$var$entityPattern, (match)=>$1ddf6027fecc0115$var$commonEntities[match]).replace(/&#(\d+);/g, (_, num)=>String.fromCharCode(parseInt(num, 10))).replace(/&#x([0-9a-fA-F]+);/g, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));


const $5f107391742a83a7$export$660b2ee2d4fb4eff = (translation)=>{
    const tokens = [];
    let position = 0;
    let currentText = '';
    const flushText = ()=>{
        if (currentText) {
            tokens.push({
                type: 'Text',
                value: currentText,
                position: position - currentText.length
            });
            currentText = '';
        }
    };
    while(position < translation.length){
        const char = translation[position];
        if (char === '<') {
            const tagMatch = translation.slice(position).match(/^<(\d+)>/);
            if (tagMatch) {
                flushText();
                tokens.push({
                    type: 'TagOpen',
                    value: tagMatch[0],
                    position: position,
                    tagNumber: parseInt(tagMatch[1], 10)
                });
                position += tagMatch[0].length;
            } else {
                const closeTagMatch = translation.slice(position).match(/^<\/(\d+)>/);
                if (closeTagMatch) {
                    flushText();
                    tokens.push({
                        type: 'TagClose',
                        value: closeTagMatch[0],
                        position: position,
                        tagNumber: parseInt(closeTagMatch[1], 10)
                    });
                    position += closeTagMatch[0].length;
                } else {
                    currentText += char;
                    position += 1;
                }
            }
        } else {
            currentText += char;
            position += 1;
        }
    }
    flushText();
    return tokens;
};



var $acw62 = parcelRequire("acw62");



const $54962d9d09845ed9$var$renderDeclarationNode = (declaration, children, childDeclarations)=>{
    const { type: type, props: props = {} } = declaration;
    if (props.children && Array.isArray(props.children) && childDeclarations) {
        const { children: _childrenToRemove, ...propsWithoutChildren } = props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, propsWithoutChildren, ...children);
    }
    if (children.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, props);
    if (children.length === 1) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, props, children[0]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, props, ...children);
};
const $54962d9d09845ed9$export$1038df9fa5e5f35f = (translation, declarations = [])=>{
    if (!translation) return [];
    const tokens = (0, $5f107391742a83a7$export$660b2ee2d4fb4eff)(translation);
    const result = [];
    const stack = [];
    const literalTagNumbers = new Set();
    const getCurrentDeclarations = ()=>{
        if (stack.length === 0) return declarations;
        const parentFrame = stack[stack.length - 1];
        if (parentFrame.declaration.props?.children && Array.isArray(parentFrame.declaration.props.children)) return parentFrame.declaration.props.children;
        return parentFrame.declarations;
    };
    tokens.forEach((token)=>{
        switch(token.type){
            case 'Text':
                {
                    const decoded = (0, $1ddf6027fecc0115$export$5cfeaa4af6841c8f)(token.value);
                    const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    targetArray.push(decoded);
                }
                break;
            case 'TagOpen':
                {
                    const { tagNumber: tagNumber } = token;
                    const currentDeclarations = getCurrentDeclarations();
                    const declaration = currentDeclarations[tagNumber];
                    if (!declaration) {
                        literalTagNumbers.add(tagNumber);
                        const literalText = `<${tagNumber}>`;
                        const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        targetArray.push(literalText);
                        break;
                    }
                    stack.push({
                        tagNumber: tagNumber,
                        children: [],
                        position: token.position,
                        declaration: declaration,
                        declarations: currentDeclarations
                    });
                }
                break;
            case 'TagClose':
                {
                    const { tagNumber: tagNumber } = token;
                    if (literalTagNumbers.has(tagNumber)) {
                        const literalText = `</${tagNumber}>`;
                        const literalTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        literalTargetArray.push(literalText);
                        literalTagNumbers.delete(tagNumber);
                        break;
                    }
                    if (stack.length === 0) throw new (0, $e0c19337b294ccec$export$aa9e222d9ffc5d1b)(`Unexpected closing tag </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const frame = stack.pop();
                    if (frame.tagNumber !== tagNumber) throw new (0, $e0c19337b294ccec$export$aa9e222d9ffc5d1b)(`Mismatched tags: expected </${frame.tagNumber}> but got </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const element = $54962d9d09845ed9$var$renderDeclarationNode(frame.declaration, frame.children, frame.declarations);
                    const elementTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    elementTargetArray.push(element);
                }
                break;
        }
    });
    if (stack.length > 0) {
        const unclosed = stack[stack.length - 1];
        throw new (0, $e0c19337b294ccec$export$aa9e222d9ffc5d1b)(`Unclosed tag <${unclosed.tagNumber}> at position ${unclosed.position}`, unclosed.position, translation);
    }
    return result;
};




function $e917e4d32765654d$export$c70a6545d92ee1d4({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `IcuTrans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, defaultTranslation);
    }
    const t = tFromProps || i18n.t?.bind(i18n) || ((k)=>k);
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    let mergedValues = values;
    if (i18n.options?.interpolation?.defaultVariables) mergedValues = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const translation = t(i18nKey, {
        defaultValue: defaultTranslation,
        ...mergedValues,
        ns: namespaces
    });
    try {
        const rendered = (0, $54962d9d09845ed9$export$1038df9fa5e5f35f)(translation, content);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, ...rendered);
    } catch (error) {
        (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'ICU_TRANS_RENDER_ERROR', `IcuTrans component error for key "${i18nKey}": ${error.message}`, {
            i18nKey: i18nKey,
            error: error
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, translation);
    }
}
$e917e4d32765654d$export$c70a6545d92ee1d4.displayName = 'IcuTransWithoutContext';



function $60cfc2270f17f8cc$export$c8b7e2ca8249a4be({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $e917e4d32765654d$export$c70a6545d92ee1d4)({
        i18nKey: i18nKey,
        defaultTranslation: defaultTranslation,
        content: content,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        values: values,
        i18n: i18n,
        t: tFromProps
    });
}
$60cfc2270f17f8cc$export$c8b7e2ca8249a4be.displayName = 'IcuTrans';




var $acw62 = parcelRequire("acw62");
var $c8e45c4daa4b95cb$exports = {};
'use strict';

$c8e45c4daa4b95cb$exports = (parcelRequire("hkKGc"));




const $3765cebd031b52c0$var$notReadyT = (k, optsOrDefaultValue)=>{
    if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
    if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
    if (typeof k === 'function') return '';
    if (Array.isArray(k)) {
        const last = k[k.length - 1];
        return typeof last === 'function' ? '' : last;
    }
    return k;
};
const $3765cebd031b52c0$var$notReadySnapshot = {
    t: $3765cebd031b52c0$var$notReadyT,
    ready: false
};
const $3765cebd031b52c0$var$dummySubscribe = ()=>()=>{};
const $3765cebd031b52c0$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $0636c84fe4549f1f$export$ea171b67e3820290)();
    if (!i18n) (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next');
    const i18nOptions = (0, $acw62.useMemo)(()=>({
            ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
            ...i18n?.options?.react,
            ...props
        }), [
        i18n,
        props
    ]);
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    const nsOrContext = ns || defaultNSFromContext || i18n?.options?.defaultNS;
    const unstableNamespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(nsOrContext) ? [
        nsOrContext
    ] : nsOrContext || [
        'translation'
    ];
    const namespaces = (0, $acw62.useMemo)(()=>unstableNamespaces, unstableNamespaces);
    i18n?.reportNamespaces?.addUsedNamespaces?.(namespaces);
    const revisionRef = (0, $acw62.useRef)(0);
    const subscribe = (0, $acw62.useCallback)((callback)=>{
        if (!i18n) return $3765cebd031b52c0$var$dummySubscribe;
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        const wrappedCallback = ()=>{
            revisionRef.current += 1;
            callback();
        };
        if (bindI18n) i18n.on(bindI18n, wrappedCallback);
        if (bindI18nStore) i18n.store.on(bindI18nStore, wrappedCallback);
        return ()=>{
            if (bindI18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, wrappedCallback));
            if (bindI18nStore) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, wrappedCallback));
        };
    }, [
        i18n,
        i18nOptions
    ]);
    const snapshotRef = (0, $acw62.useRef)();
    const getSnapshot = (0, $acw62.useCallback)(()=>{
        if (!i18n) return $3765cebd031b52c0$var$notReadySnapshot;
        const calculatedReady = !!(i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $cfb6e0167e0b350d$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
        const currentLng = props.lng || i18n.language;
        const currentRevision = revisionRef.current;
        const lastSnapshot = snapshotRef.current;
        if (lastSnapshot && lastSnapshot.ready === calculatedReady && lastSnapshot.lng === currentLng && lastSnapshot.keyPrefix === keyPrefix && lastSnapshot.revision === currentRevision) return lastSnapshot;
        const calculatedT = i18n.getFixedT(currentLng, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
        const newSnapshot = {
            t: calculatedT,
            ready: calculatedReady,
            lng: currentLng,
            keyPrefix: keyPrefix,
            revision: currentRevision
        };
        snapshotRef.current = newSnapshot;
        return newSnapshot;
    }, [
        i18n,
        namespaces,
        keyPrefix,
        i18nOptions,
        props.lng
    ]);
    const [loadCount, setLoadCount] = (0, $acw62.useState)(0);
    const { t: t, ready: ready } = (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $acw62.useEffect)(()=>{
        if (i18n && !ready && !useSuspense) {
            const onLoaded = ()=>setLoadCount((c)=>c + 1);
            if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        }
    }, [
        i18n,
        props.lng,
        namespaces,
        ready,
        useSuspense,
        loadCount
    ]);
    const finalI18n = i18n || {};
    const wrapperRef = (0, $acw62.useRef)(null);
    const wrapperLangRef = (0, $acw62.useRef)();
    const createI18nWrapper = (original)=>{
        const descriptors = Object.getOwnPropertyDescriptors(original);
        if (descriptors.__original) delete descriptors.__original;
        const wrapper = Object.create(Object.getPrototypeOf(original), descriptors);
        if (!Object.prototype.hasOwnProperty.call(wrapper, '__original')) try {
            Object.defineProperty(wrapper, '__original', {
                value: original,
                writable: false,
                enumerable: false,
                configurable: false
            });
        } catch (_) {}
        return wrapper;
    };
    const ret = (0, $acw62.useMemo)(()=>{
        const original = finalI18n;
        const lang = original?.language;
        let i18nWrapper = original;
        if (original) {
            if (wrapperRef.current && wrapperRef.current.__original === original) {
                if (wrapperLangRef.current !== lang) {
                    i18nWrapper = createI18nWrapper(original);
                    wrapperRef.current = i18nWrapper;
                    wrapperLangRef.current = lang;
                } else i18nWrapper = wrapperRef.current;
            } else {
                i18nWrapper = createI18nWrapper(original);
                wrapperRef.current = i18nWrapper;
                wrapperLangRef.current = lang;
            }
        }
        const effectiveT = !ready && !useSuspense ? (...args)=>{
            (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'USE_T_BEFORE_READY', 'useTranslation: t was called before ready. When using useSuspense: false, make sure to check the ready flag before using t.');
            return t(...args);
        } : t;
        const arr = [
            effectiveT,
            i18nWrapper,
            ready
        ];
        arr.t = effectiveT;
        arr.i18n = i18nWrapper;
        arr.ready = ready;
        return arr;
    }, [
        t,
        finalI18n,
        ready,
        finalI18n.resolvedLanguage,
        finalI18n.language,
        finalI18n.languages
    ]);
    if (i18n && useSuspense && !ready) throw new Promise((resolve)=>{
        const onLoaded = ()=>resolve();
        if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
        else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
    });
    return ret;
};



var $acw62 = parcelRequire("acw62");


const $d9bd4545752f9667$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $acw62.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $acw62.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $acw62.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $868685a400877801$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n?.language
    }, ready);
};



var $acw62 = parcelRequire("acw62");

function $c313608318d394ab$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $acw62.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $acw62.createElement)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


const $d97c91d803f78bcc$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useSSR: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
        return;
    }
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        if (!i18n.services?.resourceStore) {
            (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'I18N_NOT_INITIALIZED', "useSSR: i18n instance was found but not initialized (services.resourceStore is missing). Make sure you call i18next.init() before using useSSR \u2014 e.g. at module level, not only in getStaticProps/getServerSideProps.");
            return;
        }
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $afd5c8e3ef499392$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $d97c91d803f78bcc$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $acw62.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $0636c84fe4549f1f$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $2843511fe0fbbf82$export$324d90190a8b822a = ()=>'';
const $2843511fe0fbbf82$export$2da9be4cfdb689b1 = ()=>'';
const $2843511fe0fbbf82$export$98e628dec113755e = ()=>'';
const $2843511fe0fbbf82$export$2e6c959c16ff56b8 = ()=>'';
const $2843511fe0fbbf82$export$4e35d5c922a95490 = ()=>'';
const $2843511fe0fbbf82$export$720a3b9db04b7a0f = ()=>'';


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/url.ts
const $ee8fa670c1d03165$export$6c52c2011d568bd0 = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
const $ee8fa670c1d03165$export$825a82322d91916e = /^[\\/]{2}/;
function $ee8fa670c1d03165$export$977999b735cd4f26(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/router/history.ts
/**
* Actions represent the type of change to a location value.
*/ let $2ce80a7c58bedbaf$export$e19cd5f9376f8cee = /* @__PURE__ */ function(Action) {
    /**
	* A POP indicates a change to an arbitrary index in the history stack, such
	* as a back or forward navigation. It does not describe the direction of the
	* navigation, only that the current index changed.
	*
	* Note: This is the default action for newly created history objects.
	*/ Action["Pop"] = "POP";
    /**
	* A PUSH indicates a new entry being added to the history stack, such as when
	* a link is clicked and a new page loads. When this happens, all subsequent
	* entries in the stack are lost.
	*/ Action["Push"] = "PUSH";
    /**
	* A REPLACE indicates the entry at the current index in the history stack
	* being replaced by a new one.
	*/ Action["Replace"] = "REPLACE";
    return Action;
}({});
const $2ce80a7c58bedbaf$var$PopStateEventType = "popstate";
function $2ce80a7c58bedbaf$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
/**
* Memory history stores the current location in memory. It is designed for use
* in stateful non-browser environments like tests and React Native.
*/ function $2ce80a7c58bedbaf$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP";
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $2ce80a7c58bedbaf$export$90c043f1c57770b8(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $2ce80a7c58bedbaf$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $2ce80a7c58bedbaf$export$fe53371bee54353d(to);
    }
    return {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $2ce80a7c58bedbaf$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH";
            let nextLocation = $2ce80a7c58bedbaf$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE";
            let nextLocation = $2ce80a7c58bedbaf$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP";
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
}
/**
* Browser history stores the location in regular URLs. This is the standard for
* most web apps, but it requires some configuration on the server to ensure you
* serve the same app at multiple URLs.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
*/ function $2ce80a7c58bedbaf$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window.location;
        return $2ce80a7c58bedbaf$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash
        } : void 0);
    }
    function createBrowserHref(window, to) {
        return typeof to === "string" ? to : $2ce80a7c58bedbaf$export$fe53371bee54353d(to);
    }
    return $2ce80a7c58bedbaf$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
* Hash history stores the location in window.location.hash. This makes it ideal
* for situations where you don't want to send the location to the server for
* some reason, either because you do cannot configure it or the URL space is
* reserved for something else.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
*/ function $2ce80a7c58bedbaf$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $2ce80a7c58bedbaf$export$8ccf933b0513f8d0(window.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $2ce80a7c58bedbaf$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window, to) {
        let base = window.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $2ce80a7c58bedbaf$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $2ce80a7c58bedbaf$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $2ce80a7c58bedbaf$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $2ce80a7c58bedbaf$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $2ce80a7c58bedbaf$export$491112666e282270(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $2ce80a7c58bedbaf$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
/**
* For browser-based histories, we combine the state and key into an object
*/ function $2ce80a7c58bedbaf$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
/**
* Creates a Location object with a unique key from the given Path
*/ function $2ce80a7c58bedbaf$export$90c043f1c57770b8(current, to, state = null, key, mask) {
    return {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $2ce80a7c58bedbaf$export$8ccf933b0513f8d0(to) : to,
        state: state,
        key: to && to.key || key || $2ce80a7c58bedbaf$var$createKey(),
        mask: mask
    };
}
/**
* Creates a string URL path from the given pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The pathname, search, and hash components to combine.
* @returns The combined URL path.
*/ function $2ce80a7c58bedbaf$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
* Parses a string URL path into its separate pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The URL path to parse.
* @returns The parsed pathname, search, and hash components.
*/ function $2ce80a7c58bedbaf$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $2ce80a7c58bedbaf$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options = {}) {
    let { window: window = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window.history;
    let action = "POP";
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        return (globalHistory.state || {
            idx: null
        }).idx;
    }
    function handlePop() {
        action = "POP";
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH";
        let location = $2ce80a7c58bedbaf$var$isLocation(to) ? to : $2ce80a7c58bedbaf$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $2ce80a7c58bedbaf$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = "REPLACE";
        let location = $2ce80a7c58bedbaf$var$isLocation(to) ? to : $2ce80a7c58bedbaf$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $2ce80a7c58bedbaf$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $2ce80a7c58bedbaf$export$e2450fce17852bf2(window, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window.addEventListener($2ce80a7c58bedbaf$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window.removeEventListener($2ce80a7c58bedbaf$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $2ce80a7c58bedbaf$export$e2450fce17852bf2(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $2ce80a7c58bedbaf$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $2ce80a7c58bedbaf$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && (0, $ee8fa670c1d03165$export$825a82322d91916e).test(href)) href = base + href;
    return new URL(href, base);
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $acw62 = parcelRequire("acw62");
//#region lib/router/utils.ts
/**
* Creates a type-safe {@link RouterContext} object that can be used to
* store and retrieve arbitrary values in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
* Similar to React's [`createContext`](https://react.dev/reference/react/createContext),
* but specifically designed for React Router's request/response lifecycle.
*
* If a `defaultValue` is provided, it will be returned from `context.get()`
* when no value has been set for the context. Otherwise, reading this context
* when no value has been set will throw an error.
*
* ```tsx filename=app/context.ts
* import { createContext } from "react-router";
*
* // Create a context for user data
* export const userContext =
*   createContext<User | null>(null);
* ```
*
* ```tsx filename=app/middleware/auth.ts
* import { getUserFromSession } from "~/auth.server";
* import { userContext } from "~/context";
*
* export const authMiddleware = async ({
*   context,
*   request,
* }) => {
*   const user = await getUserFromSession(request);
*   context.set(userContext, user);
* };
* ```
*
* ```tsx filename=app/routes/profile.tsx
* import { userContext } from "~/context";
*
* export async function loader({
*   context,
* }: Route.LoaderArgs) {
*   const user = context.get(userContext);
*
*   if (!user) {
*     throw new Response("Unauthorized", { status: 401 });
*   }
*
*   return { user };
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param defaultValue An optional default value for the context. This value
* will be returned if no value has been set for this context.
* @returns A {@link RouterContext} object that can be used with
* `context.get()` and `context.set()` in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
*/ function $edf931d6dcac43ec$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
/**
* Provides methods for writing/reading values in application context in a
* type-safe way. Primarily for usage with [middleware](../../how-to/middleware).
*
* @example
* import {
*   createContext,
*   RouterContextProvider
* } from "react-router";
*
* const userContext = createContext<User | null>(null);
* const contextProvider = new RouterContextProvider();
* contextProvider.set(userContext, getUser());
* //                               ^ Type-safe
* const user = contextProvider.get(userContext);
* //    ^ User
*
* @public
* @category Utils
* @mode framework
* @mode data
*/ var $edf931d6dcac43ec$export$b8d3e69d4b3eff04 = class {
    #map = /* @__PURE__ */ new Map();
    /**
	* Create a new `RouterContextProvider` instance
	* @param init An optional initial context map to populate the provider with
	*/ constructor(init){
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
	* Access a value from the context. If no value has been set for the context,
	* it will return the context's `defaultValue` if provided, or throw an error
	* if no `defaultValue` was set.
	* @param context The context to get the value for
	* @returns The value for the context, or the context's `defaultValue` if no
	* value was set
	*/ get(context) {
        if (this.#map.has(context)) return this.#map.get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
	* Set a value for the context. If the context already has a value set, this
	* will overwrite it.
	*
	* @param context The context to set the value for
	* @param value The value to set for the context
	* @returns {void}
	*/ set(context, value) {
        this.#map.set(context, value);
    }
};
const $edf931d6dcac43ec$var$unsupportedLazyRouteObjectKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $edf931d6dcac43ec$export$3e22299e33adeed1(key) {
    return $edf931d6dcac43ec$var$unsupportedLazyRouteObjectKeys.has(key);
}
const $edf931d6dcac43ec$var$unsupportedLazyRouteFunctionKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $edf931d6dcac43ec$export$a89d811eaa209e85(key) {
    return $edf931d6dcac43ec$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $edf931d6dcac43ec$var$isIndexRoute(route) {
    return route.index === true;
}
function $edf931d6dcac43ec$export$6bc17138063be773(route) {
    let updates = {};
    if (route.Component) Object.assign(updates, {
        element: $acw62.createElement(route.Component),
        Component: void 0
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
        HydrateFallback: void 0
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: void 0
    });
    return updates;
}
function $edf931d6dcac43ec$export$87cb1a9238dc3fba(routes, mapRouteProperties = $edf931d6dcac43ec$export$6bc17138063be773, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(route.index !== true || !route.children, `Cannot specify children on an index route`);
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($edf931d6dcac43ec$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $edf931d6dcac43ec$var$mergeRouteUpdates(indexRoute, mapRouteProperties(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $edf931d6dcac43ec$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $edf931d6dcac43ec$export$87cb1a9238dc3fba(route.children, mapRouteProperties, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $edf931d6dcac43ec$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
/**
* Matches the given routes to a location and returns the match data.
*
* @example
* import { matchRoutes } from "react-router";
*
* let routes = [{
*   path: "/",
*   Component: Root,
*   children: [{
*     path: "dashboard",
*     Component: Dashboard,
*   }]
* }];
*
* matchRoutes(routes, "/dashboard"); // [rootMatch, dashboardMatch]
*
* @public
* @category Utils
* @param routes The array of route objects to match against.
* @param locationArg The location to match against, either a string path or a
* partial {@link Location} object
* @param basename Optional base path to strip from the location before matching.
* Defaults to `/`.
* @returns An array of matched routes, or `null` if no matches were found.
*/ function $edf931d6dcac43ec$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $edf931d6dcac43ec$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $edf931d6dcac43ec$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let pathname = $edf931d6dcac43ec$export$b69e3301ce081aa3((typeof locationArg === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(locationArg) : locationArg).pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $edf931d6dcac43ec$export$e486c0390e42ccf6(routes);
    let matches = null;
    let decoded = $edf931d6dcac43ec$export$cd27bea214d030c2(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $edf931d6dcac43ec$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $edf931d6dcac43ec$export$fcf533780bf49ee2(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $edf931d6dcac43ec$export$e486c0390e42ccf6(routes) {
    let branches = $edf931d6dcac43ec$var$flattenRoutes(routes);
    $edf931d6dcac43ec$var$rankRouteBranches(branches);
    return branches;
}
function $edf931d6dcac43ec$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $edf931d6dcac43ec$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $edf931d6dcac43ec$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $edf931d6dcac43ec$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta, i)=>{
                let [matcher, params] = $edf931d6dcac43ec$export$d726f29eb2425705(meta.relativePath, meta.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $edf931d6dcac43ec$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $edf931d6dcac43ec$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $edf931d6dcac43ec$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $edf931d6dcac43ec$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $edf931d6dcac43ec$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $edf931d6dcac43ec$var$paramRe = /^:[\w-]+$/;
const $edf931d6dcac43ec$var$partialParamRe = /^:[\w-]+/;
const $edf931d6dcac43ec$var$partialDynamicSegmentValue = 3.5;
const $edf931d6dcac43ec$var$dynamicSegmentValue = 3;
const $edf931d6dcac43ec$var$indexRouteValue = 2;
const $edf931d6dcac43ec$var$emptySegmentValue = 1;
const $edf931d6dcac43ec$var$staticSegmentValue = 10;
const $edf931d6dcac43ec$var$splatPenalty = -2;
const $edf931d6dcac43ec$var$isSplat = (s)=>s === "*";
function $edf931d6dcac43ec$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($edf931d6dcac43ec$var$isSplat)) initialScore += $edf931d6dcac43ec$var$splatPenalty;
    if (index) initialScore += $edf931d6dcac43ec$var$indexRouteValue;
    return segments.filter((s)=>!$edf931d6dcac43ec$var$isSplat(s)).reduce((score, segment)=>score + ($edf931d6dcac43ec$var$paramRe.test(segment) ? $edf931d6dcac43ec$var$dynamicSegmentValue : $edf931d6dcac43ec$var$partialParamRe.test(segment) ? $edf931d6dcac43ec$var$partialDynamicSegmentValue : segment === "" ? $edf931d6dcac43ec$var$emptySegmentValue : $edf931d6dcac43ec$var$staticSegmentValue), initialScore);
}
function $edf931d6dcac43ec$var$compareIndexes(a, b) {
    return a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]) ? a[a.length - 1] - b[b.length - 1] : 0;
}
function $edf931d6dcac43ec$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = meta.matcher && meta.compiledParams ? $edf931d6dcac43ec$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $edf931d6dcac43ec$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $edf931d6dcac43ec$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            params: matchedParams,
            pathname: $edf931d6dcac43ec$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $edf931d6dcac43ec$var$normalizePathname($edf931d6dcac43ec$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $edf931d6dcac43ec$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
* Characters that `encodeURIComponent` escapes but that are valid literally in
* a URL path segment. Per RFC 3986 §3.3, a path segment is made of `pchar`:
*
* ```
* pchar = unreserved / pct-encoded / sub-delims / ":" / "@"
* sub-delims = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
* ```
*
* `encodeURIComponent` targets query-string values, where `$ & + , ; = : @`
* are delimiters and must be escaped — but in a path segment they carry no
* special meaning, and browsers keep them literal in `location.pathname`.
* (`! ' ( ) *` and the unreserved set are already left alone by
* `encodeURIComponent`, so they need no restoring.)
*/ const $edf931d6dcac43ec$var$PATH_PARAM_OVERESCAPED = {
    "%24": "$",
    "%26": "&",
    "%2B": "+",
    "%2C": ",",
    "%3A": ":",
    "%3B": ";",
    "%3D": "=",
    "%40": "@"
};
/**
* Encodes a param value for interpolation into a single URL path segment.
*
* Escapes characters that would break the path (`/ ? # %`, whitespace,
* non-ASCII, …) while leaving characters that RFC 3986 permits literally in a
* path segment untouched. Escaping those would needlessly rewrite URLs — e.g.
*  a semver build param `1.0.0+1` would become `1.0.0%2B1` even though browsers
* display and match the `+` literally in `location.pathname`.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3))
*
* @param value The param value to encode.
* @returns The encoded value, safe for use as a single path segment.
*/ function $edf931d6dcac43ec$export$1adf7db041bd81b8(value) {
    return encodeURIComponent(value).replace(/%(?:24|26|2B|2C|3A|3B|3D|40)/g, (match)=>$edf931d6dcac43ec$var$PATH_PARAM_OVERESCAPED[match]);
}
/**
* Returns a path with params interpolated.
*
* Param values are percent-encoded for use in a path segment: characters that
* would change the URL structure (`/`, `?`, `#`, `%`, whitespace, non-ASCII)
* are escaped, while characters that RFC 3986 allows literally in a path
* segment (`$ & + , ; = : @`) are kept as-is. Note this differs from query-string
* encoding (`encodeURIComponent`/`URLSearchParams`), where those characters are
* delimiters and must be escaped. Splat (`*`) values are encoded per segment,
* preserving `/` separators.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3)
*
* @example
* import { generatePath } from "react-router";
*
* generatePath("/users/:id", { id: "123" }); // "/users/123"
* generatePath("/files/:name", { name: "a b" }); // "/files/a%20b"
* generatePath("/releases/:v", { v: "1.0.0+1" }); // "/releases/1.0.0+1"
*
* @public
* @category Utils
* @param originalPath The original path to generate.
* @param params The parameters to interpolate into the path.
* @returns The generated path with parameters interpolated.
*/ function $edf931d6dcac43ec$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    return prefix + path.split(/\/+/).map((segment, index, array)=>{
        if (index === array.length - 1 && segment === "*") return stringify(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(optional === "?" || param != null, `Missing ":${key}" param`);
            return $edf931d6dcac43ec$export$1adf7db041bd81b8(stringify(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment).join("/");
}
/**
* Performs pattern matching on a URL pathname and returns information about
* the match.
*
* @public
* @category Utils
* @param pattern The pattern to match against the URL pathname. This can be a
* string or a {@link PathPattern} object. If a string is provided, it will be
* treated as a pattern with `caseSensitive` set to `false` and `end` set to
* `true`.
* @param pathname The URL pathname to match against the pattern.
* @returns A path match object if the pattern matches the pathname,
* or `null` if it does not match.
*/ function $edf931d6dcac43ec$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $edf931d6dcac43ec$export$d726f29eb2425705(pattern.path, pattern.caseSensitive, pattern.end);
    return $edf931d6dcac43ec$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $edf931d6dcac43ec$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    return {
        params: compiledParams.reduce((memo, { paramName: paramName, isOptional: isOptional }, index)=>{
            if (paramName === "*") {
                let splatValue = captureGroups[index] || "";
                pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
            }
            const value = captureGroups[index];
            if (isOptional && !value) memo[paramName] = void 0;
            else memo[paramName] = (value || "").replace(/%2F/g, "/");
            return memo;
        }, {}),
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $edf931d6dcac43ec$export$d726f29eb2425705(path, caseSensitive = false, end = true) {
    (0, $2ce80a7c58bedbaf$export$491112666e282270)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(?=\/|$|\()/g, "(?:/$1)?");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    return [
        new RegExp(regexpSource, caseSensitive ? void 0 : "i"),
        params
    ];
}
function $edf931d6dcac43ec$export$cd27bea214d030c2(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $edf931d6dcac43ec$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $edf931d6dcac43ec$export$e9a5bfadbc179142({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $edf931d6dcac43ec$export$86d9a7913e44197e([
        basename,
        pathname
    ]);
}
const $edf931d6dcac43ec$export$a1cbf2de32a9fd1 = (url)=>(0, $ee8fa670c1d03165$export$6c52c2011d568bd0).test(url);
/**
* Returns a resolved {@link Path} object relative to the given pathname.
*
* @public
* @category Utils
* @param to The path to resolve, either a string or a partial {@link Path}
* object.
* @param fromPathname The pathname to resolve the path from. Defaults to `/`.
* @returns A {@link Path} object with the resolved pathname, search, and hash.
*/ function $edf931d6dcac43ec$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $edf931d6dcac43ec$export$f857a07c5bd323b8(toPathname);
        if (toPathname.startsWith("/")) pathname = $edf931d6dcac43ec$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $edf931d6dcac43ec$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $edf931d6dcac43ec$var$normalizeSearch(search),
        hash: $edf931d6dcac43ec$var$normalizeHash(hash)
    };
}
function $edf931d6dcac43ec$var$resolvePathname(relativePath, fromPathname) {
    let segments = $edf931d6dcac43ec$export$b6d465111d914331(fromPathname).split("/");
    relativePath.split("/").forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $edf931d6dcac43ec$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $edf931d6dcac43ec$export$b234c29a3bb68fc8(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $edf931d6dcac43ec$export$fe6dbc5de95f53ab(matches) {
    let pathMatches = $edf931d6dcac43ec$export$b234c29a3bb68fc8(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $edf931d6dcac43ec$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(toArg);
    else {
        to = {
            ...toArg
        };
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("?"), $edf931d6dcac43ec$var$getInvalidPathError("?", "pathname", "search", to));
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("#"), $edf931d6dcac43ec$var$getInvalidPathError("#", "pathname", "hash", to));
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!to.search || !to.search.includes("#"), $edf931d6dcac43ec$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $edf931d6dcac43ec$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
const $edf931d6dcac43ec$export$f857a07c5bd323b8 = (path)=>path.replace(/[\\/]{2,}/g, "/");
const $edf931d6dcac43ec$export$86d9a7913e44197e = (paths)=>$edf931d6dcac43ec$export$f857a07c5bd323b8(paths.join("/"));
const $edf931d6dcac43ec$export$b6d465111d914331 = (path)=>path.replace(/\/+$/, "");
const $edf931d6dcac43ec$var$normalizePathname = (pathname)=>$edf931d6dcac43ec$export$b6d465111d914331(pathname).replace(/^\/*/, "/");
const $edf931d6dcac43ec$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $edf931d6dcac43ec$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $edf931d6dcac43ec$var$DataWithResponseInit = class {
    type = "DataWithResponseInit";
    data;
    init;
    constructor(data, init){
        this.data = data;
        this.init = init || null;
    }
};
/**
* Create "responses" that contain `headers`/`status` without forcing
* serialization into an actual [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
*
* @example
* import { data } from "react-router";
*
* export async function action({ request }: Route.ActionArgs) {
*   let formData = await request.formData();
*   let item = await createItem(formData);
*   return data(item, {
*     headers: { "X-Custom-Header": "value" }
*     status: 201,
*   });
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param data The data to be included in the response.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A {@link DataWithResponseInit} instance containing the data and
* response init.
*/ function $edf931d6dcac43ec$export$4051a07651545597(data, init) {
    return new $edf931d6dcac43ec$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response).
* Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* @example
* import { redirect } from "react-router";
*
* export async function loader({ request }: Route.LoaderArgs) {
*   if (!isLoggedIn(request))
*     throw redirect("/login");
*   }
*
*   // ...
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $edf931d6dcac43ec$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will force a document reload to the new location. Sets the status code
* and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* ```tsx filename=routes/logout.tsx
* import { redirectDocument } from "react-router";
*
* import { destroySession } from "../sessions.server";
*
* export async function action({ request }: Route.ActionArgs) {
*   let session = await getSession(request.headers.get("Cookie"));
*   return redirectDocument("/", {
*     headers: { "Set-Cookie": await destroySession(session) }
*   });
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $edf931d6dcac43ec$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $edf931d6dcac43ec$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will perform a [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState)
* instead of a [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* for client-side navigation redirects. Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* @example
* import { replace } from "react-router";
*
* export async function loader() {
*   return replace("/new-location");
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $edf931d6dcac43ec$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $edf931d6dcac43ec$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
const $edf931d6dcac43ec$export$1a235bd2b33434e5 = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $edf931d6dcac43ec$export$f2680fa305b734ca = class {
    status;
    statusText;
    data;
    error;
    internal;
    constructor(status, statusText, data, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
};
/**
* Check if the given error is an {@link ErrorResponse} generated from a 4xx/5xx
* [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* thrown from an [`action`](../../start/framework/route-module#action) or
* [`loader`](../../start/framework/route-module#loader) function.
*
* @example
* import { isRouteErrorResponse } from "react-router";
*
* export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
*   if (isRouteErrorResponse(error)) {
*     return (
*       <>
*         <p>Error: `${error.status}: ${error.statusText}`</p>
*         <p>{error.data}</p>
*       </>
*     );
*   }
*
*   return (
*     <p>Error: {error instanceof Error ? error.message : "Unknown Error"}</p>
*   );
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param error The error to check.
* @returns `true` if the error is an {@link ErrorResponse}, `false` otherwise.
*/ function $edf931d6dcac43ec$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $edf931d6dcac43ec$export$d738435097971c09(matches) {
    return $edf931d6dcac43ec$export$86d9a7913e44197e(matches.map((m)=>m.route.path).filter(Boolean)) || "/";
}
function $edf931d6dcac43ec$export$141d98e45b4b08e4(request, path) {
    let url = new URL(typeof request === "string" || request instanceof URL ? request : request.url);
    let parsed = typeof path === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        let search = searchParams.toString();
        url.search = search ? `?${search}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
const $edf931d6dcac43ec$export$4e09c449d6c407f7 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $edf931d6dcac43ec$export$ac5aeb949e84fd96(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !(0, $ee8fa670c1d03165$export$6c52c2011d568bd0).test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($edf931d6dcac43ec$export$4e09c449d6c407f7) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = (0, $ee8fa670c1d03165$export$825a82322d91916e).test(to) ? new URL((0, $ee8fa670c1d03165$export$977999b735cd4f26)(to, currentUrl.protocol)) : new URL(to);
        let path = $edf931d6dcac43ec$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

//#region lib/router/instrumentation.ts
const $bb1de4858130979b$var$UninstrumentedSymbol = Symbol("Uninstrumented");
const $bb1de4858130979b$export$b1aab28b8e9d7d25 = (0, $edf931d6dcac43ec$export$fd42f52fd3ae1109)();
let $bb1de4858130979b$var$instrumentationClientResultMetaReceivers = /* @__PURE__ */ new WeakMap();
function $bb1de4858130979b$export$3cb8f5f9ecc770ef(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                if (i.lazy != null) aggregated.lazy.push(i.lazy);
                if (i["lazy.loader"] != null) aggregated["lazy.loader"].push(i["lazy.loader"]);
                if (i["lazy.action"] != null) aggregated["lazy.action"].push(i["lazy.action"]);
                if (i["lazy.middleware"] != null) aggregated["lazy.middleware"].push(i["lazy.middleware"]);
                if (i.middleware != null) aggregated.middleware.push(i.middleware);
                if (i.loader != null) aggregated.loader.push(i.loader);
                if (i.action != null) aggregated.action.push(i.action);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let lazy = route.lazy;
        updates.lazy = async (...args)=>{
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.lazy, void 0, ()=>lazy(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
        };
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        if (typeof lazyObject.middleware === "function" && aggregated["lazy.middleware"].length > 0) {
            let middleware = lazyObject.middleware;
            updates.lazy = Object.assign(updates.lazy || {}, {
                middleware: async (...args)=>{
                    return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated["lazy.middleware"], void 0, ()=>middleware(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.loader === "function" && aggregated["lazy.loader"].length > 0) {
            let loader = lazyObject.loader;
            updates.lazy = Object.assign(updates.lazy || {}, {
                loader: async (...args)=>{
                    return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated["lazy.loader"], void 0, ()=>loader(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.action === "function" && aggregated["lazy.action"].length > 0) {
            let action = lazyObject.action;
            updates.lazy = Object.assign(updates.lazy || {}, {
                action: async (...args)=>{
                    return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated["lazy.action"], void 0, ()=>action(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
                }
            });
        }
    }
    if (typeof route.loader === "function" && aggregated.loader.length > 0) {
        let original = $bb1de4858130979b$var$getUninstrumentedHandler(route.loader);
        let instrumented = async (...args)=>{
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.loader, $bb1de4858130979b$var$getHandlerInfo(args[0]), ()=>original(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
        };
        if (original.hydrate === true) instrumented.hydrate = true;
        $bb1de4858130979b$var$setUninstrumentedHandler(instrumented, original);
        updates.loader = instrumented;
    }
    if (typeof route.action === "function" && aggregated.action.length > 0) {
        let original = $bb1de4858130979b$var$getUninstrumentedHandler(route.action);
        let instrumented = async (...args)=>{
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.action, $bb1de4858130979b$var$getHandlerInfo(args[0]), ()=>original(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
        };
        $bb1de4858130979b$var$setUninstrumentedHandler(instrumented, original);
        updates.action = instrumented;
    }
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = $bb1de4858130979b$var$getUninstrumentedHandler(middleware);
        let instrumented = async (...args)=>{
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.middleware, $bb1de4858130979b$var$getHandlerInfo(args[0]), ()=>original(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
        };
        $bb1de4858130979b$var$setUninstrumentedHandler(instrumented, original);
        return instrumented;
    });
    return updates;
}
function $bb1de4858130979b$export$ac4df491f31cbbfc(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.navigate != null) aggregated.navigate.push(i.navigate);
                if (i.fetch != null) aggregated.fetch.push(i.fetch);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = $bb1de4858130979b$var$getUninstrumentedHandler(router.navigate);
        let instrumentedNavigate = async (...args)=>{
            let [to, opts] = args;
            let meta;
            let info = {
                to: typeof to === "number" || typeof to === "string" ? to : to ? (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(to) : ".",
                ...$bb1de4858130979b$var$getRouterInfo(router, opts ?? {})
            };
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.navigate, info, async ()=>{
                if (typeof to === "number") return await navigate(...args);
                let cleanup = $bb1de4858130979b$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await navigate(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$bb1de4858130979b$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $bb1de4858130979b$var$setUninstrumentedHandler(instrumentedNavigate, navigate);
        router.navigate = instrumentedNavigate;
    }
    if (aggregated.fetch.length > 0) {
        let fetch = $bb1de4858130979b$var$getUninstrumentedHandler(router.fetch);
        let instrumentedFetch = async (...args)=>{
            let [key, _, href, opts] = args;
            let meta;
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.fetch, {
                href: href ?? ".",
                fetcherKey: key,
                ...$bb1de4858130979b$var$getRouterInfo(router, opts ?? {})
            }, async ()=>{
                let cleanup = $bb1de4858130979b$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await fetch(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$bb1de4858130979b$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $bb1de4858130979b$var$setUninstrumentedHandler(instrumentedFetch, fetch);
        router.fetch = instrumentedFetch;
    }
    return router;
}
function $bb1de4858130979b$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.request != null) aggregated.request.push(i.request);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = async (...args)=>{
        let [request, context] = args;
        let instrumentationContext = context ?? new (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04)();
        return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.request, {
            request: $bb1de4858130979b$var$getReadonlyRequest(request),
            context: $bb1de4858130979b$var$getReadonlyContext(instrumentationContext)
        }, ()=>handler(request, instrumentationContext), (result, info)=>{
            let meta;
            try {
                meta = info.context?.get($bb1de4858130979b$export$b1aab28b8e9d7d25);
            } catch  {}
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(result.value instanceof Response, "Expected a Response from the request handler");
            return {
                ...$bb1de4858130979b$var$getInstrumentationInnerResult(result),
                statusCode: result.value.status,
                meta: meta
            };
        }));
    };
    return instrumentedHandler;
}
function $bb1de4858130979b$var$getUninstrumentedHandler(handler) {
    return handler[$bb1de4858130979b$var$UninstrumentedSymbol] ?? handler;
}
function $bb1de4858130979b$var$setUninstrumentedHandler(handler, uninstrumentedHandler) {
    handler[$bb1de4858130979b$var$UninstrumentedSymbol] = uninstrumentedHandler;
}
function $bb1de4858130979b$var$setInstrumentationClientResultMetaReceiver(router, receiver) {
    $bb1de4858130979b$var$instrumentationClientResultMetaReceivers.set(router, receiver);
    return ()=>{
        if ($bb1de4858130979b$var$instrumentationClientResultMetaReceivers.get(router) === receiver) $bb1de4858130979b$var$instrumentationClientResultMetaReceivers.delete(router);
    };
}
function $bb1de4858130979b$export$5579798e35f5560e(router) {
    let receiver = $bb1de4858130979b$var$instrumentationClientResultMetaReceivers.get(router);
    $bb1de4858130979b$var$instrumentationClientResultMetaReceivers.delete(router);
    return receiver;
}
function $bb1de4858130979b$var$throwOrReturnResult(result) {
    if (result.type === "error") throw result.value;
    return result.value;
}
async function $bb1de4858130979b$var$recurseRight(impls, info, handler, getInnerResult, state = {
    result: null,
    innerResult: null
}, index = impls.length - 1) {
    let impl = impls[index];
    if (!impl) {
        try {
            state.result = {
                type: "success",
                value: await handler()
            };
        } catch (e) {
            state.result = {
                type: "error",
                value: e
            };
        }
        state.innerResult = getInnerResult(state.result, info);
    } else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $bb1de4858130979b$var$recurseRight(impls, info, handler, getInnerResult, state, index - 1);
            await handlerPromise;
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(state.innerResult, "Expected an inner result");
            return state.innerResult;
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (state.result) return state.result;
    state.result = {
        type: "error",
        value: /* @__PURE__ */ new Error("No result assigned in instrumentation chain.")
    };
    state.innerResult = getInnerResult(state.result, info);
    return state.result;
}
function $bb1de4858130979b$var$getInstrumentationInnerResult(result) {
    if (result.type === "error" && result.value instanceof Error) return {
        status: "error",
        error: result.value
    };
    return {
        status: "success",
        error: void 0
    };
}
function $bb1de4858130979b$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params } = args;
    return {
        ...args,
        request: $bb1de4858130979b$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        context: $bb1de4858130979b$var$getReadonlyContext(context)
    };
}
function $bb1de4858130979b$var$getRouterInfo(router, opts) {
    return {
        currentUrl: (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $bb1de4858130979b$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $bb1de4858130979b$var$getReadonlyContext(context) {
    return {
        get: (ctx)=>context.get(ctx)
    };
}


//#region lib/router/router.ts
const $27ddc9c887d48115$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
const $27ddc9c887d48115$var$validMutationMethods = new Set($27ddc9c887d48115$var$validMutationMethodsArr);
const $27ddc9c887d48115$var$validRequestMethodsArr = [
    "GET",
    ...$27ddc9c887d48115$var$validMutationMethodsArr
];
const $27ddc9c887d48115$var$validRequestMethods = new Set($27ddc9c887d48115$var$validRequestMethodsArr);
const $27ddc9c887d48115$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $27ddc9c887d48115$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $27ddc9c887d48115$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $27ddc9c887d48115$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $27ddc9c887d48115$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
const $27ddc9c887d48115$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
const $27ddc9c887d48115$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
/**
* Encapsulates the stable and in-flight route trees together with their
* pre-computed branch caches so the structures always stay in sync.
*/ var $27ddc9c887d48115$var$DataRoutes = class {
    #routes;
    #branches;
    #hmrRoutes;
    #hmrBranches;
    constructor(routes){
        this.#routes = routes;
        this.#branches = (0, $edf931d6dcac43ec$export$e486c0390e42ccf6)(routes);
    }
    /** The stable route tree */ get stableRoutes() {
        return this.#routes;
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return this.#hmrRoutes ?? this.#routes;
    }
    /** Pre-computed branches */ get branches() {
        return this.#hmrBranches ?? this.#branches;
    }
    get hasHMRRoutes() {
        return this.#hmrRoutes != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        this.#routes = routes;
        this.#branches = (0, $edf931d6dcac43ec$export$e486c0390e42ccf6)(routes);
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        this.#hmrRoutes = routes;
        this.#hmrBranches = (0, $edf931d6dcac43ec$export$e486c0390e42ccf6)(routes);
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if (this.#hmrRoutes) {
            this.#routes = this.#hmrRoutes;
            this.#branches = this.#hmrBranches;
            this.#hmrRoutes = void 0;
            this.#hmrBranches = void 0;
        }
    }
};
/**
* Create a router and listen to history POP navigations
*/ function $27ddc9c887d48115$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $bb1de4858130979b$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $27ddc9c887d48115$var$DataRoutes((0, $edf931d6dcac43ec$export$87cb1a9238dc3fba)(init.routes, mapRouteProperties, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $27ddc9c887d48115$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions = null;
    let getScrollRestorationKey = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = (0, $edf931d6dcac43ec$export$5c7b09132f833c25)(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $27ddc9c887d48115$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            if (checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname).active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$27ddc9c887d48115$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $27ddc9c887d48115$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $27ddc9c887d48115$export$ed3e14b2f9e105d0,
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP";
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            (0, $2ce80a7c58bedbaf$export$491112666e282270)(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $27ddc9c887d48115$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            $27ddc9c887d48115$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$27ddc9c887d48115$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP", state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $27ddc9c887d48115$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $27ddc9c887d48115$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0 && !isUninterruptedRevalidation) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $27ddc9c887d48115$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $27ddc9c887d48115$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP") ;
        else if (pendingAction === "PUSH") init.history.push(location, location.state);
        else if (pendingAction === "REPLACE") init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP") {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $27ddc9c887d48115$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP";
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $27ddc9c887d48115$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let instrumentationNavigateMetaReceiver = (0, $bb1de4858130979b$export$5579798e35f5560e)(router);
        let { path: path, submission: submission, error: error } = $27ddc9c887d48115$var$normalizeNavigateOptions(false, $27ddc9c887d48115$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative), opts);
        let maskPath;
        if (opts?.mask) maskPath = {
            pathname: "",
            search: "",
            hash: "",
            ...typeof opts.mask === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            }
        };
        let currentLocation = state.location;
        let nextLocation = (0, $2ce80a7c58bedbaf$export$90c043f1c57770b8)(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH";
        if (userReplace === true) historyAction = "REPLACE";
        else if (userReplace === false) ;
        else if (submission != null && $27ddc9c887d48115$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE";
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $27ddc9c887d48115$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate,
            instrumentationNavigateMetaReceiver: instrumentationNavigateMetaReceiver
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $27ddc9c887d48115$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? state.matches : (0, $edf931d6dcac43ec$export$5c7b09132f833c25)(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $27ddc9c887d48115$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $27ddc9c887d48115$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (opts?.instrumentationNavigateMetaReceiver) {
            let meta = $27ddc9c887d48115$var$getInstrumentationNavigateMeta(init.history, location, matches);
            opts.instrumentationNavigateMetaReceiver(meta);
        }
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $27ddc9c887d48115$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04)();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $27ddc9c887d48115$var$findNearestBoundary(matches).route.id,
            {
                type: "error",
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $27ddc9c887d48115$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($27ddc9c887d48115$var$isErrorResult(result) && (0, $edf931d6dcac43ec$export$972111febbeef05b)(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $27ddc9c887d48115$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $27ddc9c887d48115$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$27ddc9c887d48115$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        updateState({
            navigation: $27ddc9c887d48115$var$getSubmittingNavigation(location, matches, historyAction, submission)
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error",
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $27ddc9c887d48115$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error",
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error",
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $27ddc9c887d48115$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error",
            error: $27ddc9c887d48115$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy(request, location, $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties, scopedContext), scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($27ddc9c887d48115$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else replace = $27ddc9c887d48115$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history) === state.location.pathname + state.location.search;
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($27ddc9c887d48115$var$isErrorResult(result)) {
            let boundaryMatch = $27ddc9c887d48115$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH";
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $27ddc9c887d48115$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $27ddc9c887d48115$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $27ddc9c887d48115$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $27ddc9c887d48115$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers = new Map(state.fetchers);
            let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                errors: pendingActionResult && $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$27ddc9c887d48115$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects ? {
                    fetchers: workingFetchers
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect = $27ddc9c887d48115$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $27ddc9c887d48115$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $27ddc9c887d48115$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$27ddc9c887d48115$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $27ddc9c887d48115$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let instrumentationResultMetaReceiver = (0, $bb1de4858130979b$export$5579798e35f5560e)(router);
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $27ddc9c887d48115$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = (0, $edf931d6dcac43ec$export$5c7b09132f833c25)(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (instrumentationResultMetaReceiver) instrumentationResultMetaReceiver($27ddc9c887d48115$var$getInstrumentationNavigateMeta(init.history, normalizedPath, matches));
        if (!matches) {
            setFetcherError(key, routeId, $27ddc9c887d48115$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $27ddc9c887d48115$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04)();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $27ddc9c887d48115$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        updateFetcherState(key, $27ddc9c887d48115$var$getSubmittingFetcher(submission, state.fetchers.get(key)), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $27ddc9c887d48115$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $27ddc9c887d48115$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $27ddc9c887d48115$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            setFetcherError(key, routeId, $27ddc9c887d48115$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            }), {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match of fetchMatches)if (actionResults[match.route.id]) {
                actionResult = actionResults[match.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($27ddc9c887d48115$var$isRedirectResult(actionResult) || $27ddc9c887d48115$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($27ddc9c887d48115$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $27ddc9c887d48115$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($27ddc9c887d48115$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $27ddc9c887d48115$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? (0, $edf931d6dcac43ec$export$5c7b09132f833c25)(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $27ddc9c887d48115$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $27ddc9c887d48115$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = workingFetchers.get(staleKey);
            let revalidatingFetcher = $27ddc9c887d48115$var$getLoadingFetcher(void 0, existingFetcher ? existingFetcher.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers = new Map(s.fetchers);
            workingFetchers.set(key, $27ddc9c887d48115$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers
            };
        };
        let redirect = $27ddc9c887d48115$var$findRedirect(loaderResults);
        if (redirect) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect = $27ddc9c887d48115$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $27ddc9c887d48115$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $27ddc9c887d48115$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $27ddc9c887d48115$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $27ddc9c887d48115$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $27ddc9c887d48115$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $27ddc9c887d48115$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $27ddc9c887d48115$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy(fetchRequest, path, $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, matches, match, hydrationRouteProperties, scopedContext), scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match of matches)if (results[match.route.id]) {
                result = results[match.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(void 0));
            return;
        }
        if ($27ddc9c887d48115$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($27ddc9c887d48115$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(result.data));
    }
    /**
	* Utility function to handle redirects returned from an action or loader.
	* Normally, a redirect "replaces" the navigation that triggered it.  So, for
	* example:
	*
	*  - user is on /a
	*  - user clicks a link to /b
	*  - loader for /b redirects to /c
	*
	* In a non-JS app the browser would track the in-flight navigation to /b and
	* then replace it with /c when it encountered the redirect response.  In
	* the end it would only ever update the URL bar with /c.
	*
	* In client-side routing using pushState/replaceState, we aim to emulate
	* this behavior and we also do not update history until the end of the
	* navigation (including processed redirects).  This means that we never
	* actually touch history until we've processed redirects, so we just use
	* the history action from the original navigation (PUSH or REPLACE).
	*/ async function startRedirectNavigation(request, redirect, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(location, "Expected a Location header on the redirect Response");
        location = $27ddc9c887d48115$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = (0, $2ce80a7c58bedbaf$export$90c043f1c57770b8)(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ((0, $edf931d6dcac43ec$export$a1cbf2de32a9fd1)(location)) {
                const url = (0, $2ce80a7c58bedbaf$export$e2450fce17852bf2)(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace === true || redirect.response.headers.has("X-Remix-Replace") ? "REPLACE" : "PUSH";
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $27ddc9c887d48115$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($27ddc9c887d48115$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $27ddc9c887d48115$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else await startNavigation(redirectNavigationType, redirectLocation, {
            overrideNavigation: $27ddc9c887d48115$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission),
            fetcherSubmission: fetcherSubmission,
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $27ddc9c887d48115$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error",
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$27ddc9c887d48115$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error") break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error",
                result: /* @__PURE__ */ new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($27ddc9c887d48115$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect",
                response: $27ddc9c887d48115$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $27ddc9c887d48115$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let result = (await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key))[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error",
                    error: $27ddc9c887d48115$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        return {
            loaderResults: await loaderResultsPromise,
            fetcherResults: (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {})
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $27ddc9c887d48115$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $27ddc9c887d48115$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $27ddc9c887d48115$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $27ddc9c887d48115$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $27ddc9c887d48115$export$386d57f03f0b2883;
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $27ddc9c887d48115$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        if (!initialScrollRestored && state.navigation === $27ddc9c887d48115$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) return getScrollRestorationKey(location, matches.map((m)=>(0, $edf931d6dcac43ec$export$fcf533780bf49ee2)(m, state.loaderData))) || location.key;
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) return {
                active: true,
                matches: (0, $edf931d6dcac43ec$export$5c7b09132f833c25)(routesToUse, pathname, basename, true, activeBranches) || []
            };
            else if (Object.keys(matches[0].params).length > 0) return {
                active: true,
                matches: (0, $edf931d6dcac43ec$export$5c7b09132f833c25)(routesToUse, pathname, basename, true, activeBranches)
            };
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $27ddc9c887d48115$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = (0, $edf931d6dcac43ec$export$5c7b09132f833c25)(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = (0, $edf931d6dcac43ec$export$5c7b09132f833c25)(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    if (!(newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length)))) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = (0, $edf931d6dcac43ec$export$5c7b09132f833c25)(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes((0, $edf931d6dcac43ec$export$87cb1a9238dc3fba)(newRoutes, mapRouteProperties, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $27ddc9c887d48115$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = (0, $bb1de4858130979b$export$ac4df491f31cbbfc)(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
/**
* Create a static handler to perform server-side data loading
*
* @example
* export async function handleRequest(request: Request) {
*   let { query, dataRoutes } = createStaticHandler(routes);
*   let context = await query(request);
*
*   if (context instanceof Response) {
*     return context;
*   }
*
*   let router = createStaticRouter(dataRoutes, context);
*   return new Response(
*     ReactDOMServer.renderToString(<StaticRouterProvider ... />),
*     { headers: { "Content-Type": "text/html" } }
*   );
* }
*
* @public
* @category Data Routers
* @mode data
* @param routes The {@link RouteObject | route objects} to create a static
* handler for
* @param opts Options
* @param opts.basename The base URL for the static handler (default: `/`)
* @param opts.future Future flags for the static handler
* @returns A static handler that can be used to query data for the provided
* routes
*/ function $27ddc9c887d48115$export$3336b097a6fbc59a(routes, opts) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    ({
        ...opts?.future
    });
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $bb1de4858130979b$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = (0, $edf931d6dcac43ec$export$87cb1a9238dc3fba)(routes, mapRouteProperties, void 0, manifest);
    let routeBranches = (0, $edf931d6dcac43ec$export$e486c0390e42ccf6)(dataRoutes);
    /**
	* The query() method is intended for document requests, in which we want to
	* call an optional action and potentially multiple loaders for all nested
	* routes.  It returns a StaticHandlerContext object, which is very similar
	* to the router state (location, loaderData, actionData, errors, etc.) and
	* also adds SSR-specific information such as the statusCode and headers
	* from action/loaders Responses.
	*
	* It _should_ never throw and should report all errors through the
	* returned handlerContext.errors object, properly associating errors to
	* their error boundary.  Additionally, it tracks _deepestRenderedBoundaryId
	* which can be used to emulate React error boundaries during SSR by performing
	* a second pass only down to the boundaryId.
	*
	* The one exception where we do not return a StaticHandlerContext is when a
	* redirect response is returned or thrown from any action/loader.  We
	* propagate that out and return the raw Response so the HTTP server can
	* return it directly.
	*
	* - `opts.requestContext` is an optional server context that will be passed
	*   to actions/loaders in the `context` parameter
	* - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
	*   the bubbling of errors which allows single-fetch-type implementations
	*   where the client will handle the bubbling and we may need to return data
	*   for the handling route
	*/ async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $27ddc9c887d48115$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $2ce80a7c58bedbaf$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = (0, $edf931d6dcac43ec$export$5c7b09132f833c25)(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04)();
        if (!$27ddc9c887d48115$var$isValidMethod(method) && method !== "HEAD") {
            let error = $27ddc9c887d48115$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $27ddc9c887d48115$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(requestContext instanceof (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $27ddc9c887d48115$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
                let renderedStaticContext;
                let response = await $27ddc9c887d48115$var$runServerMiddlewarePipeline({
                    request: request,
                    url: (0, $edf931d6dcac43ec$export$141d98e45b4b08e4)(request, location),
                    pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(matches),
                    matches: matches,
                    params: matches[0].params,
                    context: requestContext
                }, async ()=>{
                    return await generateMiddlewareResponse(async (revalidationRequest, opts = {})=>{
                        let result = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts ? opts.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(result)) return result;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result
                        };
                        return renderedStaticContext;
                    });
                }, async (error, routeId)=>{
                    if ($27ddc9c887d48115$export$6e80290866a84dd4(error)) return error;
                    if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(error)) try {
                        error = new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(error.status, error.statusText, await $27ddc9c887d48115$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($27ddc9c887d48115$export$e0163cfdf7bc9cfa(error)) error = $27ddc9c887d48115$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $27ddc9c887d48115$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $27ddc9c887d48115$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [skipLoaderErrorBubbling ? routeId : $27ddc9c887d48115$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id]: error
                            },
                            statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($27ddc9c887d48115$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    /**
	* The queryRoute() method is intended for targeted route requests, either
	* for fetch ?_data requests or resource route requests.  In this case, we
	* are only ever calling a single action or loader, and we are returning the
	* returned value directly.  In most cases, this will be a Response returned
	* from the action/loader, but it may be a primitive or other value as well -
	* and in such cases the calling context should handle that accordingly.
	*
	* We do respect the throw/return differentiation, so if an action/loader
	* throws, then this method will throw the value.  This is important so we
	* can do proper boundary identification in Remix where a thrown Response
	* must go to the Catch Boundary but a returned Response is happy-path.
	*
	* One thing to note is that any Router-initiated Errors that make sense
	* to associate with a status code will be thrown as an ErrorResponse
	* instance which include the raw Error, such that the calling context can
	* serialize the error as they see fit while including the proper response
	* code.  Examples here are 404 and 405 errors that occur prior to reaching
	* any user-defined loaders.
	*
	* - `opts.routeId` allows you to specify the specific route handler to call.
	*   If not provided the handler will determine the proper route by matching
	*   against `request.url`
	* - `opts.requestContext` is an optional server context that will be passed
	*    to actions/loaders in the `context` parameter
	*/ async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $27ddc9c887d48115$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $2ce80a7c58bedbaf$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = (0, $edf931d6dcac43ec$export$5c7b09132f833c25)(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04)();
        if (!$27ddc9c887d48115$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $27ddc9c887d48115$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $27ddc9c887d48115$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $27ddc9c887d48115$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $27ddc9c887d48115$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $27ddc9c887d48115$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(requestContext instanceof (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $27ddc9c887d48115$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
            return await $27ddc9c887d48115$var$runServerMiddlewarePipeline({
                request: request,
                url: (0, $edf931d6dcac43ec$export$141d98e45b4b08e4)(request, location),
                pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(matches),
                matches: matches,
                params: matches[0].params,
                context: requestContext
            }, async ()=>{
                return await generateMiddlewareResponse(async (innerRequest)=>{
                    let processed = handleQueryResult(await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false));
                    return $27ddc9c887d48115$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
            }, (error)=>{
                if ($27ddc9c887d48115$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($27ddc9c887d48115$var$dataWithResponseInitToResponse(error));
                if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
        }
        return handleQueryResult(await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false));
        function handleQueryResult(result) {
            if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(result)) return result;
            let error = result.errors ? Object.values(result.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result.actionData) return Object.values(result.actionData)[0];
            if (result.loaderData) return Object.values(result.loaderData)[0];
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($27ddc9c887d48115$export$cbae47800eb95bc3(request.method)) return await submit(request, location, matches, routeMatch || $27ddc9c887d48115$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $27ddc9c887d48115$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($27ddc9c887d48115$var$isDataStrategyResult(e) && $27ddc9c887d48115$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error") throw e.result;
                return e.result;
            }
            if ($27ddc9c887d48115$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $27ddc9c887d48115$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error",
                error: error
            };
        } else {
            result = (await callDataStrategy(request, location, $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, [], requestContext), isRouteRequest, requestContext, dataStrategy))[actionMatch.route.id];
            if (request.signal.aborted) $27ddc9c887d48115$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($27ddc9c887d48115$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($27ddc9c887d48115$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($27ddc9c887d48115$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $27ddc9c887d48115$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($27ddc9c887d48115$var$isErrorResult(result)) return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                (skipLoaderErrorBubbling ? actionMatch : $27ddc9c887d48115$var$findNearestBoundary(matches, actionMatch.route.id)).route.id,
                result
            ]),
            statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
            actionData: null,
            actionHeaders: {
                ...result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {}
            }
        };
        return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad),
            actionData: {
                [actionMatch.route.id]: result.data
            },
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $27ddc9c887d48115$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = (0, $edf931d6dcac43ec$export$d738435097971c09)(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, false);
                return $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $27ddc9c887d48115$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        return {
            ...$27ddc9c887d48115$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling),
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $27ddc9c887d48115$var$callDataStrategyImpl(dataStrategy || $27ddc9c887d48115$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($27ddc9c887d48115$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $27ddc9c887d48115$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($27ddc9c887d48115$export$e0163cfdf7bc9cfa(result.result)) throw $27ddc9c887d48115$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $27ddc9c887d48115$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
/**
* Given an existing StaticHandlerContext and an error thrown at render time,
* provide an updated StaticHandlerContext suitable for a second SSR render
*
* @category Utils
*/ function $27ddc9c887d48115$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $27ddc9c887d48115$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    throw new Error(`${isRouteRequest ? "queryRoute" : "query"}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $27ddc9c887d48115$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $27ddc9c887d48115$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $27ddc9c887d48115$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = (0, $edf931d6dcac43ec$export$cae722b0cc860f13)(to ? to : ".", (0, $edf931d6dcac43ec$export$fe6dbc5de95f53ab)(contextualMatches), (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $27ddc9c887d48115$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = (0, $edf931d6dcac43ec$export$e9a5bfadbc179142)({
        basename: basename,
        pathname: path.pathname
    });
    return (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(path);
}
function $27ddc9c887d48115$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$27ddc9c887d48115$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$27ddc9c887d48115$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $27ddc9c887d48115$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $27ddc9c887d48115$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let formMethod = (opts.formMethod || "get").toUpperCase();
    let formAction = $27ddc9c887d48115$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$27ddc9c887d48115$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}\n`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$27ddc9c887d48115$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $27ddc9c887d48115$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $27ddc9c887d48115$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $27ddc9c887d48115$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $27ddc9c887d48115$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($27ddc9c887d48115$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(path);
    if (isFetcher && parsedPath.search && $27ddc9c887d48115$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(parsedPath),
        submission: submission
    };
}
function $27ddc9c887d48115$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = (0, $edf931d6dcac43ec$export$d738435097971c09)(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$27ddc9c887d48115$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad } = $27ddc9c887d48115$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad;
        } else if ($27ddc9c887d48115$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($27ddc9c887d48115$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        return $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, $27ddc9c887d48115$var$shouldRevalidateLoader(match, shouldRevalidateArgs), shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = (0, $edf931d6dcac43ec$export$5c7b09132f833c25)(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $27ddc9c887d48115$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $27ddc9c887d48115$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($27ddc9c887d48115$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $27ddc9c887d48115$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $27ddc9c887d48115$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$27ddc9c887d48115$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $27ddc9c887d48115$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $27ddc9c887d48115$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $27ddc9c887d48115$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $27ddc9c887d48115$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute)=>$27ddc9c887d48115$var$isSameRoute(newRoute, existingRoute));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = (0, $edf931d6dcac43ec$export$87cb1a9238dc3fba)(uniqueChildren, mapRouteProperties, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = (0, $edf931d6dcac43ec$export$87cb1a9238dc3fba)([
            newRoute
        ], mapRouteProperties, [], {}, true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $27ddc9c887d48115$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$27ddc9c887d48115$var$isSameRoute(aChild, bChild))) ?? false;
}
const $27ddc9c887d48115$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
const $27ddc9c887d48115$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties })=>{
    let routeToUpdate = manifest[route.id];
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $27ddc9c887d48115$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $27ddc9c887d48115$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = (0, $edf931d6dcac43ec$export$3e22299e33adeed1)(key);
        let isStaticallyDefined = routeToUpdate[key] !== void 0;
        if (isUnsupported) {
            (0, $2ce80a7c58bedbaf$export$491112666e282270)(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
const $27ddc9c887d48115$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
/**
* Execute route.lazy functions to lazily load route modules (loader, action,
* shouldRevalidate) and update the routeManifest in place which shares objects
* with dataRoutes so those get updated as well.
*/ function $27ddc9c887d48115$var$loadLazyRoute(route, type, manifest, mapRouteProperties, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $27ddc9c887d48115$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise = (async ()=>{
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = (0, $edf931d6dcac43ec$export$a89d811eaa209e85)(lazyRouteProperty);
                let isStaticallyDefined = routeToUpdate[lazyRouteProperty] !== void 0;
                if (isUnsupported) (0, $2ce80a7c58bedbaf$export$491112666e282270)(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) (0, $2ce80a7c58bedbaf$export$491112666e282270)(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                ...mapRouteProperties(routeToUpdate),
                lazy: void 0
            });
        })();
        $27ddc9c887d48115$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise);
        lazyRoutePromise.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise,
            lazyHandlerPromise: lazyRoutePromise
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $27ddc9c887d48115$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $27ddc9c887d48115$var$isNonNullable(value) {
    return value !== void 0;
}
function $27ddc9c887d48115$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return;
        return $27ddc9c887d48115$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
    }).filter($27ddc9c887d48115$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $27ddc9c887d48115$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    (await Promise.all(matchesToLoad.map((m)=>m.resolve()))).forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $27ddc9c887d48115$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $27ddc9c887d48115$var$defaultDataStrategy(args);
    return $27ddc9c887d48115$var$runClientMiddlewarePipeline(args, ()=>$27ddc9c887d48115$var$defaultDataStrategy(args));
}
function $27ddc9c887d48115$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $27ddc9c887d48115$var$runMiddlewarePipeline(args, handler, processResult, $27ddc9c887d48115$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $27ddc9c887d48115$export$e0163cfdf7bc9cfa(result) ? $27ddc9c887d48115$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $27ddc9c887d48115$var$runClientMiddlewarePipeline(args, handler) {
    return $27ddc9c887d48115$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($27ddc9c887d48115$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $27ddc9c887d48115$var$isDataStrategyResults, errorHandler);
    async function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        });
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let deepestRouteId = matches[maxBoundaryIdx].route.id;
            for (let match of matches.slice(0, maxBoundaryIdx + 1))try {
                await match._lazyPromises?.route;
            } catch  {
                deepestRouteId = match.route.id;
                break;
            }
            return {
                [$27ddc9c887d48115$var$findNearestBoundary(matches, deepestRouteId).route.id]: {
                    type: "error",
                    result: error
                }
            };
        }
    }
}
async function $27ddc9c887d48115$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    return await $27ddc9c887d48115$var$callRouteMiddleware(dataFnArgs, matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []), handler, processResult, isResult, errorHandler);
}
async function $27ddc9c887d48115$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? /* @__PURE__ */ new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) return await handler();
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            nextResult = {
                value: await $27ddc9c887d48115$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1)
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        return await errorHandler(error, routeId, nextResult);
    }
}
function $27ddc9c887d48115$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $27ddc9c887d48115$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties
    });
    let lazyRoutePromises = $27ddc9c887d48115$var$loadLazyRoute(match.route, $27ddc9c887d48115$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $27ddc9c887d48115$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $27ddc9c887d48115$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $27ddc9c887d48115$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $27ddc9c887d48115$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$27ddc9c887d48115$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($27ddc9c887d48115$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $27ddc9c887d48115$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data",
                result: void 0
            });
        }
    };
}
function $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $27ddc9c887d48115$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, (0, $edf931d6dcac43ec$export$d738435097971c09)(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $27ddc9c887d48115$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: (0, $edf931d6dcac43ec$export$141d98e45b4b08e4)(request, path),
        pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $27ddc9c887d48115$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $27ddc9c887d48115$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $27ddc9c887d48115$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(/* @__PURE__ */ new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: (0, $edf931d6dcac43ec$export$141d98e45b4b08e4)(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                return {
                    type: "data",
                    result: await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler())
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler = isAction ? match.route.action : match.route.loader;
                if (handler) [result] = await Promise.all([
                    runHandler(handler),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $27ddc9c887d48115$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data",
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            throw $27ddc9c887d48115$var$getInternalRouterError(404, {
                pathname: url.pathname + url.search
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error",
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $27ddc9c887d48115$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $27ddc9c887d48115$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(result)) {
        let data;
        try {
            data = await $27ddc9c887d48115$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error",
                error: e
            };
        }
        if (type === "error") return {
            type: "error",
            error: new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data",
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error") {
        if ($27ddc9c887d48115$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error",
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error",
                error: $27ddc9c887d48115$var$dataWithResponseInitToErrorResponse(result),
                statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error",
            error: result,
            statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(result) ? result.status : void 0
        };
    }
    if ($27ddc9c887d48115$export$e0163cfdf7bc9cfa(result)) return {
        type: "data",
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data",
        data: result
    };
}
function $27ddc9c887d48115$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!(0, $edf931d6dcac43ec$export$a1cbf2de32a9fd1)(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $27ddc9c887d48115$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
const $27ddc9c887d48115$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    "javascript:"
];
function $27ddc9c887d48115$export$961a3ef7a4da3a39(location) {
    try {
        return $27ddc9c887d48115$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $27ddc9c887d48115$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ((0, $edf931d6dcac43ec$export$a1cbf2de32a9fd1)(location)) {
        let normalizedLocation = location;
        let url = (0, $ee8fa670c1d03165$export$825a82322d91916e).test(normalizedLocation) ? new URL((0, $ee8fa670c1d03165$export$977999b735cd4f26)(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($27ddc9c887d48115$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return (0, $edf931d6dcac43ec$export$f857a07c5bd323b8)(url.pathname) + url.search + url.hash;
    }
    try {
        if ($27ddc9c887d48115$export$961a3ef7a4da3a39(historyInstance.createURL(location).toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $27ddc9c887d48115$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($27ddc9c887d48115$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $27ddc9c887d48115$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $27ddc9c887d48115$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $27ddc9c887d48115$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $27ddc9c887d48115$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $27ddc9c887d48115$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!$27ddc9c887d48115$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($27ddc9c887d48115$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $27ddc9c887d48115$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $27ddc9c887d48115$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = (0, $edf931d6dcac43ec$export$972111febbeef05b)(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $27ddc9c887d48115$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $27ddc9c887d48115$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(result, "Did not find corresponding fetcher result");
        if ($27ddc9c887d48115$var$isErrorResult(result)) {
            let boundaryMatch = $27ddc9c887d48115$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($27ddc9c887d48115$var$isRedirectResult(result)) (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $27ddc9c887d48115$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $27ddc9c887d48115$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $27ddc9c887d48115$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $27ddc9c887d48115$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? {
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $27ddc9c887d48115$var$findNearestBoundary(matches, routeId) {
    return (routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ]).reverse().find((m)=>m.route.ErrorBoundary != null || m.route.errorElement != null) || matches[0];
}
function $27ddc9c887d48115$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $27ddc9c887d48115$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(status || 500, statusText, new Error(errorMessage), true);
}
function $27ddc9c887d48115$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($27ddc9c887d48115$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $27ddc9c887d48115$var$stripHashFromPath(path) {
    return (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)({
        ...typeof path === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(path) : path,
        hash: ""
    });
}
function $27ddc9c887d48115$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $27ddc9c887d48115$var$dataWithResponseInitToResponse(data) {
    return Response.json(data.data, data.init ?? void 0);
}
function $27ddc9c887d48115$var$dataWithResponseInitToErrorResponse(data) {
    return new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(data.init?.status ?? 500, data.init?.statusText ?? "Internal Server Error", data.data);
}
function $27ddc9c887d48115$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $27ddc9c887d48115$var$isDataStrategyResult(value));
}
function $27ddc9c887d48115$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" || result.type === "error");
}
function $27ddc9c887d48115$var$isRedirectDataStrategyResult(result) {
    return $27ddc9c887d48115$export$3f1eb41d9a6a6a27(result.result) && $27ddc9c887d48115$var$redirectStatusCodes.has(result.result.status);
}
function $27ddc9c887d48115$var$isErrorResult(result) {
    return result.type === "error";
}
function $27ddc9c887d48115$var$isRedirectResult(result) {
    return (result && result.type) === "redirect";
}
function $27ddc9c887d48115$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $27ddc9c887d48115$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $27ddc9c887d48115$export$794b2760043cf8cd(statusCode) {
    return $27ddc9c887d48115$var$redirectStatusCodes.has(statusCode);
}
function $27ddc9c887d48115$export$6e80290866a84dd4(result) {
    return $27ddc9c887d48115$export$3f1eb41d9a6a6a27(result) && $27ddc9c887d48115$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $27ddc9c887d48115$var$isValidMethod(method) {
    return $27ddc9c887d48115$var$validRequestMethods.has(method.toUpperCase());
}
function $27ddc9c887d48115$export$cbae47800eb95bc3(method) {
    return $27ddc9c887d48115$var$validMutationMethods.has(method.toUpperCase());
}
function $27ddc9c887d48115$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $27ddc9c887d48115$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(location).search : location.search;
    if (matches[matches.length - 1].route.index && $27ddc9c887d48115$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = (0, $edf931d6dcac43ec$export$b234c29a3bb68fc8)(matches);
    return pathMatches[pathMatches.length - 1];
}
function $27ddc9c887d48115$var$getInstrumentationNavigateMeta(history, location, matches) {
    return {
        url: (0, $edf931d6dcac43ec$export$141d98e45b4b08e4)(history.createURL(location), location),
        pattern: matches ? (0, $edf931d6dcac43ec$export$d738435097971c09)(matches) : "",
        params: matches?.[0]?.params ? {
            ...matches[0].params
        } : {}
    };
}
function $27ddc9c887d48115$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $27ddc9c887d48115$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    else return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0
    };
}
function $27ddc9c887d48115$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    return {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
}
function $27ddc9c887d48115$var$getLoadingFetcher(submission, data) {
    if (submission) return {
        state: "loading",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: data
    };
    else return {
        state: "loading",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $27ddc9c887d48115$var$getSubmittingFetcher(submission, existingFetcher) {
    return {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
}
function $27ddc9c887d48115$var$getDoneFetcher(data) {
    return {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $27ddc9c887d48115$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($27ddc9c887d48115$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $27ddc9c887d48115$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($27ddc9c887d48115$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $27ddc9c887d48115$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
//#region lib/context.ts
const $52882ad28a21bc0a$export$2eeee58951ff3c1c = $acw62.createContext(null);
$52882ad28a21bc0a$export$2eeee58951ff3c1c.displayName = "DataRouter";
const $52882ad28a21bc0a$export$315e3ffb01f217 = $acw62.createContext(null);
$52882ad28a21bc0a$export$315e3ffb01f217.displayName = "DataRouterState";
const $52882ad28a21bc0a$export$717f757c655223f1 = $acw62.createContext(false);
function $52882ad28a21bc0a$export$6e1eeb090b3ec35b() {
    return $acw62.useContext($52882ad28a21bc0a$export$717f757c655223f1);
}
const $52882ad28a21bc0a$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$52882ad28a21bc0a$export$3681f408decb40d1.displayName = "ViewTransition";
const $52882ad28a21bc0a$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$52882ad28a21bc0a$export$cb3f1df1bef00a39.displayName = "Fetchers";
const $52882ad28a21bc0a$export$804c460aade54ac8 = $acw62.createContext(null);
$52882ad28a21bc0a$export$804c460aade54ac8.displayName = "Await";
const $52882ad28a21bc0a$export$2666c20e15407622 = (props)=>$acw62.createElement($52882ad28a21bc0a$export$804c460aade54ac8.Provider, props);
const $52882ad28a21bc0a$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$52882ad28a21bc0a$export$3044ab7fdabeaee6.displayName = "Navigation";
const $52882ad28a21bc0a$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$52882ad28a21bc0a$export$e6a44b110a0c44d3.displayName = "Location";
const $52882ad28a21bc0a$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$52882ad28a21bc0a$export$aac280ed165a4397.displayName = "Route";
const $52882ad28a21bc0a$export$af8bd2647fea9c11 = $acw62.createContext(null);
$52882ad28a21bc0a$export$af8bd2647fea9c11.displayName = "RouteError";


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 



/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/errors.ts
const $b9584a574d863128$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
const $b9584a574d863128$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
const $b9584a574d863128$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $b9584a574d863128$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$b9584a574d863128$var$ERROR_DIGEST_BASE}:${$b9584a574d863128$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $b9584a574d863128$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$b9584a574d863128$var$ERROR_DIGEST_BASE}:${$b9584a574d863128$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}



var $acw62 = parcelRequire("acw62");
//#region lib/hooks.tsx
/**
* Resolves a URL against the current {@link Location}.
*
* @example
* import { useHref } from "react-router";
*
* function SomeComponent() {
*   let href = useHref("some/where");
*   // "/resolved/some/where"
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the
* route tree.
* Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved href string
*/ function $baf2581b6f4e4c0a$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($baf2581b6f4e4c0a$export$9c954a9d03d32f4a(), `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let { hash: hash, pathname: pathname, search: search } = $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
* Returns `true` if this component is a descendant of a {@link Router}, useful
* to ensure a component is used within a {@link Router}.
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns Whether the component is within a {@link Router} context
*/ function $baf2581b6f4e4c0a$export$9c954a9d03d32f4a() {
    return $acw62.useContext((0, $52882ad28a21bc0a$export$e6a44b110a0c44d3)) != null;
}
/**
* Returns the current {@link Location}. This can be useful if you'd like to
* perform some side effect whenever it changes.
*
* @example
* import * as React from 'react'
* import { useLocation } from 'react-router'
*
* function SomeComponent() {
*   let location = useLocation()
*
*   React.useEffect(() => {
*     // Google Analytics
*     ga('send', 'pageview')
*   }, [location]);
*
*   return (
*     // ...
*   );
* }
*
* @public
* @category Hooks
* @returns The current {@link Location} object
*/ function $baf2581b6f4e4c0a$export$45d76561a5302f2b() {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($baf2581b6f4e4c0a$export$9c954a9d03d32f4a(), `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext((0, $52882ad28a21bc0a$export$e6a44b110a0c44d3)).location;
}
/**
* Returns the current {@link Navigation} action which describes how the router
* came to the current {@link Location}, either by a pop, push, or replace on
* the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack.
*
* @public
* @category Hooks
* @returns The current {@link NavigationType} (`"POP"`, `"PUSH"`, or `"REPLACE"`)
*/ function $baf2581b6f4e4c0a$export$1b3f31771c5d07c() {
    return $acw62.useContext((0, $52882ad28a21bc0a$export$e6a44b110a0c44d3)).navigationType;
}
/**
* Returns a {@link PathMatch} object if the given pattern matches the current URL.
* This is useful for components that need to know "active" state, e.g.
* {@link NavLink | `<NavLink>`}.
*
* @public
* @category Hooks
* @param pattern The pattern to match against the current {@link Location}
* @returns The path match object if the pattern matches, `null` otherwise
*/ function $baf2581b6f4e4c0a$export$6c330e8992e8a295(pattern) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($baf2581b6f4e4c0a$export$9c954a9d03d32f4a(), `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $baf2581b6f4e4c0a$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $edf931d6dcac43ec$export$81336c211d5ff295)(pattern, (0, $edf931d6dcac43ec$export$cd27bea214d030c2)(pathname)), [
        pathname,
        pattern
    ]);
}
const $baf2581b6f4e4c0a$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
/**
* Returns a function that lets you navigate programmatically in the browser in
* response to user interactions or effects.
*
* It's often better to use {@link redirect} in [`action`](../../start/framework/route-module#action)/[`loader`](../../start/framework/route-module#loader)
* functions than this hook.
*
* The returned function signature is `navigate(to, options?)`/`navigate(delta)` where:
*
* * `to` can be a string path, a {@link To} object, or a number (delta)
* * `options` contains options for modifying the navigation
*   * These options work in all modes (Framework, Data, and Declarative):
*     * `relative`: `"route"` or `"path"` to control relative routing logic
*     * `replace`: Replace the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack
*     * `state`: Optional [`history.state`](https://developer.mozilla.org/en-US/docs/Web/API/History/state) to include with the new {@link Location}
*   * These options only work in Framework and Data modes:
*     * `flushSync`: Wrap the DOM updates in [`ReactDom.flushSync`](https://react.dev/reference/react-dom/flushSync)
*     * `preventScrollReset`: Do not scroll back to the top of the page after navigation
*     * `viewTransition`: Enable [`document.startViewTransition`](https://developer.mozilla.org/en-US/docs/Web/API/Document/startViewTransition) for this navigation
*
* @example
* import { useNavigate } from "react-router";
*
* function SomeComponent() {
*   let navigate = useNavigate();
*   return (
*     <button onClick={() => navigate(-1)}>
*       Go Back
*     </button>
*   );
* }
*
* @additionalExamples
* ### Navigate to another path
*
* ```tsx
* navigate("/some/route");
* navigate("/some/route?search=param");
* ```
*
* ### Navigate with a {@link To} object
*
* All properties are optional.
*
* ```tsx
* navigate(
*   {
*     pathname: "/some/route",
*     search: "?search=param",
*     hash: "#hash",
*   },
*   {
*     state: { some: "state" },
*   },
* );
* ```
*
* If you use `state`, that will be available on the {@link Location} object on
* the next page. Access it with `useLocation().state` (see {@link useLocation}).
*
* ### Navigate back or forward in the history stack
*
* ```tsx
* // back
* // often used to close modals
* navigate(-1);
*
* // forward
* // often used in a multistep wizard workflows
* navigate(1);
* ```
*
* Be cautious with `navigate(number)`. If your application can load up to a
* route that has a button that tries to navigate forward/back, there may not be
* a [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry to go back or forward to, or it can go somewhere you don't expect
* (like a different domain).
*
* Only use this if you're sure they will have an entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack to navigate to.
*
* ### Replace the current entry in the history stack
*
* This will remove the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, replacing it with a new one, similar to a server side redirect.
*
* ```tsx
* navigate("/some/route", { replace: true });
* ```
*
* ### Prevent Scroll Reset
*
* [MODES: framework, data]
*
* <br/>
* <br/>
*
* To prevent {@link ScrollRestoration | `<ScrollRestoration>`} from resetting
* the scroll position, use the `preventScrollReset` option.
*
* ```tsx
* navigate("?some-tab=1", { preventScrollReset: true });
* ```
*
* For example, if you have a tab interface connected to search params in the
* middle of a page, and you don't want it to scroll to the top when a tab is
* clicked.
*
* ### Return Type Augmentation
*
* Internally, `useNavigate` uses a separate implementation when you are in
* Declarative mode versus Data/Framework mode - the primary difference being
* that the latter is able to return a stable reference that does not change
* identity across navigations. The implementation in Data/Framework mode also
* returns a [`Promise`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise)
* that resolves when the navigation is completed. This means the return type of
* `useNavigate` is `void | Promise<void>`. This is accurate, but can lead to
* some red squigglies based on the union in the return value:
*
* - If you're using `typescript-eslint`, you may see errors from
*   [`@typescript-eslint/no-floating-promises`](https://typescript-eslint.io/rules/no-floating-promises)
* - In Framework/Data mode, `React.use(navigate())` will show a false-positive
*   `Argument of type 'void | Promise<void>' is not assignable to parameter of
*   type 'Usable<void>'` error
*
* The easiest way to work around these issues is to augment the type based on the
* router you're using:
*
* ```ts
* // If using <BrowserRouter>
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): void;
*     (delta: number): void;
*   }
* }
*
* // If using <RouterProvider> or Framework mode
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): Promise<void>;
*     (delta: number): Promise<void>;
*   }
* }
* ```
*
* @public
* @category Hooks
* @returns A navigate function for programmatic navigation
*/ function $baf2581b6f4e4c0a$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    return isDataRoute ? $baf2581b6f4e4c0a$var$useNavigateStable() : $baf2581b6f4e4c0a$var$useNavigateUnstable();
}
function $baf2581b6f4e4c0a$var$useNavigateUnstable() {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($baf2581b6f4e4c0a$export$9c954a9d03d32f4a(), `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    let { basename: basename, navigator: navigator } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let { matches: matches } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    let { pathname: locationPathname } = $baf2581b6f4e4c0a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $edf931d6dcac43ec$export$fe6dbc5de95f53ab)(matches));
    let activeRef = $acw62.useRef(false);
    $acw62.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $acw62.useCallback((to, options = {})=>{
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(activeRef.current, $baf2581b6f4e4c0a$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $edf931d6dcac43ec$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
}
const $baf2581b6f4e4c0a$var$OutletContext = $acw62.createContext(null);
/**
* Returns the parent route {@link Outlet | `<Outlet context>`}.
*
* Often parent routes manage state or other values you want shared with child
* routes. You can create your own [context provider](https://react.dev/learn/passing-data-deeply-with-context)
* if you like, but this is such a common situation that it's built-into
* {@link Outlet | `<Outlet>`}.
*
* ```tsx
* // Parent route
* function Parent() {
*   const [count, setCount] = React.useState(0);
*   return <Outlet context={[count, setCount]} />;
* }
* ```
*
* ```tsx
* // Child route
* import { useOutletContext } from "react-router";
*
* function Child() {
*   const [count, setCount] = useOutletContext();
*   const increment = () => setCount((c) => c + 1);
*   return <button onClick={increment}>{count}</button>;
* }
* ```
*
* If you're using TypeScript, we recommend the parent component provide a
* custom hook for accessing the context value. This makes it easier for
* consumers to get nice typings, control consumers, and know who's consuming
* the context value.
*
* Here's a more realistic example:
*
* ```tsx filename=src/routes/dashboard.tsx lines=[14,20]
* import { useState } from "react";
* import { Outlet, useOutletContext } from "react-router";
*
* import type { User } from "./types";
*
* type ContextType = { user: User | null };
*
* export default function Dashboard() {
*   const [user, setUser] = useState<User | null>(null);
*
*   return (
*     <div>
*       <h1>Dashboard</h1>
*       <Outlet context={{ user } satisfies ContextType} />
*     </div>
*   );
* }
*
* export function useUser() {
*   return useOutletContext<ContextType>();
* }
* ```
*
* ```tsx filename=src/routes/dashboard/messages.tsx lines=[1,4]
* import { useUser } from "../dashboard";
*
* export default function DashboardMessages() {
*   const { user } = useUser();
*   return (
*     <div>
*       <h2>Messages</h2>
*       <p>Hello, {user.name}!</p>
*     </div>
*   );
* }
* ```
*
* @public
* @category Hooks
* @returns The context value passed to the parent {@link Outlet} component
*/ function $baf2581b6f4e4c0a$export$4138103a3ae699cc() {
    return $acw62.useContext($baf2581b6f4e4c0a$var$OutletContext);
}
/**
* Returns the element for the child route at this level of the route
* hierarchy. Used internally by {@link Outlet | `<Outlet>`} to render child
* routes.
*
* @public
* @category Hooks
* @param context The context to pass to the outlet
* @returns The child route element or `null` if no child routes match
*/ function $baf2581b6f4e4c0a$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397)).outlet;
    return $acw62.useMemo(()=>outlet && /* @__PURE__ */ $acw62.createElement($baf2581b6f4e4c0a$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
/**
* Returns an object of key/value-pairs of the dynamic params from the current
* URL that were matched by the routes. Child routes inherit all params from
* their parent routes.
*
* Assuming a route pattern like `/posts/:postId` is matched by `/posts/123`
* then `params.postId` will be `"123"`.
*
* @example
* import { useParams } from "react-router";
*
* function SomeComponent() {
*   let params = useParams();
*   params.postId;
* }
*
* @additionalExamples
* ### Basic Usage
*
* ```tsx
* import { useParams } from "react-router";
*
* // given a route like:
* <Route path="/posts/:postId" element={<Post />} />;
*
* // or a data route like:
* createBrowserRouter([
*   {
*     path: "/posts/:postId",
*     component: Post,
*   },
* ]);
*
* // or in routes.ts
* route("/posts/:postId", "routes/post.tsx");
* ```
*
* Access the params in a component:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return <h1>Post: {params.postId}</h1>;
* }
* ```
*
* ### Multiple Params
*
* Patterns can have multiple params:
*
* ```tsx
* "/posts/:postId/comments/:commentId";
* ```
*
* All will be available in the params object:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return (
*     <h1>
*       Post: {params.postId}, Comment: {params.commentId}
*     </h1>
*   );
* }
* ```
*
* ### Catchall Params
*
* Catchall params are defined with `*`:
*
* ```tsx
* "/files/*";
* ```
*
* The matched value will be available in the params object as follows:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function File() {
*   let params = useParams();
*   let catchall = params["*"];
*   // ...
* }
* ```
*
* You can destructure the catchall param:
*
* ```tsx
* export default function File() {
*   let { "*": catchall } = useParams();
*   console.log(catchall);
* }
* ```
*
* @public
* @category Hooks
* @returns An object containing the dynamic route parameters
*/ function $baf2581b6f4e4c0a$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    return matches[matches.length - 1]?.params ?? {};
}
/**
* Resolves the pathname of the given `to` value against the current
* {@link Location}. Similar to {@link useHref}, but returns a
* {@link Path} instead of a string.
*
* @example
* import { useResolvedPath } from "react-router";
*
* function SomeComponent() {
*   // if the user is at /dashboard/profile
*   let path = useResolvedPath("../accounts");
*   path.pathname; // "/dashboard/accounts"
*   path.search; // ""
*   path.hash; // ""
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the route tree.
*                         Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved {@link Path} object with `pathname`, `search`, and `hash`
*/ function $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    let { pathname: locationPathname } = $baf2581b6f4e4c0a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $edf931d6dcac43ec$export$fe6dbc5de95f53ab)(matches));
    return $acw62.useMemo(()=>(0, $edf931d6dcac43ec$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
* Hook version of {@link Routes | `<Routes>`} that uses objects instead of
* components. These objects have the same properties as the component props.
* The return value of `useRoutes` is either a valid React element you can use
* to render the route tree, or `null` if nothing matched.
*
* @example
* import { useRoutes } from "react-router";
*
* function App() {
*   let element = useRoutes([
*     {
*       path: "/",
*       element: <Dashboard />,
*       children: [
*         {
*           path: "messages",
*           element: <DashboardMessages />,
*         },
*         { path: "tasks", element: <DashboardTasks /> },
*       ],
*     },
*     { path: "team", element: <AboutPage /> },
*   ]);
*
*   return element;
* }
*
* @public
* @category Hooks
* @param routes An array of {@link RouteObject}s that define the route hierarchy
* @param locationArg An optional {@link Location} object or pathname string to
* use instead of the current {@link Location}
* @returns A React element to render the matched route, or `null` if no routes matched
*/ function $baf2581b6f4e4c0a$export$5d3fca4a98652595(routes, locationArg) {
    return $baf2581b6f4e4c0a$export$f7ce0646a48561fb(routes, locationArg);
}
function $baf2581b6f4e4c0a$export$f7ce0646a48561fb(routes, locationArg, dataRouterOpts) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($baf2581b6f4e4c0a$export$9c954a9d03d32f4a(), `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let { matches: parentMatches } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    routeMatch && routeMatch.pathname;
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    routeMatch && routeMatch.route;
    let locationFromContext = $baf2581b6f4e4c0a$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        remainingPathname = "/" + pathname.replace(/^\//, "").split("/").slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : (0, $edf931d6dcac43ec$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $baf2581b6f4e4c0a$export$569816e95a012c39(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$e6a44b110a0c44d3).Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP"
        }
    }, renderedMatches);
    return renderedMatches;
}
function $baf2581b6f4e4c0a$var$DefaultErrorComponent() {
    let error = $baf2581b6f4e4c0a$export$ed527bf60f6e05f2();
    let message = (0, $edf931d6dcac43ec$export$972111febbeef05b)(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "0.5rem",
            backgroundColor: "rgba(200,200,200, 0.5)"
        }
    }, stack) : null, null);
}
const $baf2581b6f4e4c0a$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($baf2581b6f4e4c0a$var$DefaultErrorComponent, null);
var $baf2581b6f4e4c0a$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static contextType = (0, $52882ad28a21bc0a$export$717f757c655223f1);
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = (0, $b9584a574d863128$export$2b5950305b3e7eaf)(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$aac280ed165a4397).Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$af8bd2647fea9c11).Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $acw62.createElement($baf2581b6f4e4c0a$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
const $baf2581b6f4e4c0a$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $baf2581b6f4e4c0a$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect = (0, $b9584a574d863128$export$30db792b333fd2ee)(error.digest);
        if (redirect) {
            let existingRedirect = $baf2581b6f4e4c0a$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = (0, $edf931d6dcac43ec$export$ac5aeb949e84fd96)(redirect.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            if ((0, $27ddc9c887d48115$export$961a3ef7a4da3a39)(target)) throw new Error("Invalid redirect location");
            if ((0, $edf931d6dcac43ec$export$4e09c449d6c407f7) && !$baf2581b6f4e4c0a$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect.replace
                        }));
                    $baf2581b6f4e4c0a$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $acw62.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $baf2581b6f4e4c0a$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$aac280ed165a4397).Provider, {
        value: routeContext
    }, children);
}
function $baf2581b6f4e4c0a$export$569816e95a012c39(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors || errors[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $baf2581b6f4e4c0a$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $baf2581b6f4e4c0a$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($baf2581b6f4e4c0a$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($baf2581b6f4e4c0a$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $baf2581b6f4e4c0a$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(ctx, $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $baf2581b6f4e4c0a$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $52882ad28a21bc0a$export$315e3ffb01f217));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(state, $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName));
    return state;
}
function $baf2581b6f4e4c0a$var$useRouteContext(hookName) {
    let route = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(route, $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName));
    return route;
}
function $baf2581b6f4e4c0a$var$useCurrentRouteId(hookName) {
    let route = $baf2581b6f4e4c0a$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
/**
* Returns the ID for the nearest contextual route
*
* @category Hooks
* @returns The ID of the nearest contextual route
*/ function $baf2581b6f4e4c0a$export$4200b254756b08af() {
    return $baf2581b6f4e4c0a$var$useCurrentRouteId("useRouteId");
}
/**
* Returns the current {@link Navigation}, defaulting to an "idle" navigation
* when no navigation is in progress. You can use this to render pending UI
* (like a global spinner) or read [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData)
* from a form navigation.
*
* @example
* import { useNavigation } from "react-router";
*
* function SomeComponent() {
*   let navigation = useNavigation();
*   navigation.state;
*   navigation.formData;
*   // etc.
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current {@link Navigation} object
*/ function $baf2581b6f4e4c0a$export$d0fd4b7106de2769() {
    let state = $baf2581b6f4e4c0a$var$useDataRouterState("useNavigation");
    return $acw62.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
/**
* Revalidate the data on the page for reasons outside of normal data mutations
* like [`Window` focus](https://developer.mozilla.org/en-US/docs/Web/API/Window/focus_event)
* or polling on an interval.
*
* Note that page data is already revalidated automatically after actions.
* If you find yourself using this for normal CRUD operations on your data in
* response to user interactions, you're probably not taking advantage of the
* other APIs like {@link useFetcher}, {@link Form}, {@link useSubmit} that do
* this automatically.
*
* @example
* import { useRevalidator } from "react-router";
*
* function WindowFocusRevalidator() {
*   const revalidator = useRevalidator();
*
*   useFakeWindowFocus(() => {
*     revalidator.revalidate();
*   });
*
*   return (
*     <div hidden={revalidator.state === "idle"}>
*       Revalidating...
*     </div>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An object with a `revalidate` function and the current revalidation
* `state`
*/ function $baf2581b6f4e4c0a$export$600dc272ed516c15() {
    let dataRouterContext = $baf2581b6f4e4c0a$var$useDataRouterContext("useRevalidator");
    let state = $baf2581b6f4e4c0a$var$useDataRouterState("useRevalidator");
    let revalidate = $acw62.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $acw62.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
/**
* Returns the active route matches, useful for accessing `loaderData` for
* parent/child routes or the route [`handle`](../../start/framework/route-module#handle)
* property
*
* Pairing the route `handle` with `useMatches` gets very powerful since you can put
* whatever you want on a route handle and have access to `useMatches` anywhere.
* Please see the [handle](../../how-to/using-handle) documentation for an example
* of breadcrumbs via `useMatches`/`handle`.
*
* ```tsx
* import { useMatches } from "react-router";
*
* function SomeComponent() {
*   const matches = useMatches();
*   // matches[i].id          // route id
*   // matches[i].pathname    // the portion of the URL the route matched
*   // matches[i].params      // the parsed params from the URL
*   // matches[i].loaderData  // the data from the loader
*   // matches[i].handle      // the route handle with any app specific data
* }
* ```
*
* <docs-info>useMatches only works with a data router like `createBrowserRouter`,
* since they know the full route tree up front and can provide all of the current
* matches. Additionally, `useMatches` will not match down into any descendant route
* trees since the router isn't aware of the descendant routes.</docs-info>
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of {@link UIMatch | UI matches} for the current route hierarchy
*/ function $baf2581b6f4e4c0a$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $baf2581b6f4e4c0a$var$useDataRouterState("useMatches");
    return $acw62.useMemo(()=>matches.map((m)=>(0, $edf931d6dcac43ec$export$fcf533780bf49ee2)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
* Returns the data from the closest route
* [`loader`](../../start/framework/route-module#loader) or
* [`clientLoader`](../../start/framework/route-module#clientloader).
*
* @example
* import { useLoaderData } from "react-router";
*
* export async function loader() {
*   return await fakeDb.invoices.findAll();
* }
*
* export default function Invoices() {
*   let invoices = useLoaderData<typeof loader>();
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`loader`](../../start/framework/route-module#loader) or [`clientLoader`](../../start/framework/route-module#clientloader) function
*/ function $baf2581b6f4e4c0a$export$1448a5050d252c4d() {
    let state = $baf2581b6f4e4c0a$var$useDataRouterState("useLoaderData");
    let routeId = $baf2581b6f4e4c0a$var$useCurrentRouteId("useLoaderData");
    return state.loaderData[routeId];
}
/**
* Returns the [`loader`](../../start/framework/route-module#loader) data for a
* given route by route ID.
*
* Route IDs are created automatically. They are simply the path of the route file
* relative to the app folder without the extension.
*
* | Route Filename               | Route ID               |
* | ---------------------------- | ---------------------- |
* | `app/root.tsx`               | `"root"`               |
* | `app/routes/teams.tsx`       | `"routes/teams"`       |
* | `app/whatever/teams.$id.tsx` | `"whatever/teams.$id"` |
*
* @example
* import { useRouteLoaderData } from "react-router";
*
* function SomeComponent() {
*   const { user } = useRouteLoaderData("root");
* }
*
* // You can also specify your own route ID's manually in your routes.ts file:
* route("/", "containers/app.tsx", { id: "app" })
* useRouteLoaderData("app");
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param routeId The ID of the route to return loader data from
* @returns The data returned from the specified route's [`loader`](../../start/framework/route-module#loader)
* function, or `undefined` if not found
*/ function $baf2581b6f4e4c0a$export$fd5d37484eab868d(routeId) {
    return $baf2581b6f4e4c0a$var$useDataRouterState("useRouteLoaderData").loaderData[routeId];
}
/**
* Returns the [`action`](../../start/framework/route-module#action) data from
* the most recent `POST` navigation form submission or `undefined` if there
* hasn't been one.
*
* @example
* import { Form, useActionData } from "react-router";
*
* export async function action({ request }) {
*   const body = await request.formData();
*   const name = body.get("visitorsName");
*   return { message: `Hello, ${name}` };
* }
*
* export default function Invoices() {
*   const data = useActionData();
*   return (
*     <Form method="post">
*       <input type="text" name="visitorsName" />
*       {data ? data.message : "Waiting..."}
*     </Form>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`action`](../../start/framework/route-module#action)
* function, or `undefined` if no [`action`](../../start/framework/route-module#action)
* has been called
*/ function $baf2581b6f4e4c0a$export$fdc00f3f26066d5e() {
    let state = $baf2581b6f4e4c0a$var$useDataRouterState("useActionData");
    let routeId = $baf2581b6f4e4c0a$var$useCurrentRouteId("useLoaderData");
    return state.actionData ? state.actionData[routeId] : void 0;
}
/**
* Accesses the error thrown during an
* [`action`](../../start/framework/route-module#action),
* [`loader`](../../start/framework/route-module#loader),
* or component render to be used in a route module
* [`ErrorBoundary`](../../start/framework/route-module#errorboundary).
*
* @example
* export function ErrorBoundary() {
*   const error = useRouteError();
*   return <div>{error.message}</div>;
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown during route [loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action) execution, or rendering
*/ function $baf2581b6f4e4c0a$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext((0, $52882ad28a21bc0a$export$af8bd2647fea9c11));
    let state = $baf2581b6f4e4c0a$var$useDataRouterState("useRouteError");
    let routeId = $baf2581b6f4e4c0a$var$useCurrentRouteId("useRouteError");
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
/**
* Returns the resolved promise value from the closest {@link Await | `<Await>`}.
*
* @example
* function SomeDescendant() {
*   const value = useAsyncValue();
*   // ...
* }
*
* // somewhere in your app
* <Await resolve={somePromise}>
*   <SomeDescendant />
* </Await>;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The resolved value from the nearest {@link Await} component
*/ function $baf2581b6f4e4c0a$export$78a72ddb39bdd145() {
    return $acw62.useContext((0, $52882ad28a21bc0a$export$804c460aade54ac8))?._data;
}
/**
* Returns the rejection value from the closest {@link Await | `<Await>`}.
*
* @example
* import { Await, useAsyncError } from "react-router";
*
* function ErrorElement() {
*   const error = useAsyncError();
*   return (
*     <p>Uh Oh, something went wrong! {error.message}</p>
*   );
* }
*
* // somewhere in your app
* <Await
*   resolve={promiseThatRejects}
*   errorElement={<ErrorElement />}
* />;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown in the nearest {@link Await} component
*/ function $baf2581b6f4e4c0a$export$17f53340677d5831() {
    return $acw62.useContext((0, $52882ad28a21bc0a$export$804c460aade54ac8))?._error;
}
let $baf2581b6f4e4c0a$var$blockerId = 0;
/**
* Allow the application to block navigations within the SPA and present the
* user a confirmation dialog to confirm the navigation. Mostly used to avoid
* using half-filled form data. This does not handle hard-reloads or
* cross-origin navigations.
*
* The {@link Blocker} object returned by the hook has the following properties:
*
* - **`state`**
*   - `unblocked` - the blocker is idle and has not prevented any navigation
*   - `blocked` - the blocker has prevented a navigation
*   - `proceeding` - the blocker is proceeding through from a blocked navigation
* - **`location`**
*   - When in a `blocked` state, this represents the {@link Location} to which
*     we blocked a navigation. When in a `proceeding` state, this is the
*     location being navigated to after a `blocker.proceed()` call.
* - **`proceed()`**
*   - When in a `blocked` state, you may call `blocker.proceed()` to proceed to
*     the blocked location.
* - **`reset()`**
*   - When in a `blocked` state, you may call `blocker.reset()` to return the
*     blocker to an `unblocked` state and leave the user at the current
*     location.
*
* @example
* // Boolean version
* let blocker = useBlocker(value !== "");
*
* // Function version
* let blocker = useBlocker(
*   ({ currentLocation, nextLocation, historyAction }) =>
*     value !== "" &&
*     currentLocation.pathname !== nextLocation.pathname
* );
*
* @additionalExamples
* ```tsx
* import { useCallback, useState } from "react";
* import { BlockerFunction, useBlocker } from "react-router";
*
* export function ImportantForm() {
*   const [value, setValue] = useState("");
*
*   const shouldBlock = useCallback<BlockerFunction>(
*     () => value !== "",
*     [value]
*   );
*   const blocker = useBlocker(shouldBlock);
*
*   return (
*     <form
*       onSubmit={(e) => {
*         e.preventDefault();
*         setValue("");
*         if (blocker.state === "blocked") {
*           blocker.proceed();
*         }
*       }}
*     >
*       <input
*         name="data"
*         value={value}
*         onChange={(e) => setValue(e.target.value)}
*       />
*
*       <button type="submit">Save</button>
*
*       {blocker.state === "blocked" ? (
*         <>
*           <p style={{ color: "red" }}>
*             Blocked the last navigation to
*           </p>
*           <button
*             type="button"
*             onClick={() => blocker.proceed()}
*           >
*             Let me through
*           </button>
*           <button
*             type="button"
*             onClick={() => blocker.reset()}
*           >
*             Keep me here
*           </button>
*         </>
*       ) : blocker.state === "proceeding" ? (
*         <p style={{ color: "orange" }}>
*           Proceeding through blocked navigation
*         </p>
*       ) : (
*         <p style={{ color: "green" }}>
*           Blocker is currently unblocked
*         </p>
*       )}
*     </form>
*   );
* }
* ```
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param shouldBlock Either a boolean or a function returning a boolean which
* indicates whether the navigation should be blocked. The function format
* receives a single object parameter containing the `currentLocation`,
* `nextLocation`, and `historyAction` of the potential navigation.
* @returns A {@link Blocker} object with state and reset functionality
*/ function $baf2581b6f4e4c0a$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $baf2581b6f4e4c0a$var$useDataRouterContext("useBlocker");
    let state = $baf2581b6f4e4c0a$var$useDataRouterState("useBlocker");
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$baf2581b6f4e4c0a$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $27ddc9c887d48115$export$386d57f03f0b2883);
}
function $baf2581b6f4e4c0a$var$useNavigateStable() {
    let { router: router } = $baf2581b6f4e4c0a$var$useDataRouterContext("useNavigate");
    let id = $baf2581b6f4e4c0a$var$useCurrentRouteId("useNavigate");
    let activeRef = $acw62.useRef(false);
    $acw62.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $acw62.useCallback(async (to, options = {})=>{
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(activeRef.current, $baf2581b6f4e4c0a$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
}
const $baf2581b6f4e4c0a$var$alreadyWarned = {};
function $baf2581b6f4e4c0a$var$warningOnce(key, cond, message) {
    if (!cond && !$baf2581b6f4e4c0a$var$alreadyWarned[key]) {
        $baf2581b6f4e4c0a$var$alreadyWarned[key] = true;
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, message);
    }
}
function $baf2581b6f4e4c0a$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $baf2581b6f4e4c0a$var$useCurrentRouteId("useRoute");
    const id = args[0] ?? currentRouteId;
    const state = $baf2581b6f4e4c0a$var$useDataRouterState("useRoute");
    const route = state.matches.find(({ route: route })=>route.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $baf2581b6f4e4c0a$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
/**
* A unified hook for reading router state: current (`active`) and in-flight
* (`pending`) locations, search params, params, matches, and navigation type.
*
* This hook consolidates the information you used to get from {@link useLocation},
* {@link useSearchParams}, {@link useParams}, {@link useMatches}, {@link useNavigation},
* and {@link useNavigationType} into a single hook.
*
*
* @example
* import { unstable_useRouterState as useRouterState } from "react-router";
*
* let { active, pending } = unstable_useRouterState();
*
* // Active is always populated with the current location
* active.location; // replaces `useLocation()`
* active.searchParams; // replaces `useSearchParams()[0]`
* active.params; // replaces `useParams()`
* active.matches; // replaces `useMatches()`
* active.type; // replaces `useNavigationType()`
*
* // Pending is only populated during a navigation
* pending.location; // replaces `useNavigation().location`
* pending.searchParams; // equivalent to `new URLSearchParams(useNavigation().search)`
* pending.params; // Not directly accessible today
* pending.matches; // Not directly accessible today
* pending.type; // Not directly accessible today
* pending.state; // replaces `useNavigation().state`
* pending.formMethod; // replaces useNavigation().formMethod
* pending.formAction; // replaces useNavigation().formAction
* pending.formEncType; // replaces useNavigation().formEncType
* pending.formData; // replaces useNavigation().formData
* pending.json; // replaces useNavigation().json
* pending.text; // replaces useNavigation().text
*
* @name unstable_useRouterState
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current router state with `active` and `pending` variants
*/ function $baf2581b6f4e4c0a$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $baf2581b6f4e4c0a$var$useDataRouterState("unstable_useRouterState");
    let active = $acw62.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$baf2581b6f4e4c0a$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $acw62.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$baf2581b6f4e4c0a$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $acw62.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/server-runtime/warnings.ts
const $9cdee517b2ac63e9$var$alreadyWarned = {};
function $9cdee517b2ac63e9$export$5b28268982f175ba(condition, message) {
    if (!condition && !$9cdee517b2ac63e9$var$alreadyWarned[message]) {
        $9cdee517b2ac63e9$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}



var $acw62 = parcelRequire("acw62");
//#region lib/components.tsx
const $1b6caee6a6f10651$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
/**
* Create a new {@link DataRouter} that manages the application path using an
* in-memory [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack. Useful for non-browser environments without a DOM API.
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {MemoryRouterOpts.basename} opts.basename n/a
* @param {MemoryRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {MemoryRouterOpts.future} opts.future n/a
* @param {MemoryRouterOpts.getContext} opts.getContext n/a
* @param {MemoryRouterOpts.hydrationData} opts.hydrationData n/a
* @param {MemoryRouterOpts.initialEntries} opts.initialEntries n/a
* @param {MemoryRouterOpts.initialIndex} opts.initialIndex n/a
* @param {MemoryRouterOpts.instrumentations} opts.instrumentations n/a
* @param {MemoryRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @returns An initialized {@link DataRouter} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $1b6caee6a6f10651$export$f30f7e456d254e83(routes, opts) {
    return (0, $27ddc9c887d48115$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $2ce80a7c58bedbaf$export$2b76ad033c6e6d08)({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: (0, $edf931d6dcac43ec$export$6bc17138063be773),
        hydrationRouteProperties: $1b6caee6a6f10651$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $1b6caee6a6f10651$var$Deferred = class {
    status = "pending";
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
/**
* Render the UI for the given {@link DataRouter}. This component should
* typically be at the top of an app's element tree. The router prop should
* be a single router instance created outside of the React tree. Avoid
* creating new routers during React renders/re-renders.
*
* ```tsx
* import { createBrowserRouter } from "react-router";
* import { RouterProvider } from "react-router/dom";
* import { createRoot } from "react-dom/client";
*
* const router = createBrowserRouter(routes);
* createRoot(document.getElementById("root")).render(
*   <RouterProvider router={router} />
* );
* ```
*
* <docs-info>Please note that this component is exported both from
* `react-router` and `react-router/dom` with the only difference being that the
* latter automatically wires up `react-dom`'s [`flushSync`](https://react.dev/reference/react-dom/flushSync)
* implementation. You _almost always_ want to use the version from
* `react-router/dom` unless you're running in a non-DOM environment.</docs-info>
*
*
* @public
* @category Data Routers
* @mode data
* @param props Props
* @param {RouterProviderProps.flushSync} props.flushSync n/a
* @param {RouterProviderProps.onError} props.onError n/a
* @param {RouterProviderProps.router} props.router n/a
* @param {RouterProviderProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router
*/ function $1b6caee6a6f10651$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    useTransitions = (0, $52882ad28a21bc0a$export$6e1eeb090b3ec35b)() || useTransitions;
    let [_state, setStateImpl] = $acw62.useState(router.state);
    let [state, setOptimisticState] = (0, $acw62.useOptimistic)(_state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        (0, $9cdee517b2ac63e9$export$5b28268982f175ba)(flushSync === false || reactDomFlushSyncImpl != null, "You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from \"react-router/dom\"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.");
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        (0, $9cdee517b2ac63e9$export$5b28268982f175ba)(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $acw62.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$1b6caee6a6f10651$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $1b6caee6a6f10651$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $acw62.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$1b6caee6a6f10651$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c).Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$315e3ffb01f217).Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$cb3f1df1bef00a39).Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$3681f408decb40d1).Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $1b6caee6a6f10651$var$getOptimisticRouterState(currentState, newState) {
    return {
        ...currentState,
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
const $1b6caee6a6f10651$var$MemoizedDataRoutes = $acw62.memo($1b6caee6a6f10651$export$699f06c8afb533c9);
function $1b6caee6a6f10651$export$699f06c8afb533c9({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return (0, $baf2581b6f4e4c0a$export$f7ce0646a48561fb)(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores all entries in memory.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {MemoryRouterProps.basename} props.basename n/a
* @param {MemoryRouterProps.children} props.children n/a
* @param {MemoryRouterProps.initialEntries} props.initialEntries n/a
* @param {MemoryRouterProps.initialIndex} props.initialIndex n/a
* @param {MemoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative in-memory {@link Router | `<Router>`} for client-side
* routing.
*/ function $1b6caee6a6f10651$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $acw62.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $2ce80a7c58bedbaf$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A component-based version of {@link useNavigate} to use in a
* [`React.Component` class](https://react.dev/reference/react/Component) where
* hooks cannot be used.
*
* It's recommended to avoid using this component in favor of {@link useNavigate}.
*
* @example
* <Navigate to="/tasks" />
*
* @public
* @category Components
* @param props Props
* @param {NavigateProps.relative} props.relative n/a
* @param {NavigateProps.replace} props.replace n/a
* @param {NavigateProps.state} props.state n/a
* @param {NavigateProps.to} props.to n/a
* @returns {void}
*
*/ function $1b6caee6a6f10651$export$444b3ab0cb9aec40({ to: to, replace: replace, state: state, relative: relative }) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)((0, $baf2581b6f4e4c0a$export$9c954a9d03d32f4a)(), `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    (0, $2ce80a7c58bedbaf$export$491112666e282270)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    let { pathname: locationPathname } = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    let path = (0, $edf931d6dcac43ec$export$cae722b0cc860f13)(to, (0, $edf931d6dcac43ec$export$fe6dbc5de95f53ab)(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
* Renders the matching child route of a parent route or nothing if no child
* route matches.
*
* @example
* import { Outlet } from "react-router";
*
* export default function SomeParent() {
*   return (
*     <div>
*       <h1>Parent Content</h1>
*       <Outlet />
*     </div>
*   );
* }
*
* @public
* @category Components
* @param props Props
* @param {OutletProps.context} props.context n/a
* @returns React element for the rendered outlet or `null` if no child route matches.
*/ function $1b6caee6a6f10651$export$910ae8079b2c2852(props) {
    return (0, $baf2581b6f4e4c0a$export$a3be3530d8e40d0b)(props.context);
}
/**
* Configures an element to render when a pattern matches the current location.
* It must be rendered within a {@link Routes} element. Note that these routes
* do not participate in data loading, actions, code splitting, or any other
* route module features.
*
* @example
* // Usually used in a declarative router
* function App() {
*   return (
*     <BrowserRouter>
*       <Routes>
*         <Route index element={<StepOne />} />
*         <Route path="step-2" element={<StepTwo />} />
*         <Route path="step-3" element={<StepThree />} />
*       </Routes>
*    </BrowserRouter>
*   );
* }
*
* // But can be used with a data router as well if you prefer the JSX notation
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @public
* @category Components
* @param props Props
* @param {PathRouteProps.action} props.action n/a
* @param {PathRouteProps.caseSensitive} props.caseSensitive n/a
* @param {PathRouteProps.Component} props.Component n/a
* @param {PathRouteProps.children} props.children n/a
* @param {PathRouteProps.element} props.element n/a
* @param {PathRouteProps.ErrorBoundary} props.ErrorBoundary n/a
* @param {PathRouteProps.errorElement} props.errorElement n/a
* @param {PathRouteProps.handle} props.handle n/a
* @param {PathRouteProps.HydrateFallback} props.HydrateFallback n/a
* @param {PathRouteProps.hydrateFallbackElement} props.hydrateFallbackElement n/a
* @param {PathRouteProps.id} props.id n/a
* @param {PathRouteProps.index} props.index n/a
* @param {PathRouteProps.lazy} props.lazy n/a
* @param {PathRouteProps.loader} props.loader n/a
* @param {PathRouteProps.path} props.path n/a
* @param {PathRouteProps.shouldRevalidate} props.shouldRevalidate n/a
* @returns {void}
*/ function $1b6caee6a6f10651$export$e7b0ac011bb776c6(props) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
* Provides location context for the rest of the app.
*
* Note: You usually won't render a `<Router>` directly. Instead, you'll render a
* router that is more specific to your environment such as a {@link BrowserRouter}
* in web browsers or a {@link ServerRouter} for server rendering.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {RouterProps.basename} props.basename n/a
* @param {RouterProps.children} props.children n/a
* @param {RouterProps.location} props.location n/a
* @param {RouterProps.navigationType} props.navigationType n/a
* @param {RouterProps.navigator} props.navigator n/a
* @param {RouterProps.static} props.static n/a
* @param {RouterProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router or `null` if the location does
* not match the {@link props.basename}
*/ function $1b6caee6a6f10651$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP", navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!(0, $baf2581b6f4e4c0a$export$9c954a9d03d32f4a)(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    (0, $2ce80a7c58bedbaf$export$491112666e282270)(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6).Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$e6a44b110a0c44d3).Provider, {
        children: children,
        value: locationContext
    }));
}
/**
* Renders a branch of {@link Route | `<Route>`s} that best matches the current
* location. Note that these routes do not participate in [data loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action), code splitting, or
* any other [route module](../../start/framework/route-module) features.
*
* @example
* import { Route, Routes } from "react-router";
*
* <Routes>
*   <Route index element={<StepOne />} />
*   <Route path="step-2" element={<StepTwo />} />
*   <Route path="step-3" element={<StepThree />} />
* </Routes>
*
* @public
* @category Components
* @param props Props
* @param {RoutesProps.children} props.children n/a
* @param {RoutesProps.location} props.location n/a
* @returns React element for the rendered routes or `null` if no route matches
*/ function $1b6caee6a6f10651$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return (0, $baf2581b6f4e4c0a$export$5d3fca4a98652595)($1b6caee6a6f10651$export$16da398f5434bdec(children), location);
}
/**
* Used to render promise values with automatic error handling.
*
* **Note:** `<Await>` expects to be rendered inside a [`<React.Suspense>`](https://react.dev/reference/react/Suspense)
*
* @example
* import { Await, useLoaderData } from "react-router";
*
* export async function loader() {
*   // not awaited
*   const reviews = getReviews();
*   // awaited (blocks the transition)
*   const book = await fetch("/api/book").then((res) => res.json());
*   return { book, reviews };
* }
*
* function Book() {
*   const { book, reviews } = useLoaderData();
*   return (
*     <div>
*       <h1>{book.title}</h1>
*       <p>{book.description}</p>
*       <React.Suspense fallback={<ReviewsSkeleton />}>
*         <Await
*           resolve={reviews}
*           errorElement={
*             <div>Could not load reviews 😬</div>
*           }
*           children={(resolvedReviews) => (
*             <Reviews items={resolvedReviews} />
*           )}
*         />
*       </React.Suspense>
*     </div>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {AwaitProps.children} props.children n/a
* @param {AwaitProps.errorElement} props.errorElement n/a
* @param {AwaitProps.resolve} props.resolve n/a
* @returns React element for the rendered awaited value
*/ function $1b6caee6a6f10651$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    let dataRouterStateContext = $acw62.useContext((0, $52882ad28a21bc0a$export$315e3ffb01f217));
    let onError = $acw62.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$var$ResolveAwait, null, children));
}
var $1b6caee6a6f10651$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0;
        if (!(resolve instanceof Promise)) {
            status = 1;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 : "_data" in promise ? 1 : 0;
        } else {
            status = 0;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 && !errorElement) throw promise._error;
        if (status === 2) return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$804c460aade54ac8).Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1) return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$804c460aade54ac8).Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $1b6caee6a6f10651$var$ResolveAwait({ children: children }) {
    let data = (0, $baf2581b6f4e4c0a$export$78a72ddb39bdd145)();
    let toRender = typeof children === "function" ? children(data) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
/**
* Creates a route config from a React "children" object, which is usually
* either a `<Route>` element or an array of them. Used internally by
* `<Routes>` to create a route config from its children.
*
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ function $1b6caee6a6f10651$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $1b6caee6a6f10651$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(element.type === $1b6caee6a6f10651$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        let props = element.props;
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!props.index || !props.children, "An index route cannot have child routes.");
        let route = {
            id: props.id || treePath.join("-"),
            caseSensitive: props.caseSensitive,
            element: props.element,
            Component: props.Component,
            index: props.index,
            path: props.path,
            middleware: props.middleware,
            loader: props.loader,
            action: props.action,
            hydrateFallbackElement: props.hydrateFallbackElement,
            HydrateFallback: props.HydrateFallback,
            errorElement: props.errorElement,
            ErrorBoundary: props.ErrorBoundary,
            shouldRevalidate: props.shouldRevalidate,
            handle: props.handle,
            lazy: props.lazy
        };
        if (props.children) route.children = $1b6caee6a6f10651$export$16da398f5434bdec(props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
* Create route objects from JSX elements instead of arrays of objects.
*
* @example
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @name createRoutesFromElements
* @public
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* This is used for internal recursion and is not intended to be used by the
* application developer.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ const $1b6caee6a6f10651$export$9b5b6d122dea0c88 = $1b6caee6a6f10651$export$16da398f5434bdec;
/**
* Renders the result of {@link matchRoutes} into a React element.
*
* @public
* @category Utils
* @param matches The array of {@link RouteMatch | route matches} to render
* @returns A React element that renders the matched routes or `null` if no matches
*/ function $1b6caee6a6f10651$export$daf73786167a7f72(matches) {
    return (0, $baf2581b6f4e4c0a$export$569816e95a012c39)(matches);
}
function $1b6caee6a6f10651$var$useRouteComponentProps() {
    return {
        params: (0, $baf2581b6f4e4c0a$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $baf2581b6f4e4c0a$export$1448a5050d252c4d)(),
        actionData: (0, $baf2581b6f4e4c0a$export$fdc00f3f26066d5e)(),
        matches: (0, $baf2581b6f4e4c0a$export$2378eb7f5ff86053)()
    };
}
function $1b6caee6a6f10651$export$6c4f3826290c37af({ children: children }) {
    const props = $1b6caee6a6f10651$var$useRouteComponentProps();
    return $acw62.cloneElement(children, props);
}
function $1b6caee6a6f10651$export$1a5de91a5c3255e0(Component) {
    return function WithComponentProps() {
        const props = $1b6caee6a6f10651$var$useRouteComponentProps();
        return $acw62.createElement(Component, props);
    };
}
function $1b6caee6a6f10651$var$useHydrateFallbackProps() {
    return {
        params: (0, $baf2581b6f4e4c0a$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $baf2581b6f4e4c0a$export$1448a5050d252c4d)(),
        actionData: (0, $baf2581b6f4e4c0a$export$fdc00f3f26066d5e)()
    };
}
function $1b6caee6a6f10651$export$f8cff34f39c1932a({ children: children }) {
    const props = $1b6caee6a6f10651$var$useHydrateFallbackProps();
    return $acw62.cloneElement(children, props);
}
function $1b6caee6a6f10651$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps() {
        const props = $1b6caee6a6f10651$var$useHydrateFallbackProps();
        return $acw62.createElement(HydrateFallback, props);
    };
}
function $1b6caee6a6f10651$var$useErrorBoundaryProps() {
    return {
        params: (0, $baf2581b6f4e4c0a$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $baf2581b6f4e4c0a$export$1448a5050d252c4d)(),
        actionData: (0, $baf2581b6f4e4c0a$export$fdc00f3f26066d5e)(),
        error: (0, $baf2581b6f4e4c0a$export$ed527bf60f6e05f2)()
    };
}
function $1b6caee6a6f10651$export$e5afde5c4b6d747b({ children: children }) {
    const props = $1b6caee6a6f10651$var$useErrorBoundaryProps();
    return $acw62.cloneElement(children, props);
}
function $1b6caee6a6f10651$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps() {
        const props = $1b6caee6a6f10651$var$useErrorBoundaryProps();
        return $acw62.createElement(ErrorBoundary, props);
    };
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

const $89bbb3f5cea75f10$var$defaultEncType = "application/x-www-form-urlencoded";
function $89bbb3f5cea75f10$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $89bbb3f5cea75f10$var$isButtonElement(object) {
    return $89bbb3f5cea75f10$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $89bbb3f5cea75f10$var$isFormElement(object) {
    return $89bbb3f5cea75f10$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $89bbb3f5cea75f10$var$isInputElement(object) {
    return $89bbb3f5cea75f10$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $89bbb3f5cea75f10$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $89bbb3f5cea75f10$export$4c2d35dce1b682e(event, target) {
    return event.button === 0 && (!target || target === "_self") && !$89bbb3f5cea75f10$var$isModifiedEvent(event);
}
/**
* Creates a URLSearchParams object using the given initializer.
*
* This is identical to `new URLSearchParams(init)` except it also supports
* arrays as values in the object form of the initializer instead of just
* strings. This is convenient when you need multiple values for a given key,
* but don't want to use an array initializer.
*
* @example
* // Instead of:
* let searchParams = new URLSearchParams([
*   ["sort", "name"],
*   ["sort", "price"],
* ]);
*
* // You can do:
* let searchParams = createSearchParams({
*   sort: ["name", "price"],
* });
*
* @public
* @category Utils
* @param init The value used to initialize the URL search parameters.
* @returns A URLSearchParams object containing the initialized search
* parameters.
*/ function $89bbb3f5cea75f10$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $89bbb3f5cea75f10$export$4370c962fe3096e6(locationSearch, defaultSearchParams) {
    let searchParams = $89bbb3f5cea75f10$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
let $89bbb3f5cea75f10$var$_formDataSupportsSubmitter = null;
function $89bbb3f5cea75f10$var$isFormDataSubmitterSupported() {
    if ($89bbb3f5cea75f10$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), 0);
        $89bbb3f5cea75f10$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $89bbb3f5cea75f10$var$_formDataSupportsSubmitter = true;
    }
    return $89bbb3f5cea75f10$var$_formDataSupportsSubmitter;
}
const $89bbb3f5cea75f10$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $89bbb3f5cea75f10$var$getFormEncType(encType) {
    if (encType != null && !$89bbb3f5cea75f10$var$supportedFormEncTypes.has(encType)) {
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$89bbb3f5cea75f10$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $89bbb3f5cea75f10$export$80917616746b9ab4(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($89bbb3f5cea75f10$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || "get";
        encType = $89bbb3f5cea75f10$var$getFormEncType(target.getAttribute("enctype")) || $89bbb3f5cea75f10$var$defaultEncType;
        formData = new FormData(target);
    } else if ($89bbb3f5cea75f10$var$isButtonElement(target) || $89bbb3f5cea75f10$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || "get";
        encType = $89bbb3f5cea75f10$var$getFormEncType(target.getAttribute("formenctype")) || $89bbb3f5cea75f10$var$getFormEncType(form.getAttribute("enctype")) || $89bbb3f5cea75f10$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$89bbb3f5cea75f10$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($89bbb3f5cea75f10$var$isHtmlElement(target)) throw new Error("Cannot submit element that is not <form>, <button>, or <input type=\"submit|image\">");
    else {
        method = "get";
        action = null;
        encType = $89bbb3f5cea75f10$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/markup.ts
const $c6f8fc82db0f6244$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
const $c6f8fc82db0f6244$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $c6f8fc82db0f6244$export$4cf11838cdc2a8a8(html) {
    return html.replace($c6f8fc82db0f6244$var$ESCAPE_REGEX, (match)=>$c6f8fc82db0f6244$var$ESCAPE_LOOKUP[match]);
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 



/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/invariant.ts
function $f6e8c7ac4ab8992c$export$2e2bcd8739ae039(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/routeModules.ts
var $b7db53197255e154$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/production/lib/dom/ssr/routeModules.js"
});
async function $b7db53197255e154$export$d9c4a4e8105733a6(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && $b7db53197255e154$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}


//#region lib/dom/ssr/links.ts
/**
* Gets all the links for a set of matches. The modules are assumed to have been
* loaded already.
*/ function $bb47af95f14cb967$export$c43eb07eab2c950a(matches, routeModules, manifest) {
    return $bb47af95f14cb967$var$dedupeLinkDescriptors(matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2), $bb47af95f14cb967$export$442b9e023f41af00(matches, manifest));
}
function $bb47af95f14cb967$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $bb47af95f14cb967$export$2ee8f5601ba37b41(route) {
    if (!route.css) return;
    let descriptors = $bb47af95f14cb967$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($bb47af95f14cb967$var$prefetchStyleLink));
}
async function $bb47af95f14cb967$export$26f28bc6dfd6cfc6(route, routeModule) {
    if (!route.css && !routeModule.links || !$bb47af95f14cb967$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$bb47af95f14cb967$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$bb47af95f14cb967$export$aea1aca0de10baae(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($bb47af95f14cb967$var$prefetchStyleLink));
}
async function $bb47af95f14cb967$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $bb47af95f14cb967$export$aea1aca0de10baae(object) {
    return object != null && typeof object.page === "string";
}
function $bb47af95f14cb967$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $bb47af95f14cb967$export$98f31d7a23772264(matches, manifest, routeModules) {
    return $bb47af95f14cb967$var$dedupeLinkDescriptors((await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await (0, $b7db53197255e154$export$d9c4a4e8105733a6)(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }))).flat(1).filter($bb47af95f14cb967$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $bb47af95f14cb967$export$4af547f9516933c(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return currentMatches[index].pathname !== match.pathname || currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"];
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $bb47af95f14cb967$export$442b9e023f41af00(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $bb47af95f14cb967$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $bb47af95f14cb967$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $bb47af95f14cb967$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $bb47af95f14cb967$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        if (preloads && !$bb47af95f14cb967$export$aea1aca0de10baae(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href)) return deduped;
        let key = JSON.stringify($bb47af95f14cb967$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
let $bb47af95f14cb967$var$_isPreloadSupported;
function $bb47af95f14cb967$var$isPreloadSupported() {
    if ($bb47af95f14cb967$var$_isPreloadSupported !== void 0) return $bb47af95f14cb967$var$_isPreloadSupported;
    let el = document.createElement("link");
    $bb47af95f14cb967$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $bb47af95f14cb967$var$_isPreloadSupported;
}



/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 



/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/utils.ts
var $bb1d86855daf76fc$export$85f6557964517f1a = class {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $bb1d86855daf76fc$export$4786a9f20844482d() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/flatten.ts
const $fe0f2fac6e7ce220$var$TIME_LIMIT_MS = 1;
const $fe0f2fac6e7ce220$var$getNow = ()=>Date.now();
const $fe0f2fac6e7ce220$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $fe0f2fac6e7ce220$export$bffa455ba8c619a6(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return -7;
    if (input === null) return -5;
    if (Number.isNaN(input)) return -2;
    if (input === Number.POSITIVE_INFINITY) return -6;
    if (input === Number.NEGATIVE_INFINITY) return -3;
    if (input === 0 && 1 / input < 0) return -4;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $fe0f2fac6e7ce220$var$stringify.call(this, stack);
    return index;
}
async function $fe0f2fac6e7ce220$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $fe0f2fac6e7ce220$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return -7;
        if (value === null) return -5;
        if (Number.isNaN(value)) return -2;
        if (value === Number.POSITIVE_INFINITY) return -6;
        if (value === Number.NEGATIVE_INFINITY) return -3;
        if (value === 0 && 1 / value < 0) return -4;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $fe0f2fac6e7ce220$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $fe0f2fac6e7ce220$var$TIME_LIMIT_MS) {
            await $fe0f2fac6e7ce220$var$yieldToMain();
            lastYieldTime = $fe0f2fac6e7ce220$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["B","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = /* @__PURE__ */ new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["Y",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `-5`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input.length; i++)result += (i ? "," : "") + (i in input ? flattenValue(input[i]) : -1);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["D",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["U",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["R",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["S",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["S"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["M",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["M"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["P",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["E",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["N",{${partsForObj(input)}}]`;
                        else if ($fe0f2fac6e7ce220$var$isPlainObject(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = /* @__PURE__ */ new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = /* @__PURE__ */ new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
const $fe0f2fac6e7ce220$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $fe0f2fac6e7ce220$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $fe0f2fac6e7ce220$var$objectProtoNames;
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

//#region vendor/turbo-stream-v2/unflatten.ts
const $f0a2a611d7bf4aef$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $f0a2a611d7bf4aef$export$4315a2af848d75d7(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $f0a2a611d7bf4aef$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $f0a2a611d7bf4aef$var$hydrate.call(this, startIndex);
}
function $f0a2a611d7bf4aef$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index, set] = stack.pop();
        switch(index){
            case -7:
                set(void 0);
                continue;
            case -5:
                set(null);
                continue;
            case -2:
                set(NaN);
                continue;
            case -6:
                set(Infinity);
                continue;
            case -3:
                set(-Infinity);
                continue;
            case -4:
                set(-0);
                continue;
        }
        if (hydrated[index]) {
            set(hydrated[index]);
            continue;
        }
        const value = values[index];
        if (!value || typeof value !== "object") {
            hydrated[index] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case "D":
                        set(hydrated[index] = new Date(b));
                        continue;
                    case "U":
                        set(hydrated[index] = new URL(b));
                        continue;
                    case "B":
                        set(hydrated[index] = BigInt(b));
                        continue;
                    case "R":
                        set(hydrated[index] = new RegExp(b, c));
                        continue;
                    case "Y":
                        set(hydrated[index] = Symbol.for(b));
                        continue;
                    case "S":
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case "M":
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case "N":
                        const obj = Object.create(null);
                        hydrated[index] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case "P":
                        if (hydrated[b]) set(hydrated[index] = hydrated[b]);
                        else {
                            const d = new (0, $bb1d86855daf76fc$export$85f6557964517f1a)();
                            deferred[b] = d;
                            set(hydrated[index] = d.promise);
                        }
                        continue;
                    case "E":
                        const [, message, errorType] = value;
                        let error = errorType && $f0a2a611d7bf4aef$var$globalObj && (0, $edf931d6dcac43ec$export$1a235bd2b33434e5).includes(errorType) && errorType in $f0a2a611d7bf4aef$var$globalObj && typeof $f0a2a611d7bf4aef$var$globalObj[errorType] === "function" ? new $f0a2a611d7bf4aef$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index] = error;
                        set(error);
                        continue;
                    case "Z":
                        set(hydrated[index] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v)=>{
                                        r[i] = v;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result = plugin(value[0], ...r);
                                    if (result) {
                                        set(hydrated[index] = result.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== -1) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}


//#region vendor/turbo-stream-v2/turbo-stream.ts
async function $7dbb8f88df69b2a1$export$2f872c0f2117be69(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new (0, $bb1d86855daf76fc$export$85f6557964517f1a)();
    const reader = readable.pipeThrough((0, $bb1d86855daf76fc$export$4786a9f20844482d)()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $7dbb8f88df69b2a1$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $7dbb8f88df69b2a1$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $7dbb8f88df69b2a1$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: (0, $f0a2a611d7bf4aef$export$4315a2af848d75d7).call(this, line)
    };
}
async function $7dbb8f88df69b2a1$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case "P":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = (0, $f0a2a611d7bf4aef$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case "E":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = (0, $f0a2a611d7bf4aef$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $7dbb8f88df69b2a1$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    return new ReadableStream({
        async start (controller) {
            const id = await (0, $fe0f2fac6e7ce220$export$bffa455ba8c619a6).call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}\n`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]\n`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || /* @__PURE__ */ new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id = await (0, $fe0f2fac6e7ce220$export$bffa455ba8c619a6).call(encoder, resolved);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`P${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = /* @__PURE__ */ new Error("An unknown error occurred");
                                const id = await (0, $fe0f2fac6e7ce220$export$bffa455ba8c619a6).call(encoder, reason);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`E${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/data.ts
async function $0f7c5b1be99998e3$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}



var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/single-fetch.tsx
const $45db1c6124c1e415$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $45db1c6124c1e415$var$SingleFetchNoResultError = class extends Error {
};
const $45db1c6124c1e415$export$e35ccdcde387134d = new Set([
    100,
    101,
    204,
    205
]);
function $45db1c6124c1e415$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${(0, $c6f8fc82db0f6244$export$4cf11838cdc2a8a8)(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($45db1c6124c1e415$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $45db1c6124c1e415$export$77d7799427e365da(getRouter, manifest, routeModules, ssr) {
    let dataStrategy = $45db1c6124c1e415$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $45db1c6124c1e415$var$fetchAndDecodeViaTurboStream, ssr);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $45db1c6124c1e415$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $45db1c6124c1e415$var$singleFetchActionStrategy(args, fetchAndDecode);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $45db1c6124c1e415$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode);
        if (fetcherKey) return $45db1c6124c1e415$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode);
        return $45db1c6124c1e415$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut);
    };
}
async function $45db1c6124c1e415$var$singleFetchActionStrategy(args, fetchAndDecode) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        return await handler(async ()=>{
            let { data: data, status: status } = await fetchAndDecode(args, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $45db1c6124c1e415$var$unwrapSingleFetchResult(data, actionMatch.route.id);
        });
    });
    if ((0, $27ddc9c887d48115$export$3f1eb41d9a6a6a27)(result.result) || (0, $edf931d6dcac43ec$export$972111febbeef05b)(result.result) || (0, $27ddc9c887d48115$export$e0163cfdf7bc9cfa)(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: (0, $edf931d6dcac43ec$export$4051a07651545597)(result.result, actionStatus)
        }
    };
}
async function $45db1c6124c1e415$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data } = await fetchAndDecode(args, [
                        routeId
                    ]);
                    return $45db1c6124c1e415$var$unwrapSingleFetchResult(data, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $45db1c6124c1e415$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$45db1c6124c1e415$var$createDeferred());
    let singleFetchDfd = $45db1c6124c1e415$var$createDeferred();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            if (!m.shouldCallHandler(defaultShouldRevalidate)) {
                foundOptOutRoute ||= m.shouldRevalidateArgs != null && hasLoader;
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    results[routeId] = {
                        type: "data",
                        result: await handler(async ()=>{
                            let { data: data } = await fetchAndDecode(args, [
                                routeId
                            ]);
                            return $45db1c6124c1e415$var$unwrapSingleFetchResult(data, routeId);
                        })
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                results[routeId] = {
                    type: "data",
                    result: await handler(async ()=>{
                        return $45db1c6124c1e415$var$unwrapSingleFetchResult(await singleFetchDfd.promise, routeId);
                    })
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    if ((!router.state.initialized && router.state.navigation.state === "idle" || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data = await fetchAndDecode(args, targetRoutes);
            singleFetchDfd.resolve(data.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $45db1c6124c1e415$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $45db1c6124c1e415$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $45db1c6124c1e415$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $45db1c6124c1e415$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data } = await fetchAndDecode(args, [
                routeId
            ]);
            return $45db1c6124c1e415$var$unwrapSingleFetchResult(data, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $45db1c6124c1e415$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $45db1c6124c1e415$export$7b977381851b2c(reqUrl, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
    else url.pathname = `${url.pathname}.${extension}`;
    return url;
}
async function $45db1c6124c1e415$var$fetchAndDecodeViaTurboStream(args, targetRoutes) {
    let { request: request } = args;
    let url = $45db1c6124c1e415$export$7b977381851b2c(request.url, "data");
    if (request.method === "GET") {
        url = $45db1c6124c1e415$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await (0, $0f7c5b1be99998e3$export$a30aa2a0fce6c468)(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: 202,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($45db1c6124c1e415$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(res.body, "No response body to decode");
    try {
        let decoded = await $45db1c6124c1e415$export$4023ad4ecd4126a2(res.body, window);
        let data;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($45db1c6124c1e415$export$60644022b8b46aaa in typed) data = {
                redirect: typed[$45db1c6124c1e415$export$60644022b8b46aaa]
            };
            else data = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data = {
                redirect: typed
            };
            else data = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $45db1c6124c1e415$export$4023ad4ecd4126a2(body, global) {
    return (0, $7dbb8f88df69b2a1$export$2f872c0f2117be69)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && (0, $edf931d6dcac43ec$export$1a235bd2b33434e5).includes(name) && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data, status, statusText] = rest;
                    return {
                        value: new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(status, statusText, data)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$45db1c6124c1e415$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $45db1c6124c1e415$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace, status: status } = result.redirect;
        throw (0, $edf931d6dcac43ec$export$89e12c5b50f7529d)(location, {
            status: status,
            headers: {
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $45db1c6124c1e415$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $45db1c6124c1e415$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/errorBoundaries.tsx
var $75aa75cf49dc6413$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($75aa75cf49dc6413$export$20b33acd14692c9, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
/**
* When app's don't provide a root level ErrorBoundary, we default to this.
*/ function $75aa75cf49dc6413$export$20b33acd14692c9({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = (0, $baf242efa2d54ba7$export$17134ff624fc6bc2)();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ((0, $edf931d6dcac43ec$export$972111febbeef05b)(error)) return /* @__PURE__ */ $acw62.createElement($75aa75cf49dc6413$export$cf8626ebc6a4ba63, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($75aa75cf49dc6413$export$cf8626ebc6a4ba63, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $75aa75cf49dc6413$export$cf8626ebc6a4ba63({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = (0, $baf242efa2d54ba7$export$17134ff624fc6bc2)();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement((0, $baf242efa2d54ba7$export$ff0bf87698939488), null) : null)));
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/fallback.tsx
function $a7f36f18f4887f62$export$7e8143a7b6df36d9() {
    let { nonce: nonce } = (0, $baf242efa2d54ba7$export$17134ff624fc6bc2)();
    return /* @__PURE__ */ $acw62.createElement((0, $75aa75cf49dc6413$export$cf8626ebc6a4ba63), {
        title: "Loading...",
        renderScripts: true
    }, null);
}



var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/routes.tsx
function $aa520e004fa2ab60$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $aa520e004fa2ab60$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component = $aa520e004fa2ab60$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? (0, $a7f36f18f4887f62$export$7e8143a7b6df36d9) : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement((0, $75aa75cf49dc6413$export$20b33acd14692c9), {
            error: (0, $baf2581b6f4e4c0a$export$ed527bf60f6e05f2)()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component, null))
        } : {
            Component: Component
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $aa520e004fa2ab60$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $aa520e004fa2ab60$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$aa520e004fa2ab60$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $aa520e004fa2ab60$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $aa520e004fa2ab60$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $aa520e004fa2ab60$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $aa520e004fa2ab60$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $aa520e004fa2ab60$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let msg = `You are trying to call ${type === "action" ? "serverAction()" : "serverLoader()"} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(400, "Bad Request", new Error(msg), true);
    }
}
function $aa520e004fa2ab60$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(405, "Method Not Allowed", new Error(msg), true);
}
function $aa520e004fa2ab60$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $aa520e004fa2ab60$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $aa520e004fa2ab60$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route) {
            if (route.clientActionModule) prefetchModule(route.clientActionModule);
            if (route.clientLoaderModule) prefetchModule(route.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? (0, $bb47af95f14cb967$export$26f28bc6dfd6cfc6)(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$aa520e004fa2ab60$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $aa520e004fa2ab60$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                return await prefetchStylesAndCallHandler(async ()=>{
                    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $aa520e004fa2ab60$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
            };
            dataRoute.loader.hydrate = $aa520e004fa2ab60$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $aa520e004fa2ab60$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $aa520e004fa2ab60$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $aa520e004fa2ab60$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $aa520e004fa2ab60$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $aa520e004fa2ab60$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $aa520e004fa2ab60$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $aa520e004fa2ab60$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $aa520e004fa2ab60$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $aa520e004fa2ab60$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $aa520e004fa2ab60$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? (0, $edf931d6dcac43ec$export$d726f29eb2425705)(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $aa520e004fa2ab60$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $aa520e004fa2ab60$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = (0, $b7db53197255e154$export$d9c4a4e8105733a6)(route, routeModules);
    let prefetchRouteCssPromise = (0, $bb47af95f14cb967$export$2ee8f5601ba37b41)(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        (0, $bb47af95f14cb967$export$26f28bc6dfd6cfc6)(route, routeModule)
    ]);
    return {
        Component: $aa520e004fa2ab60$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $aa520e004fa2ab60$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    if (!(typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0)) return routeModule.default;
}
function $aa520e004fa2ab60$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}



var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/fog-of-war.ts
const $a41fcd44fe4543d6$var$nextPaths = /* @__PURE__ */ new Set();
const $a41fcd44fe4543d6$var$discoveredPathsMaxSize = 1e3;
const $a41fcd44fe4543d6$var$discoveredPaths = /* @__PURE__ */ new Set();
const $a41fcd44fe4543d6$export$b5915cf27fa06b9f = 7680;
function $a41fcd44fe4543d6$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $a41fcd44fe4543d6$export$741d98b28dbfd(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $a41fcd44fe4543d6$export$ae5150779dbcc11a({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = (0, $edf931d6dcac43ec$export$5c7b09132f833c25)(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $a41fcd44fe4543d6$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$a41fcd44fe4543d6$export$741d98b28dbfd(routeDiscovery, ssr)) return;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($a41fcd44fe4543d6$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $a41fcd44fe4543d6$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $a41fcd44fe4543d6$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$a41fcd44fe4543d6$export$741d98b28dbfd(routeDiscovery, ssr) || window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$a41fcd44fe4543d6$var$discoveredPaths.has(pathname)) $a41fcd44fe4543d6$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($a41fcd44fe4543d6$var$nextPaths.keys()).filter((path)=>{
                if ($a41fcd44fe4543d6$var$discoveredPaths.has(path)) {
                    $a41fcd44fe4543d6$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $a41fcd44fe4543d6$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $a41fcd44fe4543d6$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $a41fcd44fe4543d6$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
        basename,
        manifestPath
    ]);
}
const $a41fcd44fe4543d6$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $a41fcd44fe4543d6$export$2f7ce2790dc2d211(needsReload, version, errorReloadPath) {
    if (!needsReload) {
        try {
            sessionStorage.removeItem($a41fcd44fe4543d6$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        return false;
    }
    if (!errorReloadPath) {
        console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
        return true;
    }
    try {
        if (sessionStorage.getItem($a41fcd44fe4543d6$var$MANIFEST_VERSION_STORAGE_KEY) === version) {
            console.error("Unable to discover routes due to manifest version mismatch.");
            return true;
        }
        sessionStorage.setItem($a41fcd44fe4543d6$var$MANIFEST_VERSION_STORAGE_KEY, version);
    } catch  {}
    window.location.href = errorReloadPath;
    console.warn("Detected manifest version mismatch, reloading...");
    await new Promise(()=>{});
    return true;
}
async function $a41fcd44fe4543d6$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $a41fcd44fe4543d6$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($a41fcd44fe4543d6$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > 7680) {
        $a41fcd44fe4543d6$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        if (await $a41fcd44fe4543d6$export$2f7ce2790dc2d211(res.status === 204 && res.headers.has("X-Remix-Reload-Document"), manifest.version, errorReloadPath)) return;
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$a41fcd44fe4543d6$var$addToFifoQueue(p, $a41fcd44fe4543d6$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, (0, $aa520e004fa2ab60$export$af76e85f27ba0229)(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $a41fcd44fe4543d6$var$addToFifoQueue(path, queue) {
    if (queue.size >= $a41fcd44fe4543d6$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        if (first !== void 0) queue.delete(first);
    }
    queue.add(path);
}
function $a41fcd44fe4543d6$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}



var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/components.tsx
function $baf242efa2d54ba7$var$useDataRouterContext() {
    let context = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $baf242efa2d54ba7$var$useDataRouterStateContext() {
    let context = $acw62.useContext((0, $52882ad28a21bc0a$export$315e3ffb01f217));
    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
const $baf242efa2d54ba7$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$baf242efa2d54ba7$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $baf242efa2d54ba7$export$17134ff624fc6bc2() {
    let context = $acw62.useContext($baf242efa2d54ba7$export$208d6a3bc3aa62bd);
    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $baf242efa2d54ba7$export$6eb91431f5da407c(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($baf242efa2d54ba7$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: .5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $baf242efa2d54ba7$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $baf242efa2d54ba7$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $baf242efa2d54ba7$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $baf242efa2d54ba7$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $baf242efa2d54ba7$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $baf242efa2d54ba7$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $baf242efa2d54ba7$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$baf242efa2d54ba7$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
const $baf242efa2d54ba7$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
/**
* Renders all the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags created by the route module's [`links`](../../start/framework/route-module#links)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Links } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Links />
*       </head>
*       <body></body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {LinksProps.nonce} props.nonce n/a
* @param {LinksProps.crossOrigin} props.crossOrigin n/a
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $baf242efa2d54ba7$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let { errors: errors, matches: routerMatches } = $baf242efa2d54ba7$var$useDataRouterStateContext();
    let matches = $baf242efa2d54ba7$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>(0, $bb47af95f14cb967$export$c43eb07eab2c950a)(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $acw62.createElement("style", {
        [$baf242efa2d54ba7$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $acw62.createElement("link", {
        [$baf242efa2d54ba7$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>(0, $bb47af95f14cb967$export$aea1aca0de10baae)(link) ? /* @__PURE__ */ $acw62.createElement($baf242efa2d54ba7$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
/**
* Renders [`<link rel=prefetch|modulepreload>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel)
* tags for modules and data of another page to enable an instant navigation to
* that page. [`<Link prefetch>`](./Link#prefetch) uses this internally, but you
* can render it to prefetch a page for any other reason.
*
* For example, you may render one of this as the user types into a search field
* to prefetch search results before they click through to their selection.
*
* @example
* import { PrefetchPageLinks } from "react-router";
*
* <PrefetchPageLinks page="/absolute/path" />
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {PageLinkDescriptor.page} props.page n/a
* @param props.linkProps Additional props to spread onto the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/crossOrigin),
* [`integrity`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/integrity),
* [`rel`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel),
* etc.
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $baf242efa2d54ba7$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = (0, $52882ad28a21bc0a$export$6e1eeb090b3ec35b)();
    let { nonce: contextNonce } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let { router: router } = $baf242efa2d54ba7$var$useDataRouterContext();
    let matches = $acw62.useMemo(()=>(0, $edf931d6dcac43ec$export$2708184779ceb39d)(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $acw62.createElement($baf242efa2d54ba7$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $acw62.createElement($baf242efa2d54ba7$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $baf242efa2d54ba7$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        (0, $bb47af95f14cb967$export$98f31d7a23772264)(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $baf242efa2d54ba7$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = (0, $45db1c6124c1e415$export$7b977381851b2c)(page, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $baf242efa2d54ba7$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let { manifest: manifest, routeModules: routeModules } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let { loaderData: loaderData, matches: matches } = $baf242efa2d54ba7$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>(0, $bb47af95f14cb967$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>(0, $bb47af95f14cb967$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = (0, $45db1c6124c1e415$export$7b977381851b2c)(page, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>(0, $bb47af95f14cb967$export$442b9e023f41af00)(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $baf242efa2d54ba7$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>/* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
/**
* Renders all the [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags created by the route module's [`meta`](../../start/framework/route-module#meta)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Meta } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Meta />
*       </head>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @returns A collection of React elements for [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags
*/ function $baf242efa2d54ba7$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $baf242efa2d54ba7$var$useDataRouterStateContext();
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let _matches = $baf242efa2d54ba7$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            loaderData: data,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            loaderData: data,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$baf242efa2d54ba7$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ??= metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: (0, $c6f8fc82db0f6244$export$4cf11838cdc2a8a8)(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $baf242efa2d54ba7$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
/**
* Tracks whether hydration is finished, so scripts can be skipped
* during client-side updates.
*/ let $baf242efa2d54ba7$var$isHydrated = false;
function $baf242efa2d54ba7$export$3be068dde909e563() {
    $baf242efa2d54ba7$var$isHydrated = true;
}
/**
* Renders the client runtime of your app. It should be rendered inside the
* [`<body>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/body)
*  of the document.
*
* If server rendering, you can omit `<Scripts/>` and the app will work as a
* traditional web app without JavaScript, relying solely on HTML and browser
* behaviors.
*
* @example
* import { Scripts } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head />
*       <body>
*         <Scripts />
*       </body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param scriptProps Additional props to spread onto the [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement/crossOrigin),
* [`nonce`](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Global_attributes/nonce),
* etc.
* @returns A collection of React elements for [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags
*/ function $baf242efa2d54ba7$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let { router: router, static: isStatic, staticContext: staticContext } = $baf242efa2d54ba7$var$useDataRouterContext();
    let { matches: routerMatches } = $baf242efa2d54ba7$var$useDataRouterStateContext();
    let isRSCRouterContext = (0, $52882ad28a21bc0a$export$6e1eeb090b3ec35b)();
    let enableFogOfWar = (0, $a41fcd44fe4543d6$export$741d98b28dbfd)(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $baf242efa2d54ba7$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $baf242efa2d54ba7$export$3be068dde909e563();
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            return [
                chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n"),
                `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? `window.__reactRouterManifest = ${JSON.stringify((0, $a41fcd44fe4543d6$export$ae5150779dbcc11a)(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $baf242efa2d54ba7$var$isHydrated || isRSCRouterContext ? [] : [
        ...new Set(manifest.entry.imports.concat((0, $bb47af95f14cb967$export$442b9e023f41af00)(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    (0, $9cdee517b2ac63e9$export$5b28268982f175ba)(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $baf242efa2d54ba7$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $acw62.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $baf242efa2d54ba7$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}



var $acw62 = parcelRequire("acw62");
//#region lib/dom/lib.tsx
const $5cec2af50e95548c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($5cec2af50e95548c$var$isBrowser) window.__reactRouterVersion = "8.3.0";
} catch (e) {}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* and [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $5cec2af50e95548c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $27ddc9c887d48115$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $2ce80a7c58bedbaf$export$719fc203c4e16dee)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $5cec2af50e95548c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $edf931d6dcac43ec$export$6bc17138063be773),
        hydrationRouteProperties: $1b6caee6a6f10651$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $5cec2af50e95548c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $27ddc9c887d48115$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $2ce80a7c58bedbaf$export$b71fdd3798280242)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $5cec2af50e95548c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $edf931d6dcac43ec$export$6bc17138063be773),
        hydrationRouteProperties: $1b6caee6a6f10651$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $5cec2af50e95548c$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $5cec2af50e95548c$var$deserializeErrors(state.errors)
    };
    return state;
}
function $5cec2af50e95548c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries)if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(val.status, val.statusText, val.data, val.internal === true);
    else if (val && val.__type === "Error") {
        if (typeof val.__subType === "string" && (0, $edf931d6dcac43ec$export$1a235bd2b33434e5).includes(val.__subType)) {
            let ErrorConstructor = window[val.__subType];
            if (typeof ErrorConstructor === "function") try {
                let error = new ErrorConstructor(val.message);
                error.stack = "";
                serialized[key] = error;
            } catch (e) {}
        }
        if (serialized[key] == null) {
            let error = new Error(val.message);
            error.stack = "";
            serialized[key] = error;
        }
    } else serialized[key] = val;
    return serialized;
}
/**
* A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {BrowserRouterProps.basename} props.basename n/a
* @param {BrowserRouterProps.children} props.children n/a
* @param {BrowserRouterProps.useTransitions} props.useTransitions n/a
* @param {BrowserRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*/ function $5cec2af50e95548c$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $acw62.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $2ce80a7c58bedbaf$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement((0, $1b6caee6a6f10651$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores the location in the
* [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash) portion
* of the URL so it is not sent to the server.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HashRouterProps.basename} props.basename n/a
* @param {HashRouterProps.children} props.children n/a
* @param {HashRouterProps.useTransitions} props.useTransitions n/a
* @param {HashRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash)
* for client-side routing.
*/ function $5cec2af50e95548c$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $acw62.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $2ce80a7c58bedbaf$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement((0, $1b6caee6a6f10651$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that accepts a pre-instantiated
* `history` object.
* It's important to note that using your own `history` object is highly discouraged
* and may add two versions of the `history` library to your bundles unless you use
* the same version of the `history` library that React Router uses internally.
*
* @name unstable_HistoryRouter
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HistoryRouterProps.basename} props.basename n/a
* @param {HistoryRouterProps.children} props.children n/a
* @param {HistoryRouterProps.history} props.history n/a
* @param {HistoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative {@link Router | `<Router>`} using the provided history
* implementation for client-side routing.
*/ function $5cec2af50e95548c$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement((0, $1b6caee6a6f10651$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$5cec2af50e95548c$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
/**
* A progressively enhanced [`<a href>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a)
* wrapper to enable navigation with client-side routing.
*
* @example
* import { Link } from "react-router";
*
* <Link to="/dashboard">Dashboard</Link>;
*
* <Link
*   to={{
*     pathname: "/some/path",
*     search: "?query=string",
*     hash: "#hash",
*   }}
* />;
*
* @public
* @category Components
* @param {LinkProps.discover} props.discover [modes: framework] n/a
* @param {LinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {LinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {LinkProps.relative} props.relative n/a
* @param {LinkProps.reloadDocument} props.reloadDocument n/a
* @param {LinkProps.replace} props.replace n/a
* @param {LinkProps.state} props.state n/a
* @param {LinkProps.to} props.to n/a
* @param {LinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
* @param {LinkProps.defaultShouldRevalidate} props.defaultShouldRevalidate n/a
* @param {LinkProps.mask} props.mask [modes: framework, data] n/a
*/ const $5cec2af50e95548c$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let isAbsolute = typeof to === "string" && (0, $ee8fa670c1d03165$export$6c52c2011d568bd0).test(to);
    let parsed = (0, $edf931d6dcac43ec$export$ac5aeb949e84fd96)(to, basename);
    to = parsed.to;
    let href = (0, $baf2581b6f4e4c0a$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let maskedHref = null;
    if (mask) {
        let resolved = (0, $edf931d6dcac43ec$export$cae722b0cc860f13)(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = (0, $baf242efa2d54ba7$export$6eb91431f5da407c)(prefetch, rest);
    let internalOnClick = $5cec2af50e95548c$export$67621102c14d847(to, {
        replace: replace,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: (0, $baf242efa2d54ba7$export$c9058316764c140e)(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement((0, $baf242efa2d54ba7$export$60dcec93e67386bd), {
        page: href
    })) : link;
});
$5cec2af50e95548c$export$a6c7ac8248d6e38a.displayName = "Link";
/**
* Wraps {@link Link | `<Link>`} with additional props for styling active and
* pending states.
*
* - Automatically applies classes to the link based on its `active` and `pending`
* states, see {@link NavLinkProps.className}
*   - Note that `pending` is only available with Framework and Data modes.
* - Automatically applies `aria-current="page"` to the link when the link is active.
* See [`aria-current`](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-current)
* on MDN.
* - States are additionally available through the className, style, and children
* render props. See {@link NavLinkRenderProps}.
*
* @example
* <NavLink to="/message">Messages</NavLink>
*
* // Using render props
* <NavLink
*   to="/messages"
*   className={({ isActive, isPending }) =>
*     isPending ? "pending" : isActive ? "active" : ""
*   }
* >
*   Messages
* </NavLink>
*
* @public
* @category Components
* @param {NavLinkProps.caseSensitive} props.caseSensitive n/a
* @param {NavLinkProps.children} props.children n/a
* @param {NavLinkProps.className} props.className n/a
* @param {NavLinkProps.discover} props.discover [modes: framework] n/a
* @param {NavLinkProps.end} props.end n/a
* @param {NavLinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {NavLinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {NavLinkProps.relative} props.relative n/a
* @param {NavLinkProps.reloadDocument} props.reloadDocument n/a
* @param {NavLinkProps.replace} props.replace n/a
* @param {NavLinkProps.state} props.state n/a
* @param {NavLinkProps.style} props.style n/a
* @param {NavLinkProps.to} props.to n/a
* @param {NavLinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
*/ const $5cec2af50e95548c$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = (0, $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $52882ad28a21bc0a$export$315e3ffb01f217));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let isTransitioning = routerState != null && $5cec2af50e95548c$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(endSlashPosition) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($5cec2af50e95548c$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$5cec2af50e95548c$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
* A progressively enhanced HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form)
* that submits data to actions via [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/fetch),
* activating pending states in {@link useNavigation} which enables advanced
* user interfaces beyond a basic HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
* After a form's `action` completes, all data on the page is automatically
* revalidated to keep the UI in sync with the data.
*
* Because it uses the HTML form API, server rendered pages are interactive at a
* basic level before JavaScript loads. Instead of React Router managing the
* submission, the browser manages the submission as well as the pending states
* (like the spinning favicon). After JavaScript loads, React Router takes over
* enabling web application user experiences.
*
* `Form` is most useful for submissions that should also change the URL or
* otherwise add an entry to the browser history stack. For forms that shouldn't
* manipulate the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, use {@link FetcherWithComponents.Form | `<fetcher.Form>`}.
*
* @example
* import { Form } from "react-router";
*
* function NewEvent() {
*   return (
*     <Form action="/events" method="post">
*       <input name="title" type="text" />
*       <input name="description" type="text" />
*     </Form>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param {FormProps.action} action n/a
* @param {FormProps.discover} discover n/a
* @param {FormProps.encType} encType n/a
* @param {FormProps.fetcherKey} fetcherKey n/a
* @param {FormProps.method} method n/a
* @param {FormProps.navigate} navigate n/a
* @param {FormProps.preventScrollReset} preventScrollReset n/a
* @param {FormProps.relative} relative n/a
* @param {FormProps.reloadDocument} reloadDocument n/a
* @param {FormProps.replace} replace n/a
* @param {FormProps.state} state n/a
* @param {FormProps.viewTransition} viewTransition n/a
* @param {FormProps.defaultShouldRevalidate} defaultShouldRevalidate n/a
* @returns A progressively enhanced [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) component
*/ const $5cec2af50e95548c$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = "get", action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let submit = $5cec2af50e95548c$export$47c85c6e3a081d3();
    let formAction = $5cec2af50e95548c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && (0, $ee8fa670c1d03165$export$6c52c2011d568bd0).test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $acw62.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$5cec2af50e95548c$export$a7fed597f4b8afd8.displayName = "Form";
/**
* Emulates the browser's scroll restoration on location changes. Apps should only render one of these, right before the {@link Scripts} component.
*
* ```tsx
* import { ScrollRestoration } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <body>
*         <ScrollRestoration />
*         <Scripts />
*       </body>
*     </html>
*   );
* }
* ```
*
* This component renders an inline `<script>` to prevent scroll flashing. The
* `nonce` prop will be passed down to the script tag to allow CSP nonce usage.
* If not provided in Framework Mode, it will default to any
* {@link ServerRouter | `<ServerRouter nonce>`} prop.
*
* ```tsx
* <ScrollRestoration nonce={cspNonce} />
* ```
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {ScrollRestorationProps.getKey} props.getKey n/a
* @param {ScriptsProps.nonce} props.nonce n/a
* @param {ScrollRestorationProps.storageKey} props.storageKey n/a
* @returns A [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tag that restores scroll positions on navigation.
*/ function $5cec2af50e95548c$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext((0, $baf242efa2d54ba7$export$208d6a3bc3aa62bd));
    let { basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let matches = (0, $baf2581b6f4e4c0a$export$2378eb7f5ff86053)();
    $5cec2af50e95548c$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $5cec2af50e95548c$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let storedY = JSON.parse(sessionStorage.getItem(storageKey) || "{}")[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${(0, $c6f8fc82db0f6244$export$4cf11838cdc2a8a8)(JSON.stringify(storageKey || $5cec2af50e95548c$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${(0, $c6f8fc82db0f6244$export$4cf11838cdc2a8a8)(JSON.stringify(ssrKey))})`
        }
    });
}
$5cec2af50e95548c$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $5cec2af50e95548c$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $5cec2af50e95548c$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(ctx, $5cec2af50e95548c$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $5cec2af50e95548c$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $52882ad28a21bc0a$export$315e3ffb01f217));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(state, $5cec2af50e95548c$var$getDataRouterConsoleError(hookName));
    return state;
}
/**
* Handles the click behavior for router {@link Link | `<Link>`} components.This
* is useful if you need to create custom {@link Link | `<Link>`} components with
* the same click behavior we use in our exported {@link Link | `<Link>`}.
*
* @public
* @category Hooks
* @param to The URL to navigate to, can be a string or a partial {@link Path}.
* @param options Options
* @param options.preventScrollReset Whether to prevent the scroll position from
* being reset to the top of the viewport on completion of the navigation when
* using the {@link ScrollRestoration} component. Defaults to `false`.
* @param options.relative The {@link RelativeRoutingType | relative routing type}
* to use for the link. Defaults to `"route"`.
* @param options.replace Whether to replace the current [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry instead of pushing a new one. Defaults to `false`.
* @param options.state The state to add to the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry for this navigation. Defaults to `undefined`.
* @param options.target The target attribute for the link. Defaults to `undefined`.
* @param options.viewTransition Enables a [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* for this navigation. To apply specific styles during the transition, see
* {@link useViewTransitionState}. Defaults to `false`.
* @param options.defaultShouldRevalidate Specify the default revalidation
* behavior for the navigation. When not specified, loaders revalidate
* according to the router's standard revalidation behavior.
* @param options.mask Masked location to display in the browser instead
* of the router location. Defaults to `undefined`.
* @param options.useTransitions Wraps the navigation in
* [`React.startTransition`](https://react.dev/reference/react/startTransition)
* for concurrent rendering. Defaults to `false`.
* @returns A click handler function that can be used in a custom {@link Link} component.
*/ function $5cec2af50e95548c$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let path = (0, $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ((0, $89bbb3f5cea75f10$export$4c2d35dce1b682e)(event, target)) {
            event.preventDefault();
            let replace = replaceProp !== void 0 ? replaceProp : (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(location) === (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $acw62.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
/**
* Returns a tuple of the current URL's [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them. Setting the search params causes a navigation.
*
* ```tsx
* import { useSearchParams } from "react-router";
*
* export function SomeComponent() {
*   const [searchParams, setSearchParams] = useSearchParams();
*   // ...
* }
* ```
*
* ### `setSearchParams` function
*
* The second element of the tuple is a function that can be used to update the
* search params. It accepts the same types as `defaultInit` and will cause a
* navigation to the new URL.
*
* ```tsx
* let [searchParams, setSearchParams] = useSearchParams();
*
* // a search param string
* setSearchParams("?tab=1");
*
* // a shorthand object
* setSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* setSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* setSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* setSearchParams(new URLSearchParams("?tab=1"));
* ```
*
* It also supports a function callback like React's
* [`setState`](https://react.dev/reference/react/useState#setstate):
*
* ```tsx
* setSearchParams((searchParams) => {
*   searchParams.set("tab", "2");
*   return searchParams;
* });
* ```
*
* <docs-warning>The function callback version of `setSearchParams` does not support
* the [queueing](https://react.dev/reference/react/useState#setstate-parameters)
* logic that React's `setState` implements.  Multiple calls to `setSearchParams`
* in the same tick will not build on the prior value.  If you need this behavior,
* you can use `setState` manually.</docs-warning>
*
* ### Notes
*
* Note that `searchParams` is a stable reference, so you can reliably use it
* as a dependency in React's [`useEffect`](https://react.dev/reference/react/useEffect)
* hooks.
*
* ```tsx
* useEffect(() => {
*   console.log(searchParams.get("tab"));
* }, [searchParams]);
* ```
*
* However, this also means it's mutable. If you change the object without
* calling `setSearchParams`, its values will change between renders if some
* other state causes the component to re-render and URL will not reflect the
* values.
*
* @public
* @category Hooks
* @param defaultInit
* You can initialize the search params with a default value, though it **will
* not** change the URL on the first render.
*
* ```tsx
* // a search param string
* useSearchParams("?tab=1");
*
* // a shorthand object
* useSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* useSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* useSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* useSearchParams(new URLSearchParams("?tab=1"));
* ```
* @returns A tuple of the current [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them.
*/ function $5cec2af50e95548c$export$f1a78c17382fe22a(defaultInit) {
    (0, $2ce80a7c58bedbaf$export$491112666e282270)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    let defaultSearchParamsRef = $acw62.useRef((0, $89bbb3f5cea75f10$export$a2e4e2dcc7b1f22f)(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>(0, $89bbb3f5cea75f10$export$4370c962fe3096e6)(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    return [
        searchParams,
        $acw62.useCallback((nextInit, navigateOptions)=>{
            const newSearchParams = (0, $89bbb3f5cea75f10$export$a2e4e2dcc7b1f22f)(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
            hasSetSearchParamsRef.current = true;
            navigate("?" + newSearchParams, navigateOptions);
        }, [
            navigate,
            searchParams
        ])
    ];
}
let $5cec2af50e95548c$var$fetcherId = 0;
let $5cec2af50e95548c$var$getUniqueFetcherId = ()=>`__${String(++$5cec2af50e95548c$var$fetcherId)}__`;
/**
* The imperative version of {@link Form | `<Form>`} that lets you submit a form
* from code instead of a user interaction.
*
* @example
* import { useSubmit } from "react-router";
*
* function SomeComponent() {
*   const submit = useSubmit();
*   return (
*     <Form onChange={(event) => submit(event.currentTarget)} />
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns A function that can be called to submit a {@link Form} imperatively.
*/ function $5cec2af50e95548c$export$47c85c6e3a081d3() {
    let { router: router } = $5cec2af50e95548c$var$useDataRouterContext("useSubmit");
    let { basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let currentRouteId = (0, $baf2581b6f4e4c0a$export$4200b254756b08af)();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = (0, $89bbb3f5cea75f10$export$80917616746b9ab4)(target, basename);
        if (options.navigate === false) await routerFetch(options.fetcherKey || $5cec2af50e95548c$var$getUniqueFetcherId(), currentRouteId, options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            flushSync: options.flushSync
        });
        else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
/**
* Resolves the URL to the closest route in the component hierarchy instead of
* the current URL of the app.
*
* This is used internally by {@link Form} to resolve the `action` to the closest
* route, but can be used generically as well.
*
* ```ts
* import { useFormAction } from "react-router";
*
* function SomeComponent() {
*   // closest route URL
*   let action = useFormAction();
*
*   // closest route URL + "destroy"
*   let destroyAction = useFormAction("destroy");
* }
* ```
*
* <docs-info>This hook adds a `basename` if your app specifies one, so that it
* can be used with raw `<form>` elements in a progressively enhanced way.  If
* you are using this to provide an `action` to `<Form>` or `fetcher.submit`, you
* will need to remove the `basename` since both of those will prepend it
* internally.</docs-info>
*
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param action The action to append to the closest route URL. Defaults to the
* closest route URL.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* action. Defaults to `"route"`.
* @returns The resolved action URL.
*/ function $5cec2af50e95548c$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let routeContext = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...(0, $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b)(action ? action : ".", {
            relative: relative
        })
    };
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        if (indexValues.some((v)=>v === "")) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(path);
}
/**
* Useful for creating complex, dynamic user interfaces that require multiple,
* concurrent data interactions without causing a navigation.
*
* Fetchers track their own, independent state and can be used to load data, submit
* forms, and generally interact with [`action`](../../start/framework/route-module#action)
* and [`loader`](../../start/framework/route-module#loader) functions.
*
* @example
* import { useFetcher } from "react-router"
*
* function SomeComponent() {
*   let fetcher = useFetcher()
*
*   // states are available on the fetcher
*   fetcher.state // "idle" | "loading" | "submitting"
*   fetcher.data // the data returned from the action or loader
*
*   // render a form
*   <fetcher.Form method="post" />
*
*   // load data
*   fetcher.load("/some/route")
*
*   // submit data
*   fetcher.submit(someFormRef, { method: "post" })
*   fetcher.submit(someData, {
*     method: "post",
*     encType: "application/json"
*   })
*
*   // reset fetcher
*   fetcher.reset()
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.key A unique key to identify the fetcher.
*
*
* By default, `useFetcher` generates a unique fetcher scoped to that component.
* If you want to identify a fetcher with your own key such that you can access
* it from elsewhere in your app, you can do that with the `key` option:
*
* ```tsx
* function SomeComp() {
*   let fetcher = useFetcher({ key: "my-key" })
*   // ...
* }
*
* // Somewhere else
* function AnotherComp() {
*   // this will be the same fetcher, sharing the state across the app
*   let fetcher = useFetcher({ key: "my-key" });
*   // ...
* }
* ```
* @returns A {@link FetcherWithComponents} object that contains the fetcher's state, data, and components for submitting forms and loading data.
*/ function $5cec2af50e95548c$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $5cec2af50e95548c$var$useDataRouterContext("useFetcher");
    let state = $5cec2af50e95548c$var$useDataRouterState("useFetcher");
    let fetcherData = $acw62.useContext((0, $52882ad28a21bc0a$export$cb3f1df1bef00a39));
    let route = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(fetcherData, `useFetcher must be used inside a FetchersContext`);
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(route, `useFetcher must be used inside a RouteContext`);
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $acw62.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $5cec2af50e95548c$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $acw62.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($5cec2af50e95548c$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || (0, $27ddc9c887d48115$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    return $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data
    ]);
}
/**
* Returns an array of all in-flight {@link Fetcher}s. This is useful for components
* throughout the app that didn't create the fetchers but want to use their submissions
* to participate in optimistic UI.
*
* @example
* import { useFetchers } from "react-router";
*
* function SomeComponent() {
*   const fetchers = useFetchers();
*   fetchers[0].formData; // FormData
*   fetchers[0].state; // etc.
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of all in-flight {@link Fetcher}s, each with a unique `key`
* property.
*/ function $5cec2af50e95548c$export$fa996778a3a31087() {
    let state = $5cec2af50e95548c$var$useDataRouterState("useFetchers");
    return $acw62.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
const $5cec2af50e95548c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $5cec2af50e95548c$var$savedScrollPositions = {};
function $5cec2af50e95548c$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
/**
* When rendered inside a {@link RouterProvider}, will restore scroll positions
* on navigations
*
* <!--
* Not marked `@public` because we only export as UNSAFE_ and therefore we don't
* maintain an .md file for this hook
* -->
*
* @name UNSAFE_useScrollRestoration
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.getKey A function that returns a key to use for scroll restoration.
* This is useful for custom scroll restoration logic, such as using only the pathname
* so that subsequent navigations to prior paths will restore the scroll. Defaults
* to `location.key`.
* @param options.storageKey The key to use for storing scroll positions in
* `sessionStorage`. Defaults to `"react-router-scroll-positions"`.
* @returns {void}
*/ function $5cec2af50e95548c$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $5cec2af50e95548c$var$useDataRouterContext("useScrollRestoration");
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $5cec2af50e95548c$var$useDataRouterState("useScrollRestoration");
    let { basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let matches = (0, $baf2581b6f4e4c0a$export$2378eb7f5ff86053)();
    let navigation = (0, $baf2581b6f4e4c0a$export$d0fd4b7106de2769)();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $5cec2af50e95548c$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $5cec2af50e95548c$var$getScrollRestorationKey(location, matches, basename, getKey);
            $5cec2af50e95548c$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $5cec2af50e95548c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($5cec2af50e95548c$var$savedScrollPositions));
        } catch (error) {
            (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $5cec2af50e95548c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $5cec2af50e95548c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($5cec2af50e95548c$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location, matches)=>$5cec2af50e95548c$var$getScrollRestorationKey(location, matches, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
* Set up a callback to be fired on [Window's `beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event).
*
* @public
* @category Hooks
* @param callback The callback to be called when the [`beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event)
* is fired.
* @param options Options
* @param options.capture If `true`, the event will be captured during the capture
* phase. Defaults to `false`.
* @returns {void}
*/ function $5cec2af50e95548c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $5cec2af50e95548c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
* Wrapper around {@link useBlocker} to show a [`window.confirm`](https://developer.mozilla.org/en-US/docs/Web/API/Window/confirm)
* prompt to users instead of building a custom UI with {@link useBlocker}.
*
* The `unstable_` flag will not be removed because this technique has a lot of
* rough edges and behaves very differently (and incorrectly sometimes) across
* browsers if users click addition back/forward navigations while the
* confirmation is open. Use at your own risk.
*
* @example
* function ImportantForm() {
*   let [value, setValue] = React.useState("");
*
*   // Block navigating elsewhere when data has been entered into the input
*   unstable_usePrompt({
*     message: "Are you sure?",
*     when: ({ currentLocation, nextLocation }) =>
*       value !== "" &&
*       currentLocation.pathname !== nextLocation.pathname,
*   });
*
*   return (
*     <Form method="post">
*       <label>
*         Enter some important data:
*         <input
*           name="data"
*           value={value}
*           onChange={(e) => setValue(e.target.value)}
*         />
*       </label>
*       <button type="submit">Save</button>
*     </Form>
*   );
* }
*
* @name unstable_usePrompt
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.message The message to show in the confirmation dialog.
* @param options.when A boolean or a function that returns a boolean indicating
* whether to block the navigation. If a function is provided, it will receive an
* object with `currentLocation` and `nextLocation` properties.
* @returns {void}
*/ function $5cec2af50e95548c$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = (0, $baf2581b6f4e4c0a$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            if (window.confirm(message)) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
* This hook returns `true` when there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the specified location matches either side of the navigation (the URL you are
* navigating **to** or the URL you are navigating **from**). This can be used to apply finer-grained styles to
* elements to further customize the view transition. This requires that view
* transitions have been enabled for the given navigation via {@link LinkProps.viewTransition}
* (or the `Form`, `submit`, or `navigate` call)
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param to The {@link To} location to compare against the active transition's current
* and next URLs.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* `to` location, defaults to `"route"`. See {@link RelativeRoutingType} for
* more details.
* @returns `true` if there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the resolved path matches the transition's destination or source pathname, otherwise `false`.
*/ function $5cec2af50e95548c$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $acw62.useContext((0, $52882ad28a21bc0a$export$3681f408decb40d1));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(vtContext != null, "`useViewTransitionState` must be used within `react-router/dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $5cec2af50e95548c$var$useDataRouterContext("useViewTransitionState");
    let path = (0, $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return (0, $edf931d6dcac43ec$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $edf931d6dcac43ec$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $acw62 = parcelRequire("acw62");











"use client";
//#region packages/@mantine/core/src/components/ActionIcon/ActionIcon.module.css
var $26a2a5a3efbc7af7$export$2e2bcd8739ae039 = {
    "root": "m_8d3f4000",
    "icon": "m_8d3afb97",
    "loader": "m_302b9fb1",
    "group": "m_1a0f1b21",
    "groupSection": "m_437b6484"
};










"use client";
//#region packages/@mantine/core/src/components/ActionIcon/ActionIconGroup/ActionIconGroup.tsx
const $0d9419fe2f9f5fd3$var$defaultProps = {
    orientation: "horizontal"
};
const $0d9419fe2f9f5fd3$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { borderWidth: borderWidth })=>({
        group: {
            "--ai-border-width": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(borderWidth)
        }
    }));
const $0d9419fe2f9f5fd3$export$e0bcefd5d6a90b2f = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ActionIconGroup", $0d9419fe2f9f5fd3$var$defaultProps, _props);
    const { className: className, style: style, classNames: classNames, styles: styles, unstyled: unstyled, orientation: orientation, vars: vars, borderWidth: borderWidth, variant: variant, mod: mod, attributes: attributes, ...others } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...(0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
            name: "ActionIconGroup",
            props: props,
            classes: (0, $26a2a5a3efbc7af7$export$2e2bcd8739ae039),
            className: className,
            style: style,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            attributes: attributes,
            vars: vars,
            varsResolver: $0d9419fe2f9f5fd3$var$varsResolver,
            rootSelector: "group"
        })("group"),
        variant: variant,
        mod: [
            {
                "data-orientation": orientation
            },
            mod
        ],
        role: "group",
        ...others
    });
});
$0d9419fe2f9f5fd3$export$e0bcefd5d6a90b2f.classes = (0, $26a2a5a3efbc7af7$export$2e2bcd8739ae039);
$0d9419fe2f9f5fd3$export$e0bcefd5d6a90b2f.varsResolver = $0d9419fe2f9f5fd3$var$varsResolver;
$0d9419fe2f9f5fd3$export$e0bcefd5d6a90b2f.displayName = "@mantine/core/ActionIconGroup";










"use client";
//#region packages/@mantine/core/src/components/ActionIcon/ActionIconGroupSection/ActionIconGroupSection.tsx
const $49f18ff94b8aea48$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { radius: radius, color: color, gradient: gradient, variant: variant, autoContrast: autoContrast, size: size })=>{
    const colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme: theme,
        gradient: gradient,
        variant: variant || "filled",
        autoContrast: autoContrast
    });
    return {
        groupSection: {
            "--section-height": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "section-height"),
            "--section-padding-x": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "section-padding-x"),
            "--section-fz": (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--section-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--section-bg": color || variant ? colors.background : void 0,
            "--section-color": colors.color,
            "--section-bd": color || variant ? colors.border : void 0
        }
    };
});
const $49f18ff94b8aea48$export$805bb4e67f6cc760 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ActionIconGroupSection", null, _props);
    const { className: className, style: style, classNames: classNames, styles: styles, unstyled: unstyled, vars: vars, variant: variant, gradient: gradient, radius: radius, autoContrast: autoContrast, attributes: attributes, ...others } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...(0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
            name: "ActionIconGroupSection",
            props: props,
            classes: (0, $26a2a5a3efbc7af7$export$2e2bcd8739ae039),
            className: className,
            style: style,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            attributes: attributes,
            vars: vars,
            varsResolver: $49f18ff94b8aea48$var$varsResolver,
            rootSelector: "groupSection"
        })("groupSection"),
        variant: variant,
        ...others
    });
});
$49f18ff94b8aea48$export$805bb4e67f6cc760.classes = (0, $26a2a5a3efbc7af7$export$2e2bcd8739ae039);
$49f18ff94b8aea48$export$805bb4e67f6cc760.varsResolver = $49f18ff94b8aea48$var$varsResolver;
$49f18ff94b8aea48$export$805bb4e67f6cc760.displayName = "@mantine/core/ActionIconGroupSection";



"use client";
//#region packages/@mantine/core/src/components/ActionIcon/ActionIcon.tsx
const $5eeb3c9a10486755$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { size: size, radius: radius, variant: variant, gradient: gradient, color: color, autoContrast: autoContrast })=>{
    const colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme: theme,
        gradient: gradient,
        variant: variant || "filled",
        autoContrast: autoContrast
    });
    return {
        root: {
            "--ai-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "ai-size"),
            "--ai-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--ai-bg": color || variant ? colors.background : void 0,
            "--ai-hover": color || variant ? colors.hover : void 0,
            "--ai-hover-color": color || variant ? colors.hoverColor : void 0,
            "--ai-color": colors.color,
            "--ai-bd": color || variant ? colors.border : void 0
        }
    };
});
const $5eeb3c9a10486755$export$c8e5c1392561c508 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ActionIcon", null, _props);
    const { className: className, unstyled: unstyled, variant: variant, classNames: classNames, styles: styles, style: style, loading: loading, loaderProps: loaderProps, size: size, color: color, radius: radius, __staticSelector: __staticSelector, gradient: gradient, vars: vars, children: children, disabled: disabled, "data-disabled": dataDisabled, autoContrast: autoContrast, mod: mod, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: [
            "ActionIcon",
            __staticSelector
        ],
        props: props,
        className: className,
        style: style,
        classes: (0, $26a2a5a3efbc7af7$export$2e2bcd8739ae039),
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $5eeb3c9a10486755$var$varsResolver
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), {
        ...getStyles("root", {
            active: !disabled && !loading && !dataDisabled
        }),
        "aria-busy": loading || void 0,
        ...others,
        unstyled: unstyled,
        variant: variant,
        size: size,
        disabled: disabled || loading,
        mod: [
            {
                loading: loading,
                disabled: disabled || dataDisabled
            },
            mod
        ],
        children: [
            typeof loading === "boolean" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4e0d3c4af0891b98$export$be58926105124dd4), {
                mounted: loading,
                transition: "slide-down",
                duration: 150,
                children: (transitionStyles)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                        component: "span",
                        ...getStyles("loader", {
                            style: transitionStyles
                        }),
                        "aria-hidden": true,
                        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f943dfe4129424c6$export$3b0d6d7590275603), {
                            color: "var(--ai-color)",
                            size: "calc(var(--ai-size) * 0.55)",
                            ...loaderProps
                        })
                    })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                component: "span",
                mod: {
                    loading: loading
                },
                ...getStyles("icon"),
                children: children
            })
        ]
    });
});
$5eeb3c9a10486755$export$c8e5c1392561c508.classes = (0, $26a2a5a3efbc7af7$export$2e2bcd8739ae039);
$5eeb3c9a10486755$export$c8e5c1392561c508.varsResolver = $5eeb3c9a10486755$var$varsResolver;
$5eeb3c9a10486755$export$c8e5c1392561c508.displayName = "@mantine/core/ActionIcon";
$5eeb3c9a10486755$export$c8e5c1392561c508.Group = (0, $0d9419fe2f9f5fd3$export$e0bcefd5d6a90b2f);
$5eeb3c9a10486755$export$c8e5c1392561c508.GroupSection = (0, $49f18ff94b8aea48$export$805bb4e67f6cc760);








"use client";
//#region packages/@mantine/core/src/components/Badge/Badge.module.css
var $b3f0be63582d4bcd$export$2e2bcd8739ae039 = {
    "root": "m_347db0ec",
    "root--dot": "m_fbd81e3d",
    "label": "m_5add502a",
    "section": "m_91fdda9b"
};



"use client";
//#region packages/@mantine/core/src/components/Badge/Badge.tsx
const $b24692670674b261$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { radius: radius, color: color, gradient: gradient, variant: variant, size: size, autoContrast: autoContrast, circle: circle })=>{
    const colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme: theme,
        gradient: gradient,
        variant: variant || "filled",
        autoContrast: autoContrast
    });
    return {
        root: {
            "--badge-height": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "badge-height"),
            "--badge-padding-x": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "badge-padding-x"),
            "--badge-fz": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "badge-fz"),
            "--badge-radius": circle || radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--badge-bg": color || variant ? colors.background : void 0,
            "--badge-color": color || variant ? colors.color : void 0,
            "--badge-bd": color || variant ? colors.border : void 0,
            "--badge-dot-color": variant === "dot" ? (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(color, theme) : void 0
        }
    };
});
const $b24692670674b261$export$37acb3580601e69a = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Badge", null, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, radius: radius, color: color, gradient: gradient, leftSection: leftSection, rightSection: rightSection, children: children, variant: variant, fullWidth: fullWidth, autoContrast: autoContrast, circle: circle, mod: mod, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Badge",
        props: props,
        classes: (0, $b3f0be63582d4bcd$export$2e2bcd8739ae039),
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $b24692670674b261$var$varsResolver
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        variant: variant,
        mod: [
            {
                block: fullWidth,
                circle: circle,
                "with-right-section": !!rightSection,
                "with-left-section": !!leftSection
            },
            mod
        ],
        ...getStyles("root", {
            variant: variant
        }),
        ...others,
        children: [
            leftSection && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...getStyles("section"),
                "data-position": "left",
                children: leftSection
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...getStyles("label"),
                children: children
            }),
            rightSection && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...getStyles("section"),
                "data-position": "right",
                children: rightSection
            })
        ]
    });
});
$b24692670674b261$export$37acb3580601e69a.classes = (0, $b3f0be63582d4bcd$export$2e2bcd8739ae039);
$b24692670674b261$export$37acb3580601e69a.varsResolver = $b24692670674b261$var$varsResolver;
$b24692670674b261$export$37acb3580601e69a.displayName = "@mantine/core/Badge";

"use client";
//#region packages/@mantine/core/src/core/utils/find-element-ancestor/find-element-ancestor.ts
function $2c8b9d23474a2600$export$3d0f3f5781bcdc48(element, selector) {
    let _element = element;
    while((_element = _element.parentElement) && !_element.matches(selector));
    return _element;
}


"use client";
//#region packages/@mantine/core/src/core/utils/get-context-item-index/get-context-item-index.ts
function $ec739097b6605e9b$export$b6cd2ea9779a9a9a(elementSelector, parentSelector, node) {
    if (!node) return null;
    return Array.from((0, $2c8b9d23474a2600$export$3d0f3f5781bcdc48)(node, parentSelector)?.querySelectorAll(elementSelector) || []).findIndex((element)=>element === node);
}






"use client";
//#region packages/@mantine/core/src/core/styles-api/use-resolved-styles-api/use-resolved-styles-api.ts
function $3da94ce37793f66c$export$92dc9b0c0bd35ec0({ classNames: classNames, styles: styles, props: props, stylesCtx: stylesCtx }) {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    return {
        resolvedClassNames: classNames === void 0 ? void 0 : (0, $ba12a721d32e28d3$export$7df0003ea9a4d3a4)({
            theme: theme,
            classNames: classNames,
            props: props,
            stylesCtx: stylesCtx || void 0
        }),
        resolvedStyles: styles === void 0 ? void 0 : (0, $d9501d38e7649221$export$5376e124e9154c53)({
            theme: theme,
            styles: styles,
            props: props,
            stylesCtx: stylesCtx || void 0
        })
    };
}





var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/utils/Floating/use-delayed-hover.ts
function $408ab93e040f8067$export$7771a820816ce7f1({ open: open, close: close, openDelay: openDelay, closeDelay: closeDelay }) {
    const openTimeout = (0, $acw62.useRef)(-1);
    const closeTimeout = (0, $acw62.useRef)(-1);
    const clearTimeouts = ()=>{
        window.clearTimeout(openTimeout.current);
        window.clearTimeout(closeTimeout.current);
    };
    const openDropdown = ()=>{
        clearTimeouts();
        if (openDelay === 0 || openDelay === void 0) open();
        else openTimeout.current = window.setTimeout(open, openDelay);
    };
    const closeDropdown = ()=>{
        clearTimeouts();
        if (closeDelay === 0 || closeDelay === void 0) close();
        else closeTimeout.current = window.setTimeout(close, closeDelay);
    };
    (0, $acw62.useEffect)(()=>clearTimeouts, []);
    return {
        openDropdown: openDropdown,
        closeDropdown: closeDropdown
    };
}










"use client";
//#region packages/@mantine/core/src/utils/Floating/get-floating-position/get-floating-position.ts
function $f1fa51258cb44e6e$export$950b4922bb2f6bc6(dir, position) {
    if (dir === "rtl" && (position.includes("right") || position.includes("left"))) {
        const [side, placement] = position.split("-");
        const flippedPosition = side === "right" ? "left" : "right";
        return placement === void 0 ? flippedPosition : `${flippedPosition}-${placement}`;
    }
    return position;
}






"use client";
//#region packages/@mantine/core/src/components/Popover/Popover.context.ts
const [$74f44c98474c2c98$export$f5300fbf692a63ec, $74f44c98474c2c98$export$1468d0761b26e6c8] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("Popover component was not found in the tree");





"use client";
//#region packages/@mantine/core/src/core/utils/create-event-handler/create-event-handler.ts
function $528465f85c56cc6b$export$48d1ea6320830260(parentEventHandler, eventHandler) {
    return (event)=>{
        parentEventHandler?.(event);
        eventHandler?.(event);
    };
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-long-press/use-long-press.ts
const $18fe32c00c294bcc$var$DEFAULT_EVENTS = [
    "mouse",
    "touch"
];
const $18fe32c00c294bcc$var$DEFAULT_MOVE_THRESHOLD = 10;
function $18fe32c00c294bcc$export$c24ed0104d07eab9(onLongPress, options = {}) {
    const { threshold: threshold = 400, events: events = $18fe32c00c294bcc$var$DEFAULT_EVENTS, cancelOnMove: cancelOnMove = false, onStart: onStart, onFinish: onFinish, onCancel: onCancel } = options;
    const isLongPressActive = (0, $acw62.useRef)(false);
    const isPressed = (0, $acw62.useRef)(false);
    const timeout = (0, $acw62.useRef)(-1);
    const startPosition = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>()=>window.clearTimeout(timeout.current), []);
    return (0, $acw62.useMemo)(()=>{
        if (typeof onLongPress !== "function") return {};
        const moveEnabled = cancelOnMove !== false;
        const moveThreshold = cancelOnMove === true ? $18fe32c00c294bcc$var$DEFAULT_MOVE_THRESHOLD : cancelOnMove === false ? 0 : cancelOnMove;
        const start = (event)=>{
            if (!$18fe32c00c294bcc$var$isMouseEvent(event) && !$18fe32c00c294bcc$var$isTouchEvent(event)) return;
            if (onStart) onStart(event);
            startPosition.current = $18fe32c00c294bcc$var$getEventPosition(event);
            isPressed.current = true;
            timeout.current = window.setTimeout(()=>{
                onLongPress(event);
                isLongPressActive.current = true;
            }, threshold);
        };
        const cancel = (event)=>{
            if (!$18fe32c00c294bcc$var$isMouseEvent(event) && !$18fe32c00c294bcc$var$isTouchEvent(event)) return;
            if (isLongPressActive.current) {
                if (onFinish) onFinish(event);
            } else if (isPressed.current) {
                if (onCancel) onCancel(event);
            }
            isLongPressActive.current = false;
            isPressed.current = false;
            startPosition.current = null;
            if (timeout.current !== -1) {
                window.clearTimeout(timeout.current);
                timeout.current = -1;
            }
        };
        const move = (event)=>{
            if (!moveEnabled || !isPressed.current || isLongPressActive.current) return;
            const position = $18fe32c00c294bcc$var$getEventPosition(event);
            if (!position || !startPosition.current) return;
            const dx = position.x - startPosition.current.x;
            const dy = position.y - startPosition.current.y;
            if (Math.sqrt(dx * dx + dy * dy) > moveThreshold) cancel(event);
        };
        const handlers = {};
        if (events.includes("mouse")) {
            handlers.onMouseDown = start;
            handlers.onMouseUp = cancel;
            handlers.onMouseLeave = cancel;
            if (moveEnabled) handlers.onMouseMove = move;
        }
        if (events.includes("touch")) {
            handlers.onTouchStart = start;
            handlers.onTouchEnd = cancel;
            handlers.onTouchCancel = cancel;
            if (moveEnabled) handlers.onTouchMove = move;
        }
        return handlers;
    }, [
        onLongPress,
        threshold,
        onCancel,
        onFinish,
        onStart,
        cancelOnMove,
        events.join(",")
    ]);
}
function $18fe32c00c294bcc$var$getEventPosition(event) {
    if ($18fe32c00c294bcc$var$isTouchEvent(event)) {
        const touch = event.touches[0] ?? event.changedTouches[0];
        return touch ? {
            x: touch.clientX,
            y: touch.clientY
        } : null;
    }
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $18fe32c00c294bcc$var$isTouchEvent(event) {
    return window.TouchEvent ? event.nativeEvent instanceof TouchEvent : "touches" in event.nativeEvent;
}
function $18fe32c00c294bcc$var$isMouseEvent(event) {
    return event.nativeEvent instanceof MouseEvent;
}


"use client";
//#region packages/@mantine/core/src/utils/Floating/use-context-menu-handlers.ts
function $a1e85b714a9eb32c$export$d6f5131b955d9374({ childProps: childProps, disabled: disabled, opened: opened, longPressDelay: longPressDelay = 500, setReference: setReference, open: open }) {
    const touchActiveRef = (0, $acw62.useRef)(false);
    const gestureHandledRef = (0, $acw62.useRef)(false);
    const touchTargetRef = (0, $acw62.useRef)(null);
    const disabledRef = (0, $acw62.useRef)(disabled);
    disabledRef.current = disabled;
    const openAtPoint = (clientX, clientY, contextElement)=>{
        setReference({
            getBoundingClientRect: ()=>({
                    x: clientX,
                    y: clientY,
                    width: 0,
                    height: 0,
                    top: clientY,
                    left: clientX,
                    right: clientX,
                    bottom: clientY,
                    toJSON: ()=>void 0
                }),
            contextElement: contextElement
        });
        open();
    };
    const onMouseDown = (0, $528465f85c56cc6b$export$48d1ea6320830260)(childProps.onMouseDown, (event)=>{
        if (disabled) return;
        if (event.button === 2) event.stopPropagation();
    });
    const onContextMenu = (0, $528465f85c56cc6b$export$48d1ea6320830260)(childProps.onContextMenu, (event)=>{
        if (disabled || event.defaultPrevented) return;
        event.preventDefault();
        if (gestureHandledRef.current) return;
        openAtPoint(event.clientX, event.clientY, event.currentTarget);
        if (touchActiveRef.current) gestureHandledRef.current = true;
    });
    const longPressHandlers = (0, $18fe32c00c294bcc$export$c24ed0104d07eab9)((event)=>{
        if (disabledRef.current || gestureHandledRef.current) return;
        const touchEvent = event;
        const touch = touchEvent.touches[0] ?? touchEvent.changedTouches[0];
        if (!touch) return;
        openAtPoint(touch.clientX, touch.clientY, touchTargetRef.current);
        gestureHandledRef.current = true;
    }, {
        threshold: longPressDelay,
        events: [
            "touch"
        ],
        cancelOnMove: true,
        onStart: (event)=>{
            touchActiveRef.current = true;
            gestureHandledRef.current = false;
            touchTargetRef.current = event.currentTarget;
        },
        onFinish: (event)=>{
            touchActiveRef.current = false;
            gestureHandledRef.current = false;
            if (!disabledRef.current) event.preventDefault();
        },
        onCancel: ()=>{
            touchActiveRef.current = false;
            gestureHandledRef.current = false;
        }
    });
    return {
        onContextMenu: onContextMenu,
        onMouseDown: onMouseDown,
        onTouchStart: (0, $528465f85c56cc6b$export$48d1ea6320830260)(childProps.onTouchStart, longPressHandlers.onTouchStart),
        onTouchEnd: (0, $528465f85c56cc6b$export$48d1ea6320830260)(childProps.onTouchEnd, longPressHandlers.onTouchEnd),
        onTouchCancel: (0, $528465f85c56cc6b$export$48d1ea6320830260)(childProps.onTouchCancel, longPressHandlers.onTouchCancel),
        onTouchMove: (0, $528465f85c56cc6b$export$48d1ea6320830260)(childProps.onTouchMove, longPressHandlers.onTouchMove),
        style: disabled ? childProps.style : {
            ...childProps.style,
            WebkitTouchCallout: "none",
            WebkitUserSelect: "none",
            userSelect: "none"
        },
        "data-expanded": opened ? true : void 0
    };
}



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/components/Popover/PopoverContextMenu/PopoverContextMenu.tsx
function $62cac8d5482abc3d$export$bb17859a2be78797(props) {
    const { children: children, disabled: disabled, longPressDelay: longPressDelay } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("PopoverContextMenu", null, props);
    const child = (0, $fc5f5fc6d9909a8d$export$1fd9bef6809ad57c)(children);
    if (!child) throw new Error("Popover.ContextMenu component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    const ctx = (0, $74f44c98474c2c98$export$1468d0761b26e6c8)();
    return (0, $acw62.cloneElement)(child, (0, $a1e85b714a9eb32c$export$d6f5131b955d9374)({
        childProps: child.props,
        disabled: disabled || ctx.disabled,
        opened: ctx.opened,
        longPressDelay: longPressDelay,
        setReference: ctx.reference,
        open: ()=>{
            if (!ctx.opened) ctx.onToggle();
        }
    }));
}
$62cac8d5482abc3d$export$bb17859a2be78797.displayName = "@mantine/core/PopoverContextMenu";


"use client";
//#region packages/@mantine/core/src/components/Popover/Popover.module.css
var $ddfa993246a665fb$export$2e2bcd8739ae039 = {
    "dropdown": "m_38a85659",
    "arrow": "m_a31dc6c1",
    "overlay": "m_3d7bc908"
};



"use client";
//#region packages/@mantine/core/src/core/utils/noop/noop.ts
const $203042273dcf69c8$export$8793edee2d425525 = ()=>{};


"use client";
//#region packages/@mantine/core/src/core/utils/close-on-escape/close-on-escape.ts
function $f9102fe801bfca5d$export$902efad8ff1933eb(callback, options = {
    active: true
}) {
    if (typeof callback !== "function" || !options.active) return options.onKeyDown || (0, $203042273dcf69c8$export$8793edee2d425525);
    return (event)=>{
        if (event.key === "Escape") {
            callback(event);
            options.onTrigger?.();
        }
    };
}






"use client";
//#region packages/@mantine/core/src/utils/Floating/FloatingArrow/get-arrow-position-styles.ts
function $1f6bb031670a6c5f$var$horizontalSide(placement, arrowY, arrowOffset, arrowPosition) {
    if (placement === "center" || arrowPosition === "center") return {
        top: arrowY
    };
    if (placement === "end") return {
        bottom: arrowOffset
    };
    if (placement === "start") return {
        top: arrowOffset
    };
    return {};
}
function $1f6bb031670a6c5f$var$verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir) {
    if (placement === "center" || arrowPosition === "center") return {
        left: arrowX
    };
    if (placement === "end") return {
        [dir === "ltr" ? "right" : "left"]: arrowOffset
    };
    if (placement === "start") return {
        [dir === "ltr" ? "left" : "right"]: arrowOffset
    };
    return {};
}
const $1f6bb031670a6c5f$var$radiusByFloatingSide = {
    bottom: "borderTopLeftRadius",
    left: "borderTopRightRadius",
    right: "borderBottomLeftRadius",
    top: "borderBottomRightRadius"
};
function $1f6bb031670a6c5f$var$getMergeArrowStyles({ position: position, arrowSize: arrowSize, dir: dir }) {
    const [side, placement] = position.split("-");
    if (!placement) return;
    const baseStyles = {
        width: arrowSize,
        height: arrowSize,
        position: "absolute"
    };
    if (side === "bottom") {
        const isStart = placement === "start";
        const physicalSide = isStart ? dir === "ltr" ? "left" : "right" : dir === "ltr" ? "right" : "left";
        return {
            ...baseStyles,
            top: -arrowSize,
            [physicalSide]: 0,
            clipPath: isStart !== (dir === "rtl") ? "polygon(0% 0%, 0% 100%, 100% 100%)" : "polygon(100% 0%, 0% 100%, 100% 100%)"
        };
    }
    if (side === "top") {
        const isStart = placement === "start";
        const physicalSide = isStart ? dir === "ltr" ? "left" : "right" : dir === "ltr" ? "right" : "left";
        return {
            ...baseStyles,
            bottom: -arrowSize,
            [physicalSide]: 0,
            clipPath: isStart !== (dir === "rtl") ? "polygon(0% 0%, 100% 0%, 0% 100%)" : "polygon(0% 0%, 100% 0%, 100% 100%)"
        };
    }
    if (side === "left") return {
        ...baseStyles,
        right: -arrowSize,
        [placement === "start" ? "top" : "bottom"]: 0,
        clipPath: placement === "start" ? "polygon(0% 0%, 100% 0%, 0% 100%)" : "polygon(0% 0%, 0% 100%, 100% 100%)"
    };
    if (side === "right") return {
        ...baseStyles,
        left: -arrowSize,
        [placement === "start" ? "top" : "bottom"]: 0,
        clipPath: placement === "start" ? "polygon(0% 0%, 100% 0%, 100% 100%)" : "polygon(100% 0%, 0% 100%, 100% 100%)"
    };
}
function $1f6bb031670a6c5f$export$1b8d75826ae84e20({ position: position, arrowSize: arrowSize, arrowOffset: arrowOffset, arrowRadius: arrowRadius, arrowPosition: arrowPosition, arrowX: arrowX, arrowY: arrowY, dir: dir }) {
    if (arrowPosition === "merge") {
        const mergeStyles = $1f6bb031670a6c5f$var$getMergeArrowStyles({
            position: position,
            arrowSize: arrowSize,
            dir: dir
        });
        if (mergeStyles) return mergeStyles;
    }
    const [side, placement = "center"] = position.split("-");
    const baseStyles = {
        width: arrowSize,
        height: arrowSize,
        transform: "rotate(45deg)",
        position: "absolute",
        [$1f6bb031670a6c5f$var$radiusByFloatingSide[side]]: arrowRadius
    };
    const arrowPlacement = -arrowSize / 2;
    if (side === "left") return {
        ...baseStyles,
        ...$1f6bb031670a6c5f$var$horizontalSide(placement, arrowY, arrowOffset, arrowPosition),
        right: arrowPlacement,
        borderLeftColor: "transparent",
        borderBottomColor: "transparent",
        clipPath: "polygon(100% 0, 0 0, 100% 100%)"
    };
    if (side === "right") return {
        ...baseStyles,
        ...$1f6bb031670a6c5f$var$horizontalSide(placement, arrowY, arrowOffset, arrowPosition),
        left: arrowPlacement,
        borderRightColor: "transparent",
        borderTopColor: "transparent",
        clipPath: "polygon(0 100%, 0 0, 100% 100%)"
    };
    if (side === "top") return {
        ...baseStyles,
        ...$1f6bb031670a6c5f$var$verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir),
        bottom: arrowPlacement,
        borderTopColor: "transparent",
        borderLeftColor: "transparent",
        clipPath: "polygon(0 100%, 100% 100%, 100% 0)"
    };
    if (side === "bottom") return {
        ...baseStyles,
        ...$1f6bb031670a6c5f$var$verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir),
        top: arrowPlacement,
        borderBottomColor: "transparent",
        borderRightColor: "transparent",
        clipPath: "polygon(0 100%, 0 0, 100% 0)"
    };
    return {};
}
function $1f6bb031670a6c5f$export$8c97a2febfe9fadf({ position: position, dir: dir }) {
    const [side, placement] = position.split("-");
    if (!placement) return;
    const isPhysicallyLeft = placement === "start" && dir === "ltr" || placement === "end" && dir === "rtl";
    if (side === "bottom") return isPhysicallyLeft ? {
        borderTopLeftRadius: 0
    } : {
        borderTopRightRadius: 0
    };
    if (side === "top") return isPhysicallyLeft ? {
        borderBottomLeftRadius: 0
    } : {
        borderBottomRightRadius: 0
    };
    if (side === "left") return placement === "start" ? {
        borderTopRightRadius: 0
    } : {
        borderBottomRightRadius: 0
    };
    if (side === "right") return placement === "start" ? {
        borderTopLeftRadius: 0
    } : {
        borderBottomLeftRadius: 0
    };
}





"use client";
//#region packages/@mantine/core/src/utils/Floating/FloatingArrow/FloatingArrow.tsx
function $ae8d40c368b113dd$export$33511391554732bc({ position: position, arrowSize: arrowSize, arrowOffset: arrowOffset, arrowRadius: arrowRadius, arrowPosition: arrowPosition, visible: visible, arrowX: arrowX, arrowY: arrowY, style: style, ...others }) {
    const { dir: dir } = (0, $35c57ac18e24a61d$export$b39126d51d94e6f3)();
    if (!visible) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "presentation",
        ...others,
        style: {
            ...style,
            ...(0, $1f6bb031670a6c5f$export$1b8d75826ae84e20)({
                position: position,
                arrowSize: arrowSize,
                arrowOffset: arrowOffset,
                arrowRadius: arrowRadius,
                arrowPosition: arrowPosition,
                dir: dir,
                arrowX: arrowX,
                arrowY: arrowY
            })
        }
    });
}
$ae8d40c368b113dd$export$33511391554732bc.displayName = "@mantine/core/FloatingArrow";









"use client";
//#region packages/@mantine/core/src/components/Popover/PopoverDropdown/PopoverDropdown.tsx
const $c6c02060e092d07e$export$bc4cee0d3f11c45d = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("PopoverDropdown", null, _props);
    const { className: className, style: style, vars: vars, children: children, onKeyDownCapture: onKeyDownCapture, variant: variant, classNames: classNames, styles: styles, ref: ref, ...others } = props;
    const ctx = (0, $74f44c98474c2c98$export$1468d0761b26e6c8)();
    const { dir: dir } = (0, $35c57ac18e24a61d$export$b39126d51d94e6f3)();
    const mergeStyles = ctx.arrowPosition === "merge" && ctx.withArrow ? (0, $1f6bb031670a6c5f$export$8c97a2febfe9fadf)({
        position: ctx.placement,
        dir: dir
    }) : void 0;
    const returnFocus = (0, $f4823e3369c057aa$export$275f09232623ff6f)({
        opened: ctx.opened,
        shouldReturnFocus: ctx.returnFocus
    });
    const accessibleProps = ctx.withRoles ? {
        "aria-labelledby": ctx.getTargetId(),
        id: ctx.getDropdownId(),
        role: "dialog",
        tabIndex: -1
    } : {};
    const mergedRef = (0, $7034a45159125c0b$export$36a55fa7500f01f)(ref, ctx.floating);
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c40c05f34c6cea16$export$425106c5d6e6dc37), {
        ...ctx.portalProps,
        withinPortal: ctx.withinPortal,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4e0d3c4af0891b98$export$be58926105124dd4), {
            mounted: ctx.opened,
            ...ctx.transitionProps,
            transition: ctx.transitionProps?.transition || "fade",
            duration: ctx.transitionProps?.duration ?? 150,
            keepMounted: ctx.keepMounted,
            keepMountedMode: ctx.keepMountedMode,
            exitDuration: typeof ctx.transitionProps?.exitDuration === "number" ? ctx.transitionProps.exitDuration : ctx.transitionProps?.duration,
            children: (transitionStyles)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $78545dc889974525$export$34eba2437817a67b), {
                    active: ctx.trapFocus && ctx.opened,
                    innerRef: mergedRef,
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                        ...accessibleProps,
                        ...others,
                        variant: variant,
                        onKeyDownCapture: (0, $f9102fe801bfca5d$export$902efad8ff1933eb)(()=>{
                            ctx.onClose?.();
                            ctx.onDismiss?.();
                        }, {
                            active: ctx.closeOnEscape,
                            onTrigger: returnFocus,
                            onKeyDown: onKeyDownCapture
                        }),
                        "data-position": ctx.placement,
                        "data-fixed": ctx.floatingStrategy === "fixed" || void 0,
                        ...ctx.getStyles("dropdown", {
                            className: className,
                            props: props,
                            classNames: classNames,
                            styles: styles,
                            style: [
                                {
                                    ...transitionStyles,
                                    ...mergeStyles,
                                    zIndex: ctx.zIndex,
                                    top: ctx.y ?? 0,
                                    left: ctx.x ?? 0,
                                    width: ctx.width === "target" ? void 0 : (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(ctx.width),
                                    ...ctx.referenceHidden ? {
                                        display: "none"
                                    } : null
                                },
                                ctx.resolvedStyles?.dropdown,
                                styles?.dropdown,
                                style
                            ]
                        }),
                        children: [
                            children,
                            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ae8d40c368b113dd$export$33511391554732bc), {
                                ref: ctx.arrowRef,
                                arrowX: ctx.arrowX,
                                arrowY: ctx.arrowY,
                                visible: ctx.withArrow,
                                position: ctx.placement,
                                arrowSize: ctx.arrowSize,
                                arrowRadius: ctx.arrowRadius,
                                arrowOffset: ctx.arrowOffset,
                                arrowPosition: ctx.arrowPosition,
                                ...ctx.getStyles("arrow", {
                                    props: props,
                                    classNames: classNames,
                                    styles: styles
                                })
                            })
                        ]
                    })
                })
        })
    });
});
$c6c02060e092d07e$export$bc4cee0d3f11c45d.classes = (0, $ddfa993246a665fb$export$2e2bcd8739ae039);
$c6c02060e092d07e$export$bc4cee0d3f11c45d.displayName = "@mantine/core/PopoverDropdown";



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/core/utils/get-ref-prop/get-ref-prop.ts
function $9cf39e3b273a94ee$export$4f7e0d2799f89885(element) {
    const version = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version;
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version !== "string") return element?.ref;
    if (version.startsWith("18.")) return element?.ref;
    return element?.props?.ref;
}







var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/Popover/PopoverTarget/PopoverTarget.tsx
const $a8854574e99469aa$var$defaultProps = {
    refProp: "ref",
    popupType: "dialog"
};
const $a8854574e99469aa$export$5ad0c0856b469f13 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props)=>{
    const { children: children, refProp: refProp, popupType: popupType, ref: ref, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("PopoverTarget", $a8854574e99469aa$var$defaultProps, props);
    const child = (0, $fc5f5fc6d9909a8d$export$1fd9bef6809ad57c)(children);
    if (!child) throw new Error("Popover.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    const forwardedProps = others;
    const ctx = (0, $74f44c98474c2c98$export$1468d0761b26e6c8)();
    const targetRef = (0, $7034a45159125c0b$export$36a55fa7500f01f)(ctx.reference, (0, $9cf39e3b273a94ee$export$4f7e0d2799f89885)(child), ref);
    const accessibleProps = ctx.withRoles ? {
        "aria-haspopup": popupType,
        "aria-expanded": ctx.opened,
        "aria-controls": ctx.opened ? ctx.getDropdownId() : void 0,
        id: ctx.getTargetId()
    } : {};
    const childProps = child.props;
    return (0, $acw62.cloneElement)(child, {
        ...forwardedProps,
        ...accessibleProps,
        ...ctx.targetProps,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(ctx.targetProps.className, forwardedProps.className, childProps.className),
        [refProp]: targetRef,
        ...!ctx.controlled ? {
            onClick: (event)=>{
                ctx.onToggle();
                childProps.onClick?.(event);
            }
        } : null
    });
});
$a8854574e99469aa$export$5ad0c0856b469f13.displayName = "@mantine/core/PopoverTarget";



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-uncontrolled/use-uncontrolled.ts
function $4197894a742d9f84$export$ec55e9daaf703a7d({ value: value, defaultValue: defaultValue, finalValue: finalValue, onChange: onChange = ()=>{} }) {
    const [uncontrolledValue, setUncontrolledValue] = (0, $acw62.useState)(defaultValue !== void 0 ? defaultValue : finalValue);
    const handleUncontrolledChange = (val, ...payload)=>{
        setUncontrolledValue(val);
        onChange?.(val, ...payload);
    };
    if (value !== void 0) return [
        value,
        onChange,
        true
    ];
    return [
        uncontrolledValue,
        handleUncontrolledChange,
        false
    ];
}



"use client";
//#region packages/@mantine/core/src/components/Popover/use-popover.ts
function $c63cfc7636e0b51f$var$getDefaultMiddlewares(middlewares) {
    if (middlewares === void 0) return {
        shift: true,
        flip: true
    };
    const result = {
        ...middlewares
    };
    if (middlewares.shift === void 0) result.shift = true;
    if (middlewares.flip === void 0) result.flip = true;
    return result;
}
function $c63cfc7636e0b51f$var$getPopoverMiddlewares(options, getFloating, disableFlip, lockEnabled) {
    const middlewaresOptions = $c63cfc7636e0b51f$var$getDefaultMiddlewares(options.middlewares);
    const middlewares = [
        (0, $4cdaae7c2a5f3f0d$export$cc800923e997bb8)(options.offset),
        (0, $4cdaae7c2a5f3f0d$export$fe8985bb6374093c)()
    ];
    if (middlewaresOptions.flip && !disableFlip) {
        const userFlip = typeof middlewaresOptions.flip === "boolean" ? {} : middlewaresOptions.flip;
        const flipOptions = lockEnabled ? {
            fallbackStrategy: "initialPlacement",
            ...userFlip
        } : userFlip;
        middlewares.push((0, $4cdaae7c2a5f3f0d$export$8a83211c878a3f1f)(flipOptions));
    }
    if (middlewaresOptions.shift) {
        const shiftOptions = typeof middlewaresOptions.shift === "boolean" ? {} : middlewaresOptions.shift;
        middlewares.push((0, $4cdaae7c2a5f3f0d$export$fba63a578e423eb)((state)=>{
            const isVerticalPlacement = state.placement.startsWith("top") || state.placement.startsWith("bottom");
            return {
                limiter: (0, $4cdaae7c2a5f3f0d$export$7bf07e38f3dc4b69)(),
                padding: 5,
                ...options.width === "target" && isVerticalPlacement ? {
                    mainAxis: false
                } : null,
                ...shiftOptions
            };
        }));
    }
    if (middlewaresOptions.inline) middlewares.push(typeof middlewaresOptions.inline === "boolean" ? (0, $4cdaae7c2a5f3f0d$export$18c8ad048e32c7d5)() : (0, $4cdaae7c2a5f3f0d$export$18c8ad048e32c7d5)(middlewaresOptions.inline));
    middlewares.push((0, $4cdaae7c2a5f3f0d$export$f2120bbfa5450bd2)({
        element: options.arrowRef,
        padding: options.arrowOffset
    }));
    if (middlewaresOptions.size || options.width === "target") middlewares.push((0, $4cdaae7c2a5f3f0d$export$346677f925de839c)({
        ...typeof middlewaresOptions.size === "boolean" ? {} : middlewaresOptions.size,
        apply ({ rects: rects, availableWidth: availableWidth, availableHeight: availableHeight, ...rest }) {
            const styles = getFloating().refs.floating.current?.style ?? {};
            if (middlewaresOptions.size) {
                if (typeof middlewaresOptions.size === "object" && !!middlewaresOptions.size.apply) middlewaresOptions.size.apply({
                    rects: rects,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight,
                    ...rest
                });
                else Object.assign(styles, {
                    maxWidth: `${availableWidth}px`,
                    maxHeight: `${availableHeight}px`
                });
            }
            if (options.width === "target") Object.assign(styles, {
                width: `${rects.reference.width}px`
            });
        }
    }));
    return middlewares;
}
function $c63cfc7636e0b51f$export$542a6fd13ac93354(options) {
    const [_opened, setOpened] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: options.opened,
        defaultValue: options.defaultOpened,
        finalValue: false,
        onChange: options.onChange
    });
    const previouslyOpened = (0, $acw62.useRef)(_opened);
    const [lockedPlacement, setLockedPlacement] = (0, $acw62.useState)(null);
    const lockEnabled = options.preventPositionChangeWhenVisible !== false;
    const wasOpenedRef = (0, $acw62.useRef)(_opened);
    if (_opened !== wasOpenedRef.current) {
        wasOpenedRef.current = _opened;
        if (_opened && lockedPlacement !== null) setLockedPlacement(null);
    }
    const resetLockedPlacement = (0, $acw62.useCallback)(()=>setLockedPlacement(null), []);
    const onClose = ()=>{
        if (_opened && !options.disabled) setOpened(false);
    };
    const onToggle = ()=>{
        if (!options.disabled) setOpened(!_opened);
    };
    const floating = (0, $1923ad12705fb717$export$4e02a5c1d08bac65)({
        open: _opened,
        strategy: options.strategy,
        placement: lockEnabled ? lockedPlacement ?? options.position : options.position,
        middleware: $c63cfc7636e0b51f$var$getPopoverMiddlewares(options, ()=>floating, lockEnabled && lockedPlacement !== null, lockEnabled),
        whileElementsMounted: !options.keepMounted ? (0, $bede215d88ec3aee$export$deee3a793edee05f) : void 0
    });
    (0, $acw62.useEffect)(()=>{
        if (!options.keepMounted) return;
        const referenceElement = floating.refs.reference.current;
        const floatingElement = floating.refs.floating.current;
        if (_opened && referenceElement && floatingElement) return (0, $bede215d88ec3aee$export$deee3a793edee05f)(referenceElement, floatingElement, floating.update);
    }, [
        options.keepMounted,
        _opened,
        floating.update,
        floating.elements.reference,
        floating.elements.floating
    ]);
    const measuredAfterShowRef = (0, $acw62.useRef)(false);
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        if (!_opened) {
            measuredAfterShowRef.current = false;
            return;
        }
        if (!lockEnabled || lockedPlacement !== null) return;
        const flEl = floating.refs.floating.current;
        if (!flEl || flEl.offsetHeight === 0 || flEl.offsetWidth === 0) return;
        if (!measuredAfterShowRef.current) {
            measuredAfterShowRef.current = true;
            floating.update();
            return;
        }
        if (floating.isPositioned) setLockedPlacement(floating.placement);
    }, [
        lockEnabled,
        _opened,
        floating.isPositioned,
        floating.placement,
        lockedPlacement,
        floating.update
    ]);
    const previousPlacementRef = (0, $acw62.useRef)(floating.placement);
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        if (previousPlacementRef.current !== floating.placement) {
            previousPlacementRef.current = floating.placement;
            options.onPositionChange?.(floating.placement);
        }
    }, [
        floating.placement
    ]);
    (0, $d9273517323905a9$export$e34ed88fef4dc107)(()=>{
        if (_opened !== previouslyOpened.current) {
            if (!_opened) options.onClose?.();
            else options.onOpen?.();
        }
        previouslyOpened.current = _opened;
    }, [
        _opened,
        options.onClose,
        options.onOpen
    ]);
    return {
        floating: floating,
        controlled: typeof options.opened === "boolean",
        opened: _opened,
        onClose: onClose,
        onToggle: onToggle,
        resetLockedPlacement: resetLockedPlacement
    };
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-click-outside/use-click-outside.ts
const $cacf5a31c84dd481$var$DEFAULT_EVENTS = [
    "mousedown",
    "touchstart"
];
function $cacf5a31c84dd481$export$1896bab46732d207(callback, events, nodes, enabled = true) {
    const ref = (0, $acw62.useRef)(null);
    const eventsList = events || $cacf5a31c84dd481$var$DEFAULT_EVENTS;
    const listener = (0, $acw62.useEffectEvent)((event)=>{
        const { target: target } = event ?? {};
        if (!document.body.contains(target) && target?.tagName !== "HTML") return;
        const path = event.composedPath();
        if (Array.isArray(nodes)) nodes.every((node)=>!!node && !path.includes(node)) && callback(event);
        else if (ref.current && !path.includes(ref.current)) callback(event);
    });
    const eventsKey = eventsList.join(",");
    (0, $acw62.useEffect)(()=>{
        if (!enabled) return;
        const events = eventsKey.split(",");
        events.forEach((fn)=>document.addEventListener(fn, listener));
        return ()=>{
            events.forEach((fn)=>document.removeEventListener(fn, listener));
        };
    }, [
        eventsKey,
        enabled
    ]);
    return ref;
}



"use client";
//#region packages/@mantine/core/src/components/Popover/Popover.tsx
const $4c321a5e1b48bbbf$var$defaultProps = {
    position: "bottom",
    offset: 8,
    transitionProps: {
        transition: "fade",
        duration: 150
    },
    middlewares: {
        flip: true,
        shift: true,
        inline: false
    },
    arrowSize: 7,
    arrowOffset: 5,
    arrowRadius: 0,
    arrowPosition: "side",
    closeOnClickOutside: true,
    withinPortal: true,
    closeOnEscape: true,
    trapFocus: false,
    withRoles: true,
    returnFocus: false,
    withOverlay: false,
    hideDetached: true,
    preventPositionChangeWhenVisible: true,
    clickOutsideEvents: [
        "mousedown",
        "touchstart"
    ],
    zIndex: (0, $f4b868e08831abbf$export$65573e7d509c92dc)("popover"),
    __staticSelector: "Popover",
    width: "max-content"
};
const $4c321a5e1b48bbbf$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { radius: radius, shadow: shadow })=>({
        dropdown: {
            "--popover-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--popover-shadow": (0, $fcab4af601ce7e99$export$db93b77dbb14f011)(shadow)
        }
    }));
function $4c321a5e1b48bbbf$export$5b6b19405a83ff9d(_props) {
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Popover", $4c321a5e1b48bbbf$var$defaultProps, _props);
    const { children: children, position: position, offset: offset, onPositionChange: onPositionChange, opened: opened, transitionProps: transitionProps, onExitTransitionEnd: onExitTransitionEnd, onEnterTransitionEnd: onEnterTransitionEnd, width: width, middlewares: middlewares, withArrow: withArrow, arrowSize: arrowSize, arrowOffset: arrowOffset, arrowRadius: arrowRadius, arrowPosition: arrowPosition, unstyled: unstyled, classNames: classNames, styles: styles, closeOnClickOutside: closeOnClickOutside, withinPortal: withinPortal, portalProps: portalProps, closeOnEscape: closeOnEscape, clickOutsideEvents: clickOutsideEvents, trapFocus: trapFocus, onClose: onClose, onDismiss: onDismiss, onOpen: onOpen, onChange: onChange, zIndex: zIndex, radius: radius, shadow: shadow, id: id, defaultOpened: defaultOpened, __staticSelector: __staticSelector, withRoles: withRoles, disabled: disabled, returnFocus: returnFocus, variant: variant, keepMounted: keepMounted, keepMountedMode: keepMountedMode, vars: vars, floatingStrategy: floatingStrategy, withOverlay: withOverlay, overlayProps: overlayProps, hideDetached: hideDetached, attributes: attributes, preventPositionChangeWhenVisible: preventPositionChangeWhenVisible, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: __staticSelector,
        props: props,
        classes: (0, $ddfa993246a665fb$export$2e2bcd8739ae039),
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        rootSelector: "dropdown",
        vars: vars,
        varsResolver: $4c321a5e1b48bbbf$var$varsResolver
    });
    const { resolvedStyles: resolvedStyles } = (0, $3da94ce37793f66c$export$92dc9b0c0bd35ec0)({
        classNames: classNames,
        styles: styles,
        props: props
    });
    const arrowRef = (0, $acw62.useRef)(null);
    const [targetNode, setTargetNode] = (0, $acw62.useState)(null);
    const [dropdownNode, setDropdownNode] = (0, $acw62.useState)(null);
    const { dir: dir } = (0, $35c57ac18e24a61d$export$b39126d51d94e6f3)();
    const env = (0, $bbb97275c373484a$export$2a0cf0a5fd0c6e81)();
    const uid = (0, $cee42e5537afff93$export$f680877a34711e37)(id);
    const popover = (0, $c63cfc7636e0b51f$export$542a6fd13ac93354)({
        middlewares: middlewares,
        width: width,
        position: (0, $f1fa51258cb44e6e$export$950b4922bb2f6bc6)(dir, position),
        offset: typeof offset === "number" ? offset + (withArrow ? arrowSize / 2 : 0) : offset,
        arrowRef: arrowRef,
        arrowOffset: arrowOffset,
        onPositionChange: onPositionChange,
        opened: opened,
        defaultOpened: defaultOpened,
        onChange: onChange,
        onOpen: onOpen,
        onClose: onClose,
        onDismiss: onDismiss,
        strategy: floatingStrategy,
        disabled: disabled,
        preventPositionChangeWhenVisible: preventPositionChangeWhenVisible,
        keepMounted: keepMounted
    });
    (0, $cacf5a31c84dd481$export$1896bab46732d207)(()=>{
        if (closeOnClickOutside) {
            popover.onClose();
            onDismiss?.();
        }
    }, clickOutsideEvents, [
        targetNode,
        dropdownNode
    ]);
    const reference = (0, $acw62.useCallback)((node)=>{
        setTargetNode(node);
        popover.floating.refs.setReference(node);
    }, [
        popover.floating.refs.setReference
    ]);
    const floating = (0, $acw62.useCallback)((node)=>{
        setDropdownNode(node);
        popover.floating.refs.setFloating(node);
    }, [
        popover.floating.refs.setFloating
    ]);
    const onExited = (0, $acw62.useCallback)(()=>{
        transitionProps?.onExited?.();
        onExitTransitionEnd?.();
        popover.resetLockedPlacement();
    }, [
        transitionProps?.onExited,
        onExitTransitionEnd,
        popover.resetLockedPlacement
    ]);
    const onEntered = (0, $acw62.useCallback)(()=>{
        transitionProps?.onEntered?.();
        onEnterTransitionEnd?.();
    }, [
        transitionProps?.onEntered,
        onEnterTransitionEnd
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $74f44c98474c2c98$export$f5300fbf692a63ec), {
        value: {
            returnFocus: returnFocus,
            disabled: disabled,
            controlled: popover.controlled,
            reference: reference,
            floating: floating,
            x: popover.floating.x,
            y: popover.floating.y,
            arrowX: popover.floating?.middlewareData?.arrow?.x,
            arrowY: popover.floating?.middlewareData?.arrow?.y,
            opened: popover.opened,
            arrowRef: arrowRef,
            transitionProps: {
                ...transitionProps,
                onExited: onExited,
                onEntered: onEntered
            },
            width: width,
            withArrow: withArrow,
            arrowSize: arrowSize,
            arrowOffset: arrowOffset,
            arrowRadius: arrowRadius,
            arrowPosition: arrowPosition,
            placement: popover.floating.placement,
            trapFocus: trapFocus,
            withinPortal: withinPortal,
            portalProps: portalProps,
            zIndex: zIndex,
            radius: radius,
            shadow: shadow,
            closeOnEscape: closeOnEscape,
            onDismiss: onDismiss,
            onClose: popover.onClose,
            onToggle: popover.onToggle,
            getTargetId: ()=>uid,
            getDropdownId: ()=>`${uid}-dropdown`,
            withRoles: withRoles,
            targetProps: others,
            __staticSelector: __staticSelector,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            variant: variant,
            keepMounted: keepMounted,
            keepMountedMode: keepMountedMode,
            getStyles: getStyles,
            resolvedStyles: resolvedStyles,
            floatingStrategy: floatingStrategy,
            referenceHidden: hideDetached && env !== "test" ? popover.floating.middlewareData.hide?.referenceHidden : false
        },
        children: [
            children,
            withOverlay && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4e0d3c4af0891b98$export$be58926105124dd4), {
                transition: "fade",
                mounted: popover.opened,
                duration: transitionProps?.duration || 250,
                exitDuration: transitionProps?.exitDuration || 250,
                children: (transitionStyles)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c40c05f34c6cea16$export$425106c5d6e6dc37), {
                        withinPortal: withinPortal,
                        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8816b2889866f4a7$export$c6fdb837b070b4ff), {
                            ...overlayProps,
                            ...getStyles("overlay", {
                                className: overlayProps?.className,
                                style: [
                                    transitionStyles,
                                    overlayProps?.style
                                ]
                            })
                        })
                    })
            })
        ]
    });
}
$4c321a5e1b48bbbf$export$5b6b19405a83ff9d.Target = (0, $a8854574e99469aa$export$5ad0c0856b469f13);
$4c321a5e1b48bbbf$export$5b6b19405a83ff9d.Dropdown = (0, $c6c02060e092d07e$export$bc4cee0d3f11c45d);
$4c321a5e1b48bbbf$export$5b6b19405a83ff9d.ContextMenu = (0, $62cac8d5482abc3d$export$bb17859a2be78797);
$4c321a5e1b48bbbf$export$5b6b19405a83ff9d.varsResolver = $4c321a5e1b48bbbf$var$varsResolver;
$4c321a5e1b48bbbf$export$5b6b19405a83ff9d.displayName = "@mantine/core/Popover";
$4c321a5e1b48bbbf$export$5b6b19405a83ff9d.extend = (input)=>input;
$4c321a5e1b48bbbf$export$5b6b19405a83ff9d.withProps = (fixedProps)=>{
    const Extended = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($4c321a5e1b48bbbf$export$5b6b19405a83ff9d, {
            ...fixedProps,
            ...props
        });
    Extended.extend = $4c321a5e1b48bbbf$export$5b6b19405a83ff9d.extend;
    Extended.displayName = `WithProps(${$4c321a5e1b48bbbf$export$5b6b19405a83ff9d.displayName})`;
    return Extended;
};



"use client";
//#region packages/@mantine/core/src/components/Menu/Menu.context.ts
const [$1a88617e76f04480$export$2cad3fd48ac06579, $1a88617e76f04480$export$21c7ab35b39f78ec] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("Menu component was not found in the tree");




var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/components/Menu/MenuCheckboxGroup/MenuCheckboxGroup.context.tsx
const $86e5c1d6962305d5$export$42637d6ac6dd1cb8 = (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/Menu/MenuCheckboxGroup/MenuCheckboxGroup.tsx
function $3ef21e6ef8208c50$export$1e188c9c826116ca(_props) {
    const { value: value, defaultValue: defaultValue, onChange: onChange, children: children } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuCheckboxGroup", null, _props);
    const [_value, setValue] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: value,
        defaultValue: defaultValue,
        finalValue: [],
        onChange: onChange
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $86e5c1d6962305d5$export$42637d6ac6dd1cb8), {
        value: {
            values: _value,
            onChange: (0, $acw62.useCallback)((next)=>{
                setValue(_value.includes(next) ? _value.filter((item)=>item !== next) : [
                    ..._value,
                    next
                ]);
            }, [
                _value,
                setValue
            ])
        },
        children: children
    });
}
$3ef21e6ef8208c50$export$1e188c9c826116ca.displayName = "@mantine/core/MenuCheckboxGroup";


"use client";
//#region packages/@mantine/core/src/components/Menu/Menu.module.css
var $a9cf29074e66a7d4$export$2e2bcd8739ae039 = {
    "dropdown": "m_dc9b7c9f",
    "label": "m_9bfac126",
    "divider": "m_efdf90cb",
    "item": "m_99ac2aa1",
    "search": "m_ef8769b6",
    "itemLabel": "m_5476e0d3",
    "itemIndicator": "m_8395186e",
    "itemSection": "m_8b75e504",
    "chevron": "m_b85b0bed"
};






"use client";
//#region packages/@mantine/core/src/components/Checkbox/CheckIcon.tsx
function $5513f088f1bc8bdf$export$7dd004358974b05d({ size: size, style: style, ...others }) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 10 7",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: size !== void 0 ? {
            width: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(size),
            height: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(size),
            ...style
        } : style,
        "aria-hidden": true,
        ...others,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    });
}
function $5513f088f1bc8bdf$export$c0a1936901b0e55({ indeterminate: indeterminate, ...others }) {
    if (indeterminate) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 6",
        "aria-hidden": true,
        ...others,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("rect", {
            width: "32",
            height: "6",
            fill: "currentColor",
            rx: "3"
        })
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($5513f088f1bc8bdf$export$7dd004358974b05d, {
        ...others
    });
}





"use client";
//#region packages/@mantine/core/src/core/utils/create-scoped-keydown-handler/create-scoped-keydown-handler.ts
function $afa38183edceda99$var$getPreviousIndex(current, elements, loop) {
    for(let i = current - 1; i >= 0; i -= 1)if (!elements[i].disabled) return i;
    if (loop) {
        for(let i = elements.length - 1; i > -1; i -= 1)if (!elements[i].disabled) return i;
    }
    return current;
}
function $afa38183edceda99$var$getNextIndex(current, elements, loop) {
    for(let i = current + 1; i < elements.length; i += 1)if (!elements[i].disabled) return i;
    if (loop) {
        for(let i = 0; i < elements.length; i += 1)if (!elements[i].disabled) return i;
    }
    return current;
}
/** Validates that target element is on the same level as sibling, used to filter out children that have the same sibling selector */ function $afa38183edceda99$var$onSameLevel(target, sibling, parentSelector) {
    return (0, $2c8b9d23474a2600$export$3d0f3f5781bcdc48)(target, parentSelector) === (0, $2c8b9d23474a2600$export$3d0f3f5781bcdc48)(sibling, parentSelector);
}
function $afa38183edceda99$export$5b1acc7188190893({ parentSelector: parentSelector, siblingSelector: siblingSelector, onKeyDown: onKeyDown, loop: loop = true, activateOnFocus: activateOnFocus = false, dir: dir = "rtl", orientation: orientation }) {
    return (event)=>{
        onKeyDown?.(event);
        const elements = Array.from((0, $2c8b9d23474a2600$export$3d0f3f5781bcdc48)(event.currentTarget, parentSelector)?.querySelectorAll(siblingSelector) || []).filter((node)=>$afa38183edceda99$var$onSameLevel(event.currentTarget, node, parentSelector));
        const current = elements.findIndex((el)=>event.currentTarget === el);
        const _nextIndex = $afa38183edceda99$var$getNextIndex(current, elements, loop);
        const _previousIndex = $afa38183edceda99$var$getPreviousIndex(current, elements, loop);
        const nextIndex = dir === "rtl" ? _previousIndex : _nextIndex;
        const previousIndex = dir === "rtl" ? _nextIndex : _previousIndex;
        switch(event.key){
            case "ArrowRight":
                if (orientation === "horizontal") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[nextIndex].focus();
                    activateOnFocus && elements[nextIndex].click();
                }
                break;
            case "ArrowLeft":
                if (orientation === "horizontal") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[previousIndex].focus();
                    activateOnFocus && elements[previousIndex].click();
                }
                break;
            case "ArrowUp":
                if (orientation === "vertical") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[_previousIndex].focus();
                    activateOnFocus && elements[_previousIndex].click();
                }
                break;
            case "ArrowDown":
                if (orientation === "vertical") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[_nextIndex].focus();
                    activateOnFocus && elements[_nextIndex].click();
                }
                break;
            case "Home":
                event.stopPropagation();
                event.preventDefault();
                elements[$afa38183edceda99$var$getNextIndex(-1, elements, false)]?.focus();
                break;
            case "End":
                event.stopPropagation();
                event.preventDefault();
                elements[$afa38183edceda99$var$getPreviousIndex(elements.length, elements, false)]?.focus();
                break;
        }
    };
}









var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/components/Menu/MenuSub/MenuSub.context.tsx
const $49bf31ed6c75b961$export$fb8a596c8c94a588 = (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/Menu/MenuSelectableItem/MenuSelectableItem.tsx
function $983f0e320fb17a18$export$af476b1618e9ea3e({ role: role, checked: checked, indicator: indicator, onSelect: onSelect, color: color, closeMenuOnClick: closeMenuOnClick, rightSection: rightSection, children: children, disabled: disabled, dataDisabled: dataDisabled, className: className, style: style, styles: styles, classNames: classNames, buttonRef: buttonRef, others: others }) {
    const ctx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    const subCtx = (0, $acw62.use)((0, $49bf31ed6c75b961$export$fb8a596c8c94a588));
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const { dir: dir } = (0, $35c57ac18e24a61d$export$b39126d51d94e6f3)();
    const itemRef = (0, $acw62.useRef)(null);
    const handleClick = (0, $528465f85c56cc6b$export$48d1ea6320830260)(others.onClick, ()=>{
        if (dataDisabled) return;
        onSelect();
        if (closeMenuOnClick) ctx.closeDropdownImmediately();
    });
    const handleMouseMove = (0, $528465f85c56cc6b$export$48d1ea6320830260)(others.onMouseMove, ()=>{
        if (!ctx.hasSearch) return;
        const dropdown = itemRef.current?.closest("[data-menu-dropdown]");
        if (!dropdown) return;
        dropdown.querySelectorAll("[data-menu-active]").forEach((node)=>{
            if (node !== itemRef.current && node.closest("[data-menu-dropdown]") === dropdown) node.removeAttribute("data-menu-active");
        });
    });
    const handleKeydown = (0, $528465f85c56cc6b$export$48d1ea6320830260)(others.onKeyDown, (event)=>{
        if (event.key === "ArrowLeft" && subCtx) {
            subCtx.close();
            subCtx.focusParentItem();
        }
    });
    const colors = color ? theme.variantColorResolver({
        color: color,
        theme: theme,
        variant: "light"
    }) : void 0;
    const parsedThemeColor = color ? (0, $33a822173b5f4b0f$export$83e0a426d2da8ac1)({
        color: color,
        theme: theme
    }) : null;
    const renderIndicator = ctx.alignItemsLabels !== "none" || checked;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), {
        onMouseDown: (event)=>event.preventDefault(),
        ...others,
        unstyled: ctx.unstyled,
        tabIndex: ctx.menuItemTabIndex,
        ...ctx.getStyles("item", {
            className: className,
            style: style,
            styles: styles,
            classNames: classNames
        }),
        ref: (0, $7034a45159125c0b$export$36a55fa7500f01f)(itemRef, buttonRef),
        role: role,
        "aria-checked": checked,
        disabled: disabled,
        "data-menu-item": true,
        "data-checked": checked || void 0,
        "data-disabled": disabled || dataDisabled || void 0,
        "data-mantine-stop-propagation": true,
        onClick: handleClick,
        onMouseMove: handleMouseMove,
        onKeyDown: (0, $afa38183edceda99$export$5b1acc7188190893)({
            siblingSelector: "[data-menu-item]:not([data-disabled])",
            parentSelector: "[data-menu-dropdown]",
            activateOnFocus: false,
            loop: ctx.loop,
            dir: dir,
            orientation: "vertical",
            onKeyDown: handleKeydown
        }),
        __vars: {
            "--menu-item-color": parsedThemeColor?.isThemeColor && parsedThemeColor?.shade === void 0 ? `var(--mantine-color-${parsedThemeColor.color}-6)` : colors?.color,
            "--menu-item-hover": colors?.hover
        },
        children: [
            renderIndicator && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...ctx.getStyles("itemIndicator", {
                    styles: styles,
                    classNames: classNames
                }),
                "data-checked": checked || void 0,
                children: checked ? indicator : null
            }),
            children && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...ctx.getStyles("itemLabel", {
                    styles: styles,
                    classNames: classNames
                }),
                "data-menu-item-label": true,
                children: children
            }),
            rightSection && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...ctx.getStyles("itemSection", {
                    styles: styles,
                    classNames: classNames
                }),
                "data-position": "right",
                children: rightSection
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/Menu/MenuCheckboxItem/MenuCheckboxItem.tsx
const $02d0ba7e88e0ce9f$export$f6f243521332502d = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, color: color, closeMenuOnClick: closeMenuOnClick, rightSection: rightSection, children: children, disabled: disabled, "data-disabled": dataDisabled, value: value, checked: checked, defaultChecked: defaultChecked, onChange: onChange, checkIcon: checkIcon, ref: ref, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuCheckboxItem", null, _props);
    const ctx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    const groupCtx = (0, $acw62.use)((0, $86e5c1d6962305d5$export$42637d6ac6dd1cb8));
    const groupChecked = groupCtx && value !== void 0 ? groupCtx.values.includes(value) : void 0;
    const [_checked, setChecked] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: checked ?? groupChecked,
        defaultValue: defaultChecked,
        finalValue: false,
        onChange: onChange
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $983f0e320fb17a18$export$af476b1618e9ea3e), {
        role: "menuitemcheckbox",
        checked: _checked,
        indicator: checkIcon ?? ctx.checkIcon ?? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $5513f088f1bc8bdf$export$7dd004358974b05d), {
            size: 10
        }),
        onSelect: ()=>{
            if (onChange) setChecked(!_checked);
            else if (groupCtx && value !== void 0) groupCtx.onChange(value);
            else setChecked(!_checked);
        },
        color: color,
        closeMenuOnClick: closeMenuOnClick,
        rightSection: rightSection,
        disabled: disabled,
        dataDisabled: dataDisabled,
        className: className,
        style: style,
        styles: styles,
        classNames: classNames,
        buttonRef: ref,
        others: others,
        children: children
    });
});
$02d0ba7e88e0ce9f$export$f6f243521332502d.classes = (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039);
$02d0ba7e88e0ce9f$export$f6f243521332502d.displayName = "@mantine/core/MenuCheckboxItem";








var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/components/Menu/MenuContextMenu/MenuContextMenu.tsx
function $707eea501bb3c916$export$1ca9a6b43409b647(props) {
    const { children: children, disabled: disabled, longPressDelay: longPressDelay } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuContextMenu", null, props);
    const child = (0, $fc5f5fc6d9909a8d$export$1fd9bef6809ad57c)(children);
    if (!child) throw new Error("Menu.ContextMenu component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    const ctx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    const popoverCtx = (0, $74f44c98474c2c98$export$1468d0761b26e6c8)();
    return (0, $acw62.cloneElement)(child, (0, $a1e85b714a9eb32c$export$d6f5131b955d9374)({
        childProps: child.props,
        disabled: disabled || popoverCtx.disabled,
        opened: ctx.opened,
        longPressDelay: longPressDelay,
        setReference: popoverCtx.reference,
        open: ()=>ctx.openDropdown()
    }));
}
$707eea501bb3c916$export$1ca9a6b43409b647.displayName = "@mantine/core/MenuContextMenu";








"use client";
//#region packages/@mantine/core/src/components/Menu/MenuDivider/MenuDivider.tsx
const $0e186a6eac2a78c1$export$acb07b4664ac227c = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuDivider", null, props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...(0, $1a88617e76f04480$export$21c7ab35b39f78ec)().getStyles("divider", {
            className: className,
            style: style,
            styles: styles,
            classNames: classNames
        }),
        ...others
    });
});
$0e186a6eac2a78c1$export$acb07b4664ac227c.classes = (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039);
$0e186a6eac2a78c1$export$acb07b4664ac227c.displayName = "@mantine/core/MenuDivider";









var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/components/Menu/use-menu-type-ahead.ts
const $51dd66e68277cc84$var$RESET_DELAY = 500;
function $51dd66e68277cc84$var$getItemText(item) {
    return ((item.querySelector("[data-menu-item-label]") ?? item).textContent ?? "").trim().toLowerCase();
}
function $51dd66e68277cc84$var$isRepeatedChar(buffer) {
    return buffer.length > 1 && buffer.split("").every((char)=>char === buffer[0]);
}
function $51dd66e68277cc84$export$599972bc946db2aa({ enabled: enabled, opened: opened, getDropdown: getDropdown }) {
    const stateRef = (0, $acw62.useRef)({
        buffer: "",
        timeoutId: null
    });
    (0, $acw62.useEffect)(()=>{
        if (opened && enabled) return;
        const state = stateRef.current;
        if (state.timeoutId !== null) {
            window.clearTimeout(state.timeoutId);
            state.timeoutId = null;
        }
        state.buffer = "";
    }, [
        opened,
        enabled
    ]);
    (0, $acw62.useEffect)(()=>()=>{
            const { timeoutId: timeoutId } = stateRef.current;
            if (timeoutId !== null) window.clearTimeout(timeoutId);
        }, []);
    return (event)=>{
        if (!enabled || event.defaultPrevented) return;
        if (event.ctrlKey || event.metaKey || event.altKey) return;
        if (event.key.length !== 1 || event.key === " ") return;
        const target = event.target;
        if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.tagName === "SELECT" || target.isContentEditable)) return;
        const dropdown = getDropdown();
        if (!dropdown) return;
        const items = Array.from(dropdown.querySelectorAll("[data-menu-item]:not([data-disabled])")).filter((item)=>item.closest("[data-menu-dropdown]") === dropdown);
        if (items.length === 0) return;
        const state = stateRef.current;
        state.buffer = (state.buffer + event.key).toLowerCase();
        if (state.timeoutId !== null) window.clearTimeout(state.timeoutId);
        state.timeoutId = window.setTimeout(()=>{
            state.buffer = "";
            state.timeoutId = null;
        }, $51dd66e68277cc84$var$RESET_DELAY);
        const activeElement = document.activeElement;
        const currentIndex = activeElement ? items.indexOf(activeElement) : -1;
        let match = null;
        if (state.buffer.length === 1 || $51dd66e68277cc84$var$isRepeatedChar(state.buffer)) {
            const char = state.buffer[0];
            const startIndex = currentIndex + 1;
            for(let i = 0; i < items.length; i += 1){
                const idx = (startIndex + i) % items.length;
                if ($51dd66e68277cc84$var$getItemText(items[idx]).startsWith(char)) {
                    match = items[idx];
                    break;
                }
            }
        } else for(let i = 0; i < items.length; i += 1)if ($51dd66e68277cc84$var$getItemText(items[i]).startsWith(state.buffer)) {
            match = items[i];
            break;
        }
        if (match) {
            event.preventDefault();
            match.focus();
        }
    };
}



var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/Menu/MenuDropdown/MenuDropdown.tsx
const $f3829f8ad9101183$export$c7794ca2de686af4 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, children: children, ref: ref, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuDropdown", null, props);
    const wrapperRef = (0, $acw62.useRef)(null);
    const ctx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    const typeAhead = (0, $51dd66e68277cc84$export$599972bc946db2aa)({
        enabled: !ctx.hasSearch,
        opened: ctx.opened,
        getDropdown: ()=>wrapperRef.current
    });
    const handleKeyDown = (0, $528465f85c56cc6b$export$48d1ea6320830260)(onKeyDown, (event)=>{
        typeAhead(event);
        if (event.defaultPrevented || ctx.hasSearch) return;
        if (event.key === "ArrowUp" || event.key === "ArrowDown") {
            event.preventDefault();
            wrapperRef.current?.querySelectorAll("[data-menu-item]:not(:disabled)")[0]?.focus();
        }
    });
    const handleMouseEnter = (0, $528465f85c56cc6b$export$48d1ea6320830260)(onMouseEnter, ()=>(ctx.trigger === "hover" || ctx.trigger === "click-hover") && ctx.openDropdown());
    const handleMouseLeave = (0, $528465f85c56cc6b$export$48d1ea6320830260)(onMouseLeave, ()=>(ctx.trigger === "hover" || ctx.trigger === "click-hover") && ctx.closeDropdown());
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $4c321a5e1b48bbbf$export$5b6b19405a83ff9d).Dropdown, {
        ...others,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        role: "menu",
        "aria-orientation": "vertical",
        ref: (0, $7034a45159125c0b$export$36a55fa7500f01f)(ref, wrapperRef),
        ...ctx.getStyles("dropdown", {
            className: className,
            style: style,
            styles: styles,
            classNames: classNames,
            withStaticClass: false
        }),
        tabIndex: -1,
        "data-menu-dropdown": true,
        onKeyDown: handleKeyDown,
        children: [
            ctx.withInitialFocusPlaceholder && !ctx.hasSearch && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "presentation",
                tabIndex: -1,
                "data-autofocus": true,
                "data-mantine-stop-propagation": true,
                style: {
                    outline: 0
                }
            }),
            children
        ]
    });
});
$f3829f8ad9101183$export$c7794ca2de686af4.classes = (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039);
$f3829f8ad9101183$export$c7794ca2de686af4.displayName = "@mantine/core/MenuDropdown";














var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/Menu/MenuItem/MenuItem.tsx
const $a0cdadc3699aa402$export$2ce376c2cc3355c8 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, color: color, closeMenuOnClick: closeMenuOnClick, leftSection: leftSection, rightSection: rightSection, children: children, disabled: disabled, "data-disabled": dataDisabled, ref: ref, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuItem", null, props);
    const ctx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    const subCtx = (0, $acw62.use)((0, $49bf31ed6c75b961$export$fb8a596c8c94a588));
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const { dir: dir } = (0, $35c57ac18e24a61d$export$b39126d51d94e6f3)();
    const itemRef = (0, $acw62.useRef)(null);
    const _others = others;
    const handleClick = (0, $528465f85c56cc6b$export$48d1ea6320830260)(_others.onClick, ()=>{
        if (dataDisabled) return;
        if (typeof closeMenuOnClick === "boolean") closeMenuOnClick && ctx.closeDropdownImmediately();
        else ctx.closeOnItemClick && ctx.closeDropdownImmediately();
    });
    const handleMouseMove = (0, $528465f85c56cc6b$export$48d1ea6320830260)(_others.onMouseMove, ()=>{
        if (!ctx.hasSearch) return;
        const dropdown = itemRef.current?.closest("[data-menu-dropdown]");
        if (!dropdown) return;
        dropdown.querySelectorAll("[data-menu-active]").forEach((node)=>{
            if (node !== itemRef.current && node.closest("[data-menu-dropdown]") === dropdown) node.removeAttribute("data-menu-active");
        });
    });
    const colors = color ? theme.variantColorResolver({
        color: color,
        theme: theme,
        variant: "light"
    }) : void 0;
    const parsedThemeColor = color ? (0, $33a822173b5f4b0f$export$83e0a426d2da8ac1)({
        color: color,
        theme: theme
    }) : null;
    const handleKeydown = (0, $528465f85c56cc6b$export$48d1ea6320830260)(_others.onKeyDown, (event)=>{
        if (event.key === "ArrowLeft" && subCtx) {
            subCtx.close();
            subCtx.focusParentItem();
        }
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), {
        onMouseDown: (event)=>event.preventDefault(),
        ...others,
        unstyled: ctx.unstyled,
        tabIndex: ctx.menuItemTabIndex,
        ...ctx.getStyles("item", {
            className: className,
            style: style,
            styles: styles,
            classNames: classNames
        }),
        ref: (0, $7034a45159125c0b$export$36a55fa7500f01f)(itemRef, ref),
        role: "menuitem",
        disabled: disabled,
        "data-menu-item": true,
        "data-disabled": disabled || dataDisabled || void 0,
        "data-mantine-stop-propagation": true,
        onClick: handleClick,
        onMouseMove: handleMouseMove,
        onKeyDown: (0, $afa38183edceda99$export$5b1acc7188190893)({
            siblingSelector: "[data-menu-item]:not([data-disabled])",
            parentSelector: "[data-menu-dropdown]",
            activateOnFocus: false,
            loop: ctx.loop,
            dir: dir,
            orientation: "vertical",
            onKeyDown: handleKeydown
        }),
        __vars: {
            "--menu-item-color": parsedThemeColor?.isThemeColor && parsedThemeColor?.shade === void 0 ? `var(--mantine-color-${parsedThemeColor.color}-6)` : colors?.color,
            "--menu-item-hover": colors?.hover
        },
        children: [
            ctx.alignItemsLabels === "all" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...ctx.getStyles("itemIndicator", {
                    styles: styles,
                    classNames: classNames
                }),
                "data-placeholder": true
            }),
            leftSection && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...ctx.getStyles("itemSection", {
                    styles: styles,
                    classNames: classNames
                }),
                "data-position": "left",
                children: leftSection
            }),
            children && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...ctx.getStyles("itemLabel", {
                    styles: styles,
                    classNames: classNames
                }),
                "data-menu-item-label": true,
                children: children
            }),
            rightSection && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...ctx.getStyles("itemSection", {
                    styles: styles,
                    classNames: classNames
                }),
                "data-position": "right",
                children: rightSection
            })
        ]
    });
});
$a0cdadc3699aa402$export$2ce376c2cc3355c8.classes = (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039);
$a0cdadc3699aa402$export$2ce376c2cc3355c8.displayName = "@mantine/core/MenuItem";








"use client";
//#region packages/@mantine/core/src/components/Menu/MenuLabel/MenuLabel.tsx
const $4b566499fd345957$export$dd37bec0e8a99143 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuLabel", null, props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...(0, $1a88617e76f04480$export$21c7ab35b39f78ec)().getStyles("label", {
            className: className,
            style: style,
            styles: styles,
            classNames: classNames
        }),
        ...others
    });
});
$4b566499fd345957$export$dd37bec0e8a99143.classes = (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039);
$4b566499fd345957$export$dd37bec0e8a99143.displayName = "@mantine/core/MenuLabel";




var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/components/Menu/MenuRadioGroup/MenuRadioGroup.context.tsx
const $b232d8f02804eb21$export$ca2d9104ddb3d7d3 = (0, $acw62.createContext)(null);




"use client";
//#region packages/@mantine/core/src/components/Menu/MenuRadioGroup/MenuRadioGroup.tsx
function $a63c2b54de036797$export$ea2200c9eee416b3(_props) {
    const { value: value, defaultValue: defaultValue, onChange: onChange, children: children } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuRadioGroup", null, _props);
    const [_value, setValue] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: value,
        defaultValue: defaultValue,
        finalValue: null,
        onChange: onChange
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b232d8f02804eb21$export$ca2d9104ddb3d7d3), {
        value: {
            value: _value,
            onChange: (next)=>setValue(next)
        },
        children: children
    });
}
$a63c2b54de036797$export$ea2200c9eee416b3.displayName = "@mantine/core/MenuRadioGroup";










"use client";
//#region packages/@mantine/core/src/components/Radio/RadioIcon.tsx
function $ee4c8e2afae28f3e$export$dc5561ae0d840124({ size: size, style: style, ...others }) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 5 5",
        style: {
            width: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(size),
            height: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(size),
            ...style
        },
        "aria-hidden": true,
        ...others,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("circle", {
            cx: "2.5",
            cy: "2.5",
            r: "2.5",
            fill: "currentColor"
        })
    });
}



var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/Menu/MenuRadioItem/MenuRadioItem.tsx
const $b731b70c4e5ddae8$export$69bd225e9817f6d0 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, color: color, closeMenuOnClick: closeMenuOnClick, rightSection: rightSection, children: children, disabled: disabled, "data-disabled": dataDisabled, value: value, checked: checked, onChange: onChange, checkIcon: checkIcon, ref: ref, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuRadioItem", null, _props);
    const ctx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    const groupCtx = (0, $acw62.use)((0, $b232d8f02804eb21$export$ca2d9104ddb3d7d3));
    const _checked = checked ?? (groupCtx ? groupCtx.value === value : false);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $983f0e320fb17a18$export$af476b1618e9ea3e), {
        role: "menuitemradio",
        checked: _checked,
        indicator: checkIcon ?? ctx.checkIcon ?? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ee4c8e2afae28f3e$export$dc5561ae0d840124), {
            size: 5
        }),
        onSelect: ()=>{
            if (!_checked) {
                if (onChange) onChange(value);
                else if (groupCtx) groupCtx.onChange(value);
            }
        },
        color: color,
        closeMenuOnClick: closeMenuOnClick,
        rightSection: rightSection,
        disabled: disabled,
        dataDisabled: dataDisabled,
        className: className,
        style: style,
        styles: styles,
        classNames: classNames,
        buttonRef: ref,
        others: others,
        children: children
    });
});
$b731b70c4e5ddae8$export$69bd225e9817f6d0.classes = (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039);
$b731b70c4e5ddae8$export$69bd225e9817f6d0.displayName = "@mantine/core/MenuRadioItem";















var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/components/Input/Input.context.ts
const $5a3e69c58a027a5c$export$37fb8590cf2c088c = (0, $acw62.createContext)({
    size: "sm"
});








var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/Input/InputClearButton/InputClearButton.tsx
const $be0ef0bea4d6eec5$export$669fae9fa3a95656 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputClearButton", null, _props);
    const { size: size, variant: variant, vars: vars, classNames: classNames, styles: styles, ...others } = props;
    const ctx = (0, $acw62.use)((0, $5a3e69c58a027a5c$export$37fb8590cf2c088c));
    const { resolvedClassNames: resolvedClassNames, resolvedStyles: resolvedStyles } = (0, $3da94ce37793f66c$export$92dc9b0c0bd35ec0)({
        classNames: classNames,
        styles: styles,
        props: props
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $30da360a5c87638a$export$de65de8213222d10), {
        variant: variant || "transparent",
        size: size || ctx?.size || "sm",
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        __staticSelector: "InputClearButton",
        style: {
            pointerEvents: "all",
            background: "var(--input-bg)",
            ...others.style
        },
        ...others
    });
});
$be0ef0bea4d6eec5$export$669fae9fa3a95656.displayName = "@mantine/core/InputClearButton";



"use client";
//#region packages/@mantine/core/src/components/Input/InputClearSection/InputClearSection.tsx
const $6650f6591b24da47$var$clearSectionOffset = {
    xs: 7,
    sm: 8,
    md: 10,
    lg: 12,
    xl: 15
};
function $6650f6591b24da47$export$72c193036f6cce57({ __clearable: __clearable, __clearSection: __clearSection, rightSection: rightSection, __defaultRightSection: __defaultRightSection, size: size = "sm", __clearSectionMode: __clearSectionMode = "both" }) {
    const clearSection = __clearable && __clearSection;
    if (__clearSectionMode === "rightSection") return rightSection === null ? null : rightSection || __defaultRightSection;
    if (__clearSectionMode === "clear") return rightSection === null ? null : clearSection || __defaultRightSection;
    if (clearSection && (rightSection || __defaultRightSection)) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-combined-clear-section": true,
        style: {
            display: "flex",
            gap: 2,
            alignItems: "center",
            paddingInlineEnd: $6650f6591b24da47$var$clearSectionOffset[size]
        },
        children: [
            clearSection,
            rightSection || __defaultRightSection
        ]
    });
    return rightSection === null ? null : rightSection || clearSection || __defaultRightSection;
}



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/core/src/components/Input/InputWrapper.context.ts
const $71cd98bbd243f876$export$47074f334c9c22e7 = (0, $acw62.createContext)({
    offsetBottom: false,
    offsetTop: false,
    describedBy: void 0,
    getStyles: null,
    inputId: void 0,
    labelId: void 0
});


"use client";
//#region packages/@mantine/core/src/components/Input/Input.module.css
var $68788066a3c963e6$export$2e2bcd8739ae039 = {
    "wrapper": "m_6c018570",
    "input": "m_8fb7ebe7",
    "bottomSection": "m_93f4ed57",
    "section": "m_82577fc2",
    "placeholder": "m_88bacfd0",
    "root": "m_46b77525",
    "label": "m_8fdc1311",
    "required": "m_78a94662",
    "error": "m_8f816625",
    "success": "m_9d9d40e0",
    "description": "m_fe47ce59"
};












var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/Input/InputDescription/InputDescription.tsx
const $2250c0d6f2e006ef$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size })=>({
        description: {
            "--input-description-size": size === void 0 ? void 0 : `calc(${(0, $fcab4af601ce7e99$export$7d055c252aebca58)(size)} - ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(2)})`
        }
    }));
const $2250c0d6f2e006ef$export$416ae9045a33afd = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputDescription", null, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, __staticSelector: __staticSelector, __inheritStyles: __inheritStyles = true, attributes: attributes, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputDescription", null, props);
    const ctx = (0, $acw62.use)((0, $71cd98bbd243f876$export$47074f334c9c22e7));
    const _getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props: props,
        classes: (0, $68788066a3c963e6$export$2e2bcd8739ae039),
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        rootSelector: "description",
        vars: vars,
        varsResolver: $2250c0d6f2e006ef$var$varsResolver
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "p",
        ...(__inheritStyles && ctx?.getStyles || _getStyles)("description", ctx?.getStyles ? {
            className: className,
            style: style
        } : void 0),
        ...others
    });
});
$2250c0d6f2e006ef$export$416ae9045a33afd.classes = (0, $68788066a3c963e6$export$2e2bcd8739ae039);
$2250c0d6f2e006ef$export$416ae9045a33afd.varsResolver = $2250c0d6f2e006ef$var$varsResolver;
$2250c0d6f2e006ef$export$416ae9045a33afd.displayName = "@mantine/core/InputDescription";












var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/Input/InputError/InputError.tsx
const $6fc8a9095ea9adf5$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size })=>({
        error: {
            "--input-error-size": size === void 0 ? void 0 : `calc(${(0, $fcab4af601ce7e99$export$7d055c252aebca58)(size)} - ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(2)})`
        }
    }));
const $6fc8a9095ea9adf5$export$404cd3170eee2e81 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputError", null, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, attributes: attributes, __staticSelector: __staticSelector, __inheritStyles: __inheritStyles = true, ...others } = props;
    const _getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props: props,
        classes: (0, $68788066a3c963e6$export$2e2bcd8739ae039),
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        rootSelector: "error",
        vars: vars,
        varsResolver: $6fc8a9095ea9adf5$var$varsResolver
    });
    const ctx = (0, $acw62.use)((0, $71cd98bbd243f876$export$47074f334c9c22e7));
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "p",
        ...(__inheritStyles && ctx?.getStyles || _getStyles)("error", ctx?.getStyles ? {
            className: className,
            style: style
        } : void 0),
        ...others
    });
});
$6fc8a9095ea9adf5$export$404cd3170eee2e81.classes = (0, $68788066a3c963e6$export$2e2bcd8739ae039);
$6fc8a9095ea9adf5$export$404cd3170eee2e81.varsResolver = $6fc8a9095ea9adf5$var$varsResolver;
$6fc8a9095ea9adf5$export$404cd3170eee2e81.displayName = "@mantine/core/InputError";











var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/Input/InputLabel/InputLabel.tsx
const $7142f79830a0b6ab$var$defaultProps = {
    labelElement: "label"
};
const $7142f79830a0b6ab$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size })=>({
        label: {
            "--input-label-size": (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--input-asterisk-color": void 0
        }
    }));
const $7142f79830a0b6ab$export$76d3231fec538b73 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputLabel", $7142f79830a0b6ab$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, labelElement: labelElement, required: required, htmlFor: htmlFor, onMouseDown: onMouseDown, children: children, __staticSelector: __staticSelector, mod: mod, attributes: attributes, ...others } = props;
    const _getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props: props,
        classes: (0, $68788066a3c963e6$export$2e2bcd8739ae039),
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        rootSelector: "label",
        vars: vars,
        varsResolver: $7142f79830a0b6ab$var$varsResolver
    });
    const ctx = (0, $acw62.use)((0, $71cd98bbd243f876$export$47074f334c9c22e7));
    const getStyles = ctx?.getStyles || _getStyles;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...getStyles("label", ctx?.getStyles ? {
            className: className,
            style: style
        } : void 0),
        component: labelElement,
        htmlFor: labelElement === "label" ? htmlFor : void 0,
        mod: [
            {
                required: required
            },
            mod
        ],
        onMouseDown: (event)=>{
            onMouseDown?.(event);
            if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
        },
        ...others,
        children: [
            children,
            required && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...getStyles("required"),
                "aria-hidden": true,
                children: " *"
            })
        ]
    });
});
$7142f79830a0b6ab$export$76d3231fec538b73.classes = (0, $68788066a3c963e6$export$2e2bcd8739ae039);
$7142f79830a0b6ab$export$76d3231fec538b73.varsResolver = $7142f79830a0b6ab$var$varsResolver;
$7142f79830a0b6ab$export$76d3231fec538b73.displayName = "@mantine/core/InputLabel";








"use client";
//#region packages/@mantine/core/src/components/Input/InputPlaceholder/InputPlaceholder.tsx
const $15c2b8d80d4839cc$export$1dcf0d4dcfd98808 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputPlaceholder", null, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, __staticSelector: __staticSelector, error: error, mod: mod, attributes: attributes, ...others } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...(0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
            name: [
                "InputPlaceholder",
                __staticSelector
            ],
            props: props,
            classes: (0, $68788066a3c963e6$export$2e2bcd8739ae039),
            className: className,
            style: style,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            attributes: attributes,
            rootSelector: "placeholder"
        })("placeholder"),
        mod: [
            {
                error: !!error
            },
            mod
        ],
        component: "span",
        ...others
    });
});
$15c2b8d80d4839cc$export$1dcf0d4dcfd98808.classes = (0, $68788066a3c963e6$export$2e2bcd8739ae039);
$15c2b8d80d4839cc$export$1dcf0d4dcfd98808.displayName = "@mantine/core/InputPlaceholder";












var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/Input/InputSuccess/InputSuccess.tsx
const $554919d57c98928f$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size })=>({
        success: {
            "--input-success-size": size === void 0 ? void 0 : `calc(${(0, $fcab4af601ce7e99$export$7d055c252aebca58)(size)} - ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(2)})`
        }
    }));
const $554919d57c98928f$export$c636cf922acac766 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputSuccess", null, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, attributes: attributes, __staticSelector: __staticSelector, __inheritStyles: __inheritStyles = true, ...others } = props;
    const _getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props: props,
        classes: (0, $68788066a3c963e6$export$2e2bcd8739ae039),
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        rootSelector: "success",
        vars: vars,
        varsResolver: $554919d57c98928f$var$varsResolver
    });
    const ctx = (0, $acw62.use)((0, $71cd98bbd243f876$export$47074f334c9c22e7));
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "p",
        ...(__inheritStyles && ctx?.getStyles || _getStyles)("success", ctx?.getStyles ? {
            className: className,
            style: style
        } : void 0),
        ...others
    });
});
$554919d57c98928f$export$c636cf922acac766.classes = (0, $68788066a3c963e6$export$2e2bcd8739ae039);
$554919d57c98928f$export$c636cf922acac766.varsResolver = $554919d57c98928f$var$varsResolver;
$554919d57c98928f$export$c636cf922acac766.displayName = "@mantine/core/InputSuccess";















"use client";
//#region packages/@mantine/core/src/components/Input/InputWrapper/get-input-offsets/get-input-offsets.ts
function $7e1176cb96c17956$export$25327628fc2f4542(inputWrapperOrder, { hasDescription: hasDescription, hasError: hasError }) {
    const inputIndex = inputWrapperOrder.findIndex((part)=>part === "input");
    const aboveInput = inputWrapperOrder.slice(0, inputIndex);
    const belowInput = inputWrapperOrder.slice(inputIndex + 1);
    const offsetTop = hasDescription && aboveInput.includes("description") || hasError && aboveInput.includes("error");
    return {
        offsetBottom: hasDescription && belowInput.includes("description") || hasError && belowInput.includes("error"),
        offsetTop: offsetTop
    };
}



var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/Input/InputWrapper/InputWrapper.tsx
const $62cbf17611d1016d$var$defaultProps = {
    labelElement: "label",
    inputContainer: (children)=>children,
    inputWrapperOrder: [
        "label",
        "description",
        "input",
        "error"
    ]
};
const $62cbf17611d1016d$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size })=>({
        label: {
            "--input-label-size": (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--input-asterisk-color": void 0
        },
        error: {
            "--input-error-size": size === void 0 ? void 0 : `calc(${(0, $fcab4af601ce7e99$export$7d055c252aebca58)(size)} - ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(2)})`
        },
        success: {
            "--input-success-size": size === void 0 ? void 0 : `calc(${(0, $fcab4af601ce7e99$export$7d055c252aebca58)(size)} - ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(2)})`
        },
        description: {
            "--input-description-size": size === void 0 ? void 0 : `calc(${(0, $fcab4af601ce7e99$export$7d055c252aebca58)(size)} - ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(2)})`
        }
    }));
const $62cbf17611d1016d$export$fb9f58ebe9de6283 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputWrapper", $62cbf17611d1016d$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, size: size, variant: variant, __staticSelector: __staticSelector, inputContainer: inputContainer, inputWrapperOrder: inputWrapperOrder, label: label, error: error, success: success, description: description, labelProps: labelProps, descriptionProps: descriptionProps, errorProps: errorProps, successProps: successProps, labelElement: labelElement, children: children, withAsterisk: withAsterisk, id: id, required: required, __stylesApiProps: __stylesApiProps, mod: mod, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props: __stylesApiProps || props,
        classes: (0, $68788066a3c963e6$export$2e2bcd8739ae039),
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $62cbf17611d1016d$var$varsResolver
    });
    const sharedProps = {
        size: size,
        variant: variant,
        __staticSelector: __staticSelector
    };
    const idBase = (0, $cee42e5537afff93$export$f680877a34711e37)(id);
    const isRequired = typeof withAsterisk === "boolean" ? withAsterisk : required;
    const errorId = errorProps?.id || `${idBase}-error`;
    const successId = successProps?.id || `${idBase}-success`;
    const descriptionId = descriptionProps?.id || `${idBase}-description`;
    const inputId = idBase;
    const hasError = !!error && typeof error !== "boolean";
    const hasSuccess = !!success && typeof success !== "boolean" && !error;
    const hasDescription = !!description;
    const errorRendered = hasError && inputWrapperOrder.includes("error");
    const successRendered = hasSuccess && inputWrapperOrder.includes("error");
    const descriptionRendered = hasDescription && inputWrapperOrder.includes("description");
    const _describedBy = `${errorRendered ? errorId : ""} ${successRendered ? successId : ""} ${descriptionRendered ? descriptionId : ""}`;
    const describedBy = _describedBy.trim().length > 0 ? _describedBy.trim() : void 0;
    const labelId = labelProps?.id || `${idBase}-label`;
    const _label = label && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7142f79830a0b6ab$export$76d3231fec538b73), {
        labelElement: labelElement,
        id: labelId,
        htmlFor: inputId,
        required: isRequired,
        ...sharedProps,
        ...labelProps,
        children: label
    }, "label");
    const _description = hasDescription && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2250c0d6f2e006ef$export$416ae9045a33afd), {
        ...descriptionProps,
        ...sharedProps,
        size: descriptionProps?.size || sharedProps.size,
        id: descriptionProps?.id || descriptionId,
        children: description
    }, "description");
    const _input = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Fragment), {
        children: inputContainer(children)
    }, "input");
    const _error = hasError && /* @__PURE__ */ (0, $acw62.createElement)((0, $6fc8a9095ea9adf5$export$404cd3170eee2e81), {
        ...errorProps,
        ...sharedProps,
        size: errorProps?.size || sharedProps.size,
        key: "error",
        id: errorProps?.id || errorId
    }, error);
    const _success = hasSuccess && /* @__PURE__ */ (0, $acw62.createElement)((0, $554919d57c98928f$export$c636cf922acac766), {
        ...successProps,
        ...sharedProps,
        size: successProps?.size || sharedProps.size,
        key: "success",
        id: successProps?.id || successId
    }, success);
    const content = inputWrapperOrder.map((part)=>{
        switch(part){
            case "label":
                return _label;
            case "input":
                return _input;
            case "description":
                return _description;
            case "error":
                return _error || _success;
            default:
                return null;
        }
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $71cd98bbd243f876$export$47074f334c9c22e7), {
        value: {
            getStyles: getStyles,
            describedBy: describedBy,
            inputId: inputId,
            labelId: labelId,
            ...(0, $7e1176cb96c17956$export$25327628fc2f4542)(inputWrapperOrder, {
                hasDescription: hasDescription,
                hasError: hasError || hasSuccess
            })
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
            variant: variant,
            size: size,
            mod: [
                {
                    error: !!error,
                    success: !!success && !error
                },
                mod
            ],
            id: labelElement === "label" ? void 0 : id,
            ...getStyles("root"),
            ...others,
            children: content
        })
    });
});
$62cbf17611d1016d$export$fb9f58ebe9de6283.classes = (0, $68788066a3c963e6$export$2e2bcd8739ae039);
$62cbf17611d1016d$export$fb9f58ebe9de6283.varsResolver = $62cbf17611d1016d$var$varsResolver;
$62cbf17611d1016d$export$fb9f58ebe9de6283.displayName = "@mantine/core/InputWrapper";



var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/Input/Input.tsx
const $e2e9ff0d29bd408f$var$defaultProps = {
    variant: "default",
    leftSectionPointerEvents: "none",
    rightSectionPointerEvents: "none",
    withAria: true,
    withErrorStyles: true,
    withSuccessStyles: true,
    size: "sm",
    loading: false,
    loadingPosition: "right"
};
const $e2e9ff0d29bd408f$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, props, ctx)=>({
        wrapper: {
            "--input-margin-top": ctx.offsetTop ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
            "--input-margin-bottom": ctx.offsetBottom ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
            "--input-height": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(props.size, "input-height"),
            "--input-fz": (0, $fcab4af601ce7e99$export$7d055c252aebca58)(props.size),
            "--input-radius": props.radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(props.radius),
            "--input-left-section-width": props.leftSectionWidth !== void 0 ? (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(props.leftSectionWidth) : void 0,
            "--input-right-section-width": props.rightSectionWidth !== void 0 ? (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(props.rightSectionWidth) : void 0,
            "--input-padding-y": props.multiline ? (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(props.size, "input-padding-y") : void 0,
            "--input-left-section-pointer-events": props.leftSectionPointerEvents,
            "--input-right-section-pointer-events": props.rightSectionPointerEvents
        }
    }));
const $e2e9ff0d29bd408f$export$f5b8910cec6cf069 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Input", $e2e9ff0d29bd408f$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, required: required, __staticSelector: __staticSelector, __stylesApiProps: __stylesApiProps, size: size, wrapperProps: wrapperProps, error: error, success: success, disabled: disabled, leftSection: leftSection, leftSectionProps: leftSectionProps, leftSectionWidth: leftSectionWidth, rightSection: rightSection, rightSectionProps: rightSectionProps, rightSectionWidth: rightSectionWidth, rightSectionPointerEvents: rightSectionPointerEvents, leftSectionPointerEvents: leftSectionPointerEvents, variant: variant, vars: vars, pointer: pointer, multiline: multiline, radius: radius, id: id, withAria: withAria, withErrorStyles: withErrorStyles, withSuccessStyles: withSuccessStyles, mod: mod, inputSize: inputSize, attributes: attributes, __clearSection: __clearSection, __clearable: __clearable, __clearSectionMode: __clearSectionMode, __defaultRightSection: __defaultRightSection, loading: loading, loadingPosition: loadingPosition, __bottomSection: __bottomSection, __bottomSectionProps: __bottomSectionProps, rootRef: rootRef, dir: dir, ...others } = props;
    const { styleProps: styleProps, rest: rest } = (0, $2e4262c949ef0e61$export$fbc67becbdd26fbf)(others);
    const ctx = (0, $acw62.use)((0, $71cd98bbd243f876$export$47074f334c9c22e7));
    const stylesCtx = {
        offsetBottom: ctx?.offsetBottom,
        offsetTop: ctx?.offsetTop
    };
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: [
            "Input",
            __staticSelector
        ],
        props: __stylesApiProps || props,
        classes: (0, $68788066a3c963e6$export$2e2bcd8739ae039),
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        stylesCtx: stylesCtx,
        rootSelector: "wrapper",
        vars: vars,
        varsResolver: $e2e9ff0d29bd408f$var$varsResolver
    });
    const ariaAttributes = withAria ? {
        required: required,
        disabled: disabled,
        "aria-invalid": error ? true : void 0,
        "aria-describedby": ctx?.describedBy,
        id: ctx?.inputId || id
    } : {};
    const loadingIndicator = loading ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f943dfe4129424c6$export$3b0d6d7590275603), {
        size: loadingPosition === "left" ? "calc(var(--input-left-section-size) / 2)" : "calc(var(--input-right-section-size) / 2)"
    }) : null;
    const _leftSection = loading && loadingPosition === "left" ? loadingIndicator : leftSection;
    const _rightSection = (0, $6650f6591b24da47$export$72c193036f6cce57)({
        __clearable: __clearable,
        __clearSection: __clearSection,
        rightSection: loading && loadingPosition === "right" ? loadingIndicator : rightSection,
        __defaultRightSection: __defaultRightSection,
        size: size,
        __clearSectionMode: __clearSectionMode
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $5a3e69c58a027a5c$export$37fb8590cf2c088c), {
        value: {
            size: size || "sm"
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
            ref: rootRef,
            dir: dir,
            ...getStyles("wrapper"),
            ...styleProps,
            ...wrapperProps,
            mod: [
                {
                    error: !!error && withErrorStyles,
                    success: !!success && !error && withSuccessStyles,
                    pointer: pointer,
                    disabled: disabled,
                    multiline: multiline,
                    "data-with-right-section": !!_rightSection,
                    "data-with-left-section": !!_leftSection,
                    "data-with-bottom-section": !!__bottomSection
                },
                mod
            ],
            variant: variant,
            size: size,
            children: [
                _leftSection && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    ...leftSectionProps,
                    "data-position": "left",
                    ...getStyles("section", {
                        className: leftSectionProps?.className,
                        style: leftSectionProps?.style
                    }),
                    children: _leftSection
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                    component: "input",
                    ...rest,
                    ...ariaAttributes,
                    required: required,
                    mod: {
                        disabled: disabled,
                        error: !!error && withErrorStyles,
                        success: !!success && !error && withSuccessStyles
                    },
                    variant: variant,
                    __size: inputSize,
                    ...getStyles("input")
                }),
                __bottomSection && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    ...__bottomSectionProps,
                    ...getStyles("bottomSection", {
                        className: __bottomSectionProps?.className,
                        style: __bottomSectionProps?.style
                    }),
                    children: __bottomSection
                }),
                _rightSection && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    ...rightSectionProps,
                    "data-position": "right",
                    ...getStyles("section", {
                        className: rightSectionProps?.className,
                        style: rightSectionProps?.style
                    }),
                    children: _rightSection
                })
            ]
        })
    });
});
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.classes = (0, $68788066a3c963e6$export$2e2bcd8739ae039);
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.varsResolver = $e2e9ff0d29bd408f$var$varsResolver;
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.Wrapper = (0, $62cbf17611d1016d$export$fb9f58ebe9de6283);
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.Label = (0, $7142f79830a0b6ab$export$76d3231fec538b73);
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.Error = (0, $6fc8a9095ea9adf5$export$404cd3170eee2e81);
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.Success = (0, $554919d57c98928f$export$c636cf922acac766);
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.Description = (0, $2250c0d6f2e006ef$export$416ae9045a33afd);
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.Placeholder = (0, $15c2b8d80d4839cc$export$1dcf0d4dcfd98808);
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.ClearButton = (0, $be0ef0bea4d6eec5$export$669fae9fa3a95656);
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.displayName = "@mantine/core/Input";





var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/Menu/MenuSearch/MenuSearch.tsx
const $c2fee559b90f1e25$var$ITEM_SELECTOR = "[data-menu-item]:not([data-disabled])";
const $c2fee559b90f1e25$var$ACTIVE_SELECTOR = "[data-menu-active]";
function $c2fee559b90f1e25$var$getDropdown(node) {
    return node?.closest("[data-menu-dropdown]");
}
function $c2fee559b90f1e25$var$getItems(dropdown) {
    if (!dropdown) return [];
    return Array.from(dropdown.querySelectorAll($c2fee559b90f1e25$var$ITEM_SELECTOR)).filter((item)=>item.closest("[data-menu-dropdown]") === dropdown);
}
function $c2fee559b90f1e25$var$clearActive(dropdown) {
    if (!dropdown) return;
    dropdown.querySelectorAll($c2fee559b90f1e25$var$ACTIVE_SELECTOR).forEach((node)=>{
        if (node.closest("[data-menu-dropdown]") === dropdown) node.removeAttribute("data-menu-active");
    });
}
function $c2fee559b90f1e25$var$setActive(item, dropdown) {
    $c2fee559b90f1e25$var$clearActive(dropdown);
    if (item) {
        item.setAttribute("data-menu-active", "true");
        item.scrollIntoView({
            block: "nearest"
        });
    }
}
function $c2fee559b90f1e25$var$getActiveIndex(items) {
    return items.findIndex((item)=>item.hasAttribute("data-menu-active"));
}
const $c2fee559b90f1e25$var$defaultProps = {
    clearSearchOnClose: true
};
const $c2fee559b90f1e25$export$99430cbd4bdb746c = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props)=>{
    const { classNames: classNames, styles: styles, onKeyDown: onKeyDown, onChange: onChange, size: size, clearSearchOnClose: clearSearchOnClose, ref: ref, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuSearch", $c2fee559b90f1e25$var$defaultProps, props);
    const ctx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    const inputRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $7034a45159125c0b$export$36a55fa7500f01f)(ref, inputRef);
    const onChangeRef = (0, $acw62.useRef)(onChange);
    onChangeRef.current = onChange;
    (0, $acw62.useEffect)(()=>{
        return ctx.registerSearch();
    }, [
        ctx.registerSearch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (clearSearchOnClose) ctx.searchExitClearRef.current = ()=>{
            onChangeRef.current?.({
                currentTarget: {
                    value: ""
                }
            });
        };
        else ctx.searchExitClearRef.current = null;
    }, [
        clearSearchOnClose,
        ctx.searchExitClearRef
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!ctx.opened) $c2fee559b90f1e25$var$clearActive($c2fee559b90f1e25$var$getDropdown(inputRef.current));
    }, [
        ctx.opened
    ]);
    const handleChange = (0, $528465f85c56cc6b$export$48d1ea6320830260)(onChange, (event)=>{
        $c2fee559b90f1e25$var$clearActive($c2fee559b90f1e25$var$getDropdown(event.currentTarget));
    });
    const handleKeyDown = (0, $528465f85c56cc6b$export$48d1ea6320830260)(onKeyDown, (event)=>{
        if (event.defaultPrevented) return;
        const dropdown = $c2fee559b90f1e25$var$getDropdown(event.currentTarget);
        const items = $c2fee559b90f1e25$var$getItems(dropdown);
        if (event.key === "ArrowDown") {
            event.preventDefault();
            if (items.length === 0) return;
            const current = $c2fee559b90f1e25$var$getActiveIndex(items);
            $c2fee559b90f1e25$var$setActive(items[current >= items.length - 1 ? ctx.loop ? 0 : current : current + 1] ?? null, dropdown);
        } else if (event.key === "ArrowUp") {
            event.preventDefault();
            if (items.length === 0) return;
            const current = $c2fee559b90f1e25$var$getActiveIndex(items);
            $c2fee559b90f1e25$var$setActive(items[current <= 0 ? current === -1 ? items.length - 1 : ctx.loop ? items.length - 1 : 0 : current - 1] ?? null, dropdown);
        } else if (event.key === "Home") {
            event.preventDefault();
            if (items.length > 0) $c2fee559b90f1e25$var$setActive(items[0], dropdown);
        } else if (event.key === "End") {
            event.preventDefault();
            if (items.length > 0) $c2fee559b90f1e25$var$setActive(items[items.length - 1], dropdown);
        } else if (event.key === "Enter") {
            if (event.nativeEvent.isComposing || event.nativeEvent.keyCode === 229) return;
            const target = items[$c2fee559b90f1e25$var$getActiveIndex(items)];
            if (target) {
                event.preventDefault();
                if (target.hasAttribute("data-sub-menu-item")) {
                    target.focus();
                    target.dispatchEvent(new KeyboardEvent("keydown", {
                        key: "ArrowRight",
                        bubbles: true
                    }));
                } else target.click();
            }
        }
    });
    const _styles = ctx.getStyles("search");
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069), {
        "data-autofocus": true,
        "data-mantine-stop-propagation": true,
        type: "search",
        size: size,
        ...others,
        ref: mergedRef,
        classNames: [
            {
                input: _styles.className
            },
            classNames
        ],
        styles: [
            {
                input: _styles.style
            },
            styles
        ],
        onKeyDown: handleKeyDown,
        onChange: handleChange,
        __staticSelector: "Menu"
    });
});
$c2fee559b90f1e25$export$99430cbd4bdb746c.classes = (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039);
$c2fee559b90f1e25$export$99430cbd4bdb746c.displayName = "@mantine/core/MenuSearch";

















var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/Menu/MenuSubDropdown/MenuSubDropdown.tsx
const $b5f3a2913c9bde9b$export$292b8e9f6a167e49 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerEnter: onPointerEnter, onPointerLeave: onPointerLeave, onKeyDown: onKeyDown, children: children, ref: ref, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuSubDropdown", null, props);
    const wrapperRef = (0, $acw62.useRef)(null);
    const ctx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    const subCtx = (0, $acw62.use)((0, $49bf31ed6c75b961$export$fb8a596c8c94a588));
    const typeAhead = (0, $51dd66e68277cc84$export$599972bc946db2aa)({
        enabled: !ctx.hasSearch,
        opened: subCtx?.opened ?? false,
        getDropdown: ()=>wrapperRef.current
    });
    const handleKeyDown = (0, $528465f85c56cc6b$export$48d1ea6320830260)(onKeyDown, (event)=>{
        typeAhead(event);
        if (!event.ctrlKey && !event.metaKey && !event.altKey && event.key.length === 1 && event.key !== " ") event.stopPropagation();
    });
    const floatingProps = subCtx?.getFloatingProps({
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4c321a5e1b48bbbf$export$5b6b19405a83ff9d).Dropdown, {
        ...others,
        ...floatingProps,
        role: "menu",
        "aria-orientation": "vertical",
        ref: (0, $7034a45159125c0b$export$36a55fa7500f01f)(ref, wrapperRef, subCtx?.setFloating),
        ...ctx.getStyles("dropdown", {
            className: className,
            style: style,
            styles: styles,
            classNames: classNames,
            withStaticClass: false
        }),
        tabIndex: -1,
        "data-menu-dropdown": true,
        onKeyDown: handleKeyDown,
        children: children
    });
});
$b5f3a2913c9bde9b$export$292b8e9f6a167e49.classes = (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039);
$b5f3a2913c9bde9b$export$292b8e9f6a167e49.displayName = "@mantine/core/MenuSubDropdown";












"use client";
//#region packages/@mantine/core/src/components/Accordion/AccordionChevron.tsx
function $4e38105621a976b3$export$507d1a3a571ba3b7({ style: style, size: size = 16, ...others }) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            ...style,
            width: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(size),
            height: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(size),
            display: "block"
        },
        ...others,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    });
}
$4e38105621a976b3$export$507d1a3a571ba3b7.displayName = "@mantine/core/AccordionChevron";






var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/Menu/MenuSubItem/MenuSubItem.tsx
const $e7252f0f4d308177$export$2fbf84a81c8af983 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, color: color, leftSection: leftSection, rightSection: rightSection, children: children, disabled: disabled, "data-disabled": dataDisabled, closeMenuOnClick: closeMenuOnClick, ref: ref, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuSubItem", null, props);
    const ctx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    const subCtx = (0, $acw62.use)((0, $49bf31ed6c75b961$export$fb8a596c8c94a588));
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const { dir: dir } = (0, $35c57ac18e24a61d$export$b39126d51d94e6f3)();
    const itemRef = (0, $acw62.useRef)(null);
    const _others = others;
    const colors = color ? theme.variantColorResolver({
        color: color,
        theme: theme,
        variant: "light"
    }) : void 0;
    const parsedThemeColor = color ? (0, $33a822173b5f4b0f$export$83e0a426d2da8ac1)({
        color: color,
        theme: theme
    }) : null;
    const handleKeydown = (0, $528465f85c56cc6b$export$48d1ea6320830260)(_others.onKeyDown, (event)=>{
        if (event.key === "ArrowRight") {
            subCtx?.open();
            subCtx?.focusFirstItem();
        }
        if (event.key === "ArrowLeft" && subCtx?.parentContext) {
            subCtx.parentContext.close();
            subCtx.parentContext.focusParentItem();
        }
    });
    const handleClick = (0, $528465f85c56cc6b$export$48d1ea6320830260)(_others.onClick, ()=>{
        if (!dataDisabled && closeMenuOnClick) ctx.closeDropdownImmediately();
    });
    const handleMouseMove = (0, $528465f85c56cc6b$export$48d1ea6320830260)(_others.onMouseMove, ()=>{
        if (!ctx.hasSearch) return;
        const dropdown = itemRef.current?.closest("[data-menu-dropdown]");
        if (!dropdown) return;
        dropdown.querySelectorAll("[data-menu-active]").forEach((node)=>{
            if (node !== itemRef.current && node.closest("[data-menu-dropdown]") === dropdown) node.removeAttribute("data-menu-active");
        });
    });
    const referenceProps = subCtx?.getReferenceProps({
        onMouseEnter: _others.onMouseEnter,
        onMouseLeave: _others.onMouseLeave,
        onPointerEnter: _others.onPointerEnter,
        onPointerLeave: _others.onPointerLeave
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), {
        onMouseDown: (event)=>event.preventDefault(),
        ...others,
        ...referenceProps,
        unstyled: ctx.unstyled,
        tabIndex: ctx.menuItemTabIndex,
        ...ctx.getStyles("item", {
            className: className,
            style: style,
            styles: styles,
            classNames: classNames
        }),
        ref: (0, $7034a45159125c0b$export$36a55fa7500f01f)(itemRef, ref, subCtx?.setReference),
        role: "menuitem",
        disabled: disabled,
        "data-menu-item": true,
        "data-sub-menu-item": true,
        "data-disabled": disabled || dataDisabled || void 0,
        "data-mantine-stop-propagation": true,
        onClick: handleClick,
        onMouseMove: handleMouseMove,
        onKeyDown: (0, $afa38183edceda99$export$5b1acc7188190893)({
            siblingSelector: "[data-menu-item]:not([data-disabled])",
            parentSelector: "[data-menu-dropdown]",
            activateOnFocus: false,
            loop: ctx.loop,
            dir: dir,
            orientation: "vertical",
            onKeyDown: handleKeydown
        }),
        __vars: {
            "--menu-item-color": parsedThemeColor?.isThemeColor && parsedThemeColor?.shade === void 0 ? `var(--mantine-color-${parsedThemeColor.color}-6)` : colors?.color,
            "--menu-item-hover": colors?.hover
        },
        children: [
            ctx.alignItemsLabels === "all" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...ctx.getStyles("itemIndicator", {
                    styles: styles,
                    classNames: classNames
                }),
                "data-placeholder": true
            }),
            leftSection && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...ctx.getStyles("itemSection", {
                    styles: styles,
                    classNames: classNames
                }),
                "data-position": "left",
                children: leftSection
            }),
            children && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...ctx.getStyles("itemLabel", {
                    styles: styles,
                    classNames: classNames
                }),
                "data-menu-item-label": true,
                children: children
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...ctx.getStyles("itemSection", {
                    styles: styles,
                    classNames: classNames
                }),
                "data-position": "right",
                children: rightSection || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4e38105621a976b3$export$507d1a3a571ba3b7), {
                    ...ctx.getStyles("chevron"),
                    size: 14
                })
            })
        ]
    });
});
$e7252f0f4d308177$export$2fbf84a81c8af983.classes = (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039);
$e7252f0f4d308177$export$2fbf84a81c8af983.displayName = "@mantine/core/MenuSubItem";






"use client";
//#region packages/@mantine/core/src/components/Menu/MenuSubTarget/MenuSubTarget.tsx
function $b5dfc3d62c418919$export$6287a8324ee05abc({ children: children, refProp: refProp }) {
    if (!(0, $65b68cae0fe4eb32$export$45a5e7f76e0caa8d)(children)) throw new Error("Menu.Sub.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4c321a5e1b48bbbf$export$5b6b19405a83ff9d).Target, {
        refProp: refProp,
        popupType: "menu",
        children: children
    });
}
$b5dfc3d62c418919$export$6287a8324ee05abc.displayName = "@mantine/core/MenuSubTarget";



var $acw62 = parcelRequire("acw62");



"use client";
//#region packages/@mantine/core/src/components/Menu/MenuSub/MenuSub.tsx
const $300249289ab5f594$var$defaultProps = {
    offset: 0,
    position: "right-start",
    safeAreaPolygon: true,
    transitionProps: {
        duration: 0
    },
    openDelay: 0,
    middlewares: {
        shift: {
            crossAxis: true
        }
    }
};
function $300249289ab5f594$export$71bdb9d1e2909932(_props) {
    const { children: children, closeDelay: closeDelay, openDelay: openDelay, position: position, safeAreaPolygon: safeAreaPolygon, opened: openedProp, onChange: onChange, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuSub", $300249289ab5f594$var$defaultProps, _props);
    const id = (0, $cee42e5537afff93$export$f680877a34711e37)();
    const [opened, setOpened] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: openedProp,
        finalValue: false,
        onChange: onChange
    });
    const parentSubCtx = (0, $acw62.use)((0, $49bf31ed6c75b961$export$fb8a596c8c94a588));
    const menuCtx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    const { dir: dir } = (0, $35c57ac18e24a61d$export$b39126d51d94e6f3)();
    const resolvedPosition = (0, $f1fa51258cb44e6e$export$950b4922bb2f6bc6)(dir, position);
    const levelRegister = parentSubCtx?.registerOpenSub ?? menuCtx.registerOpenSub;
    const activeChildCloseRef = (0, $acw62.useRef)(null);
    const registerOpenSub = (0, $acw62.useCallback)((closeFn)=>{
        const prev = activeChildCloseRef.current;
        if (prev && prev !== closeFn) prev();
        activeChildCloseRef.current = closeFn;
        return ()=>{
            if (activeChildCloseRef.current === closeFn) activeChildCloseRef.current = null;
        };
    }, []);
    const setOpenedRef = (0, $acw62.useRef)(setOpened);
    setOpenedRef.current = setOpened;
    const handleOpen = (0, $acw62.useCallback)(()=>setOpenedRef.current(true), []);
    const handleClose = (0, $acw62.useCallback)(()=>setOpenedRef.current(false), []);
    (0, $acw62.useEffect)(()=>{
        if (!opened) return;
        return levelRegister(handleClose);
    }, [
        opened,
        levelRegister,
        handleClose
    ]);
    const { context: context, refs: refs } = (0, $1923ad12705fb717$export$4e02a5c1d08bac65)({
        placement: resolvedPosition,
        open: opened,
        onOpenChange: (nextOpen)=>{
            if (nextOpen) handleOpen();
            else handleClose();
        }
    });
    const { getReferenceProps: getReferenceProps, getFloatingProps: getFloatingProps } = (0, $1923ad12705fb717$export$a519f7794e446ddd)([
        (0, $1923ad12705fb717$export$ae780daf29e6d456)(context, {
            handleClose: safeAreaPolygon ? (0, $1923ad12705fb717$export$7484214ab62358d2)(typeof safeAreaPolygon === "object" ? safeAreaPolygon : void 0) : void 0,
            delay: {
                open: openDelay,
                close: closeDelay
            }
        })
    ]);
    const focusFirstItem = ()=>window.setTimeout(()=>{
            document.getElementById(`${id}-dropdown`)?.querySelectorAll("[data-menu-item]:not([data-disabled])")[0]?.focus();
        }, 16);
    const focusParentItem = ()=>window.setTimeout(()=>{
            document.getElementById(`${id}-target`)?.focus();
        }, 16);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $49bf31ed6c75b961$export$fb8a596c8c94a588), {
        value: {
            opened: opened,
            close: handleClose,
            open: handleOpen,
            focusFirstItem: focusFirstItem,
            focusParentItem: focusParentItem,
            parentContext: parentSubCtx,
            setReference: refs.setReference,
            setFloating: refs.setFloating,
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            registerOpenSub: registerOpenSub
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4c321a5e1b48bbbf$export$5b6b19405a83ff9d), {
            opened: opened,
            onChange: (nextOpened)=>nextOpened ? handleOpen() : handleClose(),
            withinPortal: false,
            withArrow: false,
            id: id,
            position: position,
            ...others,
            children: children
        })
    });
}
$300249289ab5f594$export$71bdb9d1e2909932.extend = (input)=>input;
$300249289ab5f594$export$71bdb9d1e2909932.displayName = "@mantine/core/MenuSub";
$300249289ab5f594$export$71bdb9d1e2909932.Target = (0, $b5dfc3d62c418919$export$6287a8324ee05abc);
$300249289ab5f594$export$71bdb9d1e2909932.Dropdown = (0, $b5f3a2913c9bde9b$export$292b8e9f6a167e49);
$300249289ab5f594$export$71bdb9d1e2909932.Item = (0, $e7252f0f4d308177$export$2fbf84a81c8af983);








var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/Menu/MenuTarget/MenuTarget.tsx
const $7f217aaf04b867eb$var$defaultProps = {
    refProp: "ref"
};
function $7f217aaf04b867eb$export$4907565bcbceec95(props) {
    const { children: children, refProp: refProp, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuTarget", $7f217aaf04b867eb$var$defaultProps, props);
    const child = (0, $fc5f5fc6d9909a8d$export$1fd9bef6809ad57c)(children);
    if (!child) throw new Error("Menu.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    const ctx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    const _childProps = child.props;
    const onClick = (0, $528465f85c56cc6b$export$48d1ea6320830260)(_childProps.onClick, ()=>{
        if (ctx.trigger === "click") ctx.toggleDropdown();
        else if (ctx.trigger === "click-hover") {
            ctx.setOpenedViaClick(true);
            if (!ctx.opened) ctx.openDropdown();
        }
    });
    const onMouseEnter = (0, $528465f85c56cc6b$export$48d1ea6320830260)(_childProps.onMouseEnter, ()=>(ctx.trigger === "hover" || ctx.trigger === "click-hover") && ctx.openDropdown());
    const onMouseLeave = (0, $528465f85c56cc6b$export$48d1ea6320830260)(_childProps.onMouseLeave, ()=>{
        if (ctx.trigger === "hover") ctx.closeDropdown();
        else if (ctx.trigger === "click-hover" && !ctx.openedViaClick) ctx.closeDropdown();
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4c321a5e1b48bbbf$export$5b6b19405a83ff9d).Target, {
        refProp: refProp,
        popupType: "menu",
        ...others,
        children: (0, $acw62.cloneElement)(child, {
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            "data-expanded": ctx.opened ? true : void 0
        })
    });
}
$7f217aaf04b867eb$export$4907565bcbceec95.displayName = "@mantine/core/MenuTarget";



var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/Menu/Menu.tsx
const $80a28427109ce9ef$var$defaultProps = {
    trapFocus: true,
    closeOnItemClick: true,
    withInitialFocusPlaceholder: true,
    clickOutsideEvents: [
        "mousedown",
        "touchstart",
        "keydown"
    ],
    loop: true,
    trigger: "click",
    openDelay: 0,
    closeDelay: 100,
    menuItemTabIndex: -1,
    alignItemsLabels: "with-indicators"
};
const $80a28427109ce9ef$export$d9b273488cd8ce6f = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Menu", $80a28427109ce9ef$var$defaultProps, _props);
    const { children: children, onOpen: onOpen, onClose: onClose, opened: opened, defaultOpened: defaultOpened, trapFocus: trapFocus, onChange: onChange, closeOnItemClick: closeOnItemClick, loop: loop, closeOnEscape: closeOnEscape, trigger: trigger, openDelay: openDelay, closeDelay: closeDelay, classNames: classNames, styles: styles, unstyled: unstyled, variant: variant, vars: vars, menuItemTabIndex: menuItemTabIndex, keepMounted: keepMounted, withInitialFocusPlaceholder: withInitialFocusPlaceholder, attributes: attributes, onExitTransitionEnd: onExitTransitionEnd, alignItemsLabels: alignItemsLabels, checkIcon: checkIcon, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Menu",
        classes: (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039),
        props: props,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes
    });
    const [_opened, setOpened] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: opened,
        defaultValue: defaultOpened,
        finalValue: false,
        onChange: onChange
    });
    const [openedViaClick, setOpenedViaClick] = (0, $acw62.useState)(false);
    const close = ()=>{
        setOpened(false);
        setOpenedViaClick(false);
        _opened && onClose?.();
    };
    const open = ()=>{
        setOpened(true);
        !_opened && onOpen?.();
    };
    const toggleDropdown = ()=>{
        _opened ? close() : open();
    };
    const { openDropdown: openDropdown, closeDropdown: closeDropdown } = (0, $408ab93e040f8067$export$7771a820816ce7f1)({
        open: open,
        close: close,
        closeDelay: closeDelay,
        openDelay: openDelay
    });
    const activeSubCloseRef = (0, $acw62.useRef)(null);
    const registerOpenSub = (0, $acw62.useCallback)((closeFn)=>{
        const prev = activeSubCloseRef.current;
        if (prev && prev !== closeFn) prev();
        activeSubCloseRef.current = closeFn;
        return ()=>{
            if (activeSubCloseRef.current === closeFn) activeSubCloseRef.current = null;
        };
    }, []);
    const searchCountRef = (0, $acw62.useRef)(0);
    const [hasSearch, setHasSearch] = (0, $acw62.useState)(false);
    const registerSearch = (0, $acw62.useCallback)(()=>{
        searchCountRef.current += 1;
        if (searchCountRef.current === 1) setHasSearch(true);
        return ()=>{
            searchCountRef.current -= 1;
            if (searchCountRef.current === 0) setHasSearch(false);
        };
    }, []);
    const searchExitClearRef = (0, $acw62.useRef)(null);
    const handleExitTransitionEnd = ()=>{
        searchExitClearRef.current?.();
        onExitTransitionEnd?.();
    };
    const getItemIndex = (node)=>(0, $ec739097b6605e9b$export$b6cd2ea9779a9a9a)("[data-menu-item]", "[data-menu-dropdown]", node);
    const { resolvedClassNames: resolvedClassNames, resolvedStyles: resolvedStyles } = (0, $3da94ce37793f66c$export$92dc9b0c0bd35ec0)({
        classNames: classNames,
        styles: styles,
        props: props
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $1a88617e76f04480$export$2cad3fd48ac06579), {
        value: {
            getStyles: getStyles,
            opened: _opened,
            toggleDropdown: toggleDropdown,
            getItemIndex: getItemIndex,
            openedViaClick: openedViaClick,
            setOpenedViaClick: setOpenedViaClick,
            closeOnItemClick: closeOnItemClick,
            closeDropdown: trigger === "click" ? close : closeDropdown,
            openDropdown: trigger === "click" ? open : openDropdown,
            closeDropdownImmediately: close,
            loop: loop,
            trigger: trigger,
            unstyled: unstyled,
            menuItemTabIndex: menuItemTabIndex,
            withInitialFocusPlaceholder: withInitialFocusPlaceholder,
            registerOpenSub: registerOpenSub,
            hasSearch: hasSearch,
            registerSearch: registerSearch,
            searchExitClearRef: searchExitClearRef,
            alignItemsLabels: alignItemsLabels,
            checkIcon: checkIcon
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4c321a5e1b48bbbf$export$5b6b19405a83ff9d), {
            returnFocus: true,
            ...others,
            opened: _opened,
            onChange: toggleDropdown,
            defaultOpened: defaultOpened,
            trapFocus: keepMounted ? false : trapFocus,
            closeOnEscape: closeOnEscape,
            __staticSelector: "Menu",
            classNames: resolvedClassNames,
            styles: resolvedStyles,
            unstyled: unstyled,
            variant: variant,
            keepMounted: keepMounted,
            onExitTransitionEnd: handleExitTransitionEnd,
            children: children
        })
    });
});
$80a28427109ce9ef$export$d9b273488cd8ce6f.displayName = "@mantine/core/Menu";
$80a28427109ce9ef$export$d9b273488cd8ce6f.classes = (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039);
$80a28427109ce9ef$export$d9b273488cd8ce6f.Item = (0, $a0cdadc3699aa402$export$2ce376c2cc3355c8);
$80a28427109ce9ef$export$d9b273488cd8ce6f.Label = (0, $4b566499fd345957$export$dd37bec0e8a99143);
$80a28427109ce9ef$export$d9b273488cd8ce6f.Dropdown = (0, $f3829f8ad9101183$export$c7794ca2de686af4);
$80a28427109ce9ef$export$d9b273488cd8ce6f.Target = (0, $7f217aaf04b867eb$export$4907565bcbceec95);
$80a28427109ce9ef$export$d9b273488cd8ce6f.Divider = (0, $0e186a6eac2a78c1$export$acb07b4664ac227c);
$80a28427109ce9ef$export$d9b273488cd8ce6f.Search = (0, $c2fee559b90f1e25$export$99430cbd4bdb746c);
$80a28427109ce9ef$export$d9b273488cd8ce6f.Sub = (0, $300249289ab5f594$export$71bdb9d1e2909932);
$80a28427109ce9ef$export$d9b273488cd8ce6f.CheckboxItem = (0, $02d0ba7e88e0ce9f$export$f6f243521332502d);
$80a28427109ce9ef$export$d9b273488cd8ce6f.CheckboxGroup = (0, $3ef21e6ef8208c50$export$1e188c9c826116ca);
$80a28427109ce9ef$export$d9b273488cd8ce6f.RadioItem = (0, $b731b70c4e5ddae8$export$69bd225e9817f6d0);
$80a28427109ce9ef$export$d9b273488cd8ce6f.RadioGroup = (0, $a63c2b54de036797$export$ea2200c9eee416b3);
$80a28427109ce9ef$export$d9b273488cd8ce6f.ContextMenu = (0, $707eea501bb3c916$export$1ca9a6b43409b647);







"use client";
//#region packages/@mantine/core/src/components/Stack/Stack.module.css
var $746950b42ffaa06e$export$2e2bcd8739ae039 = {
    "root": "m_6d731127"
};



"use client";
//#region packages/@mantine/core/src/components/Stack/Stack.tsx
const $8d008d85a5081d2e$var$defaultProps = {
    gap: "md",
    align: "stretch",
    justify: "flex-start"
};
const $8d008d85a5081d2e$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { gap: gap, align: align, justify: justify })=>({
        root: {
            "--stack-gap": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(gap),
            "--stack-align": align,
            "--stack-justify": justify
        }
    }));
const $8d008d85a5081d2e$export$694e0d28c7ffc90c = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Stack", $8d008d85a5081d2e$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, align: align, justify: justify, gap: gap, variant: variant, attributes: attributes, ...others } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...(0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
            name: "Stack",
            props: props,
            classes: (0, $746950b42ffaa06e$export$2e2bcd8739ae039),
            className: className,
            style: style,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            attributes: attributes,
            vars: vars,
            varsResolver: $8d008d85a5081d2e$var$varsResolver
        })("root"),
        variant: variant,
        ...others
    });
});
$8d008d85a5081d2e$export$694e0d28c7ffc90c.classes = (0, $746950b42ffaa06e$export$2e2bcd8739ae039);
$8d008d85a5081d2e$export$694e0d28c7ffc90c.varsResolver = $8d008d85a5081d2e$var$varsResolver;
$8d008d85a5081d2e$export$694e0d28c7ffc90c.displayName = "@mantine/core/Stack";










"use client";
//#region packages/@mantine/core/src/components/Table/Table.context.ts
const [$cc322f16227fbd49$export$d542ac353845c9cf, $cc322f16227fbd49$export$3cb274deb6c2d854] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("Table component was not found in the tree");


"use client";
//#region packages/@mantine/core/src/components/Table/Table.module.css
var $d85151a9237c0fce$export$2e2bcd8739ae039 = {
    "table": "m_b23fa0ef",
    "th": "m_4e7aa4f3",
    "tr": "m_4e7aa4fd",
    "td": "m_4e7aa4ef",
    "tbody": "m_b2404537",
    "thead": "m_b242d975",
    "caption": "m_9e5a3ac7",
    "scrollContainer": "m_a100c15",
    "scrollContainerInner": "m_62259741"
};








"use client";
//#region packages/@mantine/core/src/components/Table/Table.components.tsx
function $07c9407238c41315$var$getDataAttributes(ctx, options) {
    if (!options) return;
    const data = {};
    if (options.columnBorder && ctx.withColumnBorders) data["data-with-column-border"] = true;
    if (options.rowBorder && ctx.withRowBorders) data["data-with-row-border"] = true;
    if (options.striped && ctx.striped) data["data-striped"] = ctx.striped;
    if (options.highlightOnHover && ctx.highlightOnHover) data["data-hover"] = true;
    if (options.captionSide && ctx.captionSide) data["data-side"] = ctx.captionSide;
    if (options.stickyHeader && ctx.stickyHeader) data["data-sticky"] = true;
    return data;
}
function $07c9407238c41315$var$tableElement(element, options) {
    const name = `Table${element.charAt(0).toUpperCase()}${element.slice(1)}`;
    const Component = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
        const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)(name, {}, _props);
        const { classNames: classNames, className: className, style: style, styles: styles, ...others } = props;
        const ctx = (0, $cc322f16227fbd49$export$3cb274deb6c2d854)();
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
            component: element,
            ...$07c9407238c41315$var$getDataAttributes(ctx, options),
            ...ctx.getStyles(element, {
                className: className,
                classNames: classNames,
                style: style,
                styles: styles,
                props: props
            }),
            ...others
        });
    });
    Component.displayName = `@mantine/core/${name}`;
    Component.classes = (0, $d85151a9237c0fce$export$2e2bcd8739ae039);
    return Component;
}
const $07c9407238c41315$export$b54b56bc5929d6ba = $07c9407238c41315$var$tableElement("th", {
    columnBorder: true
});
const $07c9407238c41315$export$d803e431f42194e1 = $07c9407238c41315$var$tableElement("td", {
    columnBorder: true
});
const $07c9407238c41315$export$ba50798da7e9465d = $07c9407238c41315$var$tableElement("tr", {
    rowBorder: true,
    striped: true,
    highlightOnHover: true
});
const $07c9407238c41315$export$d05270ef946439ab = $07c9407238c41315$var$tableElement("thead", {
    stickyHeader: true
});
const $07c9407238c41315$export$8654d3c315c67484 = $07c9407238c41315$var$tableElement("tbody");
const $07c9407238c41315$export$9b64bf4087a4d538 = $07c9407238c41315$var$tableElement("tfoot");
const $07c9407238c41315$export$35468a455d619eb3 = $07c9407238c41315$var$tableElement("caption", {
    captionSide: true
});




"use client";
//#region packages/@mantine/core/src/components/Table/TableDataRenderer.tsx
function $707042c615cfc7bd$export$e08ca53b528eacac({ data: data }) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            data.caption && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $07c9407238c41315$export$35468a455d619eb3), {
                children: data.caption
            }),
            data.head && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $07c9407238c41315$export$d05270ef946439ab), {
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $07c9407238c41315$export$ba50798da7e9465d), {
                    children: data.head.map((item, index)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $07c9407238c41315$export$b54b56bc5929d6ba), {
                            children: item
                        }, index))
                })
            }),
            data.body && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $07c9407238c41315$export$8654d3c315c67484), {
                children: data.body.map((row, rowIndex)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $07c9407238c41315$export$ba50798da7e9465d), {
                        children: row.map((item, index)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $07c9407238c41315$export$d803e431f42194e1), {
                                children: item
                            }, index))
                    }, rowIndex))
            }),
            data.foot && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $07c9407238c41315$export$9b64bf4087a4d538), {
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $07c9407238c41315$export$ba50798da7e9465d), {
                    children: data.foot.map((item, index)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $07c9407238c41315$export$b54b56bc5929d6ba), {
                            children: item
                        }, index))
                })
            })
        ]
    });
}
$707042c615cfc7bd$export$e08ca53b528eacac.displayName = "@mantine/core/TableDataRenderer";











"use client";
//#region packages/@mantine/core/src/components/Table/TableScrollContainer.tsx
const $0006b9aca1f51f42$var$defaultProps = {
    type: "scrollarea"
};
const $0006b9aca1f51f42$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { minWidth: minWidth, maxHeight: maxHeight, type: type })=>({
        scrollContainer: {
            "--table-min-width": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(minWidth),
            "--table-max-height": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(maxHeight),
            "--table-overflow": type === "native" ? "auto" : void 0
        }
    }));
const $0006b9aca1f51f42$export$260673f56ecd4915 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("TableScrollContainer", $0006b9aca1f51f42$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, children: children, minWidth: minWidth, maxHeight: maxHeight, type: type, scrollAreaProps: scrollAreaProps, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "TableScrollContainer",
        classes: (0, $d85151a9237c0fce$export$2e2bcd8739ae039),
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $0006b9aca1f51f42$var$varsResolver,
        rootSelector: "scrollContainer"
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: type === "scrollarea" ? (0, $dffe8bd53d7188f1$export$ccf8d8d7bbf3c2cc) : "div",
        ...type === "scrollarea" ? maxHeight ? {
            offsetScrollbars: "xy",
            ...scrollAreaProps
        } : {
            offsetScrollbars: "x",
            ...scrollAreaProps
        } : {},
        ...getStyles("scrollContainer"),
        ...others,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...getStyles("scrollContainerInner"),
            children: children
        })
    });
});
$0006b9aca1f51f42$export$260673f56ecd4915.classes = (0, $d85151a9237c0fce$export$2e2bcd8739ae039);
$0006b9aca1f51f42$export$260673f56ecd4915.varsResolver = $0006b9aca1f51f42$var$varsResolver;
$0006b9aca1f51f42$export$260673f56ecd4915.displayName = "@mantine/core/TableScrollContainer";



"use client";
//#region packages/@mantine/core/src/components/Table/Table.tsx
const $721ee3a0af31156e$var$defaultProps = {
    withRowBorders: true,
    verticalSpacing: 7
};
const $721ee3a0af31156e$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { layout: layout, captionSide: captionSide, horizontalSpacing: horizontalSpacing, verticalSpacing: verticalSpacing, borderColor: borderColor, stripedColor: stripedColor, highlightOnHoverColor: highlightOnHoverColor, striped: striped, highlightOnHover: highlightOnHover, stickyHeaderOffset: stickyHeaderOffset, stickyHeader: stickyHeader })=>({
        table: {
            "--table-layout": layout,
            "--table-caption-side": captionSide,
            "--table-horizontal-spacing": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(horizontalSpacing),
            "--table-vertical-spacing": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(verticalSpacing),
            "--table-border-color": borderColor ? (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(borderColor, theme) : void 0,
            "--table-striped-color": striped && stripedColor ? (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(stripedColor, theme) : void 0,
            "--table-highlight-on-hover-color": highlightOnHover && highlightOnHoverColor ? (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(highlightOnHoverColor, theme) : void 0,
            "--table-sticky-header-offset": stickyHeader ? (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(stickyHeaderOffset) : void 0
        }
    }));
const $721ee3a0af31156e$export$54ec01a60f47d33d = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Table", $721ee3a0af31156e$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, horizontalSpacing: horizontalSpacing, verticalSpacing: verticalSpacing, captionSide: captionSide, stripedColor: stripedColor, highlightOnHoverColor: highlightOnHoverColor, striped: striped, highlightOnHover: highlightOnHover, withColumnBorders: withColumnBorders, withRowBorders: withRowBorders, withTableBorder: withTableBorder, borderColor: borderColor, layout: layout, data: data, children: children, stickyHeader: stickyHeader, stickyHeaderOffset: stickyHeaderOffset, mod: mod, tabularNums: tabularNums, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Table",
        props: props,
        className: className,
        style: style,
        classes: (0, $d85151a9237c0fce$export$2e2bcd8739ae039),
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        rootSelector: "table",
        vars: vars,
        varsResolver: $721ee3a0af31156e$var$varsResolver
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cc322f16227fbd49$export$d542ac353845c9cf), {
        value: {
            getStyles: getStyles,
            stickyHeader: stickyHeader,
            striped: striped === true ? "odd" : striped || void 0,
            highlightOnHover: highlightOnHover,
            withColumnBorders: withColumnBorders,
            withRowBorders: withRowBorders,
            captionSide: captionSide || "bottom"
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
            component: "table",
            mod: [
                {
                    "data-with-table-border": withTableBorder,
                    "data-tabular-nums": tabularNums
                },
                mod
            ],
            ...getStyles("table"),
            ...others,
            children: children || !!data && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $707042c615cfc7bd$export$e08ca53b528eacac), {
                data: data
            })
        })
    });
});
$721ee3a0af31156e$export$54ec01a60f47d33d.classes = (0, $d85151a9237c0fce$export$2e2bcd8739ae039);
$721ee3a0af31156e$export$54ec01a60f47d33d.varsResolver = $721ee3a0af31156e$var$varsResolver;
$721ee3a0af31156e$export$54ec01a60f47d33d.displayName = "@mantine/core/Table";
$721ee3a0af31156e$export$54ec01a60f47d33d.Td = (0, $07c9407238c41315$export$d803e431f42194e1);
$721ee3a0af31156e$export$54ec01a60f47d33d.Th = (0, $07c9407238c41315$export$b54b56bc5929d6ba);
$721ee3a0af31156e$export$54ec01a60f47d33d.Tr = (0, $07c9407238c41315$export$ba50798da7e9465d);
$721ee3a0af31156e$export$54ec01a60f47d33d.Thead = (0, $07c9407238c41315$export$d05270ef946439ab);
$721ee3a0af31156e$export$54ec01a60f47d33d.Tbody = (0, $07c9407238c41315$export$8654d3c315c67484);
$721ee3a0af31156e$export$54ec01a60f47d33d.Tfoot = (0, $07c9407238c41315$export$9b64bf4087a4d538);
$721ee3a0af31156e$export$54ec01a60f47d33d.Caption = (0, $07c9407238c41315$export$35468a455d619eb3);
$721ee3a0af31156e$export$54ec01a60f47d33d.ScrollContainer = (0, $0006b9aca1f51f42$export$260673f56ecd4915);
$721ee3a0af31156e$export$54ec01a60f47d33d.DataRenderer = (0, $707042c615cfc7bd$export$e08ca53b528eacac);

"use client";
//#region packages/@mantine/core/src/core/utils/get-safe-id/get-safe-id.ts
function $aedbb40cfdf4bb61$export$d1aa29729505dfb6(uid, errorMessage) {
    return (value)=>{
        if (typeof value !== "string" || value.trim().length === 0) throw new Error(errorMessage);
        return `${uid}-${value}`;
    };
}






"use client";
//#region packages/@mantine/core/src/core/MantineProvider/color-functions/get-auto-contrast-value/get-auto-contrast-value.ts
function $cd82beaf4d657eca$export$f96537d1a39af9b2(autoContrast, theme) {
    return typeof autoContrast === "boolean" ? autoContrast : theme.autoContrast;
}







"use client";
//#region packages/@mantine/core/src/components/Tabs/Tabs.context.ts
const [$5905eb7e15bb4b24$export$aea4e5437b3b752e, $5905eb7e15bb4b24$export$5c3d36c3adf0ba92] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("Tabs component was not found in the tree");


"use client";
//#region packages/@mantine/core/src/components/Tabs/Tabs.module.css
var $9c3d303d713905d5$export$2e2bcd8739ae039 = {
    "root": "m_89d60db1",
    "list--default": "m_576c9d4",
    "list": "m_89d33d6d",
    "tab": "m_4ec4dce6",
    "panel": "m_b0c91715",
    "tabSection": "m_fc420b1f",
    "tabLabel": "m_42bbd1ae",
    "tab--default": "m_539e827b",
    "list--outline": "m_6772fbd5",
    "tab--outline": "m_b59ab47c",
    "tab--pills": "m_c3381914"
};








"use client";
//#region packages/@mantine/core/src/components/Tabs/TabsList/TabsList.tsx
const $81881f375744b8d8$export$9712d22edc0d78c1 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("TabsList", null, _props);
    const { children: children, className: className, grow: grow, justify: justify, classNames: classNames, styles: styles, style: style, mod: mod, ...others } = props;
    const ctx = (0, $5905eb7e15bb4b24$export$5c3d36c3adf0ba92)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...ctx.getStyles("list", {
            className: className,
            style: style,
            classNames: classNames,
            styles: styles,
            props: props,
            variant: ctx.variant
        }),
        role: "tablist",
        variant: ctx.variant,
        mod: [
            {
                grow: grow,
                orientation: ctx.orientation,
                placement: ctx.orientation === "vertical" && ctx.placement,
                inverted: ctx.inverted
            },
            mod
        ],
        "aria-orientation": ctx.orientation,
        __vars: {
            "--tabs-justify": justify
        },
        ...others,
        children: children
    });
});
$81881f375744b8d8$export$9712d22edc0d78c1.classes = (0, $9c3d303d713905d5$export$2e2bcd8739ae039);
$81881f375744b8d8$export$9712d22edc0d78c1.displayName = "@mantine/core/TabsList";









var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/Tabs/TabsPanel/TabsPanel.tsx
const $e57d63711cff6295$export$9128fd9f25f0e0ae = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("TabsPanel", null, _props);
    const { children: children, className: className, value: value, classNames: classNames, styles: styles, style: style, mod: mod, keepMounted: keepMounted, ...others } = props;
    const env = (0, $bbb97275c373484a$export$2a0cf0a5fd0c6e81)();
    const ctx = (0, $5905eb7e15bb4b24$export$5c3d36c3adf0ba92)();
    (0, $acw62.useEffect)(()=>{
        ctx.setMountedPanel(value, true);
        return ()=>{
            ctx.setMountedPanel(value, false);
        };
    }, [
        value
    ]);
    const active = ctx.value === value;
    const shouldKeepMounted = ctx.keepMounted || keepMounted;
    const useActivity = ctx.keepMountedMode !== "display-none";
    const content = shouldKeepMounted && useActivity && env !== "test" ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Activity), {
        mode: active ? "visible" : "hidden",
        children: children
    }) : shouldKeepMounted ? children : active ? children : null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...ctx.getStyles("panel", {
            className: className,
            classNames: classNames,
            styles: styles,
            style: [
                style,
                !active ? {
                    display: "none"
                } : void 0
            ],
            props: props
        }),
        mod: [
            {
                orientation: ctx.orientation
            },
            mod
        ],
        role: "tabpanel",
        id: ctx.getPanelId(value),
        "aria-labelledby": ctx.getTabId(value),
        ...others,
        children: content
    });
});
$e57d63711cff6295$export$9128fd9f25f0e0ae.classes = (0, $9c3d303d713905d5$export$2e2bcd8739ae039);
$e57d63711cff6295$export$9128fd9f25f0e0ae.displayName = "@mantine/core/TabsPanel";












"use client";
//#region packages/@mantine/core/src/components/Tabs/TabsTab/TabsTab.tsx
const $9065b034395e5d74$export$14c106d4bbb1624a = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("TabsTab", null, _props);
    const { className: className, children: children, rightSection: rightSection, leftSection: leftSection, value: value, onClick: onClick, onKeyDown: onKeyDown, disabled: disabled, color: color, style: style, classNames: classNames, styles: styles, vars: vars, mod: mod, tabIndex: tabIndex, ...others } = props;
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const { dir: dir } = (0, $35c57ac18e24a61d$export$b39126d51d94e6f3)();
    const ctx = (0, $5905eb7e15bb4b24$export$5c3d36c3adf0ba92)();
    const active = value === ctx.value;
    const activateTab = (event)=>{
        ctx.onChange(ctx.allowTabDeactivation ? value === ctx.value ? null : value : value);
        onClick?.(event);
    };
    const stylesApiProps = {
        classNames: classNames,
        styles: styles,
        props: props
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), {
        ...ctx.getStyles("tab", {
            className: className,
            style: style,
            variant: ctx.variant,
            ...stylesApiProps
        }),
        disabled: disabled,
        unstyled: ctx.unstyled,
        variant: ctx.variant,
        mod: [
            {
                active: active,
                disabled: disabled,
                orientation: ctx.orientation,
                inverted: ctx.inverted,
                placement: ctx.orientation === "vertical" && ctx.placement
            },
            mod
        ],
        role: "tab",
        id: ctx.getTabId(value),
        "aria-selected": active,
        tabIndex: tabIndex !== void 0 ? tabIndex : active || ctx.value === null ? 0 : -1,
        "aria-controls": ctx.mountedPanels.current.has(value) ? ctx.getPanelId(value) : void 0,
        onClick: activateTab,
        __vars: {
            "--tabs-color": color ? (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(color, theme) : void 0
        },
        onKeyDown: (0, $afa38183edceda99$export$5b1acc7188190893)({
            siblingSelector: "[role=\"tab\"]",
            parentSelector: "[role=\"tablist\"]",
            activateOnFocus: ctx.activateTabWithKeyboard,
            loop: ctx.loop,
            orientation: ctx.orientation || "horizontal",
            dir: dir,
            onKeyDown: onKeyDown
        }),
        ...others,
        children: [
            leftSection && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...ctx.getStyles("tabSection", stylesApiProps),
                "data-position": "left",
                children: leftSection
            }),
            children && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...ctx.getStyles("tabLabel", stylesApiProps),
                children: children
            }),
            rightSection && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...ctx.getStyles("tabSection", stylesApiProps),
                "data-position": "right",
                children: rightSection
            })
        ]
    });
});
$9065b034395e5d74$export$14c106d4bbb1624a.classes = (0, $9c3d303d713905d5$export$2e2bcd8739ae039);
$9065b034395e5d74$export$14c106d4bbb1624a.displayName = "@mantine/core/TabsTab";



var $acw62 = parcelRequire("acw62");


"use client";
//#region packages/@mantine/core/src/components/Tabs/Tabs.tsx
const $c45c38e75a424966$var$VALUE_ERROR = "Tabs.Tab or Tabs.Panel component was rendered with invalid value or without value";
const $c45c38e75a424966$var$defaultProps = {
    keepMounted: true,
    keepMountedMode: "activity",
    orientation: "horizontal",
    loop: true,
    activateTabWithKeyboard: true,
    variant: "default",
    placement: "left"
};
const $c45c38e75a424966$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { radius: radius, color: color, autoContrast: autoContrast })=>({
        root: {
            "--tabs-radius": (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--tabs-color": (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(color, theme),
            "--tabs-text-color": (0, $cd82beaf4d657eca$export$f96537d1a39af9b2)(autoContrast, theme) ? (0, $9082801c02aa279b$export$77a1051494882576)({
                color: color,
                theme: theme,
                autoContrast: autoContrast
            }) : void 0
        }
    }));
const $c45c38e75a424966$export$b2539bed5023c21c = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Tabs", $c45c38e75a424966$var$defaultProps, _props);
    const { defaultValue: defaultValue, value: value, onChange: onChange, orientation: orientation, children: children, loop: loop, id: id, activateTabWithKeyboard: activateTabWithKeyboard, allowTabDeactivation: allowTabDeactivation, variant: variant, color: color, radius: radius, inverted: inverted, placement: placement, keepMounted: keepMounted, keepMountedMode: keepMountedMode, classNames: classNames, styles: styles, unstyled: unstyled, className: className, style: style, vars: vars, autoContrast: autoContrast, mod: mod, attributes: attributes, ...others } = props;
    const uid = (0, $cee42e5537afff93$export$f680877a34711e37)(id);
    const mountedPanels = (0, $acw62.useRef)(/* @__PURE__ */ new Set());
    const forceUpdate = (0, $aaffb9e6ba2a5054$export$91db9bc4f8ac944a)();
    const setMountedPanel = (0, $acw62.useCallback)((panelValue, mounted)=>{
        const panels = mountedPanels.current;
        if (mounted && !panels.has(panelValue)) {
            panels.add(panelValue);
            forceUpdate();
        } else if (!mounted && panels.has(panelValue)) {
            panels.delete(panelValue);
            forceUpdate();
        }
    }, []);
    const [currentTab, setCurrentTab] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: value,
        defaultValue: defaultValue,
        finalValue: null,
        onChange: onChange
    });
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Tabs",
        props: props,
        classes: (0, $9c3d303d713905d5$export$2e2bcd8739ae039),
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $c45c38e75a424966$var$varsResolver
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $5905eb7e15bb4b24$export$aea4e5437b3b752e), {
        value: {
            placement: placement,
            value: currentTab,
            orientation: orientation,
            id: uid,
            loop: loop,
            activateTabWithKeyboard: activateTabWithKeyboard,
            getTabId: (0, $aedbb40cfdf4bb61$export$d1aa29729505dfb6)(`${uid}-tab`, $c45c38e75a424966$var$VALUE_ERROR),
            getPanelId: (0, $aedbb40cfdf4bb61$export$d1aa29729505dfb6)(`${uid}-panel`, $c45c38e75a424966$var$VALUE_ERROR),
            onChange: setCurrentTab,
            allowTabDeactivation: allowTabDeactivation,
            variant: variant,
            color: color,
            radius: radius,
            inverted: inverted,
            keepMounted: keepMounted,
            keepMountedMode: keepMountedMode,
            unstyled: unstyled,
            getStyles: getStyles,
            mountedPanels: mountedPanels,
            setMountedPanel: setMountedPanel
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
            id: uid,
            variant: variant,
            mod: [
                {
                    orientation: orientation,
                    inverted: orientation === "horizontal" && inverted,
                    placement: orientation === "vertical" && placement
                },
                mod
            ],
            ...getStyles("root"),
            ...others,
            children: children
        })
    });
});
$c45c38e75a424966$export$b2539bed5023c21c.classes = (0, $9c3d303d713905d5$export$2e2bcd8739ae039);
$c45c38e75a424966$export$b2539bed5023c21c.varsResolver = $c45c38e75a424966$var$varsResolver;
$c45c38e75a424966$export$b2539bed5023c21c.displayName = "@mantine/core/Tabs";
$c45c38e75a424966$export$b2539bed5023c21c.Tab = (0, $9065b034395e5d74$export$14c106d4bbb1624a);
$c45c38e75a424966$export$b2539bed5023c21c.Panel = (0, $e57d63711cff6295$export$9128fd9f25f0e0ae);
$c45c38e75a424966$export$b2539bed5023c21c.List = (0, $81881f375744b8d8$export$9712d22edc0d78c1);








"use client";
//#region packages/@mantine/core/src/components/Text/Text.module.css
var $ea78a9b6a5023729$export$2e2bcd8739ae039 = {
    "root": "m_b6d8b162"
};



"use client";
//#region packages/@mantine/core/src/components/Text/Text.tsx
function $5889434a75bd9d22$var$getTextTruncate(truncate) {
    if (truncate === "start") return "start";
    if (truncate === "end" || truncate) return "end";
}
const $5889434a75bd9d22$var$defaultProps = {
    inherit: false
};
const $5889434a75bd9d22$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { variant: variant, lineClamp: lineClamp, gradient: gradient, size: size, textWrap: textWrap })=>({
        root: {
            "--text-fz": (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--text-lh": (0, $fcab4af601ce7e99$export$56204a27a2958a55)(size),
            "--text-gradient": variant === "gradient" ? (0, $bdea122fb92e1007$export$e14995d3ec1747ee)(gradient, theme) : void 0,
            "--text-line-clamp": typeof lineClamp === "number" ? lineClamp.toString() : void 0,
            "--text-text-wrap": textWrap
        }
    }));
const $5889434a75bd9d22$export$5f1af8db9871e1d6 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Text", $5889434a75bd9d22$var$defaultProps, _props);
    const { lineClamp: lineClamp, truncate: truncate, inline: inline, inherit: inherit, gradient: gradient, span: span, textWrap: textWrap, __staticSelector: __staticSelector, vars: vars, className: className, style: style, classNames: classNames, styles: styles, unstyled: unstyled, variant: variant, mod: mod, size: size, attributes: attributes, ...others } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...(0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
            name: [
                "Text",
                __staticSelector
            ],
            props: props,
            classes: (0, $ea78a9b6a5023729$export$2e2bcd8739ae039),
            className: className,
            style: style,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            attributes: attributes,
            vars: vars,
            varsResolver: $5889434a75bd9d22$var$varsResolver
        })("root", {
            focusable: true
        }),
        component: span ? "span" : "p",
        variant: variant,
        mod: [
            {
                "data-truncate": $5889434a75bd9d22$var$getTextTruncate(truncate),
                "data-line-clamp": typeof lineClamp === "number",
                "data-inline": inline,
                "data-inherit": inherit
            },
            mod
        ],
        size: size,
        ...others
    });
});
$5889434a75bd9d22$export$5f1af8db9871e1d6.classes = (0, $ea78a9b6a5023729$export$2e2bcd8739ae039);
$5889434a75bd9d22$export$5f1af8db9871e1d6.varsResolver = $5889434a75bd9d22$var$varsResolver;
$5889434a75bd9d22$export$5f1af8db9871e1d6.displayName = "@mantine/core/Text";


/**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $d8d743109e593438$export$2e2bcd8739ae039 = {
    outline: {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    },
    filled: {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "currentColor",
        stroke: "none"
    }
};


const $181aa196ec8b5be7$export$2e2bcd8739ae039 = (type, iconName, iconNamePascal, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, stroke: stroke = 2, title: title, className: className, children: children, ...rest }, ref)=>(0, $acw62.createElement)("svg", {
            ref: ref,
            ...(0, $d8d743109e593438$export$2e2bcd8739ae039)[type],
            width: size,
            height: size,
            className: [
                `tabler-icon`,
                `tabler-icon-${iconName}`,
                className
            ].join(" "),
            ...type === "filled" ? {
                fill: color
            } : {
                strokeWidth: stroke,
                stroke: color
            },
            ...rest
        }, [
            title && (0, $acw62.createElement)("title", {
                key: "svg-title"
            }, title),
            ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
            ...Array.isArray(children) ? children : [
                children
            ]
        ]));
    Component.displayName = `${iconNamePascal}`;
    return Component;
};


const $fc48fe382c89157e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M18 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
            "key": "svg-2"
        }
    ]
];
const $fc48fe382c89157e$export$2e2bcd8739ae039 = (0, $181aa196ec8b5be7$export$2e2bcd8739ae039)("outline", "dots", "Dots", $fc48fe382c89157e$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");
// src/mutationObserver.ts




var $1ddf06f11bccca52$export$d3c1860ee66f291a = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    #client;
    #currentResult = void 0;
    #currentMutation;
    #mutateOptions;
    constructor(client, options){
        super();
        this.#client = client;
        this.setOptions(options);
        this.bindMethods();
        this.#updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        this.options = this.#client.defaultMutationOptions(options);
        if (!(0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(this.options, prevOptions)) this.#client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.#currentMutation,
            observer: this
        });
        if (prevOptions?.mutationKey && this.options.mutationKey && (0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (this.#currentMutation?.state.status === "pending") this.#currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.#currentMutation?.removeObserver(this);
    }
    onMutationUpdate(action) {
        this.#updateResult();
        this.#notify(action);
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    reset() {
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = void 0;
        this.#updateResult();
        this.#notify();
    }
    mutate(variables, options) {
        this.#mutateOptions = options;
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = this.#client.getMutationCache().build(this.#client, this.options);
        this.#currentMutation.addObserver(this);
        return this.#currentMutation.execute(variables);
    }
    #updateResult() {
        const state = this.#currentMutation?.state ?? (0, $524c502dbe70a85f$export$a1659b54bac3252a)();
        this.#currentResult = {
            ...state,
            isPending: state.status === "pending",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
    }
    #notify(action) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            if (this.#mutateOptions && this.hasListeners()) {
                const variables = this.#currentResult.variables;
                const onMutateResult = this.#currentResult.context;
                const context = {
                    client: this.#client,
                    meta: this.options.meta,
                    mutationKey: this.options.mutationKey
                };
                if (action?.type === "success") {
                    try {
                        this.#mutateOptions.onSuccess?.(action.data, variables, onMutateResult, context);
                    } catch (e) {
                        Promise.reject(e);
                    }
                    try {
                        this.#mutateOptions.onSettled?.(action.data, null, variables, onMutateResult, context);
                    } catch (e) {
                        Promise.reject(e);
                    }
                } else if (action?.type === "error") {
                    try {
                        this.#mutateOptions.onError?.(action.error, variables, onMutateResult, context);
                    } catch (e) {
                        Promise.reject(e);
                    }
                    try {
                        this.#mutateOptions.onSettled?.(void 0, action.error, variables, onMutateResult, context);
                    } catch (e) {
                        Promise.reject(e);
                    }
                }
            }
            this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
        });
    }
};



"use client";
function $6a05afbd57376433$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $c780594f51309d36$export$22e77b9572c4fded)(queryClient);
    const [observer] = $acw62.useState(()=>new (0, $1ddf06f11bccca52$export$d3c1860ee66f291a)(client, options));
    $acw62.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>observer.subscribe((0, $e2307e33fb454067$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $acw62.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $938ae10f13d49bdc$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}

// src/queryObserver.ts








var $2905803326ac545c$export$a06cf8c0066f0d4c = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        this.#client = client;
        this.#selectError = null;
        this.#currentThenable = (0, $f6114de20f9a4572$export$d54630db02a12b72)();
        this.bindMethods();
        this.setOptions(options);
    }
    #client;
    #currentQuery = void 0;
    #currentQueryInitialState = void 0;
    #currentResult = void 0;
    #currentResultState;
    #currentResultOptions;
    #currentThenable;
    #selectError;
    #selectFn;
    #selectResult;
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    #lastQueryWithDefinedData;
    #staleTimeoutId;
    #refetchIntervalId;
    #currentRefetchInterval;
    #trackedProps = /* @__PURE__ */ new Set();
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.#currentQuery.addObserver(this);
            if ($2905803326ac545c$var$shouldFetchOnMount(this.#currentQuery, this.options)) this.#executeFetch();
            else this.updateResult();
            this.#updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $2905803326ac545c$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $2905803326ac545c$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        this.#clearStaleTimeout();
        this.#clearRefetchInterval();
        this.#currentQuery.removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = this.#currentQuery;
        this.options = this.#client.defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $938ae10f13d49bdc$export$d7ee3961208f79c1)(this.options.enabled, this.#currentQuery) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        this.#updateQuery();
        this.#currentQuery.setOptions(this.options);
        if (prevOptions._defaulted && !(0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(this.options, prevOptions)) this.#client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.#currentQuery,
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $2905803326ac545c$var$shouldFetchOptionally(this.#currentQuery, prevQuery, this.options, prevOptions)) this.#executeFetch();
        this.updateResult();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $938ae10f13d49bdc$export$d7ee3961208f79c1)(this.options.enabled, this.#currentQuery) !== (0, $938ae10f13d49bdc$export$d7ee3961208f79c1)(prevOptions.enabled, this.#currentQuery) || (0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(this.options.staleTime, this.#currentQuery) !== (0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(prevOptions.staleTime, this.#currentQuery))) this.#updateStaleTimeout();
        const nextRefetchInterval = this.#computeRefetchInterval();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $938ae10f13d49bdc$export$d7ee3961208f79c1)(this.options.enabled, this.#currentQuery) !== (0, $938ae10f13d49bdc$export$d7ee3961208f79c1)(prevOptions.enabled, this.#currentQuery) || nextRefetchInterval !== this.#currentRefetchInterval)) this.#updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.#client.getQueryCache().build(this.#client, options);
        const result = this.createResult(query, options);
        if ($2905803326ac545c$var$shouldAssignObserverCurrentProperties(this, result)) {
            this.#currentResult = result;
            this.#currentResultOptions = this.options;
            this.#currentResultState = this.#currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked?.(key);
                if (key === "promise") {
                    this.trackProp("data");
                    if (!this.options.experimental_prefetchInRender && this.#currentThenable.status === "pending") this.#currentThenable.reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
                }
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        this.#trackedProps.add(key);
    }
    getCurrentQuery() {
        return this.#currentQuery;
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.#client.defaultQueryOptions(options);
        const query = this.#client.getQueryCache().build(this.#client, defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return this.#executeFetch({
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return this.#currentResult;
        });
    }
    #executeFetch(fetchOptions) {
        this.#updateQuery();
        let promise = this.#currentQuery.fetch(this.options, fetchOptions);
        if (!fetchOptions?.throwOnError) promise = promise.catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
        return promise;
    }
    #updateStaleTimeout() {
        this.#clearStaleTimeout();
        const staleTime = (0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(this.options.staleTime, this.#currentQuery);
        if ((0, $bba8658037432dc5$export$2d935f1a9c9d3f3e).isServer() || this.#currentResult.isStale || !(0, $938ae10f13d49bdc$export$e539f754e934e270)(staleTime)) return;
        const time = (0, $938ae10f13d49bdc$export$811b83d62bcf47f0)(this.#currentResult.dataUpdatedAt, staleTime);
        const timeout = time + 1;
        this.#staleTimeoutId = (0, $b7f1384d98eac5cd$export$94a2700736e69372).setTimeout(()=>{
            if (!this.#currentResult.isStale) this.updateResult();
        }, timeout);
    }
    #computeRefetchInterval() {
        return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.#currentQuery) : this.options.refetchInterval) ?? false;
    }
    #updateRefetchInterval(nextInterval) {
        this.#clearRefetchInterval();
        this.#currentRefetchInterval = nextInterval;
        if ((0, $bba8658037432dc5$export$2d935f1a9c9d3f3e).isServer() || (0, $938ae10f13d49bdc$export$d7ee3961208f79c1)(this.options.enabled, this.#currentQuery) === false || !(0, $938ae10f13d49bdc$export$e539f754e934e270)(this.#currentRefetchInterval) || this.#currentRefetchInterval === 0) return;
        this.#refetchIntervalId = (0, $b7f1384d98eac5cd$export$94a2700736e69372).setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $3f1a0485b2ecb725$export$6bf54661be5b02cf).isFocused()) this.#executeFetch();
        }, this.#currentRefetchInterval);
    }
    #updateTimers() {
        this.#updateStaleTimeout();
        this.#updateRefetchInterval(this.#computeRefetchInterval());
    }
    #clearStaleTimeout() {
        if (this.#staleTimeoutId !== void 0) {
            (0, $b7f1384d98eac5cd$export$94a2700736e69372).clearTimeout(this.#staleTimeoutId);
            this.#staleTimeoutId = void 0;
        }
    }
    #clearRefetchInterval() {
        if (this.#refetchIntervalId !== void 0) {
            (0, $b7f1384d98eac5cd$export$94a2700736e69372).clearInterval(this.#refetchIntervalId);
            this.#refetchIntervalId = void 0;
        }
    }
    createResult(query, options) {
        const prevQuery = this.#currentQuery;
        const prevOptions = this.options;
        const prevResult = this.#currentResult;
        const prevResultState = this.#currentResultState;
        const prevResultOptions = this.#currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.#currentQueryInitialState;
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $2905803326ac545c$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $2905803326ac545c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $bbb5e4108fb61687$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if (prevResult?.isPlaceholderData && options.placeholderData === prevResultOptions?.placeholderData) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData(this.#lastQueryWithDefinedData?.state.data, this.#lastQueryWithDefinedData) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $938ae10f13d49bdc$export$17619bac5b909b23)(prevResult?.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === prevResultState?.data && options.select === this.#selectFn) data = this.#selectResult;
            else try {
                this.#selectFn = options.select;
                data = options.select(data);
                data = (0, $938ae10f13d49bdc$export$17619bac5b909b23)(prevResult?.data, data, options);
                this.#selectResult = data;
                this.#selectError = null;
            } catch (selectError) {
                this.#selectError = selectError;
            }
        }
        if (this.#selectError) {
            error = this.#selectError;
            data = this.#selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: query.isFetched(),
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $2905803326ac545c$var$isStale(query, options),
            refetch: this.refetch,
            promise: this.#currentThenable,
            isEnabled: (0, $938ae10f13d49bdc$export$d7ee3961208f79c1)(options.enabled, query) !== false
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const hasResultData = nextResult.data !== void 0;
            const isErrorWithoutData = nextResult.status === "error" && !hasResultData;
            const finalizeThenableIfPossible = (thenable)=>{
                if (isErrorWithoutData) thenable.reject(nextResult.error);
                else if (hasResultData) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = this.#currentThenable = nextResult.promise = (0, $f6114de20f9a4572$export$d54630db02a12b72)();
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = this.#currentThenable;
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (isErrorWithoutData || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (!isErrorWithoutData || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = this.#currentResult;
        const nextResult = this.createResult(this.#currentQuery, this.options);
        this.#currentResultState = this.#currentQuery.state;
        this.#currentResultOptions = this.options;
        if (this.#currentResultState.data !== void 0) this.#lastQueryWithDefinedData = this.#currentQuery;
        if ((0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.#currentResult = nextResult;
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.#trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? this.#trackedProps);
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys(this.#currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.#currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        this.#notify({
            listeners: shouldNotifyListeners()
        });
    }
    #updateQuery() {
        const query = this.#client.getQueryCache().build(this.#client, this.options);
        if (query === this.#currentQuery) return;
        const prevQuery = this.#currentQuery;
        this.#currentQuery = query;
        this.#currentQueryInitialState = query.state;
        if (this.hasListeners()) {
            prevQuery?.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) this.#updateTimers();
    }
    #notify(notifyOptions) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
            this.#client.getQueryCache().notify({
                query: this.#currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
};
function $2905803326ac545c$var$shouldLoadOnMount(query, options) {
    return (0, $938ae10f13d49bdc$export$d7ee3961208f79c1)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && (0, $938ae10f13d49bdc$export$d7ee3961208f79c1)(options.retryOnMount, query) === false);
}
function $2905803326ac545c$var$shouldFetchOnMount(query, options) {
    return $2905803326ac545c$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $2905803326ac545c$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $2905803326ac545c$var$shouldFetchOn(query, options, field) {
    if ((0, $938ae10f13d49bdc$export$d7ee3961208f79c1)(options.enabled, query) !== false && (0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $2905803326ac545c$var$isStale(query, options);
    }
    return false;
}
function $2905803326ac545c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $938ae10f13d49bdc$export$d7ee3961208f79c1)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $2905803326ac545c$var$isStale(query, options);
}
function $2905803326ac545c$var$isStale(query, options) {
    return (0, $938ae10f13d49bdc$export$d7ee3961208f79c1)(options.enabled, query) !== false && query.isStaleByTime((0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $2905803326ac545c$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

"use client";
function $3ccd03800b9b1a4a$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $3ccd03800b9b1a4a$var$QueryErrorResetBoundaryContext = $acw62.createContext($3ccd03800b9b1a4a$var$createValue());
var $3ccd03800b9b1a4a$export$50dfac555130cafd = ()=>$acw62.useContext($3ccd03800b9b1a4a$var$QueryErrorResetBoundaryContext);
var $3ccd03800b9b1a4a$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $acw62.useState(()=>$3ccd03800b9b1a4a$var$createValue());
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($3ccd03800b9b1a4a$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $acw62 = parcelRequire("acw62");

"use client";
var $b8d88d7bae8d797f$export$ae8adb3de3d77633 = (options, errorResetBoundary, query)=>{
    const throwOnError = query?.state.error && typeof options.throwOnError === "function" ? (0, $938ae10f13d49bdc$export$2072f68e6c3507cf)(options.throwOnError, [
        query.state.error,
        query
    ]) : options.throwOnError;
    if (options.suspense || options.experimental_prefetchInRender || throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $b8d88d7bae8d797f$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $acw62.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $b8d88d7bae8d797f$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $938ae10f13d49bdc$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};



var $acw62 = parcelRequire("acw62");
"use client";
var $b2f924bc70e540d6$var$IsRestoringContext = $acw62.createContext(false);
var $b2f924bc70e540d6$export$4da0178d6b5f553 = ()=>$acw62.useContext($b2f924bc70e540d6$var$IsRestoringContext);
var $b2f924bc70e540d6$export$593807d4e94f9621 = $b2f924bc70e540d6$var$IsRestoringContext.Provider;


// src/suspense.ts
var $d9109c84b9b954d9$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $d9109c84b9b954d9$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
var $d9109c84b9b954d9$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $d9109c84b9b954d9$export$88d3586dfed64df9 = (defaultedOptions, result)=>defaultedOptions?.suspense && result.isPending;
var $d9109c84b9b954d9$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $22b97878ddf0e02d$export$fff0865807e996c5(options, Observer, queryClient) {
    const isRestoring = (0, $b2f924bc70e540d6$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $3ccd03800b9b1a4a$export$50dfac555130cafd)();
    const client = (0, $c780594f51309d36$export$22e77b9572c4fded)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    client.getDefaultOptions().queries?._experimental_beforeQuery?.(defaultedOptions);
    const query = client.getQueryCache().get(defaultedOptions.queryHash);
    const subscribed = options.subscribed !== false;
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : subscribed ? "optimistic" : void 0;
    (0, $d9109c84b9b954d9$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $b8d88d7bae8d797f$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary, query);
    (0, $b8d88d7bae8d797f$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $acw62.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && subscribed;
    $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $e2307e33fb454067$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $938ae10f13d49bdc$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $acw62.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $d9109c84b9b954d9$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $d9109c84b9b954d9$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $b8d88d7bae8d797f$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: query,
        suspense: defaultedOptions.suspense
    })) throw result.error;
    client.getDefaultOptions().queries?._experimental_afterQuery?.(defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $bba8658037432dc5$export$2d935f1a9c9d3f3e).isServer() && (0, $d9109c84b9b954d9$export$e0a3f29513afe430)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $d9109c84b9b954d9$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        query?.promise;
        promise?.catch((0, $938ae10f13d49bdc$export$8793edee2d425525)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $4cdfd80436a5bb32$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $22b97878ddf0e02d$export$fff0865807e996c5)(options, (0, $2905803326ac545c$export$a06cf8c0066f0d4c), queryClient);
}



var $acw62 = parcelRequire("acw62");


function $876e57a8c3918f9f$export$3e3c8cccd287b2b2(error) {
    if (!error) return "";
    if (error instanceof Error) return `Error name: ${error.name}. Error message: ${error.message}. Error stack: ${error.stack}`;
    return JSON.stringify(error);
}


function $ffcdcbf268129353$export$e00be8a380f446b9() {
    return window.location.host === "localhost:8080";
}


const $e9e66f0970a759b5$var$MOCK_USER = {
    UserId: "117162129063344749731",
    Name: "jorgeaguirre1@gmail.com",
    Email: "jorgeaguirre1@gmail.com",
    EncryptedRefreshToken: "038189152023015127072203190205233043100201075194048152021250165188201052129202067075032237107090057177192175180077163065087087124196025192237097",
    Bought: false,
    EmailConfirmed: false,
    PaymentDate: undefined,
    PaymentId: undefined,
    PaymentMethod: undefined,
    ConfirmEmailGuid: "9e7f98b5-f6ae-4b3c-8859-82e971a81e5f",
    EmailConfirmedDate: undefined,
    AccountEmail: "jorgeaguirre1@gmail.com",
    AccountType: "Google",
    PaymentAmount: 0,
    PaymentCurrency: undefined,
    IsAdmin: true,
    PartitionKey: "UserInfo",
    RowKey: "117162129063344749731",
    Timestamp: new Date("2019-03-11T00:52:57.1416795+00:00"),
    ETag: "W/datetime'2019-03-11T00%3A52%3A57.1416795Z'"
};
function $e9e66f0970a759b5$export$e5432d4c8eb97ea7() {
    if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) return $e9e66f0970a759b5$var$MOCK_USER;
    if (typeof __cloudUser__ === "undefined" || __cloudUser__ === null) return undefined;
    return __cloudUser__;
}
function $e9e66f0970a759b5$export$90c873f50cd44aba() {
    if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) return true;
    return __isDistributor__ === true;
}
function $e9e66f0970a759b5$export$985c431ed65d8e6a() {
    if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) return {
        SignInUrl: "https://labelmaster.azurewebsites.net",
        LogoutUrl: "https://labelmaster.azurewebsites.net",
        Price: 15,
        PriceForDistributors: 112,
        PriceRecommendedForDistributors: 160,
        StripePublishableKey: "12",
        PriceForDistributorsWithTaxes: 129.92,
        SupportEmail: "support@dinlabel.com"
    };
    return __cloudMetadata__;
}



/** Matches LabelMaster.Core.Config.PublicKeys.AzureAppInsightsKey */ const $4382af072e10244e$export$761c8c873022103f = "7dec69f6-c8d3-4017-b8d5-0a608853c729";
const $4382af072e10244e$var$INGEST_URL = "https://dc.services.visualstudio.com/v2/track";
function $4382af072e10244e$var$toStringProperties(properties) {
    if (!properties) return {};
    const result = {};
    for (const [key, value] of Object.entries(properties))result[key] = String(value);
    return result;
}
class $4382af072e10244e$export$cf2703eaa89313da {
    instrumentationKey;
    enabled;
    sessionId;
    userId;
    constructor(instrumentationKey, enabled){
        this.instrumentationKey = instrumentationKey;
        this.enabled = enabled;
        this.sessionId = $4382af072e10244e$var$cryptoRandomId();
    }
    setEnabled(enabled) {
        this.enabled = enabled;
    }
    setAuthenticatedUser(userId) {
        this.userId = userId;
    }
    trackEvent(name, properties) {
        if (!this.enabled || !this.instrumentationKey) return;
        const payload = [
            {
                name: "Microsoft.ApplicationInsights.Event",
                time: new Date().toISOString(),
                iKey: this.instrumentationKey,
                tags: {
                    "ai.session.id": this.sessionId,
                    "ai.cloud.role": "LabelMaster.Web",
                    ...this.userId ? {
                        "ai.user.id": this.userId
                    } : {}
                },
                data: {
                    baseType: "EventData",
                    baseData: {
                        ver: 2,
                        name: name,
                        properties: $4382af072e10244e$var$toStringProperties(properties)
                    }
                }
            }
        ];
        const body = JSON.stringify(payload);
        try {
            if (typeof navigator !== "undefined" && navigator.sendBeacon) {
                const blob = new Blob([
                    body
                ], {
                    type: "application/json"
                });
                if (navigator.sendBeacon($4382af072e10244e$var$INGEST_URL, blob)) return;
            }
            fetch($4382af072e10244e$var$INGEST_URL, {
                method: "POST",
                body: body,
                headers: {
                    "Content-Type": "application/json"
                },
                keepalive: true,
                mode: "cors"
            }).catch(()=>{
            // Best-effort telemetry
            });
        } catch  {
        // Best-effort telemetry
        }
    }
    trackPageView(route) {
        this.trackEvent("WebPageView", {
            route: route
        });
    }
}
function $4382af072e10244e$var$cryptoRandomId() {
    try {
        if (typeof crypto !== "undefined" && "randomUUID" in crypto) return crypto.randomUUID();
    } catch  {
    // fall through
    }
    return `web-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
let $4382af072e10244e$var$sharedClient = null;
function $4382af072e10244e$export$ab7cfb71d8592d3c() {
    if (!$4382af072e10244e$var$sharedClient) $4382af072e10244e$var$sharedClient = new $4382af072e10244e$export$cf2703eaa89313da($4382af072e10244e$export$761c8c873022103f, false);
    return $4382af072e10244e$var$sharedClient;
}



class $d8894b6421bad9cf$export$ba6a9c7ac8291f7f {
    namespace;
    constructor(namespace){
        this.namespace = namespace;
    }
    error(message) {
        console.error(`[${this.namespace}] [Error] ${message}`);
    }
    info(message) {
        console.log(`[${this.namespace}] [Info] ${message}`);
    }
    warn(message) {
        console.warn(`[${this.namespace}] [Warn] ${message}`);
    }
    logReportData(eventName, payload) {
        console.info(`[${this.namespace}] [${eventName}]`, payload ? payload : "");
        (0, $4382af072e10244e$export$ab7cfb71d8592d3c)().trackEvent(eventName, payload);
    }
}


class $fbac34ae8aa6584b$export$ce30dbb46644d06c {
    static loggerInstance = new (0, $d8894b6421bad9cf$export$ba6a9c7ac8291f7f)("DinLabel");
    static initialized = false;
    static get logger() {
        return this.loggerInstance;
    }
    /** Enable App Insights in production (non-localhost). Safe to call once at startup. */ static initializeTelemetry() {
        if ($fbac34ae8aa6584b$export$ce30dbb46644d06c.initialized) return;
        $fbac34ae8aa6584b$export$ce30dbb46644d06c.initialized = true;
        const client = (0, $4382af072e10244e$export$ab7cfb71d8592d3c)();
        const enabled = !(0, $ffcdcbf268129353$export$e00be8a380f446b9)();
        client.setEnabled(enabled);
        client.setAuthenticatedUser((0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)()?.UserId);
        if (enabled) client.trackEvent("WebAppStart", {});
    }
}


class $1df6718fe0c83b41$export$e81dfb2144b2f874 {
    start;
    activityName;
    primitiveProperties;
    activityIsFinished;
    eventName = "Activity";
    constructor(activityName){
        this.start = Date.now();
        this.activityName = activityName;
        this.primitiveProperties = {};
        this.activityIsFinished = false;
    }
    markActivityFinishedAndWarnIfAlreadyFinished() {
        if (this.activityIsFinished) (0, $fbac34ae8aa6584b$export$ce30dbb46644d06c).logger.error(`The activity ${this.activityName} was somehow finished twice - this should never happen!`);
        this.activityIsFinished = true;
    }
    finishWithSuccess() {
        this.markActivityFinishedAndWarnIfAlreadyFinished();
        (0, $fbac34ae8aa6584b$export$ce30dbb46644d06c).logger.logReportData(this.eventName, {
            ...this.primitiveProperties,
            Success: true,
            SuccessRate: 1,
            Duration: Date.now() - this.start,
            ActivityName: this.activityName
        });
    }
    finishWithFailure(errorBucket, error) {
        this.markActivityFinishedAndWarnIfAlreadyFinished();
        let errorMessage = errorBucket;
        if (error) errorMessage = (0, $876e57a8c3918f9f$export$3e3c8cccd287b2b2)(error);
        (0, $fbac34ae8aa6584b$export$ce30dbb46644d06c).logger.logReportData(this.eventName, {
            ...this.primitiveProperties,
            Success: false,
            SuccessRate: 0,
            ErrorName: error ? error.name : "",
            Duration: Date.now() - this.start,
            ErrorMessage: errorMessage,
            ErrorBucket: errorBucket,
            ActivityName: this.activityName
        });
    }
    addProperty(key, value) {
        this.primitiveProperties[key] = value;
    }
}




class $0fb2b9595b8b3089$export$f2e832acab1bdd79 extends Error {
    statusCode;
    body;
    errorInfo;
    constructor(statusCode, body, message){
        super(message);
        this.statusCode = statusCode;
        this.body = body;
        this.name = "ApiError";
        if (body) try {
            const json = JSON.parse(body);
            this.errorInfo = json;
        } catch (error) {
            console.error("Error parsing error body", error);
            return;
        }
    }
    static isApiError(error) {
        // tslint:disable-next-line:no-any
        return !!error.statusCode;
    }
    static buildString(apiError) {
        let strToPrint = "";
        if (apiError) {
            if (apiError.statusCode) strToPrint += apiError.statusCode + "\n";
            if (apiError.errorInfo) {
                if (apiError.errorInfo.ErrorCode) strToPrint += apiError.errorInfo.ErrorCode + "\n";
                if (apiError.errorInfo.ErrorMessage) strToPrint += apiError.errorInfo.ErrorMessage + "\n";
                if (apiError.errorInfo.ExceptionType) strToPrint += apiError.errorInfo.ExceptionType + "\n";
                if (apiError.errorInfo.FullErrorMessage) strToPrint += apiError.errorInfo.FullErrorMessage + "\n";
            }
        }
        return strToPrint;
    }
}
const $0fb2b9595b8b3089$export$e531c43d2585d3d6 = {
    labels: [
        "labels"
    ],
    label: (fileId)=>[
            "label",
            fileId
        ],
    admin: [
        "admin"
    ],
    buySession: [
        "buySession"
    ],
    eula: (lang)=>[
            "eula",
            lang
        ],
    distributorInfo: [
        "distributorInfo"
    ]
};
const $0fb2b9595b8b3089$var$MOCK_CLOUD_USER = {
    UserId: "117162129063344749731",
    Name: "jorgeaguirre1@gmail.com",
    Email: "jorgeaguirre1@gmail.com",
    EncryptedRefreshToken: "mock",
    Bought: false,
    EmailConfirmed: false,
    ConfirmEmailGuid: "9e7f98b5-f6ae-4b3c-8859-82e971a81e5f",
    AccountEmail: "jorgeaguirre1@gmail.com",
    AccountType: "Google",
    PaymentAmount: 0,
    IsAdmin: false,
    PartitionKey: "UserInfo",
    RowKey: "117162129063344749731",
    Timestamp: new Date("2019-03-11T00:52:57.1416795+00:00"),
    ETag: "W/datetime'2019-03-11T00%3A52%3A57.1416795Z'"
};
const $0fb2b9595b8b3089$var$MOCK_DISTRIBUTOR = {
    DistributorInfo: {
        CompanyName: "Mock Distributor Co",
        Address: "3",
        PhoneNumber: "2",
        Street2: "4",
        Number: "5",
        City: "6",
        State: "7",
        Country: "8",
        BusinessId: "0",
        Zip: "9",
        PartitionKey: "DistributorsInfo",
        RowKey: "117162129063344749731",
        Timestamp: "2019-03-11T17:37:36.868404+00:00",
        ETag: "W/datetime'2019-03-11T17%3A37%3A36.868404Z'",
        DistribuidorAutorizado: true
    },
    DistributorLicenseMailMappings: [
        {
            LicenseInvitationEmail: "customer@example.com",
            InsertionTime: "2024-03-01T10:00:00.000Z",
            LicenseId: "mock-license-1",
            AcceptedByUserId: "",
            AcceptedDate: ""
        }
    ],
    CloudUser: $0fb2b9595b8b3089$var$MOCK_CLOUD_USER,
    DistributorPayments: [
        {
            PaymentMethod: "Stripe",
            PaymentId: "Stripe|ch_1CgNY6JZNgXFrghdv5c4XBv5",
            LicenseCount: 2,
            PaymentAmount: 4859.01,
            PaymentCurrency: "mxn",
            PaymentDate: "2018-06-24T02:01:55.0926575Z",
            PartitionKey: "117162129063344749731",
            RowKey: "ch_1CgNY6JZNgXFrghdv5c4XBv5",
            Timestamp: "2018-06-24T02:01:55.1858025+00:00",
            ETag: "W/datetime'2018-06-24T02%3A01%3A55.1858025Z'"
        }
    ],
    AvailableLicenses: 1,
    LicensesBought: 2
};
const $0fb2b9595b8b3089$var$MOCK_LABELS = [
    {
        FileName: "Demo label.din",
        CreatedDate: "2024-06-15T14:30:00.000Z",
        PointerToBlob: "mock-label-1",
        CreatedDateMs: Date.parse("2024-06-15T14:30:00.000Z")
    },
    {
        FileName: "Shipping labels.din",
        CreatedDate: "2025-01-08T09:12:00.000Z",
        PointerToBlob: "mock-label-2",
        CreatedDateMs: Date.parse("2025-01-08T09:12:00.000Z")
    }
];
const $0fb2b9595b8b3089$var$MOCK_ADMIN = {
    users: [
        {
            UserId: "117162129063344749731",
            Name: "jorgeaguirre1@gmail.com",
            Email: "jorgeaguirre1@gmail.com",
            EmailConfirmed: false,
            Timestamp: "2019-03-11T00:52:57.1416795+00:00",
            Bought: false,
            IsAdmin: true
        },
        {
            UserId: "mock-user-paid",
            Name: "paid.user@example.com",
            Email: "paid.user@example.com",
            EmailConfirmed: true,
            Timestamp: "2024-02-01T12:00:00.000Z",
            Bought: true,
            IsAdmin: false,
            PaymentMethod: "Stripe",
            PaymentId: "ch_mock_paid_very_long_id_for_truncation",
            PaymentAmount: 180,
            PaymentCurrency: "mxn",
            PaymentDate: "2024-02-01T12:05:00.000Z"
        }
    ],
    totalSubscribedUsers: 1,
    distributors: [
        {
            AvailableLicenses: 2,
            LicensesBought: 2,
            CloudUser: {
                UserId: "117162129063344749731",
                Email: "jorgeaguirre1@gmail.com"
            },
            DistributorInfo: {
                CompanyName: "Mock Distributor Co",
                DistribuidorAutorizado: true,
                RowKey: "117162129063344749731"
            }
        },
        {
            AvailableLicenses: 0,
            LicensesBought: 0,
            CloudUser: {
                UserId: "mock-pending-distributor",
                Email: "pending@distributor.example.com"
            },
            DistributorInfo: {
                CompanyName: "Pending Distributor SA",
                DistribuidorAutorizado: false,
                RowKey: "mock-pending-distributor"
            }
        }
    ],
    distributorPayments: [
        {
            PartitionKey: "117162129063344749731",
            PaymentId: "ch_1CgNY6JZNgXFrghdv5c4XBv5",
            PaymentDate: "2018-06-24T02:01:55.0926575Z",
            PaymentMethod: "Stripe",
            PaymentAmount: 4859.01,
            PaymentCurrency: "mxn",
            LicenseCount: 2
        }
    ],
    licenseAccepted: [
        {
            Distributor: {
                CompanyName: "Mock Distributor Co"
            },
            LicenseInvitation: {
                LicenseId: "mock-license-1",
                LicenseInvitationEmail: "customer@example.com",
                AcceptedByUserId: "mock-user-paid",
                AcceptedDate: "2024-03-01T10:00:00.000Z"
            },
            UserThatAccepted: {
                Email: "paid.user@example.com",
                Name: "paid.user@example.com"
            }
        }
    ],
    demoDownloaders: [
        {
            RowKey: "mock-demo-1",
            Email: "demo.user@example.com",
            DownloadedAtUtc: "2025-06-15T14:30:00.000Z"
        },
        {
            RowKey: "mock-demo-2",
            Email: "another.demo@example.com",
            DownloadedAtUtc: "2025-07-01T09:12:00.000Z"
        }
    ]
};
const $0fb2b9595b8b3089$var$MOCK_EULA = `DINLabel End User License Agreement (mock)

This is mock EULA text for local development when the API is not available.
By using this application you agree to the terms that would normally be
served from /privacypolicy/eulatext.
`;
class $0fb2b9595b8b3089$export$1f53e240b076325b {
    static getApiBaseUrl() {
        // The base URL will be overriden, so make sure we override this one as well
        const url = new URL(window.location.href);
        return url.protocol + "//" + url.host;
    }
    static async getErrorFromResponse(response) {
        const body = await response.text();
        const statusCode = response.status;
        return new $0fb2b9595b8b3089$export$f2e832acab1bdd79(statusCode, body, "API request failed");
    }
    static async ensureOk(response, activity) {
        if (response.ok) {
            activity.finishWithSuccess();
            return;
        }
        const error = await $0fb2b9595b8b3089$export$1f53e240b076325b.getErrorFromResponse(response);
        activity.finishWithFailure("FailedRequest", error);
        throw error;
    }
    static async parseJson(response, activity) {
        await $0fb2b9595b8b3089$export$1f53e240b076325b.ensureOk(response, activity);
        return response.json();
    }
    static async getDistributorInfo() {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] getDistributorInfo");
            return structuredClone($0fb2b9595b8b3089$var$MOCK_DISTRIBUTOR);
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("GetDistributorInfo");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/distributor/getdistributorinfo`, {
            credentials: "same-origin"
        });
        if (response.status === 401) {
            const error = new Error("unauthorized");
            activity.finishWithFailure("Unauthorized", error);
            throw error;
        }
        await $0fb2b9595b8b3089$export$1f53e240b076325b.ensureOk(response, activity);
        const text = await response.text();
        if (!text || text === "null") return null;
        return JSON.parse(text);
    }
    static async sendLicencia(mail) {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] sendLicencia", mail);
            return;
        }
        const getActivity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("SendLicencia");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/distributor/sendlicense`, {
            method: "POST",
            body: JSON.stringify({
                recipientEmail: mail,
                respondWithJson: "true"
            }),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        });
        await $0fb2b9595b8b3089$export$1f53e240b076325b.ensureOk(response, getActivity);
    }
    static async resendLicencia(rowKey, partitionKey, email) {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] resendLicencia", {
                rowKey: rowKey,
                partitionKey: partitionKey,
                email: email
            });
            return;
        }
        const getActivity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("ReSendLicencia");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/distributor/resendlicense`, {
            method: "POST",
            body: JSON.stringify({
                rowKey: rowKey,
                partitionKey: partitionKey,
                email: email,
                respondWithJson: "true"
            }),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        });
        await $0fb2b9595b8b3089$export$1f53e240b076325b.ensureOk(response, getActivity);
    }
    static async loginAndReload() {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] loginAndReload");
            return;
        }
        const getActivity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("LoginThroughAPI");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/distributorportal`, {
            method: "POST",
            body: JSON.stringify({
                respondWithJson: "true"
            }),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        });
        await $0fb2b9595b8b3089$export$1f53e240b076325b.ensureOk(response, getActivity);
    }
    static async getLabels() {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] getLabels");
            return $0fb2b9595b8b3089$var$MOCK_LABELS;
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("GetLabels");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/mylabels/getlabels`, {
            credentials: "same-origin"
        });
        return $0fb2b9595b8b3089$export$1f53e240b076325b.parseJson(response, activity);
    }
    static async getLabel(fileId) {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] getLabel", fileId);
            const found = $0fb2b9595b8b3089$var$MOCK_LABELS.find((label)=>label.PointerToBlob === fileId);
            return found ?? {
                FileName: `Mock label (${fileId}).din`,
                CreatedDate: new Date().toISOString(),
                PointerToBlob: fileId
            };
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("GetLabel");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/mylabels/getlabel?fileId=${encodeURIComponent(fileId)}`, {
            credentials: "same-origin"
        });
        return $0fb2b9595b8b3089$export$1f53e240b076325b.parseJson(response, activity);
    }
    static async getAdminInfo() {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] getAdminInfo");
            return structuredClone($0fb2b9595b8b3089$var$MOCK_ADMIN);
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("GetAdminInfo");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/admin/getadmininfo`, {
            credentials: "same-origin"
        });
        return $0fb2b9595b8b3089$export$1f53e240b076325b.parseJson(response, activity);
    }
    static async getFakeEmail(action, lang) {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] getFakeEmail", action, lang);
            return {
                subject: `[mock] ${action}`,
                body: `<p>Mock preview for <strong>${action}</strong> (${lang}).</p>`
            };
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("GetFakeEmail");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/fakeemail/${encodeURIComponent(action)}?lang=${encodeURIComponent(lang)}`, {
            credentials: "same-origin",
            headers: {
                "Accept-Language": lang
            }
        });
        return $0fb2b9595b8b3089$export$1f53e240b076325b.parseJson(response, activity);
    }
    static async sendFakeEmailTest(action, to, lang) {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] sendFakeEmailTest", action, to, lang);
            return;
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("SendFakeEmailTest");
        const params = new URLSearchParams({
            emailAction: action,
            to: to,
            lang: lang
        });
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/fakeemail/sendTest?${params.toString()}`, {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Accept-Language": lang
            }
        });
        await $0fb2b9595b8b3089$export$1f53e240b076325b.ensureOk(response, activity);
    }
    static async authorizeDistributor(userId) {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] authorizeDistributor", userId);
            const distributor = $0fb2b9595b8b3089$var$MOCK_ADMIN.distributors.find((d)=>d.CloudUser?.UserId === userId || d.DistributorInfo.RowKey === userId);
            if (distributor) distributor.DistributorInfo.DistribuidorAutorizado = true;
            return;
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("AuthorizeDistributor");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/distributor/authorizedistributor`, {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                UserId: userId
            })
        });
        await $0fb2b9595b8b3089$export$1f53e240b076325b.ensureOk(response, activity);
    }
    static async toggleBought() {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] toggleBought");
            const currentUser = (0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)();
            const user = $0fb2b9595b8b3089$var$MOCK_ADMIN.users.find((u)=>u.UserId === currentUser?.UserId);
            if (user) user.Bought = !user.Bought;
            return;
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("ToggleBought");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/admin/toggleBought`, {
            method: "POST",
            credentials: "same-origin"
        });
        await $0fb2b9595b8b3089$export$1f53e240b076325b.ensureOk(response, activity);
    }
    static async toggleAdmin(userId) {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] toggleAdmin", userId);
            const user = $0fb2b9595b8b3089$var$MOCK_ADMIN.users.find((u)=>u.UserId === userId);
            if (user) user.IsAdmin = !user.IsAdmin;
            return;
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("ToggleAdmin");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/admin/toggleAdmin`, {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                UserId: userId
            })
        });
        await $0fb2b9595b8b3089$export$1f53e240b076325b.ensureOk(response, activity);
    }
    static async createBuySession() {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] createBuySession");
            return {
                bought: false,
                sessionId: "mock-stripe-session-buy",
                email: "jorgeaguirre1@gmail.com"
            };
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("CreateBuySession");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/buy/createsession`, {
            credentials: "same-origin"
        });
        if (response.status === 401) {
            const error = new Error("unauthorized");
            activity.finishWithFailure("Unauthorized", error);
            throw error;
        }
        return $0fb2b9595b8b3089$export$1f53e240b076325b.parseJson(response, activity);
    }
    static async createDistributorStripeSession(licenseCount) {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] createDistributorStripeSession", licenseCount);
            return `mock-stripe-session-distributor-${licenseCount}`;
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("CreateDistributorStripeSession");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/api/stripe/createSessionForDistributor?licenseCount=${licenseCount}`, {
            method: "POST"
        });
        return $0fb2b9595b8b3089$export$1f53e240b076325b.parseJson(response, activity);
    }
    static async resendConfirmationEmail() {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] resendConfirmationEmail");
            return;
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("ResendConfirmationEmail");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/userinfo/resendConfirmationEmail`, {
            method: "POST",
            credentials: "same-origin"
        });
        await $0fb2b9595b8b3089$export$1f53e240b076325b.ensureOk(response, activity);
    }
    static async getSubscriptionStatus() {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] getSubscriptionStatus");
            return {
                HasSubscription: true,
                Status: "active",
                HasAccess: true,
                CancelAtPeriodEnd: false,
                CurrentPeriodEnd: new Date(Date.now() + 2592000000).toISOString(),
                SubscriptionId: "sub_mock",
                CustomerId: "cus_mock"
            };
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("GetSubscriptionStatus");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/userinfo/subscriptionstatus`, {
            credentials: "same-origin"
        });
        if (response.status === 401) {
            const error = new Error("unauthorized");
            activity.finishWithFailure("Unauthorized", error);
            throw error;
        }
        return $0fb2b9595b8b3089$export$1f53e240b076325b.parseJson(response, activity);
    }
    static async getEulaText(lang) {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] getEulaText", lang);
            return $0fb2b9595b8b3089$var$MOCK_EULA;
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("GetEulaText");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/privacypolicy/eulatext?lang=${encodeURIComponent(lang)}`);
        if (!response.ok) {
            const error = await $0fb2b9595b8b3089$export$1f53e240b076325b.getErrorFromResponse(response);
            activity.finishWithFailure("FailedRequest", error);
            throw error;
        }
        activity.finishWithSuccess();
        return response.text();
    }
    static async recordDemoDownload(email) {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info("[mock] recordDemoDownload", email);
            return;
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("RecordDemoDownload");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/api/demodownload/record`, {
            method: "POST",
            credentials: "same-origin",
            body: JSON.stringify({
                Email: email
            }),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        });
        await $0fb2b9595b8b3089$export$1f53e240b076325b.ensureOk(response, activity);
    }
    static async localAuthLogin(email, password) {
        await $0fb2b9595b8b3089$export$1f53e240b076325b.postLocalAuth("/api/localauth/login", "LocalAuthLogin", {
            Email: email,
            Password: password
        });
    }
    static async localAuthRegister(email, password) {
        await $0fb2b9595b8b3089$export$1f53e240b076325b.postLocalAuth("/api/localauth/register", "LocalAuthRegister", {
            Email: email,
            Password: password
        });
    }
    static async localAuthForgot(email) {
        await $0fb2b9595b8b3089$export$1f53e240b076325b.postLocalAuth("/api/localauth/forgot", "LocalAuthForgot", {
            Email: email
        });
    }
    static async localAuthReset(email, token, password) {
        await $0fb2b9595b8b3089$export$1f53e240b076325b.postLocalAuth("/api/localauth/reset", "LocalAuthReset", {
            Email: email,
            Token: token,
            Password: password
        });
    }
    static async localAuthHasPassword() {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) return false;
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)("LocalAuthHasPassword");
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}/api/localauth/haspassword`, {
            method: "GET",
            credentials: "same-origin",
            headers: {
                Accept: "application/json"
            }
        });
        if (!response.ok) {
            const error = await $0fb2b9595b8b3089$export$1f53e240b076325b.getErrorFromResponse(response);
            activity.finishWithFailure("FailedRequest", error);
            throw error;
        }
        activity.finishWithSuccess();
        const json = await response.json();
        return !!json.HasPassword;
    }
    static async localAuthSetPassword(password) {
        await $0fb2b9595b8b3089$export$1f53e240b076325b.postLocalAuth("/api/localauth/setpassword", "LocalAuthSetPassword", {
            Password: password
        });
    }
    static async localAuthChangePassword(currentPassword, password) {
        await $0fb2b9595b8b3089$export$1f53e240b076325b.postLocalAuth("/api/localauth/changepassword", "LocalAuthChangePassword", {
            CurrentPassword: currentPassword,
            Password: password
        });
    }
    static async postLocalAuth(path, activityName, body) {
        if ((0, $ffcdcbf268129353$export$e00be8a380f446b9)()) {
            console.info(`[mock] ${activityName}`, body.Email);
            return;
        }
        const activity = new (0, $1df6718fe0c83b41$export$e81dfb2144b2f874)(activityName);
        const response = await fetch(`${$0fb2b9595b8b3089$export$1f53e240b076325b.getApiBaseUrl()}${path}`, {
            method: "POST",
            credentials: "same-origin",
            body: JSON.stringify(body),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        });
        if (!response.ok) {
            const text = await response.text();
            let message = "Request failed";
            try {
                const parsed = JSON.parse(text);
                message = parsed.Message || parsed.message || message;
            } catch  {
            // keep default
            }
            const error = new $0fb2b9595b8b3089$export$f2e832acab1bdd79(response.status, text, message);
            activity.finishWithFailure("FailedRequest", error);
            throw error;
        }
        activity.finishWithSuccess();
    }
}







"use client";
//#region packages/@mantine/core/src/components/Anchor/Anchor.module.css
var $b07e501f9fd3f876$export$2e2bcd8739ae039 = {
    "root": "m_849cf0da"
};




"use client";
//#region packages/@mantine/core/src/components/Anchor/Anchor.tsx
const $7f444f4382bb0812$var$defaultProps = {
    underline: "hover"
};
const $7f444f4382bb0812$export$b688253958b8dfe7 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((props)=>{
    const { underline: underline, className: className, unstyled: unstyled, mod: mod, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Anchor", $7f444f4382bb0812$var$defaultProps, props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
        component: "a",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
            [(0, $b07e501f9fd3f876$export$2e2bcd8739ae039).root]: !unstyled
        }, className),
        ...others,
        mod: [
            {
                underline: underline
            },
            mod
        ],
        __staticSelector: "Anchor",
        unstyled: unstyled
    });
});
$7f444f4382bb0812$export$b688253958b8dfe7.classes = (0, $b07e501f9fd3f876$export$2e2bcd8739ae039);
$7f444f4382bb0812$export$b688253958b8dfe7.displayName = "@mantine/core/Anchor";








"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShell.context.ts
const [$bc836bedbf7f5239$export$f1c70b06465d541e, $bc836bedbf7f5239$export$6a9abcfe5948d367] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("AppShell was not found in tree");


"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShell.module.css
var $5d5e905597c33b78$export$2e2bcd8739ae039 = {
    "root": "m_89ab340",
    "navbar": "m_45252eee",
    "aside": "m_9cdde9a",
    "header": "m_3b16f56b",
    "main": "m_8983817",
    "footer": "m_3840c879",
    "section": "m_6dcfc7c7"
};










"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellAside/AppShellAside.tsx
const $78e6f4a4a0198500$export$53f6f96f8b7092f2 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, withBorder: withBorder, zIndex: zIndex, mod: mod, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AppShellAside", null, _props);
    const ctx = (0, $bc836bedbf7f5239$export$6a9abcfe5948d367)();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "aside",
        mod: [
            {
                "with-border": withBorder ?? ctx.withBorder
            },
            mod
        ],
        ...ctx.getStyles("aside", {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                [(0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039).classNames.zeroRight]: ctx.offsetScrollbars
            }, className),
            classNames: classNames,
            styles: styles,
            style: style
        }),
        ...others,
        __vars: {
            "--app-shell-aside-z-index": `calc(${zIndex ?? ctx.zIndex} + 1)`
        }
    });
});
$78e6f4a4a0198500$export$53f6f96f8b7092f2.classes = (0, $5d5e905597c33b78$export$2e2bcd8739ae039);
$78e6f4a4a0198500$export$53f6f96f8b7092f2.displayName = "@mantine/core/AppShellAside";










"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellFooter/AppShellFooter.tsx
const $7f89d268cd453eb6$export$c7be6f5ced93654d = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, withBorder: withBorder, zIndex: zIndex, mod: mod, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AppShellFooter", null, _props);
    const ctx = (0, $bc836bedbf7f5239$export$6a9abcfe5948d367)();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "footer",
        mod: [
            {
                "with-border": withBorder ?? ctx.withBorder
            },
            mod
        ],
        ...ctx.getStyles("footer", {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                [(0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039).classNames.zeroRight]: ctx.offsetScrollbars
            }, className),
            classNames: classNames,
            styles: styles,
            style: style
        }),
        ...others,
        __vars: {
            "--app-shell-footer-z-index": (zIndex ?? ctx.zIndex)?.toString()
        }
    });
});
$7f89d268cd453eb6$export$c7be6f5ced93654d.classes = (0, $5d5e905597c33b78$export$2e2bcd8739ae039);
$7f89d268cd453eb6$export$c7be6f5ced93654d.displayName = "@mantine/core/AppShellFooter";










"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellHeader/AppShellHeader.tsx
const $f45aa3268986d2cf$export$7932a9fc07def21a = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, withBorder: withBorder, zIndex: zIndex, mod: mod, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AppShellHeader", null, _props);
    const ctx = (0, $bc836bedbf7f5239$export$6a9abcfe5948d367)();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "header",
        mod: [
            {
                "with-border": withBorder ?? ctx.withBorder
            },
            mod
        ],
        ...ctx.getStyles("header", {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                [(0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039).classNames.zeroRight]: ctx.offsetScrollbars
            }, className),
            classNames: classNames,
            styles: styles,
            style: style
        }),
        ...others,
        __vars: {
            "--app-shell-header-z-index": (zIndex ?? ctx.zIndex)?.toString()
        }
    });
});
$f45aa3268986d2cf$export$7932a9fc07def21a.classes = (0, $5d5e905597c33b78$export$2e2bcd8739ae039);
$f45aa3268986d2cf$export$7932a9fc07def21a.displayName = "@mantine/core/AppShellHeader";








"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellMain/AppShellMain.tsx
const $b02392ee6d9b6089$export$38840998a170df80 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AppShellMain", null, _props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "main",
        ...(0, $bc836bedbf7f5239$export$6a9abcfe5948d367)().getStyles("main", {
            className: className,
            style: style,
            classNames: classNames,
            styles: styles
        }),
        ...others
    });
});
$b02392ee6d9b6089$export$38840998a170df80.classes = (0, $5d5e905597c33b78$export$2e2bcd8739ae039);
$b02392ee6d9b6089$export$38840998a170df80.displayName = "@mantine/core/AppShellMain";








"use client";
//#region packages/@mantine/core/src/core/utils/get-breakpoint-value/get-breakpoint-value.ts
function $0b047129fb57dfcc$export$4adb988360925c51(breakpoint, breakpoints) {
    if (breakpoint in breakpoints) return (0, $36050ce217b59930$export$91c0eda1d06bf008)(breakpoints[breakpoint]);
    return (0, $36050ce217b59930$export$91c0eda1d06bf008)(breakpoint);
}


"use client";
//#region packages/@mantine/core/src/core/utils/get-sorted-breakpoints/get-sorted-breakpoints.ts
function $e4e164d3d352ee58$export$bd80382e31449c0e(values, breakpoints) {
    const convertedBreakpoints = values.map((breakpoint)=>({
            value: breakpoint,
            px: (0, $0b047129fb57dfcc$export$4adb988360925c51)(breakpoint, breakpoints)
        }));
    convertedBreakpoints.sort((a, b)=>a.px - b.px);
    return convertedBreakpoints;
}





"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/get-base-size/get-base-size.ts
function $0788b76ca8d1217c$export$88a9076c5877d24f(size) {
    if (typeof size === "object") return size.base;
    return size;
}


"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/is-primitive-size/is-primitive-size.ts
function $dbe2020228889b86$export$595d4c6c22e3891(size) {
    const isBaseSize = typeof size === "object" && size !== null && typeof size.base !== "undefined" && Object.keys(size).length === 1;
    return typeof size === "number" || typeof size === "string" || isBaseSize;
}


"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/is-responsive-size/is-responsive-size.ts
function $3e5e4a7b004b31ae$export$13e1ea2a48bdc51e(size) {
    if (typeof size !== "object" || size === null) return false;
    if (Object.keys(size).length === 1 && "base" in size) return false;
    return true;
}


"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/assign-aside-variables/assign-aside-variables.ts
function $e50d39ec24509fdf$export$b266d6a359856a1d({ baseStyles: baseStyles, minMediaStyles: minMediaStyles, maxMediaStyles: maxMediaStyles, aside: aside, theme: theme, mode: mode }) {
    const asideWidth = aside?.width;
    const collapsedAsideTransform = "translateX(var(--app-shell-aside-width))";
    const collapsedAsideTransformRtl = "translateX(calc(var(--app-shell-aside-width) * -1))";
    if (aside?.breakpoint !== void 0 && !aside?.collapsed?.mobile) {
        maxMediaStyles[aside?.breakpoint] = maxMediaStyles[aside?.breakpoint] || {};
        if (mode === "fixed") {
            maxMediaStyles[aside?.breakpoint]["--app-shell-aside-width"] = "100%";
            maxMediaStyles[aside?.breakpoint]["--app-shell-aside-offset"] = "0px";
        } else {
            maxMediaStyles[aside?.breakpoint]["--app-shell-aside-width"] = "0px";
            maxMediaStyles[aside?.breakpoint]["--app-shell-aside-offset"] = "0px";
        }
    }
    if ((0, $dbe2020228889b86$export$595d4c6c22e3891)(asideWidth)) {
        const baseSize = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)((0, $0788b76ca8d1217c$export$88a9076c5877d24f)(asideWidth));
        baseStyles["--app-shell-aside-width"] = baseSize;
        baseStyles["--app-shell-aside-offset"] = baseSize;
    }
    if ((0, $3e5e4a7b004b31ae$export$13e1ea2a48bdc51e)(asideWidth)) {
        if (typeof asideWidth.base !== "undefined") {
            baseStyles["--app-shell-aside-width"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(asideWidth.base);
            baseStyles["--app-shell-aside-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(asideWidth.base);
        }
        (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(asideWidth).forEach((key)=>{
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-aside-width"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(asideWidth[key]);
                minMediaStyles[key]["--app-shell-aside-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(asideWidth[key]);
            }
        });
    }
    if (aside?.breakpoint !== void 0 && mode === "static") {
        minMediaStyles[aside.breakpoint] = minMediaStyles[aside.breakpoint] || {};
        minMediaStyles[aside.breakpoint]["--app-shell-aside-position"] = "sticky";
        minMediaStyles[aside.breakpoint]["--app-shell-aside-grid-row"] = "2";
        minMediaStyles[aside.breakpoint]["--app-shell-aside-grid-column"] = "3";
        minMediaStyles[aside.breakpoint]["--app-shell-main-column-end"] = "3";
    }
    if (aside?.collapsed?.desktop) {
        const breakpointValue = aside.breakpoint;
        minMediaStyles[breakpointValue] = minMediaStyles[breakpointValue] || {};
        minMediaStyles[breakpointValue]["--app-shell-aside-transform"] = collapsedAsideTransform;
        minMediaStyles[breakpointValue]["--app-shell-aside-transform-rtl"] = collapsedAsideTransformRtl;
        if (mode === "fixed") minMediaStyles[breakpointValue]["--app-shell-aside-offset"] = "0px !important";
        else {
            minMediaStyles[breakpointValue]["--app-shell-aside-width"] = "0px";
            minMediaStyles[breakpointValue]["--app-shell-aside-display"] = "none";
            minMediaStyles[breakpointValue]["--app-shell-main-column-end"] = "-1";
        }
        minMediaStyles[breakpointValue]["--app-shell-aside-scroll-locked-visibility"] = "hidden";
    }
    if (aside?.collapsed?.mobile) {
        const breakpointValue = (0, $0b047129fb57dfcc$export$4adb988360925c51)(aside.breakpoint, theme.breakpoints) - .1;
        maxMediaStyles[breakpointValue] = maxMediaStyles[breakpointValue] || {};
        if (mode === "fixed") {
            maxMediaStyles[breakpointValue]["--app-shell-aside-width"] = "100%";
            maxMediaStyles[breakpointValue]["--app-shell-aside-offset"] = "0px";
        } else maxMediaStyles[breakpointValue]["--app-shell-aside-width"] = "0px";
        maxMediaStyles[breakpointValue]["--app-shell-aside-transform"] = collapsedAsideTransform;
        maxMediaStyles[breakpointValue]["--app-shell-aside-transform-rtl"] = collapsedAsideTransformRtl;
        maxMediaStyles[breakpointValue]["--app-shell-aside-scroll-locked-visibility"] = "hidden";
    }
}







"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/assign-footer-variables/assign-footer-variables.ts
function $2fb426187e235bef$export$9b0931cecc660105({ baseStyles: baseStyles, minMediaStyles: minMediaStyles, footer: footer, mode: mode }) {
    const footerHeight = footer?.height;
    const collapsedFooterTransform = "translateY(var(--app-shell-footer-height))";
    const shouldOffset = mode === "static" ? true : footer?.offset ?? true;
    if (mode === "static" && footer) {
        baseStyles["--app-shell-footer-position"] = "sticky";
        baseStyles["--app-shell-footer-grid-column"] = "1 / -1";
        baseStyles["--app-shell-footer-grid-row"] = "3";
    }
    if ((0, $dbe2020228889b86$export$595d4c6c22e3891)(footerHeight)) {
        const baseSize = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)((0, $0788b76ca8d1217c$export$88a9076c5877d24f)(footerHeight));
        baseStyles["--app-shell-footer-height"] = baseSize;
        if (shouldOffset) baseStyles["--app-shell-footer-offset"] = baseSize;
    }
    if ((0, $3e5e4a7b004b31ae$export$13e1ea2a48bdc51e)(footerHeight)) {
        if (typeof footerHeight.base !== "undefined") {
            baseStyles["--app-shell-footer-height"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(footerHeight.base);
            if (shouldOffset) baseStyles["--app-shell-footer-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(footerHeight.base);
        }
        (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(footerHeight).forEach((key)=>{
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-footer-height"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(footerHeight[key]);
                if (shouldOffset) minMediaStyles[key]["--app-shell-footer-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(footerHeight[key]);
            }
        });
    }
    if (footer?.collapsed) {
        baseStyles["--app-shell-footer-transform"] = collapsedFooterTransform;
        if (mode === "fixed") baseStyles["--app-shell-footer-offset"] = "0px !important";
    }
}







"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/assign-header-variables/assign-header-variables.ts
function $2bb10e190151b86d$export$9990017af629c1d7({ baseStyles: baseStyles, minMediaStyles: minMediaStyles, header: header, mode: mode }) {
    const headerHeight = header?.height;
    const collapsedHeaderTransform = "translateY(calc(var(--app-shell-header-height) * -1))";
    const shouldOffset = mode === "static" ? true : header?.offset ?? true;
    if (mode === "static" && header) {
        baseStyles["--app-shell-header-position"] = "sticky";
        baseStyles["--app-shell-header-grid-column"] = "1 / -1";
        baseStyles["--app-shell-header-grid-row"] = "1";
    }
    if ((0, $dbe2020228889b86$export$595d4c6c22e3891)(headerHeight)) {
        const baseSize = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)((0, $0788b76ca8d1217c$export$88a9076c5877d24f)(headerHeight));
        baseStyles["--app-shell-header-height"] = baseSize;
        if (shouldOffset) baseStyles["--app-shell-header-offset"] = baseSize;
    }
    if ((0, $3e5e4a7b004b31ae$export$13e1ea2a48bdc51e)(headerHeight)) {
        if (typeof headerHeight.base !== "undefined") {
            baseStyles["--app-shell-header-height"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(headerHeight.base);
            if (shouldOffset) baseStyles["--app-shell-header-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(headerHeight.base);
        }
        (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(headerHeight).forEach((key)=>{
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-header-height"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(headerHeight[key]);
                if (shouldOffset) minMediaStyles[key]["--app-shell-header-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(headerHeight[key]);
            }
        });
    }
    if (header?.collapsed) {
        baseStyles["--app-shell-header-transform"] = collapsedHeaderTransform;
        if (mode === "fixed") baseStyles["--app-shell-header-offset"] = "0px !important";
    }
}








"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/assign-navbar-variables/assign-navbar-variables.ts
function $5b76db2b2ae599e8$export$4e3d4baa5f113da9({ baseStyles: baseStyles, minMediaStyles: minMediaStyles, maxMediaStyles: maxMediaStyles, navbar: navbar, theme: theme, mode: mode }) {
    const navbarWidth = navbar?.width;
    const collapsedNavbarTransform = "translateX(calc(var(--app-shell-navbar-width) * -1))";
    const collapsedNavbarTransformRtl = "translateX(var(--app-shell-navbar-width))";
    if (navbar?.breakpoint !== void 0 && !navbar?.collapsed?.mobile) {
        maxMediaStyles[navbar?.breakpoint] = maxMediaStyles[navbar?.breakpoint] || {};
        maxMediaStyles[navbar?.breakpoint]["--app-shell-navbar-offset"] = "0px";
        maxMediaStyles[navbar?.breakpoint]["--app-shell-navbar-width"] = "100%";
        if (mode === "static") maxMediaStyles[navbar?.breakpoint]["--app-shell-navbar-grid-width"] = "0px";
    }
    if ((0, $dbe2020228889b86$export$595d4c6c22e3891)(navbarWidth)) {
        const baseSize = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)((0, $0788b76ca8d1217c$export$88a9076c5877d24f)(navbarWidth));
        baseStyles["--app-shell-navbar-width"] = baseSize;
        baseStyles["--app-shell-navbar-offset"] = baseSize;
        if (mode === "static") baseStyles["--app-shell-navbar-grid-width"] = baseSize;
    }
    if ((0, $3e5e4a7b004b31ae$export$13e1ea2a48bdc51e)(navbarWidth)) {
        if (typeof navbarWidth.base !== "undefined") {
            baseStyles["--app-shell-navbar-width"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(navbarWidth.base);
            baseStyles["--app-shell-navbar-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(navbarWidth.base);
            if (mode === "static") baseStyles["--app-shell-navbar-grid-width"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(navbarWidth.base);
        }
        (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(navbarWidth).forEach((key)=>{
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-navbar-width"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(navbarWidth[key]);
                minMediaStyles[key]["--app-shell-navbar-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(navbarWidth[key]);
                if (mode === "static") minMediaStyles[key]["--app-shell-navbar-grid-width"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(navbarWidth[key]);
            }
        });
    }
    if (navbar?.breakpoint !== void 0 && mode === "static") {
        minMediaStyles[navbar.breakpoint] = minMediaStyles[navbar.breakpoint] || {};
        minMediaStyles[navbar.breakpoint]["--app-shell-navbar-position"] = "sticky";
        minMediaStyles[navbar.breakpoint]["--app-shell-navbar-grid-row"] = "2";
        minMediaStyles[navbar.breakpoint]["--app-shell-navbar-grid-column"] = "1";
        minMediaStyles[navbar.breakpoint]["--app-shell-main-column-start"] = "2";
    }
    if (navbar?.collapsed?.desktop) {
        const breakpointValue = navbar.breakpoint;
        minMediaStyles[breakpointValue] = minMediaStyles[breakpointValue] || {};
        minMediaStyles[breakpointValue]["--app-shell-navbar-transform"] = collapsedNavbarTransform;
        minMediaStyles[breakpointValue]["--app-shell-navbar-transform-rtl"] = collapsedNavbarTransformRtl;
        if (mode === "fixed") minMediaStyles[breakpointValue]["--app-shell-navbar-offset"] = "0px !important";
        else {
            minMediaStyles[breakpointValue]["--app-shell-navbar-width"] = "0px";
            minMediaStyles[breakpointValue]["--app-shell-navbar-display"] = "none";
            minMediaStyles[breakpointValue]["--app-shell-main-column-start"] = "1";
        }
    }
    if (navbar?.collapsed?.mobile) {
        const breakpointValue = (0, $0b047129fb57dfcc$export$4adb988360925c51)(navbar.breakpoint, theme.breakpoints) - .1;
        maxMediaStyles[breakpointValue] = maxMediaStyles[breakpointValue] || {};
        maxMediaStyles[breakpointValue]["--app-shell-navbar-width"] = "100%";
        maxMediaStyles[breakpointValue]["--app-shell-navbar-offset"] = "0px";
        if (mode === "static") maxMediaStyles[breakpointValue]["--app-shell-navbar-grid-width"] = "0px";
        maxMediaStyles[breakpointValue]["--app-shell-navbar-transform"] = collapsedNavbarTransform;
        maxMediaStyles[breakpointValue]["--app-shell-navbar-transform-rtl"] = collapsedNavbarTransformRtl;
    }
}







"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/get-padding-value/get-padding-value.ts
function $ed317108986257b0$export$802b63d1375ae912(padding) {
    return Number(padding) === 0 ? "0px" : (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(padding);
}


"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/assign-padding-variables/assign-padding-variables.ts
function $00df409f9b7f8b8f$export$32b13804b21181d0({ padding: padding, baseStyles: baseStyles, minMediaStyles: minMediaStyles }) {
    if ((0, $dbe2020228889b86$export$595d4c6c22e3891)(padding)) baseStyles["--app-shell-padding"] = (0, $ed317108986257b0$export$802b63d1375ae912)((0, $0788b76ca8d1217c$export$88a9076c5877d24f)(padding));
    if ((0, $3e5e4a7b004b31ae$export$13e1ea2a48bdc51e)(padding)) {
        if (padding.base) baseStyles["--app-shell-padding"] = (0, $ed317108986257b0$export$802b63d1375ae912)(padding.base);
        (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(padding).forEach((key)=>{
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-padding"] = (0, $ed317108986257b0$export$802b63d1375ae912)(padding[key]);
            }
        });
    }
}


"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/get-variables/get-variables.ts
function $fcb9f4e004c28daf$export$a39eddd73bba62c1({ navbar: navbar, header: header, footer: footer, aside: aside, padding: padding, theme: theme, mode: mode }) {
    const minMediaStyles = {};
    const maxMediaStyles = {};
    const baseStyles = {};
    if (mode === "static") {
        baseStyles["--app-shell-main-grid-column"] = "1 / -1";
        baseStyles["--app-shell-main-grid-row"] = "2";
    }
    (0, $5b76db2b2ae599e8$export$4e3d4baa5f113da9)({
        baseStyles: baseStyles,
        minMediaStyles: minMediaStyles,
        maxMediaStyles: maxMediaStyles,
        navbar: navbar,
        theme: theme,
        mode: mode
    });
    (0, $e50d39ec24509fdf$export$b266d6a359856a1d)({
        baseStyles: baseStyles,
        minMediaStyles: minMediaStyles,
        maxMediaStyles: maxMediaStyles,
        aside: aside,
        theme: theme,
        mode: mode
    });
    (0, $2bb10e190151b86d$export$9990017af629c1d7)({
        baseStyles: baseStyles,
        minMediaStyles: minMediaStyles,
        header: header,
        mode: mode
    });
    (0, $2fb426187e235bef$export$9b0931cecc660105)({
        baseStyles: baseStyles,
        minMediaStyles: minMediaStyles,
        footer: footer,
        mode: mode
    });
    (0, $00df409f9b7f8b8f$export$32b13804b21181d0)({
        baseStyles: baseStyles,
        minMediaStyles: minMediaStyles,
        padding: padding
    });
    const minMedia = (0, $e4e164d3d352ee58$export$bd80382e31449c0e)((0, $76cd5f02de8ee394$export$ed97f33186d4b816)(minMediaStyles), theme.breakpoints).map((breakpoint)=>({
            query: `(min-width: ${(0, $7a68b0670ce0ab52$export$c63c6f932822f543)(breakpoint.px)})`,
            styles: minMediaStyles[breakpoint.value]
        }));
    const maxMedia = (0, $e4e164d3d352ee58$export$bd80382e31449c0e)((0, $76cd5f02de8ee394$export$ed97f33186d4b816)(maxMediaStyles), theme.breakpoints).map((breakpoint)=>({
            query: `(max-width: ${(0, $7a68b0670ce0ab52$export$c63c6f932822f543)(breakpoint.px)})`,
            styles: maxMediaStyles[breakpoint.value]
        }));
    return {
        baseStyles: baseStyles,
        media: [
            ...minMedia,
            ...maxMedia
        ]
    };
}



"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/AppShellMediaStyles.tsx
function $dbef21a227d6a722$export$f0ff95717b842c51({ navbar: navbar, header: header, aside: aside, footer: footer, padding: padding, mode: mode, selector: selector }) {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const ctx = (0, $bbb97275c373484a$export$2f9729a1501fd576)();
    const { media: media, baseStyles: baseStyles } = (0, $fcb9f4e004c28daf$export$a39eddd73bba62c1)({
        navbar: navbar,
        header: header,
        footer: footer,
        aside: aside,
        padding: padding,
        theme: theme,
        mode: mode
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e221d2b030e78e40$export$6b8bda124c097cf0), {
        media: media,
        styles: baseStyles,
        selector: selector || ctx.cssVariablesSelector
    });
}







parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellNavbar/AppShellNavbar.tsx
const $81ba6bfef5e37874$export$8a923106bebaaaad = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, withBorder: withBorder, zIndex: zIndex, mod: mod, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AppShellNavbar", null, _props);
    const ctx = (0, $bc836bedbf7f5239$export$6a9abcfe5948d367)();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "nav",
        mod: [
            {
                "with-border": withBorder ?? ctx.withBorder
            },
            mod
        ],
        ...ctx.getStyles("navbar", {
            className: className,
            classNames: classNames,
            styles: styles,
            style: style
        }),
        ...others,
        __vars: {
            "--app-shell-navbar-z-index": `calc(${zIndex ?? ctx.zIndex} + 1)`
        }
    });
});
$81ba6bfef5e37874$export$8a923106bebaaaad.classes = (0, $5d5e905597c33b78$export$2e2bcd8739ae039);
$81ba6bfef5e37874$export$8a923106bebaaaad.displayName = "@mantine/core/AppShellNavbar";








"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellSection/AppShellSection.tsx
const $bbd9fd8be7935767$export$807454a51b0b3c53 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, grow: grow, mod: mod, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AppShellSection", null, _props);
    const ctx = (0, $bc836bedbf7f5239$export$6a9abcfe5948d367)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        mod: [
            {
                grow: grow
            },
            mod
        ],
        ...ctx.getStyles("section", {
            className: className,
            style: style,
            classNames: classNames,
            styles: styles
        }),
        ...others
    });
});
$bbd9fd8be7935767$export$807454a51b0b3c53.classes = (0, $5d5e905597c33b78$export$2e2bcd8739ae039);
$bbd9fd8be7935767$export$807454a51b0b3c53.displayName = "@mantine/core/AppShellSection";



var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/AppShell/use-resizing/use-resizing.tsx
function $32177cc1fc184ed4$export$a300664a1a230956({ transitionDuration: transitionDuration, disabled: disabled }) {
    const [resizing, setResizing] = (0, $acw62.useState)(true);
    const resizingTimeout = (0, $acw62.useRef)(-1);
    const disabledTimeout = (0, $acw62.useRef)(-1);
    (0, $f73e1d55da1ebeeb$export$ee579bb285b8d4aa)("resize", ()=>{
        setResizing(true);
        clearTimeout(resizingTimeout.current);
        resizingTimeout.current = window.setTimeout(()=>(0, $acw62.startTransition)(()=>{
                setResizing(false);
            }), 200);
    });
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        setResizing(true);
        clearTimeout(disabledTimeout.current);
        disabledTimeout.current = window.setTimeout(()=>(0, $acw62.startTransition)(()=>{
                setResizing(false);
            }), transitionDuration || 0);
    }, [
        disabled,
        transitionDuration
    ]);
    return resizing;
}




"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShell.tsx
const $dc95f0b8bd3f9327$var$defaultProps = {
    withBorder: true,
    padding: 0,
    transitionDuration: 200,
    transitionTimingFunction: "ease",
    zIndex: (0, $f4b868e08831abbf$export$65573e7d509c92dc)("app"),
    mode: "fixed"
};
const $dc95f0b8bd3f9327$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { transitionDuration: transitionDuration, transitionTimingFunction: transitionTimingFunction })=>({
        root: {
            "--app-shell-transition-duration": `${transitionDuration}ms`,
            "--app-shell-transition-timing-function": transitionTimingFunction
        }
    }));
const $dc95f0b8bd3f9327$export$2afed54d6b7d68d9 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AppShell", $dc95f0b8bd3f9327$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, navbar: navbar, withBorder: withBorder, padding: padding, transitionDuration: transitionDuration, transitionTimingFunction: transitionTimingFunction, header: header, zIndex: zIndex, layout: layout, disabled: disabled, aside: aside, footer: footer, offsetScrollbars: offsetScrollbars = true, mode: mode, mod: mod, attributes: attributes, id: id, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "AppShell",
        classes: (0, $5d5e905597c33b78$export$2e2bcd8739ae039),
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $dc95f0b8bd3f9327$var$varsResolver
    });
    const resizing = (0, $32177cc1fc184ed4$export$a300664a1a230956)({
        disabled: disabled,
        transitionDuration: transitionDuration
    });
    const _id = (0, $cee42e5537afff93$export$f680877a34711e37)(id);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $bc836bedbf7f5239$export$f1c70b06465d541e), {
        value: {
            getStyles: getStyles,
            withBorder: withBorder,
            zIndex: zIndex,
            disabled: disabled,
            offsetScrollbars: offsetScrollbars,
            mode: mode
        },
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dbef21a227d6a722$export$f0ff95717b842c51), {
                navbar: navbar,
                header: header,
                aside: aside,
                footer: footer,
                padding: padding,
                mode: mode,
                selector: mode === "static" ? `#${_id}` : void 0
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                ...getStyles("root"),
                id: _id,
                mod: [
                    {
                        resizing: resizing,
                        layout: layout,
                        disabled: disabled,
                        mode: mode
                    },
                    mod
                ],
                ...others
            })
        ]
    });
});
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.classes = (0, $5d5e905597c33b78$export$2e2bcd8739ae039);
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.varsResolver = $dc95f0b8bd3f9327$var$varsResolver;
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.displayName = "@mantine/core/AppShell";
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.Navbar = (0, $81ba6bfef5e37874$export$8a923106bebaaaad);
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.Header = (0, $f45aa3268986d2cf$export$7932a9fc07def21a);
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.Main = (0, $b02392ee6d9b6089$export$38840998a170df80);
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.Aside = (0, $78e6f4a4a0198500$export$53f6f96f8b7092f2);
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.Footer = (0, $7f89d268cd453eb6$export$c7be6f5ced93654d);
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.Section = (0, $bbd9fd8be7935767$export$807454a51b0b3c53);










"use client";
//#region packages/@mantine/core/src/components/Burger/Burger.module.css
var $7dbdc4eb4f81fb98$export$2e2bcd8739ae039 = {
    "root": "m_fea6bf1a",
    "burger": "m_d4fb9cad"
};



"use client";
//#region packages/@mantine/core/src/components/Burger/Burger.tsx
const $9ff5b9fe3a78c7ce$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { color: color, size: size, lineSize: lineSize, transitionDuration: transitionDuration, transitionTimingFunction: transitionTimingFunction })=>({
        root: {
            "--burger-color": color ? (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(color, theme) : void 0,
            "--burger-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "burger-size"),
            "--burger-line-size": lineSize ? (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(lineSize) : void 0,
            "--burger-transition-duration": transitionDuration === void 0 ? void 0 : `${transitionDuration}ms`,
            "--burger-transition-timing-function": transitionTimingFunction
        }
    }));
const $9ff5b9fe3a78c7ce$export$3990fdb7137d85ae = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Burger", null, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, opened: opened, children: children, transitionDuration: transitionDuration, transitionTimingFunction: transitionTimingFunction, lineSize: lineSize, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Burger",
        classes: (0, $7dbdc4eb4f81fb98$export$2e2bcd8739ae039),
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $9ff5b9fe3a78c7ce$var$varsResolver
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), {
        ...getStyles("root"),
        ...others,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                mod: [
                    "reduce-motion",
                    {
                        opened: opened
                    }
                ],
                ...getStyles("burger")
            }),
            children
        ]
    });
});
$9ff5b9fe3a78c7ce$export$3990fdb7137d85ae.classes = (0, $7dbdc4eb4f81fb98$export$2e2bcd8739ae039);
$9ff5b9fe3a78c7ce$export$3990fdb7137d85ae.varsResolver = $9ff5b9fe3a78c7ce$var$varsResolver;
$9ff5b9fe3a78c7ce$export$3990fdb7137d85ae.displayName = "@mantine/core/Burger";







"use client";
//#region packages/@mantine/core/src/components/Container/Container.module.css
var $bd12188ed7dd9507$export$2e2bcd8739ae039 = {
    "root": "m_7485cace"
};



"use client";
//#region packages/@mantine/core/src/components/Container/Container.tsx
const $2903b8a25a65807a$var$defaultProps = {
    strategy: "block"
};
const $2903b8a25a65807a$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size, fluid: fluid })=>({
        root: {
            "--container-size": fluid ? void 0 : (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "container-size")
        }
    }));
const $2903b8a25a65807a$export$42a852a2b6b56249 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Container", $2903b8a25a65807a$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, fluid: fluid, mod: mod, attributes: attributes, strategy: strategy, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Container",
        classes: (0, $bd12188ed7dd9507$export$2e2bcd8739ae039),
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $2903b8a25a65807a$var$varsResolver
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        mod: [
            {
                fluid: fluid,
                strategy: strategy
            },
            mod
        ],
        ...getStyles("root"),
        ...others
    });
});
$2903b8a25a65807a$export$42a852a2b6b56249.classes = (0, $bd12188ed7dd9507$export$2e2bcd8739ae039);
$2903b8a25a65807a$export$42a852a2b6b56249.varsResolver = $2903b8a25a65807a$var$varsResolver;
$2903b8a25a65807a$export$42a852a2b6b56249.displayName = "@mantine/core/Container";







"use client";
//#region packages/@mantine/core/src/components/Image/Image.module.css
var $d673717bc5724c9d$export$2e2bcd8739ae039 = {
    "root": "m_9e117634"
};



var $acw62 = parcelRequire("acw62");

"use client";
//#region packages/@mantine/core/src/components/Image/Image.tsx
const $95f3644217e6673d$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { radius: radius, fit: fit })=>({
        root: {
            "--image-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--image-object-fit": fit
        }
    }));
const $95f3644217e6673d$export$3e431a229df88919 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Image", null, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, onError: onError, src: src, radius: radius, fit: fit, fallbackSrc: fallbackSrc, mod: mod, attributes: attributes, ...others } = props;
    const [error, setError] = (0, $acw62.useState)(!src);
    (0, $acw62.useEffect)(()=>setError(!src), [
        src
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Image",
        classes: (0, $d673717bc5724c9d$export$2e2bcd8739ae039),
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $95f3644217e6673d$var$varsResolver
    });
    if (error && fallbackSrc) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "img",
        src: fallbackSrc,
        ...getStyles("root"),
        onError: onError,
        mod: [
            "fallback",
            mod
        ],
        ...others
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        component: "img",
        ...getStyles("root"),
        src: src,
        onError: (event)=>{
            onError?.(event);
            setError(true);
        },
        mod: mod,
        ...others
    });
});
$95f3644217e6673d$export$3e431a229df88919.classes = (0, $d673717bc5724c9d$export$2e2bcd8739ae039);
$95f3644217e6673d$export$3e431a229df88919.varsResolver = $95f3644217e6673d$var$varsResolver;
$95f3644217e6673d$export$3e431a229df88919.displayName = "@mantine/core/Image";







"use client";
//#region packages/@mantine/core/src/components/Title/get-title-size.ts
const $e4fe3ad81ad8c4ca$var$headings = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
];
const $e4fe3ad81ad8c4ca$var$sizes = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
function $e4fe3ad81ad8c4ca$export$f6b837b5b6e905c7(order, size) {
    const titleSize = size !== void 0 ? size : `h${order}`;
    if ($e4fe3ad81ad8c4ca$var$headings.includes(titleSize)) return {
        fontSize: `var(--mantine-${titleSize}-font-size)`,
        fontWeight: `var(--mantine-${titleSize}-font-weight)`,
        lineHeight: `var(--mantine-${titleSize}-line-height)`
    };
    else if ($e4fe3ad81ad8c4ca$var$sizes.includes(titleSize)) return {
        fontSize: `var(--mantine-font-size-${titleSize})`,
        fontWeight: `var(--mantine-h${order}-font-weight)`,
        lineHeight: `var(--mantine-h${order}-line-height)`
    };
    return {
        fontSize: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(titleSize),
        fontWeight: `var(--mantine-h${order}-font-weight)`,
        lineHeight: `var(--mantine-h${order}-line-height)`
    };
}


"use client";
//#region packages/@mantine/core/src/components/Title/Title.module.css
var $ac73af9ec0cba08b$export$2e2bcd8739ae039 = {
    "root": "m_8a5d1357"
};



"use client";
//#region packages/@mantine/core/src/components/Title/Title.tsx
const $67043e2cdc2b41f6$var$defaultProps = {
    order: 1
};
const $67043e2cdc2b41f6$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { order: order, size: size, lineClamp: lineClamp, textWrap: textWrap })=>{
    const sizeVariables = (0, $e4fe3ad81ad8c4ca$export$f6b837b5b6e905c7)(order || 1, size);
    return {
        root: {
            "--title-fw": sizeVariables.fontWeight,
            "--title-lh": sizeVariables.lineHeight,
            "--title-fz": sizeVariables.fontSize,
            "--title-line-clamp": typeof lineClamp === "number" ? lineClamp.toString() : void 0,
            "--title-text-wrap": textWrap
        }
    };
});
const $67043e2cdc2b41f6$export$f99233281efd08a0 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Title", $67043e2cdc2b41f6$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, order: order, vars: vars, size: size, variant: variant, lineClamp: lineClamp, textWrap: textWrap, mod: mod, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Title",
        props: props,
        classes: (0, $ac73af9ec0cba08b$export$2e2bcd8739ae039),
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $67043e2cdc2b41f6$var$varsResolver
    });
    if (![
        1,
        2,
        3,
        4,
        5,
        6
    ].includes(order)) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...getStyles("root"),
        component: `h${order}`,
        variant: variant,
        mod: [
            {
                order: order,
                "data-line-clamp": typeof lineClamp === "number"
            },
            mod
        ],
        size: size,
        ...others
    });
});
$67043e2cdc2b41f6$export$f99233281efd08a0.classes = (0, $ac73af9ec0cba08b$export$2e2bcd8739ae039);
$67043e2cdc2b41f6$export$f99233281efd08a0.varsResolver = $67043e2cdc2b41f6$var$varsResolver;
$67043e2cdc2b41f6$export$f99233281efd08a0.displayName = "@mantine/core/Title";



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/use-disclosure/use-disclosure.ts
function $f8988135042e9951$export$6e3e27031a30522f(initialState = false, options = {}) {
    const [opened, setOpened] = (0, $acw62.useState)(initialState);
    const open = (0, $acw62.useCallback)(()=>{
        setOpened((isOpened)=>{
            if (!isOpened) {
                options.onOpen?.();
                return true;
            }
            return isOpened;
        });
    }, [
        options.onOpen
    ]);
    const close = (0, $acw62.useCallback)(()=>{
        setOpened((isOpened)=>{
            if (isOpened) {
                options.onClose?.();
                return false;
            }
            return isOpened;
        });
    }, [
        options.onClose
    ]);
    return [
        opened,
        {
            open: open,
            close: close,
            toggle: (0, $acw62.useCallback)(()=>{
                opened ? close() : open();
            }, [
                close,
                open,
                opened
            ]),
            set: setOpened
        }
    ];
}


parcelRequire("acw62");



const { slice: $60196a4650e96cb1$var$slice, forEach: $60196a4650e96cb1$var$forEach } = [];
function $60196a4650e96cb1$var$defaults(obj) {
    $60196a4650e96cb1$var$forEach.call($60196a4650e96cb1$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $60196a4650e96cb1$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $60196a4650e96cb1$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $60196a4650e96cb1$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $60196a4650e96cb1$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $60196a4650e96cb1$var$serializeCookie(name, value, cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name, domain) {
        this.create(name, '', -1, domain);
    }
};
var $60196a4650e96cb1$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $60196a4650e96cb1$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $60196a4650e96cb1$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $60196a4650e96cb1$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$hash = {
    name: 'hash',
    // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
    lookup (_ref) {
        let { lookupHash: lookupHash, lookupFromHashIndex: lookupFromHashIndex } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            const { hash: hash } = window.location;
            if (hash && hash.length > 2) {
                const query = hash.substring(1);
                if (lookupHash) {
                    const params = query.split('&');
                    for(let i = 0; i < params.length; i++){
                        const pos = params[i].indexOf('=');
                        if (pos > 0) {
                            const key = params[i].substring(0, pos);
                            if (key === lookupHash) found = params[i].substring(pos + 1);
                        }
                    }
                }
                if (found) return found;
                if (!found && lookupFromHashIndex > -1) {
                    const language = hash.match(/\/([a-zA-Z-]*)/g);
                    if (!Array.isArray(language)) return undefined;
                    const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
                    return language[index]?.replace('/', '');
                }
            }
        }
        return found;
    }
};
let $60196a4650e96cb1$var$hasLocalStorageSupport = null;
const $60196a4650e96cb1$var$localStorageAvailable = ()=>{
    if ($60196a4650e96cb1$var$hasLocalStorageSupport !== null) return $60196a4650e96cb1$var$hasLocalStorageSupport;
    try {
        $60196a4650e96cb1$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$60196a4650e96cb1$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasLocalStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasLocalStorageSupport;
};
var $60196a4650e96cb1$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $60196a4650e96cb1$var$hasSessionStorageSupport = null;
const $60196a4650e96cb1$var$sessionStorageAvailable = ()=>{
    if ($60196a4650e96cb1$var$hasSessionStorageSupport !== null) return $60196a4650e96cb1$var$hasSessionStorageSupport;
    try {
        $60196a4650e96cb1$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$60196a4650e96cb1$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasSessionStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasSessionStorageSupport;
};
var $60196a4650e96cb1$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $60196a4650e96cb1$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $60196a4650e96cb1$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $60196a4650e96cb1$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return language[index]?.replace('/', '');
    }
};
var $60196a4650e96cb1$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $60196a4650e96cb1$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $60196a4650e96cb1$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $60196a4650e96cb1$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$60196a4650e96cb1$var$canCookies) $60196a4650e96cb1$var$order.splice(1, 1);
const $60196a4650e96cb1$var$getDefaults = ()=>({
        order: $60196a4650e96cb1$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $60196a4650e96cb1$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $60196a4650e96cb1$var$defaults(options, this.options || {}, $60196a4650e96cb1$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($60196a4650e96cb1$var$cookie$1);
        this.addDetector($60196a4650e96cb1$var$querystring);
        this.addDetector($60196a4650e96cb1$var$localStorage);
        this.addDetector($60196a4650e96cb1$var$sessionStorage);
        this.addDetector($60196a4650e96cb1$var$navigator$1);
        this.addDetector($60196a4650e96cb1$var$htmlTag);
        this.addDetector($60196a4650e96cb1$var$path);
        this.addDetector($60196a4650e96cb1$var$subdomain);
        this.addDetector($60196a4650e96cb1$var$hash);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$60196a4650e96cb1$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$60196a4650e96cb1$export$2e2bcd8739ae039.type = 'languageDetector';



var $dc3e861ed4ee6a89$exports = {};
$dc3e861ed4ee6a89$exports = JSON.parse('{"nav":{"home":"Start","tutorials":"Tutorials","barcodes":"Barcodes","contact":"Kontakt","logout":"Abmelden","logoAlt":"DinLabel","download":"Herunterladen","downloadDemo":"Demo herunterladen","buy":"Abonnieren","login":"Anmelden","myAccount":"Mein Konto","language":"Sprache","distributorPortal":"H\xe4ndlerportal"},"language":{"title":"Sprache","description":"W\xe4hlen Sie die Sprache der Anwendung. Standardm\xe4\xdfig wird die Browsersprache verwendet.","browser":"Browsersprache verwenden","english":"Englisch","spanish":"Spanisch","german":"Deutsch","french":"Franz\xf6sisch"},"offline":{"title":"Offline","message":"Die Anwendung kann keine Verbindung zum Server herstellen :( !!"},"dialogs":{"apiError":"API-Fehler","confirmYes":"Ja","cancel":"Abbrechen","send":"Senden"},"portal":{"pageTitle":"H\xe4ndlerportal","actions":"Aktionen","authorized":"Autorisiert","pending":"Genehmigung ausstehend","buyLicenses":"Lizenzen kaufen","pendingApproval":"Ihr H\xe4ndlerantrag wurde noch nicht genehmigt \u2013 bei Fragen k\xf6nnen Sie {{email}} kontaktieren. Dieser Vorgang sollte nicht l\xe4nger als 2 Werktage dauern.","distributorInfo":"Informationen f\xfcr H\xe4ndler","loading":"H\xe4ndlerinformationen werden geladen\u2026","loadError":"H\xe4ndlerinformationen konnten nicht geladen werden."},"licenses":{"noneAvailable":"Sie haben derzeit keine Lizenzen zum Senden verf\xfcgbar.","statAvailable":"Zum Senden verf\xfcgbar","statBought":"Gekauft","statSent":"Gesendet","sentHistory":"Gesendete Lizenzen","activatedYes":"Aktiviert","buyTitle":"H\xe4ndlerportal \u2013 Lizenzen kaufen","buyLoading":"Wird geladen\u2026","buyLoadError":"H\xe4ndlerinformationen konnten nicht geladen werden.","buyIntro":"Geben Sie an, wie viele Lizenzen Sie kaufen m\xf6chten \u2013 der H\xe4ndlerpreis betr\xe4gt {{price}} Pesos. H\xe4ndler k\xf6nnen DinLabel zu einem angemessenen Preis verkaufen; unser empfohlener Preis betr\xe4gt {{recommended}} Pesos.","licenseCountLabel":"Anzahl der Lizenzen","costSummary":"Die Kosten f\xfcr {{count}} Lizenzen betragen {{cost}} Pesos + Steuern.","buyButton":"{{count}} Lizenzen kaufen","sendTitle":"Lizenz senden","resendConfirm":"M\xf6chten Sie die Lizenz erneut an {{email}} senden?","sendPrompt":"Geben Sie die E-Mail-Adresse ein, an die gesendet werden soll","emailPlaceholder":"email@beispiel.com","errorTitle":"Fehler!","sendError":"Beim Senden der Lizenz ist ein Fehler aufgetreten {{error}}","resentTitle":"Lizenz erneut gesendet!","resentMessage":"Die Lizenz wurde erneut an {{email}} mit Kopie an {{cc}} gesendet","sentTitle":"Lizenz gesendet!","sentMessage":"Die Lizenz wurde an {{email}} mit Kopie an {{cc}} gesendet","sendToEmail":"Lizenz per E-Mail senden...","recipient":"Lizenzempf\xe4nger","date":"Datum","sent":"Gesendet","activated":"Aktiviert","notActivated":"Noch nicht aktiviert","resend":"Lizenz erneut senden"},"register":{"title":"H\xe4ndler werden","intro":"Um auf das DinLabel-H\xe4ndlerportal zuzugreifen, m\xfcssen Sie sich zuerst registrieren:","company":"Firma","companyPlaceholder":"Firmenname","phone":"Telefon","phonePlaceholder":"Telefon","phoneDescription":"Achten Sie darauf, die L\xe4ndervorwahl anzugeben, z. B. +49 30...","street":"Stra\xdfe","street1Placeholder":"Stra\xdfe 1","street2Placeholder":"Stra\xdfe 2","number":"Nummer","city":"Stadt","state":"Bundesland","country":"Land","zip":"Postleitzahl","rfc":"Steuer-ID","nextSteps":"Sie erhalten eine E-Mail mit den n\xe4chsten Schritten","submit":"Absenden"},"faq":{"qGoogleAccount":"Ben\xf6tige ich ein Google-Konto, um DINLabel-H\xe4ndler zu werden?","aGoogleAccount":"Ja, Sie ben\xf6tigen ein Google-Konto. Wenn Sie bereits eines haben, k\xf6nnen Sie sich damit im H\xe4ndlerportal anmelden.","qRequirements":"Was brauche ich, um DINLabel-H\xe4ndler zu werden?","aRequirementsBefore":"Registrieren Sie sich als H\xe4ndler im","aRequirementsLink":"H\xe4ndlerportal","aRequirementsAfter":"und warten Sie auf die Best\xe4tigungs-E-Mail, die Sie als DINLabel-H\xe4ndler autorisiert.","qAnyoneCanSell":"Kann jede Person oder jedes Unternehmen DINLabel verkaufen?","aAnyoneCanSell":"Ja, Sie m\xfcssen sich nur im DINLabel-H\xe4ndlerportal registrieren und die Best\xe4tigungs-E-Mail erhalten.","qHowManyDistributors":"Wie viele H\xe4ndler kann es bei DINLabel geben?","aHowManyDistributors":"Es gibt keine Begrenzung.","qDistributorCost":"Was kostet eine DINLabel-Lizenz f\xfcr einen H\xe4ndler?","aDistributorCost":"112 USD zuz\xfcglich Steuern pro Lizenz.","qRecommendedPrice":"Was ist der empfohlene Verkaufspreis vom H\xe4ndler an seine Kunden f\xfcr eine DINLabel-Lizenz?","aRecommendedPrice":"Der H\xe4ndler legt den Preis fest; es gibt keinen festen Preis. Wir empfehlen einen Verkaufspreis von 160 USD zuz\xfcglich Steuern. Direktkunden im DinLabel-Portal abonnieren f\xfcr 15 USD pro Monat zuz\xfcglich Steuern.","qWhereToBuy":"Wo kann ein Endnutzer DinLabel erhalten?","aWhereToBuyBefore":"Neue Kunden abonnieren monatlich auf der Abonnementseite oder erhalten eine Lizenz von einem H\xe4ndler. Bestehende Einmalk\xe4ufer behalten lebenslangen Zugriff. Abonnieren Sie im Portal","qHowBuyAsDistributor":"Als H\xe4ndler, wie kaufe ich DINLabel-Lizenzen?","aHowBuyAsDistributorBefore":"\xdcber das H\xe4ndlerportal im Bereich Lizenzen kaufen. Siehe das Tutorial","aHowBuyAsDistributorLink":"wie man Lizenzen kauft.","qMinimumLicenses":"Als H\xe4ndler, wie viele Lizenzen muss ich mindestens kaufen, um sie sp\xe4ter an meine Kunden zu verkaufen?","aMinimumLicenses":"Es gibt kein Minimum; Sie k\xf6nnen ab 1 Lizenz kaufen.","qHowDeliver":"Als H\xe4ndler, wie liefere ich eine DINLabel-Lizenz an meinen Kunden?","aHowDeliverBefore":"\xdcber das H\xe4ndlerportal im Bereich","aHowDeliverSendLink":"Lizenzen senden","aHowDeliverMiddle":"; siehe das","aHowDeliverTutorialLink":"Tutorial zum Senden von Lizenzen.","qHowLongPurchase":"Wie lange dauert es, als H\xe4ndler eine Lizenz zu kaufen und an den Kunden zu liefern?","aHowLongPurchase":"Wenn Sie bereits als H\xe4ndler registriert sind, k\xf6nnen Kauf und Lizenzlieferung in wenigen Minuten erfolgen.","qHowLongToSell":"Als H\xe4ndler, wie lange habe ich Zeit, die im Portal gekauften Lizenzen zu verkaufen?","aHowLongToSell":"H\xe4ndlerlizenzen verfallen nicht. Beim Kauf werden sie Ihrem Lizenzbestand hinzugef\xfcgt und k\xf6nnen jederzeit verwendet werden.","qHowManyAvailable":"Wie kann ich als H\xe4ndler sehen, wie viele Lizenzen ich habe?","aHowManyAvailableBefore":"Wenn Sie das DINLabel-","aHowManyAvailableLink":"H\xe4ndlerportal","aHowManyAvailableAfter":" \xf6ffnen, zeigt der erste Bildschirm Ihren Bestand an zum Senden verf\xfcgbaren Lizenzen.","qSoldLicenses":"Wie kann ich sehen, welche Lizenzen ich verkauft habe und an wen?","aSoldLicensesBefore":"\xdcber das DINLabel-H\xe4ndlerportal unter","aSoldLicensesLink":"Details anzeigen","qTryBefore":"Kann ich DINLabel ausprobieren, bevor ich H\xe4ndler werde?","aTryBeforeBefore":"Ja, Sie k\xf6nnen eine Demo unter","aTryBeforeAfter":"herunterladen und ausprobieren.","qMainFaq":"Gibt es FAQs (h\xe4ufig gestellte Fragen) im DINLabel-Portal?","aMainFaqBefore":"Unter","aMainFaqAfter":"finden Sie die h\xe4ufigsten Fragen zur Nutzung des DINLabel-Systems.","qTutorials":"Gibt es Tutorials zur Nutzung von DINLabel?","aTutorialsBefore":"Unter","aTutorialsAfter":"finden Sie alle ben\xf6tigten Tutorials zur Nutzung von DINLabel.","qSupport":"Habe ich als H\xe4ndler technischen Support?","aSupport":"Per E-Mail; siehe das Ende dieser FAQ.","qOtherQuestion":"Ich habe eine Frage, die nicht auf der Liste steht. Was kann ich tun?","aOtherQuestionBefore":"Wir helfen Ihnen gerne. Gehen Sie zu","aOtherQuestionLink":"Kontakt","aOtherQuestionAfter":", senden Sie Ihre Fragen, und wir antworten Ihnen gerne."},"tutorials":{"title":"Tutorials","alsoSeeFaqBefore":"Sie k\xf6nnen auch die","alsoSeeFaqLink":"FAQ","sendLicenseTutorial":"Tutorial: So senden Sie eine Lizenz aus dem H\xe4ndlerportal","iframeTitle":"Tutorial Lizenz senden"},"home":{"welcome":"Willkommen, {{email}}","error":"Fehler"},"userLicenses":{"hasLicense":"Sie haben bereits vollen Zugriff auf DinLabel.","hasSubscription":"Ihr DinLabel-Abonnement ist aktiv.","manageBilling":"Abrechnung verwalten","noLicense":"Sie haben kein aktives DinLabel-Abonnement","buyHere":"Hier abonnieren"},"signin":{"title":"Anmelden","intro":"Melden Sie sich mit Google oder mit E-Mail und Passwort an.","withGoogle":"Mit Google anmelden","orEmail":"oder","email":"E-Mail","password":"Passwort","withEmail":"Mit E-Mail anmelden","createAccount":"Konto erstellen","forgotPassword":"Passwort vergessen?","emailPasswordError":"Anmeldung fehlgeschlagen. Pr\xfcfen Sie E-Mail und Passwort.","agreePrefix":"Indem Sie fortfahren, stimmen Sie unserer","privacyLink":"Datenschutzerkl\xe4rung und den Nutzungsbedingungen","alreadySignedIn":"Sie sind bereits angemeldet","signedInAs":"Angemeldet als {{email}}","continue":"Weiter","debugSignInUrl":"Anmelde-URL"},"registerAccount":{"title":"Konto erstellen","intro":"Registrieren Sie sich mit E-Mail und Passwort.","email":"E-Mail","password":"Passwort","passwordHint":"Mindestens 8 Zeichen","submit":"Konto erstellen","haveAccount":"Haben Sie bereits ein Konto?","signIn":"Anmelden","error":"Konto konnte nicht erstellt werden.","googleExists":"Diese E-Mail ist bereits mit Google registriert. Melden Sie sich mit Google an und f\xfcgen Sie danach unter Mein Konto ein Passwort hinzu."},"forgotPassword":{"title":"Passwort vergessen","intro":"Geben Sie Ihre E-Mail ein. Wenn ein Konto existiert, senden wir einen Reset-Link.","email":"E-Mail","submit":"Reset-Link senden","sent":"Wenn ein Konto mit dieser E-Mail existiert, wurde ein Reset-Link gesendet.","backToSignIn":"Zur\xfcck zur Anmeldung","error":"Reset-E-Mail konnte nicht gesendet werden."},"resetPassword":{"title":"Passwort zur\xfccksetzen","password":"Neues Passwort","passwordHint":"Mindestens 8 Zeichen","submit":"Passwort aktualisieren","success":"Ihr Passwort wurde aktualisiert.","signIn":"Anmelden","backToSignIn":"Zur\xfcck zur Anmeldung","invalidLink":"Dieser Reset-Link ist ung\xfcltig oder unvollst\xe4ndig.","error":"Passwort konnte nicht zur\xfcckgesetzt werden."},"applogin":{"title":"In DinLabel fortfahren","intro":"Fahren Sie fort, um die Anmeldung in der Desktop-App abzuschlie\xdfen.","signedInAs":"Sie sind angemeldet als {{email}}.","continue":"Weiter","switchAccount":"Anderes Konto verwenden","redirecting":"Weiterleitung zur Anmeldung\u2026","invalidTitle":"Ung\xfcltiger Anmeldelink","invalidBody":"Diese Seite wird von der DinLabel-Desktop-App ge\xf6ffnet. Bitte starten Sie die Anmeldung in der Anwendung."},"marketing":{"headline":"Professionelle Software f\xfcr Etikettenverwaltung und -druck","slogan":"Konfigurieren und drucken Sie einfach auf Thermo- (Zebra und mehr), Laser- und Tintenstrahldruckern. F\xfcgen Sie Texte, Barcodes, variable Daten und fortlaufende Nummerierung auf Stoff-, Karton- oder Klebeetiketten hinzu.","featureNumbers":"Fortlaufende Nummerierung & Z\xe4hler","featureImages":"Scharfe Logos & Bilder","featureVariable":"Variable Daten ohne Aufwand","featureQr":"Interaktive QR-Codes","featureText":"Klarer, lesbarer Text","featureBarcode":"Professionelle Barcodes","featureDemo":{"productName":"Produktname","oliveOil":"Oliven\xf6l","oliveOilDesc":"Beschreibung des Oliven\xf6ls","fontsNote":"Klare, feine, lesbare Schriften","sequence":"Sequenz {{n}}","client":"KUNDE:","name":"Name","city":"STADT:","companyLogo":"Firmenlogo"},"featuresTitle":"Alles, was Sie auf einem Etikett brauchen","featuresSubtitle":"Erstellen Sie professionelle Etiketten mit den Werkzeugen, auf die Druckereien und Lagerh\xe4user t\xe4glich setzen.","seeBarcodeTypes":"Unterst\xfctzte Barcode-Typen ansehen","printersTitle":"Kompatibel mit jedem Drucker","printersSubtitle":"DinLabel verbindet sich direkt mit den Druckern, die Sie bereits in Ihrem Betrieb nutzen \u2014 \xfcber die Standard-Windows-Treiber.","printersTypesTitle":"Druckertypen und Medien:","printersThermalLabel":"Thermo und Thermotransfer:","printersThermalBody":"Ideal f\xfcr selbstklebende Rollenetiketten, Tyvek, Nylon, Karton usw.","printersLaserLabel":"Laser und Tintenstrahl (Inkjet):","printersLaserBody":"Ideal f\xfcr selbstklebende Bogenlayouts, Karton oder Stoff.","whyTitle":"Warum DinLabel?","whyCompatLabel":"Volle Kompatibilit\xe4t:","whyCompatBody":"Drucken Sie auf jedem Drucker (Thermo, Laser und Tintenstrahl) auf Rollen oder B\xf6gen.","whyCostLabel":"Keine aufgebl\xe4hten Kosten:","whyCostBody":"Alle professionellen Funktionen, ohne teure Enterprise-Lizenzen zu zahlen.","whySupportLabel":"Echter technischer Support:","whySupportBody":"Wir helfen Ihnen Schritt f\xfcr Schritt \u2014 vom Download und der Installation bis zum Druck Ihrer Etiketten.","tryTitle":"Testen Sie DinLabel noch heute kostenlos","trySubtitle":"Laden Sie die kostenlose Demo herunter, verbinden Sie den Drucker, den Sie haben (Thermo, Laser oder Tintenstrahl), und pr\xfcfen Sie in Minuten, wie Ihre Etiketten gedruckt werden.","needHelp":"Brauchen Sie Hilfe?","customerService":"Kundenservice","customerServiceText":"Kontaktieren Sie uns per E-Mail \u2013 wir helfen Ihnen gerne.","tutorialsText":"Schritt-f\xfcr-Schritt-Video-Tutorials f\xfcr jede Funktion."},"barcodes":{"title":"Barcode-Typen in DinLabel","intro":"DinLabel druckt die Barcode-Typen, die auf Einzelhandels-, Versand- und Industrieetiketten am h\xe4ufigsten vorkommen. Die folgenden Typen erscheinen zuerst, wenn Sie einen Barcode hinzuf\xfcgen. W\xe4hlen Sie im Editor Mehr anzeigen, um jeden weiteren unterst\xfctzten Typ zu verwenden.","commonTitle":"Die g\xe4ngigsten Barcode-Typen","commonIntro":"Diese Typen empfehlen wir f\xfcr die meisten Etiketten. DinLabel unterst\xfctzt sie alle direkt.","fullTitle":"Alle unterst\xfctzten Barcode-Typen","fullIntro":"Der Barcode-Editor zeigt diese Namen, wenn Sie Mehr anzeigen w\xe4hlen. Verwenden Sie in DinLabel denselben Namen wie hier.","fullCount":"DinLabel unterst\xfctzt {{count}} Barcode-Typen.","ctaInstall":"DinLabel herunterladen","ctaTutorials":"Barcode-Tutorials ansehen","common":{"UpcA":{"name":"UPC-A","description":"Der 12-stellige Barcode auf den meisten Produkten in Nordamerika."},"UpcE":{"name":"UPC-E","description":"Ein kompakter 6-stelliger UPC f\xfcr kleine Verpackungen, die kein UPC-A fassen."},"Ean13":{"name":"EAN-13","description":"Der 13-stellige Einzelhandelsbarcode, der weltweit verwendet wird, auch in Europa und Lateinamerika."},"Ean8":{"name":"EAN-8","description":"Ein k\xfcrzerer EAN f\xfcr kleine Produkte, die kein EAN-13 fassen."},"Code128":{"name":"Code 128","description":"Ein hochdichter linearer Barcode f\xfcr Buchstaben, Zahlen und Symbole. \xdcblich in Versand und Lager."},"GS1128":{"name":"GS1-128","description":"Code 128 mit GS1-Anwendungskennungen f\xfcr Logistik, GTIN, Charge und Datum."},"Code39":{"name":"Code 39","description":"Ein weit verbreiteter Industriebarcode f\xfcr Buchstaben, Zahlen und einige Symbole."},"Interleaved2of5":{"name":"Interleaved 2 of 5","description":"Ein kompakter numerischer Barcode f\xfcr Lager, Distribution und Industrieetiketten."},"Itf14":{"name":"ITF-14","description":"Ein 14-stelliger Barcode f\xfcr Versandkartons und Umverpackungen (GTIN-14)."},"QRCode":{"name":"QR-Code","description":"Ein 2D-Code f\xfcr URLs, Text und mehr. Einfach mit dem Handy zu scannen."},"DataMatrix":{"name":"Data Matrix","description":"Ein kompakter 2D-Code f\xfcr Elektronik, Gesundheitswesen und kleine Bauteile."},"Pdf417":{"name":"PDF417","description":"Ein gestapelter 2D-Barcode mit mehr Daten als typische 1D-Codes, z. B. auf Ausweisen, Versandetiketten und Tickets."}}},"footer":{"tagline":"Professionelles Etikettendesign f\xfcr Thermodrucker \u2014 Zebra und mehr.","privacy":"Datenschutz & Bedingungen","copyright":"\xa9 {{year}} DinLabel"},"install":{"title":"Herunterladen","intro":"Installieren Sie DinLabel unter Windows und beginnen Sie in Minuten mit dem Design von Etiketten f\xfcr Thermodrucker \u2014 einschlie\xdflich Zebra und anderer Windows-Etikettendrucker.","windowsNote":"Windows-Installer (.exe). Funktioniert unter Windows 7 und neuer.","requirements":"Systemanforderungen","reqWindows":"Jede Windows-Version ab Windows 7","reqInternet":"Internetzugang","reqDisk":"50 MB Festplattenspeicher","freeTag":"Demo-Version","freeText":"Die Demo-Version enth\xe4lt ein Wasserzeichen auf gedruckten Etiketten.","paidTitle":"Vollversion","paidText":"Keine Wasserzeichen \u2014 bereit f\xfcr den Produktionsdruck.","buyApp":"DinLabel abonnieren","orDistributor":"Lieber \xfcber einen Partner abonnieren?","distributorsLink":"H\xe4ndler anzeigen","emailModalTitle":"Demo herunterladen","emailModalIntro":"Geben Sie Ihre E-Mail-Adresse ein, um die DinLabel-Demo herunterzuladen.","emailLabel":"E-Mail","emailSubmit":"Herunterladen","emailInvalid":"Bitte geben Sie eine g\xfcltige E-Mail-Adresse ein.","emailSubmitError":"Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.","purchasedIntro":"Laden Sie DinLabel herunter und installieren Sie es, um Ihre Vollversion zu nutzen.","signInTitle":"So melden Sie sich an","signInStep1":"Laden Sie DinLabel mit der Schaltfl\xe4che oben herunter und installieren Sie es.","signInStep2":"\xd6ffnen Sie DinLabel.","signInStep3":"W\xe4hlen Sie Anmelden / Registrieren im Men\xfc.","signInStep4":"Melden Sie sich mit demselben Konto an, mit dem Sie abonniert haben. Nach der Anmeldung nutzen Sie die Vollversion von DinLabel.","signInStep4UnpurchasedBefore":"Melden Sie sich mit einem Konto an. Sie nutzen die Demo-Version,","signInStep4UnpurchasedLink":"bis Sie ein Abonnement abschlie\xdfen","signInStep4UnpurchasedAfter":"."},"fullTutorials":{"title":"Tutorials","intro":"Schritt-f\xfcr-Schritt-Videos, die Ihnen helfen, DinLabel zu nutzen, zu drucken und optimal einzusetzen.","howToRoll":"So erstellen Sie ein Etikett auf einer Rolle","howToSheet":"So erstellen Sie ein Etikett auf einem Bogen","howTo3Across":"So erstellen Sie 3-bahnige Etiketten","howToText":"So f\xfcgen Sie Text hinzu","howToShapes":"So f\xfcgen Sie Formen hinzu","howToImages":"So f\xfcgen Sie Bilder hinzu","howToBarCodes":"So f\xfcgen Sie Barcodes hinzu","howToQR":"So f\xfcgen Sie QR-Codes hinzu","howToPrint":"So drucken Sie","howToConsecutive":"So verwenden Sie fortlaufende Nummern","howToDataBase":"So verwenden Sie Datenbanken","howToBuy":"So abonnieren Sie DinLabel","alsoDistributor":"H\xe4ndlerspezifische Tutorials finden Sie im H\xe4ndlerportal.","distributorLink":"H\xe4ndlerportal \xf6ffnen"},"privacy":{"title":"Datenschutzerkl\xe4rung und Nutzungsbedingungen","eulaLink":"Endbenutzer-Lizenzvertrag","policyLink":"Datenschutzerkl\xe4rung","note":"Die Datenschutzerkl\xe4rung \xf6ffnet das lokalisierte statische HTML-Dokument.","loading":"Wird geladen\u2026","eulaLoadError":"Die EULA konnte nicht geladen werden."},"distributors":{"title":"H\xe4ndler"},"buyPage":{"title":"DinLabel abonnieren","intro":"Schalten Sie die Vollversion mit einem Monatsabonnement frei \u2014 ohne Wasserzeichen, bereit f\xfcr Thermo- und Produktionsdruck auf Zebra und anderen Etikettendruckern.","panelTitle":"Monatsabonnement","errorTitle":"Etwas ist schiefgelaufen","thanks":"Danke f\xfcr Ihr DinLabel-Abonnement. Sie haben jetzt vollen Zugriff auf die App!","thanksLifetime":"Danke \u2014 Sie haben bereits lebenslangen Zugriff auf DinLabel.","checkAccount":"Kontostatus pr\xfcfen","goToDownload":"Zur Download-Seite","manageBilling":"Abrechnung verwalten","price":"USD ${{price}}/Monat + Steuern","payWithCard":"Mit Karte abonnieren","payError":"Weiterleitung zu Stripe Checkout fehlgeschlagen.","adminTestMode":"Dies ist ein Admin-Benutzer, daher verwendet der Checkout Testmode-Informationen. Verwenden Sie die Kreditkarte \'4242 4242 4242 4242\'.","debugToggleBought":"Nur f\xfcr Admins: Debug: Bought umschalten","toggleBoughtError":"Bought-Status konnte nicht umgeschaltet werden.","orVia":"Andere Option bevorzugen?","downloadDemo":"Eine voll funktionsf\xe4hige Demo herunterladen"},"userInfo":{"title":"Mein Konto","detailsTitle":"Kontodaten","quickLinks":"Schnelllinks","userId":"Benutzer-ID","email":"E-Mail-Adresse","emailConfirmed":"E-Mail best\xe4tigt","confirmed":"Best\xe4tigt","notConfirmed":"Nicht best\xe4tigt","resend":"Erneut senden","resentEmail":"Best\xe4tigungs-E-Mail erneut an {{email}} gesendet","resendError":"Best\xe4tigungs-E-Mail konnte nicht erneut gesendet werden.","version":"Anwendungsversion","freeVersion":"Demo-Version","fullVersion":"Vollversion","lifetimeAccess":"Lebenslanger Zugriff","subscription":"Abonnement","subscriptionTitle":"Abonnement","subscriptionStatus":"Status","subscriptionRenews":"Verl\xe4ngert am","subscriptionEnds":"Zugriff bis","subscriptionCancelScheduled":"Endet zum Periodenende","subscriptionLoading":"Abonnement wird geladen\u2026","subscriptionError":"Abonnementstatus konnte nicht geladen werden.","manageBilling":"Abrechnung verwalten","statusActive":"Aktiv","statusTrialing":"Testphase","statusPastDue":"Zahlungsr\xfcckstand","statusCanceled":"Gek\xfcndigt","statusUnpaid":"Unbezahlt","statusIncomplete":"Unvollst\xe4ndig","statusIncompleteExpired":"Abgelaufen","statusPaused":"Pausiert","statusUnknown":"{{status}}","buyApp":"Abonnieren","accountType":"Konto","admin":"Admin-Portal","openDistributorPortal":"H\xe4ndlerportal \xf6ffnen","setPasswordTitle":"Passwort hinzuf\xfcgen","setPasswordIntro":"F\xfcgen Sie ein Passwort hinzu, um sich auch per E-Mail anzumelden. Konto und Lizenz bleiben gleich.","changePasswordTitle":"Passwort \xe4ndern","changePasswordIntro":"Aktualisieren Sie das Passwort f\xfcr die E-Mail-Anmeldung.","confirmEmailBeforePassword":"Best\xe4tigen Sie Ihre E-Mail, bevor Sie ein Passwort hinzuf\xfcgen.","currentPassword":"Aktuelles Passwort","newPassword":"Neues Passwort","passwordHint":"Mindestens 8 Zeichen","setPasswordExpand":"Passwort hinzuf\xfcgen","changePasswordExpand":"Passwort \xe4ndern","passwordFormCancel":"Abbrechen","setPasswordSubmit":"Passwort speichern","changePasswordSubmit":"Passwort aktualisieren","passwordSet":"Passwort gespeichert. Sie k\xf6nnen sich jetzt mit E-Mail und Passwort anmelden.","passwordChanged":"Passwort aktualisiert.","passwordError":"Passwort konnte nicht aktualisiert werden."},"myLabels":{"title":"Meine Etiketten","loading":"Wird geladen\u2026","loadError":"Etiketten konnten nicht geladen werden.","empty":"Sie haben keine gespeicherten Etiketten.","name":"Name","date":"Datum","view":"Anzeigen","download":"Herunterladen","back":"Zur\xfcck zu meinen Etiketten"},"admin":{"title":"Admin-Portal","dataLink":"DinLabel Client-Analytics-Dashboard","serverAnalyticsLink":"Server-Analytics-Dashboard","fakeEmailLink":"Fake-E-Mails","loading":"Wird geladen\u2026","loadError":"Admindaten konnten nicht geladen werden.","totalUsers":"Benutzer insgesamt: {{count}}","paidUsers":"Zahlende Benutzer: {{count}}","totalSubscribedUsers":"Abonnenten gesamt: {{count}}","users":"Benutzer","distributors":"H\xe4ndler","payments":"H\xe4ndlerzahlungen","demoDownloaders":"Demo-Downloads","authorize":"Autorisieren","toggleAdmin":"Admin umschalten"},"fakeEmail":{"title":"Fake-E-Mails","description":"Vorschau generierter E-Mail-Vorlagen mit Platzhalterdaten.","distributorSignUp":"H\xe4ndler-Anmeldung","activationLink":"Aktivierung / E-Mail best\xe4tigen","sendEmailLicense":"H\xe4ndler sendet Lizenz","congratulationEmail":"Gl\xfcckwunsch","boughtLicensesMail":"Gekaufte Lizenzen","demoDownloadThankYou":"Demo-Download Danke","subject":"Betreff","body":"Text","loading":"Wird geladen\u2026","loadError":"Diese E-Mail konnte nicht geladen werden.","backAdmin":"Zur\xfcck zur Administration","testAddress":"Testadresse","testAddressPlaceholder":"du@beispiel.com","sendTest":"Test senden","sendSuccess":"{{action}} an {{email}} gesendet","sendError":"Test-E-Mail konnte nicht gesendet werden."}}');


var $ba2d6df89db01e7e$exports = {};
$ba2d6df89db01e7e$exports = JSON.parse('{"nav":{"home":"Home","tutorials":"Tutorials","barcodes":"Barcodes","contact":"Contact us","logout":"Logout","logoAlt":"DinLabel","download":"Download","downloadDemo":"Download demo","buy":"Subscribe","login":"Login","myAccount":"My Account","language":"Language","distributorPortal":"Distributor portal"},"language":{"title":"Language","description":"Choose the language used in the app. By default, your browser language is used.","browser":"Use browser language","english":"English","spanish":"Spanish","german":"German","french":"French"},"offline":{"title":"Offline","message":"The application cannot connect to the server :( !!"},"dialogs":{"apiError":"API Error","confirmYes":"Yes","cancel":"Cancel","send":"Send"},"portal":{"pageTitle":"Distributor portal","actions":"Actions","authorized":"Authorized","pending":"Pending approval","buyLicenses":"Buy licenses","pendingApproval":"Your distributor application has not been approved yet - for any questions, you can contact {{email}}. This process should not take more than 2 business days.","distributorInfo":"Information for distributors","loading":"Loading distributor information\u2026","loadError":"Could not load distributor information."},"licenses":{"noneAvailable":"You currently have no licenses available to send.","statAvailable":"Available to send","statBought":"Purchased","statSent":"Sent","sentHistory":"Licenses sent","activatedYes":"Activated","buyTitle":"Distributor Portal - Buy licenses","buyLoading":"Loading\u2026","buyLoadError":"Could not load distributor information.","buyIntro":"Specify how many licenses you want to buy - the distributor price is {{price}} pesos. Distributors can sell DinLabel however they consider appropriate, but our recommended price is {{recommended}} pesos.","licenseCountLabel":"Number of licenses","costSummary":"The cost of {{count}} licenses is {{cost}} pesos + taxes.","buyButton":"Buy {{count}} licenses","sendTitle":"Send license","resendConfirm":"Do you want to resend the license to {{email}}?","sendPrompt":"Enter the email you want to send to","emailPlaceholder":"email@example.com","errorTitle":"Error!","sendError":"There was an error sending the license {{error}}","resentTitle":"License resent!","resentMessage":"The license has been resent to {{email}} with a copy to {{cc}}","sentTitle":"License sent!","sentMessage":"The license has been sent to {{email}} with a copy to {{cc}}","sendToEmail":"Send license to email...","recipient":"License recipient","date":"Date","sent":"Sent","activated":"Activated","notActivated":"Not yet activated","resend":"Resend license"},"register":{"title":"Become a distributor","intro":"To access the DinLabel distributor portal, you must first register:","company":"Company","companyPlaceholder":"Company name","phone":"Phone","phonePlaceholder":"Phone","phoneDescription":"Make sure to include your country code, for example +52 8183...","street":"Street","street1Placeholder":"Street 1","street2Placeholder":"Street 2","number":"Number","city":"City","state":"State","country":"Country","zip":"ZIP code","rfc":"Tax ID (RFC)","nextSteps":"You will receive an email with the next steps","submit":"Submit"},"faq":{"qGoogleAccount":"Do I need a Google account to be a DINLabel distributor?","aGoogleAccount":"Yes, you need a Google account. If you already have one, you can use it to sign in to the distributor portal.","qRequirements":"What do I need to become a DINLabel distributor?","aRequirementsBefore":"Register as a distributor in the","aRequirementsLink":"distributor portal","aRequirementsAfter":"and wait to receive the confirmation email authorizing you as a DINLabel distributor.","qAnyoneCanSell":"Can any person or company sell DINLabel?","aAnyoneCanSell":"Yes, you only need to register in the DINLabel distributor portal and receive the confirmation email.","qHowManyDistributors":"How many distributors can there be in DINLabel?","aHowManyDistributors":"There is no limit.","qDistributorCost":"How much does a DINLabel license cost a distributor?","aDistributorCost":"112 USD plus taxes per license.","qRecommendedPrice":"What is the recommended retail price from the distributor to their customers for a DINLabel license?","aRecommendedPrice":"The distributor sets the price; there is no fixed price. We suggest a selling price of 160 USD plus taxes. Direct customers on the DinLabel portal subscribe for 15 USD per month plus taxes.","qWhereToBuy":"Where can an end user get DinLabel?","aWhereToBuyBefore":"New customers subscribe monthly on the Subscribe page, or get a license from a distributor. Existing one-time purchasers keep lifetime access. Subscribe on the portal","qHowBuyAsDistributor":"As a distributor, how do I buy DINLabel licenses?","aHowBuyAsDistributorBefore":"Through the Distributor Portal, by going to the Buy Licenses section. See the tutorial","aHowBuyAsDistributorLink":"how to buy licenses.","qMinimumLicenses":"As a distributor, when buying licenses to later sell to my customers, what is the minimum number of licenses I must buy?","aMinimumLicenses":"There is no minimum; you can buy from 1 license.","qHowDeliver":"As a distributor, how do I deliver a DINLabel license to my customer?","aHowDeliverBefore":"Through the distributor portal, in the","aHowDeliverSendLink":"send licenses","aHowDeliverMiddle":" section; see the","aHowDeliverTutorialLink":"tutorial on how to send licenses.","qHowLongPurchase":"How long does it take to buy a license as a distributor and deliver it to the customer?","aHowLongPurchase":"If you are already registered as a distributor, the purchase and license delivery can be done in minutes.","qHowLongToSell":"As a distributor, how long do I have to sell the licenses I purchase in the portal?","aHowLongToSell":"Distributor licenses do not expire. When you buy licenses they are added to your license inventory and you can use them at any time.","qHowManyAvailable":"How can I tell how many licenses I have as a distributor?","aHowManyAvailableBefore":"When you enter the DINLabel","aHowManyAvailableLink":"distributor portal","aHowManyAvailableAfter":", the first screen shows your balance of licenses available to send.","qSoldLicenses":"How can I tell which licenses I have sold and to whom?","aSoldLicensesBefore":"Through the DINLabel distributor portal in the","aSoldLicensesLink":"view details","qTryBefore":"Can I try DINLabel before becoming a distributor?","aTryBeforeBefore":"Yes, you can download a Demo at","aTryBeforeAfter":"and try it.","qMainFaq":"Are there FAQs (frequently asked questions) on the DINLabel portal?","aMainFaqBefore":"At","aMainFaqAfter":"you will find the most frequent questions about using the DINLabel system.","qTutorials":"Are there tutorials for using DINLabel?","aTutorialsBefore":"At","aTutorialsAfter":"you will find all the tutorials needed to use DINLabel.","qSupport":"As a distributor, do I have technical support?","aSupport":"By email; see the end of this FAQ.","qOtherQuestion":"I have a question that is not on the list. What can I do?","aOtherQuestionBefore":"We would love to help. Go to","aOtherQuestionLink":"contact us","aOtherQuestionAfter":", send your questions, and we will gladly respond."},"tutorials":{"title":"Tutorials","alsoSeeFaqBefore":"You can also see the","alsoSeeFaqLink":"FAQ","sendLicenseTutorial":"Tutorial: How to send a license from the distributor portal","iframeTitle":"Send license tutorial"},"home":{"welcome":"Welcome, {{email}}","error":"Error"},"userLicenses":{"hasLicense":"You already have full access to DinLabel.","hasSubscription":"Your DinLabel subscription is active.","manageBilling":"Manage billing","noLicense":"You do not have an active DinLabel subscription","buyHere":"Subscribe here"},"signin":{"title":"Sign in","intro":"Sign in with Google or your email and password to continue.","withGoogle":"Sign in with Google","orEmail":"or","email":"Email","password":"Password","withEmail":"Sign in with email","createAccount":"Create an account","forgotPassword":"Forgot password?","emailPasswordError":"Could not sign in. Check your email and password.","agreePrefix":"By continuing you agree to our","privacyLink":"Privacy Policy and Terms of Service","alreadySignedIn":"You are already signed in","signedInAs":"Signed in as {{email}}","continue":"Continue","debugSignInUrl":"Sign-in URL"},"registerAccount":{"title":"Create an account","intro":"Register with your email and a password.","email":"Email","password":"Password","passwordHint":"At least 8 characters","submit":"Create account","haveAccount":"Already have an account?","signIn":"Sign in","error":"Could not create the account.","googleExists":"This email is already registered with Google. Sign in with Google, then add a password in My Account if you want."},"forgotPassword":{"title":"Forgot password","intro":"Enter your email and we will send a reset link if an account exists.","email":"Email","submit":"Send reset link","sent":"If an account exists for that email, a reset link has been sent.","backToSignIn":"Back to sign in","error":"Could not send the reset email."},"resetPassword":{"title":"Reset password","password":"New password","passwordHint":"At least 8 characters","submit":"Update password","success":"Your password has been updated.","signIn":"Sign in","backToSignIn":"Back to sign in","invalidLink":"This reset link is invalid or incomplete.","error":"Could not reset the password."},"applogin":{"title":"Continue in DinLabel","intro":"Continue to finish signing in to the desktop app.","signedInAs":"You\'re signed in as {{email}}.","continue":"Continue","switchAccount":"Use a different account","redirecting":"Redirecting to sign in\u2026","invalidTitle":"Invalid app login link","invalidBody":"This page is opened by the DinLabel desktop app. Please start sign-in from the application."},"marketing":{"headline":"Professional software for label management and printing","slogan":"Easily set up and print on thermal (Zebra and more), laser, and inkjet printers. Add text, barcodes, variable data, and sequential numbering on fabric, cardstock, or adhesive labels.","featureNumbers":"Sequential numbering & counters","featureImages":"Sharp logos & images","featureVariable":"Variable data, no hassle","featureQr":"Interactive QR codes","featureText":"Clear, readable text","featureBarcode":"Professional barcodes","featureDemo":{"productName":"Product name","oliveOil":"Olive Oil","oliveOilDesc":"Description of the olive oil","fontsNote":"Clear, fine, readable fonts","sequence":"Sequence {{n}}","client":"CLIENT:","name":"Name","city":"CITY:","companyLogo":"Company Logo"},"featuresTitle":"Everything you need on a label","featuresSubtitle":"Build professional labels with the tools print shops and warehouses rely on every day.","seeBarcodeTypes":"See supported barcode types","printersTitle":"Compatible with any printer","printersSubtitle":"DinLabel connects directly to the printers you already use in your business through standard Windows drivers.","printersTypesTitle":"Printer types and media:","printersThermalLabel":"Thermal and Thermal Transfer:","printersThermalBody":"Ideal for adhesive roll labels, Tyvek, nylon, cardboard, and more.","printersLaserLabel":"Laser and Inkjet:","printersLaserBody":"Ideal for adhesive sheet layouts, cardboard, or fabric.","whyTitle":"Why DinLabel?","whyCompatLabel":"Full compatibility:","whyCompatBody":"Print on any printer (thermal, laser, and inkjet) on rolls or sheets.","whyCostLabel":"No inflated costs:","whyCostBody":"All professional features without paying for expensive enterprise licenses.","whySupportLabel":"Real technical support:","whySupportBody":"We help you step by step from download and install through printing your first labels.","tryTitle":"Try DinLabel free today","trySubtitle":"Download the free demo, connect the printer you have (thermal, laser, or inkjet), and see how it prints your labels in minutes.","needHelp":"Need help?","customerService":"Customer service","customerServiceText":"Contact us by email and we will gladly help.","tutorialsText":"Step-by-step video tutorials for every feature."},"barcodes":{"title":"Barcode types in DinLabel","intro":"DinLabel prints the barcode types used most often on retail, shipping, and industrial labels. The types below appear first when you add a barcode. Choose Show more in the editor to use any of the additional types we support.","commonTitle":"Most common barcode types","commonIntro":"These are the types we recommend for most labels. DinLabel supports all of them out of the box.","fullTitle":"All supported barcode types","fullIntro":"The barcode editor lists these names when you choose Show more. Use the same name in DinLabel that you see here.","fullCount":"DinLabel supports {{count}} barcode types.","ctaInstall":"Download DinLabel","ctaTutorials":"Watch barcode tutorials","common":{"UpcA":{"name":"UPC-A","description":"The 12-digit barcode on most products sold in North America."},"UpcE":{"name":"UPC-E","description":"A compact 6-digit UPC for small packages that cannot fit UPC-A."},"Ean13":{"name":"EAN-13","description":"The 13-digit retail barcode used worldwide, including Europe and Latin America."},"Ean8":{"name":"EAN-8","description":"A shorter EAN for small products that cannot fit EAN-13."},"Code128":{"name":"Code 128","description":"A high-density linear barcode for letters, numbers, and symbols. Common in shipping and inventory."},"GS1128":{"name":"GS1-128","description":"Code 128 with GS1 application identifiers for logistics, GTIN, lot, and date data."},"Code39":{"name":"Code 39","description":"A widely used industrial barcode that encodes letters, numbers, and a few symbols."},"Interleaved2of5":{"name":"Interleaved 2 of 5","description":"A compact numeric barcode used in warehousing, distribution, and industrial labeling."},"Itf14":{"name":"ITF-14","description":"A 14-digit barcode for shipping cartons and outer cases (GTIN-14)."},"QRCode":{"name":"QR Code","description":"A 2D code that stores URLs, text, and more. Easy to scan with a phone."},"DataMatrix":{"name":"Data Matrix","description":"A compact 2D code used in electronics, healthcare, and small parts marking."},"Pdf417":{"name":"PDF417","description":"A stacked 2D barcode that holds more data than typical 1D codes, used on IDs, shipping, and tickets."}}},"footer":{"tagline":"Professional label design for thermal printers \u2014 Zebra and more.","privacy":"Privacy & terms","copyright":"\xa9 {{year}} DinLabel"},"install":{"title":"Download","intro":"Install DinLabel on Windows and start designing labels for thermal printers \u2014 including Zebra and other Windows label printers \u2014 in minutes.","windowsNote":"Windows installer (.exe). Works on Windows 7 and newer.","requirements":"System requirements","reqWindows":"Any Windows version after (Windows 7 and newer)","reqInternet":"Internet access","reqDisk":"50 MB Hard disk storage","freeTag":"Demo version","freeText":"The demo version includes a watermark on printed labels.","paidTitle":"Full version","paidText":"No watermarks \u2014 ready for production printing.","buyApp":"Subscribe to DinLabel","orDistributor":"Prefer to subscribe through a partner?","distributorsLink":"View distributors","emailModalTitle":"Download the demo","emailModalIntro":"Enter your email to download the DinLabel demo.","emailLabel":"Email","emailSubmit":"Download","emailInvalid":"Please enter a valid email address.","emailSubmitError":"Something went wrong. Please try again.","purchasedIntro":"Download and install DinLabel to start using your full version.","signInTitle":"How to sign in","signInStep1":"Download and install DinLabel using the button above.","signInStep2":"Open DinLabel.","signInStep3":"Choose Sign in / register from the menu.","signInStep4":"Sign in with the same account you used to subscribe. Once signed in, you\'ll be using the full version of DinLabel.","signInStep4UnpurchasedBefore":"Sign in with an account. You\'ll be using the demo version until you","signInStep4UnpurchasedLink":"subscribe","signInStep4UnpurchasedAfter":"."},"fullTutorials":{"title":"Tutorials","intro":"Step-by-step videos to help you design, print, and get the most out of DinLabel.","howToRoll":"How to create a label on a roll","howToSheet":"How to create a label on a sheet","howTo3Across":"How to create 3-across labels","howToText":"How to add text","howToShapes":"How to add shapes","howToImages":"How to add images","howToBarCodes":"How to add barcodes","howToQR":"How to add QR codes","howToPrint":"How to print","howToConsecutive":"How to use consecutive numbers","howToDataBase":"How to use databases","howToBuy":"How to subscribe to DinLabel","alsoDistributor":"Distributor-specific tutorials are available in the distributor portal.","distributorLink":"Open distributor portal"},"privacy":{"title":"Privacy Policy and Terms of Service","eulaLink":"End User License Agreement","policyLink":"Privacy Policy","note":"The privacy policy opens the localized static HTML document.","loading":"Loading\u2026","eulaLoadError":"Could not load the EULA."},"distributors":{"title":"Distributors"},"buyPage":{"title":"Subscribe to DinLabel","intro":"Unlock the full version with a monthly subscription \u2014 no watermarks, ready for thermal and production printing on Zebra and other label printers.","panelTitle":"Monthly subscription","errorTitle":"Something went wrong","thanks":"Thank you for subscribing to DinLabel. You now have full access to the app!","thanksLifetime":"Thank you \u2014 you already have lifetime access to DinLabel.","checkAccount":"Check the status of your account","goToDownload":"Go to the download page","manageBilling":"Manage billing","price":"USD ${{price}}/month + Tax","payWithCard":"Subscribe with card","payError":"Could not redirect to Stripe checkout.","adminTestMode":"This is an admin user, so the checkout flow will be using testmode information. Use credit card \'4242 4242 4242 4242\'.","debugToggleBought":"For admins only: Debug: Toggle Bought (cancels Stripe subscription if any)","toggleBoughtError":"Could not toggle bought state.","orVia":"Prefer another option?","downloadDemo":"Download a fully working demo"},"userInfo":{"title":"My Account","detailsTitle":"Account details","quickLinks":"Quick links","userId":"User ID","email":"Email address","emailConfirmed":"Email confirmed","confirmed":"Confirmed","notConfirmed":"Not confirmed","resend":"Resend","resentEmail":"Confirmation email resent to {{email}}","resendError":"Could not resend confirmation email.","version":"Application version","freeVersion":"Demo version","fullVersion":"Full version","lifetimeAccess":"Lifetime access","subscription":"Subscription","subscriptionTitle":"Subscription","subscriptionStatus":"Status","subscriptionRenews":"Renews on","subscriptionEnds":"Access until","subscriptionCancelScheduled":"Cancels at period end","subscriptionLoading":"Loading subscription\u2026","subscriptionError":"Could not load subscription status.","manageBilling":"Manage billing","statusActive":"Active","statusTrialing":"Trial","statusPastDue":"Past due","statusCanceled":"Canceled","statusUnpaid":"Unpaid","statusIncomplete":"Incomplete","statusIncompleteExpired":"Expired","statusPaused":"Paused","statusUnknown":"{{status}}","buyApp":"Subscribe","accountType":"Account","admin":"Admin portal","openDistributorPortal":"Open distributor portal","setPasswordTitle":"Add a password","setPasswordIntro":"Add a password to sign in with email as well as Google. Your account and license stay the same.","changePasswordTitle":"Change password","changePasswordIntro":"Update the password used for email sign-in.","confirmEmailBeforePassword":"Confirm your email before adding a password.","currentPassword":"Current password","newPassword":"New password","passwordHint":"At least 8 characters","setPasswordExpand":"Add a password","changePasswordExpand":"Change password","passwordFormCancel":"Cancel","setPasswordSubmit":"Save password","changePasswordSubmit":"Update password","passwordSet":"Password saved. You can now sign in with email and password.","passwordChanged":"Password updated.","passwordError":"Could not update the password."},"myLabels":{"title":"My Labels","loading":"Loading\u2026","loadError":"Could not load labels.","empty":"You have no saved labels.","name":"Name","date":"Date","view":"View","download":"Download","back":"Back to my labels"},"admin":{"title":"Admin Portal","dataLink":"DinLabel client analytics dashboard","serverAnalyticsLink":"Server analytics dashboard","fakeEmailLink":"Fake emails","loading":"Loading\u2026","loadError":"Could not load admin data.","totalUsers":"Total users: {{count}}","paidUsers":"Paid users: {{count}}","totalSubscribedUsers":"Total subscribed users: {{count}}","users":"Users","distributors":"Distributors","payments":"Distributor payments","demoDownloaders":"Demo downloaders","authorize":"Authorize","toggleAdmin":"Toggle Admin"},"fakeEmail":{"title":"Fake emails","description":"Preview generated email templates with placeholder data.","distributorSignUp":"Distributor sign-up","activationLink":"Activation / confirm email","sendEmailLicense":"Distributor send license","congratulationEmail":"Congratulations","boughtLicensesMail":"Bought licenses","demoDownloadThankYou":"Demo download thank-you","subject":"Subject","body":"Body","loading":"Loading\u2026","loadError":"Could not load this email.","backAdmin":"Back to admin","testAddress":"Test address","testAddressPlaceholder":"you@example.com","sendTest":"Send test","sendSuccess":"Sent {{action}} to {{email}}","sendError":"Failed to send test email."}}');


var $e688fdd8fc0ba8bd$exports = {};
$e688fdd8fc0ba8bd$exports = JSON.parse('{"nav":{"home":"Inicio","tutorials":"Tutoriales","barcodes":"C\xf3digos de barras","contact":"Contactanos","logout":"Logout","logoAlt":"DinLabel","download":"Descargar","downloadDemo":"Descargar demo","buy":"Suscribirse","login":"Iniciar sesi\xf3n","myAccount":"Mi cuenta","language":"Idioma","distributorPortal":"Portal de distribuidores"},"language":{"title":"Idioma","description":"Elige el idioma de la aplicaci\xf3n. Por defecto se usa el idioma del navegador.","browser":"Usar idioma del navegador","english":"Ingl\xe9s","spanish":"Espa\xf1ol","german":"Alem\xe1n","french":"Franc\xe9s"},"offline":{"title":"Sin conexi\xf3n","message":"La aplicaci\xf3n no se puede conectar con el servidor :( !!"},"dialogs":{"apiError":"Error de Api","confirmYes":"S\xed","cancel":"Cancelar","send":"Enviar"},"portal":{"pageTitle":"Portal de distribuidores","actions":"Acciones","authorized":"Autorizado","pending":"Pendiente de aprobaci\xf3n","buyLicenses":"Comprar licencias","pendingApproval":"Su solicitud de distribuidor todavia no ha sido aprobada - para cualquier pregunta, puede contactar a {{email}}. Este proceso no debe tardar m\xe1s de 2 dias habiles.","distributorInfo":"Informaci\xf3n para distribuidores","loading":"Cargando informaci\xf3n de distribuidor\u2026","loadError":"No se pudo cargar la informaci\xf3n de distribuidor."},"licenses":{"noneAvailable":"Actualmente, usted no tiene licencias disponibles para enviar.","statAvailable":"Disponibles para enviar","statBought":"Compradas","statSent":"Enviadas","sentHistory":"Licencias enviadas","activatedYes":"Activada","buyTitle":"Portal de Distribuidores - Comprar licencias","buyLoading":"Cargando\u2026","buyLoadError":"No se pudo cargar la informaci\xf3n de distribuidor.","buyIntro":"Especifique cuantas licencias desea comprar - el precio de venta a distribuidores es de {{price}} pesos. Los distribuidores pueden vender DinLabel de la manera que consideren apropiada, pero nuestro precio recomendado es de {{recommended}} pesos.","licenseCountLabel":"N\xfamero de licencias","costSummary":"El costo de {{count}} licencias es de {{cost}} pesos + impuestos.","buyButton":"Comprar {{count}} licencias","sendTitle":"Enviar licencia","resendConfirm":"Deseas reenviar la licencia a {{email}}?","sendPrompt":"Ingresa el correo al que deseas enviar","emailPlaceholder":"correo@ejemplo.com","errorTitle":"Error!","sendError":"Hubo un error al enviar la licencia {{error}}","resentTitle":"Licencia reenviada!","resentMessage":"La licencia ha sido reenviada a {{email}} con copia a {{cc}}","sentTitle":"Licencia enviada!","sentMessage":"La licencia ha sido enviada a {{email}} con copia a {{cc}}","sendToEmail":"Enviar licencia a correo...","recipient":"Recipiente de licencia","date":"Fecha","sent":"Enviada","activated":"Activada","notActivated":"A\xfan no activada","resend":"Reenviar licencia"},"register":{"title":"Convi\xe9rtete en distribuidor","intro":"Para acceder al portal de distribuidores DinLabel, debe primero registrarse:","company":"Empresa","companyPlaceholder":"Nombre de empresa","phone":"Tel\xe9fono","phonePlaceholder":"Telefono","phoneDescription":"Asegurese de incluir el c\xf3digo de su pais, por ejemplo +52 8183...","street":"Calle","street1Placeholder":"Calle1","street2Placeholder":"Calle2","number":"N\xfamero","city":"Ciudad","state":"Estado","country":"Pa\xeds","zip":"C\xf3digo postal","rfc":"RFC","nextSteps":"Recibira un correo con los suguientes pasos","submit":"Submit"},"faq":{"qGoogleAccount":"\xbfNecesito una cuenta de Google para ser distribuidor de DINLabel?","aGoogleAccount":"Si es necesario que tengas una cuenta de Google, si ya cuentas con una la puedes usar para ingresar al portal de distribuidores.","qRequirements":"\xbfQu\xe9 necesito para ser distribuidor de DINLabel?","aRequirementsBefore":"Registrarte como distribuidor en el","aRequirementsLink":"portal de distribuidores","aRequirementsAfter":"y esperar a recibir el correo de confirmaci\xf3n autoriz\xe1ndote como distribuidor de DINLabel.","qAnyoneCanSell":"\xbfCualquier persona o empresa puede vender DINLabel?","aAnyoneCanSell":"Si, solo debe registrarse en el portal de distribuidores de DINLabel y recibir el correo de confirmaci\xf3n.","qHowManyDistributors":"\xbfCu\xe1ntos distribuidores puede haber en DINLabel?","aHowManyDistributors":"No hay l\xedmite.","qDistributorCost":"\xbfCu\xe1nto le cuesta a un distribuidor una licencia de DINLabel?","aDistributorCost":"112 dlls mas impuestos por cada licencia.","qRecommendedPrice":"\xbfCu\xe1l es el precio recomendado de venta del distribuidor a sus clientes por una licencia de DINLabel?","aRecommendedPrice":"El precio lo define el distribuidor, no hay un precio establecido, sugerimos un precio de venta de 160 dlls mas impuestos. Los clientes directos en el portal de DinLabel se suscriben por 15 USD al mes m\xe1s impuestos.","qWhereToBuy":"\xbfD\xf3nde puede obtener DinLabel un usuario final?","aWhereToBuyBefore":"Los clientes nuevos se suscriben mensualmente en la p\xe1gina de suscripci\xf3n, o reciben una licencia de un distribuidor. Quienes ya compraron una vez conservan acceso de por vida. Suscr\xedbete en el portal","qHowBuyAsDistributor":"\xbfComo distribuidor, como compro licencias de DINLabel?","aHowBuyAsDistributorBefore":"A trav\xe9s del Portal de distribuidores, accediendo a la secci\xf3n Comprar Licencias, consulta el tutorial","aHowBuyAsDistributorLink":"como comprar licencias.","qMinimumLicenses":"Como distribuidor, al comprar licencias para luego venderlas a mis clientes \xbfCu\xe1l es el m\xednimo de licencias que debo comprar?","aMinimumLicenses":"No hay un m\xednimo, se puede comprar desde 1 licencia.","qHowDeliver":"Como Distribuidor, \xbfcomo le entrego a mi cliente una licencia de DINLabel?","aHowDeliverBefore":"A trav\xe9s del portal de distribuidores, en la secci\xf3n de","aHowDeliverSendLink":"enviar licencias","aHowDeliverMiddle":", consulte el","aHowDeliverTutorialLink":"tutorial de como enviar licencias.","qHowLongPurchase":"\xbfCu\xe1nto tiempo toma comprar una licencia como distribuidor y entregarla al cliente?","aHowLongPurchase":"Si ya est\xe1s registrado como distribuidor en cuesti\xf3n de minutos se puede hacer la compra y el env\xedo de la licencia.","qHowLongToSell":"Como distribuidor, \xbfCu\xe1nto tiempo tengo para vender las licencias que adquiera en el portal?","aHowLongToSell":"Las licencias del distribuidor no caducan, al comprar licencias se agregan al inventario de licencias del distribuidor y se puede disponer de ellas en cualquier momento.","qHowManyAvailable":"\xbfC\xf3mo puedo saber cuantas licencias tengo como distribuidor?","aHowManyAvailableBefore":"Al ingresar al","aHowManyAvailableLink":"portal de distribuidores","aHowManyAvailableAfter":"de DINLabel, en la primera pantalla te mostrar\xe1 tu saldo de licencias disponibles para enviar.","qSoldLicenses":"\xbfC\xf3mo puedo saber qu\xe9 licencias he vendido y a quien se las he vendido?","aSoldLicensesBefore":"A trav\xe9s del portal de distribuidores de DINLabel en la secci\xf3n","aSoldLicensesLink":"ver detalles","qTryBefore":"\xbfPuedo probar DINLabel antes de hacerme distribuidor?","aTryBeforeBefore":"Si, puedes descargar una Demo en","aTryBeforeAfter":"y probarla.","qMainFaq":"\xbfHay FAQ\u2019s (preguntas frecuentes) para consultar en el portal DINLabel?","aMainFaqBefore":"En","aMainFaqAfter":"encontrar\xe1s las pregutas mas frequentes sobre el uso del sistema DINLabel.","qTutorials":"\xbfHay tutoriales para el uso del DINLabel?","aTutorialsBefore":"En","aTutorialsAfter":"encontrar\xe1s todos los tutoriales necesarios para el uso del DINLabel.","qSupport":"\xbfComo distribuidor, tengo soporte t\xe9cnico?","aSupport":"Por correo electr\xf3nico, ver el final de estas FAQ.","qOtherQuestion":"Tengo una duda y no se encuentra en la lista. \xbfQu\xe9 puedo hacer?","aOtherQuestionBefore":"Nos encantar\xeda ayudarte. Ir a","aOtherQuestionLink":"cont\xe1ctanos","aOtherQuestionAfter":", env\xeda tus dudas y con gusto te respondemos."},"tutorials":{"title":"Tutoriales","alsoSeeFaqBefore":"Tambien puede ver la p\xe1gina de","alsoSeeFaqLink":"FAQ","sendLicenseTutorial":"Tutorial: Como enviar una licencia desde el portal de distribuidores","iframeTitle":"Tutorial enviar licencia"},"home":{"welcome":"Bienvenid@, {{email}}","error":"Error"},"userLicenses":{"hasLicense":"Ya tienes acceso completo a DinLabel.","hasSubscription":"Tu suscripci\xf3n de DinLabel est\xe1 activa.","manageBilling":"Administrar facturaci\xf3n","noLicense":"No tienes una suscripci\xf3n activa de DinLabel","buyHere":"Suscr\xedbete aqu\xed"},"signin":{"title":"Iniciar sesi\xf3n","intro":"Inicia sesi\xf3n con Google o con tu correo y contrase\xf1a para continuar.","withGoogle":"Iniciar sesi\xf3n con Google","orEmail":"o","email":"Correo electr\xf3nico","password":"Contrase\xf1a","withEmail":"Iniciar sesi\xf3n con correo","createAccount":"Crear una cuenta","forgotPassword":"\xbfOlvidaste tu contrase\xf1a?","emailPasswordError":"No se pudo iniciar sesi\xf3n. Revisa tu correo y contrase\xf1a.","agreePrefix":"Al continuar aceptas nuestra","privacyLink":"Pol\xedtica de privacidad y t\xe9rminos de servicio","alreadySignedIn":"Ya has iniciado sesi\xf3n","signedInAs":"Sesi\xf3n iniciada como {{email}}","continue":"Continuar","debugSignInUrl":"URL de inicio de sesi\xf3n"},"registerAccount":{"title":"Crear una cuenta","intro":"Reg\xedstrate con tu correo y una contrase\xf1a.","email":"Correo electr\xf3nico","password":"Contrase\xf1a","passwordHint":"Al menos 8 caracteres","submit":"Crear cuenta","haveAccount":"\xbfYa tienes una cuenta?","signIn":"Iniciar sesi\xf3n","error":"No se pudo crear la cuenta.","googleExists":"Este correo ya est\xe1 registrado con Google. Inicia sesi\xf3n con Google y luego agrega una contrase\xf1a en Mi cuenta si quieres."},"forgotPassword":{"title":"Olvid\xe9 mi contrase\xf1a","intro":"Escribe tu correo y te enviaremos un enlace de restablecimiento si existe una cuenta.","email":"Correo electr\xf3nico","submit":"Enviar enlace","sent":"Si existe una cuenta con ese correo, se ha enviado un enlace de restablecimiento.","backToSignIn":"Volver a iniciar sesi\xf3n","error":"No se pudo enviar el correo de restablecimiento."},"resetPassword":{"title":"Restablecer contrase\xf1a","password":"Nueva contrase\xf1a","passwordHint":"Al menos 8 caracteres","submit":"Actualizar contrase\xf1a","success":"Tu contrase\xf1a ha sido actualizada.","signIn":"Iniciar sesi\xf3n","backToSignIn":"Volver a iniciar sesi\xf3n","invalidLink":"Este enlace de restablecimiento no es v\xe1lido o est\xe1 incompleto.","error":"No se pudo restablecer la contrase\xf1a."},"applogin":{"title":"Continuar en DinLabel","intro":"Contin\xfaa para terminar de iniciar sesi\xf3n en la aplicaci\xf3n de escritorio.","signedInAs":"Has iniciado sesi\xf3n como {{email}}.","continue":"Continuar","switchAccount":"Usar otra cuenta","redirecting":"Redirigiendo al inicio de sesi\xf3n\u2026","invalidTitle":"Enlace de inicio de sesi\xf3n no v\xe1lido","invalidBody":"Esta p\xe1gina la abre la aplicaci\xf3n de escritorio DinLabel. Inicia sesi\xf3n desde la aplicaci\xf3n."},"marketing":{"headline":"Software profesional para la gesti\xf3n e impresi\xf3n de etiquetas","slogan":"Configura e imprime f\xe1cilmente en impresoras t\xe9rmicas (Zebra y m\xe1s), l\xe1ser e inyecci\xf3n. Agrega textos, c\xf3digos de barras, datos variables y numeraci\xf3n consecutiva en etiquetas de tela, cartulina o adhesivas.","featureNumbers":"Numeraci\xf3n consecutiva y contadores","featureImages":"Logos e im\xe1genes n\xedtidas","featureVariable":"Datos variables sin complicaciones","featureQr":"C\xf3digos QR interactivos","featureText":"Texto claro y legible","featureBarcode":"C\xf3digos de barras profesionales","featureDemo":{"productName":"Nombre del producto","oliveOil":"Aceite de Oliva","oliveOilDesc":"Descripci\xf3n del aceite de oliva","fontsNote":"Fuentes claras y finas legibles","sequence":"Secuencia {{n}}","client":"CLIENTE:","name":"Nombre","city":"CIUDAD:","companyLogo":"Logo de empresa"},"featuresTitle":"Todo lo que necesitas en una etiqueta","featuresSubtitle":"Crea etiquetas profesionales con las herramientas que usan imprentas y almacenes cada d\xeda.","seeBarcodeTypes":"Ver tipos de c\xf3digo de barras compatibles","printersTitle":"Compatible con cualquier impresora","printersSubtitle":"DinLabel se conecta directamente a las impresoras que ya usas en tu negocio mediante los controladores est\xe1ndar de Windows.","printersTypesTitle":"Tipos de impresoras y soportes:","printersThermalLabel":"T\xe9rmicas y Transferencia T\xe9rmica:","printersThermalBody":"Ideales para etiquetas en rollo adhesivas, tyvek, nylon, cart\xf3n etc.","printersLaserLabel":"L\xe1ser e Inyecci\xf3n de Tinta (Inkjet):","printersLaserBody":"Ideales para planillas de hojas adhesivas, de cart\xf3n o tela.","whyTitle":"\xbfPor qu\xe9 DinLabel?","whyCompatLabel":"Compatibilidad total:","whyCompatBody":"Imprime en cualquier impresora (t\xe9rmica, l\xe1ser e inkjet) en rollos o planillas.","whyCostLabel":"Sin costos inflados:","whyCostBody":"Todas las funciones profesionales sin pagar licencias empresariales car\xedsimas.","whySupportLabel":"Soporte t\xe9cnico real:","whySupportBody":"Te ayudamos paso a paso desde que lo descargas, lo instalas y empiezas a imprimir tus etiquetas.","tryTitle":"Prueba DinLabel gratis hoy mismo","trySubtitle":"Descarga la versi\xf3n demo gratuita, conecta la impresora que tengas (t\xe9rmica, l\xe1ser e inkjet) y comprueba c\xf3mo imprime tus etiquetas en minutos.","needHelp":"\xbfNecesitas ayuda?","customerService":"Servicio al cliente","customerServiceText":"Cont\xe1ctanos por correo y con gusto te ayudamos.","tutorialsText":"Tutoriales en video paso a paso para cada funci\xf3n."},"barcodes":{"title":"Tipos de c\xf3digo de barras en DinLabel","intro":"DinLabel imprime los tipos de c\xf3digo de barras m\xe1s usados en etiquetas de retail, env\xedo e industria. Los tipos de abajo aparecen primero al agregar un c\xf3digo de barras. Elige Mostrar m\xe1s en el editor para usar cualquiera de los tipos adicionales que soportamos.","commonTitle":"Tipos de c\xf3digo de barras m\xe1s comunes","commonIntro":"Estos son los tipos que recomendamos para la mayor\xeda de las etiquetas. DinLabel los incluye desde el inicio.","fullTitle":"Todos los tipos de c\xf3digo de barras compatibles","fullIntro":"El editor de c\xf3digos de barras muestra estos nombres cuando eliges Mostrar m\xe1s. Usa en DinLabel el mismo nombre que ves aqu\xed.","fullCount":"DinLabel admite {{count}} tipos de c\xf3digo de barras.","ctaInstall":"Descargar DinLabel","ctaTutorials":"Ver tutoriales de c\xf3digos de barras","common":{"UpcA":{"name":"UPC-A","description":"El c\xf3digo de 12 d\xedgitos en la mayor\xeda de los productos que se venden en Norteam\xe9rica."},"UpcE":{"name":"UPC-E","description":"Un UPC compacto de 6 d\xedgitos para empaques peque\xf1os que no caben UPC-A."},"Ean13":{"name":"EAN-13","description":"El c\xf3digo de barras de 13 d\xedgitos usado en todo el mundo, incluso en Europa y Am\xe9rica Latina."},"Ean8":{"name":"EAN-8","description":"Un EAN m\xe1s corto para productos peque\xf1os que no caben EAN-13."},"Code128":{"name":"Code 128","description":"Un c\xf3digo lineal de alta densidad para letras, n\xfameros y s\xedmbolos. Com\xfan en env\xedos e inventario."},"GS1128":{"name":"GS1-128","description":"Code 128 con identificadores de aplicaci\xf3n GS1 para log\xedstica, GTIN, lote y fechas."},"Code39":{"name":"Code 39","description":"Un c\xf3digo industrial muy usado que codifica letras, n\xfameros y algunos s\xedmbolos."},"Interleaved2of5":{"name":"Interleaved 2 de 5","description":"Un c\xf3digo num\xe9rico compacto usado en almacenes, distribuci\xf3n y etiquetas industriales."},"Itf14":{"name":"ITF-14","description":"Un c\xf3digo de 14 d\xedgitos para cajas de env\xedo y empaques exteriores (GTIN-14)."},"QRCode":{"name":"C\xf3digo QR","description":"Un c\xf3digo 2D que guarda URL, texto y m\xe1s. F\xe1cil de escanear con el tel\xe9fono."},"DataMatrix":{"name":"Data Matrix","description":"Un c\xf3digo 2D compacto usado en electr\xf3nica, salud y marcado de piezas peque\xf1as."},"Pdf417":{"name":"PDF417","description":"Un c\xf3digo 2D apilado que guarda m\xe1s datos que un c\xf3digo 1D t\xedpico, usado en identificaciones, env\xedos y boletos."}}},"footer":{"tagline":"Dise\xf1o profesional de etiquetas para impresoras t\xe9rmicas \u2014 Zebra y m\xe1s.","privacy":"Privacidad y t\xe9rminos","copyright":"\xa9 {{year}} DinLabel"},"install":{"title":"Descargar","intro":"Instala DinLabel en Windows y empieza a dise\xf1ar etiquetas para impresoras t\xe9rmicas \u2014 incluyendo Zebra y otras impresoras de etiquetas Windows \u2014 en minutos.","windowsNote":"Instalador de Windows (.exe). Compatible con Windows 7 y posteriores.","requirements":"Requisitos del sistema","reqWindows":"Compatible con cualquier version de Windows a partir de Windows 7","reqInternet":"Acceso a Internet","reqDisk":"50 MB de espacio disponible en disco duro","freeTag":"Versi\xf3n demo","freeText":"La versi\xf3n demo incluye una marca de agua en las etiquetas impresas.","paidTitle":"Versi\xf3n completa","paidText":"Sin marcas de agua \u2014 lista para impresi\xf3n de producci\xf3n.","buyApp":"Suscribirse a DinLabel","orDistributor":"\xbfPrefieres suscribirte a trav\xe9s de un socio?","distributorsLink":"Ver distribuidores","emailModalTitle":"Descargar la demo","emailModalIntro":"Introduce tu correo electr\xf3nico para descargar la demo de DinLabel.","emailLabel":"Correo electr\xf3nico","emailSubmit":"Descargar","emailInvalid":"Introduce una direcci\xf3n de correo v\xe1lida.","emailSubmitError":"Algo sali\xf3 mal. Int\xe9ntalo de nuevo.","purchasedIntro":"Descarga e instala DinLabel para empezar a usar tu versi\xf3n completa.","signInTitle":"C\xf3mo iniciar sesi\xf3n","signInStep1":"Descarga e instala DinLabel con el bot\xf3n de arriba.","signInStep2":"Abre DinLabel.","signInStep3":"Elige Iniciar sesi\xf3n / registrarse en el men\xfa.","signInStep4":"Inicia sesi\xf3n con la misma cuenta que usaste para suscribirte. Una vez iniciada la sesi\xf3n, estar\xe1s usando la versi\xf3n completa de DinLabel.","signInStep4UnpurchasedBefore":"Inicia sesi\xf3n con una cuenta. Usar\xe1s la versi\xf3n demo","signInStep4UnpurchasedLink":"hasta que te suscribas","signInStep4UnpurchasedAfter":"."},"fullTutorials":{"title":"Tutoriales","intro":"Videos paso a paso para dise\xf1ar, imprimir y aprovechar DinLabel al m\xe1ximo.","howToRoll":"C\xf3mo crear una etiqueta en rollo","howToSheet":"C\xf3mo crear una etiqueta en planilla","howTo3Across":"C\xf3mo crear etiquetas de 3 al paso","howToText":"C\xf3mo agregar texto","howToShapes":"C\xf3mo agregar figuras","howToImages":"C\xf3mo agregar im\xe1genes","howToBarCodes":"C\xf3mo agregar c\xf3digos de barras","howToQR":"C\xf3mo agregar c\xf3digos QR","howToPrint":"C\xf3mo imprimir","howToConsecutive":"C\xf3mo usar n\xfameros consecutivos","howToDataBase":"C\xf3mo usar bases de datos","howToBuy":"C\xf3mo suscribirse a DinLabel","alsoDistributor":"Los tutoriales para distribuidores est\xe1n en el portal de distribuidores.","distributorLink":"Abrir portal de distribuidores"},"privacy":{"title":"Pol\xedtica de privacidad y t\xe9rminos de servicio","eulaLink":"Contrato de licencia de usuario final","policyLink":"Pol\xedtica de privacidad","note":"La pol\xedtica de privacidad abre el documento HTML est\xe1tico localizado.","loading":"Cargando\u2026","eulaLoadError":"No se pudo cargar el EULA."},"distributors":{"title":"Distribuidores"},"buyPage":{"title":"Suscribirse a DinLabel","intro":"Desbloquea la versi\xf3n completa con una suscripci\xf3n mensual \u2014 sin marcas de agua, lista para impresi\xf3n t\xe9rmica y de producci\xf3n en Zebra y otras impresoras de etiquetas.","panelTitle":"Suscripci\xf3n mensual","errorTitle":"Algo sali\xf3 mal","thanks":"Gracias por suscribirte a DinLabel. \xa1Ya tienes acceso completo a la aplicaci\xf3n!","thanksLifetime":"Gracias \u2014 ya tienes acceso de por vida a DinLabel.","checkAccount":"Revisa el estado de tu cuenta","goToDownload":"Ir a la p\xe1gina de descarga","manageBilling":"Administrar facturaci\xf3n","price":"USD ${{price}}/mes + Impuestos","payWithCard":"Suscribirse con tarjeta","payError":"No se pudo redirigir a Stripe.","adminTestMode":"Este es un usuario administrador, por lo que el checkout usar\xe1 informaci\xf3n de testmode. Usa la tarjeta \'4242 4242 4242 4242\'.","debugToggleBought":"Solo para admins: Debug: Alternar Bought","toggleBoughtError":"No se pudo alternar el estado de compra.","orVia":"\xbfPrefieres otra opci\xf3n?","downloadDemo":"Descargar una demo completamente funcional"},"userInfo":{"title":"Mi cuenta","detailsTitle":"Datos de la cuenta","quickLinks":"Enlaces r\xe1pidos","userId":"ID de usuario","email":"Correo electr\xf3nico","emailConfirmed":"Correo confirmado","confirmed":"Confirmado","notConfirmed":"Sin confirmar","resend":"Reenviar","resentEmail":"Correo de confirmaci\xf3n reenviado a {{email}}","resendError":"No se pudo reenviar el correo de confirmaci\xf3n.","version":"Versi\xf3n de la aplicaci\xf3n","freeVersion":"Versi\xf3n demo","fullVersion":"Versi\xf3n completa","lifetimeAccess":"Acceso de por vida","subscription":"Suscripci\xf3n","subscriptionTitle":"Suscripci\xf3n","subscriptionStatus":"Estado","subscriptionRenews":"Se renueva el","subscriptionEnds":"Acceso hasta","subscriptionCancelScheduled":"Se cancela al final del periodo","subscriptionLoading":"Cargando suscripci\xf3n\u2026","subscriptionError":"No se pudo cargar el estado de la suscripci\xf3n.","manageBilling":"Administrar facturaci\xf3n","statusActive":"Activa","statusTrialing":"Prueba","statusPastDue":"Pago atrasado","statusCanceled":"Cancelada","statusUnpaid":"Impaga","statusIncomplete":"Incompleta","statusIncompleteExpired":"Vencida","statusPaused":"Pausada","statusUnknown":"{{status}}","buyApp":"Suscribirse","accountType":"Cuenta","admin":"Portal de administraci\xf3n","openDistributorPortal":"Abrir portal de distribuidores","setPasswordTitle":"Agregar contrase\xf1a","setPasswordIntro":"Agrega una contrase\xf1a para iniciar sesi\xf3n con correo adem\xe1s de Google. Tu cuenta y licencia no cambian.","changePasswordTitle":"Cambiar contrase\xf1a","changePasswordIntro":"Actualiza la contrase\xf1a del inicio de sesi\xf3n con correo.","confirmEmailBeforePassword":"Confirma tu correo antes de agregar una contrase\xf1a.","currentPassword":"Contrase\xf1a actual","newPassword":"Nueva contrase\xf1a","passwordHint":"Al menos 8 caracteres","setPasswordExpand":"Agregar contrase\xf1a","changePasswordExpand":"Cambiar contrase\xf1a","passwordFormCancel":"Cancelar","setPasswordSubmit":"Guardar contrase\xf1a","changePasswordSubmit":"Actualizar contrase\xf1a","passwordSet":"Contrase\xf1a guardada. Ya puedes iniciar sesi\xf3n con correo y contrase\xf1a.","passwordChanged":"Contrase\xf1a actualizada.","passwordError":"No se pudo actualizar la contrase\xf1a."},"myLabels":{"title":"Mis etiquetas","loading":"Cargando\u2026","loadError":"No se pudieron cargar las etiquetas.","empty":"No tienes etiquetas guardadas.","name":"Nombre","date":"Fecha","view":"Ver","download":"Descargar","back":"Volver a mis etiquetas"},"admin":{"title":"Portal de administraci\xf3n","dataLink":"Panel de an\xe1lisis de clientes DinLabel","serverAnalyticsLink":"Panel de an\xe1lisis del servidor","fakeEmailLink":"Correos falsos","loading":"Cargando\u2026","loadError":"No se pudieron cargar los datos de administraci\xf3n.","totalUsers":"Usuarios totales: {{count}}","paidUsers":"Usuarios de pago: {{count}}","totalSubscribedUsers":"Total de usuarios suscritos: {{count}}","users":"Usuarios","distributors":"Distribuidores","payments":"Pagos de distribuidores","demoDownloaders":"Descargas de demo","authorize":"Autorizar","toggleAdmin":"Alternar admin"},"fakeEmail":{"title":"Correos falsos","description":"Vista previa de plantillas de correo con datos de ejemplo.","distributorSignUp":"Registro de distribuidor","activationLink":"Activaci\xf3n / confirmar correo","sendEmailLicense":"Distribuidor env\xeda licencia","congratulationEmail":"Felicitaciones","boughtLicensesMail":"Licencias compradas","demoDownloadThankYou":"Agradecimiento por demo","subject":"Asunto","body":"Cuerpo","loading":"Cargando\u2026","loadError":"No se pudo cargar este correo.","backAdmin":"Volver a administraci\xf3n","testAddress":"Direcci\xf3n de prueba","testAddressPlaceholder":"tu@ejemplo.com","sendTest":"Enviar prueba","sendSuccess":"Se envi\xf3 {{action}} a {{email}}","sendError":"No se pudo enviar el correo de prueba."}}');


var $24b850b039f2a405$exports = {};
$24b850b039f2a405$exports = JSON.parse('{"nav":{"home":"Accueil","tutorials":"Tutoriels","barcodes":"Codes-barres","contact":"Nous contacter","logout":"D\xe9connexion","logoAlt":"DinLabel","download":"T\xe9l\xe9charger","downloadDemo":"T\xe9l\xe9charger la d\xe9mo","buy":"S\'abonner","login":"Connexion","myAccount":"Mon compte","language":"Langue","distributorPortal":"Portail distributeurs"},"language":{"title":"Langue","description":"Choisissez la langue de l\'application. Par d\xe9faut, la langue du navigateur est utilis\xe9e.","browser":"Utiliser la langue du navigateur","english":"Anglais","spanish":"Espagnol","german":"Allemand","french":"Fran\xe7ais"},"offline":{"title":"Hors ligne","message":"L\'application ne peut pas se connecter au serveur :( !!"},"dialogs":{"apiError":"Erreur API","confirmYes":"Oui","cancel":"Annuler","send":"Envoyer"},"portal":{"pageTitle":"Portail distributeurs","actions":"Actions","authorized":"Autoris\xe9","pending":"En attente d\'approbation","buyLicenses":"Acheter des licences","pendingApproval":"Votre demande de distributeur n\'a pas encore \xe9t\xe9 approuv\xe9e \u2013 pour toute question, vous pouvez contacter {{email}}. Ce processus ne devrait pas prendre plus de 2 jours ouvrables.","distributorInfo":"Informations pour les distributeurs","loading":"Chargement des informations du distributeur\u2026","loadError":"Impossible de charger les informations du distributeur."},"licenses":{"noneAvailable":"Vous n\'avez actuellement aucune licence disponible \xe0 envoyer.","statAvailable":"Disponibles \xe0 envoyer","statBought":"Achet\xe9es","statSent":"Envoy\xe9es","sentHistory":"Licences envoy\xe9es","activatedYes":"Activ\xe9e","buyTitle":"Portail distributeurs - Acheter des licences","buyLoading":"Chargement\u2026","buyLoadError":"Impossible de charger les informations du distributeur.","buyIntro":"Indiquez le nombre de licences que vous souhaitez acheter \u2013 le prix distributeur est de {{price}} pesos. Les distributeurs peuvent vendre DinLabel comme ils le jugent appropri\xe9, mais notre prix recommand\xe9 est de {{recommended}} pesos.","licenseCountLabel":"Nombre de licences","costSummary":"Le co\xfbt de {{count}} licences est de {{cost}} pesos + taxes.","buyButton":"Acheter {{count}} licences","sendTitle":"Envoyer une licence","resendConfirm":"Voulez-vous renvoyer la licence \xe0 {{email}} ?","sendPrompt":"Entrez l\'e-mail auquel vous souhaitez envoyer","emailPlaceholder":"email@exemple.com","errorTitle":"Erreur !","sendError":"Une erreur s\'est produite lors de l\'envoi de la licence {{error}}","resentTitle":"Licence renvoy\xe9e !","resentMessage":"La licence a \xe9t\xe9 renvoy\xe9e \xe0 {{email}} avec copie \xe0 {{cc}}","sentTitle":"Licence envoy\xe9e !","sentMessage":"La licence a \xe9t\xe9 envoy\xe9e \xe0 {{email}} avec copie \xe0 {{cc}}","sendToEmail":"Envoyer la licence par e-mail...","recipient":"Destinataire de la licence","date":"Date","sent":"Envoy\xe9e","activated":"Activ\xe9e","notActivated":"Pas encore activ\xe9e","resend":"Renvoyer la licence"},"register":{"title":"Devenir distributeur","intro":"Pour acc\xe9der au portail distributeurs DinLabel, vous devez d\'abord vous inscrire :","company":"Entreprise","companyPlaceholder":"Nom de l\'entreprise","phone":"T\xe9l\xe9phone","phonePlaceholder":"T\xe9l\xe9phone","phoneDescription":"Assurez-vous d\'inclure l\'indicatif du pays, par exemple +33 1...","street":"Rue","street1Placeholder":"Rue 1","street2Placeholder":"Rue 2","number":"Num\xe9ro","city":"Ville","state":"R\xe9gion","country":"Pays","zip":"Code postal","rfc":"Identifiant fiscal","nextSteps":"Vous recevrez un e-mail avec les prochaines \xe9tapes","submit":"Envoyer"},"faq":{"qGoogleAccount":"Ai-je besoin d\'un compte Google pour \xeatre distributeur DINLabel ?","aGoogleAccount":"Oui, vous avez besoin d\'un compte Google. Si vous en avez d\xe9j\xe0 un, vous pouvez l\'utiliser pour vous connecter au portail distributeurs.","qRequirements":"Que dois-je faire pour devenir distributeur DINLabel ?","aRequirementsBefore":"Inscrivez-vous en tant que distributeur dans le","aRequirementsLink":"portail distributeurs","aRequirementsAfter":"et attendez de recevoir l\'e-mail de confirmation vous autorisant en tant que distributeur DINLabel.","qAnyoneCanSell":"Toute personne ou entreprise peut-elle vendre DINLabel ?","aAnyoneCanSell":"Oui, il suffit de s\'inscrire sur le portail distributeurs DINLabel et de recevoir l\'e-mail de confirmation.","qHowManyDistributors":"Combien de distributeurs peut-il y avoir chez DINLabel ?","aHowManyDistributors":"Il n\'y a pas de limite.","qDistributorCost":"Combien co\xfbte une licence DINLabel pour un distributeur ?","aDistributorCost":"112 USD plus taxes par licence.","qRecommendedPrice":"Quel est le prix de vente recommand\xe9 du distributeur \xe0 ses clients pour une licence DINLabel ?","aRecommendedPrice":"Le distributeur fixe le prix ; il n\'y a pas de prix fixe. Nous sugg\xe9rons un prix de vente de 160 USD plus taxes. Les clients directs sur le portail DinLabel s\'abonnent pour 15 USD par mois plus taxes.","qWhereToBuy":"O\xf9 un utilisateur final peut-il obtenir DinLabel ?","aWhereToBuyBefore":"Les nouveaux clients s\'abonnent mensuellement sur la page d\'abonnement, ou obtiennent une licence aupr\xe8s d\'un distributeur. Les acheteurs ponctuels existants conservent un acc\xe8s \xe0 vie. Abonnez-vous sur le portail","qHowBuyAsDistributor":"En tant que distributeur, comment acheter des licences DINLabel ?","aHowBuyAsDistributorBefore":"Via le portail distributeurs, en allant dans la section Acheter des licences. Voir le tutoriel","aHowBuyAsDistributorLink":"comment acheter des licences.","qMinimumLicenses":"En tant que distributeur, lors de l\'achat de licences pour les revendre \xe0 mes clients, quel est le nombre minimum de licences \xe0 acheter ?","aMinimumLicenses":"Il n\'y a pas de minimum ; vous pouvez acheter \xe0 partir de 1 licence.","qHowDeliver":"En tant que distributeur, comment livrer une licence DINLabel \xe0 mon client ?","aHowDeliverBefore":"Via le portail distributeurs, dans la section","aHowDeliverSendLink":"envoyer des licences","aHowDeliverMiddle":" ; voir le","aHowDeliverTutorialLink":"tutoriel sur l\'envoi de licences.","qHowLongPurchase":"Combien de temps faut-il pour acheter une licence en tant que distributeur et la livrer au client ?","aHowLongPurchase":"Si vous \xeates d\xe9j\xe0 enregistr\xe9 en tant que distributeur, l\'achat et la livraison de la licence peuvent se faire en quelques minutes.","qHowLongToSell":"En tant que distributeur, combien de temps ai-je pour vendre les licences achet\xe9es sur le portail ?","aHowLongToSell":"Les licences distributeur n\'expirent pas. Lorsque vous achetez des licences, elles sont ajout\xe9es \xe0 votre inventaire et vous pouvez les utiliser \xe0 tout moment.","qHowManyAvailable":"Comment savoir combien de licences j\'ai en tant que distributeur ?","aHowManyAvailableBefore":"Lorsque vous entrez dans le","aHowManyAvailableLink":"portail distributeurs","aHowManyAvailableAfter":" DINLabel, le premier \xe9cran affiche votre solde de licences disponibles \xe0 envoyer.","qSoldLicenses":"Comment savoir quelles licences j\'ai vendues et \xe0 qui ?","aSoldLicensesBefore":"Via le portail distributeurs DINLabel dans la section","aSoldLicensesLink":"voir les d\xe9tails","qTryBefore":"Puis-je essayer DINLabel avant de devenir distributeur ?","aTryBeforeBefore":"Oui, vous pouvez t\xe9l\xe9charger une d\xe9mo sur","aTryBeforeAfter":"et l\'essayer.","qMainFaq":"Y a-t-il des FAQ (foire aux questions) sur le portail DINLabel ?","aMainFaqBefore":"Sur","aMainFaqAfter":"vous trouverez les questions les plus fr\xe9quentes sur l\'utilisation du syst\xe8me DINLabel.","qTutorials":"Y a-t-il des tutoriels pour utiliser DINLabel ?","aTutorialsBefore":"Sur","aTutorialsAfter":"vous trouverez tous les tutoriels n\xe9cessaires pour utiliser DINLabel.","qSupport":"En tant que distributeur, ai-je un support technique ?","aSupport":"Par e-mail ; voir la fin de cette FAQ.","qOtherQuestion":"J\'ai une question qui n\'est pas dans la liste. Que puis-je faire ?","aOtherQuestionBefore":"Nous serions ravis de vous aider. Allez \xe0","aOtherQuestionLink":"nous contacter","aOtherQuestionAfter":", envoyez vos questions, et nous vous r\xe9pondrons volontiers."},"tutorials":{"title":"Tutoriels","alsoSeeFaqBefore":"Vous pouvez aussi consulter la","alsoSeeFaqLink":"FAQ","sendLicenseTutorial":"Tutoriel : Comment envoyer une licence depuis le portail distributeurs","iframeTitle":"Tutoriel envoi de licence"},"home":{"welcome":"Bienvenue, {{email}}","error":"Erreur"},"userLicenses":{"hasLicense":"Vous avez d\xe9j\xe0 un acc\xe8s complet \xe0 DinLabel.","hasSubscription":"Votre abonnement DinLabel est actif.","manageBilling":"G\xe9rer la facturation","noLicense":"Vous n\'avez pas d\'abonnement DinLabel actif","buyHere":"S\'abonner ici"},"signin":{"title":"Connexion","intro":"Connectez-vous avec Google ou avec votre e-mail et mot de passe.","withGoogle":"Se connecter avec Google","orEmail":"ou","email":"E-mail","password":"Mot de passe","withEmail":"Se connecter avec e-mail","createAccount":"Cr\xe9er un compte","forgotPassword":"Mot de passe oubli\xe9 ?","emailPasswordError":"Connexion impossible. V\xe9rifiez votre e-mail et mot de passe.","agreePrefix":"En continuant, vous acceptez notre","privacyLink":"Politique de confidentialit\xe9 et conditions d\'utilisation","alreadySignedIn":"Vous \xeates d\xe9j\xe0 connect\xe9","signedInAs":"Connect\xe9 en tant que {{email}}","continue":"Continuer","debugSignInUrl":"URL de connexion"},"registerAccount":{"title":"Cr\xe9er un compte","intro":"Inscrivez-vous avec votre e-mail et un mot de passe.","email":"E-mail","password":"Mot de passe","passwordHint":"Au moins 8 caract\xe8res","submit":"Cr\xe9er le compte","haveAccount":"Vous avez d\xe9j\xe0 un compte ?","signIn":"Se connecter","error":"Impossible de cr\xe9er le compte.","googleExists":"Cet e-mail est d\xe9j\xe0 enregistr\xe9 avec Google. Connectez-vous avec Google, puis ajoutez un mot de passe dans Mon compte si vous le souhaitez."},"forgotPassword":{"title":"Mot de passe oubli\xe9","intro":"Entrez votre e-mail. Si un compte existe, nous enverrons un lien de r\xe9initialisation.","email":"E-mail","submit":"Envoyer le lien","sent":"Si un compte existe pour cet e-mail, un lien de r\xe9initialisation a \xe9t\xe9 envoy\xe9.","backToSignIn":"Retour \xe0 la connexion","error":"Impossible d\'envoyer l\'e-mail de r\xe9initialisation."},"resetPassword":{"title":"R\xe9initialiser le mot de passe","password":"Nouveau mot de passe","passwordHint":"Au moins 8 caract\xe8res","submit":"Mettre \xe0 jour le mot de passe","success":"Votre mot de passe a \xe9t\xe9 mis \xe0 jour.","signIn":"Se connecter","backToSignIn":"Retour \xe0 la connexion","invalidLink":"Ce lien de r\xe9initialisation est invalide ou incomplet.","error":"Impossible de r\xe9initialiser le mot de passe."},"applogin":{"title":"Continuer dans DinLabel","intro":"Continuez pour terminer la connexion \xe0 l\'application de bureau.","signedInAs":"Vous \xeates connect\xe9 en tant que {{email}}.","continue":"Continuer","switchAccount":"Utiliser un autre compte","redirecting":"Redirection vers la connexion\u2026","invalidTitle":"Lien de connexion non valide","invalidBody":"Cette page est ouverte par l\'application de bureau DinLabel. Veuillez d\xe9marrer la connexion depuis l\'application."},"marketing":{"headline":"Logiciel professionnel pour la gestion et l\'impression d\'\xe9tiquettes","slogan":"Configurez et imprimez facilement sur imprimantes thermiques (Zebra et plus), laser et jet d\'encre. Ajoutez textes, codes-barres, donn\xe9es variables et num\xe9rotation s\xe9quentielle sur \xe9tiquettes en tissu, carton ou adh\xe9sives.","featureNumbers":"Num\xe9rotation s\xe9quentielle et compteurs","featureImages":"Logos et images nets","featureVariable":"Donn\xe9es variables sans complication","featureQr":"Codes QR interactifs","featureText":"Texte clair et lisible","featureBarcode":"Codes-barres professionnels","featureDemo":{"productName":"Nom du produit","oliveOil":"Huile d\'olive","oliveOilDesc":"Description de l\'huile d\'olive","fontsNote":"Polices claires, fines et lisibles","sequence":"S\xe9quence {{n}}","client":"CLIENT :","name":"Nom","city":"VILLE :","companyLogo":"Logo d\'entreprise"},"featuresTitle":"Tout ce dont vous avez besoin sur une \xe9tiquette","featuresSubtitle":"Cr\xe9ez des \xe9tiquettes professionnelles avec les outils sur lesquels s\'appuient les imprimeries et les entrep\xf4ts chaque jour.","seeBarcodeTypes":"Voir les types de codes-barres pris en charge","printersTitle":"Compatible avec n\'importe quelle imprimante","printersSubtitle":"DinLabel se connecte directement aux imprimantes que vous utilisez d\xe9j\xe0 dans votre entreprise via les pilotes Windows standard.","printersTypesTitle":"Types d\'imprimantes et supports :","printersThermalLabel":"Thermiques et transfert thermique :","printersThermalBody":"Id\xe9ales pour les \xe9tiquettes en rouleau adh\xe9sives, Tyvek, nylon, carton, etc.","printersLaserLabel":"Laser et jet d\'encre (Inkjet) :","printersLaserBody":"Id\xe9ales pour les planches de feuilles adh\xe9sives, carton ou tissu.","whyTitle":"Pourquoi DinLabel ?","whyCompatLabel":"Compatibilit\xe9 totale :","whyCompatBody":"Imprimez sur n\'importe quelle imprimante (thermique, laser et jet d\'encre) en rouleaux ou en planches.","whyCostLabel":"Sans co\xfbts gonfl\xe9s :","whyCostBody":"Toutes les fonctions professionnelles sans payer des licences d\'entreprise exorbitantes.","whySupportLabel":"Un vrai support technique :","whySupportBody":"Nous vous aidons pas \xe0 pas, du t\xe9l\xe9chargement et de l\'installation jusqu\'\xe0 l\'impression de vos \xe9tiquettes.","tryTitle":"Essayez DinLabel gratuitement d\xe8s aujourd\'hui","trySubtitle":"T\xe9l\xe9chargez la version d\xe9mo gratuite, connectez l\'imprimante que vous avez (thermique, laser ou jet d\'encre) et v\xe9rifiez comment elle imprime vos \xe9tiquettes en quelques minutes.","needHelp":"Besoin d\'aide ?","customerService":"Service client","customerServiceText":"Contactez-nous par e-mail et nous vous aiderons volontiers.","tutorialsText":"Tutoriels vid\xe9o \xe9tape par \xe9tape pour chaque fonctionnalit\xe9."},"barcodes":{"title":"Types de codes-barres dans DinLabel","intro":"DinLabel imprime les types de codes-barres les plus utilis\xe9s sur les \xe9tiquettes de vente, d\'exp\xe9dition et industrielles. Les types ci-dessous apparaissent en premier lorsque vous ajoutez un code-barres. Choisissez Afficher plus dans l\'\xe9diteur pour utiliser l\'un des types suppl\xe9mentaires pris en charge.","commonTitle":"Types de codes-barres les plus courants","commonIntro":"Ce sont les types que nous recommandons pour la plupart des \xe9tiquettes. DinLabel les prend tous en charge d\'embl\xe9e.","fullTitle":"Tous les types de codes-barres pris en charge","fullIntro":"L\'\xe9diteur de codes-barres affiche ces noms lorsque vous choisissez Afficher plus. Utilisez dans DinLabel le m\xeame nom que celui indiqu\xe9 ici.","fullCount":"DinLabel prend en charge {{count}} types de codes-barres.","ctaInstall":"T\xe9l\xe9charger DinLabel","ctaTutorials":"Voir les tutoriels codes-barres","common":{"UpcA":{"name":"UPC-A","description":"Le code-barres \xe0 12 chiffres pr\xe9sent sur la plupart des produits vendus en Am\xe9rique du Nord."},"UpcE":{"name":"UPC-E","description":"Un UPC compact \xe0 6 chiffres pour les petits emballages trop \xe9troits pour l\'UPC-A."},"Ean13":{"name":"EAN-13","description":"Le code-barres de vente \xe0 13 chiffres utilis\xe9 dans le monde, y compris en Europe et en Am\xe9rique latine."},"Ean8":{"name":"EAN-8","description":"Un EAN plus court pour les petits produits trop \xe9troits pour l\'EAN-13."},"Code128":{"name":"Code 128","description":"Un code lin\xe9aire haute densit\xe9 pour lettres, chiffres et symboles. Courant en exp\xe9dition et en inventaire."},"GS1128":{"name":"GS1-128","description":"Code 128 avec identifiants d\'application GS1 pour la logistique, le GTIN, le lot et les dates."},"Code39":{"name":"Code 39","description":"Un code industriel tr\xe8s utilis\xe9 qui encode lettres, chiffres et quelques symboles."},"Interleaved2of5":{"name":"Interleaved 2 of 5","description":"Un code num\xe9rique compact utilis\xe9 en entrep\xf4t, distribution et \xe9tiquetage industriel."},"Itf14":{"name":"ITF-14","description":"Un code \xe0 14 chiffres pour les cartons d\'exp\xe9dition et les conditionnements externes (GTIN-14)."},"QRCode":{"name":"Code QR","description":"Un code 2D qui stocke des URL, du texte et plus. Facile \xe0 scanner avec un t\xe9l\xe9phone."},"DataMatrix":{"name":"Data Matrix","description":"Un code 2D compact utilis\xe9 en \xe9lectronique, sant\xe9 et marquage de petites pi\xe8ces."},"Pdf417":{"name":"PDF417","description":"Un code 2D empil\xe9 qui contient plus de donn\xe9es qu\'un code 1D classique, utilis\xe9 sur les pi\xe8ces d\'identit\xe9, l\'exp\xe9dition et les billets."}}},"footer":{"tagline":"Conception professionnelle d\'\xe9tiquettes pour imprimantes thermiques \u2014 Zebra et plus.","privacy":"Confidentialit\xe9 et conditions","copyright":"\xa9 {{year}} DinLabel"},"install":{"title":"T\xe9l\xe9charger","intro":"Installez DinLabel sur Windows et commencez \xe0 concevoir des \xe9tiquettes pour imprimantes thermiques \u2014 notamment Zebra et d\'autres imprimantes d\'\xe9tiquettes Windows \u2014 en quelques minutes.","windowsNote":"Installateur Windows (.exe). Compatible avec Windows 7 et versions ult\xe9rieures.","requirements":"Configuration requise","reqWindows":"Toute version de Windows \xe0 partir de Windows 7","reqInternet":"Acc\xe8s Internet","reqDisk":"50 Mo d\'espace disque dur","freeTag":"Version d\xe9mo","freeText":"La version d\xe9mo inclut un filigrane sur les \xe9tiquettes imprim\xe9es.","paidTitle":"Version compl\xe8te","paidText":"Sans filigranes \u2014 pr\xeate pour l\'impression de production.","buyApp":"S\'abonner \xe0 DinLabel","orDistributor":"Vous pr\xe9f\xe9rez vous abonner via un partenaire ?","distributorsLink":"Voir les distributeurs","emailModalTitle":"T\xe9l\xe9charger la d\xe9mo","emailModalIntro":"Entrez votre adresse e-mail pour t\xe9l\xe9charger la d\xe9mo DinLabel.","emailLabel":"E-mail","emailSubmit":"T\xe9l\xe9charger","emailInvalid":"Veuillez saisir une adresse e-mail valide.","emailSubmitError":"Une erreur s\'est produite. Veuillez r\xe9essayer.","purchasedIntro":"T\xe9l\xe9chargez et installez DinLabel pour commencer \xe0 utiliser votre version compl\xe8te.","signInTitle":"Comment se connecter","signInStep1":"T\xe9l\xe9chargez et installez DinLabel \xe0 l\'aide du bouton ci-dessus.","signInStep2":"Ouvrez DinLabel.","signInStep3":"Choisissez Se connecter / S\'inscrire dans le menu.","signInStep4":"Connectez-vous avec le m\xeame compte que celui utilis\xe9 pour l\'abonnement. Une fois connect\xe9, vous utiliserez la version compl\xe8te de DinLabel.","signInStep4UnpurchasedBefore":"Connectez-vous avec un compte. Vous utiliserez la version d\xe9mo","signInStep4UnpurchasedLink":"jusqu\'\xe0 ce que vous vous abonniez","signInStep4UnpurchasedAfter":"."},"fullTutorials":{"title":"Tutoriels","intro":"Vid\xe9os \xe9tape par \xe9tape pour vous aider \xe0 concevoir, imprimer et tirer le meilleur parti de DinLabel.","howToRoll":"Comment cr\xe9er une \xe9tiquette sur rouleau","howToSheet":"Comment cr\xe9er une \xe9tiquette sur planche","howTo3Across":"Comment cr\xe9er des \xe9tiquettes 3 de front","howToText":"Comment ajouter du texte","howToShapes":"Comment ajouter des formes","howToImages":"Comment ajouter des images","howToBarCodes":"Comment ajouter des codes-barres","howToQR":"Comment ajouter des codes QR","howToPrint":"Comment imprimer","howToConsecutive":"Comment utiliser les num\xe9ros cons\xe9cutifs","howToDataBase":"Comment utiliser les bases de donn\xe9es","howToBuy":"Comment s\'abonner \xe0 DinLabel","alsoDistributor":"Des tutoriels sp\xe9cifiques aux distributeurs sont disponibles dans le portail distributeurs.","distributorLink":"Ouvrir le portail distributeurs"},"privacy":{"title":"Politique de confidentialit\xe9 et conditions d\'utilisation","eulaLink":"Contrat de licence utilisateur final","policyLink":"Politique de confidentialit\xe9","note":"La politique de confidentialit\xe9 ouvre le document HTML statique localis\xe9.","loading":"Chargement\u2026","eulaLoadError":"Impossible de charger le CLUF."},"distributors":{"title":"Distributeurs"},"buyPage":{"title":"S\'abonner \xe0 DinLabel","intro":"D\xe9bloquez la version compl\xe8te avec un abonnement mensuel \u2014 sans filigranes, pr\xeate pour l\'impression thermique et de production sur Zebra et d\'autres imprimantes d\'\xe9tiquettes.","panelTitle":"Abonnement mensuel","errorTitle":"Une erreur s\'est produite","thanks":"Merci de vous \xeatre abonn\xe9 \xe0 DinLabel. Vous avez maintenant un acc\xe8s complet \xe0 l\'application !","thanksLifetime":"Merci \u2014 vous avez d\xe9j\xe0 un acc\xe8s \xe0 vie \xe0 DinLabel.","checkAccount":"V\xe9rifier l\'\xe9tat de votre compte","goToDownload":"Aller \xe0 la page de t\xe9l\xe9chargement","manageBilling":"G\xe9rer la facturation","price":"USD ${{price}}/mois + Taxes","payWithCard":"S\'abonner par carte","payError":"Impossible de rediriger vers le paiement Stripe.","adminTestMode":"Ceci est un utilisateur admin, le paiement utilisera donc le mode test. Utilisez la carte \'4242 4242 4242 4242\'.","debugToggleBought":"R\xe9serv\xe9 aux admins : Debug : Basculer Bought","toggleBoughtError":"Impossible de basculer l\'\xe9tat d\'achat.","orVia":"Vous pr\xe9f\xe9rez une autre option ?","downloadDemo":"T\xe9l\xe9charger une d\xe9mo enti\xe8rement fonctionnelle"},"userInfo":{"title":"Mon compte","detailsTitle":"D\xe9tails du compte","quickLinks":"Liens rapides","userId":"ID utilisateur","email":"Adresse e-mail","emailConfirmed":"E-mail confirm\xe9","confirmed":"Confirm\xe9","notConfirmed":"Non confirm\xe9","resend":"Renvoyer","resentEmail":"E-mail de confirmation renvoy\xe9 \xe0 {{email}}","resendError":"Impossible de renvoyer l\'e-mail de confirmation.","version":"Version de l\'application","freeVersion":"Version d\xe9mo","fullVersion":"Version compl\xe8te","lifetimeAccess":"Acc\xe8s \xe0 vie","subscription":"Abonnement","subscriptionTitle":"Abonnement","subscriptionStatus":"Statut","subscriptionRenews":"Renouvellement le","subscriptionEnds":"Acc\xe8s jusqu\'au","subscriptionCancelScheduled":"R\xe9siliation en fin de p\xe9riode","subscriptionLoading":"Chargement de l\'abonnement\u2026","subscriptionError":"Impossible de charger le statut de l\'abonnement.","manageBilling":"G\xe9rer la facturation","statusActive":"Actif","statusTrialing":"Essai","statusPastDue":"Impay\xe9","statusCanceled":"R\xe9sili\xe9","statusUnpaid":"Non pay\xe9","statusIncomplete":"Incomplet","statusIncompleteExpired":"Expir\xe9","statusPaused":"En pause","statusUnknown":"{{status}}","buyApp":"S\'abonner","accountType":"Compte","admin":"Portail d\'administration","openDistributorPortal":"Ouvrir le portail distributeurs","setPasswordTitle":"Ajouter un mot de passe","setPasswordIntro":"Ajoutez un mot de passe pour vous connecter aussi par e-mail. Votre compte et licence restent les m\xeames.","changePasswordTitle":"Changer le mot de passe","changePasswordIntro":"Mettez \xe0 jour le mot de passe pour la connexion e-mail.","confirmEmailBeforePassword":"Confirmez votre e-mail avant d\'ajouter un mot de passe.","currentPassword":"Mot de passe actuel","newPassword":"Nouveau mot de passe","passwordHint":"Au moins 8 caract\xe8res","setPasswordExpand":"Ajouter un mot de passe","changePasswordExpand":"Changer le mot de passe","passwordFormCancel":"Annuler","setPasswordSubmit":"Enregistrer le mot de passe","changePasswordSubmit":"Mettre \xe0 jour le mot de passe","passwordSet":"Mot de passe enregistr\xe9. Vous pouvez vous connecter avec e-mail et mot de passe.","passwordChanged":"Mot de passe mis \xe0 jour.","passwordError":"Impossible de mettre \xe0 jour le mot de passe."},"myLabels":{"title":"Mes \xe9tiquettes","loading":"Chargement\u2026","loadError":"Impossible de charger les \xe9tiquettes.","empty":"Vous n\'avez aucune \xe9tiquette enregistr\xe9e.","name":"Nom","date":"Date","view":"Voir","download":"T\xe9l\xe9charger","back":"Retour \xe0 mes \xe9tiquettes"},"admin":{"title":"Portail d\'administration","dataLink":"Tableau de bord d\'analyse client DinLabel","serverAnalyticsLink":"Tableau de bord d\'analyse serveur","fakeEmailLink":"E-mails fictifs","loading":"Chargement\u2026","loadError":"Impossible de charger les donn\xe9es d\'administration.","totalUsers":"Utilisateurs totaux : {{count}}","paidUsers":"Utilisateurs payants : {{count}}","totalSubscribedUsers":"Total d\'abonn\xe9s : {{count}}","users":"Utilisateurs","distributors":"Distributeurs","payments":"Paiements distributeurs","demoDownloaders":"T\xe9l\xe9chargements d\xe9mo","authorize":"Autoriser","toggleAdmin":"Basculer admin"},"fakeEmail":{"title":"E-mails fictifs","description":"Aper\xe7u des mod\xe8les d\'e-mail avec des donn\xe9es fictives.","distributorSignUp":"Inscription distributeur","activationLink":"Activation / confirmation d\'e-mail","sendEmailLicense":"Envoi de licence par le distributeur","congratulationEmail":"F\xe9licitations","boughtLicensesMail":"Licences achet\xe9es","demoDownloadThankYou":"Remerciement t\xe9l\xe9chargement d\xe9mo","subject":"Objet","body":"Corps","loading":"Chargement\u2026","loadError":"Impossible de charger cet e-mail.","backAdmin":"Retour \xe0 l\'administration","testAddress":"Adresse de test","testAddressPlaceholder":"vous@exemple.com","sendTest":"Envoyer un test","sendSuccess":"{{action}} envoy\xe9 \xe0 {{email}}","sendError":"\xc9chec de l\'envoi de l\'e-mail de test."}}');


const $6c154842fccf6556$export$94d2d72df36bbb16 = [
    "es-MX",
    "en-US",
    "de-DE",
    "fr-FR"
];
const $6c154842fccf6556$export$4eebed6a6088d401 = "dinlabel.languagePreference";
function $6c154842fccf6556$var$isSupportedLocale(value) {
    return $6c154842fccf6556$export$94d2d72df36bbb16.includes(value);
}
function $6c154842fccf6556$export$f38728011c178796(lng) {
    const lower = lng.toLowerCase();
    if (lower.startsWith("en")) return "en-US";
    if (lower.startsWith("es")) return "es-MX";
    if (lower.startsWith("de")) return "de-DE";
    if (lower.startsWith("fr")) return "fr-FR";
    return "en-US";
}
function $6c154842fccf6556$export$699b6efc48d2d271() {
    if (typeof localStorage === "undefined") return "browser";
    const stored = localStorage.getItem($6c154842fccf6556$export$4eebed6a6088d401);
    if (stored && $6c154842fccf6556$var$isSupportedLocale(stored)) return stored;
    return "browser";
}
async function $6c154842fccf6556$export$7db3818e7d30342d(preference) {
    if (typeof localStorage !== "undefined") {
        if (preference === "browser") localStorage.removeItem($6c154842fccf6556$export$4eebed6a6088d401);
        else localStorage.setItem($6c154842fccf6556$export$4eebed6a6088d401, preference);
    }
    const nextLanguage = preference === "browser" ? $6c154842fccf6556$export$f38728011c178796(typeof navigator !== "undefined" ? navigator.language : "en-US") : preference;
    await (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).changeLanguage(nextLanguage);
}
function $6c154842fccf6556$var$syncDocumentLang(lng) {
    if (typeof document === "undefined") return;
    const resolved = $6c154842fccf6556$export$f38728011c178796(lng);
    document.documentElement.lang = resolved;
// Page titles are owned by RouteSeo / applyPageSeo.
}
(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).use((0, $60196a4650e96cb1$export$2e2bcd8739ae039)).use((0, $26bfda595e5aa141$export$ae7e14d40d89f296)).init({
    showSupportNotice: false,
    resources: {
        "es-MX": {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($e688fdd8fc0ba8bd$exports)))
        },
        "en-US": {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($ba2d6df89db01e7e$exports)))
        },
        "de-DE": {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($dc3e861ed4ee6a89$exports)))
        },
        "fr-FR": {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($24b850b039f2a405$exports)))
        }
    },
    fallbackLng: "en-US",
    supportedLngs: [
        ...$6c154842fccf6556$export$94d2d72df36bbb16
    ],
    preload: [
        ...$6c154842fccf6556$export$94d2d72df36bbb16
    ],
    interpolation: {
        escapeValue: false
    },
    detection: {
        // Explicit preference first; otherwise follow the browser language.
        order: [
            "localStorage",
            "navigator"
        ],
        lookupLocalStorage: $6c154842fccf6556$export$4eebed6a6088d401,
        // Preference is written only via setLanguagePreference, so browser
        // detection does not sticky-cache a resolved locale.
        caches: [],
        convertDetectedLanguage: $6c154842fccf6556$export$f38728011c178796
    }
}).then(()=>{
    $6c154842fccf6556$var$syncDocumentLang((0, $673ff3dfc4a496de$export$2e2bcd8739ae039).language);
});
(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).on("languageChanged", $6c154842fccf6556$var$syncDocumentLang);
var $6c154842fccf6556$export$2e2bcd8739ae039 = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039);



/* eslint-disable @typescript-eslint/no-require-imports */ /** Parcel-bundled image URLs (use these instead of /Images/... from ASP.NET). */ 
const $f59b44cc928cf883$export$e4ce4eb81862e07f = (parcelRequire("feCqm"));

const $f59b44cc928cf883$export$1592979568e08f33 = (parcelRequire("kDwNf"));

const $f59b44cc928cf883$export$ec235bad49bf3a3a = (parcelRequire("dV726"));

const $f59b44cc928cf883$export$8adbec3a4efa782f = (parcelRequire("1NmxF"));

const $f59b44cc928cf883$export$90b2ae0bed6558b5 = (parcelRequire("j4J5v"));

const $f59b44cc928cf883$export$8da0ad777f81af9d = (parcelRequire("GUGyC"));

const $f59b44cc928cf883$export$139a93f430d64a60 = (parcelRequire("kQV5E"));

const $f59b44cc928cf883$export$98104c9ee0729143 = (parcelRequire("aG36s"));

const $f59b44cc928cf883$export$e6344dfa848edfde = (parcelRequire("lsCqq"));

const $f59b44cc928cf883$export$3ab7236b4bdc0f91 = (parcelRequire("q2WpK"));

const $f59b44cc928cf883$export$645a20fb1940aa5b = (parcelRequire("gBRIp"));

const $f59b44cc928cf883$export$e15bfca9ec932e6d = (parcelRequire("eoS7H"));

const $f59b44cc928cf883$export$d6750f761647646b = (parcelRequire("luWKO"));

const $f59b44cc928cf883$export$fac32a244105e2ba = (parcelRequire("7IhZQ"));

const $f59b44cc928cf883$export$a431b5adb36bc0b6 = (parcelRequire("2w2QI"));

const $f59b44cc928cf883$export$51d2376a2cdf7ccf = (parcelRequire("5nmUL"));

const $f59b44cc928cf883$export$307167f93eaa789e = (parcelRequire("3f17H"));

const $f59b44cc928cf883$export$213635cac2381061 = (parcelRequire("ch0Bi"));

const $f59b44cc928cf883$export$1a9c417fe62bff0d = (parcelRequire("1S1Lm"));

const $f59b44cc928cf883$export$a7495411b11a7b2a = (parcelRequire("cuaoc"));



parcelRequire("acw62");
function $b559a680df89f9bd$export$780a8cb2c23ae04b({ locale: locale, size: size = 20, title: title }) {
    const common = {
        width: size,
        height: size * 0.75,
        viewBox: "0 0 16 12",
        role: "img",
        "aria-hidden": title ? undefined : true,
        style: {
            display: "block",
            borderRadius: 2,
            boxShadow: "0 0 0 1px rgba(0,0,0,0.12)"
        }
    };
    switch(locale){
        case "en-US":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                ...common,
                "aria-label": title,
                children: [
                    title ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                        children: title
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "16",
                        height: "12",
                        fill: "#B22234"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M0 1.385h16M0 3.692h16M0 6h16M0 8.308h16M0 10.615h16",
                        stroke: "#fff",
                        strokeWidth: "1.385"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "6.4",
                        height: "6.46",
                        fill: "#3C3B6E"
                    })
                ]
            });
        case "es-MX":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                ...common,
                "aria-label": title,
                children: [
                    title ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                        children: title
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "16",
                        height: "12",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "5.33",
                        height: "12",
                        fill: "#006847"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: "10.67",
                        width: "5.33",
                        height: "12",
                        fill: "#CE1126"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "8",
                        cy: "6",
                        r: "1.4",
                        fill: "#B8860B"
                    })
                ]
            });
        case "fr-FR":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                ...common,
                "aria-label": title,
                children: [
                    title ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                        children: title
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "16",
                        height: "12",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "5.33",
                        height: "12",
                        fill: "#002395"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: "10.67",
                        width: "5.33",
                        height: "12",
                        fill: "#ED2939"
                    })
                ]
            });
        case "de-DE":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                ...common,
                "aria-label": title,
                children: [
                    title ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                        children: title
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "16",
                        height: "4",
                        fill: "#000"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        y: "4",
                        width: "16",
                        height: "4",
                        fill: "#D00"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        y: "8",
                        width: "16",
                        height: "4",
                        fill: "#FFCE00"
                    })
                ]
            });
    }
}




parcelRequire("acw62");


function $62be13b144ef278d$export$82bcc3e60bea3c1a() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("footer", {
        style: {
            background: "var(--mantine-color-charcoal-8)",
            borderTop: "1px solid var(--mantine-color-charcoal-7)",
            marginTop: "auto"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
            size: "lg",
            py: "xl",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                gap: "md",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                        justify: "space-between",
                        align: "flex-start",
                        wrap: "wrap",
                        gap: "lg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                        fw: 700,
                                        size: "lg",
                                        style: {
                                            fontFamily: "var(--mantine-font-family-headings)"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                span: true,
                                                c: "gray.3",
                                                children: "Din"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                span: true,
                                                c: "brand.5",
                                                children: "Label"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                        size: "sm",
                                        c: "dimmed",
                                        maw: 280,
                                        mt: 4,
                                        children: t("footer.tagline")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                gap: "xl",
                                wrap: "wrap",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                        to: "/install",
                                        c: "gray.4",
                                        size: "sm",
                                        underline: "hover",
                                        children: t("nav.download")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                        to: "/buy",
                                        c: "gray.4",
                                        size: "sm",
                                        underline: "hover",
                                        children: t("nav.buy")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                        to: "/tutorials",
                                        c: "gray.4",
                                        size: "sm",
                                        underline: "hover",
                                        children: t("nav.tutorials")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                        to: "/barcodes",
                                        c: "gray.4",
                                        size: "sm",
                                        underline: "hover",
                                        children: t("nav.barcodes")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                        href: "mailto:support@dinlabel.com",
                                        c: "gray.4",
                                        size: "sm",
                                        underline: "hover",
                                        children: t("nav.contact")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                        to: "/privacy",
                                        c: "gray.4",
                                        size: "sm",
                                        underline: "hover",
                                        children: t("footer.privacy")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        size: "xs",
                        c: "dimmed",
                        children: t("footer.copyright", {
                            year: new Date().getFullYear()
                        })
                    })
                ]
            })
        })
    });
}










"use client";
//#region packages/@mantine/core/src/components/Alert/Alert.module.css
var $c9c3cfad9f0274c3$export$2e2bcd8739ae039 = {
    "root": "m_66836ed3",
    "wrapper": "m_a5d60502",
    "body": "m_667c2793",
    "title": "m_6a03f287",
    "label": "m_698f4f23",
    "icon": "m_667f2a6a",
    "message": "m_7fa78076",
    "closeButton": "m_87f54839"
};




"use client";
//#region packages/@mantine/core/src/components/Alert/Alert.tsx
const $e7599b5b791e3b99$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { radius: radius, color: color, variant: variant, autoContrast: autoContrast })=>{
    const colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme: theme,
        variant: variant || "light",
        autoContrast: autoContrast
    });
    return {
        root: {
            "--alert-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--alert-bg": color || variant ? colors.background : void 0,
            "--alert-color": colors.color,
            "--alert-bd": color || variant ? colors.border : void 0
        }
    };
});
const $e7599b5b791e3b99$export$caec2af78bcc877f = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Alert", null, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, radius: radius, color: color, title: title, children: children, id: id, icon: icon, withCloseButton: withCloseButton, onClose: onClose, closeButtonLabel: closeButtonLabel, variant: variant, autoContrast: autoContrast, role: role, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Alert",
        classes: (0, $c9c3cfad9f0274c3$export$2e2bcd8739ae039),
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $e7599b5b791e3b99$var$varsResolver
    });
    const rootId = (0, $cee42e5537afff93$export$f680877a34711e37)(id);
    const titleId = title && `${rootId}-title` || void 0;
    const bodyId = `${rootId}-body`;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        id: rootId,
        ...getStyles("root", {
            variant: variant
        }),
        variant: variant,
        ...others,
        role: role || "alert",
        "aria-describedby": children ? bodyId : void 0,
        "aria-labelledby": title ? titleId : void 0,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
            ...getStyles("wrapper"),
            children: [
                icon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    ...getStyles("icon"),
                    children: icon
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    ...getStyles("body"),
                    children: [
                        title && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                            ...getStyles("title"),
                            "data-with-close-button": withCloseButton || void 0,
                            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                                id: titleId,
                                ...getStyles("label"),
                                children: title
                            })
                        }),
                        children && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                            id: bodyId,
                            ...getStyles("message"),
                            "data-variant": variant,
                            children: children
                        })
                    ]
                }),
                withCloseButton && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $30da360a5c87638a$export$de65de8213222d10), {
                    ...getStyles("closeButton"),
                    onClick: onClose,
                    variant: "transparent",
                    size: 16,
                    iconSize: 16,
                    "aria-label": closeButtonLabel,
                    unstyled: unstyled
                })
            ]
        })
    });
});
$e7599b5b791e3b99$export$caec2af78bcc877f.classes = (0, $c9c3cfad9f0274c3$export$2e2bcd8739ae039);
$e7599b5b791e3b99$export$caec2af78bcc877f.varsResolver = $e7599b5b791e3b99$var$varsResolver;
$e7599b5b791e3b99$export$caec2af78bcc877f.displayName = "@mantine/core/Alert";


/**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $037771e2cea16f79$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 9v4",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 16h.01",
            "key": "svg-2"
        }
    ]
];
const $037771e2cea16f79$export$2e2bcd8739ae039 = (0, $181aa196ec8b5be7$export$2e2bcd8739ae039)("outline", "alert-triangle", "AlertTriangle", $037771e2cea16f79$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");

function $e6c25b6e6adc0f09$export$c4a6d8fea738bc2c() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [isOffline, setIsOffline] = $acw62.useState(!navigator.onLine);
    $acw62.useEffect(()=>{
        const update = ()=>setIsOffline(!navigator.onLine);
        window.addEventListener("online", update);
        window.addEventListener("offline", update);
        return ()=>{
            window.removeEventListener("online", update);
            window.removeEventListener("offline", update);
        };
    }, []);
    if (!isOffline) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7599b5b791e3b99$export$caec2af78bcc877f), {
        color: "yellow",
        title: t("offline.title"),
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $037771e2cea16f79$export$2e2bcd8739ae039), {
            size: 18
        }),
        mb: "md",
        children: t("offline.message")
    });
}


const $1b9dd37b364dbb76$var$navLinkProps = {
    c: "gray.2",
    underline: "never",
    fw: 500
};
function $1b9dd37b364dbb76$export$8ab9296042acb886({ title: title, children: children, fullBleed: fullBleed = false, showFooter: showFooter = false }) {
    const { t: t, i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [opened, { toggle: toggle, close: close }] = (0, $f8988135042e9951$export$6e3e27031a30522f)(false);
    const currentUser = (0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)();
    const showDistributorPortal = !!currentUser && (0, $e9e66f0970a759b5$export$90c873f50cd44aba)();
    const currentLocale = (0, $6c154842fccf6556$export$f38728011c178796)(i18n.resolvedLanguage ?? i18n.language);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dc95f0b8bd3f9327$export$2afed54d6b7d68d9), {
        header: {
            height: 60
        },
        navbar: {
            width: 260,
            breakpoint: "sm",
            collapsed: {
                desktop: true,
                mobile: !opened
            }
        },
        padding: fullBleed ? 0 : "md",
        styles: {
            main: {
                backgroundColor: "var(--mantine-color-gray-0)",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column"
            }
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc95f0b8bd3f9327$export$2afed54d6b7d68d9).Header, {
                bg: "charcoal.8",
                style: {
                    borderBottom: "1px solid var(--mantine-color-charcoal-7)"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                    h: "100%",
                    px: "md",
                    justify: "space-between",
                    wrap: "nowrap",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                            gap: "sm",
                            wrap: "nowrap",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ff5b9fe3a78c7ce$export$3990fdb7137d85ae), {
                                    opened: opened,
                                    onClick: toggle,
                                    hiddenFrom: "sm",
                                    size: "sm",
                                    color: "white"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                    to: "/",
                                    underline: "never",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                            span: true,
                                            fw: 700,
                                            c: "gray.3",
                                            style: {
                                                fontFamily: "var(--mantine-font-family-headings)"
                                            },
                                            children: "Din"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                            span: true,
                                            fw: 700,
                                            c: "brand.5",
                                            style: {
                                                fontFamily: "var(--mantine-font-family-headings)"
                                            },
                                            children: "Label"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                    to: "/",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95f3644217e6673d$export$3e431a229df88919), {
                                        src: (0, $f59b44cc928cf883$export$213635cac2381061),
                                        alt: t("nav.logoAlt"),
                                        w: 40,
                                        h: 40
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                            gap: "md",
                            visibleFrom: "sm",
                            wrap: "nowrap",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                    to: "/install",
                                    ...$1b9dd37b364dbb76$var$navLinkProps,
                                    children: t("nav.download")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                    to: "/buy",
                                    c: "brand.5",
                                    underline: "never",
                                    fw: 600,
                                    children: t("nav.buy")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                    to: "/tutorials",
                                    ...$1b9dd37b364dbb76$var$navLinkProps,
                                    children: t("nav.tutorials")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                    to: "/barcodes",
                                    ...$1b9dd37b364dbb76$var$navLinkProps,
                                    children: t("nav.barcodes")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                    to: "/language",
                                    ...$1b9dd37b364dbb76$var$navLinkProps,
                                    "aria-label": t("nav.language"),
                                    title: t("nav.language"),
                                    style: {
                                        display: "inline-flex",
                                        alignItems: "center"
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b559a680df89f9bd$export$780a8cb2c23ae04b), {
                                        locale: currentLocale,
                                        size: 22,
                                        title: t("nav.language")
                                    })
                                }),
                                showDistributorPortal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                    to: "/distributorportal",
                                    ...$1b9dd37b364dbb76$var$navLinkProps,
                                    children: t("nav.distributorPortal")
                                }),
                                currentUser ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                            to: "/userinfo",
                                            ...$1b9dd37b364dbb76$var$navLinkProps,
                                            children: t("nav.myAccount")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                            href: "/logout",
                                            ...$1b9dd37b364dbb76$var$navLinkProps,
                                            children: t("nav.logout")
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                    to: "/signin",
                                    ...$1b9dd37b364dbb76$var$navLinkProps,
                                    children: t("nav.login")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dc95f0b8bd3f9327$export$2afed54d6b7d68d9).Navbar, {
                p: "md",
                bg: "charcoal.9",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                        to: "/install",
                        onClick: close,
                        py: "xs",
                        c: "gray.2",
                        children: t("nav.download")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                        to: "/buy",
                        onClick: close,
                        py: "xs",
                        c: "brand.5",
                        fw: 600,
                        children: t("nav.buy")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                        to: "/tutorials",
                        onClick: close,
                        py: "xs",
                        c: "gray.2",
                        children: t("nav.tutorials")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                        to: "/barcodes",
                        onClick: close,
                        py: "xs",
                        c: "gray.2",
                        children: t("nav.barcodes")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                        to: "/language",
                        onClick: close,
                        py: "xs",
                        c: "gray.2",
                        "aria-label": t("nav.language"),
                        style: {
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b559a680df89f9bd$export$780a8cb2c23ae04b), {
                                locale: currentLocale,
                                size: 22
                            }),
                            t("nav.language")
                        ]
                    }),
                    showDistributorPortal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                        to: "/distributorportal",
                        onClick: close,
                        py: "xs",
                        c: "gray.2",
                        children: t("nav.distributorPortal")
                    }),
                    currentUser ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                to: "/userinfo",
                                onClick: close,
                                py: "xs",
                                c: "gray.2",
                                children: t("nav.myAccount")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                href: "/logout",
                                onClick: close,
                                py: "xs",
                                c: "gray.2",
                                children: t("nav.logout")
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                        to: "/signin",
                        onClick: close,
                        py: "xs",
                        c: "gray.2",
                        children: t("nav.login")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dc95f0b8bd3f9327$export$2afed54d6b7d68d9).Main, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            flex: 1,
                            width: "100%"
                        },
                        children: fullBleed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
                                    size: "lg",
                                    pt: 0,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6c25b6e6adc0f09$export$c4a6d8fea738bc2c), {})
                                }),
                                title && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
                                    size: "lg",
                                    pt: "md",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                        order: 2,
                                        mb: "md",
                                        children: title
                                    })
                                }),
                                children
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
                            size: "lg",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6c25b6e6adc0f09$export$c4a6d8fea738bc2c), {}),
                                title && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                    order: 2,
                                    mb: "md",
                                    children: title
                                }),
                                children
                            ]
                        })
                    }),
                    showFooter && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62be13b144ef278d$export$82bcc3e60bea3c1a), {})
                ]
            })
        ]
    });
}


function $8bf45bbb8e4e2260$var$formatPaymentSummary(u) {
    return [
        u.PaymentId,
        u.PaymentAmount,
        u.PaymentCurrency
    ].filter((v)=>v !== undefined && v !== null && v !== "").join(" ");
}
function $8bf45bbb8e4e2260$var$UsersTab({ users: users, onToggleBought: onToggleBought, toggleBoughtPending: toggleBoughtPending, onToggleAdmin: onToggleAdmin, toggleAdminPending: toggleAdminPending }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const currentUser = (0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)();
    const sortedUsers = $acw62.useMemo(()=>[
            ...users
        ].sort((a, b)=>{
            const timeA = a.Timestamp ? new Date(a.Timestamp).getTime() : 0;
            const timeB = b.Timestamp ? new Date(b.Timestamp).getTime() : 0;
            return timeB - timeA;
        }), [
        users
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).ScrollContainer, {
        minWidth: 900,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Thead, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tr, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "User"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "Registration"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "License"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                style: {
                                    maxWidth: 120
                                },
                                children: "Payment"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "Payment method"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                w: 40
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tbody, {
                    children: sortedUsers.map((u)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tr, {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                        gap: "xs",
                                        wrap: "wrap",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                span: true,
                                                size: "sm",
                                                children: u.Email || u.Name
                                            }),
                                            u.EmailConfirmed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b24692670674b261$export$37acb3580601e69a), {
                                                color: "green",
                                                variant: "light",
                                                size: "sm",
                                                children: "Confirmed"
                                            }),
                                            u.IsAdmin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b24692670674b261$export$37acb3580601e69a), {
                                                color: "blue",
                                                variant: "light",
                                                size: "sm",
                                                children: "Admin"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: u.Timestamp ? new Date(u.Timestamp).toLocaleString() : ""
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: u.Bought ? "\u2713" : "\u2717"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    style: {
                                        maxWidth: 120
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                        truncate: "end",
                                        size: "sm",
                                        title: $8bf45bbb8e4e2260$var$formatPaymentSummary(u),
                                        children: $8bf45bbb8e4e2260$var$formatPaymentSummary(u)
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: u.PaymentMethod
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $80a28427109ce9ef$export$d9b273488cd8ce6f), {
                                        shadow: "md",
                                        width: 240,
                                        position: "bottom-end",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80a28427109ce9ef$export$d9b273488cd8ce6f).Target, {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eeb3c9a10486755$export$c8e5c1392561c508), {
                                                    variant: "subtle",
                                                    color: "gray",
                                                    "aria-label": "User actions",
                                                    loading: toggleBoughtPending || toggleAdminPending,
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc48fe382c89157e$export$2e2bcd8739ae039), {
                                                        size: 16
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $80a28427109ce9ef$export$d9b273488cd8ce6f).Dropdown, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80a28427109ce9ef$export$d9b273488cd8ce6f).Item, {
                                                        disabled: u.UserId !== currentUser?.UserId,
                                                        onClick: onToggleBought,
                                                        children: "Toggle Bought (cancels sub)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80a28427109ce9ef$export$d9b273488cd8ce6f).Item, {
                                                        onClick: ()=>onToggleAdmin(u.UserId),
                                                        children: t("admin.toggleAdmin")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, u.UserId))
                })
            ]
        })
    });
}
function $8bf45bbb8e4e2260$var$DistributorsTab({ distributors: distributors, onAuthorize: onAuthorize, authorizePending: authorizePending }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).ScrollContainer, {
        minWidth: 800,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Thead, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tr, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "UserId"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "Company"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "Available"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "Bought"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "Authorized"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tbody, {
                    children: distributors.map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tr, {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: d.CloudUser?.UserId
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: d.CloudUser?.Email
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: d.DistributorInfo.CompanyName
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: d.AvailableLicenses
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: d.LicensesBought
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: d.DistributorInfo.DistribuidorAutorizado ? "\u2713" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                        size: "xs",
                                        loading: authorizePending,
                                        onClick: ()=>onAuthorize(d.CloudUser?.UserId || d.DistributorInfo.RowKey),
                                        children: t("admin.authorize")
                                    })
                                })
                            ]
                        }, d.DistributorInfo.RowKey))
                })
            ]
        })
    });
}
function $8bf45bbb8e4e2260$var$PaymentsTab({ payments: payments, distributors: distributors, users: users }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).ScrollContainer, {
        minWidth: 800,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Thead, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tr, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "UserId"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "PaymentId"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "Date"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "Amount"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "Licenses"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tbody, {
                    children: payments.map((p)=>{
                        const email = distributors.find((d)=>d.DistributorInfo.RowKey === p.PartitionKey || d.CloudUser?.UserId === p.PartitionKey)?.CloudUser?.Email || users.find((u)=>u.UserId === p.PartitionKey)?.Email;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tr, {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: p.PartitionKey
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: email
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: p.PaymentId
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: new Date(p.PaymentDate).toLocaleString()
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: [
                                        p.PaymentAmount,
                                        " ",
                                        p.PaymentCurrency
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: p.LicenseCount
                                })
                            ]
                        }, p.PaymentId);
                    })
                })
            ]
        })
    });
}
function $8bf45bbb8e4e2260$var$DemoDownloadersTab({ demoDownloaders: demoDownloaders }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).ScrollContainer, {
        minWidth: 400,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Thead, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tr, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "Time"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                children: "Email"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tbody, {
                    children: demoDownloaders.map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tr, {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: d.DownloadedAtUtc ? new Date(d.DownloadedAtUtc).toLocaleString() : ""
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                    children: d.Email
                                })
                            ]
                        }, d.RowKey))
                })
            ]
        })
    });
}
function $8bf45bbb8e4e2260$var$TabLabel({ label: label, count: count }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
        gap: "xs",
        wrap: "nowrap",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b24692670674b261$export$37acb3580601e69a), {
                size: "sm",
                variant: "light",
                circle: true,
                children: count
            })
        ]
    });
}
function $8bf45bbb8e4e2260$export$b25f57c16f88d7e0() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const { data: data, isPending: isPending, isError: isError } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: (0, $0fb2b9595b8b3089$export$e531c43d2585d3d6).admin,
        queryFn: ()=>(0, $0fb2b9595b8b3089$export$1f53e240b076325b).getAdminInfo()
    });
    const authorizeMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: (userId)=>(0, $0fb2b9595b8b3089$export$1f53e240b076325b).authorizeDistributor(userId),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: (0, $0fb2b9595b8b3089$export$e531c43d2585d3d6).admin
            });
        }
    });
    const toggleBoughtMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $0fb2b9595b8b3089$export$1f53e240b076325b).toggleBought(),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: (0, $0fb2b9595b8b3089$export$e531c43d2585d3d6).admin
            });
        }
    });
    const toggleAdminMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: (userId)=>(0, $0fb2b9595b8b3089$export$1f53e240b076325b).toggleAdmin(userId),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: (0, $0fb2b9595b8b3089$export$e531c43d2585d3d6).admin
            });
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: t("admin.title"),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "lg",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                    gap: "md",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                            component: "a",
                            href: "https://portal.azure.com/#@ecaservidordincloudoutlook.onmicrosoft.com/dashboard/arm/subscriptions/94f79f8f-9726-41b8-9ae4-bf378e5854d2/resourcegroups/dashboards/providers/microsoft.portal/dashboards/7c570d6f-79f7-43bb-b2d8-ca76fdc6e51e",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            variant: "light",
                            children: t("admin.dataLink")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                            component: "a",
                            href: "https://portal.azure.com/#@ecaservidordincloudoutlook.onmicrosoft.com/resource/subscriptions/94f79f8f-9726-41b8-9ae4-bf378e5854d2/resourceGroups/DinLabel/providers/microsoft.insights/components/dinlabel/overview",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            variant: "light",
                            children: t("admin.serverAnalyticsLink")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                            to: "/admin/fakeemail",
                            variant: "light",
                            children: t("admin.fakeEmailLink")
                        })
                    ]
                }),
                isError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    c: "red",
                    children: t("admin.loadError")
                }),
                isPending && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    children: t("admin.loading")
                }),
                data && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            children: [
                                t("admin.totalUsers", {
                                    count: data.users.length
                                }),
                                " \u2014",
                                " ",
                                t("admin.paidUsers", {
                                    count: data.users.filter((u)=>u.Bought).length
                                }),
                                " ",
                                "\u2014",
                                " ",
                                t("admin.totalSubscribedUsers", {
                                    count: data.totalSubscribedUsers
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c45c38e75a424966$export$b2539bed5023c21c), {
                            defaultValue: "users",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c45c38e75a424966$export$b2539bed5023c21c).List, {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c45c38e75a424966$export$b2539bed5023c21c).Tab, {
                                            value: "users",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8bf45bbb8e4e2260$var$TabLabel, {
                                                label: t("admin.users"),
                                                count: data.users.length
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c45c38e75a424966$export$b2539bed5023c21c).Tab, {
                                            value: "distributors",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8bf45bbb8e4e2260$var$TabLabel, {
                                                label: t("admin.distributors"),
                                                count: data.distributors.length
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c45c38e75a424966$export$b2539bed5023c21c).Tab, {
                                            value: "payments",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8bf45bbb8e4e2260$var$TabLabel, {
                                                label: t("admin.payments"),
                                                count: data.distributorPayments.length
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c45c38e75a424966$export$b2539bed5023c21c).Tab, {
                                            value: "demoDownloaders",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8bf45bbb8e4e2260$var$TabLabel, {
                                                label: t("admin.demoDownloaders"),
                                                count: data.demoDownloaders.length
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c45c38e75a424966$export$b2539bed5023c21c).Panel, {
                                    value: "users",
                                    pt: "md",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8bf45bbb8e4e2260$var$UsersTab, {
                                        users: data.users,
                                        onToggleBought: ()=>toggleBoughtMutation.mutate(),
                                        toggleBoughtPending: toggleBoughtMutation.isPending,
                                        onToggleAdmin: (userId)=>toggleAdminMutation.mutate(userId),
                                        toggleAdminPending: toggleAdminMutation.isPending
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c45c38e75a424966$export$b2539bed5023c21c).Panel, {
                                    value: "distributors",
                                    pt: "md",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8bf45bbb8e4e2260$var$DistributorsTab, {
                                        distributors: data.distributors,
                                        onAuthorize: (userId)=>authorizeMutation.mutate(userId),
                                        authorizePending: authorizeMutation.isPending
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c45c38e75a424966$export$b2539bed5023c21c).Panel, {
                                    value: "payments",
                                    pt: "md",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8bf45bbb8e4e2260$var$PaymentsTab, {
                                        payments: data.distributorPayments,
                                        distributors: data.distributors,
                                        users: data.users
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c45c38e75a424966$export$b2539bed5023c21c).Panel, {
                                    value: "demoDownloaders",
                                    pt: "md",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8bf45bbb8e4e2260$var$DemoDownloadersTab, {
                                        demoDownloaders: data.demoDownloaders
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}










"use client";
//#region packages/@mantine/core/src/components/Grid/Grid.context.ts
const [$0ff4ad182075de8a$export$c4bf645ed2cecfdd, $0ff4ad182075de8a$export$55324094c969badb] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("Grid component was not found in tree");


"use client";
//#region packages/@mantine/core/src/components/Grid/Grid.module.css
var $fef2b57da7d60f04$export$2e2bcd8739ae039 = {
    "container": "m_8478a6da",
    "root": "m_410352e9",
    "inner": "m_dee7bd2f",
    "col": "m_96bdd299"
};










"use client";
//#region packages/@mantine/core/src/core/utils/get-base-value/get-base-value.ts
function $6bb9b48dd0676e4d$export$82ef48a36e8cf480(value) {
    if (typeof value === "object" && value !== null) {
        if ("base" in value) return value.base;
        return;
    }
    return value;
}






"use client";
//#region packages/@mantine/core/src/components/Grid/GridCol/GridColVariables.tsx
const $c97ca4179187fed9$var$getColumnFlexBasis = (colSpan, columns)=>{
    if (colSpan === "content") return "auto";
    if (colSpan === "auto") return "0rem";
    if (!colSpan) return;
    if (colSpan === columns) return "100%";
    return `calc(${100 * colSpan / columns}% - ${(columns - colSpan) / columns} * var(--grid-column-gap))`;
};
const $c97ca4179187fed9$var$getColumnMaxWidth = (colSpan, columns, grow)=>{
    if (grow || colSpan === "auto") return "100%";
    if (colSpan === "content") return "unset";
    return $c97ca4179187fed9$var$getColumnFlexBasis(colSpan, columns);
};
const $c97ca4179187fed9$var$getColumnFlexGrow = (colSpan, grow)=>{
    if (!colSpan) return;
    return colSpan === "auto" || grow ? "1" : "auto";
};
const $c97ca4179187fed9$var$getColumnOffset = (offset, columns)=>{
    if (offset === 0) return "0";
    if (!offset) return;
    return `calc(${100 * offset / columns}% + ${offset / columns} * var(--grid-column-gap))`;
};
function $c97ca4179187fed9$export$e50f0a39db3e65c0({ span: span, order: order, offset: offset, align: align, selector: selector }) {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const ctx = (0, $0ff4ad182075de8a$export$55324094c969badb)();
    const _breakpoints = ctx.breakpoints || theme.breakpoints;
    const baseValue = (0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(span);
    const baseSpan = baseValue === void 0 ? 12 : baseValue;
    const baseStyles = (0, $3fdf1c4abf64babc$export$d697c39a2985a4c)({
        "--col-order": (0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(order)?.toString(),
        "--col-flex-grow": $c97ca4179187fed9$var$getColumnFlexGrow(baseSpan, ctx.grow),
        "--col-flex-basis": $c97ca4179187fed9$var$getColumnFlexBasis(baseSpan, ctx.columns),
        "--col-width": baseSpan === "content" ? "auto" : void 0,
        "--col-max-width": $c97ca4179187fed9$var$getColumnMaxWidth(baseSpan, ctx.columns, ctx.grow),
        "--col-offset": $c97ca4179187fed9$var$getColumnOffset((0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(offset), ctx.columns),
        "--col-align-self": (0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(align)
    });
    const queries = (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(_breakpoints).reduce((acc, breakpoint)=>{
        if (!acc[breakpoint]) acc[breakpoint] = {};
        if (typeof order === "object" && order[breakpoint] !== void 0) acc[breakpoint]["--col-order"] = order[breakpoint]?.toString();
        if (typeof span === "object" && span[breakpoint] !== void 0) {
            acc[breakpoint]["--col-flex-grow"] = $c97ca4179187fed9$var$getColumnFlexGrow(span[breakpoint], ctx.grow);
            acc[breakpoint]["--col-flex-basis"] = $c97ca4179187fed9$var$getColumnFlexBasis(span[breakpoint], ctx.columns);
            acc[breakpoint]["--col-width"] = span[breakpoint] === "content" ? "auto" : void 0;
            acc[breakpoint]["--col-max-width"] = $c97ca4179187fed9$var$getColumnMaxWidth(span[breakpoint], ctx.columns, ctx.grow);
        }
        if (typeof offset === "object" && offset[breakpoint] !== void 0) acc[breakpoint]["--col-offset"] = $c97ca4179187fed9$var$getColumnOffset(offset[breakpoint], ctx.columns);
        if (typeof align === "object" && align[breakpoint] !== void 0) acc[breakpoint]["--col-align-self"] = align[breakpoint];
        return acc;
    }, {});
    const values = (0, $e4e164d3d352ee58$export$bd80382e31449c0e)((0, $76cd5f02de8ee394$export$ed97f33186d4b816)(queries), _breakpoints).filter((breakpoint)=>(0, $76cd5f02de8ee394$export$ed97f33186d4b816)(queries[breakpoint.value]).length > 0).map((breakpoint)=>({
            query: ctx.type === "container" ? `mantine-grid (min-width: ${_breakpoints[breakpoint.value]})` : `(min-width: ${_breakpoints[breakpoint.value]})`,
            styles: queries[breakpoint.value]
        }));
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e221d2b030e78e40$export$6b8bda124c097cf0), {
        styles: baseStyles,
        media: ctx.type === "container" ? void 0 : values,
        container: ctx.type === "container" ? values : void 0,
        selector: selector
    });
}





"use client";
//#region packages/@mantine/core/src/components/Grid/GridCol/GridCol.tsx
const $28c94b8f6d7238bc$var$defaultProps = {
    span: 12
};
const $28c94b8f6d7238bc$export$1b5689fc8adf2f5e = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, span: span, order: order, offset: offset, align: align, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("GridCol", $28c94b8f6d7238bc$var$defaultProps, _props);
    const ctx = (0, $0ff4ad182075de8a$export$55324094c969badb)();
    const responsiveClassName = (0, $6f7b5997f3c2d4f0$export$27120f2982e012b1)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c97ca4179187fed9$export$e50f0a39db3e65c0), {
                selector: `.${responsiveClassName}`,
                span: span,
                order: order,
                offset: offset,
                align: align
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                ...ctx.getStyles("col", {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(className, responsiveClassName),
                    style: style,
                    classNames: classNames,
                    styles: styles
                }),
                ...others
            })
        ]
    });
});
$28c94b8f6d7238bc$export$1b5689fc8adf2f5e.classes = (0, $fef2b57da7d60f04$export$2e2bcd8739ae039);
$28c94b8f6d7238bc$export$1b5689fc8adf2f5e.displayName = "@mantine/core/GridCol";










"use client";
//#region packages/@mantine/core/src/components/Grid/GridVariables.tsx
function $9bc5dca4841af99a$export$5db66c1bb4a02574({ gap: gap, rowGap: rowGap, columnGap: columnGap, selector: selector, breakpoints: breakpoints, type: type }) {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const _breakpoints = breakpoints || theme.breakpoints;
    const baseStyles = (0, $3fdf1c4abf64babc$export$d697c39a2985a4c)({
        "--grid-gap": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)((0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(gap)),
        "--grid-row-gap": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)((0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(rowGap)),
        "--grid-column-gap": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)((0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(columnGap))
    });
    const queries = (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(_breakpoints).reduce((acc, breakpoint)=>{
        if (!acc[breakpoint]) acc[breakpoint] = {};
        if (typeof gap === "object" && gap[breakpoint] !== void 0) acc[breakpoint]["--grid-gap"] = (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(gap[breakpoint]);
        if (typeof rowGap === "object" && rowGap[breakpoint] !== void 0) acc[breakpoint]["--grid-row-gap"] = (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(rowGap[breakpoint]);
        if (typeof columnGap === "object" && columnGap[breakpoint] !== void 0) acc[breakpoint]["--grid-column-gap"] = (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(columnGap[breakpoint]);
        return acc;
    }, {});
    const values = (0, $e4e164d3d352ee58$export$bd80382e31449c0e)((0, $76cd5f02de8ee394$export$ed97f33186d4b816)(queries), _breakpoints).filter((breakpoint)=>(0, $76cd5f02de8ee394$export$ed97f33186d4b816)(queries[breakpoint.value]).length > 0).map((breakpoint)=>({
            query: type === "container" ? `mantine-grid (min-width: ${_breakpoints[breakpoint.value]})` : `(min-width: ${_breakpoints[breakpoint.value]})`,
            styles: queries[breakpoint.value]
        }));
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e221d2b030e78e40$export$6b8bda124c097cf0), {
        styles: baseStyles,
        media: type === "container" ? void 0 : values,
        container: type === "container" ? values : void 0,
        selector: selector
    });
}



"use client";
//#region packages/@mantine/core/src/components/Grid/Grid.tsx
const $a599d521a2ea6dcd$var$defaultProps = {
    gap: "md",
    columns: 12
};
const $a599d521a2ea6dcd$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { justify: justify, align: align, overflow: overflow })=>({
        root: {
            "--grid-justify": justify,
            "--grid-align": align,
            "--grid-overflow": overflow
        }
    }));
const $a599d521a2ea6dcd$export$ef2184bd89960b14 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Grid", $a599d521a2ea6dcd$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, grow: grow, gap: gap, rowGap: rowGap, columnGap: columnGap, columns: columns, align: align, justify: justify, children: children, breakpoints: breakpoints, type: type, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Grid",
        classes: (0, $fef2b57da7d60f04$export$2e2bcd8739ae039),
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $a599d521a2ea6dcd$var$varsResolver
    });
    const responsiveClassName = (0, $6f7b5997f3c2d4f0$export$27120f2982e012b1)();
    if (type === "container" && breakpoints) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $0ff4ad182075de8a$export$c4bf645ed2cecfdd), {
        value: {
            getStyles: getStyles,
            grow: grow,
            columns: columns,
            breakpoints: breakpoints,
            type: type
        },
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9bc5dca4841af99a$export$5db66c1bb4a02574), {
                selector: `.${responsiveClassName}`,
                ...props
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...getStyles("container"),
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                    ...getStyles("root", {
                        className: responsiveClassName
                    }),
                    ...others,
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                        ...getStyles("inner"),
                        children: children
                    })
                })
            })
        ]
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $0ff4ad182075de8a$export$c4bf645ed2cecfdd), {
        value: {
            getStyles: getStyles,
            grow: grow,
            columns: columns,
            breakpoints: breakpoints,
            type: type
        },
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9bc5dca4841af99a$export$5db66c1bb4a02574), {
                selector: `.${responsiveClassName}`,
                ...props
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                ...getStyles("root", {
                    className: responsiveClassName
                }),
                ...others,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    ...getStyles("inner"),
                    children: children
                })
            })
        ]
    });
});
$a599d521a2ea6dcd$export$ef2184bd89960b14.classes = (0, $fef2b57da7d60f04$export$2e2bcd8739ae039);
$a599d521a2ea6dcd$export$ef2184bd89960b14.varsResolver = $a599d521a2ea6dcd$var$varsResolver;
$a599d521a2ea6dcd$export$ef2184bd89960b14.displayName = "@mantine/core/Grid";
$a599d521a2ea6dcd$export$ef2184bd89960b14.Col = (0, $28c94b8f6d7238bc$export$1b5689fc8adf2f5e);
















"use client";
//#region packages/@mantine/core/src/components/SimpleGrid/SimpleGridVariables.tsx
function $b9b1fda19a1e53ae$var$getMinColWidthValue(value) {
    if (value === void 0) return;
    if (typeof value === "number") return (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(value);
    return value;
}
function $b9b1fda19a1e53ae$export$83741610a85b4376({ spacing: spacing, verticalSpacing: verticalSpacing, cols: cols, minColWidth: minColWidth, autoRows: autoRows, selector: selector }) {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const _verticalSpacing = verticalSpacing === void 0 ? spacing : verticalSpacing;
    const useAutoColumns = minColWidth !== void 0;
    const baseStyles = (0, $3fdf1c4abf64babc$export$d697c39a2985a4c)({
        "--sg-spacing-x": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)((0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(spacing)),
        "--sg-spacing-y": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)((0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(_verticalSpacing)),
        "--sg-auto-rows": autoRows,
        ...useAutoColumns ? {
            "--sg-min-col-width": $b9b1fda19a1e53ae$var$getMinColWidthValue(minColWidth)
        } : {
            "--sg-cols": (0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(cols)?.toString()
        }
    });
    const queries = (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(theme.breakpoints).reduce((acc, breakpoint)=>{
        if (!acc[breakpoint]) acc[breakpoint] = {};
        if (typeof spacing === "object" && spacing[breakpoint] !== void 0) acc[breakpoint]["--sg-spacing-x"] = (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(spacing[breakpoint]);
        if (typeof _verticalSpacing === "object" && _verticalSpacing[breakpoint] !== void 0) acc[breakpoint]["--sg-spacing-y"] = (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(_verticalSpacing[breakpoint]);
        if (!useAutoColumns && typeof cols === "object" && cols[breakpoint] !== void 0) acc[breakpoint]["--sg-cols"] = cols[breakpoint];
        return acc;
    }, {});
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e221d2b030e78e40$export$6b8bda124c097cf0), {
        styles: baseStyles,
        media: (0, $e4e164d3d352ee58$export$bd80382e31449c0e)((0, $76cd5f02de8ee394$export$ed97f33186d4b816)(queries), theme.breakpoints).filter((breakpoint)=>(0, $76cd5f02de8ee394$export$ed97f33186d4b816)(queries[breakpoint.value]).length > 0).map((breakpoint)=>({
                query: `(min-width: ${theme.breakpoints[breakpoint.value]})`,
                styles: queries[breakpoint.value]
            })),
        selector: selector
    });
}
function $b9b1fda19a1e53ae$var$getBreakpoints(values) {
    if (typeof values === "object" && values !== null) return (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(values);
    return [];
}
function $b9b1fda19a1e53ae$var$sortBreakpoints(breakpoints) {
    return breakpoints.sort((a, b)=>(0, $36050ce217b59930$export$91c0eda1d06bf008)(a) - (0, $36050ce217b59930$export$91c0eda1d06bf008)(b));
}
function $b9b1fda19a1e53ae$var$getUniqueBreakpoints({ spacing: spacing, verticalSpacing: verticalSpacing, cols: cols, minColWidth: minColWidth }) {
    return $b9b1fda19a1e53ae$var$sortBreakpoints(Array.from(new Set([
        ...$b9b1fda19a1e53ae$var$getBreakpoints(spacing),
        ...$b9b1fda19a1e53ae$var$getBreakpoints(verticalSpacing),
        ...minColWidth !== void 0 ? [] : $b9b1fda19a1e53ae$var$getBreakpoints(cols)
    ])));
}
function $b9b1fda19a1e53ae$export$f89d950c036486a9({ spacing: spacing, verticalSpacing: verticalSpacing, cols: cols, minColWidth: minColWidth, autoRows: autoRows, selector: selector }) {
    const _verticalSpacing = verticalSpacing === void 0 ? spacing : verticalSpacing;
    const useAutoColumns = minColWidth !== void 0;
    const baseStyles = (0, $3fdf1c4abf64babc$export$d697c39a2985a4c)({
        "--sg-spacing-x": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)((0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(spacing)),
        "--sg-spacing-y": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)((0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(_verticalSpacing)),
        "--sg-auto-rows": autoRows,
        ...useAutoColumns ? {
            "--sg-min-col-width": $b9b1fda19a1e53ae$var$getMinColWidthValue(minColWidth)
        } : {
            "--sg-cols": (0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(cols)?.toString()
        }
    });
    const uniqueBreakpoints = $b9b1fda19a1e53ae$var$getUniqueBreakpoints({
        spacing: spacing,
        verticalSpacing: verticalSpacing,
        cols: cols,
        minColWidth: minColWidth
    });
    const queries = uniqueBreakpoints.reduce((acc, breakpoint)=>{
        if (!acc[breakpoint]) acc[breakpoint] = {};
        if (typeof spacing === "object" && spacing[breakpoint] !== void 0) acc[breakpoint]["--sg-spacing-x"] = (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(spacing[breakpoint]);
        if (typeof _verticalSpacing === "object" && _verticalSpacing[breakpoint] !== void 0) acc[breakpoint]["--sg-spacing-y"] = (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(_verticalSpacing[breakpoint]);
        if (!useAutoColumns && typeof cols === "object" && cols[breakpoint] !== void 0) acc[breakpoint]["--sg-cols"] = cols[breakpoint];
        return acc;
    }, {});
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e221d2b030e78e40$export$6b8bda124c097cf0), {
        styles: baseStyles,
        container: uniqueBreakpoints.map((breakpoint)=>({
                query: `simple-grid (min-width: ${breakpoint})`,
                styles: queries[breakpoint]
            })),
        selector: selector
    });
}


"use client";
//#region packages/@mantine/core/src/components/SimpleGrid/SimpleGrid.module.css
var $653a93786d3cfe08$export$2e2bcd8739ae039 = {
    "container": "m_925c2d2c",
    "root": "m_2415a157"
};



"use client";
//#region packages/@mantine/core/src/components/SimpleGrid/SimpleGrid.tsx
const $79fda614df4f4d2c$var$defaultProps = {
    cols: 1,
    spacing: "md",
    type: "media"
};
const $79fda614df4f4d2c$export$de97fecb6d4b30a5 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("SimpleGrid", $79fda614df4f4d2c$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, cols: cols, verticalSpacing: verticalSpacing, spacing: spacing, type: type, minColWidth: minColWidth, autoFlow: autoFlow, autoRows: autoRows, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "SimpleGrid",
        classes: (0, $653a93786d3cfe08$export$2e2bcd8739ae039),
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars
    });
    const responsiveClassName = (0, $6f7b5997f3c2d4f0$export$27120f2982e012b1)();
    const autoColsAttr = minColWidth !== void 0 ? autoFlow || "auto-fill" : void 0;
    if (type === "container") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b9b1fda19a1e53ae$export$f89d950c036486a9), {
                ...props,
                selector: `.${responsiveClassName}`
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...getStyles("container"),
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                    ...getStyles("root", {
                        className: responsiveClassName
                    }),
                    ...others,
                    "data-auto-cols": autoColsAttr
                })
            })
        ]
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b9b1fda19a1e53ae$export$83741610a85b4376), {
                ...props,
                selector: `.${responsiveClassName}`
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                ...getStyles("root", {
                    className: responsiveClassName
                }),
                ...others,
                "data-auto-cols": autoColsAttr
            })
        ]
    });
});
$79fda614df4f4d2c$export$de97fecb6d4b30a5.classes = (0, $653a93786d3cfe08$export$2e2bcd8739ae039);
$79fda614df4f4d2c$export$de97fecb6d4b30a5.displayName = "@mantine/core/SimpleGrid";


parcelRequire("acw62");


const $c100e0ce118e7023$export$9eb486a81d953462 = [
    "UpcA",
    "UpcE",
    "Ean13",
    "Ean8",
    "Code128",
    "GS1128",
    "Code39",
    "Interleaved2of5",
    "Itf14",
    "QRCode",
    "DataMatrix",
    "Pdf417"
];
const $c100e0ce118e7023$export$dbc8b3c24509e65b = [
    "Codabar",
    "Code11",
    "Code16k",
    "Code39",
    "Code93",
    "Code128",
    "DataMatrix",
    "Ean8",
    "Ean13",
    "Industrial2of5",
    "Interleaved2of5",
    "Isbn",
    "Msi",
    "Pdf417",
    "Planet",
    "Postnet",
    "UccEan128",
    "UpcA",
    "UpcE",
    "UspsOneCode4CB",
    "RoyalMail",
    "AustraliaPost",
    "RoyalTpgPostKix",
    "Sscc18",
    "Pzn",
    "DeutschePostLeitcode",
    "DeutschePostIdentcode",
    "UspsTrayLabel",
    "UspsSackLabel",
    "EanVelocity",
    "SingaporePost",
    "Jan8",
    "Jan13",
    "SwissPostParcel",
    "Opc",
    "Ean99",
    "Itf14",
    "Scc14",
    "Issn",
    "Ismn",
    "NumlyNumber",
    "QRCode",
    "UspsFim",
    "UspsHorizontalBars",
    "Telepen",
    "Pharmacode",
    "Semacode",
    "Code32",
    "UspsPicUccEan128",
    "FedExGround96",
    "AztecCode",
    "CompactPdf417",
    "MacroPdf417",
    "MicroPdf417",
    "VicsBol",
    "VicsScacPro",
    "ItalianPost25",
    "Isbt128",
    "HibcLic39",
    "HibcLic128",
    "HibcPas39",
    "HibcPas128",
    "UspsIntelligentMail",
    "EanUpcAddOn2",
    "EanUpcAddOn5",
    "UspsPicCode128",
    "GS1DataBarOmnidirectional",
    "GS1DataBar14",
    "Rss14",
    "GS1DataBarTruncated",
    "GS1DataBar14Truncated",
    "Rss14Truncated",
    "GS1DataBarStacked",
    "GS1DataBar14Stacked",
    "Rss14Stacked",
    "GS1DataBarStackedOmnidirectional",
    "GS1DataBar14StackedOmnidirectional",
    "Rss14StackedOmnidirectional",
    "GS1DataBarLimited",
    "RssLimited",
    "GS1DataBarExpanded",
    "RssExpanded",
    "GS1DataBarExpandedStacked",
    "RssExpandedStacked",
    "GS1128",
    "MaxiCode",
    "MicroQRCode",
    "Matrix2of5",
    "DanishPostal39",
    "FrenchPostal39AR",
    "IATA2of5",
    "AustraliaPostDomesticEParcelBarcode",
    "UspsIntelligentMailContainerBarcode",
    "KodakPatchCode",
    "GS1DataMatrix",
    "Ean13CCA",
    "Ean13CCB",
    "Ean8CCA",
    "Ean8CCB",
    "UpcACCA",
    "UpcACCB",
    "UpcECCA",
    "UpcECCB",
    "UccEan128CCA",
    "UccEan128CCB",
    "UccEan128CCC",
    "GS1128CCA",
    "GS1128CCB",
    "GS1128CCC",
    "GS1DataBarOmnidirectionalCCA",
    "GS1DataBar14CCA",
    "Rss14CCA",
    "GS1DataBarOmnidirectionalCCB",
    "GS1DataBar14CCB",
    "Rss14CCB",
    "GS1DataBarTruncatedCCA",
    "GS1DataBar14TruncatedCCA",
    "Rss14TruncatedCCA",
    "GS1DataBarTruncatedCCB",
    "GS1DataBar14TruncatedCCB",
    "Rss14TruncatedCCB",
    "GS1DataBarLimitedCCA",
    "RssLimitedCCA",
    "GS1DataBarLimitedCCB",
    "RssLimitedCCB",
    "GS1DataBarStackedCCA",
    "GS1DataBar14StackedCCA",
    "Rss14StackedCCA",
    "GS1DataBarStackedCCB",
    "GS1DataBar14StackedCCB",
    "Rss14StackedCCB",
    "GS1DataBarStackedOmnidirectionalCCA",
    "GS1DataBar14StackedOmnidirectionalCCA",
    "Rss14StackedOmnidirectionalCCA",
    "GS1DataBarStackedOmnidirectionalCCB",
    "GS1DataBar14StackedOmnidirectionalCCB",
    "Rss14StackedOmnidirectionalCCB",
    "GS1DataBarExpandedCCA",
    "RssExpandedCCA",
    "GS1DataBarExpandedCCB",
    "RssExpandedCCB",
    "GS1DataBarExpandedStackedCCA",
    "RssExpandedStackedCCA",
    "GS1DataBarExpandedStackedCCB",
    "RssExpandedStackedCCB",
    "MICRE13B",
    "Ean14",
    "Dun14Itf",
    "Dun14Ean",
    "GS1QRCode",
    "Ppn",
    "IFAsecurPharm",
    "DhlAwb",
    "HibcLicDataMatrix",
    "HibcLicQRCode",
    "HibcLicAztecCode",
    "HibcPasDataMatrix",
    "HibcPasQRCode",
    "HibcPasAztecCode",
    "Isbt128DataMatrix",
    "DeutschePostResponsePlusPostMatrix",
    "DeutschePostBzl",
    "UspsIntelligentMailPackageBarcode",
    "HanXinCode"
];
function $c100e0ce118e7023$export$a469c8dc04b79733(name) {
    return $c100e0ce118e7023$export$9eb486a81d953462.includes(name);
}



const $0720716f6e7eda54$var$cardStyle = {
    background: "white",
    border: "1px solid var(--mantine-color-gray-2)",
    borderRadius: "var(--mantine-radius-md)",
    boxShadow: "0 8px 32px rgba(44, 45, 48, 0.06)",
    height: "100%"
};
function $0720716f6e7eda54$var$commonNameKey(id) {
    return `barcodes.common.${id}.name`;
}
function $0720716f6e7eda54$var$commonDescriptionKey(id) {
    return `barcodes.common.${id}.description`;
}
function $0720716f6e7eda54$export$fe3d061d3c12034() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        fullBleed: true,
        showFooter: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
            style: {
                background: "linear-gradient(160deg, #fff8f2 0%, #ffffff 40%, #fff4eb 100%)"
            },
            py: {
                base: "xl",
                md: 48
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
                size: "lg",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                    gap: "xl",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                            gap: "sm",
                            maw: 720,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                    order: 1,
                                    c: "charcoal.8",
                                    children: t("barcodes.title")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                    c: "dimmed",
                                    size: "lg",
                                    children: t("barcodes.intro")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                    gap: "sm",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                            to: "/install",
                                            color: "brand",
                                            children: t("barcodes.ctaInstall")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                            to: "/tutorials#tutorial7",
                                            variant: "default",
                                            children: t("barcodes.ctaTutorials")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                            gap: "md",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                            order: 2,
                                            c: "charcoal.8",
                                            children: t("barcodes.commonTitle")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                            c: "dimmed",
                                            mt: 6,
                                            children: t("barcodes.commonIntro")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14), {
                                    children: (0, $c100e0ce118e7023$export$9eb486a81d953462).map((id)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14).Col, {
                                            span: {
                                                base: 12,
                                                sm: 6,
                                                md: 4
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                                gap: 6,
                                                p: "lg",
                                                style: $0720716f6e7eda54$var$cardStyle,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                        fw: 700,
                                                        c: "charcoal.8",
                                                        children: t($0720716f6e7eda54$var$commonNameKey(id))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                        size: "sm",
                                                        c: "dimmed",
                                                        children: t($0720716f6e7eda54$var$commonDescriptionKey(id))
                                                    })
                                                ]
                                            })
                                        }, id))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                            gap: "md",
                            id: "all-types",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                            order: 2,
                                            c: "charcoal.8",
                                            children: t("barcodes.fullTitle")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                            c: "dimmed",
                                            mt: 6,
                                            children: t("barcodes.fullIntro")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                                    p: "lg",
                                    style: $0720716f6e7eda54$var$cardStyle,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79fda614df4f4d2c$export$de97fecb6d4b30a5), {
                                        cols: {
                                            base: 1,
                                            sm: 2,
                                            md: 3
                                        },
                                        spacing: "xs",
                                        children: (0, $c100e0ce118e7023$export$dbc8b3c24509e65b).map((name)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                size: "sm",
                                                fw: (0, $c100e0ce118e7023$export$a469c8dc04b79733)(name) ? 700 : 400,
                                                c: "charcoal.7",
                                                children: name
                                            }, name))
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                    size: "sm",
                                    c: "dimmed",
                                    children: [
                                        t("barcodes.fullCount", {
                                            count: (0, $c100e0ce118e7023$export$dbc8b3c24509e65b).length
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                            to: "/install",
                                            children: t("barcodes.ctaInstall")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}





var $acw62 = parcelRequire("acw62");












"use client";
//#region packages/@mantine/core/src/components/Divider/Divider.module.css
var $d1f6d31363b1dd33$export$2e2bcd8739ae039 = {
    "root": "m_3eebeb36",
    "label": "m_9e365f20"
};



"use client";
//#region packages/@mantine/core/src/components/Divider/Divider.tsx
const $8a00b9f352798fdd$var$defaultProps = {
    orientation: "horizontal"
};
const $8a00b9f352798fdd$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { color: color, variant: variant, size: size })=>({
        root: {
            "--divider-color": color ? (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(color, theme) : void 0,
            "--divider-border-style": variant,
            "--divider-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "divider-size")
        }
    }));
const $8a00b9f352798fdd$export$2e0a83ec2e27ecbb = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Divider", $8a00b9f352798fdd$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, color: color, orientation: orientation, label: label, labelPosition: labelPosition, mod: mod, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Divider",
        classes: (0, $d1f6d31363b1dd33$export$2e2bcd8739ae039),
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $8a00b9f352798fdd$var$varsResolver
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        mod: [
            {
                orientation: orientation,
                withLabel: !!label
            },
            mod
        ],
        role: "separator",
        ...getStyles("root"),
        ...others,
        children: label && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
            component: "span",
            mod: {
                position: labelPosition
            },
            ...getStyles("label"),
            children: label
        })
    });
});
$8a00b9f352798fdd$export$2e0a83ec2e27ecbb.classes = (0, $d1f6d31363b1dd33$export$2e2bcd8739ae039);
$8a00b9f352798fdd$export$2e0a83ec2e27ecbb.varsResolver = $8a00b9f352798fdd$var$varsResolver;
$8a00b9f352798fdd$export$2e0a83ec2e27ecbb.displayName = "@mantine/core/Divider";














"use client";
//#region packages/@mantine/core/src/components/Input/use-input-props.ts
function $a8c37d27d093a1ae$export$434ed5c8d5bb7eb5(component, defaultProps, _props) {
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)([
        "Input",
        "InputWrapper",
        component
    ], defaultProps, _props);
    const { label: label, description: description, error: error, success: success, required: required, classNames: classNames, styles: styles, className: className, unstyled: unstyled, __staticSelector: __staticSelector, __stylesApiProps: __stylesApiProps, errorProps: errorProps, successProps: successProps, labelProps: labelProps, descriptionProps: descriptionProps, wrapperProps: _wrapperProps, id: id, size: size, style: style, inputContainer: inputContainer, inputWrapperOrder: inputWrapperOrder, withAsterisk: withAsterisk, variant: variant, vars: vars, mod: mod, attributes: attributes, ...others } = props;
    const { styleProps: styleProps, rest: rest } = (0, $2e4262c949ef0e61$export$fbc67becbdd26fbf)(others);
    const wrapperProps = {
        label: label,
        description: description,
        error: error,
        success: success,
        required: required,
        classNames: classNames,
        className: className,
        __staticSelector: __staticSelector,
        __stylesApiProps: __stylesApiProps || props,
        errorProps: errorProps,
        successProps: successProps,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        unstyled: unstyled,
        styles: styles,
        size: size,
        style: style,
        inputContainer: inputContainer,
        inputWrapperOrder: inputWrapperOrder,
        withAsterisk: withAsterisk,
        variant: variant,
        id: id,
        mod: mod,
        attributes: attributes,
        ..._wrapperProps
    };
    return {
        ...rest,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        wrapperProps: {
            ...wrapperProps,
            ...styleProps
        },
        inputProps: {
            required: required,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            size: size,
            __staticSelector: __staticSelector,
            __stylesApiProps: __stylesApiProps || props,
            error: error,
            success: success,
            variant: variant,
            id: id,
            attributes: attributes
        }
    };
}



"use client";
//#region packages/@mantine/core/src/components/InputBase/InputBase.tsx
const $ebdc9ebef4cbe70e$var$defaultProps = {
    __staticSelector: "InputBase",
    withAria: true,
    size: "sm"
};
const $ebdc9ebef4cbe70e$export$36eab7f492831059 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((props)=>{
    const { inputProps: inputProps, wrapperProps: wrapperProps, ...others } = (0, $a8c37d27d093a1ae$export$434ed5c8d5bb7eb5)("InputBase", $ebdc9ebef4cbe70e$var$defaultProps, props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069).Wrapper, {
        ...wrapperProps,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069), {
            ...inputProps,
            ...others
        })
    });
});
$ebdc9ebef4cbe70e$export$36eab7f492831059.classes = {
    ...(0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069).classes,
    ...(0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069).Wrapper.classes
};
$ebdc9ebef4cbe70e$export$36eab7f492831059.displayName = "@mantine/core/InputBase";



"use client";
//#region packages/@mantine/core/src/components/PasswordInput/PasswordToggleIcon.tsx
function $91f3c5e1e7069c36$export$f33d260505b4b38f({ reveal: reveal }) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        style: {
            width: "var(--psi-icon-size)",
            height: "var(--psi-icon-size)"
        },
        children: reveal ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    fill: "none",
                    d: "M0 0h256v256H0z"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "16",
                    d: "M48 40l160 176M154.91 157.6a40 40 0 01-53.82-59.2M135.53 88.71a40 40 0 0132.3 35.53"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "16",
                    d: "M208.61 169.1C230.41 149.58 240 128 240 128s-32-72-112-72a126 126 0 00-20.68 1.68M74 68.6C33.23 89.24 16 128 16 128s32 72 112 72a118.05 118.05 0 0054-12.6"
                })
            ]
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    fill: "none",
                    d: "M0 0h256v256H0z"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "16",
                    d: "M128 56c-80 0-112 72-112 72s32 72 112 72 112-72 112-72-32-72-112-72z"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "128",
                    cy: "128",
                    r: "40",
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "16"
                })
            ]
        })
    });
}


"use client";
//#region packages/@mantine/core/src/components/PasswordInput/PasswordInput.module.css
var $b0f2c82d3cd3b81f$export$2e2bcd8739ae039 = {
    "root": "m_f61ca620",
    "input": "m_ccf8da4c",
    "innerInput": "m_f2d85dd2",
    "visibilityToggle": "m_b1072d44"
};





"use client";
//#region packages/@mantine/core/src/components/PasswordInput/PasswordInput.tsx
const $3c023900663954b7$var$defaultProps = {
    visibilityToggleIcon: (0, $91f3c5e1e7069c36$export$f33d260505b4b38f),
    size: "sm"
};
const $3c023900663954b7$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size })=>({
        root: {
            "--psi-icon-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "psi-icon-size"),
            "--psi-button-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "psi-button-size")
        }
    }));
const $3c023900663954b7$export$b28585a458fee016 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)([
        "Input",
        "InputWrapper",
        "PasswordInput"
    ], $3c023900663954b7$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, required: required, error: error, success: success, leftSection: leftSection, disabled: disabled, id: id, variant: variant, inputContainer: inputContainer, description: description, label: label, size: size, errorProps: errorProps, successProps: successProps, descriptionProps: descriptionProps, labelProps: labelProps, withAsterisk: withAsterisk, inputWrapperOrder: inputWrapperOrder, wrapperProps: wrapperProps, radius: radius, rightSection: rightSection, rightSectionWidth: rightSectionWidth, rightSectionPointerEvents: rightSectionPointerEvents, leftSectionWidth: leftSectionWidth, visible: visible, defaultVisible: defaultVisible, onVisibilityChange: onVisibilityChange, visibilityToggleIcon: VisibilityToggleIcon, visibilityToggleButtonProps: visibilityToggleButtonProps, rightSectionProps: rightSectionProps, leftSectionProps: leftSectionProps, leftSectionPointerEvents: leftSectionPointerEvents, withErrorStyles: withErrorStyles, withSuccessStyles: withSuccessStyles, mod: mod, attributes: attributes, dir: dir, ...others } = props;
    const uuid = (0, $cee42e5537afff93$export$f680877a34711e37)(id);
    const [_visible, setVisibility] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: visible,
        defaultValue: defaultVisible,
        finalValue: false,
        onChange: onVisibilityChange
    });
    const toggleVisibility = ()=>setVisibility(!_visible);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "PasswordInput",
        classes: (0, $b0f2c82d3cd3b81f$export$2e2bcd8739ae039),
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $3c023900663954b7$var$varsResolver
    });
    const { resolvedClassNames: resolvedClassNames, resolvedStyles: resolvedStyles } = (0, $3da94ce37793f66c$export$92dc9b0c0bd35ec0)({
        classNames: classNames,
        styles: styles,
        props: props
    });
    const { styleProps: styleProps, rest: rest } = (0, $2e4262c949ef0e61$export$fbc67becbdd26fbf)(others);
    const errorId = errorProps?.id || `${uuid}-error`;
    const successId = successProps?.id || `${uuid}-success`;
    const descriptionId = descriptionProps?.id || `${uuid}-description`;
    const hasError = !!error && typeof error !== "boolean";
    const _describedBy = `${hasError ? errorId : ""} ${!!success && typeof success !== "boolean" && !hasError ? successId : ""} ${!!description ? descriptionId : ""}`;
    const describedBy = _describedBy.trim().length > 0 ? _describedBy.trim() : void 0;
    const visibilityToggleButton = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $5eeb3c9a10486755$export$c8e5c1392561c508), {
        ...getStyles("visibilityToggle"),
        disabled: disabled,
        radius: radius,
        "aria-pressed": _visible,
        tabIndex: -1,
        "aria-label": "Toggle password visibility",
        ...visibilityToggleButtonProps,
        variant: visibilityToggleButtonProps?.variant ?? "subtle",
        color: "gray",
        unstyled: unstyled,
        onTouchEnd: (event)=>{
            event.preventDefault();
            visibilityToggleButtonProps?.onTouchEnd?.(event);
            toggleVisibility();
        },
        onMouseDown: (event)=>{
            event.preventDefault();
            visibilityToggleButtonProps?.onMouseDown?.(event);
            toggleVisibility();
        },
        onKeyDown: (event)=>{
            visibilityToggleButtonProps?.onKeyDown?.(event);
            if (event.key === " ") {
                event.preventDefault();
                toggleVisibility();
            }
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(VisibilityToggleIcon, {
            reveal: _visible
        })
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069).Wrapper, {
        required: required,
        id: uuid,
        label: label,
        error: error,
        success: success,
        description: description,
        size: size,
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        __staticSelector: "PasswordInput",
        __stylesApiProps: props,
        unstyled: unstyled,
        withAsterisk: withAsterisk,
        inputWrapperOrder: inputWrapperOrder,
        inputContainer: inputContainer,
        variant: variant,
        labelProps: {
            ...labelProps,
            htmlFor: uuid
        },
        descriptionProps: {
            ...descriptionProps,
            id: descriptionId
        },
        errorProps: {
            ...errorProps,
            id: errorId
        },
        successProps: {
            ...successProps,
            id: successId
        },
        mod: mod,
        attributes: attributes,
        ...getStyles("root"),
        ...styleProps,
        ...wrapperProps,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069), {
            component: "div",
            dir: dir,
            error: error,
            success: success,
            leftSection: leftSection,
            size: size,
            classNames: {
                ...resolvedClassNames,
                input: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $b0f2c82d3cd3b81f$export$2e2bcd8739ae039).input, resolvedClassNames?.input)
            },
            styles: resolvedStyles,
            radius: radius,
            disabled: disabled,
            __staticSelector: "PasswordInput",
            __stylesApiProps: props,
            rightSectionWidth: rightSectionWidth,
            rightSection: rightSection ?? visibilityToggleButton,
            variant: variant,
            unstyled: unstyled,
            leftSectionWidth: leftSectionWidth,
            rightSectionPointerEvents: rightSectionPointerEvents || "all",
            rightSectionProps: rightSectionProps,
            leftSectionProps: leftSectionProps,
            leftSectionPointerEvents: leftSectionPointerEvents,
            withAria: false,
            withErrorStyles: withErrorStyles,
            withSuccessStyles: withSuccessStyles,
            attributes: attributes,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                required: required,
                "data-invalid": !!error || void 0,
                "data-with-left-section": !!leftSection || void 0,
                ...getStyles("innerInput"),
                disabled: disabled,
                id: uuid,
                dir: dir,
                ...rest,
                "aria-describedby": describedBy,
                autoComplete: rest.autoComplete || "off",
                type: _visible ? "text" : "password"
            })
        })
    });
});
$3c023900663954b7$export$b28585a458fee016.classes = {
    ...(0, $ebdc9ebef4cbe70e$export$36eab7f492831059).classes,
    ...(0, $b0f2c82d3cd3b81f$export$2e2bcd8739ae039)
};
$3c023900663954b7$export$b28585a458fee016.varsResolver = $3c023900663954b7$var$varsResolver;
$3c023900663954b7$export$b28585a458fee016.displayName = "@mantine/core/PasswordInput";





"use client";
//#region packages/@mantine/core/src/components/TextInput/TextInput.tsx
const $bcbc0ad084559bc5$export$c86715117507e8e5 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ebdc9ebef4cbe70e$export$36eab7f492831059), {
        component: "input",
        ...(0, $4fa4869d2d954dac$export$1f264be2c424fccf)([
            "Input",
            "InputWrapper",
            "TextInput"
        ], null, props),
        __staticSelector: "TextInput"
    });
});
$bcbc0ad084559bc5$export$c86715117507e8e5.classes = (0, $ebdc9ebef4cbe70e$export$36eab7f492831059).classes;
$bcbc0ad084559bc5$export$c86715117507e8e5.displayName = "@mantine/core/TextInput";



var $acw62 = parcelRequire("acw62");




const $1af3e201f2191896$export$b2a2fd2f92c8e105 = "/postsignin";
function $1af3e201f2191896$export$97fca9fed2b032d7(explicitReturn) {
    if (explicitReturn && explicitReturn.length > 0) {
        const path = explicitReturn.startsWith("/") ? explicitReturn : "/" + explicitReturn;
        if (path !== "/" && path !== $1af3e201f2191896$export$b2a2fd2f92c8e105) return path;
    }
    return $1af3e201f2191896$export$b2a2fd2f92c8e105;
}
function $1af3e201f2191896$export$8b199c2ab6ac8131(bought) {
    return bought ? "/userinfo" : "/buy";
}


function $a9103170d172c05d$export$21a94553ffa41578({ returnTo: returnToProp } = {}) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    const [params] = (0, $5cec2af50e95548c$export$f1a78c17382fe22a)();
    const user = (0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)();
    const metadata = (0, $e9e66f0970a759b5$export$985c431ed65d8e6a)();
    const requestedReturn = (0, $1af3e201f2191896$export$97fca9fed2b032d7)(returnToProp ?? params.get("return"));
    const returnTo = user && requestedReturn === (0, $1af3e201f2191896$export$b2a2fd2f92c8e105) ? (0, $1af3e201f2191896$export$8b199c2ab6ac8131)(Boolean(user.Bought)) : requestedReturn;
    const [email, setEmail] = $acw62.useState("");
    const [password, setPassword] = $acw62.useState("");
    const [error, setError] = $acw62.useState(null);
    const [submitting, setSubmitting] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        if (user) navigate(returnTo, {
            replace: true
        });
    }, [
        user,
        returnTo,
        navigate
    ]);
    const onGoogleSignIn = ()=>{
        // Put return path in Google OAuth state (server /signin/google) so desktop /applogin
        // auto-mint still works without relying on sessionStorage across the OAuth round-trip.
        window.location.href = "/signin/google?return=" + encodeURIComponent(returnTo);
    };
    const onEmailSignIn = async (event)=>{
        event.preventDefault();
        setError(null);
        setSubmitting(true);
        try {
            await (0, $0fb2b9595b8b3089$export$1f53e240b076325b).localAuthLogin(email.trim(), password);
            window.location.href = returnTo;
        } catch (err) {
            const message = err instanceof (0, $0fb2b9595b8b3089$export$f2e832acab1bdd79) ? err.message : t("signin.emailPasswordError");
            setError(message);
            setSubmitting(false);
        }
    };
    if (user) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
        gap: "md",
        maw: 480,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                order: 3,
                children: t("signin.alreadySignedIn")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                children: t("signin.signedInAs", {
                    email: user.AccountEmail || user.Email
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                to: returnTo,
                children: t("signin.continue")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                href: "/logout",
                children: t("nav.logout")
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
        gap: "md",
        maw: 480,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                order: 3,
                children: t("signin.title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                children: t("signin.intro")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                onClick: onGoogleSignIn,
                children: t("signin.withGoogle")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a00b9f352798fdd$export$2e0a83ec2e27ecbb), {
                label: t("signin.orEmail"),
                labelPosition: "center"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                onSubmit: onEmailSignIn,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                    gap: "sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                            label: t("signin.email"),
                            type: "email",
                            autoComplete: "email",
                            required: true,
                            value: email,
                            onChange: (e)=>setEmail(e.currentTarget.value)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c023900663954b7$export$b28585a458fee016), {
                            label: t("signin.password"),
                            autoComplete: "current-password",
                            required: true,
                            value: password,
                            onChange: (e)=>setPassword(e.currentTarget.value)
                        }),
                        error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            c: "red",
                            size: "sm",
                            children: error
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                            type: "submit",
                            loading: submitting,
                            children: t("signin.withEmail")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                size: "sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                        to: `/register?return=${encodeURIComponent(returnTo)}`,
                        children: t("signin.createAccount")
                    }),
                    " \xb7 ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                        to: "/forgot-password",
                        children: t("signin.forgotPassword")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                size: "sm",
                c: "dimmed",
                children: [
                    t("signin.agreePrefix"),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                        to: "/privacy",
                        children: t("signin.privacyLink")
                    })
                ]
            }),
            metadata.SignInUrl ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                label: t("signin.debugSignInUrl"),
                value: "(missing)",
                readOnly: true
            })
        ]
    });
}





function $83aa9b7d47e715a4$export$8b567d0dd9363392() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [payError, setPayError] = $acw62.useState(null);
    const [paying, setPaying] = $acw62.useState(false);
    const [togglingBought, setTogglingBought] = $acw62.useState(false);
    const [signInOpen, setSignInOpen] = $acw62.useState(false);
    const user = (0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)();
    const metadata = (0, $e9e66f0970a759b5$export$985c431ed65d8e6a)();
    const alreadyBought = Boolean(user?.Bought);
    const hasStripeCustomer = Boolean(user?.StripeCustomerId);
    const isLifetimeLicense = alreadyBought && !user?.StripeSubscriptionId;
    // Browser back from Stripe often restores this page from bfcache with
    // paying still true (redirect navigates away before finally runs).
    $acw62.useEffect(()=>{
        const onPageShow = (event)=>{
            if (event.persisted) {
                setPaying(false);
                setPayError(null);
            }
        };
        window.addEventListener("pageshow", onPageShow);
        return ()=>window.removeEventListener("pageshow", onPageShow);
    }, []);
    const onPay = async ()=>{
        if (!user) {
            setSignInOpen(true);
            return;
        }
        if (alreadyBought) return;
        (0, $fbac34ae8aa6584b$export$ce30dbb46644d06c).logger.logReportData("BuyPagePayClicked", {
            alreadyBought: alreadyBought
        });
        setPaying(true);
        setPayError(null);
        try {
            const session = await (0, $0fb2b9595b8b3089$export$1f53e240b076325b).createBuySession();
            if (session.bought) {
                window.location.reload();
                return;
            }
            const stripe = Stripe(metadata.StripePublishableKey);
            const result = await stripe.redirectToCheckout({
                sessionId: session.sessionId
            });
            if (result.error) setPayError(result.error.message);
        } catch  {
            setPayError(t("buyPage.payError"));
        } finally{
            setPaying(false);
        }
    };
    const onToggleBought = async ()=>{
        setTogglingBought(true);
        setPayError(null);
        try {
            await (0, $0fb2b9595b8b3089$export$1f53e240b076325b).toggleBought();
            window.location.reload();
        } catch  {
            setPayError(t("buyPage.toggleBoughtError"));
            setTogglingBought(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        fullBleed: true,
        showFooter: true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                style: {
                    background: "linear-gradient(160deg, #fff8f2 0%, #ffffff 45%, #fff4eb 100%)",
                    minHeight: "calc(100vh - 60px - 160px)"
                },
                py: {
                    base: "xl",
                    md: 56
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
                    size: "lg",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14), {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14).Col, {
                                span: {
                                    base: 12,
                                    md: 5
                                },
                                visibleFrom: "md",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95f3644217e6673d$export$3e431a229df88919), {
                                    src: (0, $f59b44cc928cf883$export$98104c9ee0729143),
                                    alt: "DinLabel",
                                    maw: 420,
                                    mx: "auto",
                                    style: {
                                        filter: "drop-shadow(0 20px 40px rgba(44, 45, 48, 0.16))"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14).Col, {
                                span: {
                                    base: 12,
                                    md: 7
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                    gap: "lg",
                                    maw: 480,
                                    mx: {
                                        base: "auto",
                                        md: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                                    order: 1,
                                                    c: "charcoal.8",
                                                    mb: "xs",
                                                    children: t("buyPage.title")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    c: "dimmed",
                                                    size: "lg",
                                                    children: t("buyPage.intro")
                                                })
                                            ]
                                        }),
                                        payError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7599b5b791e3b99$export$caec2af78bcc877f), {
                                            color: "red",
                                            variant: "light",
                                            title: t("buyPage.errorTitle"),
                                            children: payError
                                        }),
                                        user?.IsAdmin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                            gap: "sm",
                                            children: [
                                                !alreadyBought && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7599b5b791e3b99$export$caec2af78bcc877f), {
                                                    color: "orange",
                                                    variant: "light",
                                                    children: t("buyPage.adminTestMode")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                                    variant: "outline",
                                                    color: "orange",
                                                    size: "xs",
                                                    loading: togglingBought,
                                                    onClick: ()=>void onToggleBought(),
                                                    children: t("buyPage.debugToggleBought")
                                                })
                                            ]
                                        }),
                                        alreadyBought ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                                            p: "xl",
                                            style: {
                                                background: "white",
                                                border: "1px solid var(--mantine-color-gray-2)",
                                                borderRadius: "var(--mantine-radius-md)",
                                                boxShadow: "0 8px 32px rgba(44, 45, 48, 0.06)"
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                                gap: "md",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                                        order: 3,
                                                        c: "brand.7",
                                                        children: t(isLifetimeLicense ? "buyPage.thanksLifetime" : "buyPage.thanks")
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                                        to: "/install",
                                                        c: "brand.7",
                                                        fw: 600,
                                                        children: t("buyPage.goToDownload")
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                                        to: "/userinfo",
                                                        c: "brand.7",
                                                        fw: 600,
                                                        children: t("buyPage.checkAccount")
                                                    }),
                                                    hasStripeCustomer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                                        href: "/buy/billingportal",
                                                        c: "brand.7",
                                                        fw: 600,
                                                        children: t("buyPage.manageBilling")
                                                    })
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                                            p: "xl",
                                            style: {
                                                background: "white",
                                                border: "1px solid var(--mantine-color-gray-2)",
                                                borderRadius: "var(--mantine-radius-md)",
                                                boxShadow: "0 8px 32px rgba(44, 45, 48, 0.06)"
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                                gap: "lg",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                                fw: 600,
                                                                size: "lg",
                                                                c: "charcoal.8",
                                                                mb: 4,
                                                                children: t("buyPage.panelTitle")
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                                size: "sm",
                                                                c: "dimmed",
                                                                children: t("buyPage.price", {
                                                                    price: metadata.Price.toFixed(2)
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                                        onClick: onPay,
                                                        loading: paying,
                                                        size: "lg",
                                                        color: "brand",
                                                        fullWidth: true,
                                                        children: t("buyPage.payWithCard")
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                                        gap: "xs",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                                size: "sm",
                                                                c: "dimmed",
                                                                children: t("buyPage.orVia")
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                                                component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                                                to: "/install",
                                                                size: "sm",
                                                                c: "charcoal.5",
                                                                underline: "hover",
                                                                children: t("buyPage.downloadDemo")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b1b81586258b47fb$export$2b77a92f1a5ad772), {
                opened: signInOpen,
                onClose: ()=>setSignInOpen(false),
                centered: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a9103170d172c05d$export$21a94553ffa41578), {
                    returnTo: "/buy"
                })
            })
        ]
    });
}













"use client";
//#region packages/@mantine/core/src/components/NumberInput/NumberInputChevron.tsx
function $bb7ab0536b54b947$export$da0a9fe0e215031b({ direction: direction, style: style, ...others }) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        style: {
            width: "var(--ni-chevron-size)",
            height: "var(--ni-chevron-size)",
            transform: direction === "up" ? "rotate(180deg)" : void 0,
            ...style
        },
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...others,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    });
}


"use client";
//#region packages/@mantine/core/src/components/NumberInput/NumberInput.module.css
var $d1d668c4eb2fee2f$export$2e2bcd8739ae039 = {
    "root": "m_e2f5cd4e",
    "controls": "m_95e17d22",
    "control": "m_80b4b171"
};



var $acw62 = parcelRequire("acw62");
"use client";
//#region packages/@mantine/hooks/src/utils/clamp/clamp.ts
function $65e289b30b587335$export$7d15b64cf5a3a4c4(value, min, max) {
    if (min === void 0 && max === void 0) return value;
    if (min !== void 0 && max === void 0) return Math.max(value, min);
    if (min === void 0 && max !== void 0) return Math.min(value, max);
    return Math.min(Math.max(value, min), max);
}




/**
 * react-number-format - 5.4.5
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2026 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */ 
var $acw62 = parcelRequire("acw62");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $f9d8d8bd3b422c11$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $f9d8d8bd3b422c11$var$SourceType;
(function(SourceType) {
    SourceType["event"] = "event";
    SourceType["props"] = "prop";
})($f9d8d8bd3b422c11$var$SourceType || ($f9d8d8bd3b422c11$var$SourceType = {}));
// basic noop function
function $f9d8d8bd3b422c11$var$noop() {}
function $f9d8d8bd3b422c11$var$memoizeOnce(cb) {
    var lastArgs;
    var lastValue = undefined;
    return function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        if (lastArgs && args.length === lastArgs.length && args.every(function(value, index) {
            return value === lastArgs[index];
        })) return lastValue;
        lastArgs = args;
        lastValue = cb.apply(void 0, args);
        return lastValue;
    };
}
function $f9d8d8bd3b422c11$var$charIsNumber(char) {
    return !!(char || '').match(/\d/);
}
function $f9d8d8bd3b422c11$var$isNil(val) {
    return val === null || val === undefined;
}
function $f9d8d8bd3b422c11$var$isNanValue(val) {
    return typeof val === 'number' && isNaN(val);
}
function $f9d8d8bd3b422c11$var$isNotValidValue(val) {
    return $f9d8d8bd3b422c11$var$isNil(val) || $f9d8d8bd3b422c11$var$isNanValue(val) || typeof val === 'number' && !isFinite(val);
}
function $f9d8d8bd3b422c11$var$escapeRegExp(str) {
    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}
function $f9d8d8bd3b422c11$var$getThousandsGroupRegex(thousandsGroupStyle) {
    switch(thousandsGroupStyle){
        case 'lakh':
            return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
        case 'wan':
            return /(\d)(?=(\d{4})+(?!\d))/g;
        case 'thousand':
        default:
            return /(\d)(?=(\d{3})+(?!\d))/g;
    }
}
function $f9d8d8bd3b422c11$var$applyThousandSeparator(str, thousandSeparator, thousandsGroupStyle) {
    var thousandsGroupRegex = $f9d8d8bd3b422c11$var$getThousandsGroupRegex(thousandsGroupStyle);
    var index = str.search(/[1-9]/);
    index = index === -1 ? str.length : index;
    return str.substring(0, index) + str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator);
}
function $f9d8d8bd3b422c11$var$usePersistentCallback(cb) {
    var callbackRef = (0, $acw62.useRef)(cb);
    // keep the callback ref upto date
    callbackRef.current = cb;
    /**
     * initialize a persistent callback which never changes
     * through out the component lifecycle
     */ var persistentCbRef = (0, $acw62.useRef)(function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return callbackRef.current.apply(callbackRef, args);
    });
    return persistentCbRef.current;
}
//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function $f9d8d8bd3b422c11$var$splitDecimal(numStr, allowNegative) {
    if (allowNegative === void 0) allowNegative = true;
    var hasNegation = numStr[0] === '-';
    var addNegation = hasNegation && allowNegative;
    numStr = numStr.replace('-', '');
    var parts = numStr.split('.');
    var beforeDecimal = parts[0];
    var afterDecimal = parts[1] || '';
    return {
        beforeDecimal: beforeDecimal,
        afterDecimal: afterDecimal,
        hasNegation: hasNegation,
        addNegation: addNegation
    };
}
function $f9d8d8bd3b422c11$var$fixLeadingZero(numStr) {
    if (!numStr) return numStr;
    var isNegative = numStr[0] === '-';
    if (isNegative) numStr = numStr.substring(1, numStr.length);
    var parts = numStr.split('.');
    var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
    var afterDecimal = parts[1] || '';
    return "" + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? "." + afterDecimal : '');
}
/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */ function $f9d8d8bd3b422c11$var$limitToScale(numStr, scale, fixedDecimalScale) {
    var str = '';
    var filler = fixedDecimalScale ? '0' : '';
    for(var i = 0; i <= scale - 1; i++)str += numStr[i] || filler;
    return str;
}
function $f9d8d8bd3b422c11$var$repeat(str, count) {
    return Array(count + 1).join(str);
}
function $f9d8d8bd3b422c11$var$toNumericString(num) {
    var _num = num + ''; // typecast number to string
    // store the sign and remove it from the number.
    var sign = _num[0] === '-' ? '-' : '';
    if (sign) _num = _num.substring(1);
    // split the number into cofficient and exponent
    var ref = _num.split(/[eE]/g);
    var coefficient = ref[0];
    var exponent = ref[1];
    // covert exponent to number;
    exponent = Number(exponent);
    // if there is no exponent part or its 0, return the coffiecient with sign
    if (!exponent) return sign + coefficient;
    coefficient = coefficient.replace('.', '');
    /**
     * for scientific notation the current decimal index will be after first number (index 0)
     * So effective decimal index will always be 1 + exponent value
     */ var decimalIndex = 1 + exponent;
    var coffiecientLn = coefficient.length;
    if (decimalIndex < 0) // if decimal index is less then 0 add preceding 0s
    // add 1 as join will have
    coefficient = '0.' + $f9d8d8bd3b422c11$var$repeat('0', Math.abs(decimalIndex)) + coefficient;
    else if (decimalIndex >= coffiecientLn) // if decimal index is less then 0 add leading 0s
    coefficient = coefficient + $f9d8d8bd3b422c11$var$repeat('0', decimalIndex - coffiecientLn);
    else // else add decimal point at proper index
    coefficient = (coefficient.substring(0, decimalIndex) || '0') + '.' + coefficient.substring(decimalIndex);
    return sign + coefficient;
}
/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */ function $f9d8d8bd3b422c11$var$roundToPrecision(numStr, scale, fixedDecimalScale) {
    //if number is empty don't do anything return empty string
    if ([
        '',
        '-'
    ].indexOf(numStr) !== -1) return numStr;
    var shouldHaveDecimalSeparator = (numStr.indexOf('.') !== -1 || fixedDecimalScale) && scale;
    var ref = $f9d8d8bd3b422c11$var$splitDecimal(numStr);
    var beforeDecimal = ref.beforeDecimal;
    var afterDecimal = ref.afterDecimal;
    var hasNegation = ref.hasNegation;
    var floatValue = parseFloat("0." + (afterDecimal || '0'));
    var floatValueStr = afterDecimal.length <= scale ? "0." + afterDecimal : floatValue.toFixed(scale);
    var roundedDecimalParts = floatValueStr.split('.');
    var intPart = beforeDecimal;
    // if we have cary over from rounding decimal part, add that on before decimal
    if (beforeDecimal && Number(roundedDecimalParts[0])) intPart = beforeDecimal.split('').reverse().reduce(function(roundedStr, current, idx) {
        if (roundedStr.length > idx) return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
        return current + roundedStr;
    }, roundedDecimalParts[0]);
    var decimalPart = $f9d8d8bd3b422c11$var$limitToScale(roundedDecimalParts[1] || '', scale, fixedDecimalScale);
    var negation = hasNegation ? '-' : '';
    var decimalSeparator = shouldHaveDecimalSeparator ? '.' : '';
    return "" + negation + intPart + decimalSeparator + decimalPart;
}
/** set the caret positon in an input field **/ function $f9d8d8bd3b422c11$var$setCaretPosition(el, caretPos) {
    el.value = el.value;
    // ^ this is used to not only get 'focus', but
    // to make sure we don't have it everything -selected-
    // (it causes an issue in chrome, and having it doesn't hurt any other browser)
    if (el !== null) {
        /* @ts-ignore */ if (el.createTextRange) {
            /* @ts-ignore */ var range = el.createTextRange();
            range.move('character', caretPos);
            range.select();
            return true;
        }
        // (el.selectionStart === 0 added for Firefox bug)
        if (el.selectionStart || el.selectionStart === 0) {
            el.focus();
            el.setSelectionRange(caretPos, caretPos);
            return true;
        }
        // fail city, fortunately this never happens (as far as I've tested) :)
        el.focus();
        return false;
    }
}
/**
 * TODO: remove dependency of findChangeRange, findChangedRangeFromCaretPositions is better way to find what is changed
 * currently this is mostly required by test and isCharacterSame util
 * Given previous value and newValue it returns the index
 * start - end to which values have changed.
 * This function makes assumption about only consecutive
 * characters are changed which is correct assumption for caret input.
 */ var $f9d8d8bd3b422c11$var$findChangeRange = $f9d8d8bd3b422c11$var$memoizeOnce(function(prevValue, newValue) {
    var i = 0, j = 0;
    var prevLength = prevValue.length;
    var newLength = newValue.length;
    while(prevValue[i] === newValue[i] && i < prevLength)i++;
    //check what has been changed from last
    while(prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i && prevLength - j > i)j++;
    return {
        from: {
            start: i,
            end: prevLength - j
        },
        to: {
            start: i,
            end: newLength - j
        }
    };
});
var $f9d8d8bd3b422c11$var$findChangedRangeFromCaretPositions = function(lastCaretPositions, currentCaretPosition) {
    var startPosition = Math.min(lastCaretPositions.selectionStart, currentCaretPosition);
    return {
        from: {
            start: startPosition,
            end: lastCaretPositions.selectionEnd
        },
        to: {
            start: startPosition,
            end: currentCaretPosition
        }
    };
};
/*
  Returns a number whose value is limited to the given range
*/ function $f9d8d8bd3b422c11$var$clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
function $f9d8d8bd3b422c11$var$geInputCaretPosition(el) {
    /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/ return Math.max(el.selectionStart, el.selectionEnd);
}
function $f9d8d8bd3b422c11$var$addInputMode() {
    return typeof navigator !== 'undefined' && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function $f9d8d8bd3b422c11$var$getDefaultChangeMeta(value) {
    return {
        from: {
            start: 0,
            end: 0
        },
        to: {
            start: 0,
            end: value.length
        },
        lastValue: ''
    };
}
function $f9d8d8bd3b422c11$var$getMaskAtIndex(mask, index) {
    if (mask === void 0) mask = ' ';
    if (typeof mask === 'string') return mask;
    return mask[index] || ' ';
}
function $f9d8d8bd3b422c11$var$defaultIsCharacterSame(ref) {
    var currentValue = ref.currentValue;
    var formattedValue = ref.formattedValue;
    var currentValueIndex = ref.currentValueIndex;
    var formattedValueIndex = ref.formattedValueIndex;
    return currentValue[currentValueIndex] === formattedValue[formattedValueIndex];
}
function $f9d8d8bd3b422c11$var$getCaretPosition(newFormattedValue, lastFormattedValue, curValue, curCaretPos, boundary, isValidInputCharacter, /**
 * format function can change the character, the caret engine relies on mapping old value and new value
 * In such case if character is changed, parent can tell which chars are equivalent
 * Some example, all allowedDecimalCharacters are updated to decimalCharacters, 2nd case if user is coverting
 * number to different numeric system.
 */ isCharacterSame) {
    if (isCharacterSame === void 0) isCharacterSame = $f9d8d8bd3b422c11$var$defaultIsCharacterSame;
    /**
     * if something got inserted on empty value, add the formatted character before the current value,
     * This is to avoid the case where typed character is present on format characters
     */ var firstAllowedPosition = boundary.findIndex(function(b) {
        return b;
    });
    var prefixFormat = newFormattedValue.slice(0, firstAllowedPosition);
    if (!lastFormattedValue && !curValue.startsWith(prefixFormat)) {
        lastFormattedValue = prefixFormat;
        curValue = prefixFormat + curValue;
        curCaretPos = curCaretPos + prefixFormat.length;
    }
    var curValLn = curValue.length;
    var formattedValueLn = newFormattedValue.length;
    // create index map
    var addedIndexMap = {};
    var indexMap = new Array(curValLn);
    for(var i = 0; i < curValLn; i++){
        indexMap[i] = -1;
        for(var j = 0, jLn = formattedValueLn; j < jLn; j++){
            var isCharSame = isCharacterSame({
                currentValue: curValue,
                lastValue: lastFormattedValue,
                formattedValue: newFormattedValue,
                currentValueIndex: i,
                formattedValueIndex: j
            });
            if (isCharSame && addedIndexMap[j] !== true) {
                indexMap[i] = j;
                addedIndexMap[j] = true;
                break;
            }
        }
    }
    /**
     * For current caret position find closest characters (left and right side)
     * which are properly mapped to formatted value.
     * The idea is that the new caret position will exist always in the boundary of
     * that mapped index
     */ var pos = curCaretPos;
    while(pos < curValLn && (indexMap[pos] === -1 || !isValidInputCharacter(curValue[pos])))pos++;
    // if the caret position is on last keep the endIndex as last for formatted value
    var endIndex = pos === curValLn || indexMap[pos] === -1 ? formattedValueLn : indexMap[pos];
    pos = curCaretPos - 1;
    while(pos > 0 && indexMap[pos] === -1)pos--;
    var startIndex = pos === -1 || indexMap[pos] === -1 ? 0 : indexMap[pos] + 1;
    /**
     * case where a char is added on suffix and removed from middle, example 2sq345 becoming $2,345 sq
     * there is still a mapping but the order of start index and end index is changed
     */ if (startIndex > endIndex) return endIndex;
    /**
     * given the current caret position if it closer to startIndex
     * keep the new caret position on start index or keep it closer to endIndex
     */ return curCaretPos - startIndex < endIndex - curCaretPos ? startIndex : endIndex;
}
/* This keeps the caret within typing area so people can't type in between prefix or suffix or format characters */ function $f9d8d8bd3b422c11$var$getCaretPosInBoundary(value, caretPos, boundary, direction) {
    var valLn = value.length;
    // clamp caret position to [0, value.length]
    caretPos = $f9d8d8bd3b422c11$var$clamp(caretPos, 0, valLn);
    if (direction === 'left') {
        while(caretPos >= 0 && !boundary[caretPos])caretPos--;
        // if we don't find any suitable caret position on left, set it on first allowed position
        if (caretPos === -1) caretPos = boundary.indexOf(true);
    } else {
        while(caretPos <= valLn && !boundary[caretPos])caretPos++;
        // if we don't find any suitable caret position on right, set it on last allowed position
        if (caretPos > valLn) caretPos = boundary.lastIndexOf(true);
    }
    // if we still don't find caret position, set it at the end of value
    if (caretPos === -1) caretPos = valLn;
    return caretPos;
}
function $f9d8d8bd3b422c11$var$caretUnknownFormatBoundary(formattedValue) {
    var boundaryAry = Array.from({
        length: formattedValue.length + 1
    }).map(function() {
        return true;
    });
    for(var i = 0, ln = boundaryAry.length; i < ln; i++)// consider caret to be in boundary if it is before or after numeric value
    boundaryAry[i] = Boolean($f9d8d8bd3b422c11$var$charIsNumber(formattedValue[i]) || $f9d8d8bd3b422c11$var$charIsNumber(formattedValue[i - 1]));
    return boundaryAry;
}
function $f9d8d8bd3b422c11$var$useInternalValues(value, defaultValue, valueIsNumericString, format, removeFormatting, onValueChange) {
    if (onValueChange === void 0) onValueChange = $f9d8d8bd3b422c11$var$noop;
    var getValues = $f9d8d8bd3b422c11$var$usePersistentCallback(function(value, valueIsNumericString) {
        var formattedValue, numAsString;
        if ($f9d8d8bd3b422c11$var$isNotValidValue(value)) {
            numAsString = '';
            formattedValue = '';
        } else if (typeof value === 'number' || valueIsNumericString) {
            numAsString = typeof value === 'number' ? $f9d8d8bd3b422c11$var$toNumericString(value) : value;
            formattedValue = format(numAsString);
        } else {
            numAsString = removeFormatting(value, undefined);
            formattedValue = format(numAsString);
        }
        return {
            formattedValue: formattedValue,
            numAsString: numAsString
        };
    });
    var ref = (0, $acw62.useState)(function() {
        return getValues($f9d8d8bd3b422c11$var$isNil(value) ? defaultValue : value, valueIsNumericString);
    });
    var values = ref[0];
    var setValues = ref[1];
    var _onValueChange = $f9d8d8bd3b422c11$var$usePersistentCallback(function(newValues, sourceInfo) {
        if (newValues.formattedValue !== values.formattedValue) setValues({
            formattedValue: newValues.formattedValue,
            numAsString: newValues.value
        });
        // call parent on value change if only if formatted value is changed
        onValueChange(newValues, sourceInfo);
    });
    // if value is switch from controlled to uncontrolled, use the internal state's value to format with new props
    var _value = value;
    var _valueIsNumericString = valueIsNumericString;
    if ($f9d8d8bd3b422c11$var$isNil(value)) {
        _value = values.numAsString;
        _valueIsNumericString = true;
    }
    var newValues = getValues(_value, _valueIsNumericString);
    (0, $acw62.useMemo)(function() {
        setValues(newValues);
    }, [
        newValues.formattedValue
    ]);
    /**
     * When only a defaultValue is provided (value prop is nil), the initial formatted value is
     * derived by the library — the parent has not yet been informed of this formatted result.
     * Fire onValueChange once on mount so the parent can sync to the formatted value.
     */ (0, $acw62.useEffect)(function() {
        if (!$f9d8d8bd3b422c11$var$isNil(defaultValue) && $f9d8d8bd3b422c11$var$isNil(value) && values.formattedValue !== '') {
            var floatValue = parseFloat(values.numAsString);
            _onValueChange({
                formattedValue: values.formattedValue,
                value: values.numAsString,
                floatValue: isNaN(floatValue) ? undefined : floatValue
            }, {
                event: undefined,
                source: $f9d8d8bd3b422c11$var$SourceType.props
            });
        }
    }, []);
    return [
        values,
        _onValueChange
    ];
}
function $f9d8d8bd3b422c11$var$defaultRemoveFormatting(value) {
    return value.replace(/[^0-9]/g, '');
}
function $f9d8d8bd3b422c11$var$defaultFormat(value) {
    return value;
}
function $f9d8d8bd3b422c11$export$dd1caf9b8ccbc158(props) {
    var type = props.type;
    if (type === void 0) type = 'text';
    var displayType = props.displayType;
    if (displayType === void 0) displayType = 'input';
    var customInput = props.customInput;
    var renderText = props.renderText;
    var getInputRef = props.getInputRef;
    var format = props.format;
    if (format === void 0) format = $f9d8d8bd3b422c11$var$defaultFormat;
    var removeFormatting = props.removeFormatting;
    if (removeFormatting === void 0) removeFormatting = $f9d8d8bd3b422c11$var$defaultRemoveFormatting;
    var defaultValue = props.defaultValue;
    var valueIsNumericString = props.valueIsNumericString;
    var onValueChange = props.onValueChange;
    var isAllowed = props.isAllowed;
    var onChange = props.onChange;
    if (onChange === void 0) onChange = $f9d8d8bd3b422c11$var$noop;
    var onKeyDown = props.onKeyDown;
    if (onKeyDown === void 0) onKeyDown = $f9d8d8bd3b422c11$var$noop;
    var onMouseUp = props.onMouseUp;
    if (onMouseUp === void 0) onMouseUp = $f9d8d8bd3b422c11$var$noop;
    var onFocus = props.onFocus;
    if (onFocus === void 0) onFocus = $f9d8d8bd3b422c11$var$noop;
    var onBlur = props.onBlur;
    if (onBlur === void 0) onBlur = $f9d8d8bd3b422c11$var$noop;
    var propValue = props.value;
    var getCaretBoundary = props.getCaretBoundary;
    if (getCaretBoundary === void 0) getCaretBoundary = $f9d8d8bd3b422c11$var$caretUnknownFormatBoundary;
    var isValidInputCharacter = props.isValidInputCharacter;
    if (isValidInputCharacter === void 0) isValidInputCharacter = $f9d8d8bd3b422c11$var$charIsNumber;
    var isCharacterSame = props.isCharacterSame;
    var otherProps = $f9d8d8bd3b422c11$var$__rest(props, [
        "type",
        "displayType",
        "customInput",
        "renderText",
        "getInputRef",
        "format",
        "removeFormatting",
        "defaultValue",
        "valueIsNumericString",
        "onValueChange",
        "isAllowed",
        "onChange",
        "onKeyDown",
        "onMouseUp",
        "onFocus",
        "onBlur",
        "value",
        "getCaretBoundary",
        "isValidInputCharacter",
        "isCharacterSame"
    ]);
    var ref = $f9d8d8bd3b422c11$var$useInternalValues(propValue, defaultValue, Boolean(valueIsNumericString), format, removeFormatting, onValueChange);
    var ref_0 = ref[0];
    var formattedValue = ref_0.formattedValue;
    var numAsString = ref_0.numAsString;
    var onFormattedValueChange = ref[1];
    var caretPositionBeforeChange = (0, $acw62.useRef)();
    var lastUpdatedValue = (0, $acw62.useRef)({
        formattedValue: formattedValue,
        numAsString: numAsString
    });
    var _onValueChange = function(values, source) {
        lastUpdatedValue.current = {
            formattedValue: values.formattedValue,
            numAsString: values.value
        };
        onFormattedValueChange(values, source);
    };
    var ref$1 = (0, $acw62.useState)(false);
    var mounted = ref$1[0];
    var setMounted = ref$1[1];
    var focusedElm = (0, $acw62.useRef)(null);
    var timeout = (0, $acw62.useRef)({
        setCaretTimeout: null,
        focusTimeout: null
    });
    (0, $acw62.useEffect)(function() {
        setMounted(true);
        return function() {
            clearTimeout(timeout.current.setCaretTimeout);
            clearTimeout(timeout.current.focusTimeout);
        };
    }, []);
    var _format = format;
    var getValueObject = function(formattedValue, numAsString) {
        var floatValue = parseFloat(numAsString);
        return {
            formattedValue: formattedValue,
            value: numAsString,
            floatValue: isNaN(floatValue) ? undefined : floatValue
        };
    };
    var setPatchedCaretPosition = function(el, caretPos, currentValue) {
        // don't reset the caret position when the whole input content is selected
        if (el.selectionStart === 0 && el.selectionEnd === el.value.length) return;
        /* setting caret position within timeout of 0ms is required for mobile chrome,
        otherwise browser resets the caret position after we set it
        We are also setting it without timeout so that in normal browser we don't see the flickering */ $f9d8d8bd3b422c11$var$setCaretPosition(el, caretPos);
        timeout.current.setCaretTimeout = setTimeout(function() {
            if (el.value === currentValue && el.selectionStart !== caretPos) $f9d8d8bd3b422c11$var$setCaretPosition(el, caretPos);
        }, 0);
    };
    /* This keeps the caret within typing area so people can't type in between prefix or suffix */ var correctCaretPosition = function(value, caretPos, direction) {
        return $f9d8d8bd3b422c11$var$getCaretPosInBoundary(value, caretPos, getCaretBoundary(value), direction);
    };
    var getNewCaretPosition = function(inputValue, newFormattedValue, caretPos) {
        var caretBoundary = getCaretBoundary(newFormattedValue);
        var updatedCaretPos = $f9d8d8bd3b422c11$var$getCaretPosition(newFormattedValue, formattedValue, inputValue, caretPos, caretBoundary, isValidInputCharacter, isCharacterSame);
        //correct caret position if its outside of editable area
        updatedCaretPos = $f9d8d8bd3b422c11$var$getCaretPosInBoundary(newFormattedValue, updatedCaretPos, caretBoundary);
        return updatedCaretPos;
    };
    var updateValueAndCaretPosition = function(params) {
        var newFormattedValue = params.formattedValue;
        if (newFormattedValue === void 0) newFormattedValue = '';
        var input = params.input;
        var source = params.source;
        var event = params.event;
        var numAsString = params.numAsString;
        var caretPos;
        if (input) {
            var inputValue = params.inputValue || input.value;
            var currentCaretPosition = $f9d8d8bd3b422c11$var$geInputCaretPosition(input);
            /**
             * set the value imperatively, this is required for IE fix
             * This is also required as if new caret position is beyond the previous value.
             * Caret position will not be set correctly
             */ input.value = newFormattedValue;
            //get the caret position
            caretPos = getNewCaretPosition(inputValue, newFormattedValue, currentCaretPosition);
            //set caret position imperatively
            if (caretPos !== undefined) setPatchedCaretPosition(input, caretPos, newFormattedValue);
        }
        if (newFormattedValue !== formattedValue) // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
        _onValueChange(getValueObject(newFormattedValue, numAsString), {
            event: event,
            source: source
        });
    };
    /**
     * if the formatted value is not synced to parent, or if the formatted value is different from last synced value sync it
     * if the formatting props is removed, in which case last formatted value will be different from the numeric string value
     * in such case we need to inform the parent.
     */ (0, $acw62.useEffect)(function() {
        var ref = lastUpdatedValue.current;
        var lastFormattedValue = ref.formattedValue;
        var lastNumAsString = ref.numAsString;
        if (formattedValue !== lastFormattedValue || numAsString !== lastNumAsString) _onValueChange(getValueObject(formattedValue, numAsString), {
            event: undefined,
            source: $f9d8d8bd3b422c11$var$SourceType.props
        });
    }, [
        formattedValue,
        numAsString
    ]);
    // also if formatted value is changed from the props, we need to update the caret position
    // keep the last caret position if element is focused
    var currentCaretPosition = focusedElm.current ? $f9d8d8bd3b422c11$var$geInputCaretPosition(focusedElm.current) : undefined;
    // needed to prevent warning with useLayoutEffect on server
    var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
    useIsomorphicLayoutEffect(function() {
        var input = focusedElm.current;
        if (formattedValue !== lastUpdatedValue.current.formattedValue && input) {
            var caretPos = getNewCaretPosition(lastUpdatedValue.current.formattedValue, formattedValue, currentCaretPosition);
            /**
             * set the value imperatively, as we set the caret position as well imperatively.
             * This is to keep value and caret position in sync
             */ input.value = formattedValue;
            setPatchedCaretPosition(input, caretPos, formattedValue);
        }
    }, [
        formattedValue
    ]);
    var formatInputValue = function(inputValue, event, source) {
        var input = event.target;
        var changeRange = caretPositionBeforeChange.current ? $f9d8d8bd3b422c11$var$findChangedRangeFromCaretPositions(caretPositionBeforeChange.current, input.selectionEnd) : $f9d8d8bd3b422c11$var$findChangeRange(formattedValue, inputValue);
        var changeMeta = Object.assign(Object.assign({}, changeRange), {
            lastValue: formattedValue
        });
        var _numAsString = removeFormatting(inputValue, changeMeta);
        var _formattedValue = _format(_numAsString);
        // formatting can remove some of the number chars, so we need to fine number string again
        _numAsString = removeFormatting(_formattedValue, undefined);
        if (isAllowed && !isAllowed(getValueObject(_formattedValue, _numAsString))) {
            //reset the caret position
            var input$1 = event.target;
            var currentCaretPosition = $f9d8d8bd3b422c11$var$geInputCaretPosition(input$1);
            var caretPos = getNewCaretPosition(inputValue, formattedValue, currentCaretPosition);
            input$1.value = formattedValue;
            setPatchedCaretPosition(input$1, caretPos, formattedValue);
            return false;
        }
        updateValueAndCaretPosition({
            formattedValue: _formattedValue,
            numAsString: _numAsString,
            inputValue: inputValue,
            event: event,
            source: source,
            input: event.target
        });
        return true;
    };
    var setCaretPositionInfoBeforeChange = function(el, endOffset) {
        if (endOffset === void 0) endOffset = 0;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        caretPositionBeforeChange.current = {
            selectionStart: selectionStart,
            selectionEnd: selectionEnd + endOffset
        };
    };
    var _onChange = function(e) {
        var el = e.target;
        var inputValue = el.value;
        var changed = formatInputValue(inputValue, e, $f9d8d8bd3b422c11$var$SourceType.event);
        if (changed) onChange(e);
        // reset the position, as we have already handled the caret position
        caretPositionBeforeChange.current = undefined;
    };
    var _onKeyDown = function(e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        if (value === void 0) value = '';
        var expectedCaretPosition;
        //Handle backspace and delete against non numerical/decimal characters or arrow keys
        if (key === 'ArrowLeft' || key === 'Backspace') expectedCaretPosition = Math.max(selectionStart - 1, 0);
        else if (key === 'ArrowRight') expectedCaretPosition = Math.min(selectionStart + 1, value.length);
        else if (key === 'Delete') expectedCaretPosition = selectionStart;
        // if key is delete and text is not selected keep the end offset to 1, as it deletes one character
        // this is required as selection is not changed on delete case, which changes the change range calculation
        var endOffset = 0;
        if (key === 'Delete' && selectionStart === selectionEnd) endOffset = 1;
        var isArrowKey = key === 'ArrowLeft' || key === 'ArrowRight';
        //if expectedCaretPosition is not set it means we don't want to Handle keyDown
        // also if multiple characters are selected don't handle
        if (expectedCaretPosition === undefined || selectionStart !== selectionEnd && !isArrowKey) {
            onKeyDown(e);
            // keep information of what was the caret position before keyDown
            // set it after onKeyDown, in case parent updates the position manually
            setCaretPositionInfoBeforeChange(el, endOffset);
            return;
        }
        var newCaretPosition = expectedCaretPosition;
        if (isArrowKey) {
            var direction = key === 'ArrowLeft' ? 'left' : 'right';
            newCaretPosition = correctCaretPosition(value, expectedCaretPosition, direction);
            // arrow left or right only moves the caret, so no need to handle the event, if we are handling it manually
            if (newCaretPosition !== expectedCaretPosition) e.preventDefault();
        } else if (key === 'Delete' && !isValidInputCharacter(value[expectedCaretPosition])) // in case of delete go to closest caret boundary on the right side
        newCaretPosition = correctCaretPosition(value, expectedCaretPosition, 'right');
        else if (key === 'Backspace' && !isValidInputCharacter(value[expectedCaretPosition])) // in case of backspace go to closest caret boundary on the left side
        newCaretPosition = correctCaretPosition(value, expectedCaretPosition, 'left');
        if (newCaretPosition !== expectedCaretPosition) setPatchedCaretPosition(el, newCaretPosition, value);
        onKeyDown(e);
        setCaretPositionInfoBeforeChange(el, endOffset);
    };
    /** required to handle the caret position when click anywhere within the input **/ var _onMouseUp = function(e) {
        var el = e.target;
        /**
         * NOTE: we have to give default value for value as in case when custom input is provided
         * value can come as undefined when nothing is provided on value prop.
         */ var correctCaretPositionIfRequired = function() {
            var selectionStart = el.selectionStart;
            var selectionEnd = el.selectionEnd;
            var value = el.value;
            if (value === void 0) value = '';
            if (selectionStart === selectionEnd) {
                var caretPosition = correctCaretPosition(value, selectionStart);
                if (caretPosition !== selectionStart) setPatchedCaretPosition(el, caretPosition, value);
            }
        };
        correctCaretPositionIfRequired();
        // try to correct after selection has updated by browser
        // this case is required when user clicks on some position while a text is selected on input
        requestAnimationFrame(function() {
            correctCaretPositionIfRequired();
        });
        onMouseUp(e);
        setCaretPositionInfoBeforeChange(el);
    };
    var _onFocus = function(e) {
        // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
        // (onFocus event target selectionStart is always 0 before setTimeout)
        if (e.persist) e.persist();
        var el = e.target;
        var currentTarget = e.currentTarget;
        focusedElm.current = el;
        timeout.current.focusTimeout = setTimeout(function() {
            var selectionStart = el.selectionStart;
            var selectionEnd = el.selectionEnd;
            var value = el.value;
            if (value === void 0) value = '';
            var caretPosition = correctCaretPosition(value, selectionStart);
            //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
            if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) setPatchedCaretPosition(el, caretPosition, value);
            onFocus(Object.assign(Object.assign({}, e), {
                currentTarget: currentTarget
            }));
        }, 0);
    };
    var _onBlur = function(e) {
        focusedElm.current = null;
        clearTimeout(timeout.current.focusTimeout);
        clearTimeout(timeout.current.setCaretTimeout);
        onBlur(e);
    };
    // add input mode on element based on format prop and device once the component is mounted
    var inputMode = mounted && $f9d8d8bd3b422c11$var$addInputMode() ? 'numeric' : undefined;
    var inputProps = Object.assign({
        inputMode: inputMode
    }, otherProps, {
        type: type,
        value: formattedValue,
        onChange: _onChange,
        onKeyDown: _onKeyDown,
        onMouseUp: _onMouseUp,
        onFocus: _onFocus,
        onBlur: _onBlur
    });
    if (displayType === 'text') return renderText ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, renderText(formattedValue, otherProps) || null) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, otherProps, {
        ref: getInputRef
    }), formattedValue);
    else if (customInput) {
        var CustomInput = customInput;
        /* @ts-ignore */ return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CustomInput, Object.assign({}, inputProps, {
            ref: getInputRef
        }));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", Object.assign({}, inputProps, {
        ref: getInputRef
    }));
}
function $f9d8d8bd3b422c11$export$8afdc6404de1eded(numStr, props) {
    var decimalScale = props.decimalScale;
    var fixedDecimalScale = props.fixedDecimalScale;
    var prefix = props.prefix;
    if (prefix === void 0) prefix = '';
    var suffix = props.suffix;
    if (suffix === void 0) suffix = '';
    var allowNegative = props.allowNegative;
    var thousandsGroupStyle = props.thousandsGroupStyle;
    if (thousandsGroupStyle === void 0) thousandsGroupStyle = 'thousand';
    // don't apply formatting on empty string or '-'
    if (numStr === '' || numStr === '-') return numStr;
    var ref = $f9d8d8bd3b422c11$var$getSeparators(props);
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    /**
     * Keep the decimal separator
     * when decimalScale is not defined or non zero and the numStr has decimal in it
     * Or if decimalScale is > 0 and fixeDecimalScale is true (even if numStr has no decimal)
     */ var hasDecimalSeparator = decimalScale !== 0 && numStr.indexOf('.') !== -1 || decimalScale && fixedDecimalScale;
    var ref$1 = $f9d8d8bd3b422c11$var$splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$1.beforeDecimal;
    var afterDecimal = ref$1.afterDecimal;
    var addNegation = ref$1.addNegation; // eslint-disable-line prefer-const
    //apply decimal precision if its defined
    if (decimalScale !== undefined) afterDecimal = $f9d8d8bd3b422c11$var$limitToScale(afterDecimal, decimalScale, !!fixedDecimalScale);
    if (thousandSeparator) beforeDecimal = $f9d8d8bd3b422c11$var$applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    //add prefix and suffix when there is a number present
    if (prefix) beforeDecimal = prefix + beforeDecimal;
    if (suffix) afterDecimal = afterDecimal + suffix;
    //restore negation sign
    if (addNegation) beforeDecimal = '-' + beforeDecimal;
    numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;
    return numStr;
}
function $f9d8d8bd3b422c11$var$getSeparators(props) {
    var decimalSeparator = props.decimalSeparator;
    if (decimalSeparator === void 0) decimalSeparator = '.';
    var thousandSeparator = props.thousandSeparator;
    var allowedDecimalSeparators = props.allowedDecimalSeparators;
    if (thousandSeparator === true) thousandSeparator = ',';
    if (!allowedDecimalSeparators) allowedDecimalSeparators = [
        decimalSeparator,
        '.'
    ];
    return {
        decimalSeparator: decimalSeparator,
        thousandSeparator: thousandSeparator,
        allowedDecimalSeparators: allowedDecimalSeparators
    };
}
function $f9d8d8bd3b422c11$var$handleNegation(value, allowNegative) {
    if (value === void 0) value = '';
    var negationRegex = new RegExp('(-)');
    var doubleNegationRegex = new RegExp('(-)(.)*(-)');
    // Check number has '-' value
    var hasNegation = negationRegex.test(value);
    // Check number has 2 or more '-' values
    var removeNegation = doubleNegationRegex.test(value);
    //remove negation
    value = value.replace(/-/g, '');
    if (hasNegation && !removeNegation && allowNegative) value = '-' + value;
    return value;
}
function $f9d8d8bd3b422c11$var$getNumberRegex(decimalSeparator, global) {
    return new RegExp("(^-)|[0-9]|" + $f9d8d8bd3b422c11$var$escapeRegExp(decimalSeparator), global ? 'g' : undefined);
}
function $f9d8d8bd3b422c11$var$isNumericString(val, prefix, suffix) {
    // for empty value we can always treat it as numeric string
    if (val === '') return true;
    return !(prefix === null || prefix === void 0 ? void 0 : prefix.match(/\d/)) && !(suffix === null || suffix === void 0 ? void 0 : suffix.match(/\d/)) && typeof val === 'string' && !isNaN(Number(val));
}
function $f9d8d8bd3b422c11$export$bd06c53c8882f574(value, changeMeta, props) {
    var assign;
    if (changeMeta === void 0) changeMeta = $f9d8d8bd3b422c11$var$getDefaultChangeMeta(value);
    var allowNegative = props.allowNegative;
    var prefix = props.prefix;
    if (prefix === void 0) prefix = '';
    var suffix = props.suffix;
    if (suffix === void 0) suffix = '';
    var decimalScale = props.decimalScale;
    var from = changeMeta.from;
    var to = changeMeta.to;
    var start = to.start;
    var end = to.end;
    var ref = $f9d8d8bd3b422c11$var$getSeparators(props);
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var decimalSeparator = ref.decimalSeparator;
    var isBeforeDecimalSeparator = value[end] === decimalSeparator;
    /**
     * If only a number is added on empty input which matches with the prefix or suffix,
     * then don't remove it, just return the same
     */ if ($f9d8d8bd3b422c11$var$charIsNumber(value) && (value === prefix || value === suffix) && changeMeta.lastValue === '') return value;
    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */ if (end - start === 1 && allowedDecimalSeparators.indexOf(value[start]) !== -1) {
        var separator = decimalScale === 0 ? '' : decimalSeparator;
        value = value.substring(0, start) + separator + value.substring(start + 1, value.length);
    }
    var stripNegation = function(value, start, end) {
        /**
         * if prefix starts with - we don't allow negative number to avoid confusion
         * if suffix starts with - and the value length is same as suffix length, then the - sign is from the suffix
         * In other cases, if the value starts with - then it is a negation
         */ var hasNegation = false;
        var hasDoubleNegation = false;
        if (prefix.startsWith('-')) hasNegation = false;
        else if (value.startsWith('--')) {
            hasNegation = false;
            hasDoubleNegation = true;
        } else if (suffix.startsWith('-') && value.length === suffix.length) hasNegation = false;
        else if (value[0] === '-') hasNegation = true;
        var charsToRemove = hasNegation ? 1 : 0;
        if (hasDoubleNegation) charsToRemove = 2;
        // remove negation/double negation from start to simplify prefix logic as negation comes before prefix
        if (charsToRemove) {
            value = value.substring(charsToRemove);
            // account for the removal of the negation for start and end index
            start -= charsToRemove;
            end -= charsToRemove;
        }
        return {
            value: value,
            start: start,
            end: end,
            hasNegation: hasNegation
        };
    };
    var toMetadata = stripNegation(value, start, end);
    var hasNegation = toMetadata.hasNegation;
    assign = toMetadata, value = assign.value, start = assign.start, end = assign.end;
    var ref$1 = stripNegation(changeMeta.lastValue, from.start, from.end);
    var fromStart = ref$1.start;
    var fromEnd = ref$1.end;
    var lastValue = ref$1.value;
    // if only prefix and suffix part is updated reset the value to last value
    // if the changed range is from suffix in the updated value, and the the suffix starts with the same characters, allow the change
    var updatedSuffixPart = value.substring(start, end);
    if (value.length && lastValue.length && (fromStart > lastValue.length - suffix.length || fromEnd < prefix.length) && !(updatedSuffixPart && suffix.startsWith(updatedSuffixPart))) value = lastValue;
    /**
     * remove prefix
     * Remove whole prefix part if its present on the value
     * If the prefix is partially deleted (in which case change start index will be less the prefix length)
     * Remove only partial part of prefix.
     */ var startIndex = 0;
    if (value.startsWith(prefix)) startIndex += prefix.length;
    else if (start < prefix.length) startIndex = start;
    value = value.substring(startIndex);
    // account for deleted prefix for end
    end -= startIndex;
    /**
     * Remove suffix
     * Remove whole suffix part if its present on the value
     * If the suffix is partially deleted (in which case change end index will be greater than the suffixStartIndex)
     * remove the partial part of suffix
     */ var endIndex = value.length;
    var suffixStartIndex = value.length - suffix.length;
    if (value.endsWith(suffix)) endIndex = suffixStartIndex;
    else if (end > suffixStartIndex) endIndex = end;
    else if (end > value.length - suffix.length) endIndex = end;
    value = value.substring(0, endIndex);
    // add the negation back and handle for double negation
    value = $f9d8d8bd3b422c11$var$handleNegation(hasNegation ? "-" + value : value, allowNegative);
    // remove non numeric characters
    value = (value.match($f9d8d8bd3b422c11$var$getNumberRegex(decimalSeparator, true)) || []).join('');
    // replace the decimalSeparator with ., and only keep the first separator, ignore following ones
    var firstIndex = value.indexOf(decimalSeparator);
    value = value.replace(new RegExp($f9d8d8bd3b422c11$var$escapeRegExp(decimalSeparator), 'g'), function(match, index) {
        return index === firstIndex ? '.' : '';
    });
    //check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign
    var ref$2 = $f9d8d8bd3b422c11$var$splitDecimal(value, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const
    //clear only if something got deleted before decimal (cursor is before decimal)
    if (to.end - to.start < from.end - from.start && beforeDecimal === '' && isBeforeDecimalSeparator && !parseFloat(afterDecimal)) value = addNegation ? '-' : '';
    return value;
}
function $f9d8d8bd3b422c11$export$ce26457d42b8fa52(formattedValue, props) {
    var prefix = props.prefix;
    if (prefix === void 0) prefix = '';
    var suffix = props.suffix;
    if (suffix === void 0) suffix = '';
    var boundaryAry = Array.from({
        length: formattedValue.length + 1
    }).map(function() {
        return true;
    });
    var hasNegation = formattedValue[0] === '-';
    // fill for prefix and negation
    // Cap the fill range so we never exceed the array length when the formatted value
    // is just '-' (negation only, e.g. during intermediate typing with a multi-char prefix)
    boundaryAry.fill(false, 0, Math.min(prefix.length + (hasNegation ? 1 : 0), formattedValue.length));
    // fill for suffix
    var valLn = formattedValue.length;
    boundaryAry.fill(false, valLn - suffix.length + 1, valLn + 1);
    return boundaryAry;
}
function $f9d8d8bd3b422c11$var$validateAndUpdateProps(props) {
    var ref = $f9d8d8bd3b422c11$var$getSeparators(props);
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    // eslint-disable-next-line prefer-const
    var prefix = props.prefix;
    if (prefix === void 0) prefix = '';
    var allowNegative = props.allowNegative;
    if (allowNegative === void 0) allowNegative = true;
    if (thousandSeparator === decimalSeparator) throw new Error("\n        Decimal separator can't be same as thousand separator.\n        thousandSeparator: " + thousandSeparator + " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n        decimalSeparator: " + decimalSeparator + " (default value for decimalSeparator is .)\n     ");
    if (prefix.startsWith('-') && allowNegative) {
        // TODO: throw error in next major version
        console.error("\n      Prefix can't start with '-' when allowNegative is true.\n      prefix: " + prefix + "\n      allowNegative: " + allowNegative + "\n    ");
        allowNegative = false;
    }
    return Object.assign(Object.assign({}, props), {
        allowNegative: allowNegative
    });
}
function $f9d8d8bd3b422c11$export$2fb051e8b03d5d2d(props) {
    // validate props
    props = $f9d8d8bd3b422c11$var$validateAndUpdateProps(props);
    var _decimalSeparator = props.decimalSeparator;
    var _allowedDecimalSeparators = props.allowedDecimalSeparators;
    var thousandsGroupStyle = props.thousandsGroupStyle;
    var suffix = props.suffix;
    var allowNegative = props.allowNegative;
    var allowLeadingZeros = props.allowLeadingZeros;
    var onKeyDown = props.onKeyDown;
    if (onKeyDown === void 0) onKeyDown = $f9d8d8bd3b422c11$var$noop;
    var onBlur = props.onBlur;
    if (onBlur === void 0) onBlur = $f9d8d8bd3b422c11$var$noop;
    var thousandSeparator = props.thousandSeparator;
    var decimalScale = props.decimalScale;
    var fixedDecimalScale = props.fixedDecimalScale;
    var prefix = props.prefix;
    if (prefix === void 0) prefix = '';
    var defaultValue = props.defaultValue;
    var value = props.value;
    var valueIsNumericString = props.valueIsNumericString;
    var onValueChange = props.onValueChange;
    var restProps = $f9d8d8bd3b422c11$var$__rest(props, [
        "decimalSeparator",
        "allowedDecimalSeparators",
        "thousandsGroupStyle",
        "suffix",
        "allowNegative",
        "allowLeadingZeros",
        "onKeyDown",
        "onBlur",
        "thousandSeparator",
        "decimalScale",
        "fixedDecimalScale",
        "prefix",
        "defaultValue",
        "value",
        "valueIsNumericString",
        "onValueChange"
    ]);
    // get derived decimalSeparator and allowedDecimalSeparators
    var ref = $f9d8d8bd3b422c11$var$getSeparators(props);
    var decimalSeparator = ref.decimalSeparator;
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var _format = function(numStr) {
        return $f9d8d8bd3b422c11$export$8afdc6404de1eded(numStr, props);
    };
    var _removeFormatting = function(inputValue, changeMeta) {
        return $f9d8d8bd3b422c11$export$bd06c53c8882f574(inputValue, changeMeta, props);
    };
    var _value = $f9d8d8bd3b422c11$var$isNil(value) ? defaultValue : value;
    // try to figure out isValueNumericString based on format prop and value
    var _valueIsNumericString = valueIsNumericString !== null && valueIsNumericString !== void 0 ? valueIsNumericString : $f9d8d8bd3b422c11$var$isNumericString(_value, prefix, suffix);
    if (!$f9d8d8bd3b422c11$var$isNil(value)) _valueIsNumericString = _valueIsNumericString || typeof value === 'number';
    else if (!$f9d8d8bd3b422c11$var$isNil(defaultValue)) _valueIsNumericString = _valueIsNumericString || typeof defaultValue === 'number';
    var roundIncomingValueToPrecision = function(value) {
        if ($f9d8d8bd3b422c11$var$isNotValidValue(value)) return value;
        if (typeof value === 'number') value = $f9d8d8bd3b422c11$var$toNumericString(value);
        /**
         * only round numeric or float string values coming through props,
         * we don't need to do it for onChange events, as we want to prevent typing there
         */ if (_valueIsNumericString && typeof decimalScale === 'number') return $f9d8d8bd3b422c11$var$roundToPrecision(value, decimalScale, Boolean(fixedDecimalScale));
        return value;
    };
    var ref$1 = $f9d8d8bd3b422c11$var$useInternalValues(roundIncomingValueToPrecision(value), roundIncomingValueToPrecision(defaultValue), Boolean(_valueIsNumericString), _format, _removeFormatting, onValueChange);
    var ref$1_0 = ref$1[0];
    var numAsString = ref$1_0.numAsString;
    var formattedValue = ref$1_0.formattedValue;
    var _onValueChange = ref$1[1];
    var _onKeyDown = function(e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        if (value === void 0) value = '';
        // if user tries to delete partial prefix then ignore it
        // Exception: when value is just '-' (negation-only, no prefix shown yet), the cursor
        // is at position 1 which is < prefix.length for multi-char prefixes — we must allow
        // backspace to delete the lone negation sign in this state
        if ((key === 'Backspace' || key === 'Delete') && selectionEnd < prefix.length && value !== '-') {
            e.preventDefault();
            return;
        }
        // if multiple characters are selected and user hits backspace, no need to handle anything manually
        if (selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        // if user hits backspace, while the cursor is before prefix, and the input has negation, remove the negation
        if (key === 'Backspace' && value[0] === '-' && selectionStart === prefix.length + 1 && allowNegative) // bring the cursor to after negation
        $f9d8d8bd3b422c11$var$setCaretPosition(el, 1);
        // don't allow user to delete decimal separator when decimalScale and fixedDecimalScale is set
        if (decimalScale && fixedDecimalScale) {
            if (key === 'Backspace' && value[selectionStart - 1] === decimalSeparator) {
                $f9d8d8bd3b422c11$var$setCaretPosition(el, selectionStart - 1);
                e.preventDefault();
            } else if (key === 'Delete' && value[selectionStart] === decimalSeparator) e.preventDefault();
        }
        // if user presses the allowed decimal separator before the separator, move the cursor after the separator
        if ((allowedDecimalSeparators === null || allowedDecimalSeparators === void 0 ? void 0 : allowedDecimalSeparators.includes(key)) && value[selectionStart] === decimalSeparator) $f9d8d8bd3b422c11$var$setCaretPosition(el, selectionStart + 1);
        var _thousandSeparator = thousandSeparator === true ? ',' : thousandSeparator;
        // move cursor when delete or backspace is pressed before/after thousand separator
        if (key === 'Backspace' && value[selectionStart - 1] === _thousandSeparator) $f9d8d8bd3b422c11$var$setCaretPosition(el, selectionStart - 1);
        if (key === 'Delete' && value[selectionStart] === _thousandSeparator) $f9d8d8bd3b422c11$var$setCaretPosition(el, selectionStart + 1);
        onKeyDown(e);
    };
    var _onBlur = function(e) {
        var _value = numAsString;
        // if there no no numeric value, clear the input
        if (!_value.match(/\d/g)) _value = '';
        // clear leading 0s
        if (!allowLeadingZeros) _value = $f9d8d8bd3b422c11$var$fixLeadingZero(_value);
        // apply fixedDecimalScale on blur event
        if (fixedDecimalScale && decimalScale) _value = $f9d8d8bd3b422c11$var$roundToPrecision(_value, decimalScale, fixedDecimalScale);
        if (_value !== numAsString) {
            var formattedValue = $f9d8d8bd3b422c11$export$8afdc6404de1eded(_value, props);
            _onValueChange({
                formattedValue: formattedValue,
                value: _value,
                floatValue: parseFloat(_value)
            }, {
                event: e,
                source: $f9d8d8bd3b422c11$var$SourceType.event
            });
        }
        onBlur(e);
    };
    var isValidInputCharacter = function(inputChar) {
        if (inputChar === decimalSeparator) return true;
        return $f9d8d8bd3b422c11$var$charIsNumber(inputChar);
    };
    var isCharacterSame = function(ref) {
        var currentValue = ref.currentValue;
        var lastValue = ref.lastValue;
        var formattedValue = ref.formattedValue;
        var currentValueIndex = ref.currentValueIndex;
        var formattedValueIndex = ref.formattedValueIndex;
        var curChar = currentValue[currentValueIndex];
        var newChar = formattedValue[formattedValueIndex];
        /**
         * NOTE: as thousand separator and allowedDecimalSeparators can be same, we need to check on
         * typed range if we have typed any character from allowedDecimalSeparators, in that case we
         * consider different characters like , and . same within the range of updated value.
         */ var typedRange = $f9d8d8bd3b422c11$var$findChangeRange(lastValue, currentValue);
        var to = typedRange.to;
        // handle corner case where if we user types a decimal separator with fixedDecimalScale
        // and pass back float value the cursor jumps. #851
        var getDecimalSeparatorIndex = function(value) {
            return _removeFormatting(value).indexOf('.') + prefix.length;
        };
        if (value === 0 && fixedDecimalScale && decimalScale && currentValue[to.start] === decimalSeparator && getDecimalSeparatorIndex(currentValue) < currentValueIndex && getDecimalSeparatorIndex(formattedValue) > formattedValueIndex) return false;
        if (currentValueIndex >= to.start && currentValueIndex < to.end && allowedDecimalSeparators && allowedDecimalSeparators.includes(curChar) && newChar === decimalSeparator) return true;
        return curChar === newChar;
    };
    return Object.assign(Object.assign({}, restProps), {
        value: formattedValue,
        valueIsNumericString: false,
        isValidInputCharacter: isValidInputCharacter,
        isCharacterSame: isCharacterSame,
        onValueChange: _onValueChange,
        format: _format,
        removeFormatting: _removeFormatting,
        getCaretBoundary: function(formattedValue) {
            return $f9d8d8bd3b422c11$export$ce26457d42b8fa52(formattedValue, props);
        },
        onKeyDown: _onKeyDown,
        onBlur: _onBlur
    });
}
function $f9d8d8bd3b422c11$export$3437cf0602f97db7(props) {
    var numericFormatProps = $f9d8d8bd3b422c11$export$2fb051e8b03d5d2d(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f9d8d8bd3b422c11$export$dd1caf9b8ccbc158, Object.assign({}, numericFormatProps));
}
function $f9d8d8bd3b422c11$export$4b8d05d749baae10(numStr, props) {
    var format = props.format;
    var allowEmptyFormatting = props.allowEmptyFormatting;
    var mask = props.mask;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = '#';
    if (numStr === '' && !allowEmptyFormatting) return '';
    var hashCount = 0;
    var formattedNumberAry = format.split('');
    for(var i = 0, ln = format.length; i < ln; i++)if (format[i] === patternChar) {
        formattedNumberAry[i] = numStr[hashCount] || $f9d8d8bd3b422c11$var$getMaskAtIndex(mask, hashCount);
        hashCount += 1;
    }
    return formattedNumberAry.join('');
}
function $f9d8d8bd3b422c11$export$63600a84c223a8ea(value, changeMeta, props) {
    if (changeMeta === void 0) changeMeta = $f9d8d8bd3b422c11$var$getDefaultChangeMeta(value);
    var format = props.format;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = '#';
    var from = changeMeta.from;
    var to = changeMeta.to;
    var lastValue = changeMeta.lastValue;
    if (lastValue === void 0) lastValue = '';
    var isNumericSlot = function(caretPos) {
        return format[caretPos] === patternChar;
    };
    var removeFormatChar = function(string, startIndex) {
        var str = '';
        for(var i = 0; i < string.length; i++)if (isNumericSlot(startIndex + i) && $f9d8d8bd3b422c11$var$charIsNumber(string[i])) str += string[i];
        return str;
    };
    var extractNumbers = function(str) {
        return str.replace(/[^0-9]/g, '');
    };
    // if format doesn't have any number, remove all the non numeric characters
    if (!format.match(/\d/)) return extractNumbers(value);
    /**
     * if user paste the whole formatted text in an empty input or doing select all and paste, check if matches to the pattern
     * and remove the format characters, if there is a mismatch on the pattern, do plane number extract
     */ if ((lastValue === '' || from.end - from.start === lastValue.length) && value.length === format.length) {
        var str = '';
        for(var i = 0; i < value.length; i++){
            if (isNumericSlot(i)) {
                if ($f9d8d8bd3b422c11$var$charIsNumber(value[i])) str += value[i];
            } else if (value[i] !== format[i]) // if there is a mismatch on the pattern, do plane number extract
            return extractNumbers(value);
        }
        return str;
    }
    /**
     * For partial change,
     * where ever there is a change on the input, we can break the number in three parts
     * 1st: left part which is unchanged
     * 2nd: middle part which is changed
     * 3rd: right part which is unchanged
     *
     * The first and third section will be same as last value, only the middle part will change
     * We can consider on the change part all the new characters are non format characters.
     * And on the first and last section it can have partial format characters.
     *
     * We pick first and last section from the lastValue (as that has 1-1 mapping with format)
     * and middle one from the update value.
     */ var firstSection = lastValue.substring(0, from.start);
    var middleSection = value.substring(to.start, to.end);
    var lastSection = lastValue.substring(from.end);
    return "" + removeFormatChar(firstSection, 0) + extractNumbers(middleSection) + removeFormatChar(lastSection, from.end);
}
function $f9d8d8bd3b422c11$export$cbab503a3360c264(formattedValue, props) {
    var format = props.format;
    var mask = props.mask;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = '#';
    var boundaryAry = Array.from({
        length: formattedValue.length + 1
    }).map(function() {
        return true;
    });
    var hashCount = 0;
    var firstEmptySlot = -1;
    var maskAndIndexMap = {};
    format.split('').forEach(function(char, index) {
        var maskAtIndex = undefined;
        if (char === patternChar) {
            hashCount++;
            maskAtIndex = $f9d8d8bd3b422c11$var$getMaskAtIndex(mask, hashCount - 1);
            if (firstEmptySlot === -1 && formattedValue[index] === maskAtIndex) firstEmptySlot = index;
        }
        maskAndIndexMap[index] = maskAtIndex;
    });
    var isPosAllowed = function(pos) {
        // the position is allowed if the position is not masked and valid number area
        return format[pos] === patternChar && formattedValue[pos] !== maskAndIndexMap[pos];
    };
    for(var i = 0, ln = boundaryAry.length; i < ln; i++)// consider caret to be in boundary if it is before or after numeric value
    // Note: on pattern based format its denoted by patternCharacter
    // we should also allow user to put cursor on first empty slot
    boundaryAry[i] = i === firstEmptySlot || isPosAllowed(i) || isPosAllowed(i - 1);
    // the first patternChar position is always allowed
    boundaryAry[format.indexOf(patternChar)] = true;
    return boundaryAry;
}
function $f9d8d8bd3b422c11$var$validateProps(props) {
    var mask = props.mask;
    if (mask) {
        var maskAsStr = mask === 'string' ? mask : mask.toString();
        if (maskAsStr.match(/\d/g)) throw new Error("Mask " + mask + " should not contain numeric character;");
    }
}
function $f9d8d8bd3b422c11$var$isNumericString$1(val, format) {
    //we can treat empty string as numeric string
    if (val === '') return true;
    return !(format === null || format === void 0 ? void 0 : format.match(/\d/)) && typeof val === 'string' && (!!val.match(/^\d+$/) || val === '');
}
function $f9d8d8bd3b422c11$export$1290cfe2185b28c0(props) {
    var mask = props.mask;
    var allowEmptyFormatting = props.allowEmptyFormatting;
    var formatProp = props.format;
    var inputMode = props.inputMode;
    if (inputMode === void 0) inputMode = 'numeric';
    var onKeyDown = props.onKeyDown;
    if (onKeyDown === void 0) onKeyDown = $f9d8d8bd3b422c11$var$noop;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = '#';
    var value = props.value;
    var defaultValue = props.defaultValue;
    var valueIsNumericString = props.valueIsNumericString;
    var restProps = $f9d8d8bd3b422c11$var$__rest(props, [
        "mask",
        "allowEmptyFormatting",
        "format",
        "inputMode",
        "onKeyDown",
        "patternChar",
        "value",
        "defaultValue",
        "valueIsNumericString"
    ]);
    // validate props
    $f9d8d8bd3b422c11$var$validateProps(props);
    var _getCaretBoundary = function(formattedValue) {
        return $f9d8d8bd3b422c11$export$cbab503a3360c264(formattedValue, props);
    };
    var _onKeyDown = function(e) {
        var key = e.key;
        var el = e.target;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        // if multiple characters are selected and user hits backspace, no need to handle anything manually
        if (selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        // bring the cursor to closest numeric section
        var caretPos = selectionStart;
        // if backspace is pressed after the format characters, bring it to numeric section
        // if delete is pressed before the format characters, bring it to numeric section
        if (key === 'Backspace' || key === 'Delete') {
            var direction = 'right';
            if (key === 'Backspace') {
                while(caretPos > 0 && formatProp[caretPos - 1] !== patternChar)caretPos--;
                direction = 'left';
            } else {
                var formatLn = formatProp.length;
                while(caretPos < formatLn && formatProp[caretPos] !== patternChar)caretPos++;
                direction = 'right';
            }
            caretPos = $f9d8d8bd3b422c11$var$getCaretPosInBoundary(value, caretPos, _getCaretBoundary(value), direction);
        } else if (formatProp[caretPos] !== patternChar && key !== 'ArrowLeft' && key !== 'ArrowRight') // if user is typing on format character position, bring user to next allowed caret position
        caretPos = $f9d8d8bd3b422c11$var$getCaretPosInBoundary(value, caretPos + 1, _getCaretBoundary(value), 'right');
        // if we changing caret position, set the caret position
        if (caretPos !== selectionStart) $f9d8d8bd3b422c11$var$setCaretPosition(el, caretPos);
        onKeyDown(e);
    };
    // try to figure out isValueNumericString based on format prop and value
    var _value = $f9d8d8bd3b422c11$var$isNil(value) ? defaultValue : value;
    var isValueNumericString = valueIsNumericString !== null && valueIsNumericString !== void 0 ? valueIsNumericString : $f9d8d8bd3b422c11$var$isNumericString$1(_value, formatProp);
    var _props = Object.assign(Object.assign({}, props), {
        valueIsNumericString: isValueNumericString
    });
    return Object.assign(Object.assign({}, restProps), {
        value: value,
        defaultValue: defaultValue,
        valueIsNumericString: isValueNumericString,
        inputMode: inputMode,
        format: function(numStr) {
            return $f9d8d8bd3b422c11$export$4b8d05d749baae10(numStr, _props);
        },
        removeFormatting: function(inputValue, changeMeta) {
            return $f9d8d8bd3b422c11$export$63600a84c223a8ea(inputValue, changeMeta, _props);
        },
        getCaretBoundary: _getCaretBoundary,
        onKeyDown: _onKeyDown
    });
}
function $f9d8d8bd3b422c11$export$9e8c774149e1782b(props) {
    var patternFormatProps = $f9d8d8bd3b422c11$export$1290cfe2185b28c0(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f9d8d8bd3b422c11$export$dd1caf9b8ccbc158, Object.assign({}, patternFormatProps));
}


"use client";
//#region packages/@mantine/core/src/components/NumberInput/NumberInput.tsx
const $1efbc18c21cfd9a2$var$leadingDecimalZeroPattern = /^(0\.0*|-0(\.0*)?)$/;
const $1efbc18c21cfd9a2$var$leadingZerosPattern = /^-?0\d+(\.\d+)?\.?$/;
const $1efbc18c21cfd9a2$var$trailingZerosPattern = /\.\d*0$/;
const $1efbc18c21cfd9a2$var$trailingDecimalSeparatorPattern = /^-?\d+\.$/;
function $1efbc18c21cfd9a2$var$isNumberString(value) {
    return typeof value === "string" && value !== "" && !Number.isNaN(Number(value));
}
function $1efbc18c21cfd9a2$var$isBigIntValue(value) {
    return typeof value === "bigint";
}
function $1efbc18c21cfd9a2$var$canStep(value) {
    if (typeof value === "number") return value < Number.MAX_SAFE_INTEGER;
    return value === "" || $1efbc18c21cfd9a2$var$isNumberString(value) && Number(value) < Number.MAX_SAFE_INTEGER;
}
function $1efbc18c21cfd9a2$var$isValidBigIntString(value, allowNegative) {
    if (value === "") return false;
    if (value === "-") return false;
    if (!allowNegative && value.startsWith("-")) return false;
    return /^-?\d+$/.test(value);
}
function $1efbc18c21cfd9a2$var$canStepBigInt(value, allowNegative) {
    if (typeof value === "bigint") return true;
    return value === "" || $1efbc18c21cfd9a2$var$isValidBigIntString(value, allowNegative);
}
function $1efbc18c21cfd9a2$var$parseBigIntFromString(value) {
    if (!/^-?\d+$/.test(value)) return null;
    try {
        return BigInt(value);
    } catch  {
        return null;
    }
}
function $1efbc18c21cfd9a2$var$toBigIntOrUndefined(value) {
    if (typeof value === "bigint") return value;
    if (typeof value === "number" && Number.isFinite(value) && Number.isInteger(value)) return BigInt(value);
}
function $1efbc18c21cfd9a2$var$clampBigInt(value, min, max) {
    if (min !== void 0 && value < min) return min;
    if (max !== void 0 && value > max) return max;
    return value;
}
function $1efbc18c21cfd9a2$var$getTotalDigits(inputValue) {
    return inputValue.toString().replace(".", "").length;
}
function $1efbc18c21cfd9a2$var$isValidNumber(floatValue, value) {
    return (typeof floatValue === "number" ? floatValue < Number.MAX_SAFE_INTEGER : !Number.isNaN(Number(floatValue))) && !Number.isNaN(floatValue) && $1efbc18c21cfd9a2$var$getTotalDigits(value) < 14 && value !== "";
}
function $1efbc18c21cfd9a2$var$isInRange(value, min, max) {
    if (value === void 0) return true;
    return (min === void 0 || value >= min) && (max === void 0 || value <= max);
}
const $1efbc18c21cfd9a2$var$defaultProps = {
    size: "sm",
    step: 1,
    clampBehavior: "blur",
    allowDecimal: true,
    allowNegative: true,
    withKeyboardEvents: true,
    allowLeadingZeros: true,
    trimLeadingZeroesOnBlur: true,
    startValue: 0,
    allowedDecimalSeparators: [
        ".",
        ","
    ]
};
const $1efbc18c21cfd9a2$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size })=>({
        controls: {
            "--ni-chevron-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "ni-chevron-size")
        }
    }));
function $1efbc18c21cfd9a2$var$clampAndSanitizeInput(sanitizedValue, max, min) {
    const stringValue = sanitizedValue.toString();
    const hasTrailingDecimalSeparator = $1efbc18c21cfd9a2$var$trailingDecimalSeparatorPattern.test(stringValue);
    const replaced = stringValue.replace(/^0+(?=\d)/, "");
    const parsedValue = parseFloat(replaced);
    if (Number.isNaN(parsedValue)) return replaced;
    if (parsedValue > Number.MAX_SAFE_INTEGER) return max !== void 0 ? max : replaced;
    const clamped = (0, $65e289b30b587335$export$7d15b64cf5a3a4c4)(parsedValue, min, max);
    if (hasTrailingDecimalSeparator) return `${clamped.toString().replace(/^0+(?=\d)/, "")}.`;
    return clamped;
}
function $1efbc18c21cfd9a2$var$clampAndSanitizeBigIntInput(sanitizedValue, options) {
    if (sanitizedValue === "" || sanitizedValue === "-") return sanitizedValue;
    const parsed = $1efbc18c21cfd9a2$var$parseBigIntFromString(sanitizedValue);
    if (parsed === null) return sanitizedValue;
    return options.clampBehavior === "blur" ? $1efbc18c21cfd9a2$var$clampBigInt(parsed, options.min, options.max) : parsed;
}
const $1efbc18c21cfd9a2$export$6bf0cd3a219bbade = (0, $f1a4862560c68aef$export$3f239de2ecfaebe3)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)([
        "Input",
        "InputWrapper",
        "NumberInput"
    ], $1efbc18c21cfd9a2$var$defaultProps, _props);
    const { className: className, classNames: classNames, styles: styles, unstyled: unstyled, vars: vars, onChange: onChange, onValueChange: onValueChange, value: value, defaultValue: defaultValue, max: max, min: min, step: step, hideControls: hideControls, rightSection: rightSection, isAllowed: isAllowed, clampBehavior: clampBehavior, onBlur: onBlur, allowDecimal: allowDecimal, decimalScale: decimalScale, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, handlersRef: handlersRef, startValue: startValue, disabled: disabled, rightSectionPointerEvents: rightSectionPointerEvents, allowNegative: allowNegative, readOnly: readOnly, size: size, rightSectionWidth: rightSectionWidth, stepHoldInterval: stepHoldInterval, stepHoldDelay: stepHoldDelay, allowLeadingZeros: allowLeadingZeros, withKeyboardEvents: withKeyboardEvents, trimLeadingZeroesOnBlur: trimLeadingZeroesOnBlur, allowedDecimalSeparators: allowedDecimalSeparators, selectAllOnFocus: selectAllOnFocus, onMinReached: onMinReached, onMaxReached: onMaxReached, onFocus: onFocus, attributes: attributes, ref: ref, ...others } = props;
    const allowNegativeResolved = allowNegative ?? true;
    const allowLeadingZerosResolved = allowLeadingZeros ?? true;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "NumberInput",
        classes: (0, $d1d668c4eb2fee2f$export$2e2bcd8739ae039),
        props: props,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $1efbc18c21cfd9a2$var$varsResolver
    });
    const { resolvedClassNames: resolvedClassNames, resolvedStyles: resolvedStyles } = (0, $3da94ce37793f66c$export$92dc9b0c0bd35ec0)({
        classNames: classNames,
        styles: styles,
        props: props
    });
    const valueModeRef = (0, $acw62.useRef)($1efbc18c21cfd9a2$var$isBigIntValue(value) || $1efbc18c21cfd9a2$var$isBigIntValue(defaultValue) ? "bigint" : "number");
    if ($1efbc18c21cfd9a2$var$isBigIntValue(value)) valueModeRef.current = "bigint";
    else if (typeof value === "number") valueModeRef.current = "number";
    const isBigIntMode = valueModeRef.current === "bigint";
    const [_value, setValue] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: value,
        defaultValue: defaultValue,
        finalValue: "",
        onChange: onChange
    });
    const shouldUseStepInterval = stepHoldDelay !== void 0 && stepHoldInterval !== void 0;
    const inputRef = (0, $acw62.useRef)(null);
    const onStepTimeoutRef = (0, $acw62.useRef)(null);
    const stepCountRef = (0, $acw62.useRef)(0);
    const minNumber = typeof min === "number" ? min : void 0;
    const maxNumber = typeof max === "number" ? max : void 0;
    const stepNumber = typeof step === "number" ? step : $1efbc18c21cfd9a2$var$defaultProps.step;
    const startValueNumber = typeof startValue === "number" ? startValue : $1efbc18c21cfd9a2$var$defaultProps.startValue;
    const minBigInt = $1efbc18c21cfd9a2$var$toBigIntOrUndefined(min);
    const maxBigInt = $1efbc18c21cfd9a2$var$toBigIntOrUndefined(max);
    const stepBigInt = $1efbc18c21cfd9a2$var$toBigIntOrUndefined(step) ?? BigInt(1);
    const startValueBigInt = $1efbc18c21cfd9a2$var$toBigIntOrUndefined(startValue) ?? BigInt(0);
    const parseBigIntOrString = (inputValue)=>{
        if (!$1efbc18c21cfd9a2$var$isValidBigIntString(inputValue, allowNegativeResolved) || allowLeadingZerosResolved && $1efbc18c21cfd9a2$var$leadingZerosPattern.test(inputValue)) return inputValue;
        return $1efbc18c21cfd9a2$var$parseBigIntFromString(inputValue) ?? inputValue;
    };
    const getBigIntFloatValue = (inputValue)=>{
        const numericValue = Number(inputValue);
        return Number.isSafeInteger(numericValue) ? numericValue : void 0;
    };
    const handleValueChange = (payload, event)=>{
        if (event.source === "event") {
            if (isBigIntMode) setValue(parseBigIntOrString(payload.value));
            else setValue($1efbc18c21cfd9a2$var$isValidNumber(payload.floatValue, payload.value) && !$1efbc18c21cfd9a2$var$leadingDecimalZeroPattern.test(payload.value) && !(allowLeadingZerosResolved ? $1efbc18c21cfd9a2$var$leadingZerosPattern.test(payload.value) : false) && !$1efbc18c21cfd9a2$var$trailingZerosPattern.test(payload.value) && !$1efbc18c21cfd9a2$var$trailingDecimalSeparatorPattern.test(payload.value) ? payload.floatValue : payload.value);
        }
        onValueChange?.(payload, event);
    };
    const getDecimalPlaces = (inputValue)=>{
        const match = String(inputValue).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        if (!match) return 0;
        return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
    };
    const adjustCursor = (position)=>{
        if (inputRef.current && typeof position !== "undefined") inputRef.current.setSelectionRange(position, position);
    };
    const incrementRef = (0, $acw62.useRef)((0, $203042273dcf69c8$export$8793edee2d425525));
    incrementRef.current = ()=>{
        if (isBigIntMode) {
            if (!$1efbc18c21cfd9a2$var$canStepBigInt(_value, allowNegativeResolved)) return;
            let val;
            const currentValue = _value;
            if (typeof currentValue === "bigint") {
                const incrementedValue = currentValue + stepBigInt;
                if (maxBigInt !== void 0 && incrementedValue > maxBigInt) onMaxReached?.();
                val = maxBigInt !== void 0 && incrementedValue > maxBigInt ? maxBigInt : incrementedValue;
            } else if (typeof currentValue === "string" && currentValue !== "") {
                const parsed = $1efbc18c21cfd9a2$var$parseBigIntFromString(currentValue);
                if (parsed === null) return;
                const incrementedValue = parsed + stepBigInt;
                if (maxBigInt !== void 0 && incrementedValue > maxBigInt) onMaxReached?.();
                val = maxBigInt !== void 0 && incrementedValue > maxBigInt ? maxBigInt : incrementedValue;
            } else val = $1efbc18c21cfd9a2$var$clampBigInt(startValueBigInt, minBigInt, maxBigInt);
            const formattedValue = val.toString();
            setValue(val);
            onValueChange?.({
                floatValue: getBigIntFloatValue(val),
                formattedValue: formattedValue,
                value: formattedValue
            }, {
                source: "increment"
            });
            setTimeout(()=>adjustCursor(inputRef.current?.value.length), 0);
            return;
        }
        if (!$1efbc18c21cfd9a2$var$canStep(_value)) return;
        let val;
        const currentValuePrecision = getDecimalPlaces(_value);
        const stepPrecision = getDecimalPlaces(stepNumber);
        const maxPrecision = Math.max(currentValuePrecision, stepPrecision);
        const factor = 10 ** maxPrecision;
        if (!$1efbc18c21cfd9a2$var$isNumberString(_value) && (typeof _value !== "number" || Number.isNaN(_value))) val = (0, $65e289b30b587335$export$7d15b64cf5a3a4c4)(startValueNumber, minNumber, maxNumber);
        else if (maxNumber !== void 0) {
            const incrementedValue = (Math.round(Number(_value) * factor) + Math.round(stepNumber * factor)) / factor;
            if (incrementedValue > maxNumber) onMaxReached?.();
            val = incrementedValue <= maxNumber ? incrementedValue : maxNumber;
        } else val = (Math.round(Number(_value) * factor) + Math.round(stepNumber * factor)) / factor;
        const formattedValue = val.toFixed(maxPrecision);
        setValue(parseFloat(formattedValue));
        onValueChange?.({
            floatValue: parseFloat(formattedValue),
            formattedValue: formattedValue,
            value: formattedValue
        }, {
            source: "increment"
        });
        setTimeout(()=>adjustCursor(inputRef.current?.value.length), 0);
    };
    const decrementRef = (0, $acw62.useRef)((0, $203042273dcf69c8$export$8793edee2d425525));
    decrementRef.current = ()=>{
        if (isBigIntMode) {
            if (!$1efbc18c21cfd9a2$var$canStepBigInt(_value, allowNegativeResolved)) return;
            let val;
            const minValue = minBigInt !== void 0 ? minBigInt : !allowNegativeResolved ? BigInt(0) : void 0;
            const currentValue = _value;
            if (typeof currentValue === "bigint") {
                const decrementedValue = currentValue - stepBigInt;
                if (minValue !== void 0 && decrementedValue < minValue) onMinReached?.();
                val = minValue !== void 0 && decrementedValue < minValue ? minValue : decrementedValue;
            } else if (typeof currentValue === "string" && currentValue !== "") {
                const parsed = $1efbc18c21cfd9a2$var$parseBigIntFromString(currentValue);
                if (parsed === null) return;
                const decrementedValue = parsed - stepBigInt;
                if (minValue !== void 0 && decrementedValue < minValue) onMinReached?.();
                val = minValue !== void 0 && decrementedValue < minValue ? minValue : decrementedValue;
            } else val = $1efbc18c21cfd9a2$var$clampBigInt(startValueBigInt, minValue, maxBigInt);
            const formattedValue = val.toString();
            setValue(val);
            onValueChange?.({
                floatValue: getBigIntFloatValue(val),
                formattedValue: formattedValue,
                value: formattedValue
            }, {
                source: "decrement"
            });
            setTimeout(()=>adjustCursor(inputRef.current?.value.length), 0);
            return;
        }
        if (!$1efbc18c21cfd9a2$var$canStep(_value)) return;
        let val;
        const minValue = minNumber !== void 0 ? minNumber : !allowNegativeResolved ? 0 : Number.MIN_SAFE_INTEGER;
        const currentValuePrecision = getDecimalPlaces(_value);
        const stepPrecision = getDecimalPlaces(stepNumber);
        const maxPrecision = Math.max(currentValuePrecision, stepPrecision);
        const factor = 10 ** maxPrecision;
        if (!$1efbc18c21cfd9a2$var$isNumberString(_value) && typeof _value !== "number" || Number.isNaN(_value)) val = (0, $65e289b30b587335$export$7d15b64cf5a3a4c4)(startValueNumber, minValue, maxNumber);
        else {
            const decrementedValue = (Math.round(Number(_value) * factor) - Math.round(stepNumber * factor)) / factor;
            if (minValue !== void 0 && decrementedValue < minValue) onMinReached?.();
            val = minValue !== void 0 && decrementedValue < minValue ? minValue : decrementedValue;
        }
        const formattedValue = val.toFixed(maxPrecision);
        setValue(parseFloat(formattedValue));
        onValueChange?.({
            floatValue: parseFloat(formattedValue),
            formattedValue: formattedValue,
            value: formattedValue
        }, {
            source: "decrement"
        });
        setTimeout(()=>adjustCursor(inputRef.current?.value.length), 0);
    };
    const handlePaste = (event)=>{
        const pastedText = event.clipboardData.getData("text");
        const _decimalSeparator = others.decimalSeparator || ".";
        const separatorsToReplace = (allowedDecimalSeparators || [
            ".",
            ","
        ]).filter((s)=>s !== _decimalSeparator);
        if (separatorsToReplace.some((s)=>pastedText.includes(s))) {
            event.preventDefault();
            let modifiedText = pastedText;
            separatorsToReplace.forEach((s)=>{
                modifiedText = modifiedText.split(s).join(_decimalSeparator);
            });
            const input = inputRef.current;
            if (input) {
                const start = input.selectionStart ?? 0;
                const end = input.selectionEnd ?? 0;
                const currentValue = input.value;
                const newValue = currentValue.substring(0, start) + modifiedText + currentValue.substring(end);
                Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set?.call(input, newValue);
                input.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
                const cursorPos = start + modifiedText.length;
                setTimeout(()=>adjustCursor(cursorPos), 0);
            }
        }
        others.onPaste?.(event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown?.(event);
        if (readOnly || !withKeyboardEvents) return;
        if (event.key === "ArrowUp") {
            event.preventDefault();
            incrementRef.current?.();
        }
        if (event.key === "ArrowDown") {
            event.preventDefault();
            decrementRef.current?.();
        }
    };
    const handleKeyDownCapture = (event)=>{
        onKeyDownCapture?.(event);
        if (event.key === "Backspace") {
            const input = inputRef.current;
            if (input && input.selectionStart === 0 && input.selectionStart === input.selectionEnd) {
                event.preventDefault();
                window.setTimeout(()=>adjustCursor(0), 0);
            }
        }
    };
    const handleFocus = (event)=>{
        if (selectAllOnFocus) setTimeout(()=>event.currentTarget.select(), 0);
        onFocus?.(event);
    };
    const handleBlur = (event)=>{
        let sanitizedValue = _value;
        if (isBigIntMode) {
            if (clampBehavior === "blur" && typeof sanitizedValue === "bigint") sanitizedValue = $1efbc18c21cfd9a2$var$clampBigInt(sanitizedValue, minBigInt, maxBigInt);
            if (trimLeadingZeroesOnBlur && typeof sanitizedValue === "string") sanitizedValue = $1efbc18c21cfd9a2$var$clampAndSanitizeBigIntInput(sanitizedValue, {
                min: minBigInt,
                max: maxBigInt,
                clampBehavior: clampBehavior
            });
        } else {
            if (clampBehavior === "blur" && typeof sanitizedValue === "number") sanitizedValue = (0, $65e289b30b587335$export$7d15b64cf5a3a4c4)(sanitizedValue, minNumber, maxNumber);
            if (trimLeadingZeroesOnBlur && typeof sanitizedValue === "string" && getDecimalPlaces(sanitizedValue) < 15) sanitizedValue = $1efbc18c21cfd9a2$var$clampAndSanitizeInput(sanitizedValue, maxNumber, minNumber);
        }
        if (_value !== sanitizedValue) setValue(sanitizedValue);
        onBlur?.(event);
    };
    (0, $7034a45159125c0b$export$d734136a7b018efe)(handlersRef, {
        increment: incrementRef.current,
        decrement: decrementRef.current
    });
    const onStepHandleChange = (isIncrement)=>{
        if (isIncrement) incrementRef.current?.();
        else decrementRef.current?.();
        stepCountRef.current += 1;
    };
    const onStepLoop = (isIncrement)=>{
        onStepHandleChange(isIncrement);
        if (shouldUseStepInterval) {
            const interval = typeof stepHoldInterval === "number" ? stepHoldInterval : stepHoldInterval(stepCountRef.current);
            onStepTimeoutRef.current = window.setTimeout(()=>onStepLoop(isIncrement), interval);
        }
    };
    const onStep = (event, isIncrement)=>{
        event.preventDefault();
        inputRef.current?.focus();
        onStepHandleChange(isIncrement);
        if (shouldUseStepInterval) onStepTimeoutRef.current = window.setTimeout(()=>onStepLoop(isIncrement), stepHoldDelay);
    };
    const onStepDone = ()=>{
        if (onStepTimeoutRef.current) window.clearTimeout(onStepTimeoutRef.current);
        onStepTimeoutRef.current = null;
        stepCountRef.current = 0;
    };
    const controls = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ...getStyles("controls"),
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), {
                ...getStyles("control"),
                tabIndex: -1,
                "aria-hidden": true,
                disabled: disabled || typeof _value === "number" && maxNumber !== void 0 && _value >= maxNumber || typeof _value === "bigint" && maxBigInt !== void 0 && _value >= maxBigInt,
                mod: {
                    direction: "up"
                },
                onMouseDown: (event)=>event.preventDefault(),
                onPointerDown: (event)=>{
                    onStep(event, true);
                },
                onPointerUp: onStepDone,
                onPointerLeave: onStepDone,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $bb7ab0536b54b947$export$da0a9fe0e215031b), {
                    direction: "up"
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), {
                ...getStyles("control"),
                tabIndex: -1,
                "aria-hidden": true,
                disabled: disabled || typeof _value === "number" && minNumber !== void 0 && _value <= minNumber || typeof _value === "bigint" && minBigInt !== void 0 && _value <= minBigInt,
                mod: {
                    direction: "down"
                },
                onMouseDown: (event)=>event.preventDefault(),
                onPointerDown: (event)=>{
                    onStep(event, false);
                },
                onPointerUp: onStepDone,
                onPointerLeave: onStepDone,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $bb7ab0536b54b947$export$da0a9fe0e215031b), {
                    direction: "down"
                })
            })
        ]
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ebdc9ebef4cbe70e$export$36eab7f492831059), {
        component: (0, $f9d8d8bd3b422c11$export$3437cf0602f97db7),
        allowNegative: allowNegative,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $d1d668c4eb2fee2f$export$2e2bcd8739ae039).root, className),
        size: size,
        ...others,
        inputMode: isBigIntMode ? "numeric" : "decimal",
        readOnly: readOnly,
        disabled: disabled,
        value: typeof _value === "bigint" ? _value.toString() : _value,
        getInputRef: (0, $7034a45159125c0b$export$36a55fa7500f01f)(ref, inputRef),
        onValueChange: handleValueChange,
        rightSection: hideControls || readOnly || !(isBigIntMode ? $1efbc18c21cfd9a2$var$canStepBigInt(_value, allowNegativeResolved) : $1efbc18c21cfd9a2$var$canStep(_value)) ? rightSection : rightSection || controls,
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        unstyled: unstyled,
        __staticSelector: "NumberInput",
        decimalScale: isBigIntMode ? 0 : allowDecimal ? decimalScale : 0,
        onPaste: handlePaste,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyDownCapture: handleKeyDownCapture,
        rightSectionPointerEvents: rightSectionPointerEvents ?? (disabled ? "none" : void 0),
        rightSectionWidth: rightSectionWidth ?? `var(--ni-right-section-width-${size || "sm"})`,
        allowLeadingZeros: allowLeadingZeros,
        allowedDecimalSeparators: allowedDecimalSeparators,
        onBlur: handleBlur,
        attributes: attributes,
        isAllowed: (val)=>{
            if (!(isAllowed ? isAllowed(val) : true)) return false;
            if (clampBehavior !== "strict") return true;
            if (!isBigIntMode) return $1efbc18c21cfd9a2$var$isInRange(val.floatValue, minNumber, maxNumber);
            if (val.value === "" || val.value === "-") return true;
            const parsed = $1efbc18c21cfd9a2$var$parseBigIntFromString(val.value);
            if (parsed === null) return true;
            return (minBigInt === void 0 || parsed >= minBigInt) && (maxBigInt === void 0 || parsed <= maxBigInt);
        }
    });
});
$1efbc18c21cfd9a2$export$6bf0cd3a219bbade.classes = {
    ...(0, $ebdc9ebef4cbe70e$export$36eab7f492831059).classes,
    ...(0, $d1d668c4eb2fee2f$export$2e2bcd8739ae039)
};
$1efbc18c21cfd9a2$export$6bf0cd3a219bbade.varsResolver = $1efbc18c21cfd9a2$var$varsResolver;
$1efbc18c21cfd9a2$export$6bf0cd3a219bbade.displayName = "@mantine/core/NumberInput";




var $acw62 = parcelRequire("acw62");




function $c1eb5e5f1711cb86$export$a6e37c047f4a4354() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [licenseCount, setLicenseCount] = $acw62.useState(1);
    const cloudInfo = (0, $e9e66f0970a759b5$export$985c431ed65d8e6a)();
    const { data: distributorInfo, isPending: isPending, isError: isError } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: (0, $0fb2b9595b8b3089$export$e531c43d2585d3d6).distributorInfo,
        queryFn: ()=>(0, $0fb2b9595b8b3089$export$1f53e240b076325b).getDistributorInfo()
    });
    const checkoutMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async (count)=>{
            if (!distributorInfo) throw new Error("Distributor info should be defined");
            const sessionId = await (0, $0fb2b9595b8b3089$export$1f53e240b076325b).createDistributorStripeSession(count);
            const stripe = Stripe(cloudInfo.StripePublishableKey);
            const result = await stripe.redirectToCheckout({
                sessionId: sessionId
            });
            if (result.error) console.error(result.error.message);
        }
    });
    const updatePaymentInformation = (value)=>{
        const parsed = typeof value === "number" ? value : parseInt(value, 10);
        if (Number.isNaN(parsed)) return;
        setLicenseCount(parsed);
    };
    if (isPending) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: t("licenses.buyTitle"),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
            children: t("licenses.buyLoading")
        })
    });
    if (isError || !distributorInfo) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: t("licenses.buyTitle"),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
            c: "red",
            children: t("licenses.buyLoadError")
        })
    });
    const costo = cloudInfo.PriceForDistributors * licenseCount;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: t("licenses.buyTitle"),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "md",
            maw: 560,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    children: t("licenses.buyIntro", {
                        price: cloudInfo.PriceForDistributors,
                        recommended: cloudInfo.PriceRecommendedForDistributors
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1efbc18c21cfd9a2$export$6bf0cd3a219bbade), {
                    label: t("licenses.licenseCountLabel"),
                    id: "licenseCount",
                    name: "quantity",
                    min: 1,
                    max: 50,
                    step: 1,
                    value: licenseCount,
                    onChange: updatePaymentInformation
                }),
                licenseCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                    gap: "sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            children: t("licenses.costSummary", {
                                count: licenseCount,
                                cost: costo
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                            color: "green",
                            loading: checkoutMutation.isPending,
                            onClick: ()=>checkoutMutation.mutate(licenseCount),
                            children: t("licenses.buyButton", {
                                count: licenseCount
                            })
                        })
                    ]
                })
            ]
        })
    });
}







var $acw62 = parcelRequire("acw62");





const $689a5d6d9baa9f83$var$FAKE_EMAILS = [
    {
        action: "distributorSignUp",
        labelKey: "distributorSignUp"
    },
    {
        action: "activationLink",
        labelKey: "activationLink"
    },
    {
        action: "sendEmailLicense",
        labelKey: "sendEmailLicense"
    },
    {
        action: "sendCongratulationEmail",
        labelKey: "congratulationEmail"
    },
    {
        action: "sendBoughtLicensesMail",
        labelKey: "boughtLicensesMail"
    },
    {
        action: "sendDemoDownloadThankYou",
        labelKey: "demoDownloadThankYou"
    }
];
function $689a5d6d9baa9f83$export$8e1d1f87a83caab6() {
    const { t: t, i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const language = (0, $6c154842fccf6556$export$f38728011c178796)(i18n.resolvedLanguage ?? i18n.language);
    const [testAddress, setTestAddress] = $acw62.useState("");
    const { data: data, isPending: isPending, isError: isError } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            "fakeEmails",
            language
        ],
        queryFn: async ()=>Promise.all($689a5d6d9baa9f83$var$FAKE_EMAILS.map(async (email)=>({
                    ...email,
                    message: await (0, $0fb2b9595b8b3089$export$1f53e240b076325b).getFakeEmail(email.action, language)
                })))
    });
    const sendMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: (action)=>(0, $0fb2b9595b8b3089$export$1f53e240b076325b).sendFakeEmailTest(action, testAddress.trim(), language),
        onSuccess: (_data, action)=>{
            (0, $92225eae00b0597b$export$6008d97729a90c74).show({
                color: "green",
                message: t("fakeEmail.sendSuccess", {
                    email: testAddress.trim(),
                    action: action
                })
            });
        },
        onError: ()=>{
            (0, $92225eae00b0597b$export$6008d97729a90c74).show({
                color: "red",
                message: t("fakeEmail.sendError")
            });
        }
    });
    const canSend = testAddress.trim().length > 0 && !sendMutation.isPending;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: t("fakeEmail.title"),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "xl",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    size: "sm",
                    c: "dimmed",
                    children: t("fakeEmail.description")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                    label: t("fakeEmail.testAddress"),
                    placeholder: t("fakeEmail.testAddressPlaceholder"),
                    value: testAddress,
                    onChange: (event)=>setTestAddress(event.currentTarget.value),
                    type: "email",
                    maw: 420
                }),
                isPending && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    children: t("fakeEmail.loading")
                }),
                isError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    c: "red",
                    children: t("fakeEmail.loadError")
                }),
                data?.map((email)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                        gap: "xs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                justify: "space-between",
                                align: "center",
                                wrap: "wrap",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                        order: 4,
                                        children: t(`fakeEmail.${email.labelKey}`)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                        size: "xs",
                                        color: "brand",
                                        disabled: !canSend,
                                        loading: sendMutation.isPending && sendMutation.variables === email.action,
                                        onClick: ()=>sendMutation.mutate(email.action),
                                        children: t("fakeEmail.sendTest")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                        span: true,
                                        fw: 600,
                                        children: [
                                            t("fakeEmail.subject"),
                                            ":",
                                            " "
                                        ]
                                    }),
                                    email.message.subject
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                fw: 600,
                                children: [
                                    t("fakeEmail.body"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                title: t(`fakeEmail.${email.labelKey}`),
                                srcDoc: email.message.body,
                                style: {
                                    width: "100%",
                                    minHeight: 320,
                                    border: "1px solid var(--mantine-color-gray-4)",
                                    borderRadius: 4,
                                    background: "white"
                                }
                            })
                        ]
                    }, email.action)),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                    to: "/admin",
                    children: t("fakeEmail.backAdmin")
                })
            ]
        })
    });
}




parcelRequire("acw62");



var $07ad4a64764770d8$exports = {};
$07ad4a64764770d8$exports = import.meta.resolve("cp1eC");


function $a16b45f4e860f857$var$Question({ children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
        order: 2,
        mt: "md",
        size: "h5",
        children: children
    });
}
function $a16b45f4e860f857$var$Answer({ children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
        children: children
    });
}
function $a16b45f4e860f857$export$7562e752e5ef1fad() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "xs",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                    order: 1,
                    children: "FAQ"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                    href: $07ad4a64764770d8$exports,
                    children: t("portal.distributorInfo")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qGoogleAccount")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Answer, {
                    children: t("faq.aGoogleAccount")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qRequirements")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a16b45f4e860f857$var$Answer, {
                    children: [
                        t("faq.aRequirementsBefore"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                            to: "/distributorportal",
                            children: t("faq.aRequirementsLink")
                        }),
                        " ",
                        t("faq.aRequirementsAfter")
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qAnyoneCanSell")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Answer, {
                    children: t("faq.aAnyoneCanSell")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qHowManyDistributors")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Answer, {
                    children: t("faq.aHowManyDistributors")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qDistributorCost")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Answer, {
                    children: t("faq.aDistributorCost")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qRecommendedPrice")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Answer, {
                    children: t("faq.aRecommendedPrice")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qWhereToBuy")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a16b45f4e860f857$var$Answer, {
                    children: [
                        t("faq.aWhereToBuyBefore"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                            href: "https://www.dinlabel.com",
                            children: "www.dinlabel.com"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qHowBuyAsDistributor")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a16b45f4e860f857$var$Answer, {
                    children: [
                        t("faq.aHowBuyAsDistributorBefore"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                            to: "/distributorportal?focus=tutoriales",
                            children: t("faq.aHowBuyAsDistributorLink")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qMinimumLicenses")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Answer, {
                    children: t("faq.aMinimumLicenses")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qHowDeliver")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a16b45f4e860f857$var$Answer, {
                    children: [
                        t("faq.aHowDeliverBefore"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                            to: "/distributorportal",
                            children: t("faq.aHowDeliverSendLink")
                        }),
                        t("faq.aHowDeliverMiddle"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                            to: "/distributorportal?focus=tutoriales",
                            children: t("faq.aHowDeliverTutorialLink")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qHowLongPurchase")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Answer, {
                    children: t("faq.aHowLongPurchase")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qHowLongToSell")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Answer, {
                    children: t("faq.aHowLongToSell")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qHowManyAvailable")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a16b45f4e860f857$var$Answer, {
                    children: [
                        t("faq.aHowManyAvailableBefore"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                            to: "/distributorportal",
                            children: t("faq.aHowManyAvailableLink")
                        }),
                        " ",
                        t("faq.aHowManyAvailableAfter")
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qSoldLicenses")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a16b45f4e860f857$var$Answer, {
                    children: [
                        t("faq.aSoldLicensesBefore"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                            to: "/distributorportal",
                            children: t("faq.aSoldLicensesLink")
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qTryBefore")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a16b45f4e860f857$var$Answer, {
                    children: [
                        t("faq.aTryBeforeBefore"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                            href: "https://www.dinlabel.com/install",
                            children: "https://www.dinlabel.com/install"
                        }),
                        " ",
                        t("faq.aTryBeforeAfter")
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qMainFaq")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a16b45f4e860f857$var$Answer, {
                    children: [
                        t("faq.aMainFaqBefore"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                            href: "https://www.dinlabel.com/faq",
                            children: "https://www.dinlabel.com/faq"
                        }),
                        " ",
                        t("faq.aMainFaqAfter")
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qTutorials")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a16b45f4e860f857$var$Answer, {
                    children: [
                        t("faq.aTutorialsBefore"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                            href: "https://www.dinlabel.com/tutorials",
                            children: "https://www.dinlabel.com/tutorials"
                        }),
                        " ",
                        t("faq.aTutorialsAfter")
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qSupport")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Answer, {
                    children: t("faq.aSupport")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a16b45f4e860f857$var$Question, {
                    children: t("faq.qOtherQuestion")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a16b45f4e860f857$var$Answer, {
                    children: [
                        t("faq.aOtherQuestionBefore"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                            href: "mailto:support@dinlabel.com",
                            children: t("faq.aOtherQuestionLink")
                        }),
                        t("faq.aOtherQuestionAfter")
                    ]
                })
            ]
        })
    });
}










"use client";
//#region packages/@mantine/core/src/components/List/List.context.ts
const [$721b1134772bf440$export$9b0a72e5d41d62ec, $721b1134772bf440$export$b11084dc21db9fa4] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("List component was not found in tree");


"use client";
//#region packages/@mantine/core/src/components/List/List.module.css
var $c90c8251db4f64af$export$2e2bcd8739ae039 = {
    "root": "m_abbac491",
    "item": "m_abb6bec2",
    "itemWrapper": "m_75cd9f71",
    "itemIcon": "m_60f83e5b"
};








"use client";
//#region packages/@mantine/core/src/components/List/ListItem/ListItem.tsx
const $3ce466757a1a01b4$export$a7b06bfba60a8a78 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const { classNames: classNames, className: className, style: style, styles: styles, vars: vars, icon: icon, children: children, mod: mod, ...others } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ListItem", null, _props);
    const ctx = (0, $721b1134772bf440$export$b11084dc21db9fa4)();
    const _icon = icon || ctx.icon;
    const stylesApiProps = {
        classNames: classNames,
        styles: styles
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...ctx.getStyles("item", {
            ...stylesApiProps,
            className: className,
            style: style
        }),
        component: "li",
        mod: [
            {
                "with-icon": !!_icon,
                centered: ctx.center
            },
            mod
        ],
        ...others,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
            ...ctx.getStyles("itemWrapper", stylesApiProps),
            children: [
                _icon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                    ...ctx.getStyles("itemIcon", stylesApiProps),
                    children: _icon
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                    ...ctx.getStyles("itemLabel", stylesApiProps),
                    children: children
                })
            ]
        })
    });
});
$3ce466757a1a01b4$export$a7b06bfba60a8a78.classes = (0, $c90c8251db4f64af$export$2e2bcd8739ae039);
$3ce466757a1a01b4$export$a7b06bfba60a8a78.displayName = "@mantine/core/ListItem";



"use client";
//#region packages/@mantine/core/src/components/List/List.tsx
const $6a4218ccdfc87c17$var$defaultProps = {
    type: "unordered"
};
const $6a4218ccdfc87c17$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size, spacing: spacing })=>({
        root: {
            "--list-fz": (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--list-lh": (0, $fcab4af601ce7e99$export$56204a27a2958a55)(size),
            "--list-spacing": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(spacing)
        }
    }));
const $6a4218ccdfc87c17$export$54c2e3dc7acea9f5 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("List", $6a4218ccdfc87c17$var$defaultProps, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, children: children, type: type, withPadding: withPadding, icon: icon, spacing: spacing, center: center, listStyleType: listStyleType, mod: mod, attributes: attributes, ...others } = props;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "List",
        classes: (0, $c90c8251db4f64af$export$2e2bcd8739ae039),
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        attributes: attributes,
        vars: vars,
        varsResolver: $6a4218ccdfc87c17$var$varsResolver
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $721b1134772bf440$export$9b0a72e5d41d62ec), {
        value: {
            center: center,
            icon: icon,
            getStyles: getStyles
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
            ...getStyles("root", {
                style: {
                    listStyleType: listStyleType
                }
            }),
            component: type === "unordered" ? "ul" : "ol",
            mod: [
                {
                    "with-padding": withPadding,
                    type: icon ? "none" : listStyleType
                },
                mod
            ],
            ...others,
            children: children
        })
    });
});
$6a4218ccdfc87c17$export$54c2e3dc7acea9f5.classes = (0, $c90c8251db4f64af$export$2e2bcd8739ae039);
$6a4218ccdfc87c17$export$54c2e3dc7acea9f5.varsResolver = $6a4218ccdfc87c17$var$varsResolver;
$6a4218ccdfc87c17$export$54c2e3dc7acea9f5.displayName = "@mantine/core/List";
$6a4218ccdfc87c17$export$54c2e3dc7acea9f5.Item = (0, $3ce466757a1a01b4$export$a7b06bfba60a8a78);


/**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4a9488e46dc26332$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M5 12l5 5l10 -10",
            "key": "svg-0"
        }
    ]
];
const $4a9488e46dc26332$export$2e2bcd8739ae039 = (0, $181aa196ec8b5be7$export$2e2bcd8739ae039)("outline", "check", "Check", $4a9488e46dc26332$export$3efd853dbb351e94);

/**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dd69e2438ce7563c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M7 11l5 5l5 -5",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 4l0 12",
            "key": "svg-2"
        }
    ]
];
const $dd69e2438ce7563c$export$2e2bcd8739ae039 = (0, $181aa196ec8b5be7$export$2e2bcd8739ae039)("outline", "download", "Download", $dd69e2438ce7563c$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");







const $17d8fc5046c4600b$var$DOWNLOAD_URL = "https://labelmaster.azurewebsites.net/labelmaster/setup.exe";
const $17d8fc5046c4600b$var$SESSION_EMAIL_KEY = "demoDownloadEmail";
const $17d8fc5046c4600b$var$EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $17d8fc5046c4600b$var$panelStyle = {
    background: "white",
    border: "1px solid var(--mantine-color-gray-2)",
    borderRadius: "var(--mantine-radius-md)",
    boxShadow: "0 8px 32px rgba(44, 45, 48, 0.06)",
    height: "100%"
};
function $17d8fc5046c4600b$var$startDownload() {
    window.location.href = $17d8fc5046c4600b$var$DOWNLOAD_URL;
}
function $17d8fc5046c4600b$export$959d3514bbc6cfa8() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const user = (0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)();
    const isSignedIn = !!user;
    const alreadyBought = Boolean(user?.Bought);
    const [modalOpen, setModalOpen] = $acw62.useState(false);
    const [email, setEmail] = $acw62.useState("");
    const [submitting, setSubmitting] = $acw62.useState(false);
    const [error, setError] = $acw62.useState(null);
    const handleDownloadClick = $acw62.useCallback((event)=>{
        (0, $fbac34ae8aa6584b$export$ce30dbb46644d06c).logger.logReportData("InstallPageCtaClicked", {
            signedIn: isSignedIn,
            alreadyBought: alreadyBought
        });
        if (isSignedIn) return;
        event.preventDefault();
        const cached = sessionStorage.getItem($17d8fc5046c4600b$var$SESSION_EMAIL_KEY);
        if (cached) {
            $17d8fc5046c4600b$var$startDownload();
            return;
        }
        setError(null);
        setModalOpen(true);
    }, [
        isSignedIn,
        alreadyBought
    ]);
    const handleSubmit = async (event)=>{
        event.preventDefault();
        const trimmed = email.trim();
        if (!$17d8fc5046c4600b$var$EMAIL_REGEX.test(trimmed)) {
            setError(t("install.emailInvalid"));
            return;
        }
        setSubmitting(true);
        setError(null);
        try {
            await (0, $0fb2b9595b8b3089$export$1f53e240b076325b).recordDemoDownload(trimmed);
            sessionStorage.setItem($17d8fc5046c4600b$var$SESSION_EMAIL_KEY, trimmed);
            setModalOpen(false);
            $17d8fc5046c4600b$var$startDownload();
        } catch  {
            setError(t("install.emailSubmitError"));
        } finally{
            setSubmitting(false);
        }
    };
    const downloadButtonProps = isSignedIn ? {
        component: "a",
        href: $17d8fc5046c4600b$var$DOWNLOAD_URL
    } : {
        component: "button",
        onClick: handleDownloadClick
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        fullBleed: true,
        showFooter: true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                style: {
                    background: "linear-gradient(160deg, #fff8f2 0%, #ffffff 45%, #fff4eb 100%)",
                    minHeight: "calc(100vh - 60px - 160px)"
                },
                py: {
                    base: "xl",
                    md: 48
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
                    size: "lg",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                        gap: 48,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14), {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14).Col, {
                                        span: {
                                            base: 12,
                                            md: 7
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                            gap: "lg",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                                            order: 1,
                                                            c: "charcoal.8",
                                                            mb: "xs",
                                                            children: t("install.title")
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                            c: "dimmed",
                                                            size: "lg",
                                                            maw: 480,
                                                            children: t(alreadyBought ? "install.purchasedIntro" : "install.intro")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                                    gap: "md",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                                            ...downloadButtonProps,
                                                            size: "lg",
                                                            color: "brand",
                                                            leftSection: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd69e2438ce7563c$export$2e2bcd8739ae039), {
                                                                size: 20
                                                            }),
                                                            children: t("nav.download")
                                                        }),
                                                        !alreadyBought && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                                            to: "/buy",
                                                            size: "lg",
                                                            variant: "outline",
                                                            color: "charcoal",
                                                            children: t("install.buyApp")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    size: "sm",
                                                    c: "dimmed",
                                                    children: t("install.windowsNote")
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14).Col, {
                                        span: {
                                            base: 12,
                                            md: 5
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95f3644217e6673d$export$3e431a229df88919), {
                                            src: (0, $f59b44cc928cf883$export$98104c9ee0729143),
                                            alt: "DinLabel",
                                            maw: 360,
                                            mx: "auto",
                                            style: {
                                                filter: "drop-shadow(0 20px 40px rgba(44, 45, 48, 0.16))"
                                            }
                                        })
                                    })
                                ]
                            }),
                            !alreadyBought && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14).Col, {
                                        span: {
                                            base: 12,
                                            md: 6
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                            gap: "md",
                                            p: "xl",
                                            style: $17d8fc5046c4600b$var$panelStyle,
                                            align: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95f3644217e6673d$export$3e431a229df88919), {
                                                    src: (0, $f59b44cc928cf883$export$645a20fb1940aa5b),
                                                    alt: "",
                                                    maw: 200,
                                                    radius: "sm"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                                    order: 3,
                                                    c: "charcoal.8",
                                                    ta: "center",
                                                    children: t("install.freeTag")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    ta: "center",
                                                    size: "sm",
                                                    c: "dimmed",
                                                    maw: 320,
                                                    children: t("install.freeText")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                                    ...downloadButtonProps,
                                                    color: "brand",
                                                    fullWidth: true,
                                                    maw: 280,
                                                    leftSection: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd69e2438ce7563c$export$2e2bcd8739ae039), {
                                                        size: 18
                                                    }),
                                                    children: t("nav.download")
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14).Col, {
                                        span: {
                                            base: 12,
                                            md: 6
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                            gap: "md",
                                            p: "xl",
                                            align: "center",
                                            style: {
                                                ...$17d8fc5046c4600b$var$panelStyle,
                                                borderColor: "var(--mantine-color-brand-3)",
                                                boxShadow: "0 8px 32px rgba(242, 122, 33, 0.12)"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95f3644217e6673d$export$3e431a229df88919), {
                                                    src: (0, $f59b44cc928cf883$export$e15bfca9ec932e6d),
                                                    alt: "",
                                                    maw: 200,
                                                    radius: "sm"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                                    order: 3,
                                                    c: "charcoal.8",
                                                    ta: "center",
                                                    children: t("install.paidTitle")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    ta: "center",
                                                    size: "sm",
                                                    c: "dimmed",
                                                    maw: 320,
                                                    children: t("install.paidText")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                                    to: "/buy",
                                                    color: "brand",
                                                    fullWidth: true,
                                                    maw: 280,
                                                    children: t("install.buyApp")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                                p: "xl",
                                style: $17d8fc5046c4600b$var$panelStyle,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                        order: 3,
                                        c: "charcoal.8",
                                        mb: "md",
                                        children: t("install.signInTitle")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6a4218ccdfc87c17$export$54c2e3dc7acea9f5), {
                                        spacing: "sm",
                                        type: "ordered",
                                        c: "charcoal.7",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a4218ccdfc87c17$export$54c2e3dc7acea9f5).Item, {
                                                children: t("install.signInStep1")
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a4218ccdfc87c17$export$54c2e3dc7acea9f5).Item, {
                                                children: t("install.signInStep2")
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a4218ccdfc87c17$export$54c2e3dc7acea9f5).Item, {
                                                children: t("install.signInStep3")
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a4218ccdfc87c17$export$54c2e3dc7acea9f5).Item, {
                                                children: alreadyBought ? t("install.signInStep4") : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        t("install.signInStep4UnpurchasedBefore"),
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                                            to: "/buy",
                                                            c: "brand.7",
                                                            fw: 600,
                                                            children: t("install.signInStep4UnpurchasedLink")
                                                        }),
                                                        t("install.signInStep4UnpurchasedAfter")
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                                p: "xl",
                                style: $17d8fc5046c4600b$var$panelStyle,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                        order: 3,
                                        c: "charcoal.8",
                                        mb: "md",
                                        children: t("install.requirements")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6a4218ccdfc87c17$export$54c2e3dc7acea9f5), {
                                        spacing: "sm",
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a9488e46dc26332$export$2e2bcd8739ae039), {
                                            size: 16,
                                            color: "var(--mantine-color-brand-6)"
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a4218ccdfc87c17$export$54c2e3dc7acea9f5).Item, {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    c: "charcoal.7",
                                                    children: t("install.reqWindows")
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a4218ccdfc87c17$export$54c2e3dc7acea9f5).Item, {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    c: "charcoal.7",
                                                    children: t("install.reqInternet")
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a4218ccdfc87c17$export$54c2e3dc7acea9f5).Item, {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    c: "charcoal.7",
                                                    children: t("install.reqDisk")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !alreadyBought && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                ta: "center",
                                size: "sm",
                                c: "dimmed",
                                children: [
                                    t("install.orDistributor"),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                        to: "/viewdistributors",
                                        c: "brand.7",
                                        fw: 600,
                                        children: t("install.distributorsLink")
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b1b81586258b47fb$export$2b77a92f1a5ad772), {
                opened: modalOpen,
                onClose: ()=>!submitting && setModalOpen(false),
                title: t("install.emailModalTitle"),
                centered: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                    onSubmit: handleSubmit,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                        gap: "md",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                size: "sm",
                                c: "dimmed",
                                children: t("install.emailModalIntro")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                                label: t("install.emailLabel"),
                                type: "email",
                                value: email,
                                onChange: (e)=>setEmail(e.currentTarget.value),
                                required: true,
                                autoFocus: true,
                                disabled: submitting,
                                error: error
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                type: "submit",
                                color: "brand",
                                loading: submitting,
                                children: t("install.emailSubmit")
                            })
                        ]
                    })
                })
            })
        ]
    });
}




parcelRequire("acw62");






/**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4b539c3dd211070d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 7v-1a2 2 0 0 1 2 -2h2",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M4 17v1a2 2 0 0 0 2 2h2",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M16 4h2a2 2 0 0 1 2 2v1",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M16 20h2a2 2 0 0 0 2 -2v-1",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M5 11h1v2h-1l0 -2",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M10 11l0 2",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M14 11h1v2h-1l0 -2",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M19 11l0 2",
            "key": "svg-7"
        }
    ]
];
const $4b539c3dd211070d$export$2e2bcd8739ae039 = (0, $181aa196ec8b5be7$export$2e2bcd8739ae039)("outline", "barcode", "Barcode", $4b539c3dd211070d$export$3efd853dbb351e94);

/**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $01d2fbbd9c088558$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M11 6h9",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M11 12h9",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 18h8",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M6 10v-6l-2 2",
            "key": "svg-4"
        }
    ]
];
const $01d2fbbd9c088558$export$2e2bcd8739ae039 = (0, $181aa196ec8b5be7$export$2e2bcd8739ae039)("outline", "list-numbers", "ListNumbers", $01d2fbbd9c088558$export$3efd853dbb351e94);

/**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f3fd79dc88216e9c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M15 8h.01",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3",
            "key": "svg-3"
        }
    ]
];
const $f3fd79dc88216e9c$export$2e2bcd8739ae039 = (0, $181aa196ec8b5be7$export$2e2bcd8739ae039)("outline", "photo", "Photo", $f3fd79dc88216e9c$export$3efd853dbb351e94);

/**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a7a2016f2e0ee319$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M7 17l0 .01",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M14 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M7 7l0 .01",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M4 15a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M17 7l0 .01",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M14 14l3 0",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M20 14l0 .01",
            "key": "svg-7"
        }
    ],
    [
        "path",
        {
            "d": "M14 14l0 3",
            "key": "svg-8"
        }
    ],
    [
        "path",
        {
            "d": "M14 20l3 0",
            "key": "svg-9"
        }
    ],
    [
        "path",
        {
            "d": "M17 17l3 0",
            "key": "svg-10"
        }
    ],
    [
        "path",
        {
            "d": "M20 17l0 3",
            "key": "svg-11"
        }
    ]
];
const $a7a2016f2e0ee319$export$2e2bcd8739ae039 = (0, $181aa196ec8b5be7$export$2e2bcd8739ae039)("outline", "qrcode", "Qrcode", $a7a2016f2e0ee319$export$3efd853dbb351e94);

/**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $25268e463631a6a6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3 10h18",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M10 3v18",
            "key": "svg-2"
        }
    ]
];
const $25268e463631a6a6$export$2e2bcd8739ae039 = (0, $181aa196ec8b5be7$export$2e2bcd8739ae039)("outline", "table", "Table", $25268e463631a6a6$export$3efd853dbb351e94);

/**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c86dccb946dd0dbc$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 20l3 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M14 20l7 0",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M6.9 15l6.9 0",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M10.2 6.3l5.8 13.7",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M5 20l6 -16l2 0l7 16",
            "key": "svg-4"
        }
    ]
];
const $c86dccb946dd0dbc$export$2e2bcd8739ae039 = (0, $181aa196ec8b5be7$export$2e2bcd8739ae039)("outline", "typography", "Typography", $c86dccb946dd0dbc$export$3efd853dbb351e94);


parcelRequire("acw62");


const $ad814d46fd396e3b$var$BAR_PATTERN = [
    2,
    1,
    1,
    2,
    1,
    3,
    1,
    1,
    2,
    1,
    1,
    2,
    3,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    3,
    1,
    2,
    1,
    1,
    2,
    1,
    1,
    2,
    1,
    2,
    3,
    1,
    1,
    2,
    1,
    1,
    1,
    2
];
function $ad814d46fd396e3b$var$MiniBarcode({ className: className }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: className ?? "feature-mini-barcode",
        "aria-hidden": true,
        children: $ad814d46fd396e3b$var$BAR_PATTERN.map((w, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    flex: w
                }
            }, i))
    });
}
function $ad814d46fd396e3b$var$buildDecorativeQr(size = 21) {
    const grid = Array.from({
        length: size
    }, ()=>Array.from({
            length: size
        }, ()=>false));
    const inFinder = (r, c)=>r < 8 && c < 8 || r < 8 && c >= size - 8 || r >= size - 8 && c < 8;
    const placeFinder = (row, col)=>{
        for(let i = 0; i < 7; i++)for(let j = 0; j < 7; j++){
            const border = i === 0 || i === 6 || j === 0 || j === 6;
            const center = i >= 2 && i <= 4 && j >= 2 && j <= 4;
            grid[row + i][col + j] = border || center;
        }
    };
    placeFinder(0, 0);
    placeFinder(0, size - 7);
    placeFinder(size - 7, 0);
    for(let i = 8; i < size - 8; i++){
        grid[6][i] = i % 2 === 0;
        grid[i][6] = i % 2 === 0;
    }
    // Dark module near bottom-left finder (QR convention)
    grid[size - 8][8] = true;
    for(let r = 0; r < size; r++)for(let c = 0; c < size; c++){
        if (inFinder(r, c) || r === 6 || c === 6) continue;
        // Dense, deterministic fill so it reads as a QR code
        grid[r][c] = (r * 5 + c * 3 + r * c % 7) % 3 !== 0;
    }
    return grid.flat();
}
const $ad814d46fd396e3b$var$QR_CELLS = $ad814d46fd396e3b$var$buildDecorativeQr(21);
function $ad814d46fd396e3b$var$QrBlock() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "feature-qr",
        "aria-hidden": true,
        children: $ad814d46fd396e3b$var$QR_CELLS.map((on, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: on ? "on" : undefined
            }, i))
    });
}
function $ad814d46fd396e3b$var$FeaturePreview({ kind: kind }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    switch(kind){
        case "text":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "feature-label feature-label--text",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        size: "xs",
                        c: "dimmed",
                        children: t("marketing.featureDemo.productName")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        fw: 700,
                        fz: 18,
                        c: "charcoal.8",
                        lh: 1.2,
                        children: t("marketing.featureDemo.oliveOil")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        size: "sm",
                        c: "charcoal.6",
                        children: t("marketing.featureDemo.oliveOilDesc")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "feature-label-divider"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        size: "sm",
                        c: "charcoal.5",
                        fs: "italic",
                        style: {
                            fontFamily: "Georgia, 'Times New Roman', serif"
                        },
                        children: t("marketing.featureDemo.fontsNote")
                    })
                ]
            });
        case "barcode":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "feature-label feature-label--barcode",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "feature-barcode-stack",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad814d46fd396e3b$var$MiniBarcode, {
                            className: "feature-barcode-large"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            size: "xs",
                            ta: "center",
                            c: "charcoal.7",
                            ff: "monospace",
                            className: "feature-barcode-digits",
                            children: "1234456789906738"
                        })
                    ]
                })
            });
        case "qr":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "feature-label feature-label--qr",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad814d46fd396e3b$var$QrBlock, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        size: "xs",
                        ta: "center",
                        c: "charcoal.6",
                        mt: 8,
                        children: "www.website.com"
                    })
                ]
            });
        case "numbers":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "feature-label feature-label--numbers",
                children: [
                    1,
                    2,
                    3
                ].map((n)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "feature-seq-card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                size: "xs",
                                c: "dimmed",
                                ta: "center",
                                w: "100%",
                                children: t("marketing.featureDemo.sequence", {
                                    n: n
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                fw: 800,
                                fz: 22,
                                c: "charcoal.8",
                                lh: 1,
                                ta: "center",
                                children: String(n).padStart(3, "0")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad814d46fd396e3b$var$MiniBarcode, {})
                        ]
                    }, n))
            });
        case "variable":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "feature-label feature-label--variable",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "feature-var-row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t("marketing.featureDemo.client")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "feature-var-token",
                                children: [
                                    "[",
                                    t("marketing.featureDemo.name"),
                                    "]"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "feature-var-row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t("marketing.featureDemo.city")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "feature-var-token",
                                children: "[Madrid]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "feature-var-row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t("marketing.featureDemo.client")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "feature-var-token",
                                children: "[Mario]"
                            })
                        ]
                    })
                ]
            });
        case "images":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "feature-label feature-label--images",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                        gap: "sm",
                        align: "center",
                        wrap: "nowrap",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "feature-logo-mark",
                                "aria-hidden": true,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    viewBox: "0 0 40 40",
                                    width: "40",
                                    height: "40",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            cx: "20",
                                            cy: "20",
                                            r: "19",
                                            fill: "#f27a21",
                                            opacity: "0.15"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M20 8c-2.5 4-6 7-6 12a6 6 0 0012 0c0-5-3.5-8-6-12z",
                                            fill: "#f27a21"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M14 22c1.5 3 3.5 5 6 5s4.5-2 6-5",
                                            stroke: "#c45a10",
                                            strokeWidth: "1.5",
                                            fill: "none"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                fw: 700,
                                fz: 15,
                                c: "charcoal.8",
                                children: t("marketing.featureDemo.companyLogo")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "feature-logo-wave",
                        "aria-hidden": true
                    })
                ]
            });
    }
}
const $ad814d46fd396e3b$var$FEATURES = [
    {
        kind: "text",
        titleKey: "marketing.featureText",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c86dccb946dd0dbc$export$2e2bcd8739ae039), {
            size: 22,
            stroke: 1.6
        })
    },
    {
        kind: "barcode",
        titleKey: "marketing.featureBarcode",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b539c3dd211070d$export$2e2bcd8739ae039), {
            size: 22,
            stroke: 1.6
        }),
        to: "/barcodes"
    },
    {
        kind: "qr",
        titleKey: "marketing.featureQr",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7a2016f2e0ee319$export$2e2bcd8739ae039), {
            size: 22,
            stroke: 1.6
        }),
        to: "/barcodes"
    },
    {
        kind: "numbers",
        titleKey: "marketing.featureNumbers",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01d2fbbd9c088558$export$2e2bcd8739ae039), {
            size: 22,
            stroke: 1.6
        })
    },
    {
        kind: "variable",
        titleKey: "marketing.featureVariable",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25268e463631a6a6$export$2e2bcd8739ae039), {
            size: 22,
            stroke: 1.6
        })
    },
    {
        kind: "images",
        titleKey: "marketing.featureImages",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3fd79dc88216e9c$export$2e2bcd8739ae039), {
            size: 22,
            stroke: 1.6
        })
    }
];
function $ad814d46fd396e3b$var$FeatureCardBody({ kind: kind, title: title, icon: icon }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
        className: "marketing-feature feature-card",
        gap: "md",
        p: "lg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                justify: "space-between",
                align: "flex-start",
                wrap: "nowrap",
                gap: "sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                        order: 4,
                        c: "charcoal.8",
                        lh: 1.25,
                        maw: "80%",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "feature-card-icon",
                        children: icon
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad814d46fd396e3b$var$FeaturePreview, {
                kind: kind
            })
        ]
    });
}
function $ad814d46fd396e3b$export$90d02623f730cdca() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        className: "feature-cards-grid",
        children: $ad814d46fd396e3b$var$FEATURES.map((f)=>{
            const title = t(f.titleKey);
            if (!f.to) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad814d46fd396e3b$var$FeatureCardBody, {
                kind: f.kind,
                title: title,
                icon: f.icon
            }, f.kind);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5cec2af50e95548c$export$a6c7ac8248d6e38a), {
                to: f.to,
                className: "feature-card-link",
                "aria-label": `${title}. ${t("marketing.seeBarcodeTypes")}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad814d46fd396e3b$var$FeatureCardBody, {
                    kind: f.kind,
                    title: title,
                    icon: f.icon
                })
            }, f.kind);
        })
    });
}



function $999b7f0c70e160fa$export$c753c4e91c6407f6() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const alreadyBought = Boolean((0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)()?.Bought);
    const downloadLabel = alreadyBought ? t("nav.download") : t("nav.downloadDemo");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        fullBleed: true,
        showFooter: true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "marketing-hero",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
                    size: "lg",
                    className: "marketing-hero-inner",
                    py: "xl",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14), {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14).Col, {
                                span: {
                                    base: 12,
                                    md: 6
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                    gap: "lg",
                                    className: "marketing-hero-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                            order: 1,
                                            fz: {
                                                base: 42,
                                                sm: 52,
                                                md: 60
                                            },
                                            lh: 1.05,
                                            c: "charcoal.8",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    span: true,
                                                    c: "charcoal.5",
                                                    inherit: true,
                                                    children: "Din"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    span: true,
                                                    c: "brand.6",
                                                    inherit: true,
                                                    children: "Label"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                            order: 2,
                                            fz: {
                                                base: 22,
                                                sm: 26
                                            },
                                            fw: 500,
                                            c: "charcoal.7",
                                            style: {
                                                fontFamily: "var(--mantine-font-family)"
                                            },
                                            children: t("marketing.headline")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                            size: "lg",
                                            c: "dimmed",
                                            maw: 440,
                                            children: t("marketing.slogan")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                            gap: "md",
                                            className: "marketing-hero-ctas",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                                    to: "/install",
                                                    size: "lg",
                                                    color: "brand",
                                                    children: downloadLabel
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                                    to: "/buy",
                                                    size: "lg",
                                                    variant: "outline",
                                                    color: "charcoal",
                                                    children: t("nav.buy")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14).Col, {
                                span: {
                                    base: 12,
                                    md: 6
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                                    className: "marketing-hero-visual",
                                    ta: "center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95f3644217e6673d$export$3e431a229df88919), {
                                        src: (0, $f59b44cc928cf883$export$98104c9ee0729143),
                                        alt: "DinLabel",
                                        maw: 520,
                                        mx: "auto",
                                        style: {
                                            filter: "drop-shadow(0 24px 48px rgba(44, 45, 48, 0.18))"
                                        }
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                className: "marketing-section",
                bg: "white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
                    size: "lg",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                        gap: "xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                gap: "xs",
                                maw: 520,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                        order: 2,
                                        c: "charcoal.8",
                                        children: t("marketing.featuresTitle")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                        c: "dimmed",
                                        children: t("marketing.featuresSubtitle")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                        to: "/barcodes",
                                        fw: 600,
                                        underline: "hover",
                                        children: t("marketing.seeBarcodeTypes")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad814d46fd396e3b$export$90d02623f730cdca), {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                className: "marketing-section marketing-printers",
                bg: "charcoal.8",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
                    size: "lg",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                        gap: "lg",
                        maw: 720,
                        mx: "auto",
                        ta: "center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                order: 2,
                                c: "white",
                                children: t("marketing.printersTitle")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                c: "gray.4",
                                size: "lg",
                                children: t("marketing.printersSubtitle")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                gap: "md",
                                maw: 600,
                                mx: "auto",
                                ta: "left",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                        c: "brand.4",
                                        fw: 700,
                                        fz: {
                                            base: 16,
                                            sm: 18
                                        },
                                        children: t("marketing.printersTypesTitle")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                        gap: "sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                c: "gray.4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                        span: true,
                                                        fw: 700,
                                                        c: "white",
                                                        children: t("marketing.printersThermalLabel")
                                                    }),
                                                    " ",
                                                    t("marketing.printersThermalBody")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                c: "gray.4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                        span: true,
                                                        fw: 700,
                                                        c: "white",
                                                        children: t("marketing.printersLaserLabel")
                                                    }),
                                                    " ",
                                                    t("marketing.printersLaserBody")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                className: "marketing-section",
                style: {
                    background: "linear-gradient(180deg, #fff8f2 0%, #ffffff 100%)"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
                    size: "lg",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14), {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14).Col, {
                                span: {
                                    base: 12,
                                    md: 5
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95f3644217e6673d$export$3e431a229df88919), {
                                    src: (0, $f59b44cc928cf883$export$139a93f430d64a60),
                                    alt: "DinLabel",
                                    maw: 300,
                                    mx: "auto",
                                    radius: "md"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14).Col, {
                                span: {
                                    base: 12,
                                    md: 7
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                    gap: "md",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                            order: 2,
                                            c: "charcoal.8",
                                            children: t("marketing.whyTitle")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                            gap: "sm",
                                            maw: 520,
                                            children: [
                                                [
                                                    "whyCompatLabel",
                                                    "whyCompatBody"
                                                ],
                                                [
                                                    "whyCostLabel",
                                                    "whyCostBody"
                                                ],
                                                [
                                                    "whySupportLabel",
                                                    "whySupportBody"
                                                ]
                                            ].map(([labelKey, bodyKey])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    size: "lg",
                                                    c: "dimmed",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                            span: true,
                                                            fw: 700,
                                                            c: "charcoal.8",
                                                            children: t(`marketing.${labelKey}`)
                                                        }),
                                                        " ",
                                                        t(`marketing.${bodyKey}`)
                                                    ]
                                                }, labelKey))
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                py: 56,
                style: {
                    background: "var(--mantine-color-charcoal-8)"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
                    size: "lg",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                        justify: "space-between",
                        align: "center",
                        wrap: "wrap",
                        gap: "lg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                        order: 2,
                                        c: "white",
                                        mb: 6,
                                        children: t("marketing.tryTitle")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                        c: "gray.4",
                                        maw: 420,
                                        children: t("marketing.trySubtitle")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                to: "/install",
                                size: "lg",
                                color: "brand",
                                children: downloadLabel
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                className: "marketing-section",
                bg: "white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
                    size: "lg",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                        gap: "xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                order: 2,
                                ta: "center",
                                c: "charcoal.8",
                                children: t("marketing.needHelp")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14).Col, {
                                        span: {
                                            base: 12,
                                            sm: 6
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                            align: "center",
                                            gap: "sm",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95f3644217e6673d$export$3e431a229df88919), {
                                                    src: (0, $f59b44cc928cf883$export$e6344dfa848edfde),
                                                    alt: "",
                                                    w: 56
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                                    href: "mailto:support@dinlabel.com",
                                                    fw: 600,
                                                    c: "brand.7",
                                                    size: "lg",
                                                    children: t("marketing.customerService")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    ta: "center",
                                                    size: "sm",
                                                    c: "dimmed",
                                                    maw: 280,
                                                    children: t("marketing.customerServiceText")
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14).Col, {
                                        span: {
                                            base: 12,
                                            sm: 6
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                            align: "center",
                                            gap: "sm",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95f3644217e6673d$export$3e431a229df88919), {
                                                    src: (0, $f59b44cc928cf883$export$3ab7236b4bdc0f91),
                                                    alt: "",
                                                    w: 56
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                                    to: "/tutorials",
                                                    fw: 600,
                                                    c: "brand.7",
                                                    size: "lg",
                                                    children: t("nav.tutorials")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    ta: "center",
                                                    size: "sm",
                                                    c: "dimmed",
                                                    maw: 280,
                                                    children: t("marketing.tutorialsText")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}





parcelRequire("acw62");




function $848adf49191c8bc1$export$a95a8625616bcf5e() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { data: labels, isPending: isPending, isError: isError } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: (0, $0fb2b9595b8b3089$export$e531c43d2585d3d6).labels,
        queryFn: ()=>(0, $0fb2b9595b8b3089$export$1f53e240b076325b).getLabels()
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: t("myLabels.title"),
        children: [
            isError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                c: "red",
                children: t("myLabels.loadError")
            }),
            isPending && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                children: t("myLabels.loading")
            }),
            labels && labels.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                children: t("myLabels.empty")
            }),
            labels && labels.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Thead, {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tr, {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                    children: t("myLabels.name")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                    children: t("myLabels.date")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tbody, {
                        children: labels.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tr, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                            children: l.FileName
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                        children: new Date(l.CreatedDate).toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                            to: `/mylabels/view?fileId=${encodeURIComponent(l.PointerToBlob)}`,
                                            children: t("myLabels.view")
                                        })
                                    })
                                ]
                            }, l.PointerToBlob))
                    })
                ]
            })
        ]
    });
}
function $848adf49191c8bc1$export$d7711a32d964aeec() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [params] = (0, $5cec2af50e95548c$export$f1a78c17382fe22a)();
    const fileId = params.get("fileId") || "";
    const { data: label, isError: isError } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: (0, $0fb2b9595b8b3089$export$e531c43d2585d3d6).label(fileId),
        queryFn: ()=>(0, $0fb2b9595b8b3089$export$1f53e240b076325b).getLabel(fileId),
        enabled: !!fileId
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: t("myLabels.title"),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "md",
            children: [
                isError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    c: "red",
                    children: t("myLabels.loadError")
                }),
                label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                children: label.FileName
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                            href: `/api/file/download?fileId=${encodeURIComponent(label.PointerToBlob)}`,
                            children: t("myLabels.download")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                    to: "/mylabels",
                    children: t("myLabels.back")
                })
            ]
        })
    });
}








"use client";
//#region packages/@mantine/core/src/components/AspectRatio/AspectRatio.module.css
var $c21e3c82871a83fc$export$2e2bcd8739ae039 = {
    "root": "m_71ac47fc"
};



"use client";
//#region packages/@mantine/core/src/components/AspectRatio/AspectRatio.tsx
const $ce742f7700dbdcef$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { ratio: ratio })=>({
        root: {
            "--ar-ratio": ratio?.toString()
        }
    }));
const $ce742f7700dbdcef$export$e840e8869344ca38 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AspectRatio", null, _props);
    const { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, ratio: ratio, attributes: attributes, ...others } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        ...(0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
            name: "AspectRatio",
            classes: (0, $c21e3c82871a83fc$export$2e2bcd8739ae039),
            props: props,
            className: className,
            style: style,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            attributes: attributes,
            vars: vars,
            varsResolver: $ce742f7700dbdcef$var$varsResolver
        })("root"),
        ...others
    });
});
$ce742f7700dbdcef$export$e840e8869344ca38.classes = (0, $c21e3c82871a83fc$export$2e2bcd8739ae039);
$ce742f7700dbdcef$export$e840e8869344ca38.varsResolver = $ce742f7700dbdcef$var$varsResolver;
$ce742f7700dbdcef$export$e840e8869344ca38.displayName = "@mantine/core/AspectRatio";



/**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3b17baffcb070405$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M14 3v4a1 1 0 0 0 1 1h4",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M9 9l1 0",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M9 13l6 0",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M9 17l6 0",
            "key": "svg-4"
        }
    ]
];
const $3b17baffcb070405$export$2e2bcd8739ae039 = (0, $181aa196ec8b5be7$export$2e2bcd8739ae039)("outline", "file-text", "FileText", $3b17baffcb070405$export$3efd853dbb351e94);

/**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ec5bb0f44884c42f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3 7l9 6l9 -6",
            "key": "svg-1"
        }
    ]
];
const $ec5bb0f44884c42f$export$2e2bcd8739ae039 = (0, $181aa196ec8b5be7$export$2e2bcd8739ae039)("outline", "mail", "Mail", $ec5bb0f44884c42f$export$3efd853dbb351e94);

/**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1a8e3f49c5cef145$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M15 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M17 17h-11v-14h-2",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M6 5l14 1l-1 7h-13",
            "key": "svg-3"
        }
    ]
];
const $1a8e3f49c5cef145$export$2e2bcd8739ae039 = (0, $181aa196ec8b5be7$export$2e2bcd8739ae039)("outline", "shopping-cart", "ShoppingCart", $1a8e3f49c5cef145$export$3efd853dbb351e94);




var $acw62 = parcelRequire("acw62");











parcelRequire("acw62");


function $1b1e0d87449cf89d$export$d9f01d0b8741578e() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
        gap: "md",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                        order: 3,
                        c: "charcoal.8",
                        mb: "xs",
                        children: t("register.title")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        c: "dimmed",
                        children: t("register.intro")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                href: $07ad4a64764770d8$exports,
                c: "brand.7",
                fw: 600,
                w: "fit-content",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    style: {
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b17baffcb070405$export$2e2bcd8739ae039), {
                            size: 16
                        }),
                        t("portal.distributorInfo")
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                id: "form",
                action: "/distributor/signup",
                method: "post",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                    gap: "sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                            label: t("register.company"),
                            id: "companyName",
                            name: "companyName",
                            placeholder: t("register.companyPlaceholder")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                            label: t("register.phone"),
                            id: "phoneNumber",
                            name: "phoneNumber",
                            placeholder: t("register.phonePlaceholder"),
                            description: t("register.phoneDescription")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                            label: t("register.street"),
                            id: "street",
                            name: "street",
                            placeholder: t("register.street1Placeholder")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                            label: t("register.street"),
                            id: "street2",
                            name: "street2",
                            placeholder: t("register.street2Placeholder")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                            label: t("register.number"),
                            id: "number",
                            name: "number",
                            placeholder: t("register.number")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                            label: t("register.city"),
                            id: "city",
                            name: "city",
                            placeholder: t("register.city")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                            label: t("register.state"),
                            id: "state",
                            name: "state",
                            placeholder: t("register.state")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                            label: t("register.country"),
                            id: "country",
                            name: "country",
                            placeholder: t("register.country")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                            label: t("register.zip"),
                            id: "zip",
                            name: "zip",
                            placeholder: t("register.zip")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                            label: t("register.rfc"),
                            id: "businessId",
                            name: "businessId",
                            placeholder: t("register.rfc")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            c: "dimmed",
                            size: "sm",
                            children: t("register.nextSteps")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                            type: "submit",
                            color: "brand",
                            children: t("register.submit")
                        })
                    ]
                })
            })
        ]
    });
}



const $2b9eedf2a30bb436$var$panelStyle = {
    background: "white",
    border: "1px solid var(--mantine-color-gray-2)",
    borderRadius: "var(--mantine-radius-md)",
    boxShadow: "0 8px 28px rgba(44, 45, 48, 0.05)"
};
function $2b9eedf2a30bb436$var$StatCard({ label: label, value: value, accent: accent }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        p: "lg",
        style: {
            background: "white",
            border: accent ? "1px solid var(--mantine-color-brand-3)" : "1px solid var(--mantine-color-gray-2)",
            borderRadius: "var(--mantine-radius-md)",
            boxShadow: "0 8px 28px rgba(44, 45, 48, 0.05)",
            flex: 1,
            minWidth: 140
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                size: "sm",
                c: "dimmed",
                fw: 500,
                mb: 4,
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                fz: 32,
                fw: 700,
                c: accent ? "brand.7" : "charcoal.8",
                style: {
                    fontFamily: "var(--mantine-font-family-headings)"
                },
                lh: 1.1,
                children: value
            })
        ]
    });
}
function $2b9eedf2a30bb436$var$openAlertModal(options) {
    (0, $6de41693d1c89b64$export$3d96f1ad58688d8).open({
        title: options.title,
        centered: true,
        onClose: options.onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "md",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    size: "sm",
                    children: options.message
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                    color: options.color ?? "brand",
                    onClick: ()=>{
                        (0, $6de41693d1c89b64$export$3d96f1ad58688d8).closeAll();
                    },
                    children: "OK"
                })
            ]
        })
    });
}
function $2b9eedf2a30bb436$export$c7cafd7de5097e70() {
    const { t: t, i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const userInfo = (0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)();
    const [searchParams] = (0, $5cec2af50e95548c$export$f1a78c17382fe22a)();
    const { data: distributorInfo, isPending: isPending, isError: isError } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: (0, $0fb2b9595b8b3089$export$e531c43d2585d3d6).distributorInfo,
        queryFn: ()=>(0, $0fb2b9595b8b3089$export$1f53e240b076325b).getDistributorInfo(),
        enabled: !!userInfo
    });
    $acw62.useEffect(()=>{
        if (!distributorInfo || searchParams.get("focus") !== "tutoriales") return;
        const el = document.getElementById("tutoriales");
        el?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }, [
        distributorInfo,
        searchParams
    ]);
    const resendMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: ({ rowKey: rowKey, partitionKey: partitionKey, email: email })=>(0, $0fb2b9595b8b3089$export$1f53e240b076325b).resendLicencia(rowKey, partitionKey, email)
    });
    const sendMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: (mail)=>(0, $0fb2b9595b8b3089$export$1f53e240b076325b).sendLicencia(mail),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: (0, $0fb2b9595b8b3089$export$e531c43d2585d3d6).distributorInfo
            });
        }
    });
    const resendLicense = (rowKey, partitionKey, email)=>{
        if (!distributorInfo || !userInfo) throw new Error("Distributor info should be defined");
        (0, $fbac34ae8aa6584b$export$ce30dbb46644d06c).logger.info("Enviando licencia...");
        (0, $6de41693d1c89b64$export$3d96f1ad58688d8).openConfirmModal({
            title: t("licenses.sendTitle"),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                size: "sm",
                children: t("licenses.resendConfirm", {
                    email: email
                })
            }),
            labels: {
                confirm: t("dialogs.confirmYes"),
                cancel: t("dialogs.cancel")
            },
            confirmProps: {
                color: "brand"
            },
            centered: true,
            onConfirm: ()=>{
                (async ()=>{
                    try {
                        await resendMutation.mutateAsync({
                            rowKey: rowKey,
                            partitionKey: partitionKey,
                            email: email
                        });
                    } catch (error) {
                        $2b9eedf2a30bb436$var$openAlertModal({
                            title: t("licenses.errorTitle"),
                            message: t("licenses.sendError", {
                                error: (0, $876e57a8c3918f9f$export$3e3c8cccd287b2b2)(error)
                            }),
                            color: "red"
                        });
                        return;
                    }
                    $2b9eedf2a30bb436$var$openAlertModal({
                        title: t("licenses.resentTitle"),
                        message: t("licenses.resentMessage", {
                            email: email,
                            cc: distributorInfo.CloudUser.AccountEmail
                        }),
                        color: "brand"
                    });
                })();
            }
        });
    };
    const onEnviarLicenciasClick = ()=>{
        if (!distributorInfo || !userInfo) throw new Error("Distributor info should be defined");
        (0, $fbac34ae8aa6584b$export$ce30dbb46644d06c).logger.info("Enviando licencia...");
        let emailValue = "";
        (0, $6de41693d1c89b64$export$3d96f1ad58688d8).openConfirmModal({
            title: t("licenses.sendTitle"),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        size: "sm",
                        mb: "sm",
                        children: t("licenses.sendPrompt")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                        placeholder: t("licenses.emailPlaceholder"),
                        "data-autofocus": true,
                        onChange: (event)=>{
                            emailValue = event.currentTarget.value;
                        }
                    })
                ]
            }),
            labels: {
                confirm: t("dialogs.send"),
                cancel: t("dialogs.cancel")
            },
            confirmProps: {
                color: "brand"
            },
            centered: true,
            onConfirm: ()=>{
                const mail = emailValue.trim();
                if (!mail) return;
                (async ()=>{
                    try {
                        await sendMutation.mutateAsync(mail);
                    } catch (error) {
                        $2b9eedf2a30bb436$var$openAlertModal({
                            title: t("licenses.errorTitle"),
                            message: t("licenses.sendError", {
                                error: (0, $876e57a8c3918f9f$export$3e3c8cccd287b2b2)(error)
                            }),
                            color: "red"
                        });
                        return;
                    }
                    $2b9eedf2a30bb436$var$openAlertModal({
                        title: t("licenses.sentTitle"),
                        message: t("licenses.sentMessage", {
                            email: mail,
                            cc: distributorInfo.CloudUser.AccountEmail
                        }),
                        color: "brand"
                    });
                })();
            }
        });
    };
    const renderLicensesSentTable = (info)=>{
        if (info.DistributorLicenseMailMappings.length <= 0) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
            p: "xl",
            style: $2b9eedf2a30bb436$var$panelStyle,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                    order: 4,
                    c: "charcoal.8",
                    mb: "md",
                    children: t("licenses.sentHistory")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).ScrollContainer, {
                    minWidth: 560,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d), {
                        striped: true,
                        highlightOnHover: true,
                        verticalSpacing: "sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Thead, {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tr, {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                            children: t("licenses.recipient")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                            children: t("licenses.date")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                            children: t("licenses.sent")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Th, {
                                            children: t("licenses.activated")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tbody, {
                                children: info.DistributorLicenseMailMappings.map((row)=>{
                                    const sentDate = new Date(row.InsertionTime);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Tr, {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    size: "sm",
                                                    fw: 500,
                                                    children: row.LicenseInvitationEmail
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    size: "sm",
                                                    c: "dimmed",
                                                    children: sentDate.toLocaleDateString(i18n.language)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a9488e46dc26332$export$2e2bcd8739ae039), {
                                                    size: 18,
                                                    color: "var(--mantine-color-green-6)"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $721ee3a0af31156e$export$54ec01a60f47d33d).Td, {
                                                children: [
                                                    !row.AcceptedByUserId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                                        gap: "xs",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b24692670674b261$export$37acb3580601e69a), {
                                                                color: "orange",
                                                                variant: "light",
                                                                w: "fit-content",
                                                                children: t("licenses.notActivated")
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                                                color: "brand",
                                                                size: "xs",
                                                                variant: "light",
                                                                w: "fit-content",
                                                                loading: resendMutation.isPending && resendMutation.variables?.rowKey === row.LicenseId,
                                                                onClick: ()=>{
                                                                    resendLicense(row.LicenseId, info.CloudUser.UserId, row.LicenseInvitationEmail);
                                                                },
                                                                children: t("licenses.resend")
                                                            })
                                                        ]
                                                    }),
                                                    row.AcceptedByUserId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b24692670674b261$export$37acb3580601e69a), {
                                                        color: "green",
                                                        variant: "light",
                                                        leftSection: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a9488e46dc26332$export$2e2bcd8739ae039), {
                                                            size: 12
                                                        }),
                                                        children: t("licenses.activatedYes")
                                                    })
                                                ]
                                            })
                                        ]
                                    }, row.LicenseId);
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    const renderAuthorizedContent = (info)=>{
        const sent = info.LicensesBought - info.AvailableLicenses;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "lg",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                    gap: "md",
                    align: "stretch",
                    wrap: "wrap",
                    grow: true,
                    preventGrowOverflow: false,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2b9eedf2a30bb436$var$StatCard, {
                            label: t("licenses.statAvailable"),
                            value: info.AvailableLicenses,
                            accent: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2b9eedf2a30bb436$var$StatCard, {
                            label: t("licenses.statBought"),
                            value: info.LicensesBought
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2b9eedf2a30bb436$var$StatCard, {
                            label: t("licenses.statSent"),
                            value: sent
                        })
                    ]
                }),
                info.AvailableLicenses <= 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7599b5b791e3b99$export$caec2af78bcc877f), {
                    color: "orange",
                    variant: "light",
                    children: t("licenses.noneAvailable")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                    p: "xl",
                    style: $2b9eedf2a30bb436$var$panelStyle,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                            order: 4,
                            c: "charcoal.8",
                            mb: "md",
                            children: t("portal.actions")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                            gap: "md",
                            wrap: "wrap",
                            children: [
                                info.AvailableLicenses > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                    leftSection: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec5bb0f44884c42f$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    onClick: onEnviarLicenciasClick,
                                    loading: sendMutation.isPending,
                                    color: "brand",
                                    children: t("licenses.sendToEmail")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                    to: "/ComprarLicencias",
                                    leftSection: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a8e3f49c5cef145$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    variant: info.AvailableLicenses > 0 ? "outline" : "filled",
                                    color: "brand",
                                    children: t("portal.buyLicenses")
                                })
                            ]
                        })
                    ]
                }),
                renderLicensesSentTable(info)
            ]
        });
    };
    if (!userInfo) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
            py: "xl",
            maw: 480,
            mx: "auto",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a9103170d172c05d$export$21a94553ffa41578), {})
        })
    });
    if (isPending) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: t("portal.pageTitle"),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
            gap: "sm",
            c: "dimmed",
            py: "xl",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f943dfe4129424c6$export$3b0d6d7590275603), {
                    size: "sm",
                    color: "brand"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    children: t("portal.loading")
                })
            ]
        })
    });
    if (isError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: t("portal.pageTitle"),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7599b5b791e3b99$export$caec2af78bcc877f), {
            color: "red",
            variant: "light",
            mt: "md",
            children: t("portal.loadError")
        })
    });
    if (!distributorInfo) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: t("portal.pageTitle"),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
            mt: "md",
            p: "xl",
            maw: 640,
            style: $2b9eedf2a30bb436$var$panelStyle,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b1e0d87449cf89d$export$d9f01d0b8741578e), {})
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: t("portal.pageTitle"),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "xl",
            py: "md",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                    justify: "space-between",
                    align: "flex-start",
                    wrap: "wrap",
                    gap: "md",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                            gap: 4,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                    order: 2,
                                    c: "charcoal.8",
                                    children: distributorInfo.DistributorInfo.CompanyName
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                    c: "dimmed",
                                    children: distributorInfo.CloudUser.AccountEmail
                                })
                            ]
                        }),
                        distributorInfo.DistributorInfo.DistribuidorAutorizado ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b24692670674b261$export$37acb3580601e69a), {
                            color: "brand",
                            variant: "light",
                            size: "lg",
                            children: t("portal.authorized")
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b24692670674b261$export$37acb3580601e69a), {
                            color: "orange",
                            variant: "light",
                            size: "lg",
                            children: t("portal.pending")
                        })
                    ]
                }),
                distributorInfo.DistributorInfo.DistribuidorAutorizado && renderAuthorizedContent(distributorInfo),
                !distributorInfo.DistributorInfo.DistribuidorAutorizado && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                    p: "xl",
                    style: $2b9eedf2a30bb436$var$panelStyle,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                        gap: "md",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7599b5b791e3b99$export$caec2af78bcc877f), {
                                color: "orange",
                                variant: "light",
                                title: t("portal.pending"),
                                children: t("portal.pendingApproval", {
                                    email: (0, $e9e66f0970a759b5$export$985c431ed65d8e6a)().SupportEmail
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                href: $07ad4a64764770d8$exports,
                                c: "brand.7",
                                fw: 600,
                                w: "fit-content",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                    gap: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b17baffcb070405$export$2e2bcd8739ae039), {
                                            size: 16
                                        }),
                                        t("portal.distributorInfo")
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                    id: "tutoriales",
                    p: "xl",
                    style: $2b9eedf2a30bb436$var$panelStyle,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                        gap: "md",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                order: 4,
                                c: "charcoal.8",
                                children: t("tutorials.title")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                size: "sm",
                                c: "dimmed",
                                children: [
                                    t("tutorials.alsoSeeFaqBefore"),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                        component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                        to: "/faq",
                                        c: "brand.7",
                                        fw: 600,
                                        children: t("tutorials.alsoSeeFaqLink")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                fw: 500,
                                children: t("tutorials.sendLicenseTutorial")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce742f7700dbdcef$export$e840e8869344ca38), {
                                ratio: 16 / 9,
                                maw: 640,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                    title: t("tutorials.iframeTitle"),
                                    src: "https://www.youtube.com/embed/FF3ZZ6gjJLE",
                                    allowFullScreen: true,
                                    style: {
                                        border: 0
                                    }
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}





parcelRequire("acw62");




function $ca1be20e2bbab187$export$c54aa75865654c4a() {
    const { t: t, i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: t("privacy.title"),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "md",
            align: "center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                    to: "/eula",
                    size: "lg",
                    children: t("privacy.eulaLink")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                    href: `/privacypolicy/privacypolicy?lang=${encodeURIComponent(i18n.language)}`,
                    size: "lg",
                    children: t("privacy.policyLink")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    size: "sm",
                    c: "dimmed",
                    ta: "center",
                    children: t("privacy.note")
                })
            ]
        })
    });
}
function $ca1be20e2bbab187$export$e9ce26c044d73ed4() {
    const { t: t, i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { data: text, isPending: isPending, isError: isError } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: (0, $0fb2b9595b8b3089$export$e531c43d2585d3d6).eula(i18n.language),
        queryFn: ()=>(0, $0fb2b9595b8b3089$export$1f53e240b076325b).getEulaText(i18n.language)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: t("privacy.eulaLink"),
        children: [
            isError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                c: "red",
                children: t("privacy.eulaLoadError")
            }),
            isPending && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                children: t("privacy.loading")
            }),
            text && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                style: {
                    whiteSpace: "pre-wrap"
                },
                component: "pre",
                children: text
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");




const $93b13351aac881d4$var$languageOptionOrder = [
    "en-US",
    "es-MX",
    "fr-FR",
    "de-DE"
];
const $93b13351aac881d4$var$languageLabels = {
    "en-US": "language.english",
    "es-MX": "language.spanish",
    "de-DE": "language.german",
    "fr-FR": "language.french"
};
function $93b13351aac881d4$export$28f282c008ccfd46() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [languagePreference, setLanguagePreferenceState] = $acw62.useState(()=>(0, $6c154842fccf6556$export$699b6efc48d2d271)());
    const handleLanguageChange = async (value)=>{
        setLanguagePreferenceState(value);
        await (0, $6c154842fccf6556$export$7db3818e7d30342d)(value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: t("language.title"),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "md",
            maw: 480,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    size: "sm",
                    c: "dimmed",
                    children: t("language.description")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                    gap: "sm",
                    children: $93b13351aac881d4$var$languageOptionOrder.map((locale)=>{
                        const isActive = languagePreference === locale;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), {
                            onClick: ()=>void handleLanguageChange(locale),
                            "aria-pressed": isActive,
                            "aria-label": t($93b13351aac881d4$var$languageLabels[locale]),
                            p: "sm",
                            style: {
                                borderRadius: 8,
                                border: isActive ? "2px solid var(--mantine-color-brand-5)" : "1px solid var(--mantine-color-gray-3)",
                                background: isActive ? "var(--mantine-color-brand-0)" : "var(--mantine-color-white)",
                                minWidth: 96
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                gap: 6,
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b559a680df89f9bd$export$780a8cb2c23ae04b), {
                                        locale: locale,
                                        size: 28
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                        size: "sm",
                                        fw: isActive ? 600 : 400,
                                        children: t($93b13351aac881d4$var$languageLabels[locale])
                                    })
                                ]
                            })
                        }, locale);
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                    variant: languagePreference === "browser" ? "filled" : "light",
                    onClick: ()=>void handleLanguageChange("browser"),
                    children: t("language.browser")
                })
            ]
        })
    });
}



parcelRequire("acw62");


function $0a4042caf16d09c2$export$cf0bcac4c4020f20() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a9103170d172c05d$export$21a94553ffa41578), {})
    });
}





var $acw62 = parcelRequire("acw62");






function $1c53576d9109703f$export$b2cc78cf67c677bc() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    const [params] = (0, $5cec2af50e95548c$export$f1a78c17382fe22a)();
    const user = (0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)();
    const requestedReturn = (0, $1af3e201f2191896$export$97fca9fed2b032d7)(params.get("return"));
    const returnTo = user && requestedReturn === (0, $1af3e201f2191896$export$b2a2fd2f92c8e105) ? (0, $1af3e201f2191896$export$8b199c2ab6ac8131)(Boolean(user.Bought)) : requestedReturn;
    const [email, setEmail] = $acw62.useState("");
    const [password, setPassword] = $acw62.useState("");
    const [error, setError] = $acw62.useState(null);
    const [submitting, setSubmitting] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        if (user) navigate(returnTo, {
            replace: true
        });
    }, [
        user,
        returnTo,
        navigate
    ]);
    const onSubmit = async (event)=>{
        event.preventDefault();
        setError(null);
        setSubmitting(true);
        try {
            await (0, $0fb2b9595b8b3089$export$1f53e240b076325b).localAuthRegister(email.trim(), password);
            window.location.href = returnTo;
        } catch (err) {
            const message = err instanceof (0, $0fb2b9595b8b3089$export$f2e832acab1bdd79) ? err.message : t("registerAccount.error");
            setError(message);
            setSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "md",
            maw: 480,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                    order: 3,
                    children: t("registerAccount.title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    children: t("registerAccount.intro")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                    onSubmit: onSubmit,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                        gap: "sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                                label: t("registerAccount.email"),
                                type: "email",
                                autoComplete: "email",
                                required: true,
                                value: email,
                                onChange: (e)=>setEmail(e.currentTarget.value)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c023900663954b7$export$b28585a458fee016), {
                                label: t("registerAccount.password"),
                                description: t("registerAccount.passwordHint"),
                                autoComplete: "new-password",
                                required: true,
                                minLength: 8,
                                value: password,
                                onChange: (e)=>setPassword(e.currentTarget.value)
                            }),
                            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                c: "red",
                                size: "sm",
                                children: error
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                type: "submit",
                                loading: submitting,
                                children: t("registerAccount.submit")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    size: "sm",
                    children: [
                        t("registerAccount.haveAccount"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                            to: `/signin?return=${encodeURIComponent(returnTo)}`,
                            children: t("registerAccount.signIn")
                        })
                    ]
                })
            ]
        })
    });
}





var $acw62 = parcelRequire("acw62");




function $1b3973eafc5c4901$export$c7a55480dba6f1f1() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [email, setEmail] = $acw62.useState("");
    const [error, setError] = $acw62.useState(null);
    const [done, setDone] = $acw62.useState(false);
    const [submitting, setSubmitting] = $acw62.useState(false);
    const onSubmit = async (event)=>{
        event.preventDefault();
        setError(null);
        setSubmitting(true);
        try {
            await (0, $0fb2b9595b8b3089$export$1f53e240b076325b).localAuthForgot(email.trim());
            setDone(true);
        } catch (err) {
            const message = err instanceof (0, $0fb2b9595b8b3089$export$f2e832acab1bdd79) ? err.message : t("forgotPassword.error");
            setError(message);
        } finally{
            setSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "md",
            maw: 480,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                    order: 3,
                    children: t("forgotPassword.title")
                }),
                done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    children: t("forgotPassword.sent")
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            children: t("forgotPassword.intro")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                            onSubmit: onSubmit,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                gap: "sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                                        label: t("forgotPassword.email"),
                                        type: "email",
                                        autoComplete: "email",
                                        required: true,
                                        value: email,
                                        onChange: (e)=>setEmail(e.currentTarget.value)
                                    }),
                                    error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                        c: "red",
                                        size: "sm",
                                        children: error
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                        type: "submit",
                                        loading: submitting,
                                        children: t("forgotPassword.submit")
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                    to: "/signin",
                    children: t("forgotPassword.backToSignIn")
                })
            ]
        })
    });
}





var $acw62 = parcelRequire("acw62");




function $d68ff857a4721199$export$da4433e8d8a5678() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [params] = (0, $5cec2af50e95548c$export$f1a78c17382fe22a)();
    const email = params.get("email") ?? "";
    const token = params.get("token") ?? "";
    const [password, setPassword] = $acw62.useState("");
    const [error, setError] = $acw62.useState(null);
    const [done, setDone] = $acw62.useState(false);
    const [submitting, setSubmitting] = $acw62.useState(false);
    const onSubmit = async (event)=>{
        event.preventDefault();
        setError(null);
        setSubmitting(true);
        try {
            await (0, $0fb2b9595b8b3089$export$1f53e240b076325b).localAuthReset(email, token, password);
            setDone(true);
        } catch (err) {
            const message = err instanceof (0, $0fb2b9595b8b3089$export$f2e832acab1bdd79) ? err.message : t("resetPassword.error");
            setError(message);
        } finally{
            setSubmitting(false);
        }
    };
    const missingParams = !email || !token;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "md",
            maw: 480,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                    order: 3,
                    children: t("resetPassword.title")
                }),
                missingParams ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    c: "red",
                    children: t("resetPassword.invalidLink")
                }) : done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            children: t("resetPassword.success")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                            to: "/signin",
                            children: t("resetPassword.signIn")
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                    onSubmit: onSubmit,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                        gap: "sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                size: "sm",
                                c: "dimmed",
                                children: email
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c023900663954b7$export$b28585a458fee016), {
                                label: t("resetPassword.password"),
                                description: t("resetPassword.passwordHint"),
                                autoComplete: "new-password",
                                required: true,
                                minLength: 8,
                                value: password,
                                onChange: (e)=>setPassword(e.currentTarget.value)
                            }),
                            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                c: "red",
                                size: "sm",
                                children: error
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                type: "submit",
                                loading: submitting,
                                children: t("resetPassword.submit")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                    to: "/signin",
                    children: t("resetPassword.backToSignIn")
                })
            ]
        })
    });
}





var $acw62 = parcelRequire("acw62");




function $7676785e5d2147b0$var$buildAppLoginQuery(params) {
    const redirectUri = params.get("redirect_uri") || "";
    const state = params.get("state") || "";
    const codeChallenge = params.get("code_challenge") || "";
    const parts = [
        "redirect_uri=" + encodeURIComponent(redirectUri),
        "code_challenge=" + encodeURIComponent(codeChallenge)
    ];
    if (state) parts.push("state=" + encodeURIComponent(state));
    return parts.join("&");
}
function $7676785e5d2147b0$export$29bb4af50f769ea8() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [params] = (0, $5cec2af50e95548c$export$f1a78c17382fe22a)();
    const user = (0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)();
    const query = $7676785e5d2147b0$var$buildAppLoginQuery(params);
    const hasRequiredParams = !!params.get("redirect_uri") && !!params.get("code_challenge");
    $acw62.useEffect(()=>{
        if (!hasRequiredParams) return;
        if (!user) // MVC /applogin sends anonymous users to /signin (Google or email/password).
        window.location.href = "/applogin?" + query;
    }, [
        user,
        hasRequiredParams,
        query
    ]);
    if (!hasRequiredParams) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "md",
            maw: 480,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                    order: 3,
                    children: t("applogin.invalidTitle")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    children: t("applogin.invalidBody")
                })
            ]
        })
    });
    if (!user) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "md",
            maw: 480,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                children: t("applogin.redirecting")
            })
        })
    });
    const email = user.AccountEmail || user.Email || "";
    const continueUrl = "/applogin?" + query + "&confirm=1";
    const switchAccountUrl = "/logout?return=" + encodeURIComponent("/applogin?" + query);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "md",
            maw: 480,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                    order: 3,
                    children: t("applogin.title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    children: t("applogin.signedInAs", {
                        email: email
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    children: t("applogin.intro")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                    component: "a",
                    href: continueUrl,
                    children: t("applogin.continue")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                    href: switchAccountUrl,
                    children: t("applogin.switchAccount")
                })
            ]
        })
    });
}




parcelRequire("acw62");




const $d281fe8d44cd1d5f$var$TUTORIALS = [
    {
        id: "tutorial1",
        key: "howToRoll",
        img: (0, $f59b44cc928cf883$export$d6750f761647646b),
        yt: "w6QBhV_9e7Y"
    },
    {
        id: "tutorial2",
        key: "howToSheet",
        img: (0, $f59b44cc928cf883$export$fac32a244105e2ba),
        yt: "sH4YqscfRUY"
    },
    {
        id: "tutorial3",
        key: "howTo3Across",
        img: (0, $f59b44cc928cf883$export$a431b5adb36bc0b6),
        yt: "E30J1z7au6U"
    },
    {
        id: "tutorial4",
        key: "howToText",
        img: (0, $f59b44cc928cf883$export$90b2ae0bed6558b5),
        yt: "4UFN-fR9_Ao"
    },
    {
        id: "tutorial5",
        key: "howToShapes",
        img: (0, $f59b44cc928cf883$export$51d2376a2cdf7ccf),
        yt: "qRKJKZA1L_4"
    },
    {
        id: "tutorial6",
        key: "howToImages",
        img: (0, $f59b44cc928cf883$export$1592979568e08f33),
        yt: "_u8rg4jWM7k"
    },
    {
        id: "tutorial7",
        key: "howToBarCodes",
        img: (0, $f59b44cc928cf883$export$8da0ad777f81af9d),
        yt: "OVxsjZYXnYo"
    },
    {
        id: "tutorial8",
        key: "howToQR",
        img: (0, $f59b44cc928cf883$export$8adbec3a4efa782f),
        yt: "W76gN1Ojmf4"
    },
    {
        id: "tutorial9",
        key: "howToPrint",
        img: (0, $f59b44cc928cf883$export$307167f93eaa789e),
        yt: "Zq6Vum7V7xk"
    },
    {
        id: "tutorial10",
        key: "howToConsecutive",
        img: (0, $f59b44cc928cf883$export$e4ce4eb81862e07f),
        yt: "_-envn_bF9c"
    },
    {
        id: "tutorial11",
        key: "howToDataBase",
        img: (0, $f59b44cc928cf883$export$ec235bad49bf3a3a),
        yt: "UbAv2qGqNYM"
    },
    {
        id: "tutorial12",
        key: "howToBuy",
        img: (0, $f59b44cc928cf883$export$213635cac2381061),
        yt: "Wj-FSfzyWyE"
    }
];
function $d281fe8d44cd1d5f$export$b571b62b2f0144ac() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        fullBleed: true,
        showFooter: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
            style: {
                background: "linear-gradient(160deg, #fff8f2 0%, #ffffff 40%, #fff4eb 100%)"
            },
            py: {
                base: "xl",
                md: 48
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
                size: "lg",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                    gap: "xl",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                            gap: "xs",
                            maw: 560,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                    order: 1,
                                    c: "charcoal.8",
                                    children: t("fullTutorials.title")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                    c: "dimmed",
                                    size: "lg",
                                    children: t("fullTutorials.intro")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14), {
                            children: $d281fe8d44cd1d5f$var$TUTORIALS.map((tut)=>{
                                const title = t(`fullTutorials.${tut.key}`);
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a599d521a2ea6dcd$export$ef2184bd89960b14).Col, {
                                    span: {
                                        base: 12,
                                        md: 6
                                    },
                                    id: tut.id,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                        gap: "md",
                                        p: "lg",
                                        h: "100%",
                                        style: {
                                            background: "white",
                                            border: "1px solid var(--mantine-color-gray-2)",
                                            borderRadius: "var(--mantine-radius-md)",
                                            boxShadow: "0 8px 28px rgba(44, 45, 48, 0.05)"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                                gap: "sm",
                                                wrap: "nowrap",
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95f3644217e6673d$export$3e431a229df88919), {
                                                        src: tut.img,
                                                        alt: "",
                                                        w: 48,
                                                        h: 48,
                                                        fit: "contain"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                                        order: 4,
                                                        c: "charcoal.8",
                                                        lineClamp: 2,
                                                        children: title
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                                                style: {
                                                    position: "relative",
                                                    width: "100%",
                                                    paddingBottom: "56.25%",
                                                    borderRadius: "var(--mantine-radius-sm)",
                                                    overflow: "hidden",
                                                    background: "var(--mantine-color-charcoal-9)"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                                    src: `https://www.youtube.com/embed/${tut.yt}`,
                                                    title: title,
                                                    allowFullScreen: true,
                                                    style: {
                                                        position: "absolute",
                                                        inset: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        border: 0
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                }, tut.id);
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            size: "sm",
                            c: "dimmed",
                            ta: "center",
                            children: [
                                t("fullTutorials.alsoDistributor"),
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                    to: "/distributorportal",
                                    c: "brand.7",
                                    fw: 600,
                                    children: t("fullTutorials.distributorLink")
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}




/**
 * @license @tabler/icons-react v3.45.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d8920a99eb651813$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M18 6l-12 12",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M6 6l12 12",
            "key": "svg-1"
        }
    ]
];
const $d8920a99eb651813$export$2e2bcd8739ae039 = (0, $181aa196ec8b5be7$export$2e2bcd8739ae039)("outline", "x", "X", $d8920a99eb651813$export$3efd853dbb351e94);




var $acw62 = parcelRequire("acw62");





function $a03abcec40796bb5$var$DetailRow({ label: label, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
        justify: "space-between",
        align: "flex-start",
        wrap: "wrap",
        gap: "sm",
        py: "sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                size: "sm",
                c: "dimmed",
                fw: 500,
                miw: 140,
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                style: {
                    flex: 1,
                    textAlign: "right"
                },
                children: children
            })
        ]
    });
}
function $a03abcec40796bb5$var$subscriptionStatusLabel(t, status) {
    switch((status ?? "").toLowerCase()){
        case "active":
            return t("userInfo.statusActive");
        case "trialing":
            return t("userInfo.statusTrialing");
        case "past_due":
            return t("userInfo.statusPastDue");
        case "canceled":
            return t("userInfo.statusCanceled");
        case "unpaid":
            return t("userInfo.statusUnpaid");
        case "incomplete":
            return t("userInfo.statusIncomplete");
        case "incomplete_expired":
            return t("userInfo.statusIncompleteExpired");
        case "paused":
            return t("userInfo.statusPaused");
        default:
            return t("userInfo.statusUnknown", {
                status: status || "\u2014"
            });
    }
}
function $a03abcec40796bb5$var$subscriptionBadgeColor(status) {
    switch((status ?? "").toLowerCase()){
        case "active":
        case "trialing":
            return "brand";
        case "past_due":
            return "orange";
        case "canceled":
        case "unpaid":
        case "incomplete_expired":
            return "red";
        default:
            return "charcoal";
    }
}
function $a03abcec40796bb5$var$formatPeriodEnd(iso, locale) {
    if (!iso) return null;
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return null;
    return date.toLocaleDateString(locale, {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
}
function $a03abcec40796bb5$export$5e891aeaa6124a50() {
    const { t: t, i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const user = (0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)();
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const [resendMsg, setResendMsg] = $acw62.useState(null);
    const [resendOk, setResendOk] = $acw62.useState(false);
    const [passwordFormOpen, setPasswordFormOpen] = $acw62.useState(false);
    const [currentPassword, setCurrentPassword] = $acw62.useState("");
    const [newPassword, setNewPassword] = $acw62.useState("");
    const [passwordMsg, setPasswordMsg] = $acw62.useState(null);
    const [passwordOk, setPasswordOk] = $acw62.useState(false);
    const hasSubscriptionRecord = Boolean(user.StripeSubscriptionId);
    const passwordStatusQuery = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            "localAuthHasPassword"
        ],
        queryFn: ()=>(0, $0fb2b9595b8b3089$export$1f53e240b076325b).localAuthHasPassword()
    });
    const subscriptionQuery = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            "subscriptionStatus",
            user.StripeSubscriptionId
        ],
        queryFn: ()=>(0, $0fb2b9595b8b3089$export$1f53e240b076325b).getSubscriptionStatus(),
        enabled: hasSubscriptionRecord
    });
    const resendMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $0fb2b9595b8b3089$export$1f53e240b076325b).resendConfirmationEmail(),
        onSuccess: ()=>{
            setResendOk(true);
            setResendMsg(t("userInfo.resentEmail", {
                email: user.Email
            }));
        },
        onError: ()=>{
            setResendOk(false);
            setResendMsg(t("userInfo.resendError"));
        }
    });
    const hasPassword = passwordStatusQuery.data === true;
    const passwordMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            if (hasPassword) await (0, $0fb2b9595b8b3089$export$1f53e240b076325b).localAuthChangePassword(currentPassword, newPassword);
            else await (0, $0fb2b9595b8b3089$export$1f53e240b076325b).localAuthSetPassword(newPassword);
        },
        onSuccess: async ()=>{
            setPasswordOk(true);
            setPasswordMsg(hasPassword ? t("userInfo.passwordChanged") : t("userInfo.passwordSet"));
            setCurrentPassword("");
            setNewPassword("");
            await queryClient.invalidateQueries({
                queryKey: [
                    "localAuthHasPassword"
                ]
            });
        },
        onError: (err)=>{
            setPasswordOk(false);
            const message = err instanceof (0, $0fb2b9595b8b3089$export$f2e832acab1bdd79) ? err.message : t("userInfo.passwordError");
            setPasswordMsg(message);
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        fullBleed: true,
        showFooter: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
            style: {
                background: "linear-gradient(160deg, #fff8f2 0%, #ffffff 45%, #fff4eb 100%)",
                minHeight: "calc(100vh - 60px - 160px)"
            },
            py: {
                base: "xl",
                md: 48
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
                size: "md",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                    gap: "xl",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                            order: 1,
                            c: "charcoal.8",
                            children: t("userInfo.title")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                            p: "xl",
                            style: {
                                background: "white",
                                border: "1px solid var(--mantine-color-gray-2)",
                                borderRadius: "var(--mantine-radius-md)",
                                boxShadow: "0 8px 32px rgba(44, 45, 48, 0.06)"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                gap: 0,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                        justify: "space-between",
                                        align: "center",
                                        mb: "md",
                                        wrap: "wrap",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                                order: 3,
                                                c: "charcoal.8",
                                                children: t("userInfo.detailsTitle")
                                            }),
                                            hasSubscriptionRecord ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b24692670674b261$export$37acb3580601e69a), {
                                                color: $a03abcec40796bb5$var$subscriptionBadgeColor(subscriptionQuery.data?.Status),
                                                variant: "light",
                                                size: "lg",
                                                children: subscriptionQuery.isLoading ? t("userInfo.subscription") : $a03abcec40796bb5$var$subscriptionStatusLabel(t, subscriptionQuery.data?.Status)
                                            }) : user.Bought ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b24692670674b261$export$37acb3580601e69a), {
                                                color: "brand",
                                                variant: "light",
                                                size: "lg",
                                                children: t("userInfo.lifetimeAccess")
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b24692670674b261$export$37acb3580601e69a), {
                                                color: "charcoal",
                                                variant: "light",
                                                size: "lg",
                                                children: t("userInfo.freeVersion")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a03abcec40796bb5$var$DetailRow, {
                                        label: t("userInfo.email"),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                            fw: 500,
                                            children: user.Email
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a00b9f352798fdd$export$2e0a83ec2e27ecbb), {
                                        color: "gray.1"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a03abcec40796bb5$var$DetailRow, {
                                        label: t("userInfo.emailConfirmed"),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                            gap: "sm",
                                            justify: "flex-end",
                                            wrap: "wrap",
                                            children: user.EmailConfirmed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b24692670674b261$export$37acb3580601e69a), {
                                                color: "green",
                                                variant: "light",
                                                leftSection: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a9488e46dc26332$export$2e2bcd8739ae039), {
                                                    size: 12
                                                }),
                                                children: t("userInfo.confirmed")
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b24692670674b261$export$37acb3580601e69a), {
                                                        color: "orange",
                                                        variant: "light",
                                                        leftSection: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8920a99eb651813$export$2e2bcd8739ae039), {
                                                            size: 12
                                                        }),
                                                        children: t("userInfo.notConfirmed")
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                                        size: "xs",
                                                        color: "brand",
                                                        loading: resendMutation.isPending,
                                                        onClick: ()=>resendMutation.mutate(),
                                                        children: t("userInfo.resend")
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a00b9f352798fdd$export$2e0a83ec2e27ecbb), {
                                        color: "gray.1"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a03abcec40796bb5$var$DetailRow, {
                                        label: t("userInfo.userId"),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                            size: "sm",
                                            c: "dimmed",
                                            style: {
                                                wordBreak: "break-all"
                                            },
                                            children: user.UserId
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a00b9f352798fdd$export$2e0a83ec2e27ecbb), {
                                        color: "gray.1"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a03abcec40796bb5$var$DetailRow, {
                                        label: t("userInfo.version"),
                                        children: hasSubscriptionRecord ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                            gap: 2,
                                            align: "flex-end",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    fw: 600,
                                                    c: "brand.7",
                                                    children: t("userInfo.subscription")
                                                }),
                                                user.PaymentAmount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    size: "xs",
                                                    c: "dimmed",
                                                    children: [
                                                        "USD $",
                                                        user.PaymentAmount.toFixed(2),
                                                        user.PaymentCurrency ? ` ${user.PaymentCurrency}` : "",
                                                        "/mo"
                                                    ]
                                                })
                                            ]
                                        }) : user.Bought ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                            gap: 2,
                                            align: "flex-end",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    fw: 600,
                                                    c: "brand.7",
                                                    children: t("userInfo.lifetimeAccess")
                                                }),
                                                user.PaymentId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    size: "xs",
                                                    c: "dimmed",
                                                    children: [
                                                        user.PaymentMethod,
                                                        ": ",
                                                        user.PaymentId
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                            gap: "xs",
                                            align: "flex-end",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                    fw: 500,
                                                    children: t("userInfo.freeVersion")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                                    component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                                    to: "/buy",
                                                    size: "sm",
                                                    color: "brand",
                                                    children: t("userInfo.buyApp")
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a00b9f352798fdd$export$2e0a83ec2e27ecbb), {
                                        color: "gray.1"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a03abcec40796bb5$var$DetailRow, {
                                        label: t("userInfo.accountType"),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                            size: "sm",
                                            children: [
                                                user.AccountType,
                                                user.AccountEmail ? `: ${user.AccountEmail}` : ""
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        hasSubscriptionRecord && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                            p: "xl",
                            style: {
                                background: "white",
                                border: "1px solid var(--mantine-color-gray-2)",
                                borderRadius: "var(--mantine-radius-md)",
                                boxShadow: "0 8px 32px rgba(44, 45, 48, 0.06)"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                    justify: "space-between",
                                    align: "center",
                                    mb: "md",
                                    wrap: "wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                            order: 3,
                                            c: "charcoal.8",
                                            children: t("userInfo.subscriptionTitle")
                                        }),
                                        user.StripeCustomerId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                            component: "a",
                                            href: "/buy/billingportal",
                                            size: "sm",
                                            color: "brand",
                                            variant: "light",
                                            children: t("userInfo.manageBilling")
                                        })
                                    ]
                                }),
                                subscriptionQuery.isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                    size: "sm",
                                    c: "dimmed",
                                    children: t("userInfo.subscriptionLoading")
                                }),
                                subscriptionQuery.isError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7599b5b791e3b99$export$caec2af78bcc877f), {
                                    color: "red",
                                    variant: "light",
                                    children: t("userInfo.subscriptionError")
                                }),
                                subscriptionQuery.data && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                    gap: "md",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                            gap: 0,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a03abcec40796bb5$var$DetailRow, {
                                                    label: t("userInfo.subscriptionStatus"),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b24692670674b261$export$37acb3580601e69a), {
                                                        color: $a03abcec40796bb5$var$subscriptionBadgeColor(subscriptionQuery.data.Status),
                                                        variant: "light",
                                                        children: $a03abcec40796bb5$var$subscriptionStatusLabel(t, subscriptionQuery.data.Status)
                                                    })
                                                }),
                                                $a03abcec40796bb5$var$formatPeriodEnd(subscriptionQuery.data.CurrentPeriodEnd, i18n.language) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a00b9f352798fdd$export$2e0a83ec2e27ecbb), {
                                                            color: "gray.1"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a03abcec40796bb5$var$DetailRow, {
                                                            label: subscriptionQuery.data.CancelAtPeriodEnd || !subscriptionQuery.data.HasAccess ? t("userInfo.subscriptionEnds") : t("userInfo.subscriptionRenews"),
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                                fw: 500,
                                                                children: $a03abcec40796bb5$var$formatPeriodEnd(subscriptionQuery.data.CurrentPeriodEnd, i18n.language)
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        subscriptionQuery.data.CancelAtPeriodEnd && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7599b5b791e3b99$export$caec2af78bcc877f), {
                                            color: "orange",
                                            variant: "light",
                                            children: t("userInfo.subscriptionCancelScheduled")
                                        })
                                    ]
                                })
                            ]
                        }),
                        resendMsg && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7599b5b791e3b99$export$caec2af78bcc877f), {
                            color: resendOk ? "green" : "red",
                            variant: "light",
                            children: resendMsg
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                            p: "xl",
                            style: {
                                background: "white",
                                border: "1px solid var(--mantine-color-gray-2)",
                                borderRadius: "var(--mantine-radius-md)",
                                boxShadow: "0 8px 32px rgba(44, 45, 48, 0.06)"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                    order: 3,
                                    c: "charcoal.8",
                                    mb: "xs",
                                    children: hasPassword ? t("userInfo.changePasswordTitle") : t("userInfo.setPasswordTitle")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                    size: "sm",
                                    c: "dimmed",
                                    mb: "md",
                                    children: hasPassword ? t("userInfo.changePasswordIntro") : t("userInfo.setPasswordIntro")
                                }),
                                !user.EmailConfirmed && !hasPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7599b5b791e3b99$export$caec2af78bcc877f), {
                                    color: "orange",
                                    variant: "light",
                                    children: t("userInfo.confirmEmailBeforePassword")
                                }) : !passwordFormOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                    color: "brand",
                                    variant: "light",
                                    loading: passwordStatusQuery.isLoading,
                                    onClick: ()=>{
                                        setPasswordMsg(null);
                                        setPasswordFormOpen(true);
                                    },
                                    children: hasPassword ? t("userInfo.changePasswordExpand") : t("userInfo.setPasswordExpand")
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                                    onSubmit: (e)=>{
                                        e.preventDefault();
                                        setPasswordMsg(null);
                                        passwordMutation.mutate();
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                        gap: "sm",
                                        children: [
                                            hasPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c023900663954b7$export$b28585a458fee016), {
                                                label: t("userInfo.currentPassword"),
                                                autoComplete: "current-password",
                                                required: true,
                                                value: currentPassword,
                                                onChange: (e)=>setCurrentPassword(e.currentTarget.value)
                                            }) : null,
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c023900663954b7$export$b28585a458fee016), {
                                                label: t("userInfo.newPassword"),
                                                description: t("userInfo.passwordHint"),
                                                autoComplete: "new-password",
                                                required: true,
                                                minLength: 8,
                                                value: newPassword,
                                                onChange: (e)=>setNewPassword(e.currentTarget.value)
                                            }),
                                            passwordMsg ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7599b5b791e3b99$export$caec2af78bcc877f), {
                                                color: passwordOk ? "green" : "red",
                                                variant: "light",
                                                children: passwordMsg
                                            }) : null,
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                                gap: "sm",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                                        type: "submit",
                                                        color: "brand",
                                                        loading: passwordMutation.isPending,
                                                        disabled: passwordStatusQuery.isLoading,
                                                        children: hasPassword ? t("userInfo.changePasswordSubmit") : t("userInfo.setPasswordSubmit")
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                                        type: "button",
                                                        variant: "subtle",
                                                        color: "charcoal",
                                                        disabled: passwordMutation.isPending,
                                                        onClick: ()=>{
                                                            setPasswordFormOpen(false);
                                                            setCurrentPassword("");
                                                            setNewPassword("");
                                                            setPasswordMsg(null);
                                                        },
                                                        children: t("userInfo.passwordFormCancel")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                            p: "xl",
                            style: {
                                background: "white",
                                border: "1px solid var(--mantine-color-gray-2)",
                                borderRadius: "var(--mantine-radius-md)",
                                boxShadow: "0 8px 32px rgba(44, 45, 48, 0.06)"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                                    order: 3,
                                    c: "charcoal.8",
                                    mb: "md",
                                    children: t("userInfo.quickLinks")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                                    gap: "sm",
                                    children: [
                                        (0, $e9e66f0970a759b5$export$90c873f50cd44aba)() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                            to: "/distributorportal",
                                            c: "brand.7",
                                            fw: 600,
                                            children: t("userInfo.openDistributorPortal")
                                        }),
                                        user.IsAdmin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                            to: "/admin",
                                            c: "brand.7",
                                            fw: 600,
                                            children: t("userInfo.admin")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                            to: "/tutorials",
                                            c: "charcoal.5",
                                            fw: 500,
                                            children: t("nav.tutorials")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                            to: "/install",
                                            c: "charcoal.5",
                                            fw: 500,
                                            children: t("nav.download")
                                        }),
                                        !user.Bought && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                            component: (0, $5cec2af50e95548c$export$a6c7ac8248d6e38a),
                                            to: "/buy",
                                            c: "charcoal.5",
                                            fw: 500,
                                            children: t("userInfo.buyApp")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}




parcelRequire("acw62");



const $eba0645dfbfde97c$var$DISTRIBUTORS = [
    {
        name: "Etiprint",
        img: (0, $f59b44cc928cf883$export$1a9c417fe62bff0d),
        address: "Etiprint, Arturo B de la garza #115 Monterrey",
        email: "laurag@etiprint.com",
        phone: "+52 81 8478 0995"
    },
    {
        name: "Grupo Empresarial CT",
        img: (0, $f59b44cc928cf883$export$a7495411b11a7b2a),
        address: "Grupo Empresarial CT, Joaquin Garc\xeda #256 Monterrey",
        email: "jorgeaguirre@ctetiquetas.com",
        phone: "+52 81 1158 6565"
    }
];
function $eba0645dfbfde97c$export$dbae96fcb2f2a825() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: t("distributors.title"),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
            gap: "xl",
            children: $eba0645dfbfde97c$var$DISTRIBUTORS.map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                    align: "center",
                    gap: "xs",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95f3644217e6673d$export$3e431a229df88919), {
                            src: d.img,
                            alt: d.name,
                            maw: 200
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                            order: 4,
                            children: d.name
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            ta: "center",
                            children: d.address
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: `mailto:${d.email}`,
                                children: d.email
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            children: d.phone
                        })
                    ]
                }, d.name))
        })
    });
}



parcelRequire("acw62");




parcelRequire("acw62");


function $fccaa21d4a62401d$export$d3e6f364adb9a44e({ userInfo: userInfo }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if (!userInfo) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        children: t("home.error")
    });
    if (userInfo.Bought) {
        const isSubscriber = Boolean(userInfo.StripeSubscriptionId);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: t(isSubscriber ? "userLicenses.hasSubscription" : "userLicenses.hasLicense")
                        })
                    }),
                    userInfo.StripeCustomerId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "/buy/billingportal",
                            children: t("userLicenses.manageBilling")
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: t("userLicenses.noLicense")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5cec2af50e95548c$export$a6c7ac8248d6e38a), {
                to: "/buy",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: t("userLicenses.buyHere")
                })
            })
        ]
    });
}


function $a7424c42cef6fd2a$export$4bf416e4487289b7() {
    const userInfo = (0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b9dd37b364dbb76$export$8ab9296042acb886), {
        title: "",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: (0, $6c154842fccf6556$export$2e2bcd8739ae039).t("home.welcome", {
                    email: userInfo.Email
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fccaa21d4a62401d$export$d3e6f364adb9a44e), {
                userInfo: userInfo
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



const $7c3dbe36ec18dfd6$var$RETURN_PATH_KEY = "labelmaster.returnPath";
function $7c3dbe36ec18dfd6$export$403ff2865cd0897d(path) {
    try {
        sessionStorage.setItem($7c3dbe36ec18dfd6$var$RETURN_PATH_KEY, path);
    } catch  {
    // ignore
    }
}
function $7c3dbe36ec18dfd6$export$1fa2af4a296c7b41() {
    try {
        const value = sessionStorage.getItem($7c3dbe36ec18dfd6$var$RETURN_PATH_KEY);
        if (value) sessionStorage.removeItem($7c3dbe36ec18dfd6$var$RETURN_PATH_KEY);
        return value;
    } catch  {
    // ignore
    }
    return null;
}
function $7c3dbe36ec18dfd6$export$804b313364ec32ac(returnPath) {
    const metadata = (0, $e9e66f0970a759b5$export$985c431ed65d8e6a)();
    if (returnPath) $7c3dbe36ec18dfd6$export$403ff2865cd0897d(returnPath);
    if (metadata?.SignInUrl) window.location.href = metadata.SignInUrl;
}
function $7c3dbe36ec18dfd6$export$943fcbe9cc90f2ce() {
    const user = (0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)();
    if (!user) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$444b3ab0cb9aec40), {
        to: "/signin",
        replace: true
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$444b3ab0cb9aec40), {
        to: (0, $1af3e201f2191896$export$8b199c2ab6ac8131)(Boolean(user.Bought)),
        replace: true
    });
}
function $7c3dbe36ec18dfd6$export$77bf246365dd152a(navigate, returnPath) {
    const path = returnPath.startsWith("/") ? returnPath : "/" + returnPath;
    navigate(`/signin?return=${encodeURIComponent(path)}`);
}
function $7c3dbe36ec18dfd6$export$8ef2ed426dede42d({ children: children }) {
    const location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    const navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    const user = (0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)();
    $acw62.useEffect(()=>{
        if (!user) $7c3dbe36ec18dfd6$export$77bf246365dd152a(navigate, location.pathname + location.search);
    }, [
        user,
        location.pathname,
        location.search,
        navigate
    ]);
    if (!user) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        children: "Redirecting to sign in\u2026"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
}
function $7c3dbe36ec18dfd6$export$94408951ee39e4ac({ children: children }) {
    const location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    const navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    const user = (0, $e9e66f0970a759b5$export$e5432d4c8eb97ea7)();
    $acw62.useEffect(()=>{
        if (!user) $7c3dbe36ec18dfd6$export$77bf246365dd152a(navigate, location.pathname + location.search);
    }, [
        user,
        location.pathname,
        location.search,
        navigate
    ]);
    if (!user) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        children: "Redirecting to sign in\u2026"
    });
    if (!user.IsAdmin) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$444b3ab0cb9aec40), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
}



var $acw62 = parcelRequire("acw62");


function $e0e9d6c7b6529b80$export$f029052e0afdd4e3() {
    const location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    $acw62.useEffect(()=>{
        const route = `${location.pathname}${location.search}${location.hash}`;
        (0, $4382af072e10244e$export$ab7cfb71d8592d3c)().trackPageView(route || "/");
    }, [
        location.pathname,
        location.search,
        location.hash
    ]);
    return null;
}



var $acw62 = parcelRequire("acw62");
const $943014d3d844b077$export$ae6f3dd4ba2aa398 = "https://www.dinlabel.com";
const $943014d3d844b077$export$4986c848aafdcfea = `${$943014d3d844b077$export$ae6f3dd4ba2aa398}/public/og-product.png`;
const $943014d3d844b077$export$739780e963b1413f = new Set([
    "/",
    "/install",
    "/barcodes",
    "/buy",
    "/tutorials",
    "/faq",
    "/viewdistributors",
    "/privacy",
    "/eula"
]);
function $943014d3d844b077$var$upsertMeta(attr, key, content) {
    if (typeof document === "undefined") return;
    const selector = `meta[${attr}="${key}"]`;
    let el = document.head.querySelector(selector);
    if (!content) {
        el?.remove();
        return;
    }
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.content = content;
}
function $943014d3d844b077$var$upsertCanonical(href) {
    if (typeof document === "undefined") return;
    let el = document.head.querySelector('link[rel="canonical"]');
    if (!href) {
        el?.remove();
        return;
    }
    if (!el) {
        el = document.createElement("link");
        el.rel = "canonical";
        document.head.appendChild(el);
    }
    el.href = href;
}
function $943014d3d844b077$export$af3e118f14f40658(path) {
    if (!path || path === "/") return `${$943014d3d844b077$export$ae6f3dd4ba2aa398}/`;
    return `${$943014d3d844b077$export$ae6f3dd4ba2aa398}${path.startsWith("/") ? path : `/${path}`}`;
}
function $943014d3d844b077$export$7ae4cbc6c9cd3e17({ title: title, description: description, canonicalPath: canonicalPath, imageUrl: imageUrl = $943014d3d844b077$export$4986c848aafdcfea, noindex: noindex = false }) {
    if (typeof document === "undefined") return;
    document.title = title;
    $943014d3d844b077$var$upsertMeta("name", "description", description);
    $943014d3d844b077$var$upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    const canonical = canonicalPath != null ? $943014d3d844b077$export$af3e118f14f40658(canonicalPath) : undefined;
    $943014d3d844b077$var$upsertCanonical(canonical);
    $943014d3d844b077$var$upsertMeta("property", "og:type", "website");
    $943014d3d844b077$var$upsertMeta("property", "og:site_name", "DinLabel");
    $943014d3d844b077$var$upsertMeta("property", "og:title", title);
    $943014d3d844b077$var$upsertMeta("property", "og:description", description);
    $943014d3d844b077$var$upsertMeta("property", "og:url", canonical);
    $943014d3d844b077$var$upsertMeta("property", "og:image", imageUrl);
    $943014d3d844b077$var$upsertMeta("name", "twitter:card", "summary_large_image");
    $943014d3d844b077$var$upsertMeta("name", "twitter:title", title);
    $943014d3d844b077$var$upsertMeta("name", "twitter:description", description);
    $943014d3d844b077$var$upsertMeta("name", "twitter:image", imageUrl);
}
function $943014d3d844b077$export$e32ac76d6a7cc206(options) {
    $acw62.useEffect(()=>{
        $943014d3d844b077$export$7ae4cbc6c9cd3e17(options);
    }, [
        options.title,
        options.description,
        options.canonicalPath,
        options.imageUrl,
        options.noindex
    ]);
}


const $cd93687958c8007e$var$PAGE_SEO = {
    "/": {
        title: "DinLabel \u2014 Professional label design software",
        description: "DinLabel is professional label design software for barcodes, QR codes, variable data, and printing.",
        canonicalPath: "/"
    },
    "/install": {
        title: "Install DinLabel | DinLabel",
        description: "Download and install DinLabel label design software for Windows. Try the demo or get the full version.",
        canonicalPath: "/install"
    },
    "/barcodes": {
        title: "Supported barcode types | DinLabel",
        description: "DinLabel supports UPC, EAN, Code 128, GS1-128, QR Code, Data Matrix, PDF417, and 150+ other barcode types for professional labels.",
        canonicalPath: "/barcodes"
    },
    "/buy": {
        title: "Subscribe to DinLabel | DinLabel",
        description: "Subscribe to DinLabel online. Professional label design with barcodes, QR codes, and variable data.",
        canonicalPath: "/buy"
    },
    "/tutorials": {
        title: "Tutorials | DinLabel",
        description: "Watch DinLabel tutorials for printing labels, barcodes, QR codes, shapes, images, and more.",
        canonicalPath: "/tutorials"
    },
    "/faq": {
        title: "FAQ | DinLabel",
        description: "Frequently asked questions about becoming a DinLabel distributor, licenses, pricing, and support.",
        canonicalPath: "/faq"
    },
    "/viewdistributors": {
        title: "Distributors | DinLabel",
        description: "Find authorized DinLabel distributors near you.",
        canonicalPath: "/viewdistributors"
    },
    "/privacy": {
        title: "Privacy Policy | DinLabel",
        description: "DinLabel privacy policy and terms of service.",
        canonicalPath: "/privacy"
    },
    "/eula": {
        title: "End User License Agreement | DinLabel",
        description: "DinLabel end user license agreement (EULA).",
        canonicalPath: "/eula"
    }
};
function $cd93687958c8007e$var$ReturnPathRedirect() {
    const navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    const location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    $acw62.useEffect(()=>{
        // OAuth returns to "/". Only restore the saved path on home.
        if (location.pathname !== "/") return;
        const path = (0, $7c3dbe36ec18dfd6$export$1fa2af4a296c7b41)();
        if (path && path !== "/") navigate(path.startsWith("/") ? path : "/" + path, {
            replace: true
        });
    }, [
        location.pathname,
        navigate
    ]);
    return null;
}
function $cd93687958c8007e$var$RouteSeo() {
    const { pathname: pathname } = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    $acw62.useEffect(()=>{
        const page = $cd93687958c8007e$var$PAGE_SEO[pathname];
        if (page) {
            (0, $943014d3d844b077$export$7ae4cbc6c9cd3e17)({
                title: page.title,
                description: page.description,
                canonicalPath: page.canonicalPath,
                noindex: false
            });
            return;
        }
        if ((0, $943014d3d844b077$export$739780e963b1413f).has(pathname)) {
            (0, $943014d3d844b077$export$7ae4cbc6c9cd3e17)({
                title: "DinLabel",
                description: "DinLabel is professional label design software for barcodes, QR codes, variable data, and printing.",
                canonicalPath: pathname,
                noindex: false
            });
            return;
        }
        (0, $943014d3d844b077$export$7ae4cbc6c9cd3e17)({
            title: "DinLabel",
            description: "DinLabel is professional label design software for barcodes, QR codes, variable data, and printing.",
            noindex: true
        });
    }, [
        pathname
    ]);
    return null;
}
function $cd93687958c8007e$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$ReturnPathRedirect, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$RouteSeo, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0e9d6c7b6529b80$export$f029052e0afdd4e3), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b6caee6a6f10651$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $999b7f0c70e160fa$export$c753c4e91c6407f6), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/install",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17d8fc5046c4600b$export$959d3514bbc6cfa8), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/barcodes",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0720716f6e7eda54$export$fe3d061d3c12034), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/tutorials",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d281fe8d44cd1d5f$export$b571b62b2f0144ac), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/privacy",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca1be20e2bbab187$export$c54aa75865654c4a), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/eula",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca1be20e2bbab187$export$e9ce26c044d73ed4), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/viewdistributors",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eba0645dfbfde97c$export$dbae96fcb2f2a825), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/signin",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0a4042caf16d09c2$export$cf0bcac4c4020f20), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/postsignin",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c3dbe36ec18dfd6$export$943fcbe9cc90f2ce), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/register",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c53576d9109703f$export$b2cc78cf67c677bc), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/forgot-password",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b3973eafc5c4901$export$c7a55480dba6f1f1), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/reset-password",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d68ff857a4721199$export$da4433e8d8a5678), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/applogin",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7676785e5d2147b0$export$29bb4af50f769ea8), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/buy",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83aa9b7d47e715a4$export$8b567d0dd9363392), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/userinfo",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c3dbe36ec18dfd6$export$8ef2ed426dede42d), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a03abcec40796bb5$export$5e891aeaa6124a50), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/mylabels",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c3dbe36ec18dfd6$export$8ef2ed426dede42d), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $848adf49191c8bc1$export$a95a8625616bcf5e), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/mylabels/view",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c3dbe36ec18dfd6$export$8ef2ed426dede42d), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $848adf49191c8bc1$export$d7711a32d964aeec), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/admin",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c3dbe36ec18dfd6$export$94408951ee39e4ac), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8bf45bbb8e4e2260$export$b25f57c16f88d7e0), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/admin/fakeemail",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c3dbe36ec18dfd6$export$94408951ee39e4ac), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $689a5d6d9baa9f83$export$8e1d1f87a83caab6), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/distributorportal",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c3dbe36ec18dfd6$export$8ef2ed426dede42d), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b9eedf2a30bb436$export$c7cafd7de5097e70), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/account",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c3dbe36ec18dfd6$export$8ef2ed426dede42d), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7424c42cef6fd2a$export$4bf416e4487289b7), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/faq",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a16b45f4e860f857$export$7562e752e5ef1fad), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/language",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93b13351aac881d4$export$28f282c008ccfd46), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/settings",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$444b3ab0cb9aec40), {
                            to: "/language",
                            replace: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/webapp/faq",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$444b3ab0cb9aec40), {
                            to: "/faq",
                            replace: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/getDinLabel",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$444b3ab0cb9aec40), {
                            to: "/buy",
                            replace: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/webapp/getDinLabel",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$444b3ab0cb9aec40), {
                            to: "/buy",
                            replace: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/VerDetallesDeLicencias",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$444b3ab0cb9aec40), {
                            to: "/distributorportal",
                            replace: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/verDetallesDeLicencias",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$444b3ab0cb9aec40), {
                            to: "/distributorportal",
                            replace: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/ComprarLicencias",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c3dbe36ec18dfd6$export$8ef2ed426dede42d), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1eb5e5f1711cb86$export$a6e37c047f4a4354), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/comprarLicencias",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$444b3ab0cb9aec40), {
                            to: "/ComprarLicencias",
                            replace: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/tutoriales",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$444b3ab0cb9aec40), {
                            to: "/distributorportal?focus=tutoriales",
                            replace: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                        path: "/webapp",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$444b3ab0cb9aec40), {
                            to: "/distributorportal",
                            replace: true
                        })
                    })
                ]
            })
        ]
    });
}




//#region packages/@mantine/core/src/core/MantineProvider/create-theme/create-theme.ts
function $67db8f2a35f4db62$export$25d302a5b900a763(theme) {
    return theme;
}


/** Logo orange (~#F27A21) as primary shade 6 */ const $227f11a6809b1d6b$var$brand = [
    "#fff4eb",
    "#ffe4cc",
    "#ffc894",
    "#ffab5c",
    "#ff9333",
    "#f9841a",
    "#F27A21",
    "#d96512",
    "#b5520e",
    "#8c3d0a"
];
/** Charcoal for marketing chrome */ const $227f11a6809b1d6b$var$charcoal = [
    "#f2f2f3",
    "#e0e0e2",
    "#c0c1c4",
    "#9a9b9f",
    "#6d6e71",
    "#4a4b4e",
    "#2c2d30",
    "#1f2023",
    "#161618",
    "#0d0d0e"
];
const $227f11a6809b1d6b$export$bca14c5b3b88a9c9 = (0, $67db8f2a35f4db62$export$25d302a5b900a763)({
    primaryColor: "brand",
    primaryShade: 6,
    colors: {
        brand: $227f11a6809b1d6b$var$brand,
        charcoal: $227f11a6809b1d6b$var$charcoal
    },
    fontFamily: '"Source Sans 3", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
    headings: {
        fontFamily: '"Sora", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
        fontWeight: "600"
    },
    defaultRadius: "md",
    components: {
        Button: {
            defaultProps: {
                radius: "md"
            }
        }
    }
});


(0, $fbac34ae8aa6584b$export$ce30dbb46644d06c).initializeTelemetry();
(0, $fbac34ae8aa6584b$export$ce30dbb46644d06c).logger.info("Starting app...");
const $70fc9a727fa662ae$var$queryClient = new (0, $83ccb5f70678ce73$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false
        }
    }
});
const $70fc9a727fa662ae$var$container = document.getElementById("root");
if (!$70fc9a727fa662ae$var$container) throw new Error("Root container missing in index.html");
const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c313608318d394ab$export$1325e8699caa160f), {
    i18n: (0, $6c154842fccf6556$export$2e2bcd8739ae039),
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c780594f51309d36$export$45604f0cc8ae667b), {
        client: $70fc9a727fa662ae$var$queryClient,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f8e78febad0631e$export$2ec8a50af9fc9ed7), {
            theme: (0, $227f11a6809b1d6b$export$bca14c5b3b88a9c9),
            defaultColorScheme: "light",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a1d8e70ac2325fe5$export$d130e6a5a0bde89c), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adfe52a85354f23c$export$36ba2f559d49a8f6), {
                        position: "top-right"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5cec2af50e95548c$export$9ba4e89fdfa1fc54), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {})
                    })
                ]
            })
        })
    })
}));


//# sourceMappingURL=web-client.7605dbbf.js.map
